import { Time } from '@src/utils/types'
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: number; output: number; }
  Date: { input: Date; output: Date; }
  DateTime: { input: Date; output: Date; }
  Mixed: { input: any; output: any; }
  Time: { input: Time; output: Time; }
  Upload: { input: any; output: any; }
};

export enum Accounting_Account_Type {
  Expense = 'EXPENSE',
  Invoice = 'INVOICE',
  Proforma = 'PROFORMA'
}

export enum Accounting_Centre_Type {
  Expense = 'EXPENSE',
  Invoice = 'INVOICE'
}

export type AccountingAccount = {
  __typename?: 'AccountingAccount';
  account_number: Scalars['String']['output'];
  accounting_type?: Maybe<Accounting_Account_Type>;
  budget_categories?: Maybe<Array<AccountingAccountBudgetCategory>>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type AccountingAccountBudgetCategory = {
  __typename?: 'AccountingAccountBudgetCategory';
  accounting_account_id: Scalars['ID']['output'];
  budget_category_id: Scalars['ID']['output'];
  budget_category_type: Scalars['String']['output'];
};

export type AccountingCentre = {
  __typename?: 'AccountingCentre';
  centre: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: Accounting_Centre_Type;
};

export type AccountingVatClassification = {
  __typename?: 'AccountingVatClassification';
  centre: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: Accounting_Centre_Type;
  vatRate?: Maybe<VatRate>;
  vat_rate_id?: Maybe<Scalars['ID']['output']>;
};

export type AmountToConvert = {
  amount_in_currency: Scalars['BigInt']['input'];
  identifier: Scalars['String']['input'];
  unit_price?: InputMaybe<Scalars['BigInt']['input']>;
};

export type AssignableFile = {
  __typename?: 'AssignableFile';
  created_at: Scalars['DateTime']['output'];
  filename: Scalars['String']['output'];
  mime_type: Scalars['String']['output'];
  model_id?: Maybe<Scalars['ID']['output']>;
  model_type?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  public_id: Scalars['String']['output'];
  size: Scalars['String']['output'];
  urls: AssignableFileUrlPair;
};

export type AssignableFileUrlPair = {
  __typename?: 'AssignableFileUrlPair';
  original?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  viewable?: Maybe<Scalars['String']['output']>;
};

export type AssignmentArray = {
  brand_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  client_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contractor_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  project_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type AttachedOutgoingProformaInvoicePivot = {
  __typename?: 'AttachedOutgoingProformaInvoicePivot';
  amount_in_currency: Scalars['BigInt']['output'];
  invoice: OutgoingProformaInvoice;
};

export type AttachedProofOfPaymentPivot = {
  __typename?: 'AttachedProofOfPaymentPivot';
  amount_in_currency: Scalars['BigInt']['output'];
  invoice: OutgoingInvoice;
};

export type Attendee = {
  __typename?: 'Attendee';
  timeTrackingWorkType?: Maybe<TimeTrackingWorkType>;
  user: User;
};

export type AutocompleteCompanyData = {
  __typename?: 'AutocompleteCompanyData';
  results: Array<AutocompleteCompanyDataResult>;
  suggestions: Array<Scalars['String']['output']>;
};

export type AutocompleteCompanyDataResult = {
  __typename?: 'AutocompleteCompanyDataResult';
  cancelled: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  national_id?: Maybe<Scalars['String']['output']>;
};

export type Bank = {
  __typename?: 'Bank';
  api_id: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type BankAccount = {
  __typename?: 'BankAccount';
  iban: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  workspace_bank_account_id?: Maybe<Scalars['ID']['output']>;
};

export type BankAccountConverter = {
  __typename?: 'BankAccountConverter';
  iban?: Maybe<Scalars['String']['output']>;
};

export type BankAccountMove = {
  __typename?: 'BankAccountMove';
  amount: Scalars['BigInt']['output'];
  balance: Scalars['BigInt']['output'];
  bank_account_id?: Maybe<Scalars['ID']['output']>;
  currency: Currency;
  currency_id: Scalars['ID']['output'];
  date: Scalars['Date']['output'];
  documents?: Maybe<Array<BankAccountMoveDocument>>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ks?: Maybe<Scalars['String']['output']>;
  note: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  ss?: Maybe<Scalars['String']['output']>;
  status: BankAccountMoveStatusEnum;
  type: BankAccountMoveTypeEnum;
  vs?: Maybe<Scalars['String']['output']>;
};

export type BankAccountMoveDocument = {
  __typename?: 'BankAccountMoveDocument';
  amount: Scalars['BigInt']['output'];
  amount_in_move_currency: Scalars['BigInt']['output'];
  bankAccountMove?: Maybe<BankAccountMove>;
  bank_account_move_id: Scalars['ID']['output'];
  date: Scalars['Date']['output'];
  document_currency: Currency;
  document_id: Scalars['String']['output'];
  document_no: Scalars['String']['output'];
  document_type: BankDocumentTypeEnum;
  exchange_rate: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
};

export type BankAccountMoveDocumentInput = {
  amount: Scalars['BigInt']['input'];
  amount_in_move_currency: Scalars['BigInt']['input'];
  date: Scalars['Date']['input'];
  document_id: Scalars['ID']['input'];
  document_type: BankDocumentTypeEnum;
  exchange_rate: Scalars['BigInt']['input'];
};

/** A paginated list of BankAccountMove items. */
export type BankAccountMovePaginator = {
  __typename?: 'BankAccountMovePaginator';
  /** A list of BankAccountMove items. */
  data: Array<BankAccountMove>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type BankAccountMoveQueryArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BankAccountMoveWhereConditions>;
};

export enum BankAccountMoveStatusEnum {
  Excluded = 'EXCLUDED',
  ManualPaired = 'MANUAL_PAIRED',
  NotPaired = 'NOT_PAIRED',
  Paired = 'PAIRED'
}

export type BankAccountMoveToDocumentInput = {
  amount: Scalars['BigInt']['input'];
  amount_in_move_currency: Scalars['BigInt']['input'];
  bank_account_move_id: Scalars['ID']['input'];
  exchange_rate: Scalars['BigInt']['input'];
};

export enum BankAccountMoveTypeEnum {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export type BankAccountMoveWhereConditions = {
  AND?: InputMaybe<Array<BankAccountMoveWhereConditions>>;
  OR?: InputMaybe<Array<BankAccountMoveWhereConditions>>;
  column?: InputMaybe<BankAccountWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type BankAccountSetting = {
  __typename?: 'BankAccountSetting';
  account_holder_name?: Maybe<Scalars['String']['output']>;
  bank_account?: Maybe<Scalars['String']['output']>;
  bank_code?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['BigInt']['output']>;
  note?: Maybe<Scalars['String']['output']>;
};

export type BankAccountSettingInput = {
  account_holder_name?: InputMaybe<Scalars['String']['input']>;
  bank_account?: InputMaybe<Scalars['String']['input']>;
  bank_code?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  iban: Scalars['String']['input'];
  id?: InputMaybe<Scalars['BigInt']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export enum BankAccountWhereColumn {
  AmountFrom = 'AMOUNT_FROM',
  AmountTo = 'AMOUNT_TO',
  AmountType = 'AMOUNT_TYPE',
  BankAccountId = 'BANK_ACCOUNT_ID',
  Status = 'STATUS'
}

export enum BankDocumentTypeEnum {
  Expense = 'EXPENSE',
  OutgoingInvoice = 'OUTGOING_INVOICE',
  OutgoingProformaInvoice = 'OUTGOING_PROFORMA_INVOICE'
}

export type BillingEntity = {
  __typename?: 'BillingEntity';
  applies_vat: Scalars['Boolean']['output'];
  brands: Array<Brand>;
  city: Scalars['String']['output'];
  country: Country;
  created_at: Scalars['DateTime']['output'];
  defaultCurrency: Currency;
  disable_email_notification: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  internal_name: Scalars['String']['output'];
  invoice_email?: Maybe<Scalars['String']['output']>;
  language: Scalars['String']['output'];
  legal_name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  payment_due: Scalars['BigInt']['output'];
  registration_no?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  tax_no?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  vat_no?: Maybe<Scalars['String']['output']>;
  workspaceBankAccount?: Maybe<WorkspaceBankAccount>;
  workspaceCompany: WorkspaceCompany;
  zip: Scalars['String']['output'];
};

export type BillingEntityOrderByClause = {
  column: BillingEntityOrderByColumnEnum;
  order: SortOrder;
};

export enum BillingEntityOrderByColumnEnum {
  Id = 'ID'
}

/** A paginated list of BillingEntity items. */
export type BillingEntityPaginator = {
  __typename?: 'BillingEntityPaginator';
  /** A list of BillingEntity items. */
  data: Array<BillingEntity>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type BillingEntityQueryArgs = {
  orderBy?: InputMaybe<Array<BillingEntityOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BrandsWhereConditions>;
};

export enum BillingItemTypEnum {
  BudgetItem = 'BUDGET_ITEM',
  Category = 'CATEGORY'
}

export type BillingPlanBudget = {
  __typename?: 'BillingPlanBudget';
  billingPlanBudgetItem?: Maybe<Array<BillingPlanBudgetItem>>;
  billing_item_type: BillingItemTypEnum;
  budget_item_id?: Maybe<Scalars['ID']['output']>;
  budget_item_type: BudgetItemTypeEnum;
  category: BillingPlanBudgetItemCategory;
  id?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  total_budget: Scalars['BigInt']['output'];
};

export type BillingPlanBudgetCache = {
  __typename?: 'BillingPlanBudgetCache';
  billing_plan_invoice_id?: Maybe<Scalars['ID']['output']>;
  brand: Brand;
  created_at: Scalars['DateTime']['output'];
  date_of_supply: Scalars['Date']['output'];
  due_date: Scalars['Date']['output'];
  email_sent: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoice_no?: Maybe<Scalars['String']['output']>;
  invoiced_amount: Scalars['BigInt']['output'];
  issue_date: Scalars['Date']['output'];
  message?: Maybe<Scalars['String']['output']>;
  paid_amount: Scalars['BigInt']['output'];
  paid_at?: Maybe<Scalars['DateTime']['output']>;
  planned_amount: Scalars['BigInt']['output'];
  project: Project;
  request_for_invoicing_id?: Maybe<Scalars['ID']['output']>;
  status: BillingPlanBudgetCacheStatusEnum;
  type: BillingPlanBudgetItemInvoiceTypeEnum;
  updated_at: Scalars['DateTime']['output'];
};

/** A paginated list of BillingPlanBudgetCache items. */
export type BillingPlanBudgetCachePaginator = {
  __typename?: 'BillingPlanBudgetCachePaginator';
  /** A list of BillingPlanBudgetCache items. */
  data: Array<BillingPlanBudgetCache>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum BillingPlanBudgetCacheStatusEnum {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  ManuallyCreated = 'MANUALLY_CREATED',
  Pending = 'PENDING'
}

export type BillingPlanBudgetInvoice = {
  __typename?: 'BillingPlanBudgetInvoice';
  amount: Scalars['BigInt']['output'];
  date: Scalars['Date']['output'];
  invoice_id: Scalars['ID']['output'];
  invoice_type: BillingPlanBudgetInvoiceTypeEnum;
};

export enum BillingPlanBudgetInvoiceTypeEnum {
  OutgoingInvoice = 'OUTGOING_INVOICE',
  OutgoingProformaInvoice = 'OUTGOING_PROFORMA_INVOICE',
  RequestForInvoicing = 'REQUEST_FOR_INVOICING'
}

export type BillingPlanBudgetItem = {
  __typename?: 'BillingPlanBudgetItem';
  accounting_account_id?: Maybe<Scalars['ID']['output']>;
  accounting_centre_id?: Maybe<Scalars['ID']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
  invoice_type?: Maybe<BillingPlanBudgetItemInvoiceTypeEnum>;
  months: Array<BillingPlanMonth>;
};

export type BillingPlanBudgetItemCategory = {
  __typename?: 'BillingPlanBudgetItemCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BillingPlanBudgetItemInput = {
  accounting_account_id?: InputMaybe<Scalars['ID']['input']>;
  accounting_centre_id?: InputMaybe<Scalars['ID']['input']>;
  billingPlanMonths: Array<BillingPlanMonthInput>;
  day?: InputMaybe<Scalars['Int']['input']>;
  invoice_type?: InputMaybe<BillingPlanBudgetItemInvoiceTypeEnum>;
};

export enum BillingPlanBudgetItemInvoiceTypeEnum {
  OutgoingInvoice = 'OUTGOING_INVOICE',
  OutgoingProformaInvoice = 'OUTGOING_PROFORMA_INVOICE',
  RequestForInvoicing = 'REQUEST_FOR_INVOICING'
}

export type BillingPlanByMonths = {
  __typename?: 'BillingPlanByMonths';
  balance: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  invoiced_amount: Scalars['BigInt']['output'];
  items: Array<BillingPlanItem>;
  period: Scalars['String']['output'];
  planned_amount: Scalars['BigInt']['output'];
  status: BillingPlanMonthStatusEnum;
};

export type BillingPlanCacheOrderByClause = {
  column: BillingPlanCacheOrderByColumnEnum;
  order: SortOrder;
};

export enum BillingPlanCacheOrderByColumnEnum {
  Amount = 'AMOUNT',
  BrandName = 'BRAND_NAME',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DueDate = 'DUE_DATE',
  InvoicedAmount = 'INVOICED_AMOUNT',
  IssueDate = 'ISSUE_DATE',
  PaidAt = 'PAID_AT',
  PlannedAmount = 'PLANNED_AMOUNT',
  ProjectTitle = 'PROJECT_TITLE',
  Status = 'STATUS',
  Type = 'TYPE'
}

export type BillingPlanCacheOverviewQueryArgs = {
  date_from: Scalars['Date']['input'];
  date_to: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<BillingPlanCacheOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BillingPlanCacheOverviewWhereConditions>;
};

export type BillingPlanCacheOverviewSummary = {
  __typename?: 'BillingPlanCacheOverviewSummary';
  invoiced_amount: Scalars['BigInt']['output'];
  planned_amount: Scalars['BigInt']['output'];
  projects: Scalars['BigInt']['output'];
  uninvoiced_amount: Scalars['BigInt']['output'];
};

export enum BillingPlanCacheOverviewWhereColumn {
  BrandId = 'BRAND_ID',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DueDate = 'DUE_DATE',
  IssueDate = 'ISSUE_DATE',
  PaidAt = 'PAID_AT',
  PaymentStatus = 'PAYMENT_STATUS',
  ProjectId = 'PROJECT_ID',
  ProjectMangerId = 'PROJECT_MANGER_ID',
  ProjectStageId = 'PROJECT_STAGE_ID',
  Status = 'STATUS',
  TeamId = 'TEAM_ID',
  Type = 'TYPE'
}

export type BillingPlanCacheOverviewWhereConditions = {
  AND?: InputMaybe<Array<BillingPlanCacheOverviewWhereConditions>>;
  OR?: InputMaybe<Array<BillingPlanCacheOverviewWhereConditions>>;
  column?: InputMaybe<BillingPlanCacheOverviewWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type BillingPlanInvoice = {
  __typename?: 'BillingPlanInvoice';
  amount: Scalars['BigInt']['output'];
  brandCreditAccount?: Maybe<BrandCreditAccount>;
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  outgoingInvoice?: Maybe<OutgoingInvoice>;
  proformaInvoice?: Maybe<OutgoingProformaInvoice>;
};

export type BillingPlanItem = {
  __typename?: 'BillingPlanItem';
  amount: Scalars['BigInt']['output'];
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
};

export type BillingPlanItemInput = {
  amount: Scalars['BigInt']['input'];
  date: Scalars['Date']['input'];
};

export type BillingPlanMonth = {
  __typename?: 'BillingPlanMonth';
  billingPlanInvoice?: Maybe<Array<Maybe<BillingPlanBudgetInvoice>>>;
  date: Scalars['Date']['output'];
  value: Scalars['BigInt']['output'];
};

export type BillingPlanMonthInput = {
  date: Scalars['Date']['input'];
  value: Scalars['BigInt']['input'];
};

export type BillingPlanMonthStat = {
  __typename?: 'BillingPlanMonthStat';
  balance: Scalars['BigInt']['output'];
  current_balance: Scalars['BigInt']['output'];
  invoiced_amount: Scalars['BigInt']['output'];
  invoices: Array<BillingPlanInvoice>;
  items: Array<BillingPlanItem>;
  key: Scalars['String']['output'];
  period: Scalars['String']['output'];
  planned_amount: Scalars['BigInt']['output'];
  project: Project;
  status: BillingPlanMonthStatusEnum;
};

/** A paginated list of BillingPlanMonthStat items. */
export type BillingPlanMonthStatPaginator = {
  __typename?: 'BillingPlanMonthStatPaginator';
  /** A list of BillingPlanMonthStat items. */
  data: Array<BillingPlanMonthStat>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum BillingPlanMonthStatusEnum {
  Invoiced = 'INVOICED',
  PartiallyInvoiced = 'PARTIALLY_INVOICED',
  Uninvoiced = 'UNINVOICED'
}

export enum BillingPlanNotificationTypeEnum {
  ProjectBudgetChanged = 'PROJECT_BUDGET_CHANGED',
  ProjectDatesChanged = 'PROJECT_DATES_CHANGED'
}

export type BillingPlanNotifications = {
  __typename?: 'BillingPlanNotifications';
  project_budget_changed: Scalars['Boolean']['output'];
  project_dates_changed: Scalars['Boolean']['output'];
};

export type BillingPlanOrderByClause = {
  column: BillingPlanOrderByColumnEnum;
  order: SortOrder;
};

export enum BillingPlanOrderByColumnEnum {
  Balance = 'BALANCE',
  BrandName = 'BRAND_NAME',
  FirstDayOfSupply = 'FIRST_DAY_OF_SUPPLY',
  InvoicedAmount = 'INVOICED_AMOUNT',
  PlannedAmount = 'PLANNED_AMOUNT',
  ProjectTitle = 'PROJECT_TITLE'
}

export type BillingPlanOverviewQueryArgs = {
  month: Scalars['BigInt']['input'];
  orderBy?: InputMaybe<Array<BillingPlanOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BillingPlanOverviewWhereConditions>;
  year: Scalars['BigInt']['input'];
};

export type BillingPlanOverviewSummary = {
  __typename?: 'BillingPlanOverviewSummary';
  invoiced_amount: Scalars['BigInt']['output'];
  planned_amount: Scalars['BigInt']['output'];
  projects: Scalars['BigInt']['output'];
  uninvoiced: Scalars['BigInt']['output'];
};

export enum BillingPlanOverviewWhereColumn {
  BrandId = 'BRAND_ID',
  ProjectId = 'PROJECT_ID',
  ProjectManagerId = 'PROJECT_MANAGER_ID',
  ProjectStageId = 'PROJECT_STAGE_ID',
  Status = 'STATUS',
  TeamId = 'TEAM_ID'
}

export type BillingPlanOverviewWhereConditions = {
  AND?: InputMaybe<Array<BillingPlanOverviewWhereConditions>>;
  OR?: InputMaybe<Array<BillingPlanOverviewWhereConditions>>;
  column?: InputMaybe<BillingPlanOverviewWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type BillingPlanStats = {
  __typename?: 'BillingPlanStats';
  current_month_balance: Scalars['BigInt']['output'];
  current_month_invoiced: Scalars['BigInt']['output'];
  current_month_planned: Scalars['BigInt']['output'];
  show_invoice_date_approaching_warning: Scalars['Boolean']['output'];
};

export type BooleanResult = {
  __typename?: 'BooleanResult';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type Brand = {
  __typename?: 'Brand';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  average_time_tracking_rate?: Maybe<Scalars['BigInt']['output']>;
  calculated_average_time_tracking_rate?: Maybe<Scalars['BigInt']['output']>;
  client: Client;
  cloudUrl?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  contacts: Array<Contact>;
  contracts?: Maybe<ContractPaginator>;
  created_at: Scalars['DateTime']['output'];
  creditAccounts?: Maybe<Array<BrandCreditAccount>>;
  defaultBillingEntity?: Maybe<BillingEntity>;
  driveCloudUrl?: Maybe<Scalars['String']['output']>;
  externalLinks: Array<ExternalLink>;
  id: Scalars['ID']['output'];
  image?: Maybe<AssignableFile>;
  name: Scalars['String']['output'];
  numeric_code?: Maybe<Scalars['String']['output']>;
  otherDocuments?: Maybe<OtherDocumentPaginator>;
  otherResponsiblePersons: Array<User>;
  pipedriveCustomFieldValues: Array<PipedriveCustomFieldValue>;
  projects: Array<Project>;
  responsiblePerson?: Maybe<User>;
  stats: BrandStats;
  timeTrackingRates: Array<TimeTrackingRate>;
  updated_at: Scalars['DateTime']['output'];
  users: Array<User>;
};


export type BrandContractsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandOtherDocumentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type BrandProjectsArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  proBonoProjects?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrandCreditAccount = {
  __typename?: 'BrandCreditAccount';
  brand: Brand;
  created_at: Scalars['DateTime']['output'];
  creditAccount: CreditAccount;
  credits: Array<BrandCreditAccountCreditStats>;
  debits: Array<BrandCreditAccountDebitStats>;
  expenseBudgetCategories?: Maybe<Array<ExpenseBudgetCategory>>;
  id: Scalars['ID']['output'];
  ourWorkBudgetCategories?: Maybe<Array<OurWorkBudgetCategory>>;
  stats: BrandCreditAccountStats;
  team: Team;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type BrandCreditAccountCreditStats = {
  __typename?: 'BrandCreditAccountCreditStats';
  credit: Scalars['BigInt']['output'];
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  originatesBrandCreditAccount?: Maybe<BrandCreditAccount>;
  outgoingInvoice?: Maybe<OutgoingInvoice>;
};

export type BrandCreditAccountDebitStats = {
  __typename?: 'BrandCreditAccountDebitStats';
  brandCreditAccount?: Maybe<BrandCreditAccount>;
  credit: Scalars['BigInt']['output'];
  credit_account_operation_id: Scalars['ID']['output'];
  expenseBudgetItem?: Maybe<ExpenseBudgetItem>;
  id: Scalars['ID']['output'];
  ourWorkBudgetItem?: Maybe<OurWorkBudgetItem>;
  performed_at: Scalars['Date']['output'];
};

export type BrandCreditAccountOrderByClause = {
  column: BrandCreditAccountOrderByColumnEnum;
  order: SortOrder;
};

export enum BrandCreditAccountOrderByColumnEnum {
  BrandName = 'BRAND_NAME',
  Id = 'ID',
  RemainingCredit = 'REMAINING_CREDIT',
  Title = 'TITLE',
  TotalCredit = 'TOTAL_CREDIT',
  TotalDebit = 'TOTAL_DEBIT'
}

/** A paginated list of BrandCreditAccount items. */
export type BrandCreditAccountPaginator = {
  __typename?: 'BrandCreditAccountPaginator';
  /** A list of BrandCreditAccount items. */
  data: Array<BrandCreditAccount>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type BrandCreditAccountStats = {
  __typename?: 'BrandCreditAccountStats';
  id: Scalars['ID']['output'];
  remaining_credit: Scalars['BigInt']['output'];
  total_credit: Scalars['BigInt']['output'];
  total_debit: Scalars['BigInt']['output'];
};

export enum BrandCreditAccountStatusEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type BrandCreditAccountsSummary = {
  __typename?: 'BrandCreditAccountsSummary';
  brand_credit_accounts: Scalars['BigInt']['output'];
  remaining_credit: Scalars['BigInt']['output'];
  total_credit: Scalars['BigInt']['output'];
  total_debit: Scalars['BigInt']['output'];
};

export enum BrandCreditAccountsWhereColumn {
  BrandId = 'BRAND_ID',
  CreatedAt = 'CREATED_AT',
  ExpenseBudgetCategoryId = 'EXPENSE_BUDGET_CATEGORY_ID',
  OurWorkBudgetCategoryId = 'OUR_WORK_BUDGET_CATEGORY_ID',
  Status = 'STATUS',
  TeamId = 'TEAM_ID'
}

export type BrandCreditAccountsWhereConditions = {
  AND?: InputMaybe<Array<BrandCreditAccountsWhereConditions>>;
  OR?: InputMaybe<Array<BrandCreditAccountsWhereConditions>>;
  column?: InputMaybe<BrandCreditAccountsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type BrandOrderByClause = {
  column: BrandOrderByColumnEnum;
  order: SortOrder;
};

export enum BrandOrderByColumnEnum {
  ActiveProjects = 'ACTIVE_PROJECTS',
  BrandName = 'BRAND_NAME',
  ClientName = 'CLIENT_NAME'
}

/** A paginated list of Brand items. */
export type BrandPaginator = {
  __typename?: 'BrandPaginator';
  /** A list of Brand items. */
  data: Array<Brand>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type BrandQueryArgs = {
  orderBy?: InputMaybe<Array<BrandOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BrandsWhereConditions>;
};

export type BrandRevenue = {
  __typename?: 'BrandRevenue';
  paginatorInfo: PaginatorInfo;
  result: Array<BrandWithRevenueResult>;
};

export enum BrandRevenueGroupByEnum {
  Client = 'CLIENT',
  None = 'NONE'
}

export type BrandRevenueOrderByClause = {
  column: BrandRevenueOrderByColumnEnum;
  order: SortOrder;
};

export enum BrandRevenueOrderByColumnEnum {
  BrandName = 'BRAND_NAME'
}

export type BrandRevenueQueryArgs = {
  first?: InputMaybe<Scalars['BigInt']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  groupBy: BrandRevenueGroupByEnum;
  orderBy?: InputMaybe<Array<BrandRevenueOrderByClause>>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  where?: InputMaybe<BrandRevenueWhereConditions>;
};

export type BrandRevenueShare = {
  __typename?: 'BrandRevenueShare';
  name: Scalars['String']['output'];
  value: Scalars['BigInt']['output'];
};

export type BrandRevenueSummary = {
  __typename?: 'BrandRevenueSummary';
  brand_profit_share?: Maybe<Array<BrandRevenueShare>>;
  brand_revenue_share?: Maybe<Array<BrandRevenueShare>>;
  client_revenue_share?: Maybe<Array<BrandRevenueShare>>;
  expense_revenue_for_date_range: Array<ExpenseRevenueByCategory>;
  gross_income_for_date_range: Scalars['BigInt']['output'];
  gross_profit_for_date_range: Scalars['BigInt']['output'];
  our_work_billings_for_date_range: Scalars['BigInt']['output'];
  our_work_revenue_for_date_range: Scalars['BigInt']['output'];
  our_work_revenue_for_date_range_percentage: Scalars['BigInt']['output'];
  profit_top_clients?: Maybe<Array<TopClient>>;
  projectIds: Array<Scalars['ID']['output']>;
  projects: Scalars['BigInt']['output'];
  revenue_top_clients?: Maybe<Array<TopClient>>;
  total_invoiced: Scalars['BigInt']['output'];
};

export enum BrandRevenueWhereColumn {
  BrandId = 'BRAND_ID',
  CategoryId = 'CATEGORY_ID',
  ClientId = 'CLIENT_ID',
  ProjectId = 'PROJECT_ID'
}

export type BrandRevenueWhereConditions = {
  AND?: InputMaybe<Array<BrandRevenueWhereConditions>>;
  OR?: InputMaybe<Array<BrandRevenueWhereConditions>>;
  column?: InputMaybe<BrandRevenueWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type BrandSimple = {
  __typename?: 'BrandSimple';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  code: Scalars['String']['output'];
  defaultBillingEntity?: Maybe<BillingEntity>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  numeric_code?: Maybe<Scalars['String']['output']>;
};

export type BrandStats = {
  __typename?: 'BrandStats';
  active_projects: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
};

export type BrandWithRevenue = {
  __typename?: 'BrandWithRevenue';
  expenses_billings_for_date_range: Array<ProjectRevenueBillingsByExpenseCategory>;
  expenses_profit_for_date_range: Array<ProjectRevenueProfitByExpenseCategory>;
  filtered_profit_share: Scalars['BigInt']['output'];
  filtered_revenue_share: Scalars['BigInt']['output'];
  gross_income_for_date_range: Scalars['BigInt']['output'];
  gross_profit_for_date_range: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<AssignableFile>;
  name: Scalars['String']['output'];
  ourWork: Array<OurWorkBudgetItemWithRevenue>;
  our_work_billings_for_date_range: Scalars['BigInt']['output'];
  our_work_revenue_for_date_range: Scalars['BigInt']['output'];
  total_invoiced: Scalars['BigInt']['output'];
  total_profit_share: Scalars['BigInt']['output'];
  total_revenue_share: Scalars['BigInt']['output'];
};

export type BrandWithRevenueResult = {
  __typename?: 'BrandWithRevenueResult';
  brands?: Maybe<Array<BrandWithRevenue>>;
  expensesStructured: Array<ExpenseStructuredBudgetItemWithRevenue>;
  expenses_billings_for_date_range: Array<ProjectRevenueBillingsByExpenseCategory>;
  expenses_profit_for_date_range: Array<ProjectRevenueProfitByExpenseCategory>;
  filtered_profit_share: Scalars['BigInt']['output'];
  filtered_revenue_share: Scalars['BigInt']['output'];
  gross_income_for_date_range: Scalars['BigInt']['output'];
  gross_profit_for_date_range: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<AssignableFile>;
  name: Scalars['String']['output'];
  ourWork: Array<OurWorkBudgetItemWithRevenue>;
  our_work_billings_for_date_range: Scalars['BigInt']['output'];
  our_work_revenue_for_date_range: Scalars['BigInt']['output'];
  total_invoiced: Scalars['BigInt']['output'];
  total_profit_share: Scalars['BigInt']['output'];
  total_revenue_share: Scalars['BigInt']['output'];
};

export type BrandsSummary = {
  __typename?: 'BrandsSummary';
  brandIds: Array<Scalars['ID']['output']>;
};

export enum BrandsWhereColumn {
  ClientId = 'CLIENT_ID',
  ContactId = 'CONTACT_ID',
  Id = 'ID',
  ResponsiblePersonUserId = 'RESPONSIBLE_PERSON_USER_ID',
  Status = 'STATUS'
}

export type BrandsWhereConditions = {
  AND?: InputMaybe<Array<BrandsWhereConditions>>;
  OR?: InputMaybe<Array<BrandsWhereConditions>>;
  column?: InputMaybe<BrandsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type Budget = {
  __typename?: 'Budget';
  account_manager?: Maybe<Scalars['String']['output']>;
  assignment_date?: Maybe<Scalars['Date']['output']>;
  brand?: Maybe<Brand>;
  client_approved?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['DateTime']['output'];
  currency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internally_approved?: Maybe<Scalars['Boolean']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['BigInt']['output']>;
  project?: Maybe<Project>;
  project_id?: Maybe<Scalars['ID']['output']>;
  quotes?: Maybe<Array<Quote>>;
  status: BudgetStatusEnum;
  temporaryBrand?: Maybe<TemporaryBrand>;
  temporaryProject?: Maybe<TemporaryProject>;
  temporary_project_id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<BudgetTypeEnum>;
  updated_at: Scalars['DateTime']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};

export type BudgetArgs = {
  first?: InputMaybe<Scalars['BigInt']['input']>;
  orderBy?: InputMaybe<Array<BudgetOrderByClause>>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  where?: InputMaybe<BudgetWhereConditions>;
};

export type BudgetCategory = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shortcut: Scalars['String']['output'];
};

export type BudgetExportOptionsInput = {
  add_billing_plan?: InputMaybe<Scalars['Boolean']['input']>;
  billing_entity_id?: InputMaybe<Scalars['ID']['input']>;
  billing_plan_exchange_rate?: InputMaybe<Scalars['BigInt']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  disclaimer?: InputMaybe<Array<InputMaybe<BudgetPdfDisclaimerInput>>>;
  expense_show_commission?: InputMaybe<Scalars['Boolean']['input']>;
  expense_show_description?: InputMaybe<Scalars['Boolean']['input']>;
  expense_show_discount?: InputMaybe<Scalars['Boolean']['input']>;
  expense_show_quantity?: InputMaybe<Scalars['Boolean']['input']>;
  expense_show_unit?: InputMaybe<Scalars['Boolean']['input']>;
  expense_show_vat_in_items?: InputMaybe<Scalars['Boolean']['input']>;
  hide_title_page?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  our_work_description?: InputMaybe<Scalars['Boolean']['input']>;
  our_work_positions?: InputMaybe<BudgetPdfExportOurWorkPositionsEnum>;
  our_work_show_commission?: InputMaybe<Scalars['Boolean']['input']>;
  our_work_show_discount?: InputMaybe<Scalars['Boolean']['input']>;
  our_work_vat_in_items?: InputMaybe<Scalars['Boolean']['input']>;
  our_work_view?: InputMaybe<BudgetPdfExportOurWorkViewEnum>;
  save_for_brand?: InputMaybe<Scalars['Boolean']['input']>;
  save_for_workspace?: InputMaybe<Scalars['Boolean']['input']>;
  show_client_and_brand?: InputMaybe<Scalars['Boolean']['input']>;
  show_client_details?: InputMaybe<Scalars['Boolean']['input']>;
  show_client_name?: InputMaybe<Scalars['Boolean']['input']>;
  show_disclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  show_hours?: InputMaybe<Scalars['Boolean']['input']>;
  show_project_name_full?: InputMaybe<Scalars['Boolean']['input']>;
  show_summary?: InputMaybe<Scalars['Boolean']['input']>;
  show_title_page_with_vat?: InputMaybe<Scalars['Boolean']['input']>;
  signature?: InputMaybe<Scalars['Boolean']['input']>;
  title_page_with_vat?: InputMaybe<Scalars['Boolean']['input']>;
  use_client_name_from_billing_entity?: InputMaybe<Scalars['Boolean']['input']>;
  valid_until?: InputMaybe<Scalars['Date']['input']>;
  workspace_bank_account_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id: Scalars['ID']['input'];
};

export type BudgetGroup = {
  __typename?: 'BudgetGroup';
  budget_name?: Maybe<Scalars['String']['output']>;
  budget_number?: Maybe<Scalars['ID']['output']>;
  budgets?: Maybe<Array<Maybe<Budget>>>;
  client_id?: Maybe<Scalars['ID']['output']>;
  project_id?: Maybe<Scalars['ID']['output']>;
  temporary_client_id?: Maybe<Scalars['ID']['output']>;
  temporary_project_id?: Maybe<Scalars['ID']['output']>;
};

/** Why a budget item requested for deletion is still kept in the project. */
export enum BudgetItemDeletionBlockerEnum {
  Credit = 'CREDIT',
  ExpenseItems = 'EXPENSE_ITEMS',
  ProformaInvoice = 'PROFORMA_INVOICE',
  RequestForInvoicing = 'REQUEST_FOR_INVOICING',
  Tasks = 'TASKS',
  TimeTracking = 'TIME_TRACKING'
}

export type BudgetItemForExpenseInterface = {
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  item_code?: Maybe<Scalars['String']['output']>;
  payment_status: ExpenseInvoiceStatusEnum;
  project: Project;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type BudgetItemInterface = {
  category: BudgetCategory;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  creditAccount?: Maybe<CreditAccount>;
  id: Scalars['ID']['output'];
  item_code?: Maybe<Scalars['String']['output']>;
  project: Project;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type BudgetItemPlannedExpense = {
  __typename?: 'BudgetItemPlannedExpense';
  budget_item_id: Scalars['ID']['output'];
  budget_item_type: Scalars['String']['output'];
  budgeted_amount: Scalars['BigInt']['output'];
  client_amount: Scalars['BigInt']['output'];
  contractor?: Maybe<Contractor>;
  created_at: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
  usedExpenses: Array<BudgetItemPlannedExpenseUsed>;
};

export type BudgetItemPlannedExpenseInput = {
  budgeted_amount: Scalars['BigInt']['input'];
  client_amount: Scalars['BigInt']['input'];
  contractor_id?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type BudgetItemPlannedExpenseUsed = {
  __typename?: 'BudgetItemPlannedExpenseUsed';
  created_at: Scalars['DateTime']['output'];
  expenseItem: ExpenseItem;
  id: Scalars['ID']['output'];
  plannedExpense: BudgetItemPlannedExpense;
  updated_at: Scalars['DateTime']['output'];
  used_amount: Scalars['BigInt']['output'];
};

export enum BudgetItemTypeEnum {
  ExpenseBudgetItem = 'EXPENSE_BUDGET_ITEM',
  OurWorkBudgetItem = 'OUR_WORK_BUDGET_ITEM'
}

export type BudgetOrderByClause = {
  column: BudgetOrderByColumnEnum;
  order: SortOrder;
};

export enum BudgetOrderByColumnEnum {
  ClientId = 'CLIENT_ID',
  CreatedAt = 'CREATED_AT'
}

export type BudgetPaginator = {
  __typename?: 'BudgetPaginator';
  allIds: Array<Scalars['Int']['output']>;
  data?: Maybe<Array<BudgetGroup>>;
  paginatorInfo: PaginatorInfo;
};

export type BudgetPdfDisclaimer = {
  __typename?: 'BudgetPdfDisclaimer';
  disclaimer?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
};

export type BudgetPdfDisclaimerInput = {
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};

export enum BudgetPdfExportOurWorkPositionsEnum {
  Columns = 'COLUMNS',
  Hide = 'HIDE',
  Rows = 'ROWS'
}

export enum BudgetPdfExportOurWorkViewEnum {
  Detailed = 'DETAILED',
  Summary = 'SUMMARY'
}

export type BudgetPdfSettings = {
  __typename?: 'BudgetPdfSettings';
  add_billing_plan?: Maybe<Scalars['Boolean']['output']>;
  billing_entity_id?: Maybe<Scalars['ID']['output']>;
  billing_plan_exchange_rate?: Maybe<Scalars['BigInt']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  disclaimer?: Maybe<Array<Maybe<BudgetPdfDisclaimer>>>;
  expense_show_commission?: Maybe<Scalars['Boolean']['output']>;
  expense_show_description?: Maybe<Scalars['Boolean']['output']>;
  expense_show_discount?: Maybe<Scalars['Boolean']['output']>;
  expense_show_quantity?: Maybe<Scalars['Boolean']['output']>;
  expense_show_unit?: Maybe<Scalars['Boolean']['output']>;
  expense_show_vat_in_items?: Maybe<Scalars['Boolean']['output']>;
  hide_title_page?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  our_work_description?: Maybe<Scalars['Boolean']['output']>;
  our_work_positions?: Maybe<BudgetPdfExportOurWorkPositionsEnum>;
  our_work_show_commission?: Maybe<Scalars['Boolean']['output']>;
  our_work_show_discount?: Maybe<Scalars['Boolean']['output']>;
  our_work_vat_in_items?: Maybe<Scalars['Boolean']['output']>;
  our_work_view?: Maybe<BudgetPdfExportOurWorkViewEnum>;
  show_client_and_brand?: Maybe<Scalars['Boolean']['output']>;
  show_client_details?: Maybe<Scalars['Boolean']['output']>;
  show_client_name?: Maybe<Scalars['Boolean']['output']>;
  show_disclaimer?: Maybe<Scalars['Boolean']['output']>;
  show_hours?: Maybe<Scalars['Boolean']['output']>;
  show_project_name_full?: Maybe<Scalars['Boolean']['output']>;
  show_summary?: Maybe<Scalars['Boolean']['output']>;
  signature?: Maybe<Scalars['Boolean']['output']>;
  title_page_with_vat?: Maybe<Scalars['Boolean']['output']>;
  use_client_name_from_billing_entity?: Maybe<Scalars['Boolean']['output']>;
  valid_until?: Maybe<Scalars['Date']['output']>;
  workspace_bank_account_id?: Maybe<Scalars['ID']['output']>;
  workspace_company_id: Scalars['ID']['output'];
};

export type BudgetPosition = {
  __typename?: 'BudgetPosition';
  budgeted_amount?: Maybe<Scalars['BigInt']['output']>;
  budgeted_time?: Maybe<Scalars['BigInt']['output']>;
  invoiced_amount?: Maybe<Scalars['BigInt']['output']>;
  our_work_budget_item_id?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  time_tracking_work_type_id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  total_invoiced_amount?: Maybe<Scalars['BigInt']['output']>;
  total_invoiced_time?: Maybe<Scalars['BigInt']['output']>;
  tracked_amount?: Maybe<Scalars['BigInt']['output']>;
  tracked_time?: Maybe<Scalars['BigInt']['output']>;
  uninvoiced_amount?: Maybe<Scalars['BigInt']['output']>;
  uninvoiced_time?: Maybe<Scalars['BigInt']['output']>;
  unit_amount?: Maybe<Scalars['BigInt']['output']>;
};

export type BudgetPositionsInput = {
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  our_work_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  time_tracking_work_type_id?: InputMaybe<Scalars['ID']['input']>;
  unit_amount?: InputMaybe<Scalars['BigInt']['input']>;
};

export enum BudgetStatusEnum {
  ApprovedByClient = 'APPROVED_BY_CLIENT',
  Draft = 'DRAFT',
  Final = 'FINAL',
  SentToClient = 'SENT_TO_CLIENT'
}

export enum BudgetTypeEnum {
  ActiveAssigned = 'ACTIVE_ASSIGNED',
  Archived = 'ARCHIVED',
  Assigned = 'ASSIGNED',
  Unassigned = 'UNASSIGNED'
}

export enum BudgetWhereColumn {
  AccountManager = 'ACCOUNT_MANAGER',
  BrandId = 'BRAND_ID',
  ClientApproved = 'CLIENT_APPROVED',
  Date = 'DATE',
  InternallyApproved = 'INTERNALLY_APPROVED',
  ProjectId = 'PROJECT_ID',
  Type = 'TYPE'
}

export type BudgetWhereConditions = {
  AND?: InputMaybe<Array<BudgetWhereConditions>>;
  OR?: InputMaybe<Array<BudgetWhereConditions>>;
  column?: InputMaybe<BudgetWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type BudgetovacBrandPositionsSet = {
  __typename?: 'BudgetovacBrandPositionsSet';
  brand?: Maybe<Brand>;
  budgetovacPositionSets: Array<BudgetovacPositionsSet>;
  client_id?: Maybe<Scalars['ID']['output']>;
};

export type BudgetovacPosition = {
  __typename?: 'BudgetovacPosition';
  alias: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  department_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  is_default: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type BudgetovacPositionPrice = {
  __typename?: 'BudgetovacPositionPrice';
  alias: Scalars['String']['output'];
  department_id?: Maybe<Scalars['ID']['output']>;
  department_name?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  position_id: Scalars['ID']['output'];
  price: Scalars['String']['output'];
};

export type BudgetovacPositionPriceInput = {
  alias: Scalars['String']['input'];
  department_id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  position_id: Scalars['ID']['input'];
  price: Scalars['String']['input'];
};

export type BudgetovacPositionsSet = {
  __typename?: 'BudgetovacPositionsSet';
  active: Scalars['Boolean']['output'];
  client_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  currency_code: Scalars['String']['output'];
  external_production_commission?: Maybe<Scalars['Float']['output']>;
  extras_commission?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  internal_production_commission?: Maybe<Scalars['Float']['output']>;
  media_budget_commission?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  positions_prices: Array<BudgetovacPositionPrice>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type BulkActionResponse = {
  __typename?: 'BulkActionResponse';
  failed: Scalars['BigInt']['output'];
  successful: Scalars['BigInt']['output'];
  total: Scalars['BigInt']['output'];
};

export type BulkEditTaskInput = {
  add_task_positions?: InputMaybe<Array<TaskPositionInput>>;
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  current_assignee_user_id?: InputMaybe<Scalars['ID']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  delete_old_positions: Scalars['Boolean']['input'];
  description?: InputMaybe<TaskDescriptionInput>;
  from?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  our_work_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
  parent_task_id?: InputMaybe<Scalars['ID']['input']>;
  position_mapping?: InputMaybe<Array<PositionMappingInput>>;
  task_priority_id?: InputMaybe<Scalars['ID']['input']>;
  task_status_id?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type BulkUpdateProjectsInput = {
  scopes?: InputMaybe<Array<UserScopeEnum>>;
};

export enum BusinessFormEnum {
  Company = 'COMPANY',
  Person = 'PERSON'
}

export type CalendarEventParticipant = {
  __typename?: 'CalendarEventParticipant';
  display_name?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  response_status?: Maybe<Scalars['String']['output']>;
};

export enum CalendarSyncDirectionEnum {
  Bidirectional = 'BIDIRECTIONAL',
  FromCalendar = 'FROM_CALENDAR',
  ToCalendar = 'TO_CALENDAR'
}

export enum CalendarTypeEnum {
  Google = 'GOOGLE',
  Outlook = 'OUTLOOK'
}

export type CapacityAllocation = {
  __typename?: 'CapacityAllocation';
  attendees: Array<Attendee>;
  calendarParticipants: Array<CalendarEventParticipant>;
  capacityAllocationItems: Array<CapacityAllocationItem>;
  create_task_positions: Scalars['Boolean']['output'];
  createdBy: User;
  created_at: Scalars['DateTime']['output'];
  deadline?: Maybe<Scalars['Date']['output']>;
  deadline_time?: Maybe<Scalars['Time']['output']>;
  deleted_items: Scalars['Boolean']['output'];
  from_date: Scalars['Date']['output'];
  from_time?: Maybe<Scalars['Time']['output']>;
  global: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  repetition: CapacityAllocationRepetitionTypeEnum;
  repetition_settings?: Maybe<RepetitionSettings>;
  task?: Maybe<Task>;
  teams?: Maybe<Array<TeamAttendee>>;
  timeOffType?: Maybe<TimeOffType>;
  time_off_duration_type?: Maybe<TimeOffDurationTypeEnum>;
  title?: Maybe<Scalars['String']['output']>;
  to_date: Scalars['Date']['output'];
  to_time?: Maybe<Scalars['Time']['output']>;
  total_time: Scalars['BigInt']['output'];
  total_time_per_day?: Maybe<Scalars['BigInt']['output']>;
  type: CapacityAllocationTypeEnum;
};

export type CapacityAllocationAttendee = {
  time_tracking_work_type_id?: InputMaybe<Scalars['ID']['input']>;
  user_id: Scalars['ID']['input'];
};

export type CapacityAllocationItem = {
  __typename?: 'CapacityAllocationItem';
  capacityAllocation: CapacityAllocation;
  completed: Scalars['Boolean']['output'];
  createdBy: User;
  date: Scalars['Date']['output'];
  duration_changed: Scalars['Boolean']['output'];
  eventLink?: Maybe<Scalars['String']['output']>;
  from_time?: Maybe<Scalars['Time']['output']>;
  global?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  meetLink?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  /**
   * Aggregates over the whole capacity allocation series this item belongs to.
   * Replaces fetching capacityAllocation.capacityAllocationItems just to reduce over it.
   */
  seriesSummary: CapacityAllocationSeriesSummary;
  stats?: Maybe<CapacityAllocationItemStats>;
  teams?: Maybe<Array<TeamAttendee>>;
  timeOffType?: Maybe<TimeOffType>;
  timeTrackingWorkType?: Maybe<TimeTrackingWorkType>;
  time_off_duration_type?: Maybe<TimeOffDurationTypeEnum>;
  time_tracking_work_type_id?: Maybe<Scalars['ID']['output']>;
  to_time?: Maybe<Scalars['Time']['output']>;
  total_time: Scalars['BigInt']['output'];
  type: CapacityAllocationTypeEnum;
  user: User;
  userItems: Array<CapacityAllocationItem>;
  userStats?: Maybe<CapacityAllocationUserItemStats>;
};


export type CapacityAllocationItemSeriesSummaryArgs = {
  today: Scalars['Date']['input'];
};

export type CapacityAllocationItemStats = {
  __typename?: 'CapacityAllocationItemStats';
  brand_id?: Maybe<Scalars['ID']['output']>;
  capacity_allocation_created_by_id?: Maybe<Scalars['ID']['output']>;
  capacity_allocation_id: Scalars['ID']['output'];
  capacity_allocation_item_id: Scalars['ID']['output'];
  client_id?: Maybe<Scalars['ID']['output']>;
  create_task_positions?: Maybe<Scalars['Boolean']['output']>;
  deadline?: Maybe<Scalars['Date']['output']>;
  deadline_time?: Maybe<Scalars['Time']['output']>;
  items_count: Scalars['Int']['output'];
  our_work_budget_item_id?: Maybe<Scalars['ID']['output']>;
  our_work_budget_item_title?: Maybe<Scalars['String']['output']>;
  project_code?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['ID']['output']>;
  project_title?: Maybe<Scalars['String']['output']>;
  repetition: CapacityAllocationRepetitionTypeEnum;
  task_id?: Maybe<Scalars['ID']['output']>;
  task_name?: Maybe<Scalars['String']['output']>;
  task_status_background_color?: Maybe<Scalars['String']['output']>;
  task_status_foreground_color?: Maybe<Scalars['String']['output']>;
  task_status_id?: Maybe<Scalars['ID']['output']>;
  task_status_name?: Maybe<Scalars['String']['output']>;
  task_status_system_status?: Maybe<TaskSystemStatusEnum>;
  time_off_type_affects_planning_capacity?: Maybe<Scalars['Boolean']['output']>;
  time_off_type_id?: Maybe<Scalars['ID']['output']>;
  time_off_type_name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tracking_enabled?: Maybe<Scalars['Boolean']['output']>;
  tracking_enabled_from?: Maybe<Scalars['Date']['output']>;
  tracking_enabled_to?: Maybe<Scalars['Date']['output']>;
};

export type CapacityAllocationRepetitionSettings = {
  days?: InputMaybe<Array<InputMaybe<RepetitionSettingsDaysEnum>>>;
  end: Scalars['Date']['input'];
  every: Scalars['Int']['input'];
  include_holidays?: InputMaybe<Scalars['Boolean']['input']>;
  startType?: InputMaybe<TimeOffDurationTypeEnum>;
  toType?: InputMaybe<TimeOffDurationTypeEnum>;
};

export enum CapacityAllocationRepetitionTypeEnum {
  Custom = 'CUSTOM',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Once = 'ONCE',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type CapacityAllocationSeriesSummary = {
  __typename?: 'CapacityAllocationSeriesSummary';
  /** Any item in the series has duration_changed = true. */
  any_duration_changed: Scalars['Boolean']['output'];
  /**
   * Per user, the count of completed items from today onwards.
   * Users with a count of zero are omitted.
   */
  futureCompletedPerUser: Array<CapacityAllocationUserCompletedCount>;
  /** SUM(total_time) of items from today onwards that are not completed. */
  future_open_total_time: Scalars['BigInt']['output'];
  /**
   * COUNT of items on the opened item's date that are not completed.
   * Not filtered by today - the caller keeps that guard.
   */
  same_day_open_count: Scalars['Int']['output'];
  /**
   * SUM(total_time) of items on the opened item's date that are not completed.
   * Not filtered by today - the caller keeps that guard.
   */
  same_day_open_total_time: Scalars['BigInt']['output'];
};

export enum CapacityAllocationTypeEnum {
  HomeOffice = 'HOME_OFFICE',
  Imported = 'IMPORTED',
  Meeting = 'MEETING',
  Task = 'TASK',
  TimeOff = 'TIME_OFF',
  WeekendWork = 'WEEKEND_WORK'
}

export type CapacityAllocationUserCompletedCount = {
  __typename?: 'CapacityAllocationUserCompletedCount';
  count: Scalars['Int']['output'];
  user_id: Scalars['ID']['output'];
};

export type CapacityAllocationUserItemStats = {
  __typename?: 'CapacityAllocationUserItemStats';
  capacity_allocation_item_id: Scalars['ID']['output'];
  has_running_timer: Scalars['Boolean']['output'];
  tracked_time_for_item?: Maybe<Scalars['BigInt']['output']>;
};

export enum CapacityAllocationWorkStatus {
  TimeOff = 'TIME_OFF',
  Unavailable = 'UNAVAILABLE',
  WithoutCapacity = 'WITHOUT_CAPACITY',
  Working = 'WORKING'
}

export type Client = {
  __typename?: 'Client';
  billingEntities: Array<BillingEntity>;
  brands: Array<Brand>;
  cloudUrl?: Maybe<Scalars['String']['output']>;
  contacts: Array<Contact>;
  contracts?: Maybe<ContractPaginator>;
  created_at: Scalars['DateTime']['output'];
  currencyExchangeRates: Array<CurrencyExchangeRate>;
  currencyExchangeRatesStructured: Array<CurrencyExchangeRateStructured>;
  driveCloudUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<AssignableFile>;
  name: Scalars['String']['output'];
  otherDocuments?: Maybe<OtherDocumentPaginator>;
  otherResponsiblePersons: Array<User>;
  responsiblePerson?: Maybe<User>;
  updated_at: Scalars['DateTime']['output'];
  workspaceCompany: WorkspaceCompany;
};


export type ClientBrandsArgs = {
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ClientContractsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type ClientCurrencyExchangeRatesArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ClientOtherDocumentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ClientOrderByClause = {
  column: ClientOrderByColumnEnum;
  order: SortOrder;
};

export enum ClientOrderByColumnEnum {
  ClientName = 'CLIENT_NAME'
}

/** A paginated list of Client items. */
export type ClientPaginator = {
  __typename?: 'ClientPaginator';
  /** A list of Client items. */
  data: Array<Client>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ClientQueryArgs = {
  orderBy?: InputMaybe<Array<ClientOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ClientsWhereConditions>;
};

export type ClientSimple = {
  __typename?: 'ClientSimple';
  brands: Array<BrandSimple>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};


export type ClientSimpleBrandsArgs = {
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ClientsWhereColumn {
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  ContactId = 'CONTACT_ID',
  ResponsiblePersonUserId = 'RESPONSIBLE_PERSON_USER_ID'
}

export type ClientsWhereConditions = {
  AND?: InputMaybe<Array<ClientsWhereConditions>>;
  OR?: InputMaybe<Array<ClientsWhereConditions>>;
  column?: InputMaybe<ClientsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export enum CommissionUnit {
  Absolute = 'ABSOLUTE',
  Relative = 'RELATIVE'
}

export type CompanyBankAccount = {
  __typename?: 'CompanyBankAccount';
  iban?: Maybe<Scalars['String']['output']>;
  swift?: Maybe<Scalars['String']['output']>;
};

export type CompanyData = {
  __typename?: 'CompanyData';
  applies_vat: Scalars['Boolean']['output'];
  bankAccounts: Array<CompanyBankAccount>;
  cancelled: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  legal_name?: Maybe<Scalars['String']['output']>;
  registration_no?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  tax_no?: Maybe<Scalars['String']['output']>;
  vat_no?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type CompanySettings = {
  __typename?: 'CompanySettings';
  city: Scalars['String']['output'];
  country_id: Scalars['BigInt']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  title: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type CompleteCapacityAllocationUserInput = {
  complete: Scalars['Boolean']['input'];
  existingTimeTrackingItems?: InputMaybe<Array<UpdateTimeTrackingItemInput>>;
  id: Scalars['ID']['input'];
  newTimeTrackingItem?: InputMaybe<CreateTimeTrackingItemInput>;
};

export type ConnectToMcpInput = {
  token: Scalars['String']['input'];
};

export type ConnectToMcpPayload = {
  __typename?: 'ConnectToMcpPayload';
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  created_at: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<AssignableFile>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pipedriveCustomFieldValues: Array<PipedriveCustomFieldValue>;
  updated_at: Scalars['DateTime']['output'];
};

export type Contract = Document & {
  __typename?: 'Contract';
  brands?: Maybe<Array<Maybe<Brand>>>;
  clients?: Maybe<Array<Maybe<Client>>>;
  cloudUrl?: Maybe<Scalars['String']['output']>;
  contractors?: Maybe<Array<Maybe<Contractor>>>;
  created_at: Scalars['DateTime']['output'];
  driveCloudUrl?: Maybe<Scalars['String']['output']>;
  files: Array<AssignableFile>;
  id: Scalars['ID']['output'];
  pdfFiles: Array<AssignableFile>;
  projects?: Maybe<Array<Maybe<Project>>>;
  title: Scalars['String']['output'];
  type: ContractTypeEnum;
  updated_at: Scalars['DateTime']['output'];
  urls: MediaUrlList;
  valid_from: Scalars['Date']['output'];
  valid_to?: Maybe<Scalars['Date']['output']>;
};

export type ContractOrderByClause = {
  column: ContractOrderByColumnEnum;
  order: SortOrder;
};

export enum ContractOrderByColumnEnum {
  Title = 'TITLE',
  ValidFrom = 'VALID_FROM',
  ValidTo = 'VALID_TO'
}

/** A paginated list of Contract items. */
export type ContractPaginator = {
  __typename?: 'ContractPaginator';
  /** A list of Contract items. */
  data: Array<Contract>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ContractQueryArgs = {
  orderBy?: InputMaybe<Array<ContractOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ContractsWhereConditions>;
};

export type ContractSimple = {
  __typename?: 'ContractSimple';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export enum ContractTypeEnum {
  CopyrightTreaty = 'COPYRIGHT_TREATY',
  MasterAgreement = 'MASTER_AGREEMENT',
  Nda = 'NDA',
  Other = 'OTHER',
  WorksContract = 'WORKS_CONTRACT'
}

export type Contractor = {
  __typename?: 'Contractor';
  bank_account?: Maybe<Scalars['String']['output']>;
  bank_account_code?: Maybe<Scalars['String']['output']>;
  business_form?: Maybe<BusinessFormEnum>;
  city?: Maybe<Scalars['String']['output']>;
  contracts?: Maybe<ContractPaginator>;
  contractsNonPaginated?: Maybe<Array<Contract>>;
  country?: Maybe<Country>;
  created_at: Scalars['DateTime']['output'];
  defaultAccountingAccount?: Maybe<AccountingAccount>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_vat_payer?: Maybe<Scalars['Boolean']['output']>;
  legal_name: Scalars['String']['output'];
  national_id?: Maybe<Scalars['String']['output']>;
  otherDocuments?: Maybe<OtherDocumentPaginator>;
  registration_no?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  swift?: Maybe<Scalars['String']['output']>;
  tax_no?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  vat_no?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


export type ContractorContractsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type ContractorOtherDocumentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractorBasic = {
  __typename?: 'ContractorBasic';
  id: Scalars['ID']['output'];
  legal_name: Scalars['String']['output'];
};

export type ContractorBasicQueryArgs = {
  orderBy?: InputMaybe<Array<ContractorOrderByClause>>;
  search: Scalars['String']['input'];
};

export type ContractorOrderByClause = {
  column: ContractorOrderByColumnEnum;
  order: SortOrder;
};

export enum ContractorOrderByColumnEnum {
  Iban = 'IBAN',
  Id = 'ID',
  IsVatPayer = 'IS_VAT_PAYER',
  LegalName = 'LEGAL_NAME',
  RegistrationNo = 'REGISTRATION_NO'
}

/** A paginated list of Contractor items. */
export type ContractorPaginator = {
  __typename?: 'ContractorPaginator';
  /** A list of Contractor items. */
  data: Array<Contractor>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ContractorQueryArgs = {
  orderBy?: InputMaybe<Array<ContractorOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ContractorsWhereConditions>;
};

export type ContractorSimple = {
  __typename?: 'ContractorSimple';
  id: Scalars['ID']['output'];
  legal_name: Scalars['String']['output'];
};

export type ContractorsBasic = {
  __typename?: 'ContractorsBasic';
  contractorsList: Array<ContractorBasic>;
};

export type ContractorsSummary = {
  __typename?: 'ContractorsSummary';
  contractorIds: Array<Scalars['ID']['output']>;
};

export enum ContractorsWhereColumn {
  IsVatPayer = 'IS_VAT_PAYER'
}

export type ContractorsWhereConditions = {
  AND?: InputMaybe<Array<ContractorsWhereConditions>>;
  OR?: InputMaybe<Array<ContractorsWhereConditions>>;
  column?: InputMaybe<ContractorsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type ContractsSummary = {
  __typename?: 'ContractsSummary';
  contractIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export enum ContractsWhereColumn {
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  ContractorId = 'CONTRACTOR_ID',
  ProjectId = 'PROJECT_ID',
  Type = 'TYPE',
  ValidFrom = 'VALID_FROM',
  ValidTo = 'VALID_TO'
}

export type ContractsWhereConditions = {
  AND?: InputMaybe<Array<ContractsWhereConditions>>;
  OR?: InputMaybe<Array<ContractsWhereConditions>>;
  column?: InputMaybe<ContractsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type ConvertedAmount = {
  __typename?: 'ConvertedAmount';
  amount: Scalars['BigInt']['output'];
  exchange_rate: Scalars['BigInt']['output'];
};

export type ConvertedAmountWithIdentifier = {
  __typename?: 'ConvertedAmountWithIdentifier';
  amount: Scalars['BigInt']['output'];
  identifier: Scalars['String']['output'];
  unit_price?: Maybe<Scalars['BigInt']['output']>;
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type CountrySimple = {
  __typename?: 'CountrySimple';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CreateBillingEntityInput = {
  applies_vat: Scalars['Boolean']['input'];
  city: Scalars['String']['input'];
  client_id: Scalars['ID']['input'];
  country_id: Scalars['ID']['input'];
  default_currency_id: Scalars['ID']['input'];
  disable_email_notification: Scalars['Boolean']['input'];
  internal_name: Scalars['String']['input'];
  invoice_email?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  legal_name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  payment_due?: InputMaybe<Scalars['BigInt']['input']>;
  registration_no?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  tax_no?: InputMaybe<Scalars['String']['input']>;
  vat_no?: InputMaybe<Scalars['String']['input']>;
  workspace_bank_account_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id: Scalars['ID']['input'];
  zip: Scalars['String']['input'];
};

export type CreateBrandCreditAccountInput = {
  brand_id: Scalars['ID']['input'];
  expense_budget_category_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  our_work_budget_category_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  team_id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type CreateBrandInput = {
  client_id: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  default_billing_entity_id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  numeric_code?: InputMaybe<Scalars['String']['input']>;
  other_responsible_person_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  responsible_person_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateBudgetItemPlannedExpensesInput = {
  budget_item_id: Scalars['ID']['input'];
  budget_item_type: ExpenseBudgetItemTypeEnum;
  planned_expenses: Array<BudgetItemPlannedExpenseInput>;
};

export type CreateBudgetovacPositionInput = {
  department_id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateBudgetovacPositionsSetInput = {
  active: Scalars['Boolean']['input'];
  client_id?: InputMaybe<Scalars['Int']['input']>;
  currency_code: Scalars['String']['input'];
  external_production_commission?: InputMaybe<Scalars['Float']['input']>;
  extras_commission?: InputMaybe<Scalars['Float']['input']>;
  internal_production_commission?: InputMaybe<Scalars['Float']['input']>;
  media_budget_commission?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  positions_prices: Array<BudgetovacPositionPriceInput>;
};

export type CreateCapacityAllocationInput = {
  attendees?: InputMaybe<Array<CapacityAllocationAttendee>>;
  create_task_positions: Scalars['Boolean']['input'];
  created_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  deadline_time?: InputMaybe<Scalars['Time']['input']>;
  from_date: Scalars['Date']['input'];
  from_time?: InputMaybe<Scalars['Time']['input']>;
  global: Scalars['Boolean']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  repetition: CapacityAllocationRepetitionTypeEnum;
  repetition_settings?: InputMaybe<CapacityAllocationRepetitionSettings>;
  task_id?: InputMaybe<Scalars['ID']['input']>;
  team_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  time_off_duration_type?: InputMaybe<TimeOffDurationTypeEnum>;
  time_off_type_id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  to_date: Scalars['Date']['input'];
  to_time?: InputMaybe<Scalars['Time']['input']>;
  total_time?: InputMaybe<Scalars['BigInt']['input']>;
  total_time_per_day?: InputMaybe<Scalars['BigInt']['input']>;
  type: CapacityAllocationTypeEnum;
};

export type CreateClientInput = {
  name: Scalars['String']['input'];
  other_responsible_person_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  responsible_person_user_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id: Scalars['ID']['input'];
};

export type CreateContactInput = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  client_id?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContractInput = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  client_id?: InputMaybe<Scalars['ID']['input']>;
  contractor_id?: InputMaybe<Scalars['ID']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  project_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title: Scalars['String']['input'];
  type: ContractTypeEnum;
  valid_from: Scalars['Date']['input'];
  valid_to?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateContractorInput = {
  bank_account?: InputMaybe<Scalars['String']['input']>;
  bank_account_code?: InputMaybe<Scalars['String']['input']>;
  business_form?: InputMaybe<BusinessFormEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['ID']['input']>;
  default_accounting_account_id?: InputMaybe<Scalars['ID']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  legal_name: Scalars['String']['input'];
  national_id?: InputMaybe<Scalars['String']['input']>;
  registration_no?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  swift?: InputMaybe<Scalars['String']['input']>;
  tax_no?: InputMaybe<Scalars['String']['input']>;
  vat_no?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCurrencyExchangeRateInput = {
  client_id: Scalars['ID']['input'];
  currency_id: Scalars['ID']['input'];
  exchange_rate: Scalars['BigInt']['input'];
  valid_from?: InputMaybe<Scalars['Date']['input']>;
  valid_to?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateEmailTemplateInput = {
  content: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  type: EmailTemplateTypeEnum;
};

export type CreateExchangeRateSettingsInput = {
  currency_id: Scalars['ID']['input'];
  exchange_rate: Scalars['BigInt']['input'];
  valid_from?: InputMaybe<Scalars['Date']['input']>;
  valid_to?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateExpenseInput = {
  amount_in_currency?: InputMaybe<Scalars['BigInt']['input']>;
  bank_account?: InputMaybe<Scalars['String']['input']>;
  bank_account_code?: InputMaybe<Scalars['String']['input']>;
  business_form?: InputMaybe<BusinessFormEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  constant_symbol?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['ID']['input']>;
  contractor_id?: InputMaybe<Scalars['ID']['input']>;
  country_id?: InputMaybe<Scalars['ID']['input']>;
  currency_id: Scalars['ID']['input'];
  date_of_supply?: InputMaybe<Scalars['Date']['input']>;
  default_accounting_account_id?: InputMaybe<Scalars['ID']['input']>;
  document_number?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  exchange_rate?: InputMaybe<Scalars['BigInt']['input']>;
  expense_items?: InputMaybe<Array<ExpenseItemInput>>;
  expense_no?: InputMaybe<Scalars['String']['input']>;
  expense_vat_items?: InputMaybe<Array<ExpenseVatItemInput>>;
  files?: InputMaybe<Array<FileInput>>;
  fond_contractor_id?: InputMaybe<Scalars['ID']['input']>;
  for_approval: Scalars['Boolean']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  internal_note?: InputMaybe<Scalars['String']['input']>;
  internal_number?: InputMaybe<Scalars['String']['input']>;
  invoice_order_sequence_id?: InputMaybe<Scalars['ID']['input']>;
  is_draft: Scalars['Boolean']['input'];
  issue_date?: InputMaybe<Scalars['Date']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  national_id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paid_at?: InputMaybe<Scalars['Date']['input']>;
  payment_type_id?: InputMaybe<Scalars['ID']['input']>;
  registration_no?: InputMaybe<Scalars['String']['input']>;
  /** IDs of related expenses to link (bidirectional relationship) */
  related_expense_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  specific_symbol?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  swift?: InputMaybe<Scalars['String']['input']>;
  tax_no?: InputMaybe<Scalars['String']['input']>;
  total_amount_includes_vat?: InputMaybe<Scalars['Boolean']['input']>;
  total_amount_with_vat_in_currency?: InputMaybe<Scalars['BigInt']['input']>;
  type: ExpenseTypeEnum;
  user_created_date: Scalars['Date']['input'];
  variable_symbol?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['BigInt']['input']>;
  vat_no?: InputMaybe<Scalars['String']['input']>;
  workspace_bank_account_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id?: InputMaybe<Scalars['ID']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExternalLinkInput = {
  link: Scalars['String']['input'];
  model_id: Scalars['ID']['input'];
  model_type: ExternalLinkType;
  title: Scalars['String']['input'];
};

export type CreateGlobalCreditAccountInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateInvoiceFromBillingPlanInput = {
  issue_date: Scalars['Date']['input'];
  project_id: Scalars['ID']['input'];
};

export type CreateOrderInput = {
  brand_id: Scalars['ID']['input'];
  date_of_order?: InputMaybe<Scalars['Date']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  project_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  purchase_order_no: Scalars['String']['input'];
};

export type CreateOtherDocumentInput = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  client_id?: InputMaybe<Scalars['ID']['input']>;
  contractor_id?: InputMaybe<Scalars['ID']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  project_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title: Scalars['String']['input'];
};

export type CreateProjectFromPipedriveInput = {
  creator_user_id: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  link: Scalars['String']['input'];
  org_id: Scalars['Int']['input'];
  person_id: Scalars['Int']['input'];
  stage_id: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateProjectFromTemplateInput = {
  billable: Scalars['Boolean']['input'];
  brand_id: Scalars['ID']['input'];
  category_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  contact_id?: InputMaybe<Scalars['ID']['input']>;
  expected_end_date?: InputMaybe<Scalars['Date']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  other_project_manager_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  project_manager_id: Scalars['ID']['input'];
  rate_card_exchange_rate?: InputMaybe<Scalars['BigInt']['input']>;
  rate_card_id?: InputMaybe<Scalars['ID']['input']>;
  scopes?: InputMaybe<Array<UserScopeEnum>>;
  start_date: Scalars['Date']['input'];
  team_id: Scalars['ID']['input'];
  template_id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  type: ProjectTypeEnum;
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateProjectInput = {
  billable: Scalars['Boolean']['input'];
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  budget_id?: InputMaybe<Scalars['ID']['input']>;
  category_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  contact_id?: InputMaybe<Scalars['ID']['input']>;
  expected_end_date?: InputMaybe<Scalars['Date']['input']>;
  is_template: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  other_project_manager_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  project_manager_id: Scalars['ID']['input'];
  rate_card_exchange_rate?: InputMaybe<Scalars['BigInt']['input']>;
  rate_card_id?: InputMaybe<Scalars['ID']['input']>;
  scopes?: InputMaybe<Array<UserScopeEnum>>;
  start_date: Scalars['Date']['input'];
  team_id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  type: ProjectTypeEnum;
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input pre vytvorenie Time Billing */
export type CreateProjectTimeBillingInput = {
  components?: InputMaybe<Array<TimeBillingComponentInput>>;
  date_from: Scalars['Date']['input'];
  date_to: Scalars['Date']['input'];
  final_total_amount?: InputMaybe<Scalars['BigInt']['input']>;
  final_total_note?: InputMaybe<Scalars['String']['input']>;
  project_id: Scalars['ID']['input'];
  source_ids?: InputMaybe<Array<TimeBillingSourceInput>>;
  timeTrackingItemIds: Array<Scalars['BigInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user_rows?: InputMaybe<Array<TimeBillingUserRowInput>>;
};

export type CreateRequestForInvoicingInput = {
  assignable_file_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  billing_entity_id?: InputMaybe<Scalars['ID']['input']>;
  brand_ids: Array<Scalars['ID']['input']>;
  client_id: Scalars['ID']['input'];
  contact_id?: InputMaybe<Scalars['ID']['input']>;
  credit_note_outgoing_invoice_id?: InputMaybe<Scalars['ID']['input']>;
  currency_id: Scalars['ID']['input'];
  date_of_supply?: InputMaybe<Scalars['Date']['input']>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  exchange_rate: Scalars['BigInt']['input'];
  exchange_rate_source: ExchangeRateSource;
  expense_budget_splits: Array<ExpenseBudgetSplitInput>;
  internal_note?: InputMaybe<Scalars['String']['input']>;
  invoice_items: Array<InvoiceItemInput>;
  invoice_payment_method_id?: InputMaybe<Scalars['ID']['input']>;
  issue_date?: InputMaybe<Scalars['Date']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  order_ids: Array<Scalars['ID']['input']>;
  our_work_budget_splits: Array<OurWorkBudgetSplitInput>;
  outgoing_proforma_invoice_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  owner_id?: InputMaybe<Scalars['ID']['input']>;
  prepayment_splits: Array<PrepaymentSplitInput>;
  project_ids: Array<Scalars['ID']['input']>;
  proof_of_payments_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  show_billing_accounting: Scalars['Boolean']['input'];
  show_unit_price: Scalars['Boolean']['input'];
  status: RequestForInvoicingStatusEnum;
  team_ids: Array<Scalars['ID']['input']>;
  text_on_invoice?: InputMaybe<Scalars['String']['input']>;
  timeMaterialsInvoiceData?: InputMaybe<TimeMaterialsInputData>;
  total_in_words?: InputMaybe<Scalars['String']['input']>;
  type: RequestForInvoicingTypeEnum;
  vat_percent_informative?: InputMaybe<Scalars['BigInt']['input']>;
  vat_reverse_charge: Scalars['Boolean']['input'];
  workspace_bank_account_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id: Scalars['ID']['input'];
  workspace_exchange_rate: Scalars['BigInt']['input'];
  workspace_exchange_rate_source: ExchangeRateSource;
};

export type CreateScopedTaskInput = {
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<TaskDescriptionInput>;
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  project_id?: InputMaybe<Scalars['ID']['input']>;
  task_priority_id?: InputMaybe<Scalars['ID']['input']>;
  task_status_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateScopedUserInput = {
  brands: Array<Scalars['ID']['input']>;
  codename?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  photo?: InputMaybe<Scalars['Upload']['input']>;
  scope: UserScopeEnum;
  scope_access: UserScopeAccessEnum;
  tasks: Array<Scalars['ID']['input']>;
};

export type CreateSequenceInput = {
  format: Scalars['BigInt']['input'];
  types: Array<SequenceTypesEnum>;
};

export type CreateTaskCommentInput = {
  body: Scalars['String']['input'];
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  in_reply_to_id?: InputMaybe<Scalars['ID']['input']>;
  mentioned_assignees?: InputMaybe<Scalars['Boolean']['input']>;
  mentioned_team_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  mentioned_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** only for ApiClient */
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  scope?: InputMaybe<UserScopeEnum>;
  task_id: Scalars['ID']['input'];
};

export type CreateTaskInput = {
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  create_capacity_allocations?: InputMaybe<Scalars['Boolean']['input']>;
  current_assignee_user_id?: InputMaybe<Scalars['ID']['input']>;
  days_to_deadline?: InputMaybe<Scalars['Int']['input']>;
  days_to_from?: InputMaybe<Scalars['Int']['input']>;
  days_to_to?: InputMaybe<Scalars['Int']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  default_planned_time?: InputMaybe<Scalars['BigInt']['input']>;
  description?: InputMaybe<TaskDescriptionInput>;
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from?: InputMaybe<Scalars['Date']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  is_template: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  our_work_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
  parent_id?: InputMaybe<Scalars['ID']['input']>;
  /** only for ApiClient */
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  positions?: InputMaybe<Array<TaskPositionInput>>;
  scopes?: InputMaybe<Array<UserScopeEnum>>;
  task_priority_id?: InputMaybe<Scalars['ID']['input']>;
  task_status_id?: InputMaybe<Scalars['ID']['input']>;
  task_template_group_id?: InputMaybe<Scalars['ID']['input']>;
  team_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  to?: InputMaybe<Scalars['Date']['input']>;
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateTimeTrackingItemInput = {
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  specific_time_from?: InputMaybe<Scalars['Time']['input']>;
  specific_time_to?: InputMaybe<Scalars['Time']['input']>;
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  tracked_for_date: Scalars['Date']['input'];
  tracked_time?: InputMaybe<Scalars['BigInt']['input']>;
};

export type CreateTimeTrackingWorkTypeInput = {
  alias: Scalars['String']['input'];
  default_rate: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

export type CreateUpdateExpenseContractorInput = {
  bank_account?: InputMaybe<Scalars['String']['input']>;
  bank_account_code?: InputMaybe<Scalars['String']['input']>;
  business_form?: InputMaybe<BusinessFormEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  contractor_id: Scalars['ID']['input'];
  country_id?: InputMaybe<Scalars['ID']['input']>;
  default_accounting_account_id?: InputMaybe<Scalars['ID']['input']>;
  expense_id?: InputMaybe<Scalars['ID']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  national_id?: InputMaybe<Scalars['String']['input']>;
  registration_no?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  swift?: InputMaybe<Scalars['String']['input']>;
  tax_no?: InputMaybe<Scalars['String']['input']>;
  vat_no?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserInput = {
  codename?: InputMaybe<Scalars['String']['input']>;
  default_work_type_id: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  hex_color: Scalars['String']['input'];
  internal_hourly_rate: Scalars['BigInt']['input'];
  last_name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  plannable: Scalars['Boolean']['input'];
  plannable_capacity: Scalars['BigInt']['input'];
  role_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  show_in_utilization: Scalars['Boolean']['input'];
  team_id: Scalars['ID']['input'];
};

export type CreateVatRateInput = {
  amount: Scalars['BigInt']['input'];
  type: VatRateTypeEnum;
};

export type CreateWorkspaceSmtpSettingsInput = {
  active?: Scalars['Boolean']['input'];
  smtp_encryption?: InputMaybe<Scalars['String']['input']>;
  smtp_from_address?: InputMaybe<Scalars['String']['input']>;
  smtp_from_name?: InputMaybe<Scalars['String']['input']>;
  smtp_host?: InputMaybe<Scalars['String']['input']>;
  smtp_password?: InputMaybe<Scalars['String']['input']>;
  smtp_port?: InputMaybe<Scalars['Int']['input']>;
  smtp_username?: InputMaybe<Scalars['String']['input']>;
};

export type CreditAccount = {
  __typename?: 'CreditAccount';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  team?: Maybe<Team>;
  updated_at: Scalars['DateTime']['output'];
};

export type CreditAccountQueryArgs = {
  orderBy?: InputMaybe<Array<BrandCreditAccountOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BrandCreditAccountsWhereConditions>;
};

export type CreditStats = {
  credit: Scalars['BigInt']['output'];
  invoiceable: Scalars['BigInt']['output'];
  invoiced_percent: Scalars['BigInt']['output'];
  over_invoiced: Scalars['BigInt']['output'];
  uninvoiced: Scalars['BigInt']['output'];
};

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String']['output'];
  denomination: Scalars['BigInt']['output'];
  exchange_rate?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['ID']['output'];
};

export type CurrencyExchangeRate = {
  __typename?: 'CurrencyExchangeRate';
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  exchange_rate: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
  valid_from?: Maybe<Scalars['Date']['output']>;
  valid_to?: Maybe<Scalars['Date']['output']>;
};

export type CurrencyExchangeRateStructured = {
  __typename?: 'CurrencyExchangeRateStructured';
  currency: Currency;
  exchangeRates: Array<CurrencyExchangeRate>;
};

export type CurrencyInput = {
  code: Scalars['String']['input'];
  exchange_rate?: InputMaybe<Scalars['BigInt']['input']>;
};

export type DateIntegerDataPoint = {
  __typename?: 'DateIntegerDataPoint';
  amount: Scalars['BigInt']['output'];
  date: Scalars['Date']['output'];
};

export type DateRange = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type DefaultCurrency = {
  __typename?: 'DefaultCurrency';
  code: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type DeleteCapacityAllocationForDayInput = {
  date: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
};

export type DeleteCapacityAllocationInput = {
  decline_for_user_id?: InputMaybe<Scalars['ID']['input']>;
  deleting_from_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteCapacityAllocationItemInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTimeTrackingWorkTypeInput = {
  alias: Scalars['String']['input'];
};

export type DisconnectFromMcpInput = {
  /** Id of the McpToken to revoke, so only that one client loses access. */
  id: Scalars['ID']['input'];
};

export type Document = {
  brands?: Maybe<Array<Maybe<Brand>>>;
  clients?: Maybe<Array<Maybe<Client>>>;
  contractors?: Maybe<Array<Maybe<Contractor>>>;
  created_at: Scalars['DateTime']['output'];
  files: Array<AssignableFile>;
  id: Scalars['ID']['output'];
  pdfFiles: Array<AssignableFile>;
  projects?: Maybe<Array<Maybe<Project>>>;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type DocumentExport = {
  __typename?: 'DocumentExport';
  created_at: Scalars['DateTime']['output'];
  exported_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  model_id: Scalars['ID']['output'];
  model_type: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export enum DocumentLimitTypeEnum {
  Expense = 'EXPENSE',
  OutgoingInvoice = 'OUTGOING_INVOICE',
  ProformaOutgoingInvoice = 'PROFORMA_OUTGOING_INVOICE'
}

export enum EmailLogTypeEnum {
  OutgoingInvoice = 'OUTGOING_INVOICE',
  OutgoingInvoicePaymentReminder = 'OUTGOING_INVOICE_PAYMENT_REMINDER'
}

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  type: EmailTemplateTypeEnum;
};

export enum EmailTemplateTypeEnum {
  ExpenseCreated = 'EXPENSE_CREATED',
  InvoiceSendThankYou = 'INVOICE_SEND_THANK_YOU',
  NewRfiSubmitted = 'NEW_RFI_SUBMITTED',
  OutgoingInvoice = 'OUTGOING_INVOICE',
  OutgoingInvoiceAfterDueDate = 'OUTGOING_INVOICE_AFTER_DUE_DATE',
  OutgoingInvoiceBeforeDueDateReminder = 'OUTGOING_INVOICE_BEFORE_DUE_DATE_REMINDER',
  OutgoingInvoicePaymentReminder = 'OUTGOING_INVOICE_PAYMENT_REMINDER',
  OutgoingInvoiceResend = 'OUTGOING_INVOICE_RESEND',
  OutgoingProformaInvoice = 'OUTGOING_PROFORMA_INVOICE',
  OutgoingProformaInvoiceBeforeDueDateReminder = 'OUTGOING_PROFORMA_INVOICE_BEFORE_DUE_DATE_REMINDER',
  Quote = 'QUOTE',
  RunningTimeReminder = 'RUNNING_TIME_REMINDER'
}

export enum ExchangeRateSource {
  Auto = 'AUTO',
  Budget = 'BUDGET',
  Client = 'CLIENT',
  Custom = 'CUSTOM',
  Workspace = 'WORKSPACE'
}

export type Expense = {
  __typename?: 'Expense';
  abraflexi_exported?: Maybe<Scalars['Boolean']['output']>;
  accountMoves?: Maybe<Array<BankAccountMoveDocument>>;
  bank_account?: Maybe<Scalars['String']['output']>;
  bank_account_code?: Maybe<Scalars['String']['output']>;
  business_form?: Maybe<BusinessFormEnum>;
  city?: Maybe<Scalars['String']['output']>;
  constant_symbol?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  contractor?: Maybe<Contractor>;
  country?: Maybe<Country>;
  country_id?: Maybe<Scalars['ID']['output']>;
  created_by_user_id?: Maybe<Scalars['ID']['output']>;
  currency: Currency;
  date_of_supply?: Maybe<Scalars['Date']['output']>;
  defaultAccountingAccount?: Maybe<AccountingAccount>;
  /** Export history for this expense */
  documentExports: Array<DocumentExport>;
  document_number?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['Date']['output']>;
  emailData?: Maybe<ExpenseEmailData>;
  exchange_rate?: Maybe<Scalars['BigInt']['output']>;
  expenseItems: Array<ExpenseItem>;
  expenseItemsStructured: Array<StructuredExpenseItemsItem>;
  expenseVatItems: Array<ExpenseVatItem>;
  expense_documents: Array<AssignableFile>;
  expense_no?: Maybe<Scalars['String']['output']>;
  fond_contractor_id?: Maybe<Scalars['ID']['output']>;
  /** ID of the 2% fond expense after it was created */
  fond_expense_id?: Maybe<Scalars['ID']['output']>;
  for_approval: Scalars['Boolean']['output'];
  has_master_agreement?: Maybe<Scalars['Boolean']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internal_note?: Maybe<Scalars['String']['output']>;
  internal_number?: Maybe<Scalars['String']['output']>;
  invoice_order_sequence_id?: Maybe<Scalars['ID']['output']>;
  invoice_status: ExpenseInvoiceStatusEnum;
  is_draft: Scalars['Boolean']['output'];
  issue_date?: Maybe<Scalars['Date']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  lockedDocument?: Maybe<LockDocument>;
  modelLock?: Maybe<ModelLock>;
  national_id?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  paid_at?: Maybe<Scalars['Date']['output']>;
  payment_status: PaymentStatusEnum;
  payment_type?: Maybe<PaymentType>;
  projectTimeBilling?: Maybe<ProjectTimeBilling>;
  projects: Array<Project>;
  registration_no?: Maybe<Scalars['String']['output']>;
  /** Related expenses (bidirectional - includes both directions of the relationship) */
  relatedExpenses: Array<Expense>;
  specific_symbol?: Maybe<Scalars['String']['output']>;
  stats: ExpenseStats;
  status: ExpenseStatusEnum;
  street?: Maybe<Scalars['String']['output']>;
  swift?: Maybe<Scalars['String']['output']>;
  tax_no?: Maybe<Scalars['String']['output']>;
  total_amount_includes_vat: Scalars['Boolean']['output'];
  total_amount_with_vat_in_currency: Scalars['BigInt']['output'];
  type: ExpenseTypeEnum;
  updated_at: Scalars['DateTime']['output'];
  user_created_date: Scalars['Date']['output'];
  variable_symbol?: Maybe<Scalars['String']['output']>;
  vat_no?: Maybe<Scalars['String']['output']>;
  workspace_bank_account_id?: Maybe<Scalars['ID']['output']>;
  workspace_company_id?: Maybe<Scalars['ID']['output']>;
  xero_exported?: Maybe<Scalars['Boolean']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ExpenseBudgetCategory = BudgetCategory & {
  __typename?: 'ExpenseBudgetCategory';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shortcut: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ExpenseBudgetCategoryTopProject = {
  __typename?: 'ExpenseBudgetCategoryTopProject';
  expense_budget_item_id: Scalars['ID']['output'];
  value: Scalars['BigInt']['output'];
};

export type ExpenseBudgetItem = BudgetItemForExpenseInterface & BudgetItemInterface & {
  __typename?: 'ExpenseBudgetItem';
  category: ExpenseBudgetCategory;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  creditAccount?: Maybe<CreditAccount>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  /** Empty unless requested for deletion. */
  deletion_blockers: Array<BudgetItemDeletionBlockerEnum>;
  expenseStats: Array<ExpenseBudgetItemExpenseStats>;
  globalPrepaymentStats: Array<ExpenseBudgetItemGlobalPrepaymentStats>;
  id: Scalars['ID']['output'];
  invoiceStats: Array<ExpenseBudgetItemInvoiceStats>;
  item_code?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  outgoingProformaInvoiceStats: Array<OurWorkBudgetItemProformaStats>;
  payment_status: ExpenseInvoiceStatusEnum;
  plannedExpenses: Array<BudgetItemPlannedExpense>;
  prepaymentStats: Array<ExpenseBudgetItemPrepaymentStats>;
  project: Project;
  requested_for_deletion_at?: Maybe<Scalars['DateTime']['output']>;
  stats: ExpenseBudgetItemStats;
  title: Scalars['String']['output'];
  type: ExpenseBudgetItemType;
  updated_at: Scalars['DateTime']['output'];
  vat_percent_informative?: Maybe<Scalars['BigInt']['output']>;
};

export type ExpenseBudgetItemExpenseStats = {
  __typename?: 'ExpenseBudgetItemExpenseStats';
  amount: Scalars['BigInt']['output'];
  contractor?: Maybe<Contractor>;
  date?: Maybe<Scalars['Date']['output']>;
  expense: Expense;
  id: Scalars['ID']['output'];
};

export type ExpenseBudgetItemGlobalPrepaymentStats = {
  __typename?: 'ExpenseBudgetItemGlobalPrepaymentStats';
  credit: Scalars['BigInt']['output'];
  credit_account_operation_id: Scalars['ID']['output'];
  date: Scalars['Date']['output'];
  expenseBudgetItem: ExpenseBudgetItem;
  globalCreditAccount: GlobalCreditAccount;
  id: Scalars['String']['output'];
};

export type ExpenseBudgetItemInput = {
  commission: Scalars['BigInt']['input'];
  commission_unit: CommissionUnit;
  expense_budget_category_id: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  total_budget: Scalars['BigInt']['input'];
};

export type ExpenseBudgetItemInvoiceStats = {
  __typename?: 'ExpenseBudgetItemInvoiceStats';
  credit: Scalars['BigInt']['output'];
  expenseBudgetItem: ExpenseBudgetItem;
  id: Scalars['String']['output'];
  outgoingInvoice: OutgoingInvoice;
};

export type ExpenseBudgetItemPrepaymentStats = {
  __typename?: 'ExpenseBudgetItemPrepaymentStats';
  brandCreditAccount: BrandCreditAccount;
  credit: Scalars['BigInt']['output'];
  credit_account_operation_id: Scalars['ID']['output'];
  date: Scalars['Date']['output'];
  expenseBudgetItem: ExpenseBudgetItem;
  id: Scalars['String']['output'];
};

export type ExpenseBudgetItemSimple = {
  __typename?: 'ExpenseBudgetItemSimple';
  category: ExpenseBudgetCategory;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  item_code?: Maybe<Scalars['String']['output']>;
  payment_status: ExpenseInvoiceStatusEnum;
  project: ProjectSimple;
  stats: ExpenseBudgetItemStatsSimple;
  title: Scalars['String']['output'];
  type: ExpenseBudgetItemType;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type ExpenseBudgetItemStats = CreditStats & ExpenseStatsInterface & {
  __typename?: 'ExpenseBudgetItemStats';
  budget_exceeded: Scalars['BigInt']['output'];
  client_price: Scalars['BigInt']['output'];
  credit: Scalars['BigInt']['output'];
  credit_balance: Scalars['BigInt']['output'];
  credit_direct: Scalars['BigInt']['output'];
  credit_from_prepayments: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated No longer supported */
  invoiceable: Scalars['BigInt']['output'];
  invoiced_percent: Scalars['BigInt']['output'];
  over_invoiced: Scalars['BigInt']['output'];
  /** @deprecated No longer supported */
  planned_commission: Scalars['BigInt']['output'];
  /** @deprecated No longer supported */
  planned_commission_relative_computed: Scalars['String']['output'];
  /** @deprecated No longer supported */
  planned_commission_relative_input_by_user?: Maybe<Scalars['BigInt']['output']>;
  planned_expenses: Scalars['BigInt']['output'];
  planned_profit: Scalars['BigInt']['output'];
  planned_profit_percent: Scalars['BigInt']['output'];
  profit: Scalars['BigInt']['output'];
  profit_percent: Scalars['BigInt']['output'];
  real_commission: Scalars['BigInt']['output'];
  real_commission_relative: Scalars['String']['output'];
  real_expenses: Scalars['BigInt']['output'];
  real_expenses_percent: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
  uninvoiced: Scalars['BigInt']['output'];
};

/** the minimum necessary for someone who doesnt have access to the whole project. planned_expenses and real_expenses are needed in Expense form */
export type ExpenseBudgetItemStatsSimple = {
  __typename?: 'ExpenseBudgetItemStatsSimple';
  planned_expenses: Scalars['BigInt']['output'];
  real_expenses: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
};

export enum ExpenseBudgetItemType {
  Other = 'OTHER',
  Regular = 'REGULAR'
}

export enum ExpenseBudgetItemTypeEnum {
  ExpenseBudgetItem = 'EXPENSE_BUDGET_ITEM',
  OurWorkBudgetItem = 'OUR_WORK_BUDGET_ITEM'
}

export type ExpenseBudgetItemWithRevenue = {
  __typename?: 'ExpenseBudgetItemWithRevenue';
  billings_for_date_range?: Maybe<Scalars['BigInt']['output']>;
  expenseBudgetItem: ExpenseBudgetItem;
  profit_for_date_range?: Maybe<Scalars['BigInt']['output']>;
};

export type ExpenseBudgetItemWithStatus = {
  __typename?: 'ExpenseBudgetItemWithStatus';
  payment_status: ExpenseInvoiceStatusEnum;
  title: Scalars['String']['output'];
};

export type ExpenseBudgetSplitInput = {
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  expense_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
};

export type ExpenseEmailData = {
  __typename?: 'ExpenseEmailData';
  from: Scalars['String']['output'];
  message_id: Scalars['String']['output'];
  received_at: Scalars['Date']['output'];
  subject: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export enum ExpenseInvoiceStatusEnum {
  Invoiced = 'INVOICED',
  InvoicedAndPaid = 'INVOICED_AND_PAID',
  NonInvoiceable = 'NON_INVOICEABLE',
  NotInvoiced = 'NOT_INVOICED',
  ProBono = 'PRO_BONO'
}

export type ExpenseItem = {
  __typename?: 'ExpenseItem';
  accountingAccount?: Maybe<AccountingAccount>;
  accounting_centre_id?: Maybe<Scalars['ID']['output']>;
  accounting_vat_classification_id?: Maybe<Scalars['ID']['output']>;
  amount: Scalars['BigInt']['output'];
  amount_in_currency: Scalars['BigInt']['output'];
  amount_in_percent?: Maybe<Scalars['BigInt']['output']>;
  approvals: Array<ExpenseItemApproval>;
  approved: Scalars['Boolean']['output'];
  brand_id?: Maybe<Scalars['ID']['output']>;
  budgetItem?: Maybe<BudgetItemForExpenseInterface>;
  budget_item_id: Scalars['ID']['output'];
  budget_item_type: ExpenseBudgetItemTypeEnum;
  custom_cost_ratio?: Maybe<Scalars['String']['output']>;
  description?: Maybe<ExpenseItemDesciption>;
  expense: Expense;
  expense_item_description_id?: Maybe<Scalars['ID']['output']>;
  globalCreditAccount?: Maybe<GlobalCreditAccount>;
  id: Scalars['ID']['output'];
  mandatory_id?: Maybe<Scalars['ID']['output']>;
  positions?: Maybe<Array<ExpenseItemPosition>>;
  project_id?: Maybe<Scalars['ID']['output']>;
  tag_ids?: Maybe<Array<Scalars['ID']['output']>>;
  timeBillings: Array<ProjectTimeBilling>;
  vatRate?: Maybe<VatRate>;
  vat_amount_in_currency?: Maybe<Scalars['BigInt']['output']>;
};

export type ExpenseItemApproval = {
  __typename?: 'ExpenseItemApproval';
  approved: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  user: User;
};

export type ExpenseItemDesciption = {
  __typename?: 'ExpenseItemDesciption';
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ExpenseItemForProject = {
  __typename?: 'ExpenseItemForProject';
  amount: Scalars['BigInt']['output'];
  amount_in_currency: Scalars['BigInt']['output'];
  created_at: Scalars['Date']['output'];
  legal_name: Scalars['String']['output'];
};

export type ExpenseItemInput = {
  accounting_account_id?: InputMaybe<Scalars['ID']['input']>;
  accounting_centre_id?: InputMaybe<Scalars['ID']['input']>;
  accounting_vat_classification_id?: InputMaybe<Scalars['ID']['input']>;
  amount_in_currency: Scalars['BigInt']['input'];
  amount_in_percent?: InputMaybe<Scalars['BigInt']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  budget_item_id?: InputMaybe<Scalars['ID']['input']>;
  budget_item_type?: InputMaybe<ExpenseBudgetItemTypeEnum>;
  custom_cost_ratio?: InputMaybe<Scalars['String']['input']>;
  expense_item_description_id?: InputMaybe<Scalars['ID']['input']>;
  global_credit_account_id?: InputMaybe<Scalars['ID']['input']>;
  global_credit_account_title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mandatory_id?: InputMaybe<Scalars['ID']['input']>;
  planned_expense_usages?: InputMaybe<Array<PlannedExpenseUsageInput>>;
  positions?: InputMaybe<Array<InputMaybe<ExpenseItemPositionInput>>>;
  project_id?: InputMaybe<Scalars['ID']['input']>;
  tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  vat_amount_in_currency?: InputMaybe<Scalars['BigInt']['input']>;
  vat_rate_id?: InputMaybe<Scalars['ID']['input']>;
};

/** A paginated list of ExpenseItem items. */
export type ExpenseItemPaginator = {
  __typename?: 'ExpenseItemPaginator';
  /** A list of ExpenseItem items. */
  data: Array<ExpenseItem>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ExpenseItemPosition = {
  __typename?: 'ExpenseItemPosition';
  report_date?: Maybe<Scalars['Date']['output']>;
  task?: Maybe<Task>;
  time_tracking_work_type_id?: Maybe<Scalars['ID']['output']>;
  tracked_time?: Maybe<Scalars['BigInt']['output']>;
};

export type ExpenseItemPositionInput = {
  report_date?: InputMaybe<Scalars['Date']['input']>;
  task_id?: InputMaybe<Scalars['ID']['input']>;
  time_tracking_work_type_id?: InputMaybe<Scalars['ID']['input']>;
  tracked_time?: InputMaybe<Scalars['BigInt']['input']>;
};

export type ExpenseItemsTimeBillingOrderByClause = {
  column: ExpenseItemsTimeBillingOrderByColumn;
  order: SortOrder;
};

export enum ExpenseItemsTimeBillingOrderByColumn {
  AccountingAccount = 'ACCOUNTING_ACCOUNT',
  Amount = 'AMOUNT',
  Brand = 'BRAND',
  BudgetItem = 'BUDGET_ITEM',
  ContractorName = 'CONTRACTOR_NAME',
  CostCenter = 'COST_CENTER',
  CreatedAt = 'CREATED_AT',
  DateOfSupply = 'DATE_OF_SUPPLY',
  Description = 'DESCRIPTION',
  DueDate = 'DUE_DATE',
  ExpenseNo = 'EXPENSE_NO',
  ExpenseNoRaw = 'EXPENSE_NO_RAW',
  Id = 'ID',
  InternalNote = 'INTERNAL_NOTE',
  LegalEntity = 'LEGAL_ENTITY',
  LockedTimeBilling = 'LOCKED_TIME_BILLING',
  Note = 'NOTE',
  PaidAt = 'PAID_AT',
  PaymentMethod = 'PAYMENT_METHOD',
  Project = 'PROJECT',
  Responsible = 'RESPONSIBLE',
  Status = 'STATUS',
  Tags = 'TAGS',
  TimeBilling = 'TIME_BILLING',
  Type = 'TYPE',
  VatClassification = 'VAT_CLASSIFICATION'
}

export type ExpenseItemsTimeBillingQueryArgs = {
  orderBy?: InputMaybe<Array<ExpenseItemsTimeBillingOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ExpenseItemsTimeBillingWhereConditions>;
};

export enum ExpenseItemsTimeBillingWhereColumn {
  AccountingAccountId = 'ACCOUNTING_ACCOUNT_ID',
  AccountingCentreId = 'ACCOUNTING_CENTRE_ID',
  AmountFrom = 'AMOUNT_FROM',
  AmountTo = 'AMOUNT_TO',
  BrandId = 'BRAND_ID',
  BudgetItemId = 'BUDGET_ITEM_ID',
  BudgetItemType = 'BUDGET_ITEM_TYPE',
  ClientId = 'CLIENT_ID',
  ContractorId = 'CONTRACTOR_ID',
  CreatedAt = 'CREATED_AT',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DueDate = 'DUE_DATE',
  HasTimeBilling = 'HAS_TIME_BILLING',
  InvoiceStatus = 'INVOICE_STATUS',
  MandatoryId = 'MANDATORY_ID',
  PaidAt = 'PAID_AT',
  PaymentStatus = 'PAYMENT_STATUS',
  ProjectId = 'PROJECT_ID',
  ProjectTimeBillingPlanId = 'PROJECT_TIME_BILLING_PLAN_ID',
  Status = 'STATUS',
  TagId = 'TAG_ID',
  Type = 'TYPE',
  WorkspaceBankAccountId = 'WORKSPACE_BANK_ACCOUNT_ID',
  WorkspaceCompanyId = 'WORKSPACE_COMPANY_ID'
}

export type ExpenseItemsTimeBillingWhereConditions = {
  AND?: InputMaybe<Array<ExpenseItemsTimeBillingWhereConditions>>;
  OR?: InputMaybe<Array<ExpenseItemsTimeBillingWhereConditions>>;
  column?: InputMaybe<ExpenseItemsTimeBillingWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type ExpenseOrderByClause = {
  column: ExpenseOrderByColumnEnum;
  order: SortOrder;
};

export enum ExpenseOrderByColumnEnum {
  Amount = 'AMOUNT',
  Contractor = 'CONTRACTOR',
  CreatedAt = 'CREATED_AT',
  DateOfSupply = 'DATE_OF_SUPPLY',
  Default = 'DEFAULT',
  DueDate = 'DUE_DATE',
  ExpenseNoRaw = 'EXPENSE_NO_RAW',
  Iban = 'IBAN',
  Id = 'ID',
  PaidAt = 'PAID_AT',
  Status = 'STATUS',
  Type = 'TYPE',
  UserCreatedDate = 'USER_CREATED_DATE',
  VariableSymbol = 'VARIABLE_SYMBOL'
}

/** A paginated list of Expense items. */
export type ExpensePaginator = {
  __typename?: 'ExpensePaginator';
  /** A list of Expense items. */
  data: Array<Expense>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum ExpensePaymentOrderExportType {
  PaymentOrder = 'PAYMENT_ORDER',
  QrCodesList = 'QR_CODES_LIST'
}

export type ExpensePaymentOrderResponse = {
  __typename?: 'ExpensePaymentOrderResponse';
  unprocessable_expense_ids?: Maybe<Array<Scalars['ID']['output']>>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum ExpensePaymentTypeEnum {
  BankTransfer = 'BANK_TRANSFER',
  Card = 'CARD',
  Cash = 'CASH',
  SetOff = 'SET_OFF'
}

export type ExpenseQueryArgs = {
  orderBy?: InputMaybe<Array<ExpenseOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ExpensesWhereConditions>;
};

export type ExpenseRevenueByCategory = {
  __typename?: 'ExpenseRevenueByCategory';
  billings: Scalars['BigInt']['output'];
  category: ExpenseBudgetCategory;
  profit: Scalars['BigInt']['output'];
  profit_percentage: Scalars['BigInt']['output'];
};

export type ExpenseStats = {
  __typename?: 'ExpenseStats';
  id: Scalars['ID']['output'];
  rounding: Scalars['BigInt']['output'];
  total_amount: Scalars['BigInt']['output'];
  total_amount_with_vat: Scalars['BigInt']['output'];
  total_amount_with_vat_in_currency: Scalars['BigInt']['output'];
  total_amount_without_vat: Scalars['BigInt']['output'];
  total_amount_without_vat_in_currency: Scalars['BigInt']['output'];
  total_vat: Scalars['BigInt']['output'];
  total_vat_in_currency: Scalars['BigInt']['output'];
};

export type ExpenseStatsInterface = {
  budget_exceeded: Scalars['BigInt']['output'];
  client_price: Scalars['BigInt']['output'];
  planned_commission: Scalars['BigInt']['output'];
  planned_expenses: Scalars['BigInt']['output'];
  planned_profit: Scalars['BigInt']['output'];
  planned_profit_percent: Scalars['BigInt']['output'];
  real_commission: Scalars['BigInt']['output'];
  real_expenses: Scalars['BigInt']['output'];
  real_expenses_percent: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
};

export enum ExpenseStatusEnum {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  ForApproval = 'FOR_APPROVAL',
  ForFinancialApproval = 'FOR_FINANCIAL_APPROVAL',
  Imported = 'IMPORTED'
}

export type ExpenseStructuredBudgetItem = {
  __typename?: 'ExpenseStructuredBudgetItem';
  budgetItems: Array<ExpenseBudgetItem>;
  budget_category_id: Scalars['ID']['output'];
  budget_exceeded: Scalars['BigInt']['output'];
  credit: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profit: Scalars['BigInt']['output'];
  real_expenses: Scalars['BigInt']['output'];
  real_expenses_without_other: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
};

export type ExpenseStructuredBudgetItemWithRevenue = {
  __typename?: 'ExpenseStructuredBudgetItemWithRevenue';
  budgetItems: Array<ExpenseBudgetItemWithRevenue>;
  expenseBudgetCategory: ExpenseBudgetCategory;
};

export enum ExpenseTypeEnum {
  Bill = 'BILL',
  Card = 'CARD',
  Contract = 'CONTRACT',
  Invoice = 'INVOICE',
  Other = 'OTHER',
  PaymentReceipt = 'PAYMENT_RECEIPT',
  Proforma = 'PROFORMA'
}

export type ExpenseVatItem = {
  __typename?: 'ExpenseVatItem';
  amount_in_currency: Scalars['BigInt']['output'];
  amount_with_vat_in_currency: Scalars['BigInt']['output'];
  vat_in_currency: Scalars['BigInt']['output'];
  vat_percent_informative: Scalars['BigInt']['output'];
};

export type ExpenseVatItemInput = {
  amount_in_currency: Scalars['BigInt']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  vat_in_currency: Scalars['BigInt']['input'];
  vat_percent_informative: Scalars['BigInt']['input'];
};

export type ExpensesSummary = {
  __typename?: 'ExpensesSummary';
  expenseIds?: Maybe<Array<Scalars['ID']['output']>>;
  expenses: Scalars['BigInt']['output'];
  overdue_by_31_to_90_days: Scalars['BigInt']['output'];
  overdue_by_31_to_90_days_vat: Scalars['BigInt']['output'];
  overdue_by_31_to_90_days_without_vat: Scalars['BigInt']['output'];
  overdue_by_91_to_365_days: Scalars['BigInt']['output'];
  overdue_by_91_to_365_days_vat: Scalars['BigInt']['output'];
  overdue_by_91_to_365_days_without_vat: Scalars['BigInt']['output'];
  overdue_by_less_than_30_days: Scalars['BigInt']['output'];
  overdue_by_less_than_30_days_vat: Scalars['BigInt']['output'];
  overdue_by_less_than_30_days_without_vat: Scalars['BigInt']['output'];
  overdue_by_more_than_365_days: Scalars['BigInt']['output'];
  overdue_by_more_than_365_days_vat: Scalars['BigInt']['output'];
  overdue_by_more_than_365_days_without_vat: Scalars['BigInt']['output'];
  payments_due: Scalars['BigInt']['output'];
  payments_due_vat: Scalars['BigInt']['output'];
  payments_due_without_vat: Scalars['BigInt']['output'];
  total_amount: Scalars['BigInt']['output'];
  total_amount_with_vat: Scalars['BigInt']['output'];
  total_vat: Scalars['BigInt']['output'];
};

export enum ExpensesWhereColumn {
  AmountFrom = 'AMOUNT_FROM',
  AmountTo = 'AMOUNT_TO',
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  ContractorId = 'CONTRACTOR_ID',
  CreatedAt = 'CREATED_AT',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DueDate = 'DUE_DATE',
  HasTimeBilling = 'HAS_TIME_BILLING',
  Id = 'ID',
  InvoiceStatus = 'INVOICE_STATUS',
  IssueDate = 'ISSUE_DATE',
  IsExported = 'IS_EXPORTED',
  MandatoryId = 'MANDATORY_ID',
  PaidAt = 'PAID_AT',
  PaymentStatus = 'PAYMENT_STATUS',
  ProjectId = 'PROJECT_ID',
  ProjectTimeBillingPlanId = 'PROJECT_TIME_BILLING_PLAN_ID',
  Status = 'STATUS',
  Type = 'TYPE',
  WorkspaceBankAccountId = 'WORKSPACE_BANK_ACCOUNT_ID',
  WorkspaceCompanyId = 'WORKSPACE_COMPANY_ID'
}

export type ExpensesWhereConditions = {
  AND?: InputMaybe<Array<ExpensesWhereConditions>>;
  OR?: InputMaybe<Array<ExpensesWhereConditions>>;
  column?: InputMaybe<ExpensesWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type ExportSettings = {
  __typename?: 'ExportSettings';
  expenses: Scalars['Boolean']['output'];
  expenses_xml: Scalars['Boolean']['output'];
  mlggk_project_effectiveness: Scalars['Boolean']['output'];
  mrp: Scalars['Boolean']['output'];
  omega: Scalars['Boolean']['output'];
  pohoda: Scalars['Boolean']['output'];
  premier: Scalars['Boolean']['output'];
  project_effectiveness: Scalars['Boolean']['output'];
  project_progress_statistics: Scalars['Boolean']['output'];
  project_status: Scalars['Boolean']['output'];
  proluc: Scalars['Boolean']['output'];
  transakcio: Scalars['Boolean']['output'];
  triad_project_effectiveness: Scalars['Boolean']['output'];
  unpaid_outgoing_invoices: Scalars['Boolean']['output'];
  vario: Scalars['Boolean']['output'];
  xero: Scalars['Boolean']['output'];
};

export type ExternalLink = {
  __typename?: 'ExternalLink';
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  model_id: Scalars['ID']['output'];
  model_type: ExternalLinkType;
  title: Scalars['String']['output'];
};

export enum ExternalLinkType {
  Brand = 'BRAND',
  Project = 'PROJECT'
}

export type FileInput = {
  file: Scalars['Upload']['input'];
  /** To replace existing file. */
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FilterTemplate = {
  __typename?: 'FilterTemplate';
  id: Scalars['ID']['output'];
  model_id?: Maybe<Scalars['ID']['output']>;
  model_type: Scalars['String']['output'];
  name: Scalars['String']['output'];
  params?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type FilterTemplateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  model_id?: InputMaybe<Scalars['ID']['input']>;
  model_type: Scalars['String']['input'];
  name: Scalars['String']['input'];
  only_for_me?: InputMaybe<Scalars['Boolean']['input']>;
  params?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FinanceSettings = {
  __typename?: 'FinanceSettings';
  automatically_approved_expense_items?: Maybe<Scalars['Boolean']['output']>;
  bankAccounts?: Maybe<Array<BankAccountSetting>>;
  can_transfer_credit_between_teams_without_constraints?: Maybe<Scalars['Boolean']['output']>;
  currency_id?: Maybe<Scalars['BigInt']['output']>;
  default_vat_rate_id?: Maybe<Scalars['BigInt']['output']>;
  invoicing_more_teams?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<LanguagesEnum>;
  outgoing_invoice_drafts_only?: Maybe<Scalars['Boolean']['output']>;
  registration_no: Scalars['String']['output'];
  show_contact_person?: Maybe<Scalars['Boolean']['output']>;
  show_full_bank_account_information?: Maybe<Scalars['Boolean']['output']>;
  show_project_codes?: Maybe<Scalars['Boolean']['output']>;
  tax_no: Scalars['String']['output'];
  text_on_invoice?: Maybe<Scalars['String']['output']>;
  vat_no: Scalars['String']['output'];
};

export type FondContractorSimple = {
  __typename?: 'FondContractorSimple';
  contractor_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  legal_name: Scalars['String']['output'];
};

export type GetTimeTrackingItemsPaginator = {
  __typename?: 'GetTimeTrackingItemsPaginator';
  data: Array<TimeTrackingReport>;
  paginatorInfo: PaginatorInfo;
};

export type GetTimeTrackingItemsSummary = {
  __typename?: 'GetTimeTrackingItemsSummary';
  amount: Scalars['BigInt']['output'];
  ids: Array<Scalars['ID']['output']>;
  invoiced_amount: Scalars['BigInt']['output'];
  invoiced_seconds: Scalars['BigInt']['output'];
  overserviced_amount: Scalars['BigInt']['output'];
  overserviced_seconds: Scalars['BigInt']['output'];
  tracked_time: Scalars['BigInt']['output'];
  uninvoiced_amount: Scalars['BigInt']['output'];
  uninvoiced_seconds: Scalars['BigInt']['output'];
};

export type GlobalCreditAccount = {
  __typename?: 'GlobalCreditAccount';
  created_at: Scalars['DateTime']['output'];
  creditAccount: CreditAccount;
  credits: Array<GlobalCreditAccountCreditStats>;
  debits: Array<GlobalCreditAccountDebitStats>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  stats: GlobalCreditAccountStats;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type GlobalCreditAccountCreditStats = {
  __typename?: 'GlobalCreditAccountCreditStats';
  credit: Scalars['BigInt']['output'];
  date: Scalars['Date']['output'];
  expense?: Maybe<Expense>;
  id: Scalars['ID']['output'];
  originatesGlobalCreditAccount?: Maybe<GlobalCreditAccount>;
};

export type GlobalCreditAccountDebitStats = {
  __typename?: 'GlobalCreditAccountDebitStats';
  credit: Scalars['BigInt']['output'];
  credit_account_operation_id: Scalars['ID']['output'];
  expenseBudgetItem?: Maybe<ExpenseBudgetItem>;
  id: Scalars['ID']['output'];
  originatesGlobalCreditAccount?: Maybe<GlobalCreditAccount>;
  performed_at: Scalars['Date']['output'];
};

export type GlobalCreditAccountOrderByClause = {
  column: GlobalCreditAccountOrderByColumnEnum;
  order: SortOrder;
};

export enum GlobalCreditAccountOrderByColumnEnum {
  Id = 'ID',
  Title = 'TITLE'
}

/** A paginated list of GlobalCreditAccount items. */
export type GlobalCreditAccountPaginator = {
  __typename?: 'GlobalCreditAccountPaginator';
  /** A list of GlobalCreditAccount items. */
  data: Array<GlobalCreditAccount>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type GlobalCreditAccountQueryArgs = {
  orderBy?: InputMaybe<Array<GlobalCreditAccountOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<GlobalCreditAccountsWhereConditions>;
};

export type GlobalCreditAccountStats = {
  __typename?: 'GlobalCreditAccountStats';
  id: Scalars['ID']['output'];
  remaining_credit: Scalars['BigInt']['output'];
  total_credit: Scalars['BigInt']['output'];
  total_debit: Scalars['BigInt']['output'];
};

export enum GlobalCreditAccountsWhereColumn {
  Id = 'ID'
}

export type GlobalCreditAccountsWhereConditions = {
  AND?: InputMaybe<Array<GlobalCreditAccountsWhereConditions>>;
  OR?: InputMaybe<Array<GlobalCreditAccountsWhereConditions>>;
  column?: InputMaybe<GlobalCreditAccountsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export enum ImapEncryptionEnum {
  Ssl = 'SSL'
}

export type InputAccountingAccount = {
  account_number: Scalars['String']['input'];
  accounting_type: Accounting_Account_Type;
  budget_categories?: InputMaybe<Array<InputAccountingAccountBudgetCategory>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type InputAccountingAccountBudgetCategory = {
  budget_category_id: Scalars['ID']['input'];
  budget_category_type: Scalars['String']['input'];
};

export type InputAccountingCentre = {
  centre: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  type: Accounting_Centre_Type;
};

export type InputAccountingVatClassification = {
  centre: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  type: Accounting_Centre_Type;
  vat_rate_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InputUpdateWorkspaceAccountingAccountSettings = {
  accounting_accounts: Array<InputAccountingAccount>;
};

export type InputUpdateWorkspaceAccountingCentreSettings = {
  accounting_centres: Array<InputAccountingCentre>;
};

export type InputUpdateWorkspaceAccountingVatClassificationSettings = {
  accounting_vat_classifications: Array<InputAccountingVatClassification>;
};

export type InputUpdateWorkspaceAutoExpenseEmail = {
  imap_encryption: ImapEncryptionEnum;
  imap_host: Scalars['String']['input'];
  imap_password?: InputMaybe<Scalars['String']['input']>;
  imap_port: Scalars['Int']['input'];
  imap_username: Scalars['String']['input'];
  is_active: Scalars['Boolean']['input'];
};

export type InputUpdateWorkspacePipedriveIntegration = {
  settings: WorkspacePipedriveIntegrationSettingInput;
};

export type InputUpdateWorkspaceProjectSettings = {
  automate_invoicing_plan_approval: Scalars['Boolean']['input'];
  can_close_expense_budget_item_with_unapproved_expenses: Scalars['Boolean']['input'];
  create_default_task_enabled: Scalars['Boolean']['input'];
  create_default_task_only_to_our_work_category: Scalars['Boolean']['input'];
  enable_additional_brand_numeric_code: Scalars['Boolean']['input'];
  project_code_generator: ProjectCodeGeneratorEnum;
  project_code_length: Scalars['Int']['input'];
  project_code_with_year: Scalars['Boolean']['input'];
};

export type InputWorkspaceCompanySetting = {
  companies: Array<WorkspaceCompanyInput>;
};

export type InputWorkspaceFinancialSetting = {
  currencies: Array<CurrencyInput>;
  default_show_billing_accounting_on_invoices: Scalars['Boolean']['input'];
  default_show_unit_price_on_invoices: Scalars['Boolean']['input'];
  invoice_attachment_name_templates?: InputMaybe<InvoiceAttachmentNameTemplatesInput>;
  vat_rates: Array<VatRateInput>;
};

export type InputWorkspacePlanningSetting = {
  default_user_plannable_capacity: Scalars['BigInt']['input'];
  default_utilization_range_from: Scalars['Int']['input'];
  default_utilization_range_to: Scalars['Int']['input'];
  disable_home_office_in_planning: Scalars['Boolean']['input'];
  hide_planning_total_daily_capacity: Scalars['Boolean']['input'];
  planning_alphabet_user_order: Scalars['Boolean']['input'];
  planning_sort_prioritize_time_specific_items: Scalars['Boolean']['input'];
  specific_time_in_planning_enabled: Scalars['Boolean']['input'];
  start_day_of_week: StartDayOfWeekEnum;
  working_from: Scalars['Time']['input'];
  working_to: Scalars['Time']['input'];
};

export type InputWorkspaceTaskSettings = {
  show_done_tasks: Scalars['Boolean']['input'];
  task_priorities: Array<WorkspaceTaskPriorityInput>;
  task_statuses: Array<WorkspaceTaskStatusInput>;
  use_current_assignee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputWorkspaceTeamSetting = {
  copy_users_from_team_id?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_default: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type InputWorkspaceUserManagementSetting = {
  require_two_factor_authentication: Scalars['Boolean']['input'];
  teams: Array<InputWorkspaceTeamSetting>;
};

export type InvoiceAttachmentNameTemplates = {
  __typename?: 'InvoiceAttachmentNameTemplates';
  outgoing_invoice?: Maybe<Scalars['String']['output']>;
  outgoing_proforma?: Maybe<Scalars['String']['output']>;
  payment_receipt?: Maybe<Scalars['String']['output']>;
};

export type InvoiceAttachmentNameTemplatesInput = {
  outgoing_invoice?: InputMaybe<Scalars['String']['input']>;
  outgoing_proforma?: InputMaybe<Scalars['String']['input']>;
  payment_receipt?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceEmailData = {
  __typename?: 'InvoiceEmailData';
  attachments?: Maybe<Array<Maybe<InvoiceEmailDataAttachment>>>;
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  recipients: Array<Maybe<Scalars['String']['output']>>;
  subject: Scalars['String']['output'];
};

export type InvoiceEmailDataAttachment = {
  __typename?: 'InvoiceEmailDataAttachment';
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

export type InvoiceItemInput = {
  accounting_account_id?: InputMaybe<Scalars['ID']['input']>;
  accounting_centre_id?: InputMaybe<Scalars['ID']['input']>;
  amount_in_currency?: InputMaybe<Scalars['BigInt']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  tag_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  unit_price: Scalars['BigInt']['input'];
  vat_percent_informative?: InputMaybe<Scalars['BigInt']['input']>;
};

export type InvoicePaymentMethod = {
  __typename?: 'InvoicePaymentMethod';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  system_name?: Maybe<InvoicePaymentMethodEnum>;
};

export enum InvoicePaymentMethodEnum {
  BankTransfer = 'BANK_TRANSFER',
  Card = 'CARD',
  Cash = 'CASH',
  SetOff = 'SET_OFF'
}

export type InvoiceSequenceData = {
  __typename?: 'InvoiceSequenceData';
  document_no: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum LanguagesEnum {
  Cz = 'CZ',
  En = 'EN',
  Sk = 'SK'
}

export type LatestExpenseInternalNumberPerType = {
  __typename?: 'LatestExpenseInternalNumberPerType';
  internal_number?: Maybe<Scalars['String']['output']>;
  type: ExpenseTypeEnum;
};

export type LockDocument = {
  __typename?: 'LockDocument';
  document_id: Scalars['ID']['output'];
  document_type: LockDocumentTypeEnum;
  locked_to: Scalars['DateTime']['output'];
  user: User;
};

export enum LockDocumentTypeEnum {
  Expense = 'EXPENSE'
}

export enum MailTypeEnum {
  Google = 'google',
  Microsoft = 'microsoft',
  Smtp = 'smtp'
}

export type MapQuestAddress = {
  __typename?: 'MapQuestAddress';
  city: Scalars['String']['output'];
  country?: Maybe<Country>;
  country_code: Scalars['String']['output'];
  country_id?: Maybe<Scalars['ID']['output']>;
  street: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

/**
 * One paired MCP client. Backed by the workspace API access issued to it, so
 * revoking it here revokes the token that client authenticates with.
 */
export type McpToken = {
  __typename?: 'McpToken';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mcp_name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type MediaUrlList = {
  __typename?: 'MediaUrlList';
  download?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
};

export type ModelLock = {
  __typename?: 'ModelLock';
  deletedByUser?: Maybe<User>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  is_locked: Scalars['Boolean']['output'];
  lockedByUser: User;
  locked_at: Scalars['DateTime']['output'];
};

export enum ModelLockLockableTypeEnum {
  Expense = 'EXPENSE',
  OutgoingInvoice = 'OUTGOING_INVOICE',
  OutgoingProformaInvoice = 'OUTGOING_PROFORMA_INVOICE'
}

export type ModuleSettings = {
  __typename?: 'ModuleSettings';
  billing_plan: Scalars['Boolean']['output'];
  budgetovac: Scalars['Boolean']['output'];
  clients: Scalars['Boolean']['output'];
  contractors: Scalars['Boolean']['output'];
  documents: Scalars['Boolean']['output'];
  expenses: Scalars['Boolean']['output'];
  invoices: Scalars['Boolean']['output'];
  planovac: Scalars['Boolean']['output'];
  projects: Scalars['Boolean']['output'];
  reports: Scalars['Boolean']['output'];
  time_billing: Scalars['Boolean']['output'];
  time_tracking: Scalars['Boolean']['output'];
};

export type MoveCapacityAllocationItemInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  from_user_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  new_time_tracking_work_type_id?: InputMaybe<Scalars['ID']['input']>;
  to_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type MoveTaskOnBoardInput = {
  /** Place the card after this task. Omit with before_task_id to put it at the top. */
  after_task_id?: InputMaybe<Scalars['ID']['input']>;
  /** Place the card before this task. */
  before_task_id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Board context: tab + group by, e.g. "my:TASK_STATUS". Must contain the group by —
   * without it the order lands in the wrong board and shuffles cards in other groupings.
   */
  board_key: Scalars['String']['input'];
  group_by: TaskBoardGroupByEnum;
  /** Target column. Null or "unassigned" = the empty-value column. */
  group_value?: InputMaybe<Scalars['ID']['input']>;
  /** only for ApiClient */
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Source assignee column when group_by is ASSIGNEE. Assignee columns only reorder,
   * a move into another assignee's column is rejected.
   */
  source_assignee_user_id?: InputMaybe<Scalars['ID']['input']>;
  task_id: Scalars['ID']['input'];
  /**
   * With neither after_task_id nor before_task_id, puts the card at the bottom of the column
   * instead of the top — the client may not have the last cards loaded.
   */
  to_bottom?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  UpdateCapacityAllocationForDay: CapacityAllocation;
  UpdateWorkspaceNotifications: Array<WorkspaceNotification>;
  addBankAccountMovesToDocument?: Maybe<Scalars['Boolean']['output']>;
  addDocumentsToAccountMove: BankAccountMove;
  addManualAccountMove: BankAccountMove;
  /** permission: timeTracking.create.all/team/own + timeTracking.update.all/team/own */
  addRowToWeekTimeReport: WeeklyTimeReportRow;
  /**
   * Add one position (assignee with work type and planned time), keeping the others.
   * permission: task.update.all/own for given task
   */
  addTaskAssignee: Task;
  /** permission: task.read.all/own for given task */
  addTaskFiles: Task;
  /** permission: task.read.all/own for both tasks */
  addTaskLink?: Maybe<TaskLink>;
  /** permission: brand.archive */
  archiveBrand: Brand;
  /** permission: project.archive.all/team/own */
  archiveProject: Project;
  archiveProjectsBulk: BulkActionResponse;
  budgetCreatedEvent: Scalars['Boolean']['output'];
  budgetInternalApprove: Budget;
  /** permission: brand.archive */
  bulkArchiveBrand: BulkActionResponse;
  /** permission: brand.delete */
  bulkDeleteBrand: BulkActionResponse;
  /** permission: expense.delete.all/team/own for given expenses */
  bulkDeleteExpenses: BulkActionResponse;
  /** permission: task.delete.all/own for every given task */
  bulkDeleteTasks: Scalars['Boolean']['output'];
  /**
   * Bulk delete time tracking items (cannot delete locked items)
   * permission: timeTracking.delete.all/team
   */
  bulkDeleteTimeTrackingItems: BulkActionResponse;
  /**
   * permission: for every given task, what each changed field needs on its own
   * (task.update_status, task.update_current_assignee, task.read for the priority,
   * task.update for the rest); with duplicate_task task.create.all and task.read
   */
  bulkEditTasks: Scalars['Boolean']['output'];
  bulkLockModel: BulkActionResponse;
  bulkStar: BulkActionResponse;
  bulkStarProjects: BulkActionResponse;
  bulkUnlockModel: BulkActionResponse;
  bulkUnstar: BulkActionResponse;
  bulkUnstarProjects: BulkActionResponse;
  bulkUpdateProjects: BulkActionResponse;
  changeBudgetAssignedAt: Budget;
  changeOutgoingInvoiceDates?: Maybe<Scalars['Boolean']['output']>;
  changeOutgoingProformaInvoiceDates?: Maybe<Scalars['Boolean']['output']>;
  changeRateCardOnProject?: Maybe<Project>;
  /** permission: expense.create && expense.read.all/team/own for given expense */
  cloneExpense: Expense;
  /** permission: wip.close.all/team/own */
  closeWip: WorkInProgressProjectStat;
  /** permission: wip.close.all/team/own */
  closeWipBulk: BulkActionResponse;
  /** Complete capacity allocation user item */
  completeCapacityAllocationItem: CapacityAllocationItem;
  /** permission: project.budget.completeExpenseBudgetItem.all/team/own */
  completeExpenseBudgetItem: ExpenseBudgetItem;
  /** permission: project.budget.completeExpenseBudgetItem.all/team/own */
  completeExpenseBudgetItemBulk: Array<ExpenseBudgetItem>;
  connectToMcp: ConnectToMcpPayload;
  copyCapacityAllocationItem: CapacityAllocationItem;
  /** permission: assignableFile.create */
  createAssignableFile: AssignableFile;
  /** permission: client.create */
  createBillingEntity: BillingEntity;
  /** permission: billingPlan.create */
  createBillingPlan: Array<BillingPlanByMonths>;
  /** permission: brand.create, brand.updateManagers */
  createBrand: Brand;
  /** permission: brandCreditAccount.create */
  createBrandCreditAccount: BrandCreditAccount;
  createBudgetItemPlannedExpenses: Array<BudgetItemPlannedExpense>;
  createBudgetItemPlannedExpensesBulk: Array<Array<BudgetItemPlannedExpense>>;
  /** permission: BigIntegration.budgetovac */
  createBudgetovacPosition: BudgetovacPosition;
  /** permission: BigIntegration.budgetovac */
  createBudgetovacPositionsSet: BudgetovacPositionsSet;
  /** Create capacity allocation - meeting or task. */
  createCapacityAllocation: CapacityAllocation;
  /** permission: client.create, client.updateManagers */
  createClient: Client;
  /** permission: client.update or brand.update, depending on if the contact belongs to client or brand */
  createContact: Contact;
  /** permission: contract.create */
  createContract: Contract;
  /** permission: contractor.create */
  createContractor: Contractor;
  /** permission: client.update */
  createCurrencyExchangeRate: CurrencyExchangeRate;
  createEmailTemplate: EmailTemplate;
  /** permission: workspaceSetting.edit */
  createExchangeRateForWorkspace: CurrencyExchangeRate;
  /** permission: expense.create */
  createExpense: Expense;
  createExpenseBudgetItem?: Maybe<ExpenseBudgetItem>;
  createExpenseItemDescription?: Maybe<ExpenseItemDesciption>;
  createExternalLink: ExternalLink;
  createFilterTemplate: FilterTemplate;
  /** permission: brandCreditAccount.create */
  createGlobalCreditAccount: GlobalCreditAccount;
  createInvoiceFromBillingPlan: RequestForInvoicing;
  /** permission: timeTracking.create.all/team/own + timeTracking.update.all/team/own */
  createOrUpdateTrackedTimeForDay: Scalars['Boolean']['output'];
  /** permission: order.create */
  createOrder: Order;
  /** permission: otherDocument.create */
  createOtherDocument: OtherDocument;
  createOurWorkBudgetItem?: Maybe<OurWorkBudgetItemOverview>;
  /** permission: outgoingInvoice.create */
  createOutgoingInvoice: OutgoingInvoice;
  /** permission: outgoingInvoice.create */
  createOutgoingProformaInvoice: OutgoingProformaInvoice;
  /** permission: project.create.all/team/own */
  createProject: Project;
  /** permission: projectCategory.create */
  createProjectCategory: ProjectCategory;
  createProjectFromPipedrive?: Maybe<Project>;
  /**
   * permission: project.create.all/team/own
   * Create a new project from a project template.
   */
  createProjectFromTemplate: Project;
  /**
   * Vytvorenie nového Time Billing
   * permission: project.update.all/own/team
   */
  createProjectTimeBilling: ProjectTimeBilling;
  createProjectTimeBreakdown: ProjectTimeBreakdown;
  createQuote: Quote;
  /** permission: requestForInvoicing.create.all/own/team */
  createRequestForInvoicing: RequestForInvoicing;
  /** permission: task.create.scoped */
  createScopedTask: Task;
  /** permission: user.create */
  createScopedUser: User;
  createSequence: Sequence;
  createTag?: Maybe<Tag>;
  /** permission: task.create.all/own */
  createTask: Task;
  /** permission: task.read for given task */
  createTaskComment: TaskComment;
  createTaskTemplateGroup: TaskTemplateGroup;
  createTasksFromTaskTemplateGroup: Scalars['Boolean']['output'];
  /** permission: timeTracking.create.all/team/own */
  createTimeTrackingItem: TimeTrackingItem;
  /** permission: BigIntegration.budgetovac */
  createTimeTrackingWorkType: TimeTrackingWorkType;
  /** permission: expense.create */
  createUpdateExpenseContractor: Expense;
  /** permission: user.create */
  createUser: User;
  createVatRate: VatRate;
  createWorkspaceSmtpSettings: WorkspaceSmtpSettings;
  /** permission: assignableFile.delete all/own */
  deleteAssignableFile?: Maybe<BooleanResult>;
  /** permission: client.delete */
  deleteBillingEntity: BillingEntity;
  /** permission: brand.delete */
  deleteBrand: Brand;
  /** permission: brandCreditAccount.delete.all/team.own for given ID */
  deleteBrandCreditAccount: BrandCreditAccount;
  /** permission: BigIntegration.budgetovac */
  deleteBudgetovacPosition: BudgetovacPosition;
  /** permission: BigIntegration.budgetovac */
  deleteBudgetovacPositionsSet: BudgetovacPositionsSet;
  /** Delete capacity allocation - meeting or task. */
  deleteCapacityAllocation: CapacityAllocation;
  /** Delete capacity allocation - meeting or task. */
  deleteCapacityAllocationForDay: CapacityAllocation;
  /** Delete capacity allocation item - meeting or task. */
  deleteCapacityAllocationItem: CapacityAllocationItem;
  /** permission: client.delete */
  deleteClient: Client;
  /** permission: client.update or brand.update, depending on if the contact belongs to client or brand */
  deleteContact: Contact;
  /** permission: contract.delete */
  deleteContract: Contract;
  /** permission: contractor.delete */
  deleteContractor: Contractor;
  /** permission: contractor.delete */
  deleteContractorsBulk: BulkActionResponse;
  /** permission: workspaceSetting.edit */
  deleteExchangeRateForWorkspace: CurrencyExchangeRate;
  /** permission: expense.delete.all/team/own for given expense */
  deleteExpense: Expense;
  deleteExpenseItemDescription?: Maybe<Scalars['Boolean']['output']>;
  /** permission: assignableFile.delete all/own */
  deleteExternalLink?: Maybe<Scalars['Boolean']['output']>;
  deleteFilterTemplate: Scalars['Boolean']['output'];
  /** permission: brandCreditAccount.delete.all/team.own for given ID */
  deleteGlobalCreditAccount: Scalars['Boolean']['output'];
  /** permission: order.delete */
  deleteOrder: Order;
  /** permission: otherDocument.delete */
  deleteOtherDocument: OtherDocument;
  /** permission: outgoingInvoice.delete.all/team/own for given OI */
  deleteOutgoingInvoice: Scalars['Boolean']['output'];
  /** permission: outgoingInvoice.delete.all/team/own for given OI */
  deleteOutgoingProformaInvoice: Scalars['Boolean']['output'];
  /** permission: project.delete.all/team/own */
  deleteProject: Project;
  /** permission: projectCategory.delete */
  deleteProjectCategory: ProjectCategory;
  /**
   * Zmazanie Time Billing
   * Blokované ak je locked
   * permission: project.update.all/own/team + unlocked
   */
  deleteProjectTimeBilling: Scalars['Boolean']['output'];
  deleteProjectTimeBreakdown: Scalars['Boolean']['output'];
  /** permission: project.delete.all/team/own */
  deleteProjectsBulk: BulkActionResponse;
  deleteQuote: Scalars['Boolean']['output'];
  /** permission: requestForInvoicing.delete.all/own/team */
  deleteRequestForInvoicing: RequestForInvoicing;
  /** permission: requestForInvoicing.delete.all/own/team */
  deleteRequestsForInvoicingBulk: BulkActionResponse;
  deleteTag?: Maybe<Scalars['Boolean']['output']>;
  /** permission: task.delete.all/own for given task */
  deleteTask: Task;
  /** permission: taskComment.delete.all/own and task.read for given comment's task */
  deleteTaskComment: TaskComment;
  /** permission: task.read.all/own for given task */
  deleteTaskLink: TaskLink;
  deleteTaskTemplateGroup: Scalars['Boolean']['output'];
  /** permission: timeTracking.delete.all/team/own */
  deleteTimeTrackingItem: TimeTrackingItem;
  /** permission: BigIntegration.budgetovac */
  deleteTimeTrackingWorkType: TimeTrackingWorkType;
  deleteUploadedFile: Scalars['Boolean']['output'];
  /** permission: user.delete */
  deleteUser: User;
  /** permission: user.profile.update */
  disableTwoFactorAuthentication: User;
  disconnectFromMcp: ConnectToMcpPayload;
  /** permission: project.duplicate.all/team/own */
  duplicateProject: Project;
  /** permission: task.create */
  duplicateTask: Task;
  /** permission: task.read.all/own for given task */
  editTaskWatchers: Task;
  excludeBankAccountMove: BankAccountMove;
  findAddressForExpense?: Maybe<MapQuestAddress>;
  /** permission: project.finish.all/team/own */
  finishProject: Project;
  /** permission: outgoingInvoice.create || requestForInvoicing.create.all/team/own */
  invoiceProject?: Maybe<RequestForInvoicing>;
  /** permission: outgoingInvoice.create || requestForInvoicing.create.all/team/own */
  invoiceProjectByCurrentMonthBillingPlan?: Maybe<RequestForInvoicing>;
  /** permission: outgoingInvoice.create || requestForInvoicing.create.all/team/own */
  invoiceProjectsBulk?: Maybe<RequestForInvoicing>;
  /** isDateBeforeLastPlanningUpdate */
  isDateBeforeLastPlanningUpdate: Scalars['Boolean']['output'];
  /** permission: task.read.all/own for given task */
  lastSeen?: Maybe<Task>;
  lockBillingPlanForProject?: Maybe<Project>;
  lockDocument: LockDocument;
  lockModel: ModelLock;
  /**
   * Zamknutie Time Billing
   * permission: project.update.all/own/team
   */
  lockProjectTimeBilling: ProjectTimeBilling;
  /** permission: wip.lock.all/team/own */
  lockWip: WorkInProgressProjectStat;
  /** permission: wip.lock.all/team/own */
  lockWipBulk: BulkActionResponse;
  /** permission: quote.manualApprove */
  manualApproveQuote: Quote;
  markAllNotificationsAsRead: Scalars['Boolean']['output'];
  /** permission: expense.markAsPaid */
  markExpenseAsPaid: Expense;
  /** permission: expense.markAsPaid */
  markExpenseAsPaidBulk: BulkActionResponse;
  /** permission: expense.markAsPaid */
  markExpenseAsUnpaid: Expense;
  markNotificationAsRead: Notification;
  markNotificationAsUnread: Notification;
  /** permission: outgoingInvoice.markAsPaid */
  markOutgoingInvoiceAsPaid: OutgoingInvoice;
  /** permission: outgoingInvoice.markAsPaid */
  markOutgoingInvoiceAsPaidBulk: BulkActionResponse;
  /** permission: outgoingInvoice.markAsPaid */
  markOutgoingInvoiceAsUnpaid: OutgoingInvoice;
  /** permission: outgoingInvoice.markAsPaid */
  markOutgoingProformaInvoiceAsPaid: OutgoingProformaInvoice;
  /** permission: outgoingInvoice.markAsPaid */
  markOutgoingProformaInvoiceAsUnpaid: OutgoingProformaInvoice;
  markTaskAndCommunicationNotificationAsRead: Scalars['Boolean']['output'];
  markTaskAndCommunicationNotificationAsUnread: Scalars['Boolean']['output'];
  /** Move capacity allocation item */
  moveCapacityAllocationItem: CapacityAllocationItem;
  /**
   * Move a card on the board: change the grouped value and/or rewrite board_order.
   * permission: task.read.all/own; extra checks inside by group_by
   */
  moveTaskOnBoard: Task;
  /** permission: timeTracking.update.all/team */
  moveTimeTrackingItemsToTask: BulkActionResponse;
  /** permission: timeTracking.update.all/team */
  moveTimeTrackingItemsToWorkType: BulkActionResponse;
  /** permission: wip.open.all/team/own */
  openWip: WorkInProgressProjectStat;
  /** permission: wip.open.all/team/own */
  openWipBulk: BulkActionResponse;
  /** permission: project.pin.all/team/own */
  pinProject: Project;
  pinProjectsBulk: BulkActionResponse;
  previewQuote: Quote;
  /** permission: outgoingInvoice.create || requestForInvoicing.create.all/team/own */
  proformaInvoiceProject?: Maybe<RequestForInvoicing>;
  /** permission: user.updateWorkData */
  reassignActiveProjectsAndOwnedInvoices: Scalars['Boolean']['output'];
  /** permission: project.finish.all/team/own for given project */
  redistributeProjectCredit: Project;
  /** permission: timeTracking.create.all/team/own + timeTracking.update.all/team/own */
  removeRowFromWeekTimeReport?: Maybe<WeeklyTimeReportRow>;
  /** permission: task.read.all/own for given task */
  removeTaskFiles: Task;
  /** Update capacity allocation user item */
  reopenCapacityAllocationItem: CapacityAllocationItem;
  /** permission: project.budget.reopenExpenseBudgetItem.all/team/own */
  reopenExpenseBudgetItem: ExpenseBudgetItem;
  /** permission: project.reopen.all/team/own */
  reopenProject: Project;
  /** Reorder capacity allocation user items */
  reorderCapacityAllocationItems?: Maybe<Array<CapacityAllocationItem>>;
  /** permission: billingPlan.update */
  resetBillingPlanNotifications: Project;
  returnCreditFromExpenseBudgetItem: Scalars['Boolean']['output'];
  returnCreditFromOurWorkBudgetItem: Scalars['Boolean']['output'];
  returnGlobalCreditFromExpenseItem: Scalars['Boolean']['output'];
  saveQuote: Quote;
  /** permission: user.updateAllfredData */
  scheduleUserActivation: User;
  /** permission: user.updateAllfredData */
  scheduleUserArchival: User;
  /** permission: outgoingInvoice.sendToClient */
  sendOutgoingInvoice: Scalars['Boolean']['output'];
  /** permission: outgoingInvoice.sendToClient */
  sendOutgoingInvoiceBulk: Scalars['Boolean']['output'];
  /** permission: outgoingInvoice.sendToClient */
  sendOutgoingProformaInvoice: Scalars['Boolean']['output'];
  /** permission: outgoingInvoice.sendToClient */
  sendOutgoingProformaInvoiceBulk: Scalars['Boolean']['output'];
  sendQuote: Quote;
  sendTestEmail: SmtpTestResult;
  /** permission: BigIntegration.budgetovac */
  setActiveBudgetovacPositionsSet: BudgetovacPositionsSet;
  /** permission: user.profile.update */
  setUserProfilePlanningRanges: UserProfile;
  /** permission: user.profile.update */
  setUserProfileRates: UserProfile;
  star: Star;
  starProject: Star;
  /** permission: timeTracking.timer.use.all/team/own */
  startTimer: Scalars['Boolean']['output'];
  /** permission: timeTracking.timer.use.all/team/own */
  stopTimer: Scalars['Boolean']['output'];
  stopTimerForCapacityAllocationItem: CapacityAllocationItem;
  /** permission: wip.submit.all/team/own */
  submitProgress: SubmitProgressResult;
  /** permission: wip.submit.all/team/own */
  submitProgressBulk: Array<OurWorkBudgetItem>;
  /** permission: requestForInvoicing.update.all/own/team */
  submitRequestForInvoicing: RequestForInvoicing;
  /** permission: requestForInvoicing.update.all/own/team */
  submitRequestsForInvoicingBulk: BulkActionResponse;
  subscribeToPushNotifications: Scalars['Boolean']['output'];
  syncBudgetOnProjectWithBudgetovac?: Maybe<Scalars['Boolean']['output']>;
  syncPositionsWithBudgetovac?: Maybe<Scalars['Boolean']['output']>;
  testSmtpConnection: SmtpTestResult;
  testWorkspaceAutoExpenseEmail: Scalars['String']['output'];
  /** permission: task.read for given comment's task */
  toggleTaskCommentReaction?: Maybe<Array<TaskCommentReaction>>;
  transferCredit: Scalars['Boolean']['output'];
  transferGlobalCredit: Scalars['Boolean']['output'];
  /** permission: brand.archive */
  unarchiveBrand: Brand;
  /** permission: project.archive.all/team/own */
  unarchiveProject: Project;
  unarchiveProjectsBulk: BulkActionResponse;
  unassignBudgetOnProjectWithBudgetovac?: Maybe<Scalars['Boolean']['output']>;
  unlockDocument: LockDocument;
  unlockModel: Scalars['Boolean']['output'];
  /**
   * Odomknutie Time Billing
   * permission: CFO alebo ADMIN rola
   */
  unlockProjectTimeBilling: ProjectTimeBilling;
  /**
   * Unlock time tracking items
   * permission: timeTracking.update.all/team
   */
  unlockTimeTrackingItems: BulkActionResponse;
  /** permission: wip.unlock.all/team/own */
  unlockWip: WorkInProgressProjectStat;
  /** permission: wip.unlock.all/team/own */
  unlockWipBulk: BulkActionResponse;
  /** permission: project.pin.all/team/own */
  unpinProject: Project;
  unpinProjectsBulk: BulkActionResponse;
  unstar: Scalars['Boolean']['output'];
  unstarProject: Scalars['Boolean']['output'];
  unsubscribeFromPushNotifications: Scalars['Boolean']['output'];
  /** permission: client.update */
  updateBillingEntity: BillingEntity;
  /** permission: billingPlan.update */
  updateBillingPlan: Array<BillingPlanByMonths>;
  /** permission: brand.update, brand.updateManagers */
  updateBrand: Brand;
  /** permission: brandCreditAccount.update.all/team/own for given ID */
  updateBrandCreditAccount: BrandCreditAccount;
  /** permission: BigIntegration.budgetovac */
  updateBudgetovacPosition: BudgetovacPosition;
  /** permission: BigIntegration.budgetovac */
  updateBudgetovacPositionsSet: BudgetovacPositionsSet;
  /** Update capacity allocation - meeting or task. */
  updateCapacityAllocation: CapacityAllocation;
  /** Update capacity allocation item - meeting or task. */
  updateCapacityAllocationItem: CapacityAllocationItem;
  /** permission: client.update, client.updateManagers */
  updateClient: Client;
  updateCompanySettings: CompanySettings;
  /** permission: client.update or brand.update, depending on if the contact belongs to client or brand */
  updateContact: Contact;
  /** permission: contract.update */
  updateContract: Contract;
  /** permission: contractor.update */
  updateContractor: Contractor;
  /** permission: client.update */
  updateCurrencyExchangeRate: CurrencyExchangeRate;
  updateEmailTemplate: EmailTemplate;
  /** permission: workspaceSetting.edit */
  updateExchangeRateForWorkspace: CurrencyExchangeRate;
  /** permission: expense.update.all/team/own for given expense */
  updateExpense: Expense;
  /** permission: project.budget.update.all/team/own */
  updateExpenseBudgetItemNote: ExpenseBudgetItem;
  updateExpenseItemDescription?: Maybe<ExpenseItemDesciption>;
  updateExternalLink: ExternalLink;
  updateFinanceSettings: FinanceSettings;
  /** permission: brandCreditAccount.update.all/team/own for given ID */
  updateGlobalCreditAccount: GlobalCreditAccount;
  updateNotificationSetting: NotificationSetting;
  updateNotificationSettings: NotificationSettings;
  /** permission: order.update */
  updateOrder: Order;
  /** permission: otherDocument.update */
  updateOtherDocument: OtherDocument;
  /** permission: project.budget.update.all/team/own */
  updateOurWorkBudgetItemNote: OurWorkBudgetItem;
  /** permission: project.budget.update.all/team/own */
  updateOurWorkBudgetItems: Array<OurWorkBudgetItem>;
  /** permission: outgoingInvoice.update.all/team/own for given OI */
  updateOutgoingInvoice: OutgoingInvoice;
  /** permission: outgoingInvoice.updateInvoiceNumber for given OI */
  updateOutgoingInvoiceNumber: OutgoingInvoice;
  /** permission: outgoingInvoice.update.all/team/own for given OI */
  updateOutgoingProformaInvoice: OutgoingProformaInvoice;
  /** permission: user.profile.update */
  updatePassword: User;
  updatePaymentSettings: NotificationSettings;
  updatePlanningSettings: WorkspaceSettings;
  /** isDateBeforeLastPlanningUpdate */
  updatePlanningUsersOrder: Scalars['Boolean']['output'];
  /** permission: project.update.all/team/own */
  updateProject: Project;
  updateProjectBillingPlanBudget: Array<BillingPlanBudget>;
  updateProjectBillingPlanSettings: Project;
  /** permission: project.budget.update.all/team/own */
  updateProjectBudget: Project;
  /** permission: projectCategory.update */
  updateProjectCategory: ProjectCategory;
  updateProjectSettings: ProjectSettings;
  updateProjectStage?: Maybe<Project>;
  /**
   * Update existujúceho Time Billing
   * Blokované ak je locked
   * permission: project.update.all/own/team + unlocked
   */
  updateProjectTimeBilling: ProjectTimeBilling;
  updateProjectTimeBreakdown: ProjectTimeBreakdown;
  /** permission: requestForInvoicing.update.all/own/team */
  updateRequestForInvoicing: RequestForInvoicing;
  /** permission: task.update.all/own for given task */
  updateScopedTask: Task;
  updateSequence: Sequence;
  updateTag?: Maybe<Tag>;
  /** permission: task.update.all/own for given task */
  updateTask: Task;
  /**
   * Replace all task positions (assignees with work type and planned time).
   * permission: task.update.all/own for given task
   */
  updateTaskAssignees: Task;
  /**
   * Mark the task billable or non-billable.
   * permission: task.update.all/own for given task
   */
  updateTaskBillable: Task;
  /**
   * Upsert current user's board settings for the given board_key.
   * Merge semantics: provided non-null fields overwrite, null fields stay unchanged.
   * permission: none, own settings only (authenticated user)
   */
  updateTaskBoardSettings: TaskBoardSettings;
  /** permission: taskComment.update.all/own and task.read for given comment's task */
  updateTaskComment: TaskComment;
  /** permission: task.update_current_assignee.all/own for given task */
  updateTaskCurrentAssignee: Task;
  /**
   * Set or clear the task deadline.
   * permission: task.update.all/own for given task
   */
  updateTaskDeadline: Task;
  /**
   * permission: task.update.all/own or task.update.scoped for given task,
   * or task.read.all/own when only checklist items are ticked
   */
  updateTaskDescription: Task;
  /**
   * Set the task duration; a null date leaves that side open.
   * permission: task.update.all/own for given task
   */
  updateTaskDuration: Task;
  /** permission: task.read.all/own for given task */
  updateTaskPriority: Task;
  /** permission: task.update_status.all/own for given task */
  updateTaskStatus: Task;
  updateTaskTemplateGroup: TaskTemplateGroup;
  /** permission: timeTracking.update.all/team/own */
  updateTimeTrackingItem: TimeTrackingItem;
  /** permission: timeTracking.update.all/team */
  updateTimeTrackingItemsBillable: BulkActionResponse;
  /** permission: brand.update */
  updateTimeTrackingRatesForBrand: Brand;
  /** permission: project.update.all/team/own */
  updateTimeTrackingRatesForProject: Project;
  /** permission: project.update.all/team/own */
  updateTimeTrackingSettingsForProject: Project;
  /** permission: BigIntegration.budgetovac */
  updateTimeTrackingWorkType: TimeTrackingWorkType;
  updateTimeTrackingWorkTypeInTracking: Scalars['Boolean']['output'];
  updateUser: User;
  updateUserPassword: User;
  updateVatRate: VatRate;
  updateWorkspaceAccountingAccountSettings: WorkspaceAccountingAccountSettings;
  updateWorkspaceAccountingCentreSettings: WorkspaceAccountingCentreSettings;
  updateWorkspaceAccountingVatClassificationSettings: WorkspaceAccountingVatClassificationSettings;
  updateWorkspaceAutoExpenseEmail?: Maybe<WorkspaceAutoExpenseEmailSettings>;
  updateWorkspaceCompanies: Array<WorkspaceCompanySetting>;
  updateWorkspaceFinancialSettings: WorkspaceFinancialSetting;
  updateWorkspacePipedriveIntegration: WorkspacePipedriveIntegration;
  updateWorkspacePlanningSettings: WorkspacePlanningSettings;
  updateWorkspaceProjectSettings: WorkspaceProjectSettings;
  updateWorkspaceSmtpSettings: WorkspaceSmtpSettings;
  updateWorkspaceTaskSettings: WorkspaceTaskSettings;
  updateWorkspaceUserManagementSettings: WorkspaceUserManagementSetting;
  validateCreateTimeTrackingItem: Scalars['Boolean']['output'];
};


export type MutationUpdateCapacityAllocationForDayArgs = {
  input: UpdateCapacityAllocationForDayInput;
};


export type MutationUpdateWorkspaceNotificationsArgs = {
  input?: InputMaybe<UpdateWorkspaceNotifications>;
};


export type MutationAddBankAccountMovesToDocumentArgs = {
  bank_account_moves: Array<BankAccountMoveToDocumentInput>;
  date: Scalars['Date']['input'];
  document_id: Scalars['ID']['input'];
  document_type: BankDocumentTypeEnum;
};


export type MutationAddDocumentsToAccountMoveArgs = {
  bank_account_move_id: Scalars['ID']['input'];
  documents: Array<BankAccountMoveDocumentInput>;
};


export type MutationAddManualAccountMoveArgs = {
  amount: Scalars['BigInt']['input'];
  currency_id: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  note: Scalars['String']['input'];
};


export type MutationAddRowToWeekTimeReportArgs = {
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddTaskAssigneeArgs = {
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  position: TaskPositionInput;
  task_id: Scalars['ID']['input'];
};


export type MutationAddTaskFilesArgs = {
  files: Array<Scalars['String']['input']>;
  task_id: Scalars['ID']['input'];
};


export type MutationAddTaskLinkArgs = {
  link_type_id: Scalars['ID']['input'];
  linked_task_id: Scalars['ID']['input'];
  task_id: Scalars['ID']['input'];
};


export type MutationArchiveBrandArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveProjectsBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationBudgetCreatedEventArgs = {
  budget_id: Scalars['ID']['input'];
};


export type MutationBudgetInternalApproveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBulkArchiveBrandArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationBulkDeleteBrandArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationBulkDeleteExpensesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkDeleteTasksArgs = {
  task_ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkDeleteTimeTrackingItemsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkEditTasksArgs = {
  data: BulkEditTaskInput;
  duplicate_task: Scalars['Boolean']['input'];
  task_ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkLockModelArgs = {
  lockable_ids: Array<Scalars['ID']['input']>;
  lockable_type: ModelLockLockableTypeEnum;
};


export type MutationBulkStarArgs = {
  starable_ids: Array<Scalars['ID']['input']>;
  starable_type: StarsStarableTypeEnum;
};


export type MutationBulkStarProjectsArgs = {
  options?: InputMaybe<ProjectStarOptions>;
  project_ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkUnlockModelArgs = {
  lockable_ids: Array<Scalars['ID']['input']>;
  lockable_type: ModelLockLockableTypeEnum;
};


export type MutationBulkUnstarArgs = {
  starable_ids: Array<Scalars['ID']['input']>;
  starable_type: StarsStarableTypeEnum;
};


export type MutationBulkUnstarProjectsArgs = {
  options?: InputMaybe<ProjectStarOptions>;
  project_ids: Array<Scalars['ID']['input']>;
};


export type MutationBulkUpdateProjectsArgs = {
  ids: Array<Scalars['ID']['input']>;
  input: BulkUpdateProjectsInput;
};


export type MutationChangeBudgetAssignedAtArgs = {
  date: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
};


export type MutationChangeOutgoingInvoiceDatesArgs = {
  date_of_supply: Scalars['Date']['input'];
  due_date: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
  issue_date: Scalars['Date']['input'];
  paid_at?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationChangeOutgoingProformaInvoiceDatesArgs = {
  due_date: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
  issue_date: Scalars['Date']['input'];
  paid_at?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationChangeRateCardOnProjectArgs = {
  exchange_rate?: InputMaybe<Scalars['BigInt']['input']>;
  project_id: Scalars['ID']['input'];
  rate_card_id: Scalars['ID']['input'];
};


export type MutationCloneExpenseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCloseWipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCloseWipBulkArgs = {
  input: LockProjectInput;
};


export type MutationCompleteCapacityAllocationItemArgs = {
  input: CompleteCapacityAllocationUserInput;
};


export type MutationCompleteExpenseBudgetItemArgs = {
  completed_at?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationCompleteExpenseBudgetItemBulkArgs = {
  completed_at?: InputMaybe<Scalars['Date']['input']>;
  ids: Array<Scalars['ID']['input']>;
};


export type MutationConnectToMcpArgs = {
  input: ConnectToMcpInput;
};


export type MutationCopyCapacityAllocationItemArgs = {
  input: MoveCapacityAllocationItemInput;
};


export type MutationCreateAssignableFileArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationCreateBillingEntityArgs = {
  input: CreateBillingEntityInput;
};


export type MutationCreateBillingPlanArgs = {
  project_id: Scalars['ID']['input'];
};


export type MutationCreateBrandArgs = {
  input: CreateBrandInput;
};


export type MutationCreateBrandCreditAccountArgs = {
  input: CreateBrandCreditAccountInput;
};


export type MutationCreateBudgetItemPlannedExpensesArgs = {
  input: CreateBudgetItemPlannedExpensesInput;
};


export type MutationCreateBudgetItemPlannedExpensesBulkArgs = {
  items: Array<CreateBudgetItemPlannedExpensesInput>;
};


export type MutationCreateBudgetovacPositionArgs = {
  input: CreateBudgetovacPositionInput;
};


export type MutationCreateBudgetovacPositionsSetArgs = {
  input: CreateBudgetovacPositionsSetInput;
};


export type MutationCreateCapacityAllocationArgs = {
  input: CreateCapacityAllocationInput;
};


export type MutationCreateClientArgs = {
  input: CreateClientInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateContractArgs = {
  input?: InputMaybe<CreateContractInput>;
};


export type MutationCreateContractorArgs = {
  input: CreateContractorInput;
};


export type MutationCreateCurrencyExchangeRateArgs = {
  input: CreateCurrencyExchangeRateInput;
};


export type MutationCreateEmailTemplateArgs = {
  input?: InputMaybe<CreateEmailTemplateInput>;
};


export type MutationCreateExchangeRateForWorkspaceArgs = {
  input: CreateExchangeRateSettingsInput;
};


export type MutationCreateExpenseArgs = {
  input: CreateExpenseInput;
};


export type MutationCreateExpenseBudgetItemArgs = {
  expense_budget_category_id: Scalars['ID']['input'];
  project_id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateExpenseItemDescriptionArgs = {
  title: Scalars['String']['input'];
};


export type MutationCreateExternalLinkArgs = {
  input: CreateExternalLinkInput;
};


export type MutationCreateFilterTemplateArgs = {
  input: FilterTemplateInput;
};


export type MutationCreateGlobalCreditAccountArgs = {
  input: CreateGlobalCreditAccountInput;
};


export type MutationCreateInvoiceFromBillingPlanArgs = {
  input?: InputMaybe<CreateInvoiceFromBillingPlanInput>;
};


export type MutationCreateOrUpdateTrackedTimeForDayArgs = {
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  tracked_for_date: Scalars['Date']['input'];
  tracked_time: Scalars['BigInt']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateOrderArgs = {
  input?: InputMaybe<CreateOrderInput>;
};


export type MutationCreateOtherDocumentArgs = {
  input?: InputMaybe<CreateOtherDocumentInput>;
};


export type MutationCreateOurWorkBudgetItemArgs = {
  project_id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateOutgoingInvoiceArgs = {
  invoice_no?: InputMaybe<Scalars['String']['input']>;
  invoice_order_sequence_id: Scalars['ID']['input'];
  request_for_invoicing_id: Scalars['ID']['input'];
  skip_date_validations?: Scalars['Boolean']['input'];
};


export type MutationCreateOutgoingProformaInvoiceArgs = {
  invoice_no: Scalars['ID']['input'];
  invoice_order_sequence_id: Scalars['ID']['input'];
  request_for_invoicing_id: Scalars['ID']['input'];
  skip_date_validations?: Scalars['Boolean']['input'];
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateProjectCategoryArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateProjectFromPipedriveArgs = {
  input: CreateProjectFromPipedriveInput;
};


export type MutationCreateProjectFromTemplateArgs = {
  input: CreateProjectFromTemplateInput;
};


export type MutationCreateProjectTimeBillingArgs = {
  input: CreateProjectTimeBillingInput;
};


export type MutationCreateProjectTimeBreakdownArgs = {
  budgeted: Scalars['Int']['input'];
  date_from?: InputMaybe<Scalars['Date']['input']>;
  date_to?: InputMaybe<Scalars['Date']['input']>;
  our_work_budget_item_id: Scalars['ID']['input'];
  project_id: Scalars['ID']['input'];
};


export type MutationCreateQuoteArgs = {
  budget_ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationCreateRequestForInvoicingArgs = {
  input: CreateRequestForInvoicingInput;
  skip_date_validations?: Scalars['Boolean']['input'];
};


export type MutationCreateScopedTaskArgs = {
  input: CreateScopedTaskInput;
};


export type MutationCreateScopedUserArgs = {
  input: CreateScopedUserInput;
};


export type MutationCreateSequenceArgs = {
  input?: InputMaybe<CreateSequenceInput>;
};


export type MutationCreateTagArgs = {
  title: Scalars['String']['input'];
};


export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


export type MutationCreateTaskCommentArgs = {
  input: CreateTaskCommentInput;
};


export type MutationCreateTaskTemplateGroupArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateTasksFromTaskTemplateGroupArgs = {
  our_work_budget_item_ids: Array<Scalars['ID']['input']>;
  task_template_group_id: Scalars['ID']['input'];
};


export type MutationCreateTimeTrackingItemArgs = {
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  specific_time_from?: InputMaybe<Scalars['Time']['input']>;
  specific_time_to?: InputMaybe<Scalars['Time']['input']>;
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  tracked_for_date?: InputMaybe<Scalars['Date']['input']>;
  tracked_time?: InputMaybe<Scalars['BigInt']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateTimeTrackingWorkTypeArgs = {
  input: CreateTimeTrackingWorkTypeInput;
};


export type MutationCreateUpdateExpenseContractorArgs = {
  input: CreateUpdateExpenseContractorInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateVatRateArgs = {
  input?: InputMaybe<CreateVatRateInput>;
};


export type MutationCreateWorkspaceSmtpSettingsArgs = {
  input: CreateWorkspaceSmtpSettingsInput;
};


export type MutationDeleteAssignableFileArgs = {
  public_id: Scalars['String']['input'];
};


export type MutationDeleteBillingEntityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBrandArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBrandCreditAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBudgetovacPositionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBudgetovacPositionsSetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCapacityAllocationArgs = {
  input: DeleteCapacityAllocationInput;
};


export type MutationDeleteCapacityAllocationForDayArgs = {
  input: DeleteCapacityAllocationForDayInput;
};


export type MutationDeleteCapacityAllocationItemArgs = {
  input: DeleteCapacityAllocationItemInput;
};


export type MutationDeleteClientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContractArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContractorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContractorsBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationDeleteExchangeRateForWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteExpenseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteExpenseItemDescriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteExternalLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFilterTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGlobalCreditAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOtherDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOutgoingInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOutgoingProformaInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectTimeBillingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectTimeBreakdownArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectsBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationDeleteQuoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRequestForInvoicingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRequestsForInvoicingBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskLinkArgs = {
  task_link_id: Scalars['ID']['input'];
};


export type MutationDeleteTaskTemplateGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTimeTrackingItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTimeTrackingWorkTypeArgs = {
  input: DeleteTimeTrackingWorkTypeInput;
};


export type MutationDeleteUploadedFileArgs = {
  assignable_file_id: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableTwoFactorAuthenticationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisconnectFromMcpArgs = {
  input: DisconnectFromMcpInput;
};


export type MutationDuplicateProjectArgs = {
  id: Scalars['ID']['input'];
  with_task_attachments?: Scalars['Boolean']['input'];
  with_task_comments?: Scalars['Boolean']['input'];
  with_task_description?: Scalars['Boolean']['input'];
  with_tasks?: Scalars['Boolean']['input'];
};


export type MutationDuplicateTaskArgs = {
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  task_id: Scalars['ID']['input'];
  task_input?: InputMaybe<CreateTaskInput>;
  with_attachments?: InputMaybe<Scalars['Boolean']['input']>;
  with_comments?: InputMaybe<Scalars['Boolean']['input']>;
  with_description?: InputMaybe<Scalars['Boolean']['input']>;
  with_links?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationEditTaskWatchersArgs = {
  task_id: Scalars['ID']['input'];
  user_ids: Array<Scalars['ID']['input']>;
};


export type MutationExcludeBankAccountMoveArgs = {
  bank_account_move_id: Scalars['ID']['input'];
};


export type MutationFindAddressForExpenseArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type MutationFinishProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInvoiceProjectArgs = {
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  expense_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  invoice_type?: InputMaybe<RequestForInvoicingTypeEnum>;
  our_work_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationInvoiceProjectByCurrentMonthBillingPlanArgs = {
  id: Scalars['ID']['input'];
  invoice_type: RequestForInvoicingTypeEnum;
};


export type MutationInvoiceProjectsBulkArgs = {
  id: Array<Scalars['ID']['input']>;
  invoice_type?: InputMaybe<RequestForInvoicingTypeEnum>;
};


export type MutationIsDateBeforeLastPlanningUpdateArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationLastSeenArgs = {
  task_comment_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationLockBillingPlanForProjectArgs = {
  project_id: Scalars['ID']['input'];
};


export type MutationLockDocumentArgs = {
  document_id: Scalars['ID']['input'];
  document_type: LockDocumentTypeEnum;
};


export type MutationLockModelArgs = {
  lockable_id: Scalars['ID']['input'];
  lockable_type: ModelLockLockableTypeEnum;
};


export type MutationLockProjectTimeBillingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLockWipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLockWipBulkArgs = {
  input: LockProjectInput;
};


export type MutationManualApproveQuoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkAllNotificationsAsReadArgs = {
  groups?: InputMaybe<Array<InputMaybe<NotificationGroup>>>;
};


export type MutationMarkExpenseAsPaidArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationMarkExpenseAsPaidBulkArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  id: Array<Scalars['ID']['input']>;
};


export type MutationMarkExpenseAsUnpaidArgs = {
  id: Scalars['ID']['input'];
  remove_matched_payments?: Scalars['Boolean']['input'];
};


export type MutationMarkNotificationAsReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkNotificationAsUnreadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkOutgoingInvoiceAsPaidArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationMarkOutgoingInvoiceAsPaidBulkArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  id: Array<Scalars['ID']['input']>;
};


export type MutationMarkOutgoingInvoiceAsUnpaidArgs = {
  id: Scalars['ID']['input'];
  remove_matched_payments?: Scalars['Boolean']['input'];
};


export type MutationMarkOutgoingProformaInvoiceAsPaidArgs = {
  create_summary_invoice?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationMarkOutgoingProformaInvoiceAsUnpaidArgs = {
  id: Scalars['ID']['input'];
  remove_matched_payments?: Scalars['Boolean']['input'];
};


export type MutationMarkTaskAndCommunicationNotificationAsReadArgs = {
  task_id: Scalars['ID']['input'];
};


export type MutationMarkTaskAndCommunicationNotificationAsUnreadArgs = {
  task_id: Scalars['ID']['input'];
};


export type MutationMoveCapacityAllocationItemArgs = {
  input: MoveCapacityAllocationItemInput;
};


export type MutationMoveTaskOnBoardArgs = {
  input: MoveTaskOnBoardInput;
};


export type MutationMoveTimeTrackingItemsToTaskArgs = {
  task_id: Scalars['ID']['input'];
  time_tracking_item_ids: Array<Scalars['ID']['input']>;
  time_tracking_work_type_mapping: Array<TimeTrackingWorkTypeMapping>;
};


export type MutationMoveTimeTrackingItemsToWorkTypeArgs = {
  time_tracking_item_ids: Array<Scalars['ID']['input']>;
  time_tracking_work_type_id: Scalars['ID']['input'];
};


export type MutationOpenWipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOpenWipBulkArgs = {
  input: LockProjectInput;
};


export type MutationPinProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPinProjectsBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationPreviewQuoteArgs = {
  input: QuoteInput;
};


export type MutationProformaInvoiceProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReassignActiveProjectsAndOwnedInvoicesArgs = {
  from_user_id: Scalars['ID']['input'];
  to_user_id: Scalars['ID']['input'];
};


export type MutationRedistributeProjectCreditArgs = {
  project_id: Scalars['ID']['input'];
};


export type MutationRemoveRowFromWeekTimeReportArgs = {
  first_date_of_week: Scalars['Date']['input'];
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRemoveTaskFilesArgs = {
  files: Array<Scalars['String']['input']>;
  task_id: Scalars['ID']['input'];
};


export type MutationReopenCapacityAllocationItemArgs = {
  input: ReopenCapacityAllocationItemInput;
};


export type MutationReopenExpenseBudgetItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReopenProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReorderCapacityAllocationItemsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationResetBillingPlanNotificationsArgs = {
  project_id: Scalars['ID']['input'];
  types: Array<BillingPlanNotificationTypeEnum>;
};


export type MutationReturnCreditFromExpenseBudgetItemArgs = {
  amount: Scalars['BigInt']['input'];
  brand_credit_account_id: Scalars['ID']['input'];
  credit_account_operation_id: Scalars['ID']['input'];
  expense_budget_item_id: Scalars['ID']['input'];
};


export type MutationReturnCreditFromOurWorkBudgetItemArgs = {
  amount: Scalars['BigInt']['input'];
  brand_credit_account_id: Scalars['ID']['input'];
  credit_account_operation_id: Scalars['ID']['input'];
  our_work_budget_item_id: Scalars['ID']['input'];
};


export type MutationReturnGlobalCreditFromExpenseItemArgs = {
  amount: Scalars['BigInt']['input'];
  credit_account_operation_id: Scalars['ID']['input'];
  expense_budget_item_id: Scalars['ID']['input'];
  global_credit_account_id: Scalars['ID']['input'];
};


export type MutationSaveQuoteArgs = {
  input: QuoteInput;
};


export type MutationScheduleUserActivationArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationScheduleUserArchivalArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  project_manager_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSendOutgoingInvoiceArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendOutgoingInvoiceBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationSendOutgoingProformaInvoiceArgs = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendOutgoingProformaInvoiceBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationSendQuoteArgs = {
  input: QuoteSendInput;
};


export type MutationSendTestEmailArgs = {
  input: CreateWorkspaceSmtpSettingsInput;
};


export type MutationSetActiveBudgetovacPositionsSetArgs = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetUserProfilePlanningRangesArgs = {
  planningRanges: Array<PlanningRangeInput>;
  user_id: Scalars['ID']['input'];
};


export type MutationSetUserProfileRatesArgs = {
  rates: Array<UserProfileRateInput>;
  user_id: Scalars['ID']['input'];
};


export type MutationStarArgs = {
  starable_id: Scalars['ID']['input'];
  starable_type: StarsStarableTypeEnum;
};


export type MutationStarProjectArgs = {
  options?: InputMaybe<ProjectStarOptions>;
  project_id: Scalars['ID']['input'];
};


export type MutationStartTimerArgs = {
  time_tracking_item_id: Scalars['ID']['input'];
};


export type MutationStopTimerArgs = {
  time_tracking_item_id: Scalars['ID']['input'];
};


export type MutationStopTimerForCapacityAllocationItemArgs = {
  input: StopTimerForCapacityAllocationItemInput;
};


export type MutationSubmitProgressArgs = {
  input: SubmitProgressInput;
};


export type MutationSubmitProgressBulkArgs = {
  input: SubmitProgressBulkInput;
};


export type MutationSubmitRequestForInvoicingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubmitRequestsForInvoicingBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationSubscribeToPushNotificationsArgs = {
  endpoint: Scalars['String']['input'];
  keys: PushNotificationSubscriptionKeys;
};


export type MutationSyncBudgetOnProjectWithBudgetovacArgs = {
  project_id: Scalars['ID']['input'];
};


export type MutationTestSmtpConnectionArgs = {
  input: TestSmtpConnectionInput;
};


export type MutationToggleTaskCommentReactionArgs = {
  input: ToggleTaskCommentReactionInput;
};


export type MutationTransferCreditArgs = {
  amount: Scalars['BigInt']['input'];
  from_credit_account_id: Scalars['ID']['input'];
  outgoing_invoice_id?: InputMaybe<Scalars['ID']['input']>;
  performed_at?: InputMaybe<Scalars['DateTime']['input']>;
  to_credit_account_id: Scalars['ID']['input'];
};


export type MutationTransferGlobalCreditArgs = {
  amount: Scalars['BigInt']['input'];
  from_credit_account_id: Scalars['ID']['input'];
  performed_at?: InputMaybe<Scalars['DateTime']['input']>;
  to_credit_account_id: Scalars['ID']['input'];
};


export type MutationUnarchiveBrandArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnarchiveProjectsBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationUnassignBudgetOnProjectWithBudgetovacArgs = {
  budget_id: Scalars['ID']['input'];
  project_id: Scalars['ID']['input'];
};


export type MutationUnlockDocumentArgs = {
  document_id: Scalars['ID']['input'];
  document_type: LockDocumentTypeEnum;
};


export type MutationUnlockModelArgs = {
  lockable_id: Scalars['ID']['input'];
  lockable_type: ModelLockLockableTypeEnum;
};


export type MutationUnlockProjectTimeBillingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnlockTimeTrackingItemsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationUnlockWipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnlockWipBulkArgs = {
  input: LockProjectInput;
};


export type MutationUnpinProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnpinProjectsBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type MutationUnstarArgs = {
  starable_id: Scalars['ID']['input'];
  starable_type: StarsStarableTypeEnum;
};


export type MutationUnstarProjectArgs = {
  options?: InputMaybe<ProjectStarOptions>;
  project_id: Scalars['ID']['input'];
};


export type MutationUnsubscribeFromPushNotificationsArgs = {
  endpoint: Scalars['String']['input'];
};


export type MutationUpdateBillingEntityArgs = {
  input: UpdateBillingEntityInput;
};


export type MutationUpdateBillingPlanArgs = {
  input: UpdateBillingPlanInput;
};


export type MutationUpdateBrandArgs = {
  input: UpdateBrandInput;
};


export type MutationUpdateBrandCreditAccountArgs = {
  input: UpdateBrandCreditAccountInput;
};


export type MutationUpdateBudgetovacPositionArgs = {
  input: UpdateBudgetovacPositionInput;
};


export type MutationUpdateBudgetovacPositionsSetArgs = {
  input: UpdateBudgetovacPositionsSetInput;
};


export type MutationUpdateCapacityAllocationArgs = {
  input: UpdateCapacityAllocationInput;
};


export type MutationUpdateCapacityAllocationItemArgs = {
  input: UpdateCapacityAllocationItemInput;
};


export type MutationUpdateClientArgs = {
  input: UpdateClientInput;
};


export type MutationUpdateCompanySettingsArgs = {
  input?: InputMaybe<UpdateCompanySettingsInput>;
};


export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};


export type MutationUpdateContractArgs = {
  input?: InputMaybe<UpdateContractInput>;
};


export type MutationUpdateContractorArgs = {
  input: UpdateContractorInput;
};


export type MutationUpdateCurrencyExchangeRateArgs = {
  input: UpdateCurrencyExchangeRateInput;
};


export type MutationUpdateEmailTemplateArgs = {
  input?: InputMaybe<UpdateEmailTemplateInput>;
};


export type MutationUpdateExchangeRateForWorkspaceArgs = {
  input: UpdateExchangeRateSettingsInput;
};


export type MutationUpdateExpenseArgs = {
  input: UpdateExpenseInput;
};


export type MutationUpdateExpenseBudgetItemNoteArgs = {
  expense_budget_item_id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateExpenseItemDescriptionArgs = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationUpdateExternalLinkArgs = {
  input: UpdateExternalLinkInput;
};


export type MutationUpdateFinanceSettingsArgs = {
  input?: InputMaybe<UpdateFinanceSettingsInput>;
};


export type MutationUpdateGlobalCreditAccountArgs = {
  input: UpdateGlobalCreditAccountInput;
};


export type MutationUpdateNotificationSettingArgs = {
  input: NotificationSettingInput;
};


export type MutationUpdateNotificationSettingsArgs = {
  input?: InputMaybe<UpdateNotificationSettingsInput>;
};


export type MutationUpdateOrderArgs = {
  input?: InputMaybe<UpdateOrderInput>;
};


export type MutationUpdateOtherDocumentArgs = {
  input?: InputMaybe<UpdateOtherDocumentInput>;
};


export type MutationUpdateOurWorkBudgetItemNoteArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  our_work_budget_item_id: Scalars['ID']['input'];
};


export type MutationUpdateOurWorkBudgetItemsArgs = {
  budget_items: Array<UpdateBudgetItem>;
};


export type MutationUpdateOutgoingInvoiceArgs = {
  input?: InputMaybe<UpdateOutgoingInvoiceInput>;
  skip_date_validations?: Scalars['Boolean']['input'];
};


export type MutationUpdateOutgoingInvoiceNumberArgs = {
  force?: Scalars['Boolean']['input'];
  input?: InputMaybe<UpdateOutgoingInvoiceNumberInput>;
};


export type MutationUpdateOutgoingProformaInvoiceArgs = {
  input?: InputMaybe<UpdateOutgoingProformaInvoiceInput>;
  skip_date_validations?: Scalars['Boolean']['input'];
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationUpdatePaymentSettingsArgs = {
  input?: InputMaybe<UpdatePaymentSettingsInput>;
};


export type MutationUpdatePlanningSettingsArgs = {
  input: UpdatePlanningSettings;
};


export type MutationUpdatePlanningUsersOrderArgs = {
  model_id?: InputMaybe<Scalars['ID']['input']>;
  type: PlanningOrderTypeEnum;
  user_ids: Array<Scalars['ID']['input']>;
};


export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
  propagate_billable?: Scalars['Boolean']['input'];
};


export type MutationUpdateProjectBillingPlanBudgetArgs = {
  input?: InputMaybe<UpdateProjectBillingPlanBudgetInput>;
};


export type MutationUpdateProjectBillingPlanSettingsArgs = {
  input?: InputMaybe<UpdateProjectBillingPlanSettingsInput>;
};


export type MutationUpdateProjectBudgetArgs = {
  input: UpdateProjectBudgetInput;
};


export type MutationUpdateProjectCategoryArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProjectSettingsArgs = {
  input?: InputMaybe<UpdateProjectSettingsInput>;
};


export type MutationUpdateProjectStageArgs = {
  project_id: Scalars['ID']['input'];
  project_stage_id: Scalars['ID']['input'];
};


export type MutationUpdateProjectTimeBillingArgs = {
  input: UpdateProjectTimeBillingInput;
};


export type MutationUpdateProjectTimeBreakdownArgs = {
  budgeted: Scalars['Int']['input'];
  date_from?: InputMaybe<Scalars['Date']['input']>;
  date_to?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateRequestForInvoicingArgs = {
  input: UpdateRequestForInvoicingInput;
  skip_date_validations?: Scalars['Boolean']['input'];
};


export type MutationUpdateScopedTaskArgs = {
  input: UpdateScopedTaskInput;
};


export type MutationUpdateSequenceArgs = {
  input?: InputMaybe<UpdateSequenceInput>;
};


export type MutationUpdateTagArgs = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
  propagate_billable?: Scalars['Boolean']['input'];
};


export type MutationUpdateTaskAssigneesArgs = {
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  positions: Array<TaskPositionInput>;
  task_id: Scalars['ID']['input'];
};


export type MutationUpdateTaskBillableArgs = {
  billable: Scalars['Boolean']['input'];
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  propagate_billable?: InputMaybe<Scalars['Boolean']['input']>;
  task_id: Scalars['ID']['input'];
};


export type MutationUpdateTaskBoardSettingsArgs = {
  input: UpdateTaskBoardSettingsInput;
};


export type MutationUpdateTaskCommentArgs = {
  input: UpdateTaskCommentInput;
};


export type MutationUpdateTaskCurrentAssigneeArgs = {
  current_assignee_user_id?: InputMaybe<Scalars['ID']['input']>;
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  task_id: Scalars['ID']['input'];
};


export type MutationUpdateTaskDeadlineArgs = {
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  task_id: Scalars['ID']['input'];
};


export type MutationUpdateTaskDescriptionArgs = {
  input: UpdateTaskDescriptionInput;
};


export type MutationUpdateTaskDurationArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  task_id: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationUpdateTaskPriorityArgs = {
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  priority_id: Scalars['ID']['input'];
  task_id: Scalars['ID']['input'];
};


export type MutationUpdateTaskStatusArgs = {
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  status_id: Scalars['ID']['input'];
  task_id: Scalars['ID']['input'];
};


export type MutationUpdateTaskTemplateGroupArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateTimeTrackingItemArgs = {
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  specific_time_from?: InputMaybe<Scalars['Time']['input']>;
  specific_time_to?: InputMaybe<Scalars['Time']['input']>;
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  tracked_for_date: Scalars['Date']['input'];
  tracked_time?: InputMaybe<Scalars['BigInt']['input']>;
};


export type MutationUpdateTimeTrackingItemsBillableArgs = {
  billable: Scalars['Boolean']['input'];
  time_tracking_item_ids: Array<Scalars['ID']['input']>;
};


export type MutationUpdateTimeTrackingRatesForBrandArgs = {
  input: UpdateTimeTrackingRatesForBrandInput;
};


export type MutationUpdateTimeTrackingRatesForProjectArgs = {
  input: UpdateTimeTrackingRatesForProjectInput;
};


export type MutationUpdateTimeTrackingSettingsForProjectArgs = {
  input: UpdateTimeTrackingSettingsInput;
};


export type MutationUpdateTimeTrackingWorkTypeArgs = {
  input: UpdateTimeTrackingWorkTypeInput;
};


export type MutationUpdateTimeTrackingWorkTypeInTrackingArgs = {
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
  new_time_tracking_work_type_id: Scalars['ID']['input'];
  old_time_tracking_work_type_id: Scalars['ID']['input'];
  task_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserPasswordArgs = {
  input: UpdateUserPasswordInput;
};


export type MutationUpdateVatRateArgs = {
  input?: InputMaybe<UpdateVatRateInput>;
};


export type MutationUpdateWorkspaceAccountingAccountSettingsArgs = {
  input?: InputMaybe<InputUpdateWorkspaceAccountingAccountSettings>;
};


export type MutationUpdateWorkspaceAccountingCentreSettingsArgs = {
  input?: InputMaybe<InputUpdateWorkspaceAccountingCentreSettings>;
};


export type MutationUpdateWorkspaceAccountingVatClassificationSettingsArgs = {
  input?: InputMaybe<InputUpdateWorkspaceAccountingVatClassificationSettings>;
};


export type MutationUpdateWorkspaceAutoExpenseEmailArgs = {
  input?: InputMaybe<InputUpdateWorkspaceAutoExpenseEmail>;
};


export type MutationUpdateWorkspaceCompaniesArgs = {
  input?: InputMaybe<InputWorkspaceCompanySetting>;
};


export type MutationUpdateWorkspaceFinancialSettingsArgs = {
  input?: InputMaybe<InputWorkspaceFinancialSetting>;
};


export type MutationUpdateWorkspacePipedriveIntegrationArgs = {
  input?: InputMaybe<InputUpdateWorkspacePipedriveIntegration>;
};


export type MutationUpdateWorkspacePlanningSettingsArgs = {
  input?: InputMaybe<InputWorkspacePlanningSetting>;
};


export type MutationUpdateWorkspaceProjectSettingsArgs = {
  input?: InputMaybe<InputUpdateWorkspaceProjectSettings>;
};


export type MutationUpdateWorkspaceSmtpSettingsArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWorkspaceSmtpSettingsInput;
};


export type MutationUpdateWorkspaceTaskSettingsArgs = {
  input?: InputMaybe<InputWorkspaceTaskSettings>;
};


export type MutationUpdateWorkspaceUserManagementSettingsArgs = {
  input?: InputMaybe<InputWorkspaceUserManagementSetting>;
};


export type MutationValidateCreateTimeTrackingItemArgs = {
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type Notification = {
  __typename?: 'Notification';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  object_id?: Maybe<Scalars['ID']['output']>;
  read_at?: Maybe<Scalars['DateTime']['output']>;
  type: NotificationType;
  url?: Maybe<Scalars['String']['output']>;
};

export enum NotificationGroup {
  ActionRequired = 'ACTION_REQUIRED',
  Default = 'DEFAULT',
  TaskCommunication = 'TASK_COMMUNICATION'
}

/** A paginated list of Notification items. */
export type NotificationPaginator = {
  __typename?: 'NotificationPaginator';
  /** A list of Notification items. */
  data: Array<Notification>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type NotificationPerTask = {
  __typename?: 'NotificationPerTask';
  notifications: Array<Notification>;
  task: Task;
};

export enum NotificationRoleEnum {
  Cfo = 'CFO',
  Financier = 'FINANCIER',
  ManagingDirector = 'MANAGING_DIRECTOR',
  ProjectManager = 'PROJECT_MANAGER',
  TeamLeader = 'TEAM_LEADER'
}

export type NotificationSetting = {
  __typename?: 'NotificationSetting';
  database_enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  mail_enabled: Scalars['Boolean']['output'];
  roles_to_notify?: Maybe<Array<NotificationRoleEnum>>;
  threshold?: Maybe<Scalars['BigInt']['output']>;
  type: NotificationType;
};

export type NotificationSettingInput = {
  database_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  mail_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  roles_to_notify?: InputMaybe<Array<NotificationRoleEnum>>;
  threshold?: InputMaybe<Scalars['BigInt']['input']>;
};

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  email_footer?: Maybe<Scalars['String']['output']>;
  from_email?: Maybe<Scalars['String']['output']>;
  notification_email?: Maybe<Scalars['String']['output']>;
};

export enum NotificationThresholdTypeEnum {
  Amount = 'AMOUNT',
  Days = 'DAYS',
  Hours = 'HOURS',
  None = 'NONE',
  Percentage = 'PERCENTAGE'
}

export enum NotificationType {
  ApprovedExpenseItemChanged = 'APPROVED_EXPENSE_ITEM_CHANGED',
  BillingDateApproaching = 'BILLING_DATE_APPROACHING',
  BillingPlanMustBeChecked = 'BILLING_PLAN_MUST_BE_CHECKED',
  BrandCreditAccountCreated = 'BRAND_CREDIT_ACCOUNT_CREATED',
  BudgetCreated = 'BUDGET_CREATED',
  BudgetExceededByThreshold = 'BUDGET_EXCEEDED_BY_THRESHOLD',
  BudgetExceededByThresholdFirstAlert = 'BUDGET_EXCEEDED_BY_THRESHOLD_FIRST_ALERT',
  BudgetExceededByThresholdSecondAlert = 'BUDGET_EXCEEDED_BY_THRESHOLD_SECOND_ALERT',
  BudgetInternallyApproved = 'BUDGET_INTERNALLY_APPROVED',
  ChangingProjectToProBono = 'CHANGING_PROJECT_TO_PRO_BONO',
  ExpenseAddedOnBrand = 'EXPENSE_ADDED_ON_BRAND',
  ExpenseAddedOnProject = 'EXPENSE_ADDED_ON_PROJECT',
  ExpenseItemApprovalRequested = 'EXPENSE_ITEM_APPROVAL_REQUESTED',
  ExpenseItemApproved = 'EXPENSE_ITEM_APPROVED',
  ExpenseItemUnapproved = 'EXPENSE_ITEM_UNAPPROVED',
  ExpenseUpdatedOnBrand = 'EXPENSE_UPDATED_ON_BRAND',
  ExpenseUpdatedOnProject = 'EXPENSE_UPDATED_ON_PROJECT',
  InvoiceReadyToBeSent = 'INVOICE_READY_TO_BE_SENT',
  NewExpensesToApprove = 'NEW_EXPENSES_TO_APPROVE',
  NewExpenseToApprove = 'NEW_EXPENSE_TO_APPROVE',
  NewRfisToApprove = 'NEW_RFIS_TO_APPROVE',
  NewRfiSubmitted = 'NEW_RFI_SUBMITTED',
  OwbiSpentTimeExceededGivenPercentageOfTotalTime = 'OWBI_SPENT_TIME_EXCEEDED_GIVEN_PERCENTAGE_OF_TOTAL_TIME',
  ProjectAssignedToUser = 'PROJECT_ASSIGNED_TO_USER',
  ProjectCanBeFinished = 'PROJECT_CAN_BE_FINISHED',
  ProjectCreatedFromPipedrive = 'PROJECT_CREATED_FROM_PIPEDRIVE',
  ProjectEndsInThresholdDays = 'PROJECT_ENDS_IN_THRESHOLD_DAYS',
  ProjectWithUnapprovedBudget = 'PROJECT_WITH_UNAPPROVED_BUDGET',
  QuoteStatusChanged = 'QUOTE_STATUS_CHANGED',
  RealExpensesExceededThresholdOnExpenseBudgetItemTypeOther = 'REAL_EXPENSES_EXCEEDED_THRESHOLD_ON_EXPENSE_BUDGET_ITEM_TYPE_OTHER',
  RealExpensesExceededThresholdOnExpenseBudgetItemTypeOtherFirstAlert = 'REAL_EXPENSES_EXCEEDED_THRESHOLD_ON_EXPENSE_BUDGET_ITEM_TYPE_OTHER_FIRST_ALERT',
  RealExpensesExceededThresholdOnExpenseBudgetItemTypeOtherSecondAlert = 'REAL_EXPENSES_EXCEEDED_THRESHOLD_ON_EXPENSE_BUDGET_ITEM_TYPE_OTHER_SECOND_ALERT',
  RealExpensesExceededTotalBudgetOnExpenseBudgetItem = 'REAL_EXPENSES_EXCEEDED_TOTAL_BUDGET_ON_EXPENSE_BUDGET_ITEM',
  RealExpensesExceededTotalBudgetOnExpenseBudgetItemFirstAlert = 'REAL_EXPENSES_EXCEEDED_TOTAL_BUDGET_ON_EXPENSE_BUDGET_ITEM_FIRST_ALERT',
  RealExpensesExceededTotalBudgetOnExpenseBudgetItemSecondAlert = 'REAL_EXPENSES_EXCEEDED_TOTAL_BUDGET_ON_EXPENSE_BUDGET_ITEM_SECOND_ALERT',
  SpentBudgetExceededByThresholdOnProjectWithUnapprovedBudget = 'SPENT_BUDGET_EXCEEDED_BY_THRESHOLD_ON_PROJECT_WITH_UNAPPROVED_BUDGET',
  SpentBudgetExceededByThresholdOnZeroBudgetProject = 'SPENT_BUDGET_EXCEEDED_BY_THRESHOLD_ON_ZERO_BUDGET_PROJECT',
  SpentBudgetExceededGivenPercentageOfTotalBudget = 'SPENT_BUDGET_EXCEEDED_GIVEN_PERCENTAGE_OF_TOTAL_BUDGET',
  SpentBudgetExceededGivenPercentageOfTotalBudgetFirstAlert = 'SPENT_BUDGET_EXCEEDED_GIVEN_PERCENTAGE_OF_TOTAL_BUDGET_FIRST_ALERT',
  SpentBudgetExceededGivenPercentageOfTotalBudgetSecondAlert = 'SPENT_BUDGET_EXCEEDED_GIVEN_PERCENTAGE_OF_TOTAL_BUDGET_SECOND_ALERT',
  TaskAssignedToUser = 'TASK_ASSIGNED_TO_USER',
  TaskAssignedToUserForWatcher = 'TASK_ASSIGNED_TO_USER_FOR_WATCHER',
  TaskAttachmentAdded = 'TASK_ATTACHMENT_ADDED',
  TaskAttachmentAddedForProjectManager = 'TASK_ATTACHMENT_ADDED_FOR_PROJECT_MANAGER',
  TaskAttachmentAddedForTaskAssignee = 'TASK_ATTACHMENT_ADDED_FOR_TASK_ASSIGNEE',
  TaskAttachmentAddedForTaskCreator = 'TASK_ATTACHMENT_ADDED_FOR_TASK_CREATOR',
  TaskAttachmentAddedForTaskWatcher = 'TASK_ATTACHMENT_ADDED_FOR_TASK_WATCHER',
  TaskCommentAdded = 'TASK_COMMENT_ADDED',
  TaskCommentAddedForProjectManager = 'TASK_COMMENT_ADDED_FOR_PROJECT_MANAGER',
  TaskCommentAddedForTaskAssignee = 'TASK_COMMENT_ADDED_FOR_TASK_ASSIGNEE',
  TaskCommentAddedForTaskCreator = 'TASK_COMMENT_ADDED_FOR_TASK_CREATOR',
  TaskCommentAddedForTaskWatcher = 'TASK_COMMENT_ADDED_FOR_TASK_WATCHER',
  TaskCommentMentionedUser = 'TASK_COMMENT_MENTIONED_USER',
  TaskCreatedFromClientUser = 'TASK_CREATED_FROM_CLIENT_USER',
  TaskDeadlineApproaching = 'TASK_DEADLINE_APPROACHING',
  TaskLinkCreated = 'TASK_LINK_CREATED',
  TaskLinkDeleted = 'TASK_LINK_DELETED',
  TaskMentionedUser = 'TASK_MENTIONED_USER',
  TaskPriorityChanged = 'TASK_PRIORITY_CHANGED',
  TaskPriorityChangedForProjectManager = 'TASK_PRIORITY_CHANGED_FOR_PROJECT_MANAGER',
  TaskPriorityChangedForTaskAssignee = 'TASK_PRIORITY_CHANGED_FOR_TASK_ASSIGNEE',
  TaskPriorityChangedForTaskCreator = 'TASK_PRIORITY_CHANGED_FOR_TASK_CREATOR',
  TaskPriorityChangedForTaskWatcher = 'TASK_PRIORITY_CHANGED_FOR_TASK_WATCHER',
  TaskSpentTimeExceededGivenPercentageOfTotalTime = 'TASK_SPENT_TIME_EXCEEDED_GIVEN_PERCENTAGE_OF_TOTAL_TIME',
  TaskStatusChanged = 'TASK_STATUS_CHANGED',
  TaskStatusChangedForProjectManager = 'TASK_STATUS_CHANGED_FOR_PROJECT_MANAGER',
  TaskStatusChangedForTaskAssignee = 'TASK_STATUS_CHANGED_FOR_TASK_ASSIGNEE',
  TaskStatusChangedForTaskCreator = 'TASK_STATUS_CHANGED_FOR_TASK_CREATOR',
  TaskStatusChangedForTaskWatcher = 'TASK_STATUS_CHANGED_FOR_TASK_WATCHER',
  TimerAutostop = 'TIMER_AUTOSTOP'
}

/**
 * OCR extracted expense data from an attachment file.
 * Used to prefill expense form on frontend.
 */
export type OcrExpenseData = {
  __typename?: 'OCRExpenseData';
  bank_account?: Maybe<Scalars['String']['output']>;
  bank_account_code?: Maybe<Scalars['String']['output']>;
  business_form?: Maybe<BusinessFormEnum>;
  city?: Maybe<Scalars['String']['output']>;
  constant_symbol?: Maybe<Scalars['String']['output']>;
  contractor_id?: Maybe<Scalars['ID']['output']>;
  country_id?: Maybe<Scalars['ID']['output']>;
  currency_id?: Maybe<Scalars['ID']['output']>;
  date_of_supply?: Maybe<Scalars['Date']['output']>;
  document_number?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['Date']['output']>;
  expense_items?: Maybe<Array<OcrExpenseItemData>>;
  for_approval?: Maybe<Scalars['Boolean']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  issue_date?: Maybe<Scalars['Date']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  registration_no?: Maybe<Scalars['String']['output']>;
  specific_symbol?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  swift?: Maybe<Scalars['String']['output']>;
  tax_no?: Maybe<Scalars['String']['output']>;
  total_amount_includes_vat?: Maybe<Scalars['Boolean']['output']>;
  total_amount_with_vat_in_currency?: Maybe<Scalars['BigInt']['output']>;
  type?: Maybe<ExpenseTypeEnum>;
  variable_symbol?: Maybe<Scalars['String']['output']>;
  vat_no?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type OcrExpenseItemData = {
  __typename?: 'OCRExpenseItemData';
  amount?: Maybe<Scalars['Float']['output']>;
  approved?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  vat_rate?: Maybe<Scalars['BigInt']['output']>;
};

/** Jednotliva polozka OI budget split pre Time Billing listing */
export type OiBudgetItemForTimeBilling = {
  __typename?: 'OIBudgetItemForTimeBilling';
  amount: Scalars['BigInt']['output'];
  budgetItem?: Maybe<BudgetItemForExpenseInterface>;
  budget_item_id: Scalars['ID']['output'];
  budget_item_type: BudgetItemTypeEnum;
  outgoingInvoice: OutgoingInvoice;
  outgoing_invoice_id: Scalars['ID']['output'];
};

export type OiBudgetItemsForTimeBillingPaginator = {
  __typename?: 'OIBudgetItemsForTimeBillingPaginator';
  data: Array<OiBudgetItemForTimeBilling>;
  paginatorInfo: PaginatorInfo;
};

export type OiBudgetItemsTimeBillingOrderByClause = {
  column: OiBudgetItemsTimeBillingOrderByColumn;
  order: SortOrder;
};

export enum OiBudgetItemsTimeBillingOrderByColumn {
  Amount = 'AMOUNT',
  BillingAddress = 'BILLING_ADDRESS',
  Brand = 'BRAND',
  BudgetItem = 'BUDGET_ITEM',
  DateOfSupply = 'DATE_OF_SUPPLY',
  Description = 'DESCRIPTION',
  DueDate = 'DUE_DATE',
  InternalNote = 'INTERNAL_NOTE',
  InvoiceNo = 'INVOICE_NO',
  IssueDate = 'ISSUE_DATE',
  LegalEntity = 'LEGAL_ENTITY',
  LockedTimeBilling = 'LOCKED_TIME_BILLING',
  Note = 'NOTE',
  PaidAt = 'PAID_AT',
  PaymentMethod = 'PAYMENT_METHOD',
  Project = 'PROJECT',
  TimeBilling = 'TIME_BILLING'
}

export type OiBudgetItemsTimeBillingQueryArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OiBudgetItemsTimeBillingOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OiBudgetItemsTimeBillingWhereConditions>;
};

export enum OiBudgetItemsTimeBillingWhereColumn {
  AmountFrom = 'AMOUNT_FROM',
  AmountTo = 'AMOUNT_TO',
  BrandId = 'BRAND_ID',
  BudgetItemId = 'BUDGET_ITEM_ID',
  BudgetItemType = 'BUDGET_ITEM_TYPE',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DueDate = 'DUE_DATE',
  HasTimeBilling = 'HAS_TIME_BILLING',
  IssueDate = 'ISSUE_DATE',
  OwnerId = 'OWNER_ID',
  PaidAt = 'PAID_AT',
  PaymentStatus = 'PAYMENT_STATUS',
  ProjectCategory = 'PROJECT_CATEGORY',
  ProjectId = 'PROJECT_ID',
  ProjectTimeBillingPlanId = 'PROJECT_TIME_BILLING_PLAN_ID',
  Type = 'TYPE',
  WorkspaceBankAccountId = 'WORKSPACE_BANK_ACCOUNT_ID',
  WorkspaceCompanyId = 'WORKSPACE_COMPANY_ID'
}

export type OiBudgetItemsTimeBillingWhereConditions = {
  AND?: InputMaybe<Array<OiBudgetItemsTimeBillingWhereConditions>>;
  OR?: InputMaybe<Array<OiBudgetItemsTimeBillingWhereConditions>>;
  column?: InputMaybe<OiBudgetItemsTimeBillingWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type OiProformaQueryArgs = {
  orderBy?: InputMaybe<Array<OutgoingProformaInvoiceOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OiProformaWhereConditions>;
};

export enum OiProformaWhereColumn {
  AmountFrom = 'AMOUNT_FROM',
  AmountTo = 'AMOUNT_TO',
  BrandId = 'BRAND_ID',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DueDate = 'DUE_DATE',
  IssueDate = 'ISSUE_DATE',
  IsExported = 'IS_EXPORTED',
  OwnerId = 'OWNER_ID',
  PaidAt = 'PAID_AT',
  PaymentStatus = 'PAYMENT_STATUS',
  WorkspaceBankAccountId = 'WORKSPACE_BANK_ACCOUNT_ID',
  WorkspaceCompanyId = 'WORKSPACE_COMPANY_ID'
}

export type OiProformaWhereConditions = {
  AND?: InputMaybe<Array<OiProformaWhereConditions>>;
  OR?: InputMaybe<Array<OiProformaWhereConditions>>;
  column?: InputMaybe<OiProformaWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type OiQueryArgs = {
  orderBy?: InputMaybe<Array<OutgoingInvoiceOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OiWhereConditions>;
};

export enum OiWhereColumn {
  AmountFrom = 'AMOUNT_FROM',
  AmountTo = 'AMOUNT_TO',
  BrandId = 'BRAND_ID',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DueDate = 'DUE_DATE',
  HasTimeBilling = 'HAS_TIME_BILLING',
  IssueDate = 'ISSUE_DATE',
  IsExported = 'IS_EXPORTED',
  OwnerId = 'OWNER_ID',
  PaidAt = 'PAID_AT',
  PaymentStatus = 'PAYMENT_STATUS',
  ProjectCategory = 'PROJECT_CATEGORY',
  ProjectId = 'PROJECT_ID',
  ProjectTimeBillingPlanId = 'PROJECT_TIME_BILLING_PLAN_ID',
  Type = 'TYPE',
  WorkspaceBankAccountId = 'WORKSPACE_BANK_ACCOUNT_ID',
  WorkspaceCompanyId = 'WORKSPACE_COMPANY_ID'
}

export type OiWhereConditions = {
  AND?: InputMaybe<Array<OiWhereConditions>>;
  OR?: InputMaybe<Array<OiWhereConditions>>;
  column?: InputMaybe<OiWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type Order = {
  __typename?: 'Order';
  brand: Brand;
  cloudUrl?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  date_of_order?: Maybe<Scalars['Date']['output']>;
  driveCloudUrl?: Maybe<Scalars['String']['output']>;
  files: Array<AssignableFile>;
  id: Scalars['ID']['output'];
  outgoingInvoices: Array<OutgoingInvoice>;
  pdfFiles: Array<AssignableFile>;
  projects?: Maybe<Array<Maybe<Project>>>;
  purchase_order_no?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  urls: MediaUrlList;
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export type OrderOrderByClause = {
  column: OrderOrderByColumnEnum;
  order: SortOrder;
};

export enum OrderOrderByColumnEnum {
  BrandName = 'BRAND_NAME',
  DateOfOrder = 'DATE_OF_ORDER',
  PurchaseOrderNo = 'PURCHASE_ORDER_NO'
}

/** A paginated list of Order items. */
export type OrderPaginator = {
  __typename?: 'OrderPaginator';
  /** A list of Order items. */
  data: Array<Order>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type OrderQueryArgs = {
  orderBy?: InputMaybe<Array<OrderOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OrdersWhereConditions>;
};

export type OrderSimple = {
  __typename?: 'OrderSimple';
  id: Scalars['ID']['output'];
  purchase_order_no?: Maybe<Scalars['String']['output']>;
};

export type OrdersSummary = {
  __typename?: 'OrdersSummary';
  orderIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export enum OrdersWhereColumn {
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  DateOfOrder = 'DATE_OF_ORDER',
  ProjectId = 'PROJECT_ID'
}

export type OrdersWhereConditions = {
  AND?: InputMaybe<Array<OrdersWhereConditions>>;
  OR?: InputMaybe<Array<OrdersWhereConditions>>;
  column?: InputMaybe<OrdersWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type OtherDocument = Document & {
  __typename?: 'OtherDocument';
  brands?: Maybe<Array<Maybe<Brand>>>;
  clients?: Maybe<Array<Maybe<Client>>>;
  cloudUrl?: Maybe<Scalars['String']['output']>;
  contractors?: Maybe<Array<Maybe<Contractor>>>;
  created_at: Scalars['DateTime']['output'];
  driveCloudUrl?: Maybe<Scalars['String']['output']>;
  files: Array<AssignableFile>;
  id: Scalars['ID']['output'];
  pdfFiles: Array<AssignableFile>;
  projects?: Maybe<Array<Maybe<Project>>>;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  urls: MediaUrlList;
};

export type OtherDocumentOrderByClause = {
  column: OtherDocumentOrderByColumnEnum;
  order: SortOrder;
};

export enum OtherDocumentOrderByColumnEnum {
  Title = 'TITLE'
}

/** A paginated list of OtherDocument items. */
export type OtherDocumentPaginator = {
  __typename?: 'OtherDocumentPaginator';
  /** A list of OtherDocument items. */
  data: Array<OtherDocument>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type OtherDocumentQueryArgs = {
  orderBy?: InputMaybe<Array<OtherDocumentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<OtherDocumentsWhereConditions>;
};

export type OtherDocumentsSummary = {
  __typename?: 'OtherDocumentsSummary';
  otherDocumentIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export enum OtherDocumentsWhereColumn {
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  ContractorId = 'CONTRACTOR_ID',
  ProjectId = 'PROJECT_ID'
}

export type OtherDocumentsWhereConditions = {
  AND?: InputMaybe<Array<OtherDocumentsWhereConditions>>;
  OR?: InputMaybe<Array<OtherDocumentsWhereConditions>>;
  column?: InputMaybe<OtherDocumentsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type OtherPeopleTracked = {
  __typename?: 'OtherPeopleTracked';
  time_tracking_work_type_id: Scalars['ID']['output'];
  tracked_time: Scalars['BigInt']['output'];
  user: User;
};

export type OurWorkBudgetCategory = BudgetCategory & {
  __typename?: 'OurWorkBudgetCategory';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  new_budget_creation_enabled: Scalars['Boolean']['output'];
  shortcut: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type OurWorkBudgetItem = BudgetItemForExpenseInterface & BudgetItemInterface & {
  __typename?: 'OurWorkBudgetItem';
  availableTimeTrackingWorkTypes?: Maybe<Array<TimeTrackingRate>>;
  budget_positions: Array<BudgetPosition>;
  category: OurWorkBudgetCategory;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  creditAccount: CreditAccount;
  /** @deprecated No longer supported */
  currentWorkInProgressItemStat?: Maybe<WorkInProgressItemStat>;
  deadline?: Maybe<Scalars['Date']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  /** Empty unless requested for deletion. */
  deletion_blockers: Array<BudgetItemDeletionBlockerEnum>;
  expenseStats: Array<OurWorkBudgetItemExpenseStats>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoiceStats: Array<OurWorkBudgetItemInvoiceStats>;
  item_code?: Maybe<Scalars['String']['output']>;
  lastWorkInProgressItemStat?: Maybe<WorkInProgressItemStat>;
  note?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  outgoingProformaInvoiceStats: Array<OurWorkBudgetItemProformaStats>;
  payment_status: ExpenseInvoiceStatusEnum;
  plannedExpenses: Array<BudgetItemPlannedExpense>;
  prepaymentStats: Array<OurWorkBudgetItemPrepaymentStats>;
  project: Project;
  requested_for_deletion_at?: Maybe<Scalars['DateTime']['output']>;
  stats: OurWorkBudgetItemStats;
  tasks: Array<Task>;
  timeTrackingSettings: TimeTrackingBudgetItem;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
  vat_percent_informative?: Maybe<Scalars['BigInt']['output']>;
};

export type OurWorkBudgetItemExpenseStats = {
  __typename?: 'OurWorkBudgetItemExpenseStats';
  amount: Scalars['BigInt']['output'];
  expense: Expense;
  expense_item_amount: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  position?: Maybe<TimeTrackingWorkType>;
  report_date?: Maybe<Scalars['Date']['output']>;
  task?: Maybe<Task>;
  tracked_time?: Maybe<Scalars['BigInt']['output']>;
};

export type OurWorkBudgetItemForPlanovac = {
  __typename?: 'OurWorkBudgetItemForPlanovac';
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  timeTrackingSettings: TimeTrackingBudgetItemForPlanovac;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type OurWorkBudgetItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  our_work_budget_category_id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  total_budget: Scalars['BigInt']['input'];
};

export type OurWorkBudgetItemInvoiceStats = {
  __typename?: 'OurWorkBudgetItemInvoiceStats';
  credit: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  ourWorkBudgetItem: OurWorkBudgetItem;
  outgoingInvoice: OutgoingInvoice;
};

export type OurWorkBudgetItemLimited = {
  __typename?: 'OurWorkBudgetItemLimited';
  availablepositions: Array<TimeTrackingWorkType>;
  category_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type OurWorkBudgetItemOverview = BudgetItemInterface & {
  __typename?: 'OurWorkBudgetItemOverview';
  budget_positions: Array<BudgetPosition>;
  category: OurWorkBudgetCategory;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at: Scalars['DateTime']['output'];
  creditAccount: CreditAccount;
  /** @deprecated No longer supported */
  currentWorkInProgressItemStat?: Maybe<WorkInProgressItemStat>;
  deadline?: Maybe<Scalars['Date']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  /** Empty unless requested for deletion. */
  deletion_blockers: Array<BudgetItemDeletionBlockerEnum>;
  done_task_count: Scalars['Int']['output'];
  expenseStats: Array<OurWorkBudgetItemExpenseStats>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoiceStats: Array<OurWorkBudgetItemInvoiceStats>;
  item_code?: Maybe<Scalars['String']['output']>;
  lastWorkInProgressItemStat?: Maybe<WorkInProgressItemStat>;
  note?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  plannedExpenses: Array<BudgetItemPlannedExpense>;
  prepaymentStats: Array<OurWorkBudgetItemPrepaymentStats>;
  project: Project;
  requested_for_deletion_at?: Maybe<Scalars['DateTime']['output']>;
  stats: OurWorkBudgetItemStats;
  task_count: Scalars['Int']['output'];
  tasks: Array<Task>;
  timeTrackingSettings: TimeTrackingBudgetItem;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type OurWorkBudgetItemPrepaymentStats = {
  __typename?: 'OurWorkBudgetItemPrepaymentStats';
  brandCreditAccount: BrandCreditAccount;
  credit: Scalars['BigInt']['output'];
  credit_account_operation_id: Scalars['ID']['output'];
  date: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  ourWorkBudgetItem: OurWorkBudgetItem;
};

export type OurWorkBudgetItemProformaStats = {
  __typename?: 'OurWorkBudgetItemProformaStats';
  amount: Scalars['BigInt']['output'];
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  invoice_no: Scalars['String']['output'];
};

export type OurWorkBudgetItemSimple = {
  __typename?: 'OurWorkBudgetItemSimple';
  category: OurWorkBudgetCategory;
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  item_code?: Maybe<Scalars['String']['output']>;
  project?: Maybe<ProjectSimple>;
  stats: OurWorkBudgetItemStats;
  tasks: Array<TaskSimple>;
  timeTrackingSettings: TimeTrackingBudgetItem;
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type OurWorkBudgetItemStats = CreditStats & OurWorkStatsInterface & {
  __typename?: 'OurWorkBudgetItemStats';
  budget_exceeded: Scalars['BigInt']['output'];
  credit: Scalars['BigInt']['output'];
  credit_balance: Scalars['BigInt']['output'];
  credit_direct: Scalars['BigInt']['output'];
  credit_from_prepayments: Scalars['BigInt']['output'];
  efficiency_percent: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  invoiceable: Scalars['BigInt']['output'];
  invoiced_percent: Scalars['BigInt']['output'];
  net_margin_percent: Scalars['BigInt']['output'];
  net_profit: Scalars['BigInt']['output'];
  over_invoiced: Scalars['BigInt']['output'];
  profit: Scalars['BigInt']['output'];
  profit_percent: Scalars['BigInt']['output'];
  remaining_budget: Scalars['BigInt']['output'];
  remaining_time: Scalars['Float']['output'];
  spent_budget: Scalars['BigInt']['output'];
  spent_budget_percent: Scalars['BigInt']['output'];
  spent_time: Scalars['Float']['output'];
  total_budget: Scalars['BigInt']['output'];
  total_time: Scalars['Float']['output'];
  uninvoiced: Scalars['BigInt']['output'];
};

export type OurWorkBudgetItemWithRevenue = {
  __typename?: 'OurWorkBudgetItemWithRevenue';
  billings_for_date_range?: Maybe<Scalars['BigInt']['output']>;
  ourWorkBudgetItem: OurWorkBudgetItem;
  revenue_for_date_range?: Maybe<Scalars['BigInt']['output']>;
};

export type OurWorkBudgetSplitInput = {
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  amount_in_percent?: InputMaybe<Scalars['BigInt']['input']>;
  budget_positions?: InputMaybe<Array<BudgetPositionsInput>>;
  our_work_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
};

export type OurWorkOverviewBudgetItem = {
  __typename?: 'OurWorkOverviewBudgetItem';
  budgetItems: Array<OurWorkBudgetItemOverview>;
  budget_category_id: Scalars['ID']['output'];
  budget_exceeded: Scalars['BigInt']['output'];
  credit: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profit: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
};

export type OurWorkStatsInterface = {
  budget_exceeded: Scalars['BigInt']['output'];
  remaining_budget: Scalars['BigInt']['output'];
  remaining_time: Scalars['Float']['output'];
  spent_budget: Scalars['BigInt']['output'];
  spent_budget_percent: Scalars['BigInt']['output'];
  spent_time: Scalars['Float']['output'];
  total_budget: Scalars['BigInt']['output'];
  total_time: Scalars['Float']['output'];
};

export type OurWorkStructuredBudgetItem = {
  __typename?: 'OurWorkStructuredBudgetItem';
  budgetItems: Array<OurWorkBudgetItem>;
  budget_category_id: Scalars['ID']['output'];
  budget_exceeded: Scalars['BigInt']['output'];
  credit: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profit: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
};

export type OurWorkTopProject = {
  __typename?: 'OurWorkTopProject';
  value: Scalars['BigInt']['output'];
};

export type OutgoingInvoice = {
  __typename?: 'OutgoingInvoice';
  abraflexi_exported?: Maybe<Scalars['Boolean']['output']>;
  accountMoves?: Maybe<Array<BankAccountMoveDocument>>;
  billingEntity: BillingEntity;
  brands: Array<Brand>;
  budget_positions: Array<BudgetPosition>;
  city: Scalars['String']['output'];
  client: Client;
  contact?: Maybe<Contact>;
  created_at: Scalars['DateTime']['output'];
  credit_note_outgoing_invoice_id?: Maybe<Scalars['ID']['output']>;
  currency: Currency;
  date_of_supply: Scalars['Date']['output'];
  /** Export history for this outgoing invoice */
  documentExports: Array<DocumentExport>;
  due_date: Scalars['Date']['output'];
  emailLogs: Array<OutgoingInvoiceEmailLog>;
  exchange_rate: Scalars['BigInt']['output'];
  exchange_rate_source: ExchangeRateSource;
  expenseBudgetSplits: Array<OutgoingInvoiceExpenseBudgetSplitItem>;
  filesToAttach: Array<AssignableFile>;
  has_proforma_payments: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  internal_note?: Maybe<Scalars['String']['output']>;
  invoiceItems: Array<OutgoingInvoiceItem>;
  invoicePaymentMethod?: Maybe<InvoicePaymentMethod>;
  invoicePdf?: Maybe<MediaUrlList>;
  invoiceProofOfPayments: Array<AttachedProofOfPaymentPivot>;
  invoice_no: Scalars['String']['output'];
  invoice_order_sequence_id: Scalars['ID']['output'];
  issue_date: Scalars['Date']['output'];
  legal_name: Scalars['String']['output'];
  modelLock?: Maybe<ModelLock>;
  note?: Maybe<Scalars['String']['output']>;
  old_invoice_alert_while_editing: Scalars['Boolean']['output'];
  orders: Array<Order>;
  ourWorkBudgetSplits: Array<OutgoingInvoiceOurWorkBudgetSplitItem>;
  owner: User;
  paid_at?: Maybe<Scalars['Date']['output']>;
  payment_status: PaymentStatusEnum;
  prepaymentSplits: Array<OutgoingInvoicePrepaymentSplitItem>;
  proformaInvoicesPivot: Array<AttachedOutgoingProformaInvoicePivot>;
  projectTimeBilling?: Maybe<ProjectTimeBilling>;
  projects: Array<Project>;
  registration_no?: Maybe<Scalars['String']['output']>;
  relatesToOutgoingProformaInvoice?: Maybe<OutgoingProformaInvoice>;
  request_for_invoicing_created_date?: Maybe<Scalars['Date']['output']>;
  request_for_invoicing_submit_date?: Maybe<Scalars['Date']['output']>;
  sequence?: Maybe<Sequence>;
  show_billing_accounting: Scalars['Boolean']['output'];
  show_unit_price: Scalars['Boolean']['output'];
  stats: OutgoingInvoiceStats;
  street: Scalars['String']['output'];
  summaryInvoicesForProofOfPayment?: Maybe<Array<OutgoingInvoice>>;
  tax_no?: Maybe<Scalars['String']['output']>;
  teams: Array<Team>;
  text_on_invoice?: Maybe<Scalars['String']['output']>;
  timeMaterialsInvoiceData?: Maybe<TimeMaterialsInvoiceData>;
  total_in_words?: Maybe<Scalars['String']['output']>;
  type: OutgoingInvoiceTypeEnum;
  updated_at: Scalars['DateTime']['output'];
  vat_no?: Maybe<Scalars['String']['output']>;
  vat_percent_informative?: Maybe<Scalars['BigInt']['output']>;
  vat_reverse_charge: Scalars['Boolean']['output'];
  workspace_bank_account_id: Scalars['ID']['output'];
  workspace_company_id: Scalars['ID']['output'];
  workspace_exchange_rate: Scalars['BigInt']['output'];
  workspace_exchange_rate_source: ExchangeRateSource;
  xero_exported?: Maybe<Scalars['Boolean']['output']>;
  zip: Scalars['String']['output'];
};


export type OutgoingInvoiceEmailLogsArgs = {
  type?: InputMaybe<EmailLogTypeEnum>;
};

export type OutgoingInvoiceBudgetSplitItem = {
  amount: Scalars['BigInt']['output'];
  created_at: Scalars['DateTime']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type OutgoingInvoiceEmailLog = {
  __typename?: 'OutgoingInvoiceEmailLog';
  accepted_delivery: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  recipientLog?: Maybe<Array<RecipientLog>>;
  recipients: Array<Recipient>;
  sent_at: Scalars['DateTime']['output'];
  type: Scalars['String']['output'];
};

export type OutgoingInvoiceExpenseBudgetSplitItem = OutgoingInvoiceBudgetSplitItem & {
  __typename?: 'OutgoingInvoiceExpenseBudgetSplitItem';
  amount: Scalars['BigInt']['output'];
  created_at: Scalars['DateTime']['output'];
  expense_budget_item_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type OutgoingInvoiceItem = {
  __typename?: 'OutgoingInvoiceItem';
  accounting_account_id?: Maybe<Scalars['ID']['output']>;
  accounting_centre_id?: Maybe<Scalars['ID']['output']>;
  amount_in_currency: Scalars['BigInt']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  quantity: Scalars['Float']['output'];
  tag_ids?: Maybe<Array<Scalars['ID']['output']>>;
  unit_price?: Maybe<Scalars['BigInt']['output']>;
  vat_in_currency: Scalars['BigInt']['output'];
  vat_percent_informative?: Maybe<Scalars['BigInt']['output']>;
};

export type OutgoingInvoiceOrderByClause = {
  column: OutgoingInvoiceOrderByColumnEnum;
  order: SortOrder;
};

export enum OutgoingInvoiceOrderByColumnEnum {
  Amount = 'AMOUNT',
  AmountWithVat = 'AMOUNT_WITH_VAT',
  BrandName = 'BRAND_NAME',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DueDate = 'DUE_DATE',
  InvoiceNo = 'INVOICE_NO',
  IssueDate = 'ISSUE_DATE',
  PaymentStatus = 'PAYMENT_STATUS'
}

export type OutgoingInvoiceOurWorkBudgetSplitItem = OutgoingInvoiceBudgetSplitItem & {
  __typename?: 'OutgoingInvoiceOurWorkBudgetSplitItem';
  amount: Scalars['BigInt']['output'];
  amount_in_percent?: Maybe<Scalars['BigInt']['output']>;
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  our_work_budget_item_id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

/** A paginated list of OutgoingInvoice items. */
export type OutgoingInvoicePaginator = {
  __typename?: 'OutgoingInvoicePaginator';
  /** A list of OutgoingInvoice items. */
  data: Array<OutgoingInvoice>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type OutgoingInvoicePrepaymentSplitItem = {
  __typename?: 'OutgoingInvoicePrepaymentSplitItem';
  amount: Scalars['BigInt']['output'];
  amount_left: Scalars['BigInt']['output'];
  brandCreditAccount?: Maybe<BrandCreditAccount>;
  brand_credit_account_id: Scalars['ID']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type OutgoingInvoiceStats = {
  __typename?: 'OutgoingInvoiceStats';
  billing_amount: Scalars['BigInt']['output'];
  billing_amount_in_currency: Scalars['BigInt']['output'];
  billing_amount_vat: Scalars['BigInt']['output'];
  billing_amount_vat_in_currency: Scalars['BigInt']['output'];
  billing_amount_with_vat: Scalars['BigInt']['output'];
  billing_amount_with_vat_in_currency: Scalars['BigInt']['output'];
  budget_splits_amount: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  invoice_exchange_rate: Scalars['BigInt']['output'];
  prepayment_splits_amount: Scalars['BigInt']['output'];
  total_amount: Scalars['BigInt']['output'];
  total_amount_by_workspace_rate: Scalars['BigInt']['output'];
  total_amount_in_currency: Scalars['BigInt']['output'];
  total_amount_in_currency_to_pay: Scalars['BigInt']['output'];
  total_amount_with_vat: Scalars['BigInt']['output'];
  total_amount_with_vat_by_workspace_rate: Scalars['BigInt']['output'];
  total_amount_with_vat_in_currency: Scalars['BigInt']['output'];
  total_amount_with_vat_in_currency_to_pay: Scalars['BigInt']['output'];
  total_amount_with_vat_in_currency_to_pay_from_proforma_payments: Scalars['BigInt']['output'];
  total_vat: Scalars['BigInt']['output'];
  total_vat_by_workspace_rate: Scalars['BigInt']['output'];
  total_vat_in_currency: Scalars['BigInt']['output'];
  total_vat_in_currency_to_pay_from_proforma_payments: Scalars['BigInt']['output'];
  vat_percent_informative?: Maybe<Scalars['BigInt']['output']>;
  workspace_exchange_rate: Scalars['BigInt']['output'];
};

export enum OutgoingInvoiceTypeEnum {
  CreditNote = 'CREDIT_NOTE',
  Invoice = 'INVOICE',
  ProformaPayment = 'PROFORMA_PAYMENT'
}

export type OutgoingInvoicesSummary = {
  __typename?: 'OutgoingInvoicesSummary';
  billing_amount: Scalars['BigInt']['output'];
  billing_amount_vat: Scalars['BigInt']['output'];
  billing_amount_with_vat: Scalars['BigInt']['output'];
  invoices: Scalars['BigInt']['output'];
  outgoingInvoiceIds: Array<Scalars['ID']['output']>;
  outgoingInvoiceInvoiceMediaIds: Array<Scalars['ID']['output']>;
  overdue: Scalars['BigInt']['output'];
  overdue_by_31_to_90_days: Scalars['BigInt']['output'];
  overdue_by_31_to_90_days_vat: Scalars['BigInt']['output'];
  overdue_by_31_to_90_days_without_vat: Scalars['BigInt']['output'];
  overdue_by_91_to_365_days: Scalars['BigInt']['output'];
  overdue_by_91_to_365_days_vat: Scalars['BigInt']['output'];
  overdue_by_91_to_365_days_without_vat: Scalars['BigInt']['output'];
  overdue_by_less_than_30_days: Scalars['BigInt']['output'];
  overdue_by_less_than_30_days_vat: Scalars['BigInt']['output'];
  overdue_by_less_than_30_days_without_vat: Scalars['BigInt']['output'];
  overdue_by_more_than_365_days: Scalars['BigInt']['output'];
  overdue_by_more_than_365_days_vat: Scalars['BigInt']['output'];
  overdue_by_more_than_365_days_without_vat: Scalars['BigInt']['output'];
  overdue_vat: Scalars['BigInt']['output'];
  overdue_without_vat: Scalars['BigInt']['output'];
  paid_amount: Scalars['BigInt']['output'];
  payments_due: Scalars['BigInt']['output'];
  payments_due_vat: Scalars['BigInt']['output'];
  payments_due_without_vat: Scalars['BigInt']['output'];
  total_amount: Scalars['BigInt']['output'];
  total_amount_with_vat: Scalars['BigInt']['output'];
  total_vat: Scalars['BigInt']['output'];
  unpaid_amount: Scalars['BigInt']['output'];
};

export type OutgoingProformaInvoice = {
  __typename?: 'OutgoingProformaInvoice';
  abraflexi_exported?: Maybe<Scalars['Boolean']['output']>;
  accountMoves?: Maybe<Array<BankAccountMoveDocument>>;
  billingEntity: BillingEntity;
  brands: Array<Brand>;
  budget_positions: Array<BudgetPosition>;
  city: Scalars['String']['output'];
  client: Client;
  contact?: Maybe<Contact>;
  created_at: Scalars['DateTime']['output'];
  currency: Currency;
  /** Export history for this outgoing proforma invoice */
  documentExports: Array<DocumentExport>;
  due_date: Scalars['Date']['output'];
  emailLogs: Array<OutgoingInvoiceEmailLog>;
  exchange_rate: Scalars['BigInt']['output'];
  exchange_rate_source: ExchangeRateSource;
  expenseBudgetSplits?: Maybe<Array<RequestForInvoicingExpenseBudgetSplitItem>>;
  filesToAttach: Array<AssignableFile>;
  id: Scalars['ID']['output'];
  internal_note?: Maybe<Scalars['String']['output']>;
  invoiceItems: Array<OutgoingInvoiceItem>;
  invoicePaymentMethod?: Maybe<InvoicePaymentMethod>;
  invoicePdf?: Maybe<MediaUrlList>;
  invoice_no: Scalars['String']['output'];
  invoice_order_sequence_id: Scalars['ID']['output'];
  issue_date: Scalars['Date']['output'];
  legal_name: Scalars['String']['output'];
  modelLock?: Maybe<ModelLock>;
  note?: Maybe<Scalars['String']['output']>;
  ourWorkBudgetSplits?: Maybe<Array<RequestForInvoicingOurWorkBudgetSplitItem>>;
  owner: User;
  paid_at?: Maybe<Scalars['Date']['output']>;
  payment_status: PaymentStatusEnum;
  prepaymentSplits?: Maybe<Array<RequestForInvoicingPrepaymentSplitItem>>;
  projects: Array<Project>;
  proofOfPayments?: Maybe<Array<OutgoingInvoice>>;
  registration_no?: Maybe<Scalars['String']['output']>;
  request_for_invoicing_created_date?: Maybe<Scalars['Date']['output']>;
  request_for_invoicing_submit_date?: Maybe<Scalars['Date']['output']>;
  show_billing_accounting: Scalars['Boolean']['output'];
  show_unit_price: Scalars['Boolean']['output'];
  stats: OutgoingProformaInvoiceStats;
  street: Scalars['String']['output'];
  summaryInvoices?: Maybe<Array<OutgoingInvoice>>;
  tax_no?: Maybe<Scalars['String']['output']>;
  teams: Array<Team>;
  text_on_invoice?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  vat_no?: Maybe<Scalars['String']['output']>;
  vat_percent_informative?: Maybe<Scalars['BigInt']['output']>;
  vat_reverse_charge: Scalars['Boolean']['output'];
  workspace_bank_account_id: Scalars['ID']['output'];
  workspace_company_id: Scalars['ID']['output'];
  workspace_exchange_rate: Scalars['BigInt']['output'];
  workspace_exchange_rate_source: ExchangeRateSource;
  zip: Scalars['String']['output'];
};


export type OutgoingProformaInvoiceEmailLogsArgs = {
  type?: InputMaybe<EmailLogTypeEnum>;
};

export type OutgoingProformaInvoiceOrderByClause = {
  column: OutgoingProformaInvoiceOrderByColumnEnum;
  order: SortOrder;
};

export enum OutgoingProformaInvoiceOrderByColumnEnum {
  Amount = 'AMOUNT',
  AmountWithVat = 'AMOUNT_WITH_VAT',
  BrandName = 'BRAND_NAME',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DueDate = 'DUE_DATE',
  InvoiceNo = 'INVOICE_NO',
  IssueDate = 'ISSUE_DATE',
  PaymentStatus = 'PAYMENT_STATUS',
  UnusedAmount = 'UNUSED_AMOUNT',
  UnusedAmountInCurrency = 'UNUSED_AMOUNT_IN_CURRENCY'
}

/** A paginated list of OutgoingProformaInvoice items. */
export type OutgoingProformaInvoicePaginator = {
  __typename?: 'OutgoingProformaInvoicePaginator';
  /** A list of OutgoingProformaInvoice items. */
  data: Array<OutgoingProformaInvoice>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type OutgoingProformaInvoiceStats = {
  __typename?: 'OutgoingProformaInvoiceStats';
  id: Scalars['ID']['output'];
  total_amount: Scalars['BigInt']['output'];
  total_amount_in_currency: Scalars['BigInt']['output'];
  total_amount_with_vat: Scalars['BigInt']['output'];
  total_amount_with_vat_in_currency: Scalars['BigInt']['output'];
  total_vat: Scalars['BigInt']['output'];
  total_vat_in_currency: Scalars['BigInt']['output'];
  unused_amount: Scalars['BigInt']['output'];
  unused_amount_in_currency: Scalars['BigInt']['output'];
  vat_percent_informative?: Maybe<Scalars['BigInt']['output']>;
  workspace_exchange_rate: Scalars['BigInt']['output'];
};

export type OutgoingProformaInvoicesSummary = {
  __typename?: 'OutgoingProformaInvoicesSummary';
  invoices: Scalars['BigInt']['output'];
  outgoingInvoiceIds: Array<Scalars['ID']['output']>;
  outgoingInvoiceInvoiceMediaIds: Array<Scalars['ID']['output']>;
  overdue_by_31_to_90_days: Scalars['BigInt']['output'];
  overdue_by_91_to_365_days: Scalars['BigInt']['output'];
  overdue_by_less_than_30_days: Scalars['BigInt']['output'];
  overdue_by_more_than_365_days: Scalars['BigInt']['output'];
  payments_due: Scalars['BigInt']['output'];
  total_amount: Scalars['BigInt']['output'];
  total_amount_with_vat: Scalars['BigInt']['output'];
};

/** Information about pagination using a Relay style cursor connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Number of nodes in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** The cursor to continue paginating forwards. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** The cursor to continue paginating backwards. */
  startCursor?: Maybe<Scalars['String']['output']>;
  /** Total number of nodes in the paginated connection. */
  total: Scalars['Int']['output'];
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
};

export enum PaymentOrderProviderEnum {
  Abo = 'ABO',
  AboStandard = 'ABO_STANDARD',
  SepaIso = 'SEPA_ISO'
}

export type PaymentSettings = {
  __typename?: 'PaymentSettings';
  default_payment_due?: Maybe<Scalars['String']['output']>;
  domestic_payment_order_provider?: Maybe<PaymentOrderProviderEnum>;
  foreign_payment_order_provider?: Maybe<PaymentOrderProviderEnum>;
};

export enum PaymentStatusEnum {
  NotPaid = 'NOT_PAID',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID'
}

export type PaymentType = {
  __typename?: 'PaymentType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  system_name?: Maybe<ExpensePaymentTypeEnum>;
};

export type PeriodSummary = {
  __typename?: 'PeriodSummary';
  is_period_closed: Scalars['Boolean']['output'];
  is_period_locked: Scalars['Boolean']['output'];
  is_previous_period_closed?: Maybe<Scalars['Boolean']['output']>;
  is_previous_period_locked?: Maybe<Scalars['Boolean']['output']>;
  profit_estimate: Scalars['BigInt']['output'];
  profit_estimate_billable: Scalars['BigInt']['output'];
  progress_change: Scalars['BigInt']['output'];
  progress_change_billable: Scalars['BigInt']['output'];
  work_spent: Scalars['BigInt']['output'];
};

export type PermissionList = {
  __typename?: 'PermissionList';
  assignableFile_create: Scalars['Boolean']['output'];
  assignableFile_delete_all: Scalars['Boolean']['output'];
  assignableFile_delete_own: Scalars['Boolean']['output'];
  bank_read_all: Scalars['Boolean']['output'];
  billingPlan_create: Scalars['Boolean']['output'];
  billingPlan_listing: Scalars['Boolean']['output'];
  billingPlan_update: Scalars['Boolean']['output'];
  brandCreditAccount_create: Scalars['Boolean']['output'];
  brandCreditAccount_delete_all: Scalars['Boolean']['output'];
  brandCreditAccount_delete_own: Scalars['Boolean']['output'];
  brandCreditAccount_delete_team: Scalars['Boolean']['output'];
  brandCreditAccount_read_all: Scalars['Boolean']['output'];
  brandCreditAccount_read_own: Scalars['Boolean']['output'];
  brandCreditAccount_read_team: Scalars['Boolean']['output'];
  brandCreditAccount_setBudgetCategories: Scalars['Boolean']['output'];
  brandCreditAccount_update_all: Scalars['Boolean']['output'];
  brandCreditAccount_update_own: Scalars['Boolean']['output'];
  brandCreditAccount_update_team: Scalars['Boolean']['output'];
  brand_archive: Scalars['Boolean']['output'];
  brand_create: Scalars['Boolean']['output'];
  brand_delete: Scalars['Boolean']['output'];
  brand_read: Scalars['Boolean']['output'];
  brand_update: Scalars['Boolean']['output'];
  brand_updateManagers: Scalars['Boolean']['output'];
  budget_read_all: Scalars['Boolean']['output'];
  budget_read_own: Scalars['Boolean']['output'];
  budget_read_team: Scalars['Boolean']['output'];
  client_create: Scalars['Boolean']['output'];
  client_delete: Scalars['Boolean']['output'];
  client_read: Scalars['Boolean']['output'];
  client_update: Scalars['Boolean']['output'];
  client_updateManagers: Scalars['Boolean']['output'];
  contract_create: Scalars['Boolean']['output'];
  contract_delete: Scalars['Boolean']['output'];
  contract_read: Scalars['Boolean']['output'];
  contract_update: Scalars['Boolean']['output'];
  contractor_create: Scalars['Boolean']['output'];
  contractor_delete: Scalars['Boolean']['output'];
  contractor_read: Scalars['Boolean']['output'];
  contractor_update: Scalars['Boolean']['output'];
  credit_prepayment: Scalars['Boolean']['output'];
  credit_transfer_betweenTeams: Scalars['Boolean']['output'];
  credit_transfer_fromBrandCreditAccount: Scalars['Boolean']['output'];
  credit_transfer_fromBudgetItem: Scalars['Boolean']['output'];
  credit_transfer_withDate: Scalars['Boolean']['output'];
  expense_accessAccountingAttributes: Scalars['Boolean']['output'];
  expense_accessImported: Scalars['Boolean']['output'];
  expense_approve: Scalars['Boolean']['output'];
  expense_canApproveBudgetItem: Scalars['Boolean']['output'];
  expense_create: Scalars['Boolean']['output'];
  expense_deleteFiles: Scalars['Boolean']['output'];
  expense_delete_all: Scalars['Boolean']['output'];
  expense_delete_own: Scalars['Boolean']['output'];
  expense_delete_team: Scalars['Boolean']['output'];
  expense_markAsPaid: Scalars['Boolean']['output'];
  expense_modelLock: Scalars['Boolean']['output'];
  expense_read_all: Scalars['Boolean']['output'];
  expense_read_excludeRestrictedTeams: Scalars['Boolean']['output'];
  expense_read_own: Scalars['Boolean']['output'];
  expense_read_team: Scalars['Boolean']['output'];
  expense_update_all: Scalars['Boolean']['output'];
  expense_update_own: Scalars['Boolean']['output'];
  expense_update_team: Scalars['Boolean']['output'];
  integration_budgetovac: Scalars['Boolean']['output'];
  integration_forecasting: Scalars['Boolean']['output'];
  notificationSetting_query: Scalars['Boolean']['output'];
  notificationSetting_update: Scalars['Boolean']['output'];
  order_create: Scalars['Boolean']['output'];
  order_delete: Scalars['Boolean']['output'];
  order_read: Scalars['Boolean']['output'];
  order_update: Scalars['Boolean']['output'];
  otherDocument_create: Scalars['Boolean']['output'];
  otherDocument_delete: Scalars['Boolean']['output'];
  otherDocument_read: Scalars['Boolean']['output'];
  otherDocument_update: Scalars['Boolean']['output'];
  outgoingInvoice_accessAccountingAttributes: Scalars['Boolean']['output'];
  outgoingInvoice_create: Scalars['Boolean']['output'];
  outgoingInvoice_delete_all: Scalars['Boolean']['output'];
  outgoingInvoice_delete_own: Scalars['Boolean']['output'];
  outgoingInvoice_delete_team: Scalars['Boolean']['output'];
  outgoingInvoice_markAsPaid: Scalars['Boolean']['output'];
  outgoingInvoice_modelLock: Scalars['Boolean']['output'];
  outgoingInvoice_read_all: Scalars['Boolean']['output'];
  outgoingInvoice_read_own: Scalars['Boolean']['output'];
  outgoingInvoice_read_team: Scalars['Boolean']['output'];
  outgoingInvoice_sendToClient: Scalars['Boolean']['output'];
  outgoingInvoice_updateInvoiceNumber: Scalars['Boolean']['output'];
  outgoingInvoice_update_all: Scalars['Boolean']['output'];
  outgoingInvoice_update_own: Scalars['Boolean']['output'];
  outgoingInvoice_update_team: Scalars['Boolean']['output'];
  planning_complete_all: Scalars['Boolean']['output'];
  planning_complete_own: Scalars['Boolean']['output'];
  planning_create_all: Scalars['Boolean']['output'];
  planning_create_own: Scalars['Boolean']['output'];
  planning_delete_all: Scalars['Boolean']['output'];
  planning_delete_own: Scalars['Boolean']['output'];
  planning_play_own: Scalars['Boolean']['output'];
  planning_read_all: Scalars['Boolean']['output'];
  planning_read_own: Scalars['Boolean']['output'];
  planning_show_daily_capacity: Scalars['Boolean']['output'];
  planning_update_all: Scalars['Boolean']['output'];
  planning_update_own: Scalars['Boolean']['output'];
  profitLossReport_query_all: Scalars['Boolean']['output'];
  projectCategory_create: Scalars['Boolean']['output'];
  projectCategory_delete: Scalars['Boolean']['output'];
  projectCategory_query: Scalars['Boolean']['output'];
  projectCategory_update: Scalars['Boolean']['output'];
  project_accessAccountingAttributes: Scalars['Boolean']['output'];
  project_archive_all: Scalars['Boolean']['output'];
  project_archive_own: Scalars['Boolean']['output'];
  project_archive_team: Scalars['Boolean']['output'];
  project_billingTime_lock: Scalars['Boolean']['output'];
  project_budget_completeExpenseBudgetItem_all: Scalars['Boolean']['output'];
  project_budget_completeExpenseBudgetItem_own: Scalars['Boolean']['output'];
  project_budget_completeExpenseBudgetItem_team: Scalars['Boolean']['output'];
  project_budget_reopenExpenseBudgetItem_all: Scalars['Boolean']['output'];
  project_budget_reopenExpenseBudgetItem_own: Scalars['Boolean']['output'];
  project_budget_reopenExpenseBudgetItem_team: Scalars['Boolean']['output'];
  project_budget_update_all: Scalars['Boolean']['output'];
  project_budget_update_own: Scalars['Boolean']['output'];
  project_budget_update_team: Scalars['Boolean']['output'];
  project_create_all: Scalars['Boolean']['output'];
  project_create_own: Scalars['Boolean']['output'];
  project_create_team: Scalars['Boolean']['output'];
  project_delete_all: Scalars['Boolean']['output'];
  project_delete_own: Scalars['Boolean']['output'];
  project_delete_team: Scalars['Boolean']['output'];
  project_duplicate_all: Scalars['Boolean']['output'];
  project_duplicate_own: Scalars['Boolean']['output'];
  project_duplicate_team: Scalars['Boolean']['output'];
  project_finish_all: Scalars['Boolean']['output'];
  project_finish_own: Scalars['Boolean']['output'];
  project_finish_team: Scalars['Boolean']['output'];
  project_lockBillingPlan: Scalars['Boolean']['output'];
  project_pin_all: Scalars['Boolean']['output'];
  project_pin_own: Scalars['Boolean']['output'];
  project_pin_team: Scalars['Boolean']['output'];
  project_read_all: Scalars['Boolean']['output'];
  project_read_excludeRestrictedTeams: Scalars['Boolean']['output'];
  project_read_own: Scalars['Boolean']['output'];
  project_read_team: Scalars['Boolean']['output'];
  project_reopen_all: Scalars['Boolean']['output'];
  project_reopen_own: Scalars['Boolean']['output'];
  project_reopen_team: Scalars['Boolean']['output'];
  project_timeTrackingReport_read_all: Scalars['Boolean']['output'];
  project_timeTrackingReport_read_own: Scalars['Boolean']['output'];
  project_timeTrackingReport_read_team: Scalars['Boolean']['output'];
  project_update_all: Scalars['Boolean']['output'];
  project_update_own: Scalars['Boolean']['output'];
  project_update_team: Scalars['Boolean']['output'];
  project_viewAllFields: Scalars['Boolean']['output'];
  quote_create_withoutInternalApproved: Scalars['Boolean']['output'];
  quote_manualApprove: Scalars['Boolean']['output'];
  requestForInvoicing_accessAccountingAttributes: Scalars['Boolean']['output'];
  requestForInvoicing_create_all: Scalars['Boolean']['output'];
  requestForInvoicing_create_own: Scalars['Boolean']['output'];
  requestForInvoicing_create_team: Scalars['Boolean']['output'];
  requestForInvoicing_delete_all: Scalars['Boolean']['output'];
  requestForInvoicing_delete_own: Scalars['Boolean']['output'];
  requestForInvoicing_delete_team: Scalars['Boolean']['output'];
  requestForInvoicing_querySubmittedCount_all: Scalars['Boolean']['output'];
  requestForInvoicing_querySubmittedCount_own: Scalars['Boolean']['output'];
  requestForInvoicing_read_all: Scalars['Boolean']['output'];
  requestForInvoicing_read_own: Scalars['Boolean']['output'];
  requestForInvoicing_read_team: Scalars['Boolean']['output'];
  requestForInvoicing_update_all: Scalars['Boolean']['output'];
  requestForInvoicing_update_own: Scalars['Boolean']['output'];
  requestForInvoicing_update_team: Scalars['Boolean']['output'];
  taskComment_create: Scalars['Boolean']['output'];
  taskComment_delete_all?: Maybe<Scalars['Boolean']['output']>;
  taskComment_delete_own: Scalars['Boolean']['output'];
  taskComment_update_all: Scalars['Boolean']['output'];
  taskComment_update_own: Scalars['Boolean']['output'];
  task_create_all: Scalars['Boolean']['output'];
  task_create_scoped: Scalars['Boolean']['output'];
  task_delete_all: Scalars['Boolean']['output'];
  task_delete_own: Scalars['Boolean']['output'];
  task_read_all: Scalars['Boolean']['output'];
  task_read_own: Scalars['Boolean']['output'];
  task_update_all: Scalars['Boolean']['output'];
  task_update_current_assignee_all: Scalars['Boolean']['output'];
  task_update_current_assignee_own: Scalars['Boolean']['output'];
  task_update_own: Scalars['Boolean']['output'];
  task_update_scoped: Scalars['Boolean']['output'];
  task_update_status_all: Scalars['Boolean']['output'];
  task_update_status_own: Scalars['Boolean']['output'];
  task_viewAllFields: Scalars['Boolean']['output'];
  timeTracking_create_all: Scalars['Boolean']['output'];
  timeTracking_create_own: Scalars['Boolean']['output'];
  timeTracking_create_team: Scalars['Boolean']['output'];
  timeTracking_delete_all: Scalars['Boolean']['output'];
  timeTracking_delete_own: Scalars['Boolean']['output'];
  timeTracking_delete_team: Scalars['Boolean']['output'];
  timeTracking_read_all: Scalars['Boolean']['output'];
  timeTracking_read_own: Scalars['Boolean']['output'];
  timeTracking_read_team: Scalars['Boolean']['output'];
  timeTracking_report_read_all: Scalars['Boolean']['output'];
  timeTracking_report_read_own: Scalars['Boolean']['output'];
  timeTracking_report_read_team: Scalars['Boolean']['output'];
  timeTracking_timer_use_all: Scalars['Boolean']['output'];
  timeTracking_timer_use_manual: Scalars['Boolean']['output'];
  timeTracking_timer_use_own: Scalars['Boolean']['output'];
  timeTracking_timer_use_team: Scalars['Boolean']['output'];
  timeTracking_update_all: Scalars['Boolean']['output'];
  timeTracking_update_own: Scalars['Boolean']['output'];
  timeTracking_update_team: Scalars['Boolean']['output'];
  timeTracking_userMonthlyReport_read: Scalars['Boolean']['output'];
  user_accessAccountingAttributes: Scalars['Boolean']['output'];
  user_create: Scalars['Boolean']['output'];
  user_delete: Scalars['Boolean']['output'];
  user_haveProjectsAssigned: Scalars['Boolean']['output'];
  user_password_update: Scalars['Boolean']['output'];
  user_profile_read: Scalars['Boolean']['output'];
  user_profile_update: Scalars['Boolean']['output'];
  user_read_all: Scalars['Boolean']['output'];
  user_read_own: Scalars['Boolean']['output'];
  user_scopeCreate: Scalars['Boolean']['output'];
  user_scope_all: Scalars['Boolean']['output'];
  user_scope_own: Scalars['Boolean']['output'];
  user_updateAllfredData: Scalars['Boolean']['output'];
  user_updatePersonalData: Scalars['Boolean']['output'];
  user_updatePlanningData: Scalars['Boolean']['output'];
  user_updateScopeUser: Scalars['Boolean']['output'];
  user_updateWorkData: Scalars['Boolean']['output'];
  user_update_all: Scalars['Boolean']['output'];
  user_update_own: Scalars['Boolean']['output'];
  utilizationReportProfit_query_all: Scalars['Boolean']['output'];
  utilizationReport_query_all: Scalars['Boolean']['output'];
  utilizationReport_query_own: Scalars['Boolean']['output'];
  utilizationReport_query_team: Scalars['Boolean']['output'];
  wip_close_all: Scalars['Boolean']['output'];
  wip_close_own: Scalars['Boolean']['output'];
  wip_close_team: Scalars['Boolean']['output'];
  wip_lock_all: Scalars['Boolean']['output'];
  wip_lock_own: Scalars['Boolean']['output'];
  wip_lock_team: Scalars['Boolean']['output'];
  wip_open_all: Scalars['Boolean']['output'];
  wip_open_own: Scalars['Boolean']['output'];
  wip_open_team: Scalars['Boolean']['output'];
  wip_read_all: Scalars['Boolean']['output'];
  wip_read_own: Scalars['Boolean']['output'];
  wip_read_team: Scalars['Boolean']['output'];
  wip_submit_all: Scalars['Boolean']['output'];
  wip_submit_own: Scalars['Boolean']['output'];
  wip_submit_team: Scalars['Boolean']['output'];
  wip_unlock_all: Scalars['Boolean']['output'];
  wip_unlock_own: Scalars['Boolean']['output'];
  wip_unlock_team: Scalars['Boolean']['output'];
  workspaceSetting_edit: Scalars['Boolean']['output'];
};

export type PipedriveCustomField = {
  __typename?: 'PipedriveCustomField';
  entity_type: Scalars['String']['output'];
  external_key: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  purpose: Scalars['String']['output'];
};

export type PipedriveCustomFieldValue = {
  __typename?: 'PipedriveCustomFieldValue';
  customField: PipedriveCustomField;
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type PipedriveStage = {
  __typename?: 'PipedriveStage';
  name: Scalars['String']['output'];
  pipedrive_stage_id: Scalars['ID']['output'];
};

export type PlannedExpenseUsageInput = {
  budget_item_planned_expense_id: Scalars['ID']['input'];
  used_amount: Scalars['BigInt']['input'];
};

export type PlannedExpensesBudgetItem = {
  __typename?: 'PlannedExpensesBudgetItem';
  actual_profit_amount: Scalars['BigInt']['output'];
  actual_profit_percentage: Scalars['BigInt']['output'];
  budget_item_type: PlannedExpensesBudgetItemTypeEnum;
  buy_price: Scalars['BigInt']['output'];
  category_name: Scalars['String']['output'];
  expenses_received: Scalars['BigInt']['output'];
  expenses_received_percentage: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  invoiced_amount: Scalars['BigInt']['output'];
  invoiced_amount_percentage: Scalars['BigInt']['output'];
  item_code?: Maybe<Scalars['String']['output']>;
  planned_budgeted_amount: Scalars['BigInt']['output'];
  planned_budgeted_amount_percentage: Scalars['BigInt']['output'];
  planned_client_amount: Scalars['BigInt']['output'];
  planned_client_amount_percentage: Scalars['BigInt']['output'];
  profit_estimate: Scalars['BigInt']['output'];
  profit_estimate_percentage: Scalars['BigInt']['output'];
  title: Scalars['String']['output'];
  to_plan_buy_price: Scalars['BigInt']['output'];
  to_plan_buy_price_percentage: Scalars['BigInt']['output'];
  to_plan_client_price: Scalars['BigInt']['output'];
  to_plan_client_price_percentage: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
  total_budgeted_with_commission: Scalars['BigInt']['output'];
  uninvoiced_amount: Scalars['BigInt']['output'];
  uninvoiced_amount_percentage: Scalars['BigInt']['output'];
};

export enum PlannedExpensesBudgetItemTypeEnum {
  Expense = 'EXPENSE',
  OurWork = 'OUR_WORK'
}

export type PlannedExpensesOrderByClause = {
  column: PlannedExpensesOrderByColumnEnum;
  order: SortOrder;
};

export enum PlannedExpensesOrderByColumnEnum {
  BrandName = 'BRAND_NAME',
  CreatedAt = 'CREATED_AT',
  ProjectCode = 'PROJECT_CODE',
  ProjectTitle = 'PROJECT_TITLE',
  TotalBudget = 'TOTAL_BUDGET',
  TotalBudgetedWithCommission = 'TOTAL_BUDGETED_WITH_COMMISSION',
  TotalBuyPrice = 'TOTAL_BUY_PRICE',
  TotalExpensesReceived = 'TOTAL_EXPENSES_RECEIVED',
  TotalInvoicedAmount = 'TOTAL_INVOICED_AMOUNT',
  TotalPlannedBudgetedAmount = 'TOTAL_PLANNED_BUDGETED_AMOUNT',
  TotalPlannedClientAmount = 'TOTAL_PLANNED_CLIENT_AMOUNT'
}

export type PlannedExpensesProject = {
  __typename?: 'PlannedExpensesProject';
  actual_profit_amount: Scalars['BigInt']['output'];
  actual_profit_percentage: Scalars['BigInt']['output'];
  budget_items: Array<PlannedExpensesBudgetItem>;
  expenses_received_percentage: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  invoiced_amount_percentage: Scalars['BigInt']['output'];
  planned_budgeted_amount_percentage: Scalars['BigInt']['output'];
  planned_client_amount_percentage: Scalars['BigInt']['output'];
  profit_estimate: Scalars['BigInt']['output'];
  profit_estimate_percentage: Scalars['BigInt']['output'];
  project: Project;
  to_plan_buy_price: Scalars['BigInt']['output'];
  to_plan_buy_price_percentage: Scalars['BigInt']['output'];
  to_plan_client_price: Scalars['BigInt']['output'];
  to_plan_client_price_percentage: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
  total_budgeted_with_commission: Scalars['BigInt']['output'];
  total_buy_price: Scalars['BigInt']['output'];
  total_expenses_received: Scalars['BigInt']['output'];
  total_invoiced_amount: Scalars['BigInt']['output'];
  total_planned_budgeted_amount: Scalars['BigInt']['output'];
  total_planned_client_amount: Scalars['BigInt']['output'];
  uninvoiced_amount: Scalars['BigInt']['output'];
  uninvoiced_amount_percentage: Scalars['BigInt']['output'];
};

/** A paginated list of PlannedExpensesProject items. */
export type PlannedExpensesProjectPaginator = {
  __typename?: 'PlannedExpensesProjectPaginator';
  /** A list of PlannedExpensesProject items. */
  data: Array<PlannedExpensesProject>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type PlannedExpensesQueryArgs = {
  orderBy?: InputMaybe<Array<PlannedExpensesOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PlannedExpensesWhereConditions>;
};

export type PlannedExpensesSummary = {
  __typename?: 'PlannedExpensesSummary';
  actual_profit_amount: Scalars['BigInt']['output'];
  actual_profit_percentage: Scalars['BigInt']['output'];
  expenses_received_percentage: Scalars['BigInt']['output'];
  invoiced_amount_percentage: Scalars['BigInt']['output'];
  planned_budgeted_amount_percentage: Scalars['BigInt']['output'];
  planned_client_amount_percentage: Scalars['BigInt']['output'];
  profit_estimate: Scalars['BigInt']['output'];
  profit_estimate_percentage: Scalars['BigInt']['output'];
  to_plan_buy_price: Scalars['BigInt']['output'];
  to_plan_buy_price_percentage: Scalars['BigInt']['output'];
  to_plan_client_price: Scalars['BigInt']['output'];
  to_plan_client_price_percentage: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
  total_budgeted_with_commission: Scalars['BigInt']['output'];
  total_buy_price: Scalars['BigInt']['output'];
  total_expenses_received: Scalars['BigInt']['output'];
  total_invoiced_amount: Scalars['BigInt']['output'];
  total_planned_budgeted_amount: Scalars['BigInt']['output'];
  total_planned_client_amount: Scalars['BigInt']['output'];
  total_projects: Scalars['Int']['output'];
  uninvoiced_amount: Scalars['BigInt']['output'];
  uninvoiced_amount_percentage: Scalars['BigInt']['output'];
};

export enum PlannedExpensesWhereColumn {
  BrandId = 'BRAND_ID',
  BudgetItemType = 'BUDGET_ITEM_TYPE',
  ClientId = 'CLIENT_ID',
  HasPlannedExpenses = 'HAS_PLANNED_EXPENSES',
  IncludeDrafts = 'INCLUDE_DRAFTS',
  ProjectCategoryId = 'PROJECT_CATEGORY_ID',
  ProjectId = 'PROJECT_ID',
  ProjectManagerId = 'PROJECT_MANAGER_ID',
  ProjectStageId = 'PROJECT_STAGE_ID',
  ProjectStatus = 'PROJECT_STATUS',
  ProjectType = 'PROJECT_TYPE',
  TeamId = 'TEAM_ID'
}

export type PlannedExpensesWhereConditions = {
  AND?: InputMaybe<Array<PlannedExpensesWhereConditions>>;
  OR?: InputMaybe<Array<PlannedExpensesWhereConditions>>;
  column?: InputMaybe<PlannedExpensesWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type PlanningDailyViewCapacityAllocationUserItem = {
  __typename?: 'PlanningDailyViewCapacityAllocationUserItem';
  completed: Scalars['Boolean']['output'];
  /** From CapacityAllocationUserItem */
  id: Scalars['ID']['output'];
  item: CapacityAllocationItem;
  stats?: Maybe<CapacityAllocationUserItemStats>;
  timeTrackingWorkType: TimeTrackingWorkType;
  time_tracking_work_type_id: Scalars['ID']['output'];
  user: User;
};

export type PlanningDailyViewFilters = {
  first?: InputMaybe<Scalars['BigInt']['input']>;
  from: Scalars['Date']['input'];
  page?: InputMaybe<Scalars['BigInt']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Date']['input'];
  where?: InputMaybe<PlanningDailyViewWhereCondition>;
};

export type PlanningDailyViewPaginator = {
  __typename?: 'PlanningDailyViewPaginator';
  data: Array<PlanningDailyViewUserByDay>;
  last_updated_at?: Maybe<Scalars['DateTime']['output']>;
  paginatorInfo: PaginatorInfo;
};

export type PlanningDailyViewTimeOff = {
  __typename?: 'PlanningDailyViewTimeOff';
  createdBy: User;
  created_at: Scalars['DateTime']['output'];
  duration_type: TimeOffDurationTypeEnum;
  from_date: Scalars['Date']['output'];
  from_time: Scalars['Time']['output'];
  global: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  repetition: CapacityAllocationRepetitionTypeEnum;
  repetition_settings?: Maybe<RepetitionSettings>;
  teams?: Maybe<Array<TeamAttendee>>;
  timeOffType: TimeOffType;
  to_date: Scalars['Date']['output'];
  to_time: Scalars['Time']['output'];
  total_time: Scalars['BigInt']['output'];
};

export type PlanningDailyViewTimeOffItem = {
  __typename?: 'PlanningDailyViewTimeOffItem';
  assignees: Array<TimeOffAssignee>;
  date: Scalars['Date']['output'];
  duration_type?: Maybe<TimeOffDurationTypeEnum>;
  from_time?: Maybe<Scalars['Time']['output']>;
  global: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  timeOff: PlanningDailyViewTimeOff;
  timeOffType: TimeOffType;
  to_time?: Maybe<Scalars['Time']['output']>;
  total_time: Scalars['BigInt']['output'];
  unique_id: Scalars['String']['output'];
};

export type PlanningDailyViewUnassignedTasksFilters = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  where: PlanningViewUnassignedTasksWhereConditions;
};

export type PlanningDailyViewUnassignedTasksPerDay = {
  __typename?: 'PlanningDailyViewUnassignedTasksPerDay';
  afterDeadline: Array<Task>;
  date: Scalars['Date']['output'];
  other: Array<Task>;
};

export type PlanningDailyViewUserByDay = {
  __typename?: 'PlanningDailyViewUserByDay';
  items: Array<PlanningDailyViewUserDay>;
  user: User;
};

export type PlanningDailyViewUserDay = {
  __typename?: 'PlanningDailyViewUserDay';
  /** In seconds */
  capacity: Scalars['BigInt']['output'];
  date: Scalars['Date']['output'];
  holiday?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<CapacityAllocationItem>>;
  total_tracked_for_date: Scalars['BigInt']['output'];
  workStatus: CapacityAllocationWorkStatus;
};

export enum PlanningDailyViewWhereColumn {
  /** AllocableTypeEnum values */
  AllocableType = 'ALLOCABLE_TYPE',
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  CreatedByUserId = 'CREATED_BY_USER_ID',
  /** DateRange */
  Deadline = 'DEADLINE',
  ProjectId = 'PROJECT_ID',
  TaskPriorityId = 'TASK_PRIORITY_ID',
  /** Id values */
  TaskStatusId = 'TASK_STATUS_ID',
  TeamId = 'TEAM_ID',
  TimeTrackingWorkTypeId = 'TIME_TRACKING_WORK_TYPE_ID',
  UserId = 'USER_ID'
}

export type PlanningDailyViewWhereCondition = {
  AND?: InputMaybe<Array<PlanningDailyViewWhereCondition>>;
  OR?: InputMaybe<Array<PlanningDailyViewWhereCondition>>;
  column?: InputMaybe<PlanningDailyViewWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export enum PlanningOrderTypeEnum {
  Default = 'DEFAULT',
  Team = 'TEAM'
}

export type PlanningRangeInput = {
  daily_capacity?: InputMaybe<Scalars['BigInt']['input']>;
  type?: InputMaybe<PlanningRangeTypeEnum>;
  utilising: Scalars['Boolean']['input'];
  valid_from: Scalars['Date']['input'];
  valid_to?: InputMaybe<Scalars['Date']['input']>;
  weekly_capacities?: InputMaybe<WeeklyCapacitiesInput>;
};

export type PlanningRangeType = {
  __typename?: 'PlanningRangeType';
  value: PlanningRangeTypeEnum;
};

export enum PlanningRangeTypeEnum {
  Custom = 'CUSTOM',
  Week = 'WEEK',
  Workweek = 'WORKWEEK'
}

export type PlanningViewSetting = {
  __typename?: 'PlanningViewSetting';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PlanningViewSettingInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum PlanningViewUnassignedTasksWhereColumn {
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  CreatedByUserId = 'CREATED_BY_USER_ID',
  /** DateRange */
  Deadline = 'DEADLINE',
  ProjectId = 'PROJECT_ID',
  TaskPriorityId = 'TASK_PRIORITY_ID',
  /** Id values */
  TaskStatusId = 'TASK_STATUS_ID'
}

export type PlanningViewUnassignedTasksWhereConditions = {
  AND?: InputMaybe<Array<PlanningViewUnassignedTasksWhereConditions>>;
  OR?: InputMaybe<Array<PlanningViewUnassignedTasksWhereConditions>>;
  column?: InputMaybe<PlanningViewUnassignedTasksWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type PositionMappingInput = {
  new_time_tracking_work_type_id: Scalars['ID']['input'];
  old_time_tracking_work_type_id: Scalars['ID']['input'];
};

export type PositionSpent = {
  __typename?: 'PositionSpent';
  spent: Scalars['Int']['output'];
  timeTrackingWorkType: TimeTrackingWorkType;
};

export type PrepaymentSplitInput = {
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  brand_credit_account_id?: InputMaybe<Scalars['ID']['input']>;
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input pre preview/prepočet Time Billing (bez uloženia)
 * Používa sa na real-time prepočítavanie hodnôt na frontende
 */
export type PreviewProjectTimeBillingInput = {
  components?: InputMaybe<Array<TimeBillingComponentInput>>;
  date_from: Scalars['Date']['input'];
  date_to: Scalars['Date']['input'];
  final_total_amount?: InputMaybe<Scalars['BigInt']['input']>;
  project_id: Scalars['ID']['input'];
  sources?: InputMaybe<Array<TimeBillingSourceInput>>;
  timeTrackingItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type: TimeBillingTypeEnum;
  user_rows?: InputMaybe<Array<TimeBillingUserRowPreviewInput>>;
};

export type ProfitLossReport = {
  __typename?: 'ProfitLossReport';
  columns: Array<ProfitLossReportColumn>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ProfitLossReportColumn = {
  __typename?: 'ProfitLossReportColumn';
  balance_amount: Scalars['BigInt']['output'];
  expenses_amount: Scalars['BigInt']['output'];
  invoiced_amount: Scalars['BigInt']['output'];
  title: Scalars['String']['output'];
};

export enum ProfitLossReportColumns {
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Year = 'YEAR'
}

export type ProfitLossReportGroup = {
  __typename?: 'ProfitLossReportGroup';
  columns: Array<ProfitLossReportColumn>;
  id: Scalars['ID']['output'];
  items: Array<ProfitLossReport>;
  title: Scalars['String']['output'];
};

export type ProfitLossReportGroupPaginator = {
  __typename?: 'ProfitLossReportGroupPaginator';
  data: Array<ProfitLossReportGroup>;
  paginatorInfo: PaginatorInfo;
};

export enum ProfitLossReportOrderByColumn {
  Balance = 'BALANCE',
  Expenses = 'EXPENSES',
  Invoiced = 'INVOICED'
}

export type ProfitLossReportPaginator = {
  __typename?: 'ProfitLossReportPaginator';
  data: Array<ProfitLossReport>;
  paginatorInfo: PaginatorInfo;
};

export enum ProfitLossReportRows {
  Brand = 'BRAND',
  Client = 'CLIENT',
  Project = 'PROJECT',
  Team = 'TEAM'
}

export type ProfitLossReportSummary = {
  __typename?: 'ProfitLossReportSummary';
  data: Array<ProfitLossReportColumn>;
};

export enum ProfitLossReportWhereColumn {
  BillingEntityId = 'BILLING_ENTITY_ID',
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  OtherProjectManagerId = 'OTHER_PROJECT_MANAGER_ID',
  ProjectBillable = 'PROJECT_BILLABLE',
  ProjectCategoryId = 'PROJECT_CATEGORY_ID',
  ProjectId = 'PROJECT_ID',
  ProjectManagerId = 'PROJECT_MANAGER_ID',
  ProjectStatus = 'PROJECT_STATUS',
  TeamId = 'TEAM_ID',
  WorkspaceCompanyId = 'WORKSPACE_COMPANY_ID'
}

export type ProfitLossReportWhereConditions = {
  AND?: InputMaybe<Array<ProfitLossReportWhereConditions>>;
  OR?: InputMaybe<Array<ProfitLossReportWhereConditions>>;
  column?: InputMaybe<ProfitLossReportWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type Project = {
  __typename?: 'Project';
  archivedBy?: Maybe<User>;
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  availableTimeTrackingWorkTypes: Array<TimeTrackingWorkType>;
  average_time_tracking_rate?: Maybe<Scalars['BigInt']['output']>;
  billable: Scalars['Boolean']['output'];
  billingPlanByMonths: Array<BillingPlanByMonths>;
  billingPlanIsMissing: Scalars['Boolean']['output'];
  billingPlanItems: Array<BillingPlanItem>;
  billingPlanNotifications?: Maybe<BillingPlanNotifications>;
  billingPlanSetting?: Maybe<ProjectBillingPlanSetting>;
  brand: Brand;
  budgetovacBudget?: Maybe<ProjectBudgetPivot>;
  budgetovacBudgets?: Maybe<Array<Budget>>;
  calculated_average_time_tracking_rate?: Maybe<Scalars['BigInt']['output']>;
  categories: Array<ProjectCategory>;
  cloudUrl?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  contact?: Maybe<Contact>;
  contracts?: Maybe<ContractPaginator>;
  created_at: Scalars['DateTime']['output'];
  currentMonthBillingPlanOutgoingInvoice: Scalars['BigInt']['output'];
  currentMonthBillingPlanOutgoingProformaInvoice: Scalars['BigInt']['output'];
  currentMonthBillingPlanStats: BillingPlanStats;
  /** @deprecated No longer supported */
  currentWorkInProgressProjectStat?: Maybe<WorkInProgressProjectStat>;
  driveCloudUrl?: Maybe<Scalars['String']['output']>;
  expected_end_date?: Maybe<Scalars['Date']['output']>;
  expenses: Array<ExpenseBudgetItem>;
  expensesStructured: Array<ExpenseStructuredBudgetItem>;
  expensesWithoutOther: Array<ExpenseBudgetItem>;
  expensesWithoutOtherStructured: Array<ExpenseStructuredBudgetItem>;
  externalLinks: Array<ExternalLink>;
  finishedBy?: Maybe<User>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoiceStats: Array<ProjectInvoiceStat>;
  is_pinned: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  is_pro_bono: Scalars['Boolean']['output'];
  is_starred: Scalars['Boolean']['output'];
  is_template: Scalars['Boolean']['output'];
  lastInvoice?: Maybe<ProjectInvoiceStat>;
  lastWorkInProgressProjectStat?: Maybe<WorkInProgressProjectStat>;
  lowestPossibleDateForStartDateChange?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  numeric_code?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<OrderPaginator>;
  ordersSimpleMap: Array<OrderSimple>;
  otherDocuments?: Maybe<OtherDocumentPaginator>;
  otherProjectManagers?: Maybe<Array<User>>;
  ourWork: Array<OurWorkBudgetItem>;
  ourWorkOverview: Array<OurWorkOverviewBudgetItem>;
  ourWorkStructured: Array<OurWorkStructuredBudgetItem>;
  pipedriveCustomFieldValues: Array<PipedriveCustomFieldValue>;
  pipedrive_setup_complete?: Maybe<Scalars['Boolean']['output']>;
  prepaymentStats: Array<ProjectPrepaymentStat>;
  proformaInvoices: Array<OutgoingProformaInvoice>;
  projectManager: User;
  project_stage?: Maybe<ProjectStage>;
  rate_card_exchange_rate: Scalars['BigInt']['output'];
  rate_card_id?: Maybe<Scalars['ID']['output']>;
  scopes: Array<UserScope>;
  start_date: Scalars['Date']['output'];
  stats?: Maybe<ProjectStats>;
  statsCached?: Maybe<ProjectStats>;
  status: ProjectStatusEnum;
  team: Team;
  timeTrackingRates: Array<TimeTrackingRate>;
  title: Scalars['String']['output'];
  type: ProjectTypeEnum;
  updated_at: Scalars['DateTime']['output'];
  users: Array<User>;
  uses_budgetovac: Scalars['Boolean']['output'];
};


export type ProjectContractsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectExpensesArgs = {
  hasBudgetExceeded?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectExpensesWithoutOtherArgs = {
  hasBudgetExceeded?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectOrdersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectOtherDocumentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectOurWorkArgs = {
  hasBudgetExceeded?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectOurWorkOverviewArgs = {
  budgetItemId?: InputMaybe<Scalars['ID']['input']>;
  withDoneTasks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectAllQueryArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProjectsAllWhereConditions>;
};

export type ProjectBilling = {
  __typename?: 'ProjectBilling';
  automatically_invoiced: Scalars['BigInt']['output'];
  balance: Scalars['BigInt']['output'];
  billing_plan_setting?: Maybe<ProjectBillingPlanSetting>;
  billing_type: ProjectBillingTypeEnum;
  has_billing_plan: Scalars['Boolean']['output'];
  invoiced_amount: Scalars['BigInt']['output'];
  invoiced_expense_categories: Array<ProjectBillingExpenseCategoryAmount>;
  invoiced_our_work: Scalars['BigInt']['output'];
  invoiced_prepayments: Scalars['BigInt']['output'];
  items: Array<ProjectBillingItem>;
  manually_invoiced: Scalars['BigInt']['output'];
  planned_amount: Scalars['BigInt']['output'];
  planned_expense_categories: Array<ProjectBillingExpenseCategoryAmount>;
  planned_our_work: Scalars['BigInt']['output'];
  planned_prepayments: Scalars['BigInt']['output'];
  project: Project;
};

export enum ProjectBillingDocumentTypeEnum {
  CreditNote = 'CREDIT_NOTE',
  OutgoingInvoice = 'OUTGOING_INVOICE',
  OutgoingProformaInvoice = 'OUTGOING_PROFORMA_INVOICE',
  Planned = 'PLANNED',
  Prepayment = 'PREPAYMENT',
  RequestForInvoicing = 'REQUEST_FOR_INVOICING'
}

export type ProjectBillingExpenseCategoryAmount = {
  __typename?: 'ProjectBillingExpenseCategoryAmount';
  amount: Scalars['BigInt']['output'];
  category_id: Scalars['ID']['output'];
  category_name: Scalars['String']['output'];
  category_shortcut: Scalars['String']['output'];
};

export type ProjectBillingItem = {
  __typename?: 'ProjectBillingItem';
  automatically_invoiced: Scalars['BigInt']['output'];
  balance: Scalars['BigInt']['output'];
  billingPlanBudgetCache?: Maybe<BillingPlanBudgetCache>;
  billing_item_type?: Maybe<BillingItemTypEnum>;
  brandCreditAccount?: Maybe<BrandCreditAccount>;
  brand_credit_account_id?: Maybe<Scalars['ID']['output']>;
  brand_credit_account_title?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  date_of_supply?: Maybe<Scalars['Date']['output']>;
  delivered: Scalars['Boolean']['output'];
  due_date?: Maybe<Scalars['Date']['output']>;
  email_sent?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  invoice_id?: Maybe<Scalars['ID']['output']>;
  invoice_no?: Maybe<Scalars['String']['output']>;
  invoice_type?: Maybe<BillingPlanBudgetItemInvoiceTypeEnum>;
  invoiced_amount: Scalars['BigInt']['output'];
  invoiced_expense_categories: Array<ProjectBillingExpenseCategoryAmount>;
  invoiced_our_work: Scalars['BigInt']['output'];
  invoiced_prepayments: Scalars['BigInt']['output'];
  issue_date?: Maybe<Scalars['Date']['output']>;
  item_type: ProjectBillingItemTypeEnum;
  manually_invoiced: Scalars['BigInt']['output'];
  message?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  outgoingInvoice?: Maybe<OutgoingInvoice>;
  outgoingProformaInvoice?: Maybe<OutgoingProformaInvoice>;
  paid_amount: Scalars['BigInt']['output'];
  paid_at?: Maybe<Scalars['DateTime']['output']>;
  payment_status?: Maybe<PaymentStatusEnum>;
  planned_amount: Scalars['BigInt']['output'];
  planned_expense_categories: Array<ProjectBillingExpenseCategoryAmount>;
  planned_our_work: Scalars['BigInt']['output'];
  planned_prepayments: Scalars['BigInt']['output'];
  requestForInvoicing?: Maybe<RequestForInvoicing>;
  status: ProjectBillingItemStatusEnum;
  type?: Maybe<ProjectBillingDocumentTypeEnum>;
  updated_at: Scalars['DateTime']['output'];
};

export enum ProjectBillingItemStatusEnum {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  ManuallyCreated = 'MANUALLY_CREATED',
  Pending = 'PENDING',
  PrepaymentUsed = 'PREPAYMENT_USED'
}

export enum ProjectBillingItemTypeEnum {
  InvoiceAutomatic = 'INVOICE_AUTOMATIC',
  InvoiceManual = 'INVOICE_MANUAL',
  PlannedFuture = 'PLANNED_FUTURE',
  PrepaymentUsage = 'PREPAYMENT_USAGE',
  SummaryManualPlanned = 'SUMMARY_MANUAL_PLANNED'
}

/** A paginated list of ProjectBilling items. */
export type ProjectBillingPaginator = {
  __typename?: 'ProjectBillingPaginator';
  /** A list of ProjectBilling items. */
  data: Array<ProjectBilling>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ProjectBillingPlanEmailTemplate = {
  __typename?: 'ProjectBillingPlanEmailTemplate';
  content?: Maybe<Scalars['String']['output']>;
  recipients?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type ProjectBillingPlanEmailTemplateInput = {
  content: Scalars['String']['input'];
  recipients: Array<InputMaybe<Scalars['String']['input']>>;
  subject: Scalars['String']['input'];
};

export type ProjectBillingPlanSetting = {
  __typename?: 'ProjectBillingPlanSetting';
  auto_create_invoice: Scalars['Boolean']['output'];
  auto_send_invoice: Scalars['Boolean']['output'];
  auto_send_thank_you: Scalars['Boolean']['output'];
  auto_send_thank_you_template?: Maybe<ProjectBillingPlanEmailTemplate>;
  billing_entity_id?: Maybe<Scalars['ID']['output']>;
  billing_item_type: BillingItemTypEnum;
  contact_id?: Maybe<Scalars['ID']['output']>;
  create_draft_invoice: Scalars['Boolean']['output'];
  create_summary_invoice_after_payment: Scalars['Boolean']['output'];
  date_of_supply_from_issue_date?: Maybe<Scalars['Int']['output']>;
  email_template?: Maybe<ProjectBillingPlanEmailTemplate>;
  from: Scalars['Date']['output'];
  generate_invoice_items?: Maybe<ProjectBillingPlanSettingGenerateInvoiceItemsEnum>;
  internal_note?: Maybe<Scalars['String']['output']>;
  lockedByUser?: Maybe<User>;
  locked_at?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['ID']['output']>;
  project_id: Scalars['ID']['output'];
  text_on_invoice?: Maybe<Scalars['String']['output']>;
  to: Scalars['Date']['output'];
  vat_rate_id?: Maybe<Scalars['ID']['output']>;
  workspace_bank_account_id?: Maybe<Scalars['ID']['output']>;
  workspace_company_id?: Maybe<Scalars['ID']['output']>;
};

export enum ProjectBillingPlanSettingGenerateInvoiceItemsEnum {
  BudgetItemName = 'BUDGET_ITEM_NAME',
  CategoryName = 'CATEGORY_NAME',
  ProjectName = 'PROJECT_NAME'
}

export enum ProjectBillingTypeEnum {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
  None = 'NONE'
}

export type ProjectBillingsOrderByClause = {
  column: ProjectBillingsOrderByColumnEnum;
  order: SortOrder;
};

export enum ProjectBillingsOrderByColumnEnum {
  AutomaticallyInvoiced = 'AUTOMATICALLY_INVOICED',
  Balance = 'BALANCE',
  BillingType = 'BILLING_TYPE',
  BrandName = 'BRAND_NAME',
  CreatedAt = 'CREATED_AT',
  InvoicedAmount = 'INVOICED_AMOUNT',
  InvoicedOurWork = 'INVOICED_OUR_WORK',
  ManuallyInvoiced = 'MANUALLY_INVOICED',
  PlannedAmount = 'PLANNED_AMOUNT',
  PlannedOurWork = 'PLANNED_OUR_WORK',
  ProjectCode = 'PROJECT_CODE',
  ProjectTitle = 'PROJECT_TITLE'
}

export type ProjectBillingsQueryArgs = {
  date_from: Scalars['Date']['input'];
  date_to: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<ProjectBillingsOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProjectBillingsWhereConditions>;
  with_prepayment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectBillingsSummary = {
  __typename?: 'ProjectBillingsSummary';
  projects_with_automatic_billing: Scalars['Int']['output'];
  projects_with_manual_billing: Scalars['Int']['output'];
  projects_without_billing: Scalars['Int']['output'];
  total_automatically_invoiced: Scalars['BigInt']['output'];
  total_balance: Scalars['BigInt']['output'];
  total_draft_invoices: Scalars['Int']['output'];
  total_failed_invoices: Scalars['Int']['output'];
  total_invoiced_amount: Scalars['BigInt']['output'];
  total_invoiced_expense_categories: Array<ProjectBillingExpenseCategoryAmount>;
  total_invoiced_our_work: Scalars['BigInt']['output'];
  total_invoiced_prepayments: Scalars['BigInt']['output'];
  total_issued_invoices: Scalars['Int']['output'];
  total_manually_invoiced: Scalars['BigInt']['output'];
  total_paid_amount: Scalars['BigInt']['output'];
  total_planned_amount: Scalars['BigInt']['output'];
  total_planned_expense_categories: Array<ProjectBillingExpenseCategoryAmount>;
  total_planned_invoices: Scalars['Int']['output'];
  total_planned_our_work: Scalars['BigInt']['output'];
  total_planned_prepayments: Scalars['BigInt']['output'];
  total_prepayment_usages: Scalars['Int']['output'];
  total_projects: Scalars['Int']['output'];
  total_unpaid_amount: Scalars['BigInt']['output'];
};

export enum ProjectBillingsWhereColumn {
  BalanceFrom = 'BALANCE_FROM',
  BalanceTo = 'BALANCE_TO',
  BillingItemType = 'BILLING_ITEM_TYPE',
  BillingType = 'BILLING_TYPE',
  BrandId = 'BRAND_ID',
  BrandName = 'BRAND_NAME',
  DateOfSupply = 'DATE_OF_SUPPLY',
  DateOfSupplyFrom = 'DATE_OF_SUPPLY_FROM',
  DateOfSupplyTo = 'DATE_OF_SUPPLY_TO',
  DueDate = 'DUE_DATE',
  DueDateFrom = 'DUE_DATE_FROM',
  DueDateTo = 'DUE_DATE_TO',
  HasBillingPlan = 'HAS_BILLING_PLAN',
  HasDraftInvoices = 'HAS_DRAFT_INVOICES',
  HasFailedInvoices = 'HAS_FAILED_INVOICES',
  HasInvoiceInDateRange = 'HAS_INVOICE_IN_DATE_RANGE',
  HasPlannedInDateRange = 'HAS_PLANNED_IN_DATE_RANGE',
  HasUnpaidInvoices = 'HAS_UNPAID_INVOICES',
  InvoicedAmountFrom = 'INVOICED_AMOUNT_FROM',
  InvoicedAmountTo = 'INVOICED_AMOUNT_TO',
  InvoiceType = 'INVOICE_TYPE',
  IssueDate = 'ISSUE_DATE',
  IssueDateFrom = 'ISSUE_DATE_FROM',
  IssueDateTo = 'ISSUE_DATE_TO',
  IsDraft = 'IS_DRAFT',
  IsFinal = 'IS_FINAL',
  ItemStatus = 'ITEM_STATUS',
  PaidAt = 'PAID_AT',
  PaidAtFrom = 'PAID_AT_FROM',
  PaidAtTo = 'PAID_AT_TO',
  PaymentStatus = 'PAYMENT_STATUS',
  PlannedAmountFrom = 'PLANNED_AMOUNT_FROM',
  PlannedAmountTo = 'PLANNED_AMOUNT_TO',
  ProjectCategoryId = 'PROJECT_CATEGORY_ID',
  ProjectCode = 'PROJECT_CODE',
  ProjectId = 'PROJECT_ID',
  ProjectManagerId = 'PROJECT_MANAGER_ID',
  ProjectStageId = 'PROJECT_STAGE_ID',
  ProjectStatus = 'PROJECT_STATUS',
  ProjectTitle = 'PROJECT_TITLE',
  ProjectType = 'PROJECT_TYPE',
  TeamId = 'TEAM_ID',
  Type = 'TYPE',
  WorkspaceCompanyId = 'WORKSPACE_COMPANY_ID'
}

export type ProjectBillingsWhereConditions = {
  AND?: InputMaybe<Array<ProjectBillingsWhereConditions>>;
  OR?: InputMaybe<Array<ProjectBillingsWhereConditions>>;
  column?: InputMaybe<ProjectBillingsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type ProjectBudgetPivot = {
  __typename?: 'ProjectBudgetPivot';
  budget_id?: Maybe<Scalars['ID']['output']>;
  client_approved?: Maybe<Scalars['Boolean']['output']>;
  internally_approved?: Maybe<Scalars['Boolean']['output']>;
  newer_final_version_available: Scalars['Boolean']['output'];
};

export type ProjectCategory = {
  __typename?: 'ProjectCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum ProjectCodeGeneratorEnum {
  NumberPerBrand = 'NUMBER_PER_BRAND',
  NumberPerWorkspace = 'NUMBER_PER_WORKSPACE'
}

export type ProjectDatesForBudgetChange = {
  __typename?: 'ProjectDatesForBudgetChange';
  defaultDateForBudgetChange: Scalars['Date']['output'];
  lowestPossibleDateForBudgetChange: Scalars['Date']['output'];
};

export type ProjectExpenseStats = CreditStats & ExpenseStatsInterface & {
  __typename?: 'ProjectExpenseStats';
  all_items_completed: Scalars['Boolean']['output'];
  budget_exceeded: Scalars['BigInt']['output'];
  client_price: Scalars['BigInt']['output'];
  credit: Scalars['BigInt']['output'];
  credit_balance: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated No longer supported */
  invoiceable: Scalars['BigInt']['output'];
  invoiced_percent: Scalars['BigInt']['output'];
  over_invoiced: Scalars['BigInt']['output'];
  /** @deprecated No longer supported */
  planned_commission: Scalars['BigInt']['output'];
  /** @deprecated No longer supported */
  planned_commission_relative_computed: Scalars['String']['output'];
  planned_expenses: Scalars['BigInt']['output'];
  planned_profit: Scalars['BigInt']['output'];
  planned_profit_percent: Scalars['BigInt']['output'];
  profit: Scalars['BigInt']['output'];
  profit_percent: Scalars['BigInt']['output'];
  real_commission: Scalars['BigInt']['output'];
  real_commission_relative: Scalars['String']['output'];
  real_expenses: Scalars['BigInt']['output'];
  real_expenses_percent: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
  uninvoiced: Scalars['BigInt']['output'];
};

export type ProjectFinishSummary = {
  __typename?: 'ProjectFinishSummary';
  can_be_finished_without_further_changes: Scalars['Boolean']['output'];
  can_redistribute_credit_automatically: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  incomplete_expense_budget_items: Array<ExpenseBudgetItem>;
  incomplete_our_work_budget_items: Array<OurWorkBudgetItem>;
  overinvoiced_expense_budget_items: Array<ExpenseBudgetItem>;
  overinvoiced_for_project: Scalars['Boolean']['output'];
  overinvoiced_our_work_budget_items: Array<OurWorkBudgetItem>;
  project_already_finished: Scalars['Boolean']['output'];
  underinvoiced_expense_budget_items: Array<ExpenseBudgetItem>;
  underinvoiced_for_project: Scalars['Boolean']['output'];
  underinvoiced_our_work_budget_items: Array<OurWorkBudgetItem>;
};

export type ProjectForExpense = {
  __typename?: 'ProjectForExpense';
  brand: BrandSimple;
  code: Scalars['String']['output'];
  expenses: Array<ExpenseBudgetItemSimple>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  ourWorkBudgetItems?: Maybe<Array<OurWorkBudgetItemSimple>>;
  team: Team;
  title: Scalars['String']['output'];
};

export type ProjectForPlanovac = {
  __typename?: 'ProjectForPlanovac';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  availableTimeTrackingWorkTypes: Array<TimeTrackingWorkType>;
  brand: BrandSimple;
  code: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  ourWork: Array<OurWorkBudgetItem>;
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};


export type ProjectForPlanovacOurWorkArgs = {
  updated_at_since?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A paginated list of ProjectForPlanovac items. */
export type ProjectForPlanovacPaginator = {
  __typename?: 'ProjectForPlanovacPaginator';
  /** A list of ProjectForPlanovac items. */
  data: Array<ProjectForPlanovac>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ProjectForTask = {
  __typename?: 'ProjectForTask';
  availableTimeTrackingWorkTypes: Array<TimeTrackingWorkType>;
  code: Scalars['String']['output'];
  expected_end_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  ourWork: Array<OurWorkBudgetItemSimple>;
  start_date: Scalars['Date']['output'];
  title: Scalars['String']['output'];
};

export type ProjectGraph = {
  __typename?: 'ProjectGraph';
  spentBudgetData: Array<DateIntegerDataPoint>;
  totalBudgetData: Array<DateIntegerDataPoint>;
  wipData: Array<DateIntegerDataPoint>;
};

export type ProjectInvoiceStat = {
  __typename?: 'ProjectInvoiceStat';
  credit: Scalars['BigInt']['output'];
  id: Scalars['String']['output'];
  outgoingInvoice: OutgoingInvoice;
  outgoing_invoice_date: Scalars['Date']['output'];
};

export enum ProjectInvoicedStatusEnum {
  Invoiced = 'INVOICED',
  PartiallyInvoiced = 'PARTIALLY_INVOICED',
  Uninvoiced = 'UNINVOICED'
}

export type ProjectLimited = {
  __typename?: 'ProjectLimited';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ourWork: Array<OurWorkBudgetItemLimited>;
  title: Scalars['String']['output'];
};

/** A paginated list of ProjectLimited items. */
export type ProjectLimitedPaginator = {
  __typename?: 'ProjectLimitedPaginator';
  /** A list of ProjectLimited items. */
  data: Array<ProjectLimited>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ProjectLimitedQueryArgs = {
  orderBy?: InputMaybe<Array<ProjectOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProjectsLimitedWhereConditions>;
};

export type ProjectOrderByClause = {
  column: ProjectOrderByColumnEnum;
  order: SortOrder;
};

export enum ProjectOrderByColumnEnum {
  BrandName = 'BRAND_NAME',
  BudgetExceeded = 'BUDGET_EXCEEDED',
  ClientName = 'CLIENT_NAME',
  CreatedAt = 'CREATED_AT',
  CreditBalance = 'CREDIT_BALANCE',
  FinishedAt = 'FINISHED_AT',
  OtherProjectManager = 'OTHER_PROJECT_MANAGER',
  Pinned = 'PINNED',
  ProjectCode = 'PROJECT_CODE',
  ProjectManager = 'PROJECT_MANAGER',
  ProjectNote = 'PROJECT_NOTE',
  ProjectTitle = 'PROJECT_TITLE',
  RealExpenses = 'REAL_EXPENSES',
  SpentOurWork = 'SPENT_OUR_WORK',
  TotalBudget = 'TOTAL_BUDGET',
  TotalCredit = 'TOTAL_CREDIT'
}

export type ProjectOurWorkStats = CreditStats & OurWorkStatsInterface & {
  __typename?: 'ProjectOurWorkStats';
  all_items_completed: Scalars['Boolean']['output'];
  budget_exceeded: Scalars['BigInt']['output'];
  credit: Scalars['BigInt']['output'];
  credit_balance: Scalars['BigInt']['output'];
  efficiency_percent: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  invoiceable: Scalars['BigInt']['output'];
  invoiced_percent: Scalars['BigInt']['output'];
  net_margin_percent: Scalars['BigInt']['output'];
  net_profit: Scalars['BigInt']['output'];
  over_invoiced: Scalars['BigInt']['output'];
  planned_budget: Scalars['BigInt']['output'];
  planned_time: Scalars['BigInt']['output'];
  profit: Scalars['BigInt']['output'];
  remaining_budget: Scalars['BigInt']['output'];
  remaining_time: Scalars['Float']['output'];
  spent_budget: Scalars['BigInt']['output'];
  spent_budget_percent: Scalars['BigInt']['output'];
  spent_time: Scalars['Float']['output'];
  total_budget: Scalars['BigInt']['output'];
  total_time: Scalars['Float']['output'];
  uninvoiced: Scalars['BigInt']['output'];
};

/** A paginated list of Project items. */
export type ProjectPaginator = {
  __typename?: 'ProjectPaginator';
  /** A list of Project items. */
  data: Array<Project>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ProjectPrepaymentStat = {
  __typename?: 'ProjectPrepaymentStat';
  brandCreditAccount: BrandCreditAccount;
  credit: Scalars['BigInt']['output'];
  credit_account_operation_id: Scalars['ID']['output'];
  date: Scalars['Date']['output'];
  expenseBudgetItem?: Maybe<ExpenseBudgetItem>;
  id: Scalars['String']['output'];
  ourWorkBudgetItem?: Maybe<OurWorkBudgetItem>;
};

export type ProjectQueryArgs = {
  hasBudgetExceeded?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<ProjectOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ProjectsWhereConditions>;
};

export type ProjectRateCard = {
  __typename?: 'ProjectRateCard';
  currency_iso?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['ID']['output'];
};

export type ProjectRevenue = {
  __typename?: 'ProjectRevenue';
  paginatorInfo: PaginatorInfo;
  projects: Array<ProjectWithRevenueItem>;
};

export type ProjectRevenueBillingsByExpenseCategory = {
  __typename?: 'ProjectRevenueBillingsByExpenseCategory';
  billings?: Maybe<Scalars['BigInt']['output']>;
  expense_budget_category_id: Scalars['ID']['output'];
};

export type ProjectRevenueOrderByClause = {
  column: ProjectRevenueOrderByColumnEnum;
  order: SortOrder;
};

export enum ProjectRevenueOrderByColumnEnum {
  FinishedAt = 'FINISHED_AT'
}

export type ProjectRevenueProfitByExpenseCategory = {
  __typename?: 'ProjectRevenueProfitByExpenseCategory';
  expense_budget_category_id: Scalars['ID']['output'];
  profit?: Maybe<Scalars['BigInt']['output']>;
};

export type ProjectRevenueQueryArgs = {
  exclude_presale: Scalars['Boolean']['input'];
  first?: InputMaybe<Scalars['BigInt']['input']>;
  from: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<ProjectRevenueOrderByClause>>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Date']['input'];
  where?: InputMaybe<ProjectRevenueWhereConditions>;
};

export type ProjectRevenueSummary = {
  __typename?: 'ProjectRevenueSummary';
  brand_profit_share?: Maybe<Array<BrandRevenueShare>>;
  brand_revenue_share?: Maybe<Array<BrandRevenueShare>>;
  client_revenue_share?: Maybe<Array<BrandRevenueShare>>;
  expense_revenue_for_date_range: Array<ExpenseRevenueByCategory>;
  gross_income_for_date_range: Scalars['BigInt']['output'];
  gross_profit_for_date_range: Scalars['BigInt']['output'];
  our_work_billings_for_date_range: Scalars['BigInt']['output'];
  our_work_revenue_for_date_range: Scalars['BigInt']['output'];
  our_work_revenue_for_date_range_percentage: Scalars['BigInt']['output'];
  profit_top_projects?: Maybe<Array<TopProject>>;
  projectIds: Array<Scalars['ID']['output']>;
  projects: Scalars['BigInt']['output'];
  revenue_top_projects?: Maybe<Array<TopProject>>;
  total_invoiced: Scalars['BigInt']['output'];
};

export enum ProjectRevenueWhereColumn {
  BrandId = 'BRAND_ID',
  CategoryId = 'CATEGORY_ID',
  ClientId = 'CLIENT_ID',
  ProjectManagerId = 'PROJECT_MANAGER_ID',
  Status = 'STATUS',
  TeamId = 'TEAM_ID'
}

export type ProjectRevenueWhereConditions = {
  AND?: InputMaybe<Array<ProjectRevenueWhereConditions>>;
  OR?: InputMaybe<Array<ProjectRevenueWhereConditions>>;
  column?: InputMaybe<ProjectRevenueWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type ProjectSettings = {
  __typename?: 'ProjectSettings';
  create_default_task_enabled?: Maybe<Scalars['Boolean']['output']>;
  default_task_priority_id?: Maybe<Scalars['BigInt']['output']>;
  default_task_status_id?: Maybe<Scalars['BigInt']['output']>;
  project_code_generator?: Maybe<ProjectCodeGeneratorEnum>;
  project_code_length?: Maybe<Scalars['BigInt']['output']>;
  project_code_with_year?: Maybe<Scalars['Boolean']['output']>;
};

export type ProjectSimple = {
  __typename?: 'ProjectSimple';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  availableTimeTrackingWorkTypes: Array<TimeTrackingWorkType>;
  billable: Scalars['Boolean']['output'];
  brand: BrandSimple;
  brand_id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated No longer supported */
  is_pro_bono: Scalars['Boolean']['output'];
  numeric_code?: Maybe<Scalars['String']['output']>;
  project_manager_id?: Maybe<Scalars['ID']['output']>;
  team_id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: ProjectTypeEnum;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** A paginated list of ProjectSimple items. */
export type ProjectSimplePaginator = {
  __typename?: 'ProjectSimplePaginator';
  /** A list of ProjectSimple items. */
  data: Array<ProjectSimple>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ProjectStage = {
  __typename?: 'ProjectStage';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  system_name?: Maybe<Scalars['String']['output']>;
};

export type ProjectStarOptions = {
  with_my_tasks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectStats = {
  __typename?: 'ProjectStats';
  budget_exceeded: Scalars['BigInt']['output'];
  credit: Scalars['BigInt']['output'];
  credit_balance: Scalars['BigInt']['output'];
  credit_direct: Scalars['BigInt']['output'];
  credit_from_prepayments: Scalars['BigInt']['output'];
  credit_from_unused_prepayments: Scalars['BigInt']['output'];
  expenses: ProjectExpenseStats;
  gross_income: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  invoiceable: Scalars['BigInt']['output'];
  invoiced_percent: Scalars['BigInt']['output'];
  invoiced_status: ProjectInvoicedStatusEnum;
  net_margin_percent: Scalars['BigInt']['output'];
  net_profit: Scalars['BigInt']['output'];
  ourWork: ProjectOurWorkStats;
  outgoing_invoice_amount: Scalars['BigInt']['output'];
  outgoing_invoice_paid: Scalars['BigInt']['output'];
  outgoing_invoice_unpaid: Scalars['BigInt']['output'];
  outgoing_proforma_invoice_amount: Scalars['BigInt']['output'];
  outgoing_proforma_invoice_paid: Scalars['BigInt']['output'];
  outgoing_proforma_invoice_settled: Scalars['BigInt']['output'];
  outgoing_proforma_invoice_unpaid: Scalars['BigInt']['output'];
  outgoing_proforma_invoice_unsettled: Scalars['BigInt']['output'];
  over_invoiced: Scalars['BigInt']['output'];
  planned_commission: Scalars['BigInt']['output'];
  profit: Scalars['BigInt']['output'];
  profit_percent: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
  uninvoiced: Scalars['BigInt']['output'];
  unused_sum_from_proformas: Scalars['BigInt']['output'];
};

export enum ProjectStatusEnum {
  Active = 'active',
  Archived = 'archived',
  Finished = 'finished'
}

/** Hlavný typ pre uložený Time Billing */
export type ProjectTimeBilling = {
  __typename?: 'ProjectTimeBilling';
  components: Array<ProjectTimeBillingComponent>;
  computed_total_amount: Scalars['BigInt']['output'];
  createdByUser: User;
  created_at: Scalars['DateTime']['output'];
  date_from: Scalars['Date']['output'];
  date_to: Scalars['Date']['output'];
  distributions: Array<ProjectTimeBillingDistribution>;
  final_total_amount: Scalars['BigInt']['output'];
  final_total_note?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_locked: Scalars['Boolean']['output'];
  lockedByUser?: Maybe<User>;
  locked_at?: Maybe<Scalars['DateTime']['output']>;
  /** Title, or the billed period when there is no title */
  name: Scalars['String']['output'];
  project: Project;
  sources: Array<ProjectTimeBillingSource>;
  title?: Maybe<Scalars['String']['output']>;
  total_expense: Scalars['BigInt']['output'];
  total_invoiced: Scalars['BigInt']['output'];
  total_our_work: Scalars['BigInt']['output'];
  total_prepayment: Scalars['BigInt']['output'];
  type: TimeBillingTypeEnum;
  updated_at: Scalars['DateTime']['output'];
  userRows: Array<ProjectTimeBillingUserRow>;
};

/** Komponent sumy (invoiced, prepayment, our_work, expense) */
export type ProjectTimeBillingComponent = {
  __typename?: 'ProjectTimeBillingComponent';
  amount: Scalars['BigInt']['output'];
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  key: TimeBillingComponentKeyEnum;
  source?: Maybe<ProjectTimeBillingSource>;
  updated_at: Scalars['DateTime']['output'];
  use_in_total: Scalars['Boolean']['output'];
};

/** Preview komponentu (pre compute query) */
export type ProjectTimeBillingComponentPreview = {
  __typename?: 'ProjectTimeBillingComponentPreview';
  amount: Scalars['BigInt']['output'];
  key: TimeBillingComponentKeyEnum;
  source_id?: Maybe<Scalars['ID']['output']>;
  source_type?: Maybe<TimeBillingSourceTypeEnum>;
  use_in_total: Scalars['Boolean']['output'];
};

/** Výstup pre compute query (preview bez uloženia) */
export type ProjectTimeBillingComputed = {
  __typename?: 'ProjectTimeBillingComputed';
  components: Array<ProjectTimeBillingComponentPreview>;
  computed_total_amount: Scalars['BigInt']['output'];
  date_from: Scalars['Date']['output'];
  date_to: Scalars['Date']['output'];
  distributions: Array<ProjectTimeBillingDistributionPreview>;
  project_id: Scalars['ID']['output'];
  sources: Array<ProjectTimeBillingSourcePreview>;
  total_expense: Scalars['BigInt']['output'];
  total_invoiced: Scalars['BigInt']['output'];
  total_our_work: Scalars['BigInt']['output'];
  total_prepayment: Scalars['BigInt']['output'];
  total_spent: Scalars['BigInt']['output'];
  total_tracked_time: Scalars['Int']['output'];
  userRows: Array<ProjectTimeBillingUserRowPreview>;
};

/** Distribúcia trackingu pre Time Billing (FIFO rozdelenie) */
export type ProjectTimeBillingDistribution = {
  __typename?: 'ProjectTimeBillingDistribution';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoiced_seconds: Scalars['Int']['output'];
  overserviced_seconds: Scalars['Int']['output'];
  projectTimeBilling: ProjectTimeBilling;
  timeTrackingItem: TimeTrackingItem;
  time_tracking_item_id: Scalars['ID']['output'];
  total_seconds: Scalars['Int']['output'];
  uninvoiced_seconds: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type ProjectTimeBillingDistributionPreview = {
  __typename?: 'ProjectTimeBillingDistributionPreview';
  invoiced_seconds: Scalars['Int']['output'];
  overserviced_seconds: Scalars['Int']['output'];
  timeTrackingItem: TimeTrackingItem;
  time_tracking_item_id: Scalars['ID']['output'];
  uninvoiced_seconds: Scalars['Int']['output'];
};

/** Order by klauzula pre listing */
export type ProjectTimeBillingOrderByClause = {
  column: ProjectTimeBillingOrderByColumn;
  order: SortOrder;
};

export enum ProjectTimeBillingOrderByColumn {
  CreatedAt = 'CREATED_AT',
  DateFrom = 'DATE_FROM',
  DateTo = 'DATE_TO',
  FinalTotalAmount = 'FINAL_TOTAL_AMOUNT',
  LockedAt = 'LOCKED_AT',
  Title = 'TITLE'
}

/** A paginated list of ProjectTimeBilling items. */
export type ProjectTimeBillingPaginator = {
  __typename?: 'ProjectTimeBillingPaginator';
  /** A list of ProjectTimeBilling items. */
  data: Array<ProjectTimeBilling>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Zdroj pre Time Billing (expense_item alebo oi_budget_item) */
export type ProjectTimeBillingSource = {
  __typename?: 'ProjectTimeBillingSource';
  amount: Scalars['BigInt']['output'];
  budgetItem?: Maybe<BudgetItemForExpenseInterface>;
  budget_item_id?: Maybe<Scalars['ID']['output']>;
  budget_item_type?: Maybe<BudgetItemTypeEnum>;
  components: Array<ProjectTimeBillingComponent>;
  created_at: Scalars['DateTime']['output'];
  expense?: Maybe<Expense>;
  expenseItem?: Maybe<ExpenseItem>;
  id: Scalars['ID']['output'];
  outgoingInvoice?: Maybe<OutgoingInvoice>;
  outgoing_invoice_id?: Maybe<Scalars['ID']['output']>;
  source_id?: Maybe<Scalars['ID']['output']>;
  source_type: TimeBillingSourceTypeEnum;
};

/** Preview zdroja (pre compute query) */
export type ProjectTimeBillingSourcePreview = {
  __typename?: 'ProjectTimeBillingSourcePreview';
  amount: Scalars['BigInt']['output'];
  budgetItem?: Maybe<BudgetItemForExpenseInterface>;
  budget_item_id?: Maybe<Scalars['ID']['output']>;
  budget_item_type?: Maybe<BudgetItemTypeEnum>;
  expense?: Maybe<Expense>;
  expenseItem?: Maybe<ExpenseItem>;
  outgoingInvoice?: Maybe<OutgoingInvoice>;
  outgoing_invoice_id?: Maybe<Scalars['ID']['output']>;
  source_id?: Maybe<Scalars['ID']['output']>;
  source_type: TimeBillingSourceTypeEnum;
};

/**
 * Riadok usera v Time Billing tabuľke.
 * Pre Work Expense záznamy (time tracking bez usera) je user null.
 */
export type ProjectTimeBillingUserRow = {
  __typename?: 'ProjectTimeBillingUserRow';
  amount: Scalars['BigInt']['output'];
  client_rate: Scalars['BigInt']['output'];
  created_at: Scalars['DateTime']['output'];
  effective_hourly_rate: Scalars['BigInt']['output'];
  effective_hourly_rate_invoiced: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  invoiced_time: Scalars['Int']['output'];
  overserviced_time: Scalars['Int']['output'];
  position?: Maybe<TimeTrackingWorkType>;
  spent: Scalars['BigInt']['output'];
  team?: Maybe<Team>;
  tracked_hours: Scalars['Float']['output'];
  tracked_time: Scalars['Int']['output'];
  uninvoiced_time: Scalars['Int']['output'];
  updated_at: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

/**
 * Preview user row (pre compute query).
 * Pre Work Expense záznamy (time tracking bez usera) je user_id a user null.
 */
export type ProjectTimeBillingUserRowPreview = {
  __typename?: 'ProjectTimeBillingUserRowPreview';
  amount: Scalars['BigInt']['output'];
  client_rate: Scalars['BigInt']['output'];
  effective_hourly_rate: Scalars['BigInt']['output'];
  effective_hourly_rate_invoiced: Scalars['BigInt']['output'];
  invoiced_time: Scalars['Int']['output'];
  overserviced_time: Scalars['Int']['output'];
  position?: Maybe<TimeTrackingWorkType>;
  spent: Scalars['BigInt']['output'];
  team?: Maybe<Team>;
  team_id?: Maybe<Scalars['ID']['output']>;
  time_tracking_work_type_id?: Maybe<Scalars['ID']['output']>;
  tracked_hours: Scalars['Float']['output'];
  tracked_time: Scalars['Int']['output'];
  uninvoiced_time: Scalars['Int']['output'];
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type ProjectTimeBreakdown = {
  __typename?: 'ProjectTimeBreakdown';
  budgeted: Scalars['Int']['output'];
  dateFrom?: Maybe<Scalars['Date']['output']>;
  dateTo?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  ourWorkBudgetItem: OurWorkBudgetItem;
  project: Project;
};

export type ProjectTimeBreakdownDetail = {
  __typename?: 'ProjectTimeBreakdownDetail';
  budgeted: Scalars['BigInt']['output'];
  budgeted_time: Scalars['Float']['output'];
  date_from?: Maybe<Scalars['Date']['output']>;
  date_to?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  personal_expenses: Scalars['BigInt']['output'];
  profit: Scalars['BigInt']['output'];
  tracked_amount: Scalars['BigInt']['output'];
  tracked_time: Scalars['Float']['output'];
};

export type ProjectTimeBreakdownResponse = {
  __typename?: 'ProjectTimeBreakdownResponse';
  budgeted: Scalars['BigInt']['output'];
  budgeted_time: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  personal_expenses: Scalars['BigInt']['output'];
  profit: Scalars['BigInt']['output'];
  time_breakdown: Array<ProjectTimeBreakdownDetail>;
  title: Scalars['String']['output'];
  tracked_amount: Scalars['BigInt']['output'];
  tracked_time: Scalars['Float']['output'];
};

export enum ProjectTypeEnum {
  FixedPrice = 'FIXED_PRICE',
  TimeMaterials = 'TIME_MATERIALS'
}

export type ProjectWithRevenue = {
  __typename?: 'ProjectWithRevenue';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  billable: Scalars['Boolean']['output'];
  brand: Brand;
  code: Scalars['String']['output'];
  expensesStructured: Array<ExpenseStructuredBudgetItemWithRevenue>;
  expenses_billings_for_date_range: Array<ProjectRevenueBillingsByExpenseCategory>;
  expenses_profit_for_date_range: Array<ProjectRevenueProfitByExpenseCategory>;
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  gross_income_for_date_range: Scalars['BigInt']['output'];
  gross_profit_for_date_range: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated No longer supported */
  is_pro_bono: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  ourWork: Array<OurWorkBudgetItemWithRevenue>;
  our_work_billings_for_date_range: Scalars['BigInt']['output'];
  our_work_revenue_for_date_range: Scalars['BigInt']['output'];
  projectManager: User;
  status: ProjectStatusEnum;
  title: Scalars['String']['output'];
  total_invoiced: Scalars['BigInt']['output'];
};

export type ProjectWithRevenueItem = {
  __typename?: 'ProjectWithRevenueItem';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  billable: Scalars['Boolean']['output'];
  brand: Brand;
  code: Scalars['String']['output'];
  expenses_billings_for_date_range: Array<ProjectRevenueBillingsByExpenseCategory>;
  expenses_profit_for_date_range: Array<ProjectRevenueProfitByExpenseCategory>;
  filtered_profit_share: Scalars['BigInt']['output'];
  filtered_revenue_share: Scalars['BigInt']['output'];
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  gross_income_for_date_range: Scalars['BigInt']['output'];
  gross_profit_for_date_range: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated No longer supported */
  is_pro_bono: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  ourWork: Array<OurWorkBudgetItemWithRevenue>;
  our_work_billings_for_date_range: Scalars['BigInt']['output'];
  our_work_revenue_for_date_range: Scalars['BigInt']['output'];
  projectManager: User;
  status: ProjectStatusEnum;
  title: Scalars['String']['output'];
  total_invoiced: Scalars['BigInt']['output'];
  total_profit_share: Scalars['BigInt']['output'];
  total_revenue_share: Scalars['BigInt']['output'];
};

export enum ProjectsAllWhereColumn {
  /** options: true, false */
  Billable = 'BILLABLE',
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  CreatedAt = 'CREATED_AT',
  FinishedAt = 'FINISHED_AT',
  Id = 'ID',
  /**
   * options: true, false
   * @deprecated No longer supported
   */
  IsProBono = 'IS_PRO_BONO',
  OtherProjectManagerId = 'OTHER_PROJECT_MANAGER_ID',
  ProjectManagerId = 'PROJECT_MANAGER_ID',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  TeamId = 'TEAM_ID'
}

export type ProjectsAllWhereConditions = {
  AND?: InputMaybe<Array<ProjectsAllWhereConditions>>;
  OR?: InputMaybe<Array<ProjectsAllWhereConditions>>;
  column?: InputMaybe<ProjectsAllWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export enum ProjectsLimitedWhereColumn {
  Billable = 'BILLABLE',
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  Id = 'ID',
  Status = 'STATUS',
  TeamId = 'TEAM_ID'
}

export type ProjectsLimitedWhereConditions = {
  AND?: InputMaybe<Array<ProjectsLimitedWhereConditions>>;
  OR?: InputMaybe<Array<ProjectsLimitedWhereConditions>>;
  column?: InputMaybe<ProjectsLimitedWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type ProjectsSummary = {
  __typename?: 'ProjectsSummary';
  budget_exceeded_expenses: Scalars['BigInt']['output'];
  budget_exceeded_our_work: Scalars['BigInt']['output'];
  budget_exceeded_total: Scalars['BigInt']['output'];
  credit: Scalars['BigInt']['output'];
  expenses_credit_balance: Scalars['BigInt']['output'];
  expenses_credit_proforma_balance: Scalars['BigInt']['output'];
  gross_income: Scalars['BigInt']['output'];
  net_margin_percent?: Maybe<Scalars['BigInt']['output']>;
  net_profit: Scalars['BigInt']['output'];
  our_work_credit_balance: Scalars['BigInt']['output'];
  our_work_credit_proforma_balance: Scalars['BigInt']['output'];
  our_work_efficiency: Scalars['BigInt']['output'];
  our_work_spent_budget: Scalars['BigInt']['output'];
  our_work_total_budget: Scalars['BigInt']['output'];
  profit: Scalars['BigInt']['output'];
  proforma_uninvoiced: Scalars['BigInt']['output'];
  projectIds: Array<Scalars['ID']['output']>;
  projects: Scalars['BigInt']['output'];
  real_expenses: Scalars['BigInt']['output'];
  total_budget: Scalars['BigInt']['output'];
  uninvoiced: Scalars['BigInt']['output'];
};

export enum ProjectsWhereColumn {
  ActiveInTimeframe = 'ACTIVE_IN_TIMEFRAME',
  /** options: true, false */
  ApprovedByClient = 'APPROVED_BY_CLIENT',
  /** options: true, false */
  ApprovedInternally = 'APPROVED_INTERNALLY',
  /** options: true, false */
  Billable = 'BILLABLE',
  BrandId = 'BRAND_ID',
  CategoryId = 'CATEGORY_ID',
  ClientId = 'CLIENT_ID',
  CreatedAt = 'CREATED_AT',
  ExpectedEndDate = 'EXPECTED_END_DATE',
  FinishedAt = 'FINISHED_AT',
  Id = 'ID',
  InvoicedStatus = 'INVOICED_STATUS',
  /**
   * options: true, false
   * @deprecated No longer supported
   */
  IsProBono = 'IS_PRO_BONO',
  IsTemplate = 'IS_TEMPLATE',
  /** options: true, false */
  NewerFinalVersionOfBudgetAvailable = 'NEWER_FINAL_VERSION_OF_BUDGET_AVAILABLE',
  OtherProjectManagerId = 'OTHER_PROJECT_MANAGER_ID',
  ProjectManagerId = 'PROJECT_MANAGER_ID',
  ProjectStageId = 'PROJECT_STAGE_ID',
  /** options: pinned, active, my_active, finished, archived, finished_archived */
  QuickFilter = 'QUICK_FILTER',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  TeamId = 'TEAM_ID',
  TotalBudget = 'TOTAL_BUDGET',
  Type = 'type'
}

export type ProjectsWhereConditions = {
  AND?: InputMaybe<Array<ProjectsWhereConditions>>;
  OR?: InputMaybe<Array<ProjectsWhereConditions>>;
  column?: InputMaybe<ProjectsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type PushNotificationSubscriptionKeys = {
  auth: Scalars['String']['input'];
  p256dh: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  EmailTemplates: Array<EmailTemplate>;
  /** permission: outgoingInvoice.read.all/own/team */
  ExpenseAttachmentsExport?: Maybe<Scalars['String']['output']>;
  GetQuote: Quote;
  GetQuoteEmailData: QuoteEmailData;
  GetUsersAllocatedTime?: Maybe<Array<UserAllocatedTime>>;
  GetUsersAllocationConflicts?: Maybe<Array<UserAllocationConflicts>>;
  WorkspaceNotifications: Array<WorkspaceNotification>;
  /** permission: outgoingInvoice.read.all/own/team */
  abraFlexiOIExport?: Maybe<Scalars['String']['output']>;
  /** permission: outgoingInvoice.read.all/own/team */
  abraFlexiOutgoingProformaInvoicesExport?: Maybe<Scalars['String']['output']>;
  accountingAccountsSimpleMap: Array<AccountingAccount>;
  accountingCentres: Array<AccountingCentre>;
  /** permission: task.read.all/own */
  availableTaskPositionsHoursByOurWorkBudget?: Maybe<Array<TaskPositionHour>>;
  bankAccountConverter: BankAccountConverter;
  bankAccountMoves?: Maybe<BankAccountMovePaginator>;
  bankAccounts?: Maybe<Array<BankAccount>>;
  banksQuery?: Maybe<Array<Bank>>;
  billingEntities?: Maybe<BillingEntityPaginator>;
  billingPlanBudget: Array<BillingPlanBudget>;
  /** permission: billingPlan.listing */
  billingPlanCacheOverview?: Maybe<BillingPlanBudgetCachePaginator>;
  /** permission: billingPlan.listing */
  billingPlanCacheOverviewSummary: BillingPlanCacheOverviewSummary;
  /** permission: billingPlan.listing */
  billingPlanOverview?: Maybe<BillingPlanMonthStatPaginator>;
  /** permission: billingPlan.listing */
  billingPlanOverviewSummary: BillingPlanOverviewSummary;
  /** permission: brand.read */
  brand?: Maybe<Brand>;
  /** permission: brandCreditAccount.read.all/team/own for given ID */
  brandCreditAccount?: Maybe<BrandCreditAccount>;
  /** permission: brandCreditAccount.read.all/team/own */
  brandCreditAccounts?: Maybe<BrandCreditAccountPaginator>;
  /** permission: brandCreditAccount.read.all/team/own */
  brandCreditAccountsSummary: BrandCreditAccountsSummary;
  brandRevenue: BrandRevenue;
  /** permission: project.read.all/team/own */
  brandRevenueSummary: BrandRevenueSummary;
  /** permission: brand.read */
  brands?: Maybe<BrandPaginator>;
  /** permission: brand.read */
  brandsForClient: Array<Brand>;
  brandsSimpleMap: Array<BrandSimple>;
  /** permission: brand.read */
  brandsSummary: BrandsSummary;
  budgetItemPlannedExpenses: Array<BudgetItemPlannedExpense>;
  budgetovacPosition?: Maybe<BudgetovacPosition>;
  budgetovacPositions: Array<BudgetovacPosition>;
  budgetovacPositionsSet?: Maybe<BudgetovacPositionsSet>;
  budgetovacPositionsSets: Array<BudgetovacBrandPositionsSet>;
  budgets: BudgetPaginator;
  budgetsExport: Scalars['String']['output'];
  budgetsForProject?: Maybe<Array<BudgetGroup>>;
  bulkConvertAmountFromWorkspaceCurrencyUsingUserExchangeRates: Array<ConvertedAmountWithIdentifier>;
  bulkConvertAmountToWorkspaceCurrencyUsingUserExchangeRates: Array<ConvertedAmountWithIdentifier>;
  /** permission: outgoingInvoice.read.all/own/team */
  bulkDownloadOutgoingInvoices?: Maybe<Scalars['String']['output']>;
  /** permission: outgoingInvoice.read.all/own/team */
  bulkDownloadOutgoingProformaInvoices?: Maybe<Scalars['String']['output']>;
  /** Capacity allocation detail. */
  capacityAllocationDetail?: Maybe<CapacityAllocation>;
  /** Capacity allocation item detail. */
  capacityAllocationItemDetailQuery?: Maybe<CapacityAllocationItem>;
  capacityAllocationItemList: Array<CapacityAllocationItem>;
  capacityAllocationItemTimeTrackingItems: Array<TimeTrackingItem>;
  /** permission: outgoingInvoice.accessAccountingAttributes */
  cfExport: Scalars['String']['output'];
  checkIfCreditAccountsBelongToTheSameTeam: Scalars['Boolean']['output'];
  checkInvoiceNumberExist?: Maybe<Scalars['Boolean']['output']>;
  checkTimeTrackingItemsLocked: Array<Scalars['ID']['output']>;
  /** permission: client.read */
  client?: Maybe<Client>;
  clientExchangeRatesForBudgetovac: Array<CurrencyExchangeRate>;
  /** permission: outgoingInvoice.read.all/own/team */
  clientOIExport: Scalars['String']['output'];
  /** permission: client.read */
  clients?: Maybe<ClientPaginator>;
  clientsSimpleMap: Array<ClientSimple>;
  /** permission: task.read.all/own for given task */
  commentHistory: Array<TaskComment>;
  companySettings?: Maybe<CompanySettings>;
  contacts: Array<Contact>;
  /** permission: contract.read */
  contract?: Maybe<Contract>;
  /** permission: contractor.read */
  contractor?: Maybe<Contractor>;
  /** permission: contractor.read */
  contractors?: Maybe<ContractorPaginator>;
  /** permission: contractor.read */
  contractorsBasic: ContractorsBasic;
  contractorsSimpleMap: Array<ContractorSimple>;
  /** permission: contractor.read */
  contractorsSummary: ContractorsSummary;
  /** permission: contract.read */
  contracts?: Maybe<ContractPaginator>;
  /** permission: contract.read */
  contractsExport: Scalars['String']['output'];
  contractsSimpleMap?: Maybe<Array<ContractSimple>>;
  /** permission: contract.read */
  contractsSummary: ContractsSummary;
  convertAmountToWorkspaceCurrencyUsingExchangeRate?: Maybe<ConvertedAmount>;
  countrySimpleMap: Array<CountrySimple>;
  /**
   * Compute/Preview Time Billing pre dané obdobie (BEZ uloženia)
   * Vráti vypočítané hodnoty, ktoré môže používateľ upraviť pred uložením
   * permission: project.read.all/own/team
   */
  createDataForProjectTimeBilling: ProjectTimeBillingComputed;
  creditAccount?: Maybe<CreditAccount>;
  currencies?: Maybe<Array<Currency>>;
  currency?: Maybe<Currency>;
  defaultCurrencies?: Maybe<Array<Maybe<DefaultCurrency>>>;
  /** permission: expense.read.all/team/own for given expense */
  expense: Expense;
  expenseAbraFlexiExport: Scalars['String']['output'];
  expenseBudgetCategories?: Maybe<Array<ExpenseBudgetCategory>>;
  /** permission: project.read.all/team/own */
  expenseBudgetItem?: Maybe<ExpenseBudgetItem>;
  /** permission: project.read.all/team/own */
  expenseBudgetItemsByItemCode: Array<ExpenseBudgetItemSimple>;
  expenseBudgetItemsSimpleMap: Array<ExpenseBudgetItemSimple>;
  /** permission: project.read.all/team/own */
  expenseBudgetItemsWithStatus: Array<ExpenseBudgetItemWithStatus>;
  expenseExport: Scalars['String']['output'];
  expenseItemDescriptions?: Maybe<Array<Maybe<ExpenseItemDesciption>>>;
  /** permission: expense.read.all/team/own */
  expenseItemsForProject?: Maybe<Array<ExpenseItemForProject>>;
  /**
   * Paginovany listing expense items pre Time Billing.
   * Vracia individualne expense_items s projektovymi datami a filtrami.
   * permission: expense.read.all/team/own
   */
  expenseItemsForTimeBilling?: Maybe<ExpenseItemPaginator>;
  /**
   * Summary (count + amount) pre expense items for Time Billing.
   * permission: expense.read.all/team/own
   */
  expenseItemsForTimeBillingSummary: TimeBillingSummary;
  expensePremierExport: Scalars['String']['output'];
  /** permission: expense.accessAccountingAttributes */
  expenseSummaryExportBulk: Scalars['String']['output'];
  /** permission: expense.accessAccountingAttributes */
  expenseSummaryExportSimple: Scalars['String']['output'];
  /** permission: expense.accessAccountingAttributes */
  expenseXMLExport: Scalars['String']['output'];
  expenseXeroExport: Scalars['String']['output'];
  /** permission: expense.read.all/team/own */
  expenses?: Maybe<ExpensePaginator>;
  /** permission: expense.read.all/team/own */
  expensesSummary: ExpensesSummary;
  /** permission: billingPlan.listing */
  exportBillingPlan: Scalars['String']['output'];
  externalLinks: Array<ExternalLink>;
  /**
   * Extracts expense data from an attachment file using OCR/AI.
   * Returns data in format compatible with CreateExpenseInput for form prefill.
   * permission: expense.create
   */
  fetchOCRExpenseData?: Maybe<OcrExpenseData>;
  filterTemplates: Array<FilterTemplate>;
  financeSettings?: Maybe<FinanceSettings>;
  /** permission: outgoingInvoice.read.all/own/team */
  financialOIExport?: Maybe<Scalars['String']['output']>;
  fondContractorsSimpleMap: Array<FondContractorSimple>;
  /** permission: expense.accessAccountingAttributes */
  generateExpensePaymentOrder: ExpensePaymentOrderResponse;
  getAccessTokenForThirdParty?: Maybe<Scalars['String']['output']>;
  /** permission: project.read.all/team/own */
  getActiveProjectBudgetExceededCount: Scalars['BigInt']['output'];
  getAutocompleteForCompanyData: AutocompleteCompanyData;
  getAvailableProjectsForBulkMovingTimeTrackingItems: Array<ProjectSimple>;
  getAvailableWorkTypesForBulkMovingTimeTrackingItems: Array<TimeTrackingWorkType>;
  getBillingPlanBudgetPdf: Scalars['String']['output'];
  getBudgetQuotes: QuotesPaginator;
  getCompanyDataByRegistrationNo?: Maybe<CompanyData>;
  /** permission: expense.read.all/team/own */
  getDuplicateExpensesIDs: Array<Scalars['ID']['output']>;
  getInvoiceEmailData?: Maybe<InvoiceEmailData>;
  /** permission: expense.accessAccountingAttributes */
  getLatestExpenseInternalNumberPerType: Array<LatestExpenseInternalNumberPerType>;
  getModelLock?: Maybe<ModelLock>;
  getNewInvoiceNumber: Array<InvoiceSequenceData>;
  getNextNumericalBrandCode: Scalars['String']['output'];
  /** Permission list of the currently authenticated User or ApiClient. */
  getPermissions: PermissionList;
  getPipedriveStages?: Maybe<Array<PipedriveStage>>;
  getProformaInvoiceEmailData?: Maybe<InvoiceEmailData>;
  /** permission: project.read.all/team/own */
  getProjectCanBeFinishedSummary: ProjectFinishSummary;
  /** permission: requestForInvoicing.read.all/own/team */
  getSubmittedRfiCount: Scalars['BigInt']['output'];
  getTags?: Maybe<Array<Tag>>;
  /**
   * permission: timeTracking.report.read.all/team/own
   * Paginated time tracking items with billing info (hourly_rate, amount)
   */
  getTimeTrackingItems: GetTimeTrackingItemsPaginator;
  /**
   * permission: timeTracking.report.read.all/team/own
   * Summary (all ids, totals for times and amounts) for the getTimeTrackingItems query
   */
  getTimeTrackingItemsSummary: GetTimeTrackingItemsSummary;
  getTotalInWords: Scalars['String']['output'];
  getUnmatchedWorkTypesForTaskMove: TaskMoveUnmatchedData;
  globalCreditAccount?: Maybe<GlobalCreditAccount>;
  globalCreditAccounts?: Maybe<GlobalCreditAccountPaginator>;
  hasTaskPermission: Scalars['Boolean']['output'];
  invoicePaymentMethods: Array<InvoicePaymentMethod>;
  isUserInTask: Scalars['Boolean']['output'];
  languagesForInvoicePdf: Array<Scalars['String']['output']>;
  lowestDateWithOpenProgress?: Maybe<Scalars['Date']['output']>;
  me?: Maybe<User>;
  /** permission: project.read.all/team/own */
  mlggkProjectsEffectivenessExport: Scalars['String']['output'];
  /** permission: outgoingInvoice.accessAccountingAttributes */
  mrpOIExport: Scalars['String']['output'];
  /** permission: outgoingInvoice.read.all/own/team */
  notPaidOIExport: Scalars['String']['output'];
  notificationSettings: Array<NotificationSetting>;
  notificationWorkspaceSettings?: Maybe<NotificationSettings>;
  notifications?: Maybe<NotificationPaginator>;
  /**
   * Paginovany listing OI budget items pre Time Billing.
   * Vracia kombinacie outgoing_invoice + budget_item (OurWork + Expense) so sumou.
   * permission: outgoingInvoice.read.all/own/team
   */
  oiBudgetItemsForTimeBilling: OiBudgetItemsForTimeBillingPaginator;
  /**
   * Summary (count + amount) pre OI budget items for Time Billing.
   * permission: outgoingInvoice.read.all/own/team
   */
  oiBudgetItemsForTimeBillingSummary: TimeBillingSummary;
  omegaExpenseExport?: Maybe<Scalars['String']['output']>;
  omegaExport?: Maybe<Scalars['String']['output']>;
  omegaProformaExport?: Maybe<Scalars['String']['output']>;
  /** permission: order.read */
  order?: Maybe<Order>;
  /** permission: order.read */
  orders?: Maybe<OrderPaginator>;
  /** permission: order.read */
  ordersSummary: OrdersSummary;
  /** permission: order.read */
  ordersWithPdf: Array<Order>;
  /** permission: otherDocument.read */
  otherDocument?: Maybe<OtherDocument>;
  /** permission: otherDocument.read */
  otherDocuments?: Maybe<OtherDocumentPaginator>;
  /** permission: otherDocument.read */
  otherDocumentsSummary: OtherDocumentsSummary;
  /** permission: otherDocument.read */
  otherDocumentsWithPdf: Array<OtherDocument>;
  ourWorkBudgetCategories?: Maybe<Array<OurWorkBudgetCategory>>;
  /** permission: project.read.all/team/own */
  ourWorkBudgetItem?: Maybe<OurWorkBudgetItem>;
  /** permission: project.read.all/team/own */
  ourWorkBudgetItemsByItemCode: Array<OurWorkBudgetItemSimple>;
  ourWorkBudgetItemsSimpleMap: Array<OurWorkBudgetItemSimple>;
  /** permission: outgoingInvoice.read.all/own/team */
  outgoingInvoice?: Maybe<OutgoingInvoice>;
  /** permission: outgoingInvoice.read.all/own/team */
  outgoingInvoices?: Maybe<OutgoingInvoicePaginator>;
  /** permission: outgoingInvoice.read.all/own/team */
  outgoingInvoicesSummary: OutgoingInvoicesSummary;
  /** permission: outgoingInvoice.read.all/own/team */
  outgoingProformaInvoice?: Maybe<OutgoingProformaInvoice>;
  /** permission: outgoingInvoice.read.all/own/team */
  outgoingProformaInvoices?: Maybe<OutgoingProformaInvoicePaginator>;
  /** permission: outgoingInvoice.read.all/own/team */
  outgoingProformaInvoicesSummary: OutgoingProformaInvoicesSummary;
  paymentSettings?: Maybe<PaymentSettings>;
  paymentTypes: Array<PaymentType>;
  /**
   * Listing projektov s prehladom planovanych nakladov (planned expenses)
   * Pre kazdy projekt zobrazuje budget items (Our Work + Expense) s agregovanymu sumami
   * z budget_item_planned_expenses + stats views
   *
   * permission: project.read.all/own/team
   */
  plannedExpensesOverview?: Maybe<PlannedExpensesProjectPaginator>;
  /**
   * Sumarizacia pre planned expenses overview (celkove statistiky napriec filtrovanymi projektami)
   *
   * permission: project.read.all/own/team
   */
  plannedExpensesOverviewSummary: PlannedExpensesSummary;
  planningDailyViewPeople: PlanningDailyViewPaginator;
  planningDailyViewUnassignedTasks: Array<PlanningDailyViewUnassignedTasksPerDay>;
  /** permission: outgoingInvoice.read.all/own/team */
  pohodaExpenseExport?: Maybe<Scalars['String']['output']>;
  /** permission: outgoingInvoice.read.all/own/team */
  pohodaOIExport?: Maybe<Scalars['String']['output']>;
  pohodaOPIExport?: Maybe<Scalars['String']['output']>;
  /** permission: outgoingInvoice.read.all/own/team */
  premierOIExport?: Maybe<Scalars['String']['output']>;
  premierProformaOIExport?: Maybe<Scalars['String']['output']>;
  prepareTaskDataForBulkActions: TaskBulkActionsData;
  /**
   * Preview/Prepočet Time Billing z poskytnutých dát (BEZ uloženia)
   * Používa sa na real-time prepočítavanie hodnôt počas editácie
   * permission: project.read.all/own/team
   */
  previewProjectTimeBilling: ProjectTimeBillingComputed;
  profitLossReport: ProfitLossReportGroupPaginator;
  profitLossReportSummary: ProfitLossReportSummary;
  /** permission: project.read.all/team/own */
  project?: Maybe<Project>;
  /**
   * Detail jedného projektu s billing plánom
   *
   * permission: project.read.all/own/team
   */
  projectBilling: ProjectBilling;
  /**
   * Listing projektov s billing plánmi a faktúrami
   * Zobrazuje plánované faktúry z BillingPlanBudgetCache + skutočné faktúry
   * Pre manuálne billing plány zobrazuje len existujúce faktúry + summary riadok
   *
   * Parameter with_prepayment:
   * - false (default): Zobrazí len faktúry, invoiced_amount je celková suma faktúry
   * - true: Pridá samostatné riadky pre prepayment čerpania a zníži invoiced_amount o použité prepayments
   *
   * permission: project.read.all/own/team AND outgoingInvoice.read.all/own/team
   */
  projectBillings?: Maybe<ProjectBillingPaginator>;
  /**
   * Export projektových factúr do Excelu
   *
   * permission: project.read.all/own/team AND outgoingInvoice.read.all/own/team
   */
  projectBillingsExport: Scalars['String']['output'];
  /**
   * Štatistiky pre project billings
   *
   * permission: project.read.all/own/team
   */
  projectBillingsSummary: ProjectBillingsSummary;
  projectCategories: Array<ProjectCategory>;
  projectDatesForBudgetChange: ProjectDatesForBudgetChange;
  /** the minimum necessary data for someone who doesnt have access to the whole project but has to an expense */
  projectForExpense: ProjectForExpense;
  projectForTask: ProjectForTask;
  /** permission: project.read.all/team/own */
  projectGraph: ProjectGraph;
  projectHasTimeTrackedForPositions: Array<TimeTrackingWorkType>;
  projectLimited?: Maybe<ProjectLimited>;
  projectManagerSimpleMap: Array<UserSimple>;
  /** permission: wip.read.all/team/own */
  projectProgressStatisticsExport: Scalars['String']['output'];
  projectRateCard: Array<Maybe<ProjectRateCard>>;
  /** permission: project.read.all/team/own */
  projectRevenue: ProjectRevenue;
  projectRevenueDetail: ProjectWithRevenue;
  /** permission: project.read.all/team/own */
  projectRevenueSummary: ProjectRevenueSummary;
  projectSettings?: Maybe<ProjectSettings>;
  projectStages: Array<ProjectStage>;
  /**
   * Detail Time Billing podľa ID
   * permission: project.read.all/own/team (cez project)
   */
  projectTimeBilling?: Maybe<ProjectTimeBilling>;
  /**
   * Zoznam Time Billings pre projekt
   * permission: project.read.all/own/team
   */
  projectTimeBillings?: Maybe<ProjectTimeBillingPaginator>;
  projectTimeBreakdowns: Array<ProjectTimeBreakdownResponse>;
  /** permission: wip.read.all/team/own */
  projectWipExport: Scalars['String']['output'];
  /** permission: project.read.all/team/own */
  projects?: Maybe<ProjectPaginator>;
  projectsAll?: Maybe<ProjectSimplePaginator>;
  /** permission: project.read.all/team/own */
  projectsCommissionExport: Scalars['String']['output'];
  /** permission: project.read.all/team/own */
  projectsEffectivenessExport: Scalars['String']['output'];
  /** permission: project.read.all/team/own */
  projectsForPlanovac?: Maybe<ProjectForPlanovacPaginator>;
  projectsLimited?: Maybe<ProjectLimitedPaginator>;
  /** permission: project.read.all/team/own */
  projectsProfitExport: Scalars['String']['output'];
  projectsSimpleMap: Array<ProjectSimple>;
  /** permission: project.read.all/team/own */
  projectsSummary: ProjectsSummary;
  /** permission: wip.read.all/team/own */
  projectsWithPeriods?: Maybe<WorkInProgressProjectStatPaginator>;
  /** permission: outgoingInvoice.read.all/own/team */
  prolucOIExport?: Maybe<Scalars['String']['output']>;
  /** permission: requestForInvoicing.read.all/own/team */
  requestForInvoicing?: Maybe<RequestForInvoicing>;
  /** permission: requestForInvoicing.read.all/own/team */
  requestsForInvoicing?: Maybe<RequestForInvoicingPaginator>;
  /** permission: requestForInvoicing.read.all/own/team */
  requestsForInvoicingSummary: RequestsForInvoicingSummary;
  responsiblePersonsSimpleMap: Array<UserSimple>;
  roles: Array<Role>;
  runningTimer?: Maybe<Timer>;
  sequenceSettings?: Maybe<Array<Sequence>>;
  /** permission: task.read.all/own for given task */
  task: Task;
  taskAndCommunicationNotifications: TaskAndCommunicationNotificationsPaginator;
  /**
   * Card counts per board column for the same filters as `tasks`, one page of columns at a time.
   * DONE statuses collapse into the `complete` column, which is returned only with `include_complete`.
   * With `group_values`, only those columns are returned (e.g. source and target after a move) and
   * `first`/`page`/`include_complete` are ignored; `unassigned` and `complete` are valid values.
   * Columns list every workspace user and time totals, so scoped users are left out.
   * permission: task.read.all/own + task.viewAllFields
   */
  taskBoardColumnCounts: TaskBoardColumnCountPaginator;
  /**
   * Current user's board settings for the given board_key. Null when none saved yet.
   * permission: none, own settings only (authenticated user)
   */
  taskBoardSettings?: Maybe<TaskBoardSettings>;
  taskCommentFiles: Array<AssignableFile>;
  /** permission: task.read.all/own for given task */
  taskComments?: Maybe<TaskCommentPaginator>;
  taskIds?: Maybe<Array<Scalars['ID']['output']>>;
  taskLinkTypes: Array<TaskLinkType>;
  /** permission: task.read.all/own for given task */
  taskPositionStat: Array<TaskPositionStat>;
  taskPriorities: Array<TaskPriority>;
  taskStatuses: Array<TaskStatus>;
  taskTemplateGroup: TaskTemplateGroup;
  taskTemplateGroups: Array<Maybe<TaskTemplateGroup>>;
  /** permission: task.read.all/own */
  tasks?: Maybe<TaskPaginator>;
  tasksSimpleMap: Array<TaskSimple>;
  teamSimpleMap: Array<Team>;
  timeMaterialsInvoiceData: TimeMaterialsDataForInvoicing;
  /** All available time off types. */
  timeOffTypesQuery?: Maybe<Array<TimeOffType>>;
  /** Time offs export. */
  timeOffsExport: Scalars['String']['output'];
  timeTrackingItem: TimeTrackingItem;
  /** permission: timeTracking.read.all/team/own */
  timeTrackingItems: Array<TimeTrackingItem>;
  /** permission: timeTracking.read.all */
  timeTrackingItemsPaginated?: Maybe<TimeTrackingItemPaginator>;
  /**
   * Distinct work types the given time tracking items are tracked on.
   * permission: timeTracking.read.all/team/own
   */
  timeTrackingItemsWorkTypes: Array<TimeTrackingWorkType>;
  /** use me for time tracking modal, no permissions needed */
  timeTrackingOptionsForProject: TimeTrackingOptionsForProject;
  /** permission: project.timeTrackingReport.read.all/team/own */
  timeTrackingProjectReport?: Maybe<Array<Maybe<TimeTrackingProjectReport>>>;
  /**
   * permission: timeTracking.report.read.all/team/own
   * orderBy radí položky vnútri skupín (items), nie skupiny samotné.
   */
  timeTrackingReport: TimeTrackingReportPaginator;
  /** permission: timeTracking.report.read.all/team/own */
  timeTrackingReportExport: Scalars['String']['output'];
  timeTrackingReportExportPdf: Scalars['String']['output'];
  /** permission: timeTracking.report.read.all/team/own */
  timeTrackingReportSummary: TimeTrackingReportSummary;
  /** permission: timeTracking.read.all/team/own */
  timeTrackingSummaryPerDay?: Maybe<Array<TimeTrackingSummaryPerDay>>;
  timeTrackingWorkTypes: Array<TimeTrackingWorkType>;
  transakcioExpenseExport?: Maybe<Scalars['String']['output']>;
  /** permission: project.read.all/team/own */
  triadProjectsEffectivenessExport: Scalars['String']['output'];
  unreadNotificationsCount: Scalars['BigInt']['output'];
  /** permission: outgoingInvoice.read.all/own/team */
  unusedPaidOutgoingProformaInvoices: Array<OutgoingProformaInvoice>;
  updateWorkspacePlanningSettings: WorkspacePlanningSettings;
  /** permission: user.read.all/user.read.own */
  user?: Maybe<User>;
  /** permission: timeTracking.report.read.all/team/own */
  userEffectivenessReportExport: Scalars['String']['output'];
  userMonthlyReport: UserMonthlyReportPaginator;
  /** permission: timeTracking.userMonthlyReport.read */
  userMonthlyReportExport: Scalars['String']['output'];
  userSimpleMap: Array<UserSimple>;
  /** permission: user.read.all */
  users?: Maybe<UserPaginator>;
  /** permission: user.read */
  usersForPlanovac: Array<UserForPlanovac>;
  /** permission: user.read.all */
  usersSummary: UsersSummary;
  /** permission: utilizationReport.query.all */
  utilizationReport: UtilizationReportPaginator;
  /** permission: utilizationReport.query.all */
  utilizationReportExport: Scalars['String']['output'];
  /** permission: utilizationReport.query.all */
  utilizationReportGroups: UtilizationReportGroupPaginator;
  /** permission: utilizationReport.query.all */
  utilizationReportSummary: UtilizationReport;
  /** permission: utilizationReport.query.all */
  utilizationTaskReport: Array<UtilizationTaskReport>;
  /** permission: utilizationReport.query.all */
  utilizationUserReport?: Maybe<UtilizationUserReport>;
  varioExpenseExport?: Maybe<Scalars['String']['output']>;
  varioOIExport?: Maybe<Scalars['String']['output']>;
  vatRates?: Maybe<Array<VatRate>>;
  verifyAccessTokenFromThirdParty?: Maybe<SingleSignOnData>;
  /** permission: timeTracking.read.all/team/own */
  weekTimeReport: WeekTimeReport;
  wipForBudgetAndPeriod?: Maybe<WorkInProgressItemStat>;
  wipPeriodsMap: Array<WipPeriod>;
  /** permission: wip.read.all/team/own */
  wipProjectsPeriodSummary: PeriodSummary;
  workspaceAccountingAccountSetting: WorkspaceAccountingAccountSettings;
  workspaceAccountingCentreSetting: WorkspaceAccountingCentreSettings;
  workspaceAccountingVatClassificationSetting: WorkspaceAccountingVatClassificationSettings;
  workspaceAutoExpenseEmailSettings?: Maybe<WorkspaceAutoExpenseEmailSettings>;
  workspaceCompaniesSettings: Array<WorkspaceCompanySetting>;
  workspaceExchangeRatesForBudgetovac: Array<CurrencyExchangeRate>;
  workspaceFinancialSettings: WorkspaceFinancialSetting;
  workspacePipedriveIntegration: WorkspacePipedriveIntegration;
  workspaceProjectSettings: WorkspaceProjectSettings;
  workspaceSettings?: Maybe<WorkspaceSettings>;
  workspaceSmtpSettings?: Maybe<WorkspaceSmtpSettings>;
  workspaceTaskSettings: WorkspaceTaskSettings;
  workspaceUserManagementSetting: WorkspaceUserManagementSetting;
  /** permission: outgoingInvoice.read.all/own/team */
  xeroOIExport?: Maybe<Scalars['String']['output']>;
};


export type QueryExpenseAttachmentsExportArgs = {
  expense_ids: Array<Scalars['ID']['input']>;
};


export type QueryGetQuoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetQuoteEmailDataArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetUsersAllocatedTimeArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  types: Array<CapacityAllocationTypeEnum>;
  user_ids: Array<Scalars['ID']['input']>;
};


export type QueryGetUsersAllocationConflictsArgs = {
  from: Scalars['Date']['input'];
  from_time?: InputMaybe<Scalars['Time']['input']>;
  repetition_settings?: InputMaybe<Array<InputMaybe<RepetitionSettingsDaysEnum>>>;
  to: Scalars['Date']['input'];
  to_time?: InputMaybe<Scalars['Time']['input']>;
  types: Array<CapacityAllocationTypeEnum>;
  user_ids: Array<Scalars['ID']['input']>;
};


export type QueryAbraFlexiOiExportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  outgoing_invoice_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAbraFlexiOutgoingProformaInvoicesExportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryAccountingAccountsSimpleMapArgs = {
  type?: InputMaybe<Accounting_Account_Type>;
};


export type QueryAccountingCentresArgs = {
  type?: InputMaybe<Accounting_Centre_Type>;
};


export type QueryAvailableTaskPositionsHoursByOurWorkBudgetArgs = {
  our_work_budget_item_id: Scalars['ID']['input'];
};


export type QueryBankAccountConverterArgs = {
  account_code?: InputMaybe<Scalars['String']['input']>;
  account_number: Scalars['String']['input'];
  country_id: Scalars['ID']['input'];
};


export type QueryBankAccountMovesArgs = {
  filters?: InputMaybe<BankAccountMoveQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBillingEntitiesArgs = {
  filters?: InputMaybe<BillingEntityQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBillingPlanBudgetArgs = {
  billing_item_type: BillingItemTypEnum;
  project_id: Scalars['ID']['input'];
};


export type QueryBillingPlanCacheOverviewArgs = {
  filters: BillingPlanCacheOverviewQueryArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBillingPlanCacheOverviewSummaryArgs = {
  filters: BillingPlanCacheOverviewQueryArgs;
};


export type QueryBillingPlanOverviewArgs = {
  filters: BillingPlanOverviewQueryArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBillingPlanOverviewSummaryArgs = {
  filters: BillingPlanOverviewQueryArgs;
};


export type QueryBrandArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBrandCreditAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBrandCreditAccountsArgs = {
  filters?: InputMaybe<CreditAccountQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBrandCreditAccountsSummaryArgs = {
  filters?: InputMaybe<CreditAccountQueryArgs>;
};


export type QueryBrandRevenueArgs = {
  filters?: InputMaybe<BrandRevenueQueryArgs>;
};


export type QueryBrandRevenueSummaryArgs = {
  filters?: InputMaybe<BrandRevenueQueryArgs>;
};


export type QueryBrandsArgs = {
  filters?: InputMaybe<BrandQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBrandsForClientArgs = {
  client_id: Scalars['ID']['input'];
};


export type QueryBrandsSummaryArgs = {
  filters?: InputMaybe<BrandQueryArgs>;
};


export type QueryBudgetItemPlannedExpensesArgs = {
  budget_item_id: Scalars['ID']['input'];
  budget_item_type: ExpenseBudgetItemTypeEnum;
};


export type QueryBudgetovacPositionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBudgetovacPositionsSetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBudgetovacPositionsSetsArgs = {
  client_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBudgetsArgs = {
  filters?: InputMaybe<BudgetArgs>;
};


export type QueryBudgetsExportArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  options?: InputMaybe<BudgetExportOptionsInput>;
};


export type QueryBudgetsForProjectArgs = {
  project_id: Scalars['ID']['input'];
};


export type QueryBulkConvertAmountFromWorkspaceCurrencyUsingUserExchangeRatesArgs = {
  currency_id: Scalars['ID']['input'];
  exchange_rate: Scalars['BigInt']['input'];
  items: Array<AmountToConvert>;
  workspace_company_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBulkConvertAmountToWorkspaceCurrencyUsingUserExchangeRatesArgs = {
  currency_id: Scalars['ID']['input'];
  exchange_rate: Scalars['BigInt']['input'];
  items: Array<AmountToConvert>;
  workspace_company_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBulkDownloadOutgoingInvoicesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryBulkDownloadOutgoingProformaInvoicesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCapacityAllocationDetailArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCapacityAllocationItemDetailQueryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCapacityAllocationItemListArgs = {
  date: Scalars['Date']['input'];
  task_id?: InputMaybe<Scalars['ID']['input']>;
  user_id: Scalars['ID']['input'];
};


export type QueryCapacityAllocationItemTimeTrackingItemsArgs = {
  id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};


export type QueryCfExportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryCheckIfCreditAccountsBelongToTheSameTeamArgs = {
  credit_account_ids: Array<Scalars['ID']['input']>;
};


export type QueryCheckInvoiceNumberExistArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  document_id?: InputMaybe<Scalars['ID']['input']>;
  document_no?: InputMaybe<Scalars['String']['input']>;
  invoice_order_sequence_id: Scalars['ID']['input'];
  invoice_type?: InputMaybe<SequenceTypesEnum>;
  workspace_company_id: Scalars['ID']['input'];
};


export type QueryCheckTimeTrackingItemsLockedArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryClientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientExchangeRatesForBudgetovacArgs = {
  client_id: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryClientOiExportArgs = {
  filters?: InputMaybe<OiQueryArgs>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryClientsArgs = {
  filters?: InputMaybe<ClientQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClientsSimpleMapArgs = {
  deleted_at_since?: InputMaybe<Scalars['DateTime']['input']>;
  updated_at_since?: InputMaybe<Scalars['DateTime']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCommentHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactsArgs = {
  orderBy?: InputMaybe<Array<QueryContactsOrderByOrderByClause>>;
};


export type QueryContractArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContractorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContractorsArgs = {
  filters?: InputMaybe<ContractorQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContractorsBasicArgs = {
  filters?: InputMaybe<ContractorBasicQueryArgs>;
};


export type QueryContractorsSummaryArgs = {
  filters?: InputMaybe<ContractorQueryArgs>;
};


export type QueryContractsArgs = {
  filters?: InputMaybe<ContractQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContractsExportArgs = {
  filters?: InputMaybe<ContractQueryArgs>;
};


export type QueryContractsSimpleMapArgs = {
  contractor_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContractsSummaryArgs = {
  filters?: InputMaybe<ContractQueryArgs>;
};


export type QueryConvertAmountToWorkspaceCurrencyUsingExchangeRateArgs = {
  amount_in_currency: Scalars['BigInt']['input'];
  client_id?: InputMaybe<Scalars['ID']['input']>;
  currency_id: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  exchange_rate?: InputMaybe<Scalars['BigInt']['input']>;
  project_id?: InputMaybe<Scalars['ID']['input']>;
  type: ExchangeRateSource;
  workspace_company_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCreateDataForProjectTimeBillingArgs = {
  date_from: Scalars['Date']['input'];
  date_to: Scalars['Date']['input'];
  project_id: Scalars['ID']['input'];
};


export type QueryCreditAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExpenseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExpenseAbraFlexiExportArgs = {
  expense_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryExpenseBudgetCategoriesArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type QueryExpenseBudgetItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryExpenseBudgetItemsByItemCodeArgs = {
  item_code: Scalars['String']['input'];
  project_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryExpenseBudgetItemsSimpleMapArgs = {
  project_id: Scalars['ID']['input'];
};


export type QueryExpenseBudgetItemsWithStatusArgs = {
  project_id: Scalars['ID']['input'];
};


export type QueryExpenseExportArgs = {
  filters?: InputMaybe<ExpenseQueryArgs>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryExpenseItemsForProjectArgs = {
  budget_item_id: Scalars['ID']['input'];
};


export type QueryExpenseItemsForTimeBillingArgs = {
  filters?: InputMaybe<ExpenseItemsTimeBillingQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExpenseItemsForTimeBillingSummaryArgs = {
  filters?: InputMaybe<ExpenseItemsTimeBillingQueryArgs>;
};


export type QueryExpensePremierExportArgs = {
  expense_ids: Array<Scalars['ID']['input']>;
};


export type QueryExpenseSummaryExportBulkArgs = {
  id: Array<Scalars['ID']['input']>;
};


export type QueryExpenseSummaryExportSimpleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExpenseXmlExportArgs = {
  filters?: InputMaybe<ExpenseQueryArgs>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryExpenseXeroExportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryExpensesArgs = {
  filters?: InputMaybe<ExpenseQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExpensesSummaryArgs = {
  filters?: InputMaybe<ExpenseQueryArgs>;
};


export type QueryExportBillingPlanArgs = {
  month: Scalars['BigInt']['input'];
  year: Scalars['BigInt']['input'];
};


export type QueryExternalLinksArgs = {
  model_type?: InputMaybe<ExternalLinkType>;
};


export type QueryFetchOcrExpenseDataArgs = {
  file: Scalars['Upload']['input'];
};


export type QueryFilterTemplatesArgs = {
  model_id?: InputMaybe<Scalars['ID']['input']>;
  model_type: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFinancialOiExportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryGenerateExpensePaymentOrderArgs = {
  date: Scalars['Date']['input'];
  expense_ids: Array<Scalars['ID']['input']>;
  payment_type_id: Scalars['ID']['input'];
  type: ExpensePaymentOrderExportType;
};


export type QueryGetAccessTokenForThirdPartyArgs = {
  appName?: InputMaybe<ThirdPartyEnum>;
};


export type QueryGetAutocompleteForCompanyDataArgs = {
  country_id: Scalars['ID']['input'];
  input: Scalars['String']['input'];
};


export type QueryGetAvailableProjectsForBulkMovingTimeTrackingItemsArgs = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  time_tracking_item_ids: Array<Scalars['ID']['input']>;
};


export type QueryGetAvailableWorkTypesForBulkMovingTimeTrackingItemsArgs = {
  time_tracking_item_ids: Array<Scalars['ID']['input']>;
};


export type QueryGetBillingPlanBudgetPdfArgs = {
  project_id: Scalars['ID']['input'];
};


export type QueryGetBudgetQuotesArgs = {
  filters?: InputMaybe<QuotesArgs>;
};


export type QueryGetCompanyDataByRegistrationNoArgs = {
  country_id: Scalars['ID']['input'];
  registration_no: Scalars['String']['input'];
};


export type QueryGetDuplicateExpensesIDsArgs = {
  contractor_id: Scalars['ID']['input'];
  document_number: Scalars['String']['input'];
  exclude_expense_id?: InputMaybe<Scalars['ID']['input']>;
  variable_symbol: Scalars['String']['input'];
};


export type QueryGetInvoiceEmailDataArgs = {
  outgoing_invoice_id: Scalars['ID']['input'];
};


export type QueryGetModelLockArgs = {
  lockable_id: Scalars['ID']['input'];
  lockable_type: ModelLockLockableTypeEnum;
};


export type QueryGetNewInvoiceNumberArgs = {
  date: Scalars['Date']['input'];
  document_id?: InputMaybe<Scalars['ID']['input']>;
  invoice_order_sequence_id?: InputMaybe<Scalars['ID']['input']>;
  invoice_type?: InputMaybe<SequenceTypesEnum>;
  workspace_company_id: Scalars['ID']['input'];
};


export type QueryGetProformaInvoiceEmailDataArgs = {
  outgoing_proforma_invoice_id: Scalars['ID']['input'];
};


export type QueryGetProjectCanBeFinishedSummaryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTagsArgs = {
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetTimeTrackingItemsArgs = {
  first?: InputMaybe<Scalars['BigInt']['input']>;
  from: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<TimeTrackingItemOrderByClause>>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  to: Scalars['Date']['input'];
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
};


export type QueryGetTimeTrackingItemsSummaryArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
};


export type QueryGetTotalInWordsArgs = {
  amount: Scalars['BigInt']['input'];
  language: Scalars['String']['input'];
};


export type QueryGetUnmatchedWorkTypesForTaskMoveArgs = {
  new_project_id: Scalars['ID']['input'];
  task_ids: Array<Scalars['ID']['input']>;
};


export type QueryGlobalCreditAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGlobalCreditAccountsArgs = {
  filters?: InputMaybe<GlobalCreditAccountQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHasTaskPermissionArgs = {
  task_id: Scalars['ID']['input'];
  type: TaskPermissionTypeEnum;
};


export type QueryIsUserInTaskArgs = {
  task_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};


export type QueryMlggkProjectsEffectivenessExportArgs = {
  dateOfSupply?: InputMaybe<DateRange>;
  filters?: InputMaybe<ProjectQueryArgs>;
  finishedAt?: InputMaybe<DateRange>;
  startDate?: InputMaybe<DateRange>;
};


export type QueryMrpOiExportArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};


export type QueryNotPaidOiExportArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  filters?: InputMaybe<OiQueryArgs>;
};


export type QueryNotificationsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<InputMaybe<NotificationGroup>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<NotificationType>;
};


export type QueryOiBudgetItemsForTimeBillingArgs = {
  filters?: InputMaybe<OiBudgetItemsTimeBillingQueryArgs>;
};


export type QueryOiBudgetItemsForTimeBillingSummaryArgs = {
  filters?: InputMaybe<OiBudgetItemsTimeBillingQueryArgs>;
};


export type QueryOmegaExpenseExportArgs = {
  expense_ids: Array<Scalars['ID']['input']>;
};


export type QueryOmegaExportArgs = {
  outgoing_invoice_ids: Array<Scalars['ID']['input']>;
};


export type QueryOmegaProformaExportArgs = {
  outgoing_proforma_invoice_ids: Array<Scalars['ID']['input']>;
};


export type QueryOrderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrdersArgs = {
  filters?: InputMaybe<OrderQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrdersSummaryArgs = {
  filters?: InputMaybe<OrderQueryArgs>;
};


export type QueryOrdersWithPdfArgs = {
  brand_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  project_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryOtherDocumentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOtherDocumentsArgs = {
  filters?: InputMaybe<OtherDocumentQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOtherDocumentsSummaryArgs = {
  filters?: InputMaybe<OtherDocumentQueryArgs>;
};


export type QueryOtherDocumentsWithPdfArgs = {
  brand_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  project_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryOurWorkBudgetCategoriesArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type QueryOurWorkBudgetItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOurWorkBudgetItemsByItemCodeArgs = {
  item_code: Scalars['String']['input'];
  project_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOurWorkBudgetItemsSimpleMapArgs = {
  open?: InputMaybe<Scalars['Boolean']['input']>;
  project_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  updated_at_since?: InputMaybe<Scalars['DateTime']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOutgoingInvoiceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOutgoingInvoicesArgs = {
  filters?: InputMaybe<OiQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOutgoingInvoicesSummaryArgs = {
  filters?: InputMaybe<OiQueryArgs>;
};


export type QueryOutgoingProformaInvoiceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOutgoingProformaInvoicesArgs = {
  filters?: InputMaybe<OiProformaQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOutgoingProformaInvoicesSummaryArgs = {
  filters?: InputMaybe<OiProformaQueryArgs>;
};


export type QueryPlannedExpensesOverviewArgs = {
  filters?: InputMaybe<PlannedExpensesQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlannedExpensesOverviewSummaryArgs = {
  filters?: InputMaybe<PlannedExpensesQueryArgs>;
};


export type QueryPlanningDailyViewPeopleArgs = {
  filters: PlanningDailyViewFilters;
};


export type QueryPlanningDailyViewUnassignedTasksArgs = {
  filters: PlanningDailyViewUnassignedTasksFilters;
};


export type QueryPohodaExpenseExportArgs = {
  expense_ids: Array<Scalars['ID']['input']>;
};


export type QueryPohodaOiExportArgs = {
  outgoing_invoice_ids: Array<Scalars['ID']['input']>;
};


export type QueryPohodaOpiExportArgs = {
  outgoing_proforma_invoice_ids: Array<Scalars['ID']['input']>;
};


export type QueryPremierOiExportArgs = {
  outgoing_invoice_ids: Array<Scalars['ID']['input']>;
};


export type QueryPremierProformaOiExportArgs = {
  outgoing_proforma_invoice_ids: Array<Scalars['ID']['input']>;
};


export type QueryPrepareTaskDataForBulkActionsArgs = {
  destination_budget_item_id: Scalars['ID']['input'];
  task_ids: Array<Scalars['ID']['input']>;
};


export type QueryPreviewProjectTimeBillingArgs = {
  input: PreviewProjectTimeBillingInput;
};


export type QueryProfitLossReportArgs = {
  columns?: InputMaybe<ProfitLossReportColumns>;
  first?: Scalars['BigInt']['input'];
  from: Scalars['Date']['input'];
  include_draft_expenses?: InputMaybe<Scalars['Boolean']['input']>;
  page?: Scalars['BigInt']['input'];
  rows: ProfitLossReportRows;
  to: Scalars['Date']['input'];
  where?: InputMaybe<ProfitLossReportWhereConditions>;
};


export type QueryProfitLossReportSummaryArgs = {
  columns?: InputMaybe<ProfitLossReportColumns>;
  from: Scalars['Date']['input'];
  include_draft_expenses?: InputMaybe<Scalars['Boolean']['input']>;
  to: Scalars['Date']['input'];
  where?: InputMaybe<ProfitLossReportWhereConditions>;
};


export type QueryProjectArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProjectBillingArgs = {
  date_from: Scalars['Date']['input'];
  date_to: Scalars['Date']['input'];
  project_id: Scalars['ID']['input'];
  with_prepayment?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProjectBillingsArgs = {
  filters?: InputMaybe<ProjectBillingsQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProjectBillingsExportArgs = {
  filters?: InputMaybe<ProjectBillingsQueryArgs>;
};


export type QueryProjectBillingsSummaryArgs = {
  filters?: InputMaybe<ProjectBillingsQueryArgs>;
};


export type QueryProjectDatesForBudgetChangeArgs = {
  project_id: Scalars['ID']['input'];
};


export type QueryProjectForExpenseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectForTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectGraphArgs = {
  our_work_budget_item_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  project_id: Scalars['ID']['input'];
};


export type QueryProjectHasTimeTrackedForPositionsArgs = {
  project_id: Scalars['ID']['input'];
};


export type QueryProjectLimitedArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProjectManagerSimpleMapArgs = {
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProjectProgressStatisticsExportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  wip_period_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryProjectRateCardArgs = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProjectRevenueArgs = {
  filters?: InputMaybe<ProjectRevenueQueryArgs>;
};


export type QueryProjectRevenueDetailArgs = {
  from: Scalars['Date']['input'];
  project_id: Scalars['ID']['input'];
  to: Scalars['Date']['input'];
};


export type QueryProjectRevenueSummaryArgs = {
  filters?: InputMaybe<ProjectRevenueQueryArgs>;
};


export type QueryProjectTimeBillingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectTimeBillingsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueryProjectTimeBillingsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  project_id: Scalars['ID']['input'];
};


export type QueryProjectTimeBreakdownsArgs = {
  project_id: Scalars['ID']['input'];
};


export type QueryProjectWipExportArgs = {
  period_id: Scalars['ID']['input'];
};


export type QueryProjectsArgs = {
  filters?: InputMaybe<ProjectQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProjectsAllArgs = {
  filters?: InputMaybe<ProjectAllQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProjectsCommissionExportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryProjectsEffectivenessExportArgs = {
  dateOfSupply?: InputMaybe<DateRange>;
  filters?: InputMaybe<ProjectQueryArgs>;
  finishedAt?: InputMaybe<DateRange>;
  startDate?: InputMaybe<DateRange>;
};


export type QueryProjectsForPlanovacArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  updated_at_since?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryProjectsLimitedArgs = {
  filters?: InputMaybe<ProjectLimitedQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProjectsProfitExportArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};


export type QueryProjectsSimpleMapArgs = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  client_id?: InputMaybe<Scalars['ID']['input']>;
  deleted_at_since?: InputMaybe<Scalars['DateTime']['input']>;
  my_projects?: InputMaybe<Scalars['Boolean']['input']>;
  orIdIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  project_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProjectStatusEnum>;
  type?: InputMaybe<ProjectTypeEnum>;
  updated_at_since?: InputMaybe<Scalars['DateTime']['input']>;
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  withFinished?: InputMaybe<Scalars['Boolean']['input']>;
  withProBono?: InputMaybe<Scalars['Boolean']['input']>;
  with_templates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProjectsSummaryArgs = {
  filters?: InputMaybe<ProjectQueryArgs>;
};


export type QueryProjectsWithPeriodsArgs = {
  filters?: InputMaybe<WipQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProlucOiExportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryRequestForInvoicingArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRequestsForInvoicingArgs = {
  filters?: InputMaybe<RequestForInvoicingQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRequestsForInvoicingSummaryArgs = {
  filters?: InputMaybe<RequestForInvoicingQueryArgs>;
};


export type QueryRunningTimerArgs = {
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaskAndCommunicationNotificationsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTaskBoardColumnCountsArgs = {
  filters?: InputMaybe<TaskQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_by: TaskBoardGroupByEnum;
  group_values?: InputMaybe<Array<Scalars['ID']['input']>>;
  include_complete?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTaskBoardSettingsArgs = {
  board_key: Scalars['String']['input'];
};


export type QueryTaskCommentFilesArgs = {
  scope?: InputMaybe<UserScopeEnum>;
  task_id: Scalars['ID']['input'];
};


export type QueryTaskCommentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  last_comment_ID?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<UserScopeEnum>;
  task_id: Scalars['ID']['input'];
};


export type QueryTaskIdsArgs = {
  filters?: InputMaybe<TaskQueryArgs>;
};


export type QueryTaskPositionStatArgs = {
  task_id: Scalars['ID']['input'];
};


export type QueryTaskTemplateGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTasksArgs = {
  filters?: InputMaybe<TaskQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTasksSimpleMapArgs = {
  our_work_budget_item_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  parent_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  project_id?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTeamSimpleMapArgs = {
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTimeMaterialsInvoiceDataArgs = {
  filters?: InputMaybe<TimeMaterialsQueryArgs>;
  from: Scalars['Date']['input'];
  groupBy: TimeMaterialsInvoiceDataGroupByEnum;
  outgoing_invoice_id?: InputMaybe<Scalars['ID']['input']>;
  project_id: Scalars['ID']['input'];
  to: Scalars['Date']['input'];
};


export type QueryTimeOffsExportArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};


export type QueryTimeTrackingItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTimeTrackingItemsArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
  without_capacity_allocation_item?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTimeTrackingItemsPaginatedArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  tracked_from?: InputMaybe<Scalars['Date']['input']>;
  tracked_to?: InputMaybe<Scalars['Date']['input']>;
  updated_at_since?: InputMaybe<Scalars['DateTime']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTimeTrackingItemsWorkTypesArgs = {
  time_tracking_item_ids: Array<Scalars['ID']['input']>;
};


export type QueryTimeTrackingOptionsForProjectArgs = {
  date: Scalars['Date']['input'];
  project_id: Scalars['ID']['input'];
};


export type QueryTimeTrackingProjectReportArgs = {
  filters?: InputMaybe<TimeTrackingProjectReportQueryArgs>;
};


export type QueryTimeTrackingReportArgs = {
  first?: InputMaybe<Scalars['BigInt']['input']>;
  groupBy?: InputMaybe<TimeTrackingReportGroupBy>;
  orderBy?: InputMaybe<Array<TimeTrackingItemOrderByClause>>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
};


export type QueryTimeTrackingReportExportArgs = {
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
};


export type QueryTimeTrackingReportExportPdfArgs = {
  date_from: Scalars['Date']['input'];
  date_to: Scalars['Date']['input'];
  report_type: TimeTrackingReportExportType;
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
};


export type QueryTimeTrackingReportSummaryArgs = {
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
};


export type QueryTimeTrackingSummaryPerDayArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  user_id: Scalars['ID']['input'];
};


export type QueryTransakcioExpenseExportArgs = {
  expense_ids: Array<Scalars['ID']['input']>;
};


export type QueryTriadProjectsEffectivenessExportArgs = {
  filters?: InputMaybe<ProjectQueryArgs>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryUnreadNotificationsCountArgs = {
  groups?: InputMaybe<Array<InputMaybe<NotificationGroup>>>;
};


export type QueryUnusedPaidOutgoingProformaInvoicesArgs = {
  currency_id?: InputMaybe<Scalars['ID']['input']>;
  project_ids: Array<Scalars['ID']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserEffectivenessReportExportArgs = {
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
};


export type QueryUserMonthlyReportArgs = {
  first?: InputMaybe<Scalars['BigInt']['input']>;
  month: Scalars['BigInt']['input'];
  orderBy?: InputMaybe<UserMonthlyReportOrderByClause>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  year: Scalars['BigInt']['input'];
};


export type QueryUserMonthlyReportExportArgs = {
  month: Scalars['BigInt']['input'];
  year: Scalars['BigInt']['input'];
};


export type QueryUserSimpleMapArgs = {
  mentions?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPlannable?: InputMaybe<Scalars['Boolean']['input']>;
  project_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['ID']['input']>;
  updated_at_since?: InputMaybe<Scalars['DateTime']['input']>;
  where?: InputMaybe<UsersWhereConditions>;
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUsersArgs = {
  filters?: InputMaybe<UserQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersForPlanovacArgs = {
  updated_at_since?: InputMaybe<Scalars['DateTime']['input']>;
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUsersSummaryArgs = {
  filters?: InputMaybe<UserQueryArgs>;
};


export type QueryUtilizationReportArgs = {
  dataSource: UtilizationReportDataSource;
  first?: Scalars['BigInt']['input'];
  from: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<UtilizationReportOrderByClause>>;
  page?: Scalars['BigInt']['input'];
  to: Scalars['Date']['input'];
  where?: InputMaybe<UtilizationReportWhereConditions>;
};


export type QueryUtilizationReportExportArgs = {
  dataSource: UtilizationReportDataSource;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  where?: InputMaybe<UtilizationReportWhereConditions>;
};


export type QueryUtilizationReportGroupsArgs = {
  dataSource: UtilizationReportDataSource;
  first?: Scalars['BigInt']['input'];
  from: Scalars['Date']['input'];
  groupBy: UtilizationReportGroupBy;
  groupOrderBy?: InputMaybe<Array<UtilizationReportGroupOrderByClause>>;
  orderBy?: InputMaybe<Array<UtilizationReportOrderByClause>>;
  page?: Scalars['BigInt']['input'];
  to: Scalars['Date']['input'];
  where?: InputMaybe<UtilizationReportWhereConditions>;
};


export type QueryUtilizationReportSummaryArgs = {
  dataSource: UtilizationReportDataSource;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  where?: InputMaybe<UtilizationReportWhereConditions>;
};


export type QueryUtilizationTaskReportArgs = {
  dataSource: UtilizationReportDataSource;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryUtilizationUserReportArgs = {
  dataSource: UtilizationReportDataSource;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryVarioExpenseExportArgs = {
  expense_ids: Array<Scalars['ID']['input']>;
};


export type QueryVarioOiExportArgs = {
  outgoing_invoice_ids: Array<Scalars['ID']['input']>;
};


export type QueryVerifyAccessTokenFromThirdPartyArgs = {
  appName?: InputMaybe<ThirdPartyEnum>;
};


export type QueryWeekTimeReportArgs = {
  from: Scalars['Date']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWipForBudgetAndPeriodArgs = {
  our_work_budget_item_id: Scalars['ID']['input'];
  period_id: Scalars['ID']['input'];
};


export type QueryWipPeriodsMapArgs = {
  budgetItemId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWipProjectsPeriodSummaryArgs = {
  filters?: InputMaybe<WipQueryArgs>;
};


export type QueryWorkspaceExchangeRatesForBudgetovacArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryXeroOiExportArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

/** Allowed column names for Query.contacts.orderBy. */
export enum QueryContactsOrderByColumn {
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

/** Order by clause for Query.contacts.orderBy. */
export type QueryContactsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryContactsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Query.projectTimeBillings.orderBy. */
export enum QueryProjectTimeBillingsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  DateFrom = 'DATE_FROM',
  DateTo = 'DATE_TO',
  FinalTotalAmount = 'FINAL_TOTAL_AMOUNT',
  LockedAt = 'LOCKED_AT'
}

/** Order by clause for Query.projectTimeBillings.orderBy. */
export type QueryProjectTimeBillingsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryProjectTimeBillingsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

export type Quote = {
  __typename?: 'Quote';
  Client?: Maybe<Client>;
  budgets: Array<Budget>;
  client_approval_date?: Maybe<Scalars['Date']['output']>;
  createdBy: User;
  currency: Currency;
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  sent_to_client_date?: Maybe<Scalars['Date']['output']>;
  settings: BudgetPdfSettings;
  status: QuoteStatus;
  total_amount: Scalars['BigInt']['output'];
  url: Scalars['String']['output'];
};

export type QuoteAttachment = {
  __typename?: 'QuoteAttachment';
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuoteEmailData = {
  __typename?: 'QuoteEmailData';
  attachments?: Maybe<Array<QuoteAttachment>>;
  content: Scalars['String']['output'];
  primary_recipient?: Maybe<Scalars['String']['output']>;
  recipients?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subject: Scalars['String']['output'];
};

export enum QuoteStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  ManualApproved = 'MANUAL_APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type QuotesArgs = {
  first?: InputMaybe<Scalars['BigInt']['input']>;
  orderBy?: InputMaybe<Array<BudgetOrderByClause>>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  where?: InputMaybe<BudgetWhereConditions>;
};

export type QuotesPaginator = {
  __typename?: 'QuotesPaginator';
  data?: Maybe<Array<Quote>>;
  paginatorInfo: PaginatorInfo;
};

export type Recipient = {
  __typename?: 'Recipient';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type RecipientLog = {
  __typename?: 'RecipientLog';
  recipient: Scalars['String']['output'];
  status: RecipientLogStatus;
};

export enum RecipientLogStatus {
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  Sent = 'SENT',
  Waiting = 'WAITING'
}

export type ReopenCapacityAllocationItemInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type RepetitionSettings = {
  __typename?: 'RepetitionSettings';
  days?: Maybe<Array<Maybe<RepetitionSettingsDaysEnum>>>;
  end: Scalars['String']['output'];
  every: Scalars['Int']['output'];
  include_holidays?: Maybe<Scalars['Boolean']['output']>;
  startType?: Maybe<TimeOffDurationTypeEnum>;
  toType?: Maybe<TimeOffDurationTypeEnum>;
};

export enum RepetitionSettingsDaysEnum {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type RequestForInvoicing = {
  __typename?: 'RequestForInvoicing';
  billingEntity?: Maybe<BillingEntity>;
  brands: Array<Brand>;
  budget_positions: Array<BudgetPosition>;
  client: Client;
  contact?: Maybe<Contact>;
  created_at: Scalars['DateTime']['output'];
  credit_note_outgoing_invoice_id?: Maybe<Scalars['ID']['output']>;
  currency: Currency;
  /** For PM/ACC: Requested date of invoicing, for FM: Date of supply */
  date_of_supply?: Maybe<Scalars['Date']['output']>;
  due_date?: Maybe<Scalars['Date']['output']>;
  exchange_rate: Scalars['BigInt']['output'];
  exchange_rate_source: ExchangeRateSource;
  expenseBudgetSplits: Array<RequestForInvoicingExpenseBudgetSplitItem>;
  filesToAttach: Array<AssignableFile>;
  id: Scalars['ID']['output'];
  internal_note?: Maybe<Scalars['String']['output']>;
  invoiceItems: Array<OutgoingInvoiceItem>;
  invoicePaymentMethod?: Maybe<InvoicePaymentMethod>;
  issue_date?: Maybe<Scalars['Date']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  orders: Array<Order>;
  ourWorkBudgetSplits: Array<RequestForInvoicingOurWorkBudgetSplitItem>;
  owner?: Maybe<User>;
  prepaymentSplits: Array<RequestForInvoicingPrepaymentSplitItem>;
  proformaInvoices: Array<OutgoingProformaInvoice>;
  projects: Array<Project>;
  proofOfPayments: Array<OutgoingInvoice>;
  show_billing_accounting: Scalars['Boolean']['output'];
  show_unit_price: Scalars['Boolean']['output'];
  stats: RequestForInvoicingStats;
  status: RequestForInvoicingStatusEnum;
  submit_date?: Maybe<Scalars['Date']['output']>;
  teams: Array<Team>;
  text_on_invoice?: Maybe<Scalars['String']['output']>;
  timeMaterialsInvoiceData?: Maybe<TimeMaterialsInvoiceData>;
  total_in_words?: Maybe<Scalars['String']['output']>;
  type: RequestForInvoicingTypeEnum;
  updated_at: Scalars['DateTime']['output'];
  vat_percent_informative?: Maybe<Scalars['BigInt']['output']>;
  vat_reverse_charge: Scalars['Boolean']['output'];
  workspace_bank_account_id?: Maybe<Scalars['ID']['output']>;
  workspace_company_id: Scalars['ID']['output'];
  workspace_exchange_rate: Scalars['BigInt']['output'];
  workspace_exchange_rate_source: ExchangeRateSource;
};

export type RequestForInvoicingBudgetSplitItem = {
  amount?: Maybe<Scalars['BigInt']['output']>;
  created_at: Scalars['DateTime']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type RequestForInvoicingExpenseBudgetSplitItem = RequestForInvoicingBudgetSplitItem & {
  __typename?: 'RequestForInvoicingExpenseBudgetSplitItem';
  amount?: Maybe<Scalars['BigInt']['output']>;
  created_at: Scalars['DateTime']['output'];
  expense_budget_item_id?: Maybe<Scalars['ID']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

export type RequestForInvoicingOrderByClause = {
  column: RequestForInvoicingOrderByColumnEnum;
  order: SortOrder;
};

export enum RequestForInvoicingOrderByColumnEnum {
  Amount = 'AMOUNT',
  AmountWithVat = 'AMOUNT_WITH_VAT',
  CreatedAt = 'CREATED_AT',
  DateOfSupply = 'DATE_OF_SUPPLY',
  Id = 'ID',
  Status = 'STATUS'
}

export type RequestForInvoicingOurWorkBudgetSplitItem = RequestForInvoicingBudgetSplitItem & {
  __typename?: 'RequestForInvoicingOurWorkBudgetSplitItem';
  amount?: Maybe<Scalars['BigInt']['output']>;
  amount_in_percent?: Maybe<Scalars['BigInt']['output']>;
  created_at: Scalars['DateTime']['output'];
  our_work_budget_item_id?: Maybe<Scalars['ID']['output']>;
  updated_at: Scalars['DateTime']['output'];
};

/** A paginated list of RequestForInvoicing items. */
export type RequestForInvoicingPaginator = {
  __typename?: 'RequestForInvoicingPaginator';
  /** A list of RequestForInvoicing items. */
  data: Array<RequestForInvoicing>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type RequestForInvoicingPrepaymentSplitItem = {
  __typename?: 'RequestForInvoicingPrepaymentSplitItem';
  amount?: Maybe<Scalars['BigInt']['output']>;
  brand_credit_account_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['DateTime']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type RequestForInvoicingQueryArgs = {
  orderBy?: InputMaybe<Array<RequestForInvoicingOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<RequestsForInvoicingWhereConditions>;
};

export type RequestForInvoicingStats = {
  __typename?: 'RequestForInvoicingStats';
  budget_splits_amount: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  total_amount: Scalars['BigInt']['output'];
  total_amount_with_vat: Scalars['BigInt']['output'];
  workspace_exchange_rate: Scalars['BigInt']['output'];
};

export enum RequestForInvoicingStatusEnum {
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED'
}

export enum RequestForInvoicingTypeEnum {
  CreditNote = 'CREDIT_NOTE',
  Invoice = 'INVOICE',
  Proforma = 'PROFORMA'
}

export type RequestsForInvoicingSummary = {
  __typename?: 'RequestsForInvoicingSummary';
  requestForInvoicingIds: Array<Scalars['ID']['output']>;
};

export enum RequestsForInvoicingWhereColumn {
  BrandId = 'BRAND_ID',
  CreatedAt = 'CREATED_AT',
  OwnerId = 'OWNER_ID',
  Status = 'STATUS',
  Type = 'TYPE',
  WorkspaceBankAccountId = 'WORKSPACE_BANK_ACCOUNT_ID',
  WorkspaceCompanyId = 'WORKSPACE_COMPANY_ID'
}

export type RequestsForInvoicingWhereConditions = {
  AND?: InputMaybe<Array<RequestsForInvoicingWhereConditions>>;
  OR?: InputMaybe<Array<RequestsForInvoicingWhereConditions>>;
  column?: InputMaybe<RequestsForInvoicingWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type Role = {
  __typename?: 'Role';
  documentLimits?: Maybe<Array<RoleDocumentLimit>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RoleDocumentLimit = {
  __typename?: 'RoleDocumentLimit';
  document_type: DocumentLimitTypeEnum;
  limit: Scalars['BigInt']['output'];
};

/** The available SQL operators that are used to filter query results. */
export enum SqlOperator {
  /** Whether a value is within a range of values (`BETWEEN`) */
  Between = 'BETWEEN',
  /** Equal operator (`=`) */
  Eq = 'EQ',
  /** Greater than operator (`>`) */
  Gt = 'GT',
  /** Greater than or equal operator (`>=`) */
  Gte = 'GTE',
  /** Whether a value is within a set of values (`IN`) */
  In = 'IN',
  /** Whether a value is not null (`IS NOT NULL`) */
  IsNotNull = 'IS_NOT_NULL',
  /** Whether a value is null (`IS NULL`) */
  IsNull = 'IS_NULL',
  /** Simple pattern matching (`LIKE`) */
  Like = 'LIKE',
  /** Less than operator (`<`) */
  Lt = 'LT',
  /** Less than or equal operator (`<=`) */
  Lte = 'LTE',
  /** Not equal operator (`!=`) */
  Neq = 'NEQ',
  /** Whether a value is not within a range of values (`NOT BETWEEN`) */
  NotBetween = 'NOT_BETWEEN',
  /** Whether a value is not within a set of values (`NOT IN`) */
  NotIn = 'NOT_IN',
  /** Negation of simple pattern matching (`NOT LIKE`) */
  NotLike = 'NOT_LIKE'
}

export type Sequence = {
  __typename?: 'Sequence';
  format?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  next_invoice_no: Scalars['String']['output'];
  types: Array<Maybe<SequenceTypesEnum>>;
};

export enum SequenceTypesEnum {
  CreditNote = 'CREDIT_NOTE',
  ExpenseAll = 'EXPENSE_ALL',
  ExpenseBill = 'EXPENSE_BILL',
  ExpenseCard = 'EXPENSE_CARD',
  ExpenseContract = 'EXPENSE_CONTRACT',
  ExpenseInvoice = 'EXPENSE_INVOICE',
  ExpenseOther = 'EXPENSE_OTHER',
  ExpensePaymentReceipt = 'EXPENSE_PAYMENT_RECEIPT',
  ExpenseProforma = 'EXPENSE_PROFORMA',
  OutgoingInvoice = 'OUTGOING_INVOICE',
  Proforma = 'PROFORMA',
  ProformaPayment = 'PROFORMA_PAYMENT'
}

/** Information about pagination using a simple paginator. */
export type SimplePaginatorInfo = {
  __typename?: 'SimplePaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
};

export type SingleSignOnData = {
  __typename?: 'SingleSignOnData';
  email?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
};

export type SmtpTestResult = {
  __typename?: 'SmtpTestResult';
  error?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type Star = {
  __typename?: 'Star';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  starable: Starable;
  starable_id: Scalars['ID']['output'];
  starable_type: StarsStarableTypeEnum;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type Starable = Project | Task;

export enum StarsStarableTypeEnum {
  Project = 'PROJECT',
  Task = 'TASK'
}

export enum StartDayOfWeekEnum {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type StructuredExpenseItemsItem = {
  __typename?: 'StructuredExpenseItemsItem';
  brand?: Maybe<Brand>;
  expense_items: Array<ExpenseItem>;
  total_amount: Scalars['BigInt']['output'];
};

export type SubmitProgressBulkInput = {
  ids: Array<Scalars['ID']['input']>;
  progress: Scalars['BigInt']['input'];
};

export type SubmitProgressInput = {
  id: Scalars['ID']['input'];
  progress: Scalars['BigInt']['input'];
};

export type SubmitProgressResult = {
  __typename?: 'SubmitProgressResult';
  changedWorkInProgressItemStats: Array<WorkInProgressItemStat>;
  lastWorkInProgressProjectStat: WorkInProgressProjectStat;
};

export type Tag = {
  __typename?: 'Tag';
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type Task = {
  __typename?: 'Task';
  attachments_download_url: Scalars['String']['output'];
  billable: Scalars['Boolean']['output'];
  clientCommentCount: Scalars['BigInt']['output'];
  cloudUrl?: Maybe<Scalars['String']['output']>;
  commentCount: Scalars['BigInt']['output'];
  commentFiles: Array<AssignableFile>;
  createdBy?: Maybe<User>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  currentAssignee?: Maybe<User>;
  days_to_deadline?: Maybe<Scalars['Int']['output']>;
  days_to_from?: Maybe<Scalars['Int']['output']>;
  days_to_to?: Maybe<Scalars['Int']['output']>;
  deadline?: Maybe<Scalars['DateTime']['output']>;
  default_planned_time?: Maybe<Scalars['BigInt']['output']>;
  description?: Maybe<TaskDescription>;
  driveCloudUrl?: Maybe<Scalars['String']['output']>;
  files: Array<AssignableFile>;
  from?: Maybe<Scalars['Date']['output']>;
  global: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_starred: Scalars['Boolean']['output'];
  is_template: Scalars['Boolean']['output'];
  linkedTasks?: Maybe<Array<TaskLink>>;
  name: Scalars['String']['output'];
  otherPeopleTracked?: Maybe<Array<OtherPeopleTracked>>;
  otherPeopleTrackedTotal: Scalars['BigInt']['output'];
  ourWorkBudgetItem?: Maybe<OurWorkBudgetItem>;
  parent?: Maybe<Task>;
  partnerCommentCount: Scalars['BigInt']['output'];
  planned_time: Scalars['BigInt']['output'];
  positions: Array<TaskPosition>;
  positionsSpent: Array<Maybe<PositionSpent>>;
  priority: TaskPriority;
  revision: Scalars['String']['output'];
  scopedCommentCount: Scalars['BigInt']['output'];
  scopes: Array<UserScope>;
  stats?: Maybe<TaskStats>;
  status: TaskStatus;
  subtasks?: Maybe<Array<Task>>;
  taskWatchers: Array<Maybe<TaskWatcher>>;
  task_template_group_id?: Maybe<Scalars['ID']['output']>;
  teams: Array<Team>;
  timeTrackingItems: Array<TimeTrackingItem>;
  to?: Maybe<Scalars['Date']['output']>;
  unreadCommentsCount: Scalars['BigInt']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  users: Array<User>;
};

export type TaskAndCommunicationNotificationsPaginator = {
  __typename?: 'TaskAndCommunicationNotificationsPaginator';
  data: Array<NotificationPerTask>;
  paginatorInfo: PaginatorInfo;
};

export type TaskBoardColumnCount = {
  __typename?: 'TaskBoardColumnCount';
  group_label?: Maybe<Scalars['String']['output']>;
  group_value?: Maybe<Scalars['ID']['output']>;
  planned_time: Scalars['BigInt']['output'];
  spent_time: Scalars['BigInt']['output'];
  total: Scalars['Int']['output'];
};

export type TaskBoardColumnCountPaginator = {
  __typename?: 'TaskBoardColumnCountPaginator';
  data: Array<TaskBoardColumnCount>;
  paginatorInfo: PaginatorInfo;
};

export enum TaskBoardGroupByEnum {
  Assignee = 'ASSIGNEE',
  CurrentAssignee = 'CURRENT_ASSIGNEE',
  TaskPriority = 'TASK_PRIORITY',
  TaskStatus = 'TASK_STATUS'
}

/** Per-user board settings keyed by board_key (tab + group by, e.g. "my:TASK_STATUS"). */
export type TaskBoardSettings = {
  __typename?: 'TaskBoardSettings';
  board_key: Scalars['String']['output'];
  collapsed_columns: Array<Scalars['String']['output']>;
  column_order: Array<Scalars['String']['output']>;
  hidden_columns: Array<Scalars['String']['output']>;
  sort?: Maybe<TaskBoardSort>;
};

export type TaskBoardSort = {
  __typename?: 'TaskBoardSort';
  column: Scalars['String']['output'];
  direction: SortOrder;
};

export type TaskBoardSortInput = {
  column: Scalars['String']['input'];
  direction: SortOrder;
};

export type TaskBulkActionsData = {
  __typename?: 'TaskBulkActionsData';
  available_positions: Array<TimeTrackingWorkType>;
  has_subtasks: Scalars['Boolean']['output'];
  unavailable_positions: Array<TimeTrackingWorkType>;
};

export type TaskComment = {
  __typename?: 'TaskComment';
  body: Scalars['String']['output'];
  created_at?: Maybe<Scalars['DateTime']['output']>;
  files: Array<AssignableFile>;
  has_edits?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  in_reply_to?: Maybe<TaskComment>;
  mentioned_user_ids?: Maybe<Array<Scalars['ID']['output']>>;
  reactions?: Maybe<Array<Maybe<TaskCommentReaction>>>;
  task: Task;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  user: User;
};

/** A paginated list of TaskComment items. */
export type TaskCommentPaginator = {
  __typename?: 'TaskCommentPaginator';
  /** A list of TaskComment items. */
  data: Array<TaskComment>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type TaskCommentReaction = {
  __typename?: 'TaskCommentReaction';
  emoji_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  task_comment_id: Scalars['ID']['output'];
  user: User;
};

export type TaskDescription = {
  __typename?: 'TaskDescription';
  body?: Maybe<Scalars['String']['output']>;
  mentioned_assignees?: Maybe<Scalars['Boolean']['output']>;
  mentioned_team_ids?: Maybe<Array<Scalars['ID']['output']>>;
  mentioned_user_ids?: Maybe<Array<Scalars['ID']['output']>>;
};

export type TaskDescriptionInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  mentioned_assignees?: InputMaybe<Scalars['Boolean']['input']>;
  mentioned_team_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  mentioned_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TaskLink = {
  __typename?: 'TaskLink';
  id: Scalars['ID']['output'];
  link_type?: Maybe<TaskLinkType>;
  link_type_id: Scalars['ID']['output'];
  linked_task: Task;
  linked_task_id: Scalars['ID']['output'];
  task_id: Scalars['ID']['output'];
};

export type TaskLinkType = {
  __typename?: 'TaskLinkType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TaskMoveUnmatchedData = {
  __typename?: 'TaskMoveUnmatchedData';
  has_time_tracking_entries: Scalars['Boolean']['output'];
  target_available_work_types: Array<TimeTrackingWorkType>;
  unmatched_work_types: Array<TimeTrackingWorkType>;
};

export type TaskOrderByClause = {
  /** Board context: tab + group by, e.g. "my:TASK_STATUS". Required when column is BOARD_ORDER. */
  board_key?: InputMaybe<Scalars['String']['input']>;
  column: TaskOrderByColumnEnum;
  order: SortOrder;
};

export enum TaskOrderByColumnEnum {
  BoardOrder = 'BOARD_ORDER',
  BudgetItemTitle = 'BUDGET_ITEM_TITLE',
  CreatedAt = 'CREATED_AT',
  Deadline = 'DEADLINE',
  From = 'FROM',
  Id = 'ID',
  IsStarred = 'IS_STARRED',
  /** Tasks the current user has a running timer on first (ASC). */
  IsTracking = 'IS_TRACKING',
  ProjectTitle = 'PROJECT_TITLE',
  TaskName = 'TASK_NAME',
  TaskPriority = 'TASK_PRIORITY',
  TaskStatus = 'TASK_STATUS',
  Title = 'TITLE',
  To = 'TO',
  UpdatedAt = 'UPDATED_AT'
}

/** A paginated list of Task items. */
export type TaskPaginator = {
  __typename?: 'TaskPaginator';
  /** A list of Task items. */
  data: Array<Task>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum TaskPermissionTypeEnum {
  Delete = 'DELETE',
  Update = 'UPDATE',
  UpdateCurrentAssignee = 'UPDATE_CURRENT_ASSIGNEE',
  UpdateScoped = 'UPDATE_SCOPED',
  UpdateStatus = 'UPDATE_STATUS'
}

export type TaskPosition = {
  __typename?: 'TaskPosition';
  id: Scalars['ID']['output'];
  planned_time: Scalars['BigInt']['output'];
  spent_time: Scalars['BigInt']['output'];
  timeTrackingWorkType: TimeTrackingWorkType;
  user?: Maybe<User>;
};

export type TaskPositionHour = {
  __typename?: 'TaskPositionHour';
  planned_time: Scalars['BigInt']['output'];
  time_tracking_work_type_id: Scalars['ID']['output'];
};

export type TaskPositionInput = {
  planned_time: Scalars['BigInt']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TaskPositionStat = {
  __typename?: 'TaskPositionStat';
  planned_time: Scalars['BigInt']['output'];
  spent_time: Scalars['BigInt']['output'];
  timeTrackingWorkType: TimeTrackingWorkType;
  user?: Maybe<User>;
};

export type TaskPriority = {
  __typename?: 'TaskPriority';
  /** Shown instead of the system priority icon. */
  emoji?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  system_priority?: Maybe<TaskSystemPriorityEnum>;
};

export type TaskQueryArgs = {
  orderBy?: InputMaybe<Array<TaskOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<TaskWhereConditions>;
};

export type TaskSimple = {
  __typename?: 'TaskSimple';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deadline?: Maybe<Scalars['DateTime']['output']>;
  from?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Task>;
  planned_time: Scalars['BigInt']['output'];
  positions: Array<TaskPosition>;
  priority: TaskPriority;
  status: TaskStatus;
  subtasks?: Maybe<Array<Task>>;
  to?: Maybe<Scalars['Date']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type TaskStats = {
  __typename?: 'TaskStats';
  allocated_time: Scalars['Int']['output'];
  history_spent_time: Scalars['Int']['output'];
  left_to_allocate: Scalars['Int']['output'];
  planned_time: Scalars['Int']['output'];
  spent_time: Scalars['Int']['output'];
};

export type TaskStatus = {
  __typename?: 'TaskStatus';
  background_color: Scalars['String']['output'];
  foreground_color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  system_status?: Maybe<TaskSystemStatusEnum>;
};

export enum TaskSystemPriorityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Urgent = 'URGENT'
}

export enum TaskSystemStatusEnum {
  Done = 'DONE',
  New = 'NEW'
}

export type TaskTemplateGroup = {
  __typename?: 'TaskTemplateGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tasks?: Maybe<Array<Task>>;
};

export type TaskWatcher = {
  __typename?: 'TaskWatcher';
  task_id: Scalars['ID']['output'];
  user: User;
  user_id: Scalars['ID']['output'];
};

export enum TaskWhereColumn {
  AfterDeadline = 'AFTER_DEADLINE',
  AfterEndDate = 'AFTER_END_DATE',
  AssigneeId = 'ASSIGNEE_ID',
  Billable = 'BILLABLE',
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  CreatedAt = 'CREATED_AT',
  CreatedByUserId = 'CREATED_BY_USER_ID',
  CurrentAssigneeId = 'CURRENT_ASSIGNEE_ID',
  Deadline = 'DEADLINE',
  From = 'FROM',
  HideDone = 'HIDE_DONE',
  Id = 'ID',
  IsTemplate = 'IS_TEMPLATE',
  MyCreatedTasks = 'MY_CREATED_TASKS',
  MyCurrentTasks = 'MY_CURRENT_TASKS',
  MyTasks = 'MY_TASKS',
  MyWatchedTasks = 'MY_WATCHED_TASKS',
  OnlyParent = 'ONLY_PARENT',
  OurWorkBudgetItemId = 'OUR_WORK_BUDGET_ITEM_ID',
  ParentId = 'PARENT_ID',
  ProjectCategoryId = 'PROJECT_CATEGORY_ID',
  ProjectId = 'PROJECT_ID',
  ProjectManagerId = 'PROJECT_MANAGER_ID',
  ProjectTeamLeaderId = 'PROJECT_TEAM_LEADER_ID',
  QuickFilter = 'QUICK_FILTER',
  StarredTasks = 'STARRED_TASKS',
  TaskPriorityId = 'TASK_PRIORITY_ID',
  TaskStatusId = 'TASK_STATUS_ID',
  TaskTemplateGroupId = 'TASK_TEMPLATE_GROUP_ID',
  TeamId = 'TEAM_ID',
  TimeTrackingWorkTypeId = 'TIME_TRACKING_WORK_TYPE_ID',
  To = 'TO',
  UserId = 'USER_ID'
}

export type TaskWhereConditions = {
  AND?: InputMaybe<Array<TaskWhereConditions>>;
  OR?: InputMaybe<Array<TaskWhereConditions>>;
  column?: InputMaybe<TaskWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type Team = {
  __typename?: 'Team';
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  expense_cost_centre_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  is_default: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  user_count: Scalars['Int']['output'];
};

export type TeamAttendee = {
  __typename?: 'TeamAttendee';
  team: Team;
};

export type TemporaryBrand = {
  __typename?: 'TemporaryBrand';
  name?: Maybe<Scalars['String']['output']>;
};

export type TemporaryProject = {
  __typename?: 'TemporaryProject';
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TestSmtpConnectionInput = {
  smtp_encryption: Scalars['String']['input'];
  smtp_host: Scalars['String']['input'];
  smtp_password: Scalars['String']['input'];
  smtp_port: Scalars['Int']['input'];
  smtp_username: Scalars['String']['input'];
};

export enum ThirdPartyEnum {
  Budgetovac = 'BUDGETOVAC',
  Planovac = 'PLANOVAC'
}

/** Component input */
export type TimeBillingComponentInput = {
  amount: Scalars['BigInt']['input'];
  key: TimeBillingComponentKeyEnum;
  source_id?: InputMaybe<Scalars['ID']['input']>;
  source_type?: InputMaybe<TimeBillingSourceTypeEnum>;
  use_in_total: Scalars['Boolean']['input'];
};

export enum TimeBillingComponentKeyEnum {
  ExpensesEbi = 'EXPENSES_EBI',
  ExpensesOwbi = 'EXPENSES_OWBI',
  InvoicedExpenses = 'INVOICED_EXPENSES',
  InvoicedOurwork = 'INVOICED_OURWORK',
  Prepayment = 'PREPAYMENT'
}

/**
 * Source input - pre expense_item: source_id je expense_items.id
 * Pre oi_budget_item: outgoing_invoice_id + budget_item_id + budget_item_type
 */
export type TimeBillingSourceInput = {
  budget_item_id?: InputMaybe<Scalars['ID']['input']>;
  budget_item_type?: InputMaybe<BudgetItemTypeEnum>;
  include: Scalars['Boolean']['input'];
  outgoing_invoice_id?: InputMaybe<Scalars['ID']['input']>;
  source_id?: InputMaybe<Scalars['ID']['input']>;
  source_type: TimeBillingSourceTypeEnum;
};

export enum TimeBillingSourceTypeEnum {
  ExpenseItem = 'EXPENSE_ITEM',
  OiBudgetItem = 'OI_BUDGET_ITEM'
}

/** Summary pre Time Billing listings (count + amount) */
export type TimeBillingSummary = {
  __typename?: 'TimeBillingSummary';
  allIds: Array<Scalars['ID']['output']>;
  amount: Scalars['BigInt']['output'];
  count: Scalars['Int']['output'];
};

export enum TimeBillingTypeEnum {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

/**
 * User row input (pre manual mode).
 * Pre Work Expense záznamy je user_id null.
 */
export type TimeBillingUserRowInput = {
  amount: Scalars['BigInt']['input'];
  effective_hourly_rate_invoiced: Scalars['BigInt']['input'];
  invoiced_time: Scalars['Int']['input'];
  overserviced_time: Scalars['Int']['input'];
  team_id?: InputMaybe<Scalars['ID']['input']>;
  time_tracking_work_type_id?: InputMaybe<Scalars['ID']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * User row input pre preview (obsahuje všetky polia potrebné na prepočet).
 * Pre Work Expense záznamy je user_id null.
 */
export type TimeBillingUserRowPreviewInput = {
  amount: Scalars['BigInt']['input'];
  client_rate: Scalars['BigInt']['input'];
  effective_hourly_rate_invoiced: Scalars['BigInt']['input'];
  invoiced_time: Scalars['Int']['input'];
  overserviced_time: Scalars['Int']['input'];
  team_id?: InputMaybe<Scalars['ID']['input']>;
  time_tracking_work_type_id?: InputMaybe<Scalars['ID']['input']>;
  tracked_time: Scalars['Int']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type TimeMaterialsBudgetItemInvoiceData = {
  __typename?: 'TimeMaterialsBudgetItemInvoiceData';
  amount?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tracked_time?: Maybe<Scalars['BigInt']['output']>;
};

export type TimeMaterialsBudgetItems = {
  __typename?: 'TimeMaterialsBudgetItems';
  amount: Scalars['BigInt']['output'];
  budget_category_id: Scalars['ID']['output'];
  data?: Maybe<Array<Maybe<TimeMaterialsBudgetItemInvoiceData>>>;
  default_commission?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['ID']['output'];
  invoiced: Scalars['BigInt']['output'];
  title: Scalars['String']['output'];
};

export type TimeMaterialsCommissionData = {
  __typename?: 'TimeMaterialsCommissionData';
  commission: Scalars['BigInt']['output'];
  expense_budget_item_id: Scalars['ID']['output'];
};

export type TimeMaterialsDataForInvoicing = {
  __typename?: 'TimeMaterialsDataForInvoicing';
  expenseBudgetItems: Array<TimeMaterialsBudgetItems>;
  ourWorkBudgetItems: Array<TimeMaterialsBudgetItems>;
  project: Project;
};

export type TimeMaterialsInvoiceData = {
  __typename?: 'TimeMaterialsInvoiceData';
  commission_data?: Maybe<Array<TimeMaterialsCommissionData>>;
  expense_ids?: Maybe<Array<Scalars['ID']['output']>>;
  from: Scalars['Date']['output'];
  groupBy: TimeMaterialsInvoiceDataGroupByEnum;
  ids?: Maybe<Array<Scalars['ID']['output']>>;
  project_id: Scalars['ID']['output'];
  to: Scalars['Date']['output'];
};

export enum TimeMaterialsInvoiceDataGroupByEnum {
  Date = 'DATE',
  Month = 'MONTH',
  Position = 'POSITION',
  Task = 'TASK',
  User = 'USER',
  Week = 'WEEK'
}

export type TimeOffAssignee = {
  __typename?: 'TimeOffAssignee';
  user?: Maybe<User>;
};

export enum TimeOffDurationTypeEnum {
  AllDay = 'ALL_DAY',
  Custom = 'CUSTOM',
  FirstHalfOfDay = 'FIRST_HALF_OF_DAY',
  SecondHalfOfDay = 'SECOND_HALF_OF_DAY'
}

export type TimeOffType = {
  __typename?: 'TimeOffType';
  affects_planning_capacity: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['BigInt']['output'];
};

/** Billing status pre Time Tracking items */
export enum TimeTrackingBillingStatusEnum {
  Invoiced = 'INVOICED',
  Overserviced = 'OVERSERVICED',
  Uninvoiced = 'UNINVOICED'
}

export type TimeTrackingBudgetItem = {
  __typename?: 'TimeTrackingBudgetItem';
  id: Scalars['ID']['output'];
  ourWorkBudgetItem: OurWorkBudgetItem;
  timeTrackingItems?: Maybe<Array<Maybe<TimeTrackingItem>>>;
  tracking_enabled: Scalars['Boolean']['output'];
  tracking_enabled_from?: Maybe<Scalars['Date']['output']>;
  tracking_enabled_to?: Maybe<Scalars['Date']['output']>;
};

export type TimeTrackingBudgetItemForPlanovac = {
  __typename?: 'TimeTrackingBudgetItemForPlanovac';
  id: Scalars['ID']['output'];
  tracking_enabled_from?: Maybe<Scalars['Date']['output']>;
  tracking_enabled_to?: Maybe<Scalars['Date']['output']>;
};

export type TimeTrackingBudgetItemSimpleMap = {
  __typename?: 'TimeTrackingBudgetItemSimpleMap';
  available_time_tracking_work_types: Array<TimeTrackingWorkType>;
  budget_title: Scalars['String']['output'];
  project_code: Scalars['String']['output'];
  project_id: Scalars['ID']['output'];
  project_title: Scalars['String']['output'];
  time_tracking_budget_item_id: Scalars['ID']['output'];
};

export type TimeTrackingItem = {
  __typename?: 'TimeTrackingItem';
  auto_stopped: Scalars['Boolean']['output'];
  billable: Scalars['Boolean']['output'];
  capacityAllocationItem?: Maybe<CapacityAllocationItem>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  has_running_timer: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  internal_hourly_rate?: Maybe<Scalars['BigInt']['output']>;
  is_locked: Scalars['Boolean']['output'];
  lockedByUser?: Maybe<User>;
  locked_at?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  outgoing_invoice_id?: Maybe<Scalars['ID']['output']>;
  project: Project;
  specific_time_from?: Maybe<Scalars['Time']['output']>;
  specific_time_to?: Maybe<Scalars['Time']['output']>;
  task: Task;
  timeBilling?: Maybe<ProjectTimeBilling>;
  timeBillingDistributions: Array<ProjectTimeBillingDistribution>;
  timeTrackingBudgetItem: TimeTrackingBudgetItem;
  timeTrackingWorkType: TimeTrackingWorkType;
  tracked_for_date: Scalars['Date']['output'];
  /** Tracked time in seconds */
  tracked_time: Scalars['BigInt']['output'];
  tracked_time_with_running_timer: Scalars['BigInt']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type TimeTrackingItemOrderByClause = {
  column: TimeTrackingItemOrderByColumnEnum;
  order: SortOrder;
};

export enum TimeTrackingItemOrderByColumnEnum {
  Amount = 'AMOUNT',
  Billable = 'BILLABLE',
  Brand = 'BRAND',
  Client = 'CLIENT',
  Date = 'DATE',
  HourlyRate = 'HOURLY_RATE',
  InvoicedTime = 'INVOICED_TIME',
  LockedAt = 'LOCKED_AT',
  LockedByUser = 'LOCKED_BY_USER',
  Note = 'NOTE',
  OurWorkBudgetItem = 'OUR_WORK_BUDGET_ITEM',
  OverservicedTime = 'OVERSERVICED_TIME',
  Project = 'PROJECT',
  ProjectCode = 'PROJECT_CODE',
  ProjectTimeBilling = 'PROJECT_TIME_BILLING',
  ProjectTimeBillingProject = 'PROJECT_TIME_BILLING_PROJECT',
  Task = 'TASK',
  Team = 'TEAM',
  TrackedHours = 'TRACKED_HOURS',
  UninvoicedTime = 'UNINVOICED_TIME',
  User = 'USER',
  WorkType = 'WORK_TYPE'
}

/** A paginated list of TimeTrackingItem items. */
export type TimeTrackingItemPaginator = {
  __typename?: 'TimeTrackingItemPaginator';
  /** A list of TimeTrackingItem items. */
  data: Array<TimeTrackingItem>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type TimeTrackingOptionsForProject = {
  __typename?: 'TimeTrackingOptionsForProject';
  availableTimeTrackingWorkTypes: Array<TimeTrackingWorkType>;
  ourWork: Array<OurWorkBudgetItemSimple>;
};

export type TimeTrackingProjectReport = {
  __typename?: 'TimeTrackingProjectReport';
  amount: Scalars['Float']['output'];
  billable_all: Scalars['Boolean']['output'];
  group_amount: Scalars['BigInt']['output'];
  group_tracked_time: Scalars['BigInt']['output'];
  hourly_rate?: Maybe<Scalars['Float']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  internal_hourly_rate?: Maybe<Scalars['Float']['output']>;
  invoiced_amount: Scalars['Float']['output'];
  invoiced_personal_profitability?: Maybe<Scalars['Float']['output']>;
  invoiced_seconds?: Maybe<Scalars['BigInt']['output']>;
  /** our_work_budget_item_id available only when grouping by our_work_budget_item_title */
  our_work_budget_item_id?: Maybe<Scalars['ID']['output']>;
  /** our_work_budget_item_title available only when grouping by our_work_budget_item_title */
  our_work_budget_item_title?: Maybe<Scalars['String']['output']>;
  overserviced_seconds?: Maybe<Scalars['BigInt']['output']>;
  personal_expense?: Maybe<Scalars['Float']['output']>;
  personal_profitability?: Maybe<Scalars['Float']['output']>;
  team_id?: Maybe<Scalars['ID']['output']>;
  /** time_tracking_work_type_id not available when grouping by our_work_budget_item_title */
  time_tracking_work_type_id?: Maybe<Scalars['ID']['output']>;
  /** time_tracking_work_type_title not available when grouping by our_work_budget_item_title */
  time_tracking_work_type_title?: Maybe<Scalars['String']['output']>;
  tracked_time: Scalars['BigInt']['output'];
  uninvoiced_seconds?: Maybe<Scalars['BigInt']['output']>;
  user_full_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type TimeTrackingProjectReportOrderByClause = {
  column: TimeTrackingProjectReportOrderByColumnEnum;
  order: SortOrder;
};

export enum TimeTrackingProjectReportOrderByColumnEnum {
  OurWorkBudgetItemTitle = 'OUR_WORK_BUDGET_ITEM_TITLE',
  UserFullName = 'USER_FULL_NAME',
  WorkType = 'WORK_TYPE'
}

export type TimeTrackingProjectReportQueryArgs = {
  orderBy: Array<TimeTrackingProjectReportOrderByClause>;
  project_id: Scalars['ID']['input'];
  where?: InputMaybe<TimeTrackingProjectReportsWhereConditions>;
};

export enum TimeTrackingProjectReportsWhereColumn {
  OurWorkBudgetItemId = 'OUR_WORK_BUDGET_ITEM_ID',
  TrackedForDate = 'TRACKED_FOR_DATE'
}

export type TimeTrackingProjectReportsWhereConditions = {
  AND?: InputMaybe<Array<TimeTrackingProjectReportsWhereConditions>>;
  OR?: InputMaybe<Array<TimeTrackingProjectReportsWhereConditions>>;
  column?: InputMaybe<TimeTrackingProjectReportsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type TimeTrackingRate = {
  __typename?: 'TimeTrackingRate';
  budget?: Maybe<Budget>;
  id: Scalars['ID']['output'];
  our_work_budget_item_id?: Maybe<Scalars['ID']['output']>;
  rate: Scalars['BigInt']['output'];
  timeTrackingWorkType: TimeTrackingWorkType;
};

export type TimeTrackingReport = {
  __typename?: 'TimeTrackingReport';
  amount?: Maybe<Scalars['BigInt']['output']>;
  billable: Scalars['Boolean']['output'];
  brand_id: Scalars['ID']['output'];
  brand_name: Scalars['String']['output'];
  client_id?: Maybe<Scalars['ID']['output']>;
  client_name: Scalars['String']['output'];
  hourly_rate?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['ID']['output'];
  invoiced_seconds: Scalars['BigInt']['output'];
  locked_at?: Maybe<Scalars['DateTime']['output']>;
  locked_by_user_first_name?: Maybe<Scalars['String']['output']>;
  locked_by_user_id?: Maybe<Scalars['ID']['output']>;
  locked_by_user_last_name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  our_work_budget_item_id?: Maybe<Scalars['ID']['output']>;
  our_work_budget_item_title: Scalars['String']['output'];
  overserviced_seconds: Scalars['BigInt']['output'];
  project_code: Scalars['String']['output'];
  project_id: Scalars['ID']['output'];
  project_time_billing_id?: Maybe<Scalars['ID']['output']>;
  project_time_billing_is_locked?: Maybe<Scalars['Boolean']['output']>;
  project_time_billing_name?: Maybe<Scalars['String']['output']>;
  project_time_billing_project_id?: Maybe<Scalars['ID']['output']>;
  project_time_billing_project_name?: Maybe<Scalars['String']['output']>;
  project_title: Scalars['String']['output'];
  task_id: Scalars['ID']['output'];
  task_name: Scalars['String']['output'];
  team_name?: Maybe<Scalars['String']['output']>;
  time_tracking_work_type_id: Scalars['ID']['output'];
  time_tracking_work_type_title: Scalars['String']['output'];
  tracked_for_date: Scalars['Date']['output'];
  tracked_time: Scalars['BigInt']['output'];
  uninvoiced_seconds: Scalars['BigInt']['output'];
  user_full_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export enum TimeTrackingReportExportType {
  Detailed = 'DETAILED',
  Summary = 'SUMMARY'
}

export type TimeTrackingReportGroup = {
  __typename?: 'TimeTrackingReportGroup';
  groupBy?: Maybe<Scalars['String']['output']>;
  items: Array<TimeTrackingReport>;
  trackedTime: Scalars['BigInt']['output'];
};

export enum TimeTrackingReportGroupBy {
  Brand = 'BRAND',
  BudgetItem = 'BUDGET_ITEM',
  Date = 'DATE',
  Project = 'PROJECT',
  Task = 'TASK',
  User = 'USER',
  WorkType = 'WORK_TYPE'
}

export type TimeTrackingReportPaginator = {
  __typename?: 'TimeTrackingReportPaginator';
  data: Array<TimeTrackingReportGroup>;
  paginatorInfo: PaginatorInfo;
};

export type TimeTrackingReportSummary = {
  __typename?: 'TimeTrackingReportSummary';
  ids: Array<Scalars['ID']['output']>;
  /** Sum of (tracked_time / 3600) * hourly_rate */
  total_amount: Scalars['BigInt']['output'];
  /** Sum of invoiced_seconds from distributions */
  total_invoiced_time: Scalars['BigInt']['output'];
  total_items: Scalars['BigInt']['output'];
  /** Sum of overserviced_seconds from distributions */
  total_overserviced_time: Scalars['BigInt']['output'];
  /** total_tracked_time in seconds */
  total_tracked_time: Scalars['BigInt']['output'];
  /** Sum of uninvoiced_seconds from distributions */
  total_uninvoiced_time: Scalars['BigInt']['output'];
};

export enum TimeTrackingReportsWhereColumn {
  Billable = 'BILLABLE',
  BillingStatus = 'BILLING_STATUS',
  BrandId = 'BRAND_ID',
  ClientId = 'CLIENT_ID',
  HasTimeBilling = 'HAS_TIME_BILLING',
  Id = 'ID',
  IsLocked = 'IS_LOCKED',
  OurWorkBudgetItemId = 'OUR_WORK_BUDGET_ITEM_ID',
  ProjectCategoryId = 'PROJECT_CATEGORY_ID',
  ProjectId = 'PROJECT_ID',
  ProjectTimeBillingPlanId = 'PROJECT_TIME_BILLING_PLAN_ID',
  Status = 'STATUS',
  TaskId = 'TASK_ID',
  TeamId = 'TEAM_ID',
  TrackedForDate = 'TRACKED_FOR_DATE',
  UserId = 'USER_ID',
  WorkTypeId = 'WORK_TYPE_ID'
}

export type TimeTrackingReportsWhereConditions = {
  AND?: InputMaybe<Array<TimeTrackingReportsWhereConditions>>;
  OR?: InputMaybe<Array<TimeTrackingReportsWhereConditions>>;
  column?: InputMaybe<TimeTrackingReportsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type TimeTrackingSummaryPerDay = {
  __typename?: 'TimeTrackingSummaryPerDay';
  auto_stopped: Scalars['Boolean']['output'];
  date: Scalars['Date']['output'];
  tracked_time: Scalars['BigInt']['output'];
};

export type TimeTrackingWorkType = {
  __typename?: 'TimeTrackingWorkType';
  alias: Scalars['String']['output'];
  default_rate: Scalars['BigInt']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type TimeTrackingWorkTypeMapping = {
  from_time_tracking_work_type_id: Scalars['ID']['input'];
  to_time_tracking_work_type_id: Scalars['ID']['input'];
};

export type Timer = {
  __typename?: 'Timer';
  ends_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  starts_at: Scalars['DateTime']['output'];
  timeTrackingItem?: Maybe<TimeTrackingItem>;
};

export type ToggleTaskCommentReactionInput = {
  emoji_id: Scalars['String']['input'];
  task_comment_id: Scalars['ID']['input'];
};

export type TopBrand = {
  __typename?: 'TopBrand';
  name: Scalars['String']['output'];
  value: Scalars['BigInt']['output'];
};

export type TopClient = {
  __typename?: 'TopClient';
  brands: Array<TopBrand>;
  name: Scalars['String']['output'];
  total_value: Scalars['BigInt']['output'];
};

export type TopProject = {
  __typename?: 'TopProject';
  expense_budget_categories?: Maybe<Array<Maybe<ExpenseBudgetCategoryTopProject>>>;
  our_work: OurWorkTopProject;
  title: Scalars['String']['output'];
  total_value: Scalars['BigInt']['output'];
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type UpdateBillingEntityInput = {
  applies_vat: Scalars['Boolean']['input'];
  city: Scalars['String']['input'];
  country_id: Scalars['ID']['input'];
  default_currency_id: Scalars['ID']['input'];
  disable_email_notification: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  internal_name: Scalars['String']['input'];
  invoice_email?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  legal_name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  payment_due?: InputMaybe<Scalars['BigInt']['input']>;
  registration_no?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  tax_no?: InputMaybe<Scalars['String']['input']>;
  vat_no?: InputMaybe<Scalars['String']['input']>;
  workspace_bank_account_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id: Scalars['ID']['input'];
  zip: Scalars['String']['input'];
};

export type UpdateBillingPlanInput = {
  items: Array<BillingPlanItemInput>;
  project_id: Scalars['ID']['input'];
};

export type UpdateBrandCreditAccountInput = {
  expense_budget_category_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  our_work_budget_category_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  team_id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type UpdateBrandInput = {
  code: Scalars['String']['input'];
  default_billing_entity_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  numeric_code?: InputMaybe<Scalars['String']['input']>;
  other_responsible_person_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  responsible_person_user_id?: InputMaybe<Scalars['ID']['input']>;
  update_project_codes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateBudgetItem = {
  deadline?: InputMaybe<Scalars['Date']['input']>;
  hidden: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateBudgetovacPositionInput = {
  department_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateBudgetovacPositionsSetInput = {
  active: Scalars['Boolean']['input'];
  client_id?: InputMaybe<Scalars['Int']['input']>;
  currency_code: Scalars['String']['input'];
  external_production_commission?: InputMaybe<Scalars['Float']['input']>;
  extras_commission?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  internal_production_commission?: InputMaybe<Scalars['Float']['input']>;
  media_budget_commission?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  positions_prices: Array<BudgetovacPositionPriceInput>;
};

export type UpdateCapacityAllocationForDayInput = {
  attendees?: InputMaybe<Array<CapacityAllocationAttendee>>;
  capacity_allocation_id: Scalars['ID']['input'];
  create_task_positions: Scalars['Boolean']['input'];
  created_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  deadline_time?: InputMaybe<Scalars['Time']['input']>;
  from_time?: InputMaybe<Scalars['Time']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['ID']['input']>;
  team_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  time_off_duration_type?: InputMaybe<TimeOffDurationTypeEnum>;
  time_off_type_id?: InputMaybe<Scalars['ID']['input']>;
  to_time?: InputMaybe<Scalars['Time']['input']>;
  total_time?: InputMaybe<Scalars['BigInt']['input']>;
  total_time_per_day?: InputMaybe<Scalars['BigInt']['input']>;
  type?: InputMaybe<CapacityAllocationTypeEnum>;
  updating_from_item_id: Scalars['ID']['input'];
};

export type UpdateCapacityAllocationInput = {
  accept_for_user_id?: InputMaybe<Scalars['ID']['input']>;
  attendees?: InputMaybe<Array<CapacityAllocationAttendee>>;
  create_task_positions: Scalars['Boolean']['input'];
  created_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  deadline?: InputMaybe<Scalars['Date']['input']>;
  deadline_time?: InputMaybe<Scalars['Time']['input']>;
  from_date?: InputMaybe<Scalars['Date']['input']>;
  from_time?: InputMaybe<Scalars['Time']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  repetition?: InputMaybe<CapacityAllocationRepetitionTypeEnum>;
  repetition_settings?: InputMaybe<CapacityAllocationRepetitionSettings>;
  task_id?: InputMaybe<Scalars['ID']['input']>;
  team_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  time_off_duration_type?: InputMaybe<TimeOffDurationTypeEnum>;
  time_off_type_id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  to_date?: InputMaybe<Scalars['Date']['input']>;
  to_time?: InputMaybe<Scalars['Time']['input']>;
  total_time?: InputMaybe<Scalars['BigInt']['input']>;
  total_time_per_day?: InputMaybe<Scalars['BigInt']['input']>;
  type?: InputMaybe<CapacityAllocationTypeEnum>;
  updating_item_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCapacityAllocationItemInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  create_task_positions?: InputMaybe<Scalars['Boolean']['input']>;
  created_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  from_time?: InputMaybe<Scalars['Time']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  task_id?: InputMaybe<Scalars['ID']['input']>;
  team_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  time_off_duration_type?: InputMaybe<TimeOffDurationTypeEnum>;
  time_off_type_id?: InputMaybe<Scalars['ID']['input']>;
  time_tracking_work_type_id?: InputMaybe<Scalars['ID']['input']>;
  to_time?: InputMaybe<Scalars['Time']['input']>;
  total_time?: InputMaybe<Scalars['BigInt']['input']>;
  type?: InputMaybe<CapacityAllocationTypeEnum>;
  user_id: Scalars['ID']['input'];
};

export type UpdateClientInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  other_responsible_person_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  responsible_person_user_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id: Scalars['ID']['input'];
};

export type UpdateCompanySettingsInput = {
  city: Scalars['String']['input'];
  country_id: Scalars['BigInt']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  title: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type UpdateContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  last_name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContractInput = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  client_id?: InputMaybe<Scalars['ID']['input']>;
  contractor_id?: InputMaybe<Scalars['ID']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  id: Scalars['ID']['input'];
  project_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ContractTypeEnum>;
  valid_from?: InputMaybe<Scalars['Date']['input']>;
  valid_to?: InputMaybe<Scalars['Date']['input']>;
  valid_to_indefinite?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateContractorInput = {
  bank_account?: InputMaybe<Scalars['String']['input']>;
  bank_account_code?: InputMaybe<Scalars['String']['input']>;
  business_form?: InputMaybe<BusinessFormEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['ID']['input']>;
  default_accounting_account_id?: InputMaybe<Scalars['ID']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  legal_name: Scalars['String']['input'];
  national_id?: InputMaybe<Scalars['String']['input']>;
  registration_no?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  swift?: InputMaybe<Scalars['String']['input']>;
  tax_no?: InputMaybe<Scalars['String']['input']>;
  vat_no?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCurrencyExchangeRateInput = {
  exchange_rate: Scalars['BigInt']['input'];
  id: Scalars['ID']['input'];
  valid_from?: InputMaybe<Scalars['Date']['input']>;
  valid_to?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateEmailTemplateInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
  type: EmailTemplateTypeEnum;
};

export type UpdateExchangeRateSettingsInput = {
  exchange_rate: Scalars['BigInt']['input'];
  id: Scalars['ID']['input'];
  valid_from?: InputMaybe<Scalars['Date']['input']>;
  valid_to?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateExpenseInput = {
  amount_in_currency?: InputMaybe<Scalars['BigInt']['input']>;
  bank_account?: InputMaybe<Scalars['String']['input']>;
  bank_account_code?: InputMaybe<Scalars['String']['input']>;
  business_form?: InputMaybe<BusinessFormEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  constant_symbol?: InputMaybe<Scalars['String']['input']>;
  contract_id?: InputMaybe<Scalars['ID']['input']>;
  contractor_id?: InputMaybe<Scalars['ID']['input']>;
  country_id?: InputMaybe<Scalars['ID']['input']>;
  currency_id: Scalars['ID']['input'];
  date_of_supply?: InputMaybe<Scalars['Date']['input']>;
  default_accounting_account_id?: InputMaybe<Scalars['ID']['input']>;
  document_number?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  exchange_rate?: InputMaybe<Scalars['BigInt']['input']>;
  expense_items?: InputMaybe<Array<ExpenseItemInput>>;
  expense_no?: InputMaybe<Scalars['String']['input']>;
  expense_vat_items?: InputMaybe<Array<ExpenseVatItemInput>>;
  files?: InputMaybe<Array<FileInput>>;
  for_approval: Scalars['Boolean']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  internal_note?: InputMaybe<Scalars['String']['input']>;
  internal_number?: InputMaybe<Scalars['String']['input']>;
  invoice_order_sequence_id?: InputMaybe<Scalars['ID']['input']>;
  is_draft: Scalars['Boolean']['input'];
  issue_date?: InputMaybe<Scalars['Date']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  national_id?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paid_at?: InputMaybe<Scalars['Date']['input']>;
  payment_type_id?: InputMaybe<Scalars['ID']['input']>;
  registration_no?: InputMaybe<Scalars['String']['input']>;
  /** IDs of related expenses to link (bidirectional relationship) */
  related_expense_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  specific_symbol?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  swift?: InputMaybe<Scalars['String']['input']>;
  tax_no?: InputMaybe<Scalars['String']['input']>;
  total_amount_includes_vat?: InputMaybe<Scalars['Boolean']['input']>;
  total_amount_with_vat_in_currency?: InputMaybe<Scalars['BigInt']['input']>;
  type: ExpenseTypeEnum;
  user_created_date: Scalars['Date']['input'];
  variable_symbol?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['BigInt']['input']>;
  vat_no?: InputMaybe<Scalars['String']['input']>;
  workspace_bank_account_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id?: InputMaybe<Scalars['ID']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExternalLinkInput = {
  id: Scalars['ID']['input'];
  link: Scalars['String']['input'];
  model_id: Scalars['ID']['input'];
  model_type: ExternalLinkType;
  title: Scalars['String']['input'];
};

export type UpdateFinanceSettingsInput = {
  automatically_approved_expense_items?: InputMaybe<Scalars['Boolean']['input']>;
  bankAccounts?: InputMaybe<Array<BankAccountSettingInput>>;
  can_transfer_credit_between_teams_without_constraints?: InputMaybe<Scalars['Boolean']['input']>;
  currency_id?: InputMaybe<Scalars['BigInt']['input']>;
  default_vat_rate_id?: InputMaybe<Scalars['BigInt']['input']>;
  invoicing_more_teams?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<LanguagesEnum>;
  outgoing_invoice_drafts_only?: InputMaybe<Scalars['Boolean']['input']>;
  registration_no: Scalars['String']['input'];
  show_contact_person?: InputMaybe<Scalars['Boolean']['input']>;
  show_full_bank_account_information?: InputMaybe<Scalars['Boolean']['input']>;
  show_project_codes?: InputMaybe<Scalars['Boolean']['input']>;
  tax_no: Scalars['String']['input'];
  text_on_invoice?: InputMaybe<Scalars['String']['input']>;
  vat_no: Scalars['String']['input'];
};

export type UpdateGlobalCreditAccountInput = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type UpdateNotificationSettingsInput = {
  email_footer?: InputMaybe<Scalars['String']['input']>;
  from_email?: InputMaybe<Scalars['String']['input']>;
  notification_email?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderInput = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  date_of_order?: InputMaybe<Scalars['Date']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  id: Scalars['ID']['input'];
  project_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  purchase_order_no?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOtherDocumentInput = {
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  client_id?: InputMaybe<Scalars['ID']['input']>;
  contractor_id?: InputMaybe<Scalars['ID']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  id: Scalars['ID']['input'];
  project_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOutgoingInvoiceInput = {
  assignable_file_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  billing_entity_id: Scalars['ID']['input'];
  brand_ids: Array<Scalars['ID']['input']>;
  client_id: Scalars['ID']['input'];
  contact_id?: InputMaybe<Scalars['ID']['input']>;
  credit_note_outgoing_invoice_id?: InputMaybe<Scalars['ID']['input']>;
  currency_id: Scalars['ID']['input'];
  date_of_supply: Scalars['Date']['input'];
  due_date: Scalars['Date']['input'];
  exchange_rate: Scalars['BigInt']['input'];
  exchange_rate_source: ExchangeRateSource;
  expense_budget_splits: Array<ExpenseBudgetSplitInput>;
  id: Scalars['ID']['input'];
  internal_note?: InputMaybe<Scalars['String']['input']>;
  invoice_items: Array<InvoiceItemInput>;
  invoice_no: Scalars['String']['input'];
  invoice_order_sequence_id: Scalars['ID']['input'];
  invoice_payment_method_id?: InputMaybe<Scalars['ID']['input']>;
  issue_date: Scalars['Date']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  order_ids: Array<Scalars['ID']['input']>;
  our_work_budget_splits: Array<OurWorkBudgetSplitInput>;
  outgoing_proforma_invoice_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  owner_id?: InputMaybe<Scalars['ID']['input']>;
  prepayment_splits: Array<PrepaymentSplitInput>;
  project_ids: Array<Scalars['ID']['input']>;
  proof_of_payments_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  refresh_billing_entity?: InputMaybe<Scalars['Boolean']['input']>;
  show_billing_accounting: Scalars['Boolean']['input'];
  show_unit_price: Scalars['Boolean']['input'];
  team_ids: Array<Scalars['ID']['input']>;
  text_on_invoice?: InputMaybe<Scalars['String']['input']>;
  timeMaterialsInvoiceData?: InputMaybe<TimeMaterialsInputData>;
  total_in_words?: InputMaybe<Scalars['String']['input']>;
  vat_percent_informative?: InputMaybe<Scalars['BigInt']['input']>;
  vat_reverse_charge: Scalars['Boolean']['input'];
  workspace_bank_account_id: Scalars['ID']['input'];
  workspace_company_id: Scalars['ID']['input'];
  workspace_exchange_rate: Scalars['BigInt']['input'];
  workspace_exchange_rate_source: ExchangeRateSource;
};

export type UpdateOutgoingInvoiceNumberInput = {
  id: Scalars['ID']['input'];
  invoice_no: Scalars['String']['input'];
  next_invoice_no?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOutgoingProformaInvoiceInput = {
  assignable_file_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  billing_entity_id: Scalars['ID']['input'];
  contact_id: Scalars['ID']['input'];
  currency_id: Scalars['ID']['input'];
  due_date: Scalars['Date']['input'];
  exchange_rate: Scalars['BigInt']['input'];
  exchange_rate_source: ExchangeRateSource;
  expense_budget_splits?: InputMaybe<Array<ExpenseBudgetSplitInput>>;
  id: Scalars['ID']['input'];
  internal_note?: InputMaybe<Scalars['String']['input']>;
  invoice_items: Array<InvoiceItemInput>;
  invoice_no: Scalars['ID']['input'];
  invoice_order_sequence_id: Scalars['ID']['input'];
  invoice_payment_method_id?: InputMaybe<Scalars['ID']['input']>;
  issue_date: Scalars['Date']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  our_work_budget_splits?: InputMaybe<Array<OurWorkBudgetSplitInput>>;
  owner_id?: InputMaybe<Scalars['ID']['input']>;
  prepayment_splits?: InputMaybe<Array<PrepaymentSplitInput>>;
  project_ids: Array<Scalars['ID']['input']>;
  refresh_billing_entity?: InputMaybe<Scalars['Boolean']['input']>;
  show_billing_accounting: Scalars['Boolean']['input'];
  show_unit_price: Scalars['Boolean']['input'];
  team_ids: Array<Scalars['ID']['input']>;
  text_on_invoice?: InputMaybe<Scalars['String']['input']>;
  vat_percent_informative?: InputMaybe<Scalars['BigInt']['input']>;
  vat_reverse_charge: Scalars['Boolean']['input'];
  workspace_bank_account_id: Scalars['ID']['input'];
  workspace_company_id: Scalars['ID']['input'];
  workspace_exchange_rate: Scalars['BigInt']['input'];
  workspace_exchange_rate_source: ExchangeRateSource;
};

export type UpdatePasswordInput = {
  new_password: Scalars['String']['input'];
  old_password: Scalars['String']['input'];
};

export type UpdatePaymentSettingsInput = {
  default_payment_due?: InputMaybe<Scalars['String']['input']>;
  domestic_payment_order_provider?: InputMaybe<PaymentOrderProviderEnum>;
  foreign_payment_order_provider?: InputMaybe<PaymentOrderProviderEnum>;
};

export type UpdatePlanningSettings = {
  planning_view_settings: Array<PlanningViewSettingInput>;
};

export type UpdateProjectBudgetInput = {
  budget_valid_from?: InputMaybe<Scalars['Date']['input']>;
  expenses: Array<ExpenseBudgetItemInput>;
  ourWork: Array<OurWorkBudgetItemInput>;
  project_id: Scalars['ID']['input'];
};

export type UpdateProjectInput = {
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  brand_id?: InputMaybe<Scalars['ID']['input']>;
  category_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  contact_id?: InputMaybe<Scalars['ID']['input']>;
  expected_end_date?: InputMaybe<Scalars['Date']['input']>;
  from_duplicate_project_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  is_template: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  other_project_manager_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  project_manager_id?: InputMaybe<Scalars['ID']['input']>;
  propagate_billable?: InputMaybe<Scalars['Boolean']['input']>;
  scopes?: InputMaybe<Array<UserScopeEnum>>;
  start_date?: InputMaybe<Scalars['Date']['input']>;
  team_id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProjectTypeEnum>;
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateProjectSettingsInput = {
  create_default_task_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  default_task_priority_id?: InputMaybe<Scalars['BigInt']['input']>;
  default_task_status_id?: InputMaybe<Scalars['BigInt']['input']>;
  project_code_generator?: InputMaybe<ProjectCodeGeneratorEnum>;
  project_code_length?: InputMaybe<Scalars['BigInt']['input']>;
  project_code_with_year?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input pre update Time Billing */
export type UpdateProjectTimeBillingInput = {
  components?: InputMaybe<Array<TimeBillingComponentInput>>;
  final_total_amount?: InputMaybe<Scalars['BigInt']['input']>;
  final_total_note?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  recompute?: InputMaybe<Scalars['Boolean']['input']>;
  source_ids?: InputMaybe<Array<TimeBillingSourceInput>>;
  timeTrackingItemIds: Array<Scalars['BigInt']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TimeBillingTypeEnum>;
  user_rows?: InputMaybe<Array<TimeBillingUserRowInput>>;
};

export type UpdateRequestForInvoicingInput = {
  assignable_file_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  billing_entity_id?: InputMaybe<Scalars['ID']['input']>;
  brand_ids: Array<Scalars['ID']['input']>;
  client_id: Scalars['ID']['input'];
  contact_id?: InputMaybe<Scalars['ID']['input']>;
  credit_note_outgoing_invoice_id?: InputMaybe<Scalars['ID']['input']>;
  currency_id: Scalars['ID']['input'];
  date_of_supply?: InputMaybe<Scalars['Date']['input']>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  exchange_rate: Scalars['BigInt']['input'];
  exchange_rate_source: ExchangeRateSource;
  expense_budget_splits: Array<ExpenseBudgetSplitInput>;
  id: Scalars['ID']['input'];
  internal_note?: InputMaybe<Scalars['String']['input']>;
  invoice_items: Array<InvoiceItemInput>;
  invoice_payment_method_id?: InputMaybe<Scalars['ID']['input']>;
  issue_date?: InputMaybe<Scalars['Date']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  order_ids: Array<Scalars['ID']['input']>;
  our_work_budget_splits: Array<OurWorkBudgetSplitInput>;
  outgoing_proforma_invoice_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  owner_id?: InputMaybe<Scalars['ID']['input']>;
  prepayment_splits: Array<PrepaymentSplitInput>;
  project_ids: Array<Scalars['ID']['input']>;
  proof_of_payments_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  show_billing_accounting: Scalars['Boolean']['input'];
  show_unit_price: Scalars['Boolean']['input'];
  status: RequestForInvoicingStatusEnum;
  team_ids: Array<Scalars['ID']['input']>;
  text_on_invoice?: InputMaybe<Scalars['String']['input']>;
  timeMaterialsInvoiceData?: InputMaybe<TimeMaterialsInputData>;
  total_in_words?: InputMaybe<Scalars['String']['input']>;
  vat_percent_informative?: InputMaybe<Scalars['BigInt']['input']>;
  vat_reverse_charge: Scalars['Boolean']['input'];
  workspace_bank_account_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id: Scalars['ID']['input'];
  workspace_exchange_rate: Scalars['BigInt']['input'];
  workspace_exchange_rate_source: ExchangeRateSource;
};

export type UpdateScopedTaskInput = {
  addFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<TaskDescriptionInput>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['ID']['input']>;
  removeFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  task_priority_id?: InputMaybe<Scalars['ID']['input']>;
  task_status_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSequenceInput = {
  amount: Scalars['BigInt']['input'];
  id: Scalars['BigInt']['input'];
  type: Array<SequenceTypesEnum>;
};

export type UpdateTaskBoardSettingsInput = {
  /** Board context: tab + group by, e.g. "my:TASK_STATUS". */
  board_key: Scalars['String']['input'];
  /** Null = leave unchanged. Pass [] to clear. */
  collapsed_columns?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Null = leave unchanged. Pass [] to clear. */
  column_order?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Null = leave unchanged. Pass [] to clear. */
  hidden_columns?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Null = leave unchanged. */
  sort?: InputMaybe<TaskBoardSortInput>;
};

export type UpdateTaskCommentInput = {
  body: Scalars['String']['input'];
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['ID']['input'];
  mentioned_assignees?: InputMaybe<Scalars['Boolean']['input']>;
  mentioned_team_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  mentioned_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** only for ApiClient */
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTaskDescriptionInput = {
  addFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<TaskDescriptionInput>;
  id: Scalars['ID']['input'];
  removeFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateTaskInput = {
  addFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  create_capacity_allocations?: InputMaybe<Scalars['Boolean']['input']>;
  current_assignee_user_id?: InputMaybe<Scalars['ID']['input']>;
  days_to_deadline?: InputMaybe<Scalars['Int']['input']>;
  days_to_from?: InputMaybe<Scalars['Int']['input']>;
  days_to_to?: InputMaybe<Scalars['Int']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  default_planned_time?: InputMaybe<Scalars['BigInt']['input']>;
  description?: InputMaybe<TaskDescriptionInput>;
  from?: InputMaybe<Scalars['Date']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  is_template: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  our_work_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
  parent_id?: InputMaybe<Scalars['ID']['input']>;
  /** only for ApiClient */
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  position_mapping?: InputMaybe<Array<PositionMappingInput>>;
  positions?: InputMaybe<Array<TaskPositionInput>>;
  removeFiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scopes?: InputMaybe<Array<UserScopeEnum>>;
  task_priority_id?: InputMaybe<Scalars['ID']['input']>;
  task_status_id?: InputMaybe<Scalars['ID']['input']>;
  task_template_group_id?: InputMaybe<Scalars['ID']['input']>;
  team_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  to?: InputMaybe<Scalars['Date']['input']>;
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateTimeTrackingBudgetItemInput = {
  our_work_budget_item_id: Scalars['ID']['input'];
  tracking_enabled: Scalars['Boolean']['input'];
  tracking_enabled_from?: InputMaybe<Scalars['Date']['input']>;
  tracking_enabled_to?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateTimeTrackingItemInput = {
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  specific_time_from?: InputMaybe<Scalars['Time']['input']>;
  specific_time_to?: InputMaybe<Scalars['Time']['input']>;
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  tracked_for_date: Scalars['Date']['input'];
  tracked_time?: InputMaybe<Scalars['BigInt']['input']>;
};

export type UpdateTimeTrackingRateInput = {
  rate: Scalars['BigInt']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
};

export type UpdateTimeTrackingRatesForBrandInput = {
  average_rate?: InputMaybe<Scalars['BigInt']['input']>;
  brand_id: Scalars['ID']['input'];
  time_tracking_rates_per_work_type?: InputMaybe<Array<UpdateTimeTrackingRateInput>>;
};

export type UpdateTimeTrackingRatesForProjectInput = {
  average_rate?: InputMaybe<Scalars['BigInt']['input']>;
  force_update?: InputMaybe<Scalars['Boolean']['input']>;
  project_id: Scalars['ID']['input'];
  time_tracking_rates_per_work_type?: InputMaybe<Array<UpdateTimeTrackingRateInput>>;
};

export type UpdateTimeTrackingSettingsInput = {
  our_work_budget_items: Array<UpdateTimeTrackingBudgetItemInput>;
  project_id: Scalars['ID']['input'];
};

export type UpdateTimeTrackingWorkTypeInput = {
  default_rate: Scalars['Float']['input'];
  new_alias: Scalars['String']['input'];
  old_alias: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type UpdateUserInput = {
  brand_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  calendar_sync_allocation_types?: InputMaybe<Array<InputMaybe<CapacityAllocationTypeEnum>>>;
  calendar_sync_direction?: InputMaybe<CalendarSyncDirectionEnum>;
  codename?: InputMaybe<Scalars['String']['input']>;
  default_work_type_id?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  hex_color?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  last_name?: InputMaybe<Scalars['String']['input']>;
  muted_mail_notifications?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  plannable?: InputMaybe<Scalars['Boolean']['input']>;
  role_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  scope_access?: InputMaybe<UserScopeAccessEnum>;
  scope_project_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  scope_task_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  task_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  team_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateUserPasswordInput = {
  id: Scalars['ID']['input'];
  password: Scalars['String']['input'];
};

export type UpdateVatRateInput = {
  amount: Scalars['BigInt']['input'];
  id: Scalars['BigInt']['input'];
  type: VatRateTypeEnum;
};

export type UpdateWorkspaceSmtpSettingsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  microsoft_shared_mailbox?: InputMaybe<Scalars['String']['input']>;
  smtp_encryption?: InputMaybe<Scalars['String']['input']>;
  smtp_from_address?: InputMaybe<Scalars['String']['input']>;
  smtp_from_name?: InputMaybe<Scalars['String']['input']>;
  smtp_host?: InputMaybe<Scalars['String']['input']>;
  smtp_password?: InputMaybe<Scalars['String']['input']>;
  smtp_port?: InputMaybe<Scalars['Int']['input']>;
  smtp_username?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  PMActiveProjectsCount: Scalars['BigInt']['output'];
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  brands: Array<Brand>;
  calendar_integrations?: Maybe<Array<Maybe<CalendarTypeEnum>>>;
  calendar_sync_allocation_types?: Maybe<Array<Maybe<CapacityAllocationTypeEnum>>>;
  calendar_sync_direction?: Maybe<CalendarSyncDirectionEnum>;
  codename?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  display_name: Scalars['String']['output'];
  email: Scalars['String']['output'];
  enabled_two_factor_authentication: Scalars['Boolean']['output'];
  first_name: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<AssignableFile>;
  last_name: Scalars['String']['output'];
  /**
   * Please only call me on user or me query, nothing that returns list of users
   * @deprecated No longer supported
   */
  mainPMActiveProjectsCount: Scalars['BigInt']['output'];
  mcpTokens: Array<McpToken>;
  mcp_connected: Scalars['Boolean']['output'];
  muted_mail_notifications: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  ownedOICount: Scalars['BigInt']['output'];
  permissions: PermissionList;
  phone?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<UserProfile>;
  projects: Array<Project>;
  roles: Array<Role>;
  scope?: Maybe<UserScope>;
  scope_access?: Maybe<UserScopeAccessEnum>;
  statusRanges: Array<UserStatusRange>;
  tasks: Array<Task>;
  team?: Maybe<Team>;
  updated_at: Scalars['DateTime']['output'];
};

export type UserAllocatedTime = {
  __typename?: 'UserAllocatedTime';
  dates?: Maybe<Array<UserAllocatedTimeDate>>;
  user_id: Scalars['ID']['output'];
};

export type UserAllocatedTimeData = {
  __typename?: 'UserAllocatedTimeData';
  from_time?: Maybe<Scalars['Time']['output']>;
  to_time?: Maybe<Scalars['Time']['output']>;
  type: CapacityAllocationTypeEnum;
  value: Scalars['BigInt']['output'];
};

export type UserAllocatedTimeDate = {
  __typename?: 'UserAllocatedTimeDate';
  data?: Maybe<Array<UserAllocatedTimeData>>;
  date: Scalars['Date']['output'];
  planned_capacity: Scalars['BigInt']['output'];
};

export type UserAllocationConflicts = {
  __typename?: 'UserAllocationConflicts';
  conflict: Scalars['Boolean']['output'];
  user_id: Scalars['ID']['output'];
};

/** Triadsk use this type for vacation api */
export type UserForPlanovac = {
  __typename?: 'UserForPlanovac';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  can_update_users: Scalars['Boolean']['output'];
  codename?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  default_work_type_id: Scalars['ID']['output'];
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<AssignableFile>;
  name: Scalars['String']['output'];
  profile: UserProfile;
  team_id: Scalars['ID']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type UserMonthlyReport = {
  __typename?: 'UserMonthlyReport';
  id: Scalars['ID']['output'];
  total_tracked_time: Scalars['BigInt']['output'];
  tracked_time_per_team: Array<UserMonthlyReportPerTeam>;
  user_full_name: Scalars['String']['output'];
  user_image?: Maybe<Scalars['String']['output']>;
};

export type UserMonthlyReportOrderByClause = {
  column: UserMonthlyReportOrderByColumnEnum;
  order: SortOrder;
  team_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum UserMonthlyReportOrderByColumnEnum {
  TrackedTimeByTeam = 'TRACKED_TIME_BY_TEAM',
  TrackedTimePercentageByTeam = 'TRACKED_TIME_PERCENTAGE_BY_TEAM',
  UserFullName = 'USER_FULL_NAME',
  UserTotalTrackedTime = 'USER_TOTAL_TRACKED_TIME'
}

export type UserMonthlyReportPaginator = {
  __typename?: 'UserMonthlyReportPaginator';
  data: Array<UserMonthlyReport>;
  paginatorInfo: PaginatorInfo;
  teams: Array<Team>;
};

export type UserMonthlyReportPerTeam = {
  __typename?: 'UserMonthlyReportPerTeam';
  team_id: Scalars['ID']['output'];
  tracked_time: Scalars['BigInt']['output'];
  tracked_time_percentage: Scalars['String']['output'];
};

export type UserOrderByClause = {
  column: UserOrderByColumnEnum;
  order: SortOrder;
};

export enum UserOrderByColumnEnum {
  Email = 'EMAIL',
  FullName = 'FULL_NAME',
  TeamName = 'TEAM_NAME'
}

/** A paginated list of User items. */
export type UserPaginator = {
  __typename?: 'UserPaginator';
  /** A list of User items. */
  data: Array<User>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  defaultWorktype: TimeTrackingWorkType;
  from_default_utilization_range: Scalars['Boolean']['output'];
  hex_color: Scalars['String']['output'];
  plannable: Scalars['Boolean']['output'];
  planningRanges: Array<UserProfilePlanningRange>;
  rates: Array<UserProfileRate>;
  utilization_range_from: Scalars['BigInt']['output'];
  utilization_range_to: Scalars['BigInt']['output'];
};

export type UserProfilePlanningRange = {
  __typename?: 'UserProfilePlanningRange';
  daily_capacity?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['ID']['output'];
  type: PlanningRangeType;
  utilising: Scalars['Boolean']['output'];
  valid_from: Scalars['Date']['output'];
  valid_to?: Maybe<Scalars['Date']['output']>;
  weekly_capacities?: Maybe<WeeklyCapacities>;
};

export type UserProfileRate = {
  __typename?: 'UserProfileRate';
  id: Scalars['ID']['output'];
  rate: Scalars['BigInt']['output'];
  valid_from: Scalars['Date']['output'];
  valid_to?: Maybe<Scalars['Date']['output']>;
};

export type UserProfileRateInput = {
  rate: Scalars['BigInt']['input'];
  valid_from: Scalars['Date']['input'];
  valid_to?: InputMaybe<Scalars['Date']['input']>;
};

export type UserQueryArgs = {
  orderBy?: InputMaybe<Array<UserOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<UsersWhereConditions>;
};

export type UserScope = {
  __typename?: 'UserScope';
  value: UserScopeEnum;
};

export enum UserScopeAccessEnum {
  All = 'ALL',
  Assigned = 'ASSIGNED'
}

export enum UserScopeEnum {
  Client = 'CLIENT',
  Internal = 'INTERNAL',
  Partner = 'PARTNER'
}

export type UserSimple = {
  __typename?: 'UserSimple';
  archived_at?: Maybe<Scalars['DateTime']['output']>;
  codename?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  full_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<AssignableFile>;
  name: Scalars['String']['output'];
  profile?: Maybe<UserProfile>;
  team_id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type UserStatusRange = {
  __typename?: 'UserStatusRange';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  projectManager?: Maybe<User>;
  valid_from: Scalars['Date']['output'];
  valid_to?: Maybe<Scalars['Date']['output']>;
};

export type UsersSummary = {
  __typename?: 'UsersSummary';
  userIds: Array<Scalars['ID']['output']>;
};

export enum UsersWhereColumn {
  BrandId = 'BRAND_ID',
  RoleId = 'ROLE_ID',
  Scope = 'SCOPE',
  Status = 'STATUS',
  TeamId = 'TEAM_ID'
}

export type UsersWhereConditions = {
  AND?: InputMaybe<Array<UsersWhereConditions>>;
  OR?: InputMaybe<Array<UsersWhereConditions>>;
  column?: InputMaybe<UsersWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type UtilizationReport = {
  __typename?: 'UtilizationReport';
  allocated_amount_billable?: Maybe<Scalars['Int']['output']>;
  allocated_expenses?: Maybe<Scalars['Int']['output']>;
  allocated_time?: Maybe<Scalars['Int']['output']>;
  allocated_time_billable?: Maybe<Scalars['Int']['output']>;
  available_time: Scalars['Int']['output'];
  budgeted_amount_billable?: Maybe<Scalars['Int']['output']>;
  budgeted_expenses?: Maybe<Scalars['Int']['output']>;
  budgeted_profit_amount?: Maybe<Scalars['Int']['output']>;
  budgeted_time?: Maybe<Scalars['Int']['output']>;
  budgeted_time_billable?: Maybe<Scalars['Int']['output']>;
  combined_amount_billable?: Maybe<Scalars['Int']['output']>;
  combined_expenses?: Maybe<Scalars['Int']['output']>;
  combined_profit_amount?: Maybe<Scalars['Int']['output']>;
  combined_time?: Maybe<Scalars['Int']['output']>;
  combined_time_billable?: Maybe<Scalars['Int']['output']>;
  internal_cost?: Maybe<Scalars['Int']['output']>;
  overtime: Scalars['Int']['output'];
  remaining_time: Scalars['Int']['output'];
  time_off: Scalars['Int']['output'];
  total_time: Scalars['Int']['output'];
  tracked_amount_billable?: Maybe<Scalars['Int']['output']>;
  tracked_expenses?: Maybe<Scalars['Int']['output']>;
  tracked_time?: Maybe<Scalars['Int']['output']>;
  tracked_time_billable?: Maybe<Scalars['Int']['output']>;
  utilization_percentage?: Maybe<Scalars['Int']['output']>;
  utilization_percentage_billable?: Maybe<Scalars['Int']['output']>;
};

export enum UtilizationReportDataSource {
  Combined = 'COMBINED',
  Planning = 'PLANNING',
  TaskPositions = 'TASK_POSITIONS',
  TimeTracking = 'TIME_TRACKING'
}

export type UtilizationReportGroup = {
  __typename?: 'UtilizationReportGroup';
  group_title: Scalars['String']['output'];
  items: Array<UtilizationUserReport>;
  report: UtilizationReport;
};

export enum UtilizationReportGroupBy {
  Month = 'MONTH',
  Team = 'TEAM',
  Week = 'WEEK',
  WorkType = 'WORK_TYPE'
}

export type UtilizationReportGroupOrderByClause = {
  column: UtilizationReportGroupOrderByColumn;
  order?: SortOrder;
};

export enum UtilizationReportGroupOrderByColumn {
  AllocatedTime = 'ALLOCATED_TIME',
  AllocatedTimeBillable = 'ALLOCATED_TIME_BILLABLE',
  AvailableTime = 'AVAILABLE_TIME',
  BudgetedTime = 'BUDGETED_TIME',
  BudgetedTimeBillable = 'BUDGETED_TIME_BILLABLE',
  CombinedTimeBillable = 'COMBINED_TIME_BILLABLE',
  CombinedTiMe = 'COMBINED_TiME',
  Group = 'GROUP',
  TrackedTime = 'TRACKED_TIME',
  TrackedTimeBillable = 'TRACKED_TIME_BILLABLE',
  UtilizationPercentage = 'UTILIZATION_PERCENTAGE',
  UtilizationPercentageBillable = 'UTILIZATION_PERCENTAGE_BILLABLE'
}

export type UtilizationReportGroupPaginator = {
  __typename?: 'UtilizationReportGroupPaginator';
  data: Array<UtilizationReportGroup>;
  paginatorInfo: PaginatorInfo;
};

export type UtilizationReportOrderByClause = {
  column: UtilizationReportOrderByColumn;
  order?: SortOrder;
};

export enum UtilizationReportOrderByColumn {
  AllocatedTime = 'ALLOCATED_TIME',
  AllocatedTimeBillable = 'ALLOCATED_TIME_BILLABLE',
  AvailableTime = 'AVAILABLE_TIME',
  BudgetedTime = 'BUDGETED_TIME',
  BudgetedTimeBillable = 'BUDGETED_TIME_BILLABLE',
  CombinedTimeBillable = 'COMBINED_TIME_BILLABLE',
  CombinedTiMe = 'COMBINED_TiME',
  TeamName = 'TEAM_NAME',
  TrackedTime = 'TRACKED_TIME',
  TrackedTimeBillable = 'TRACKED_TIME_BILLABLE',
  UtilizationPercentage = 'UTILIZATION_PERCENTAGE',
  UtilizationPercentageBillable = 'UTILIZATION_PERCENTAGE_BILLABLE',
  WorkTypeTitle = 'WORK_TYPE_TITLE'
}

export type UtilizationReportPaginator = {
  __typename?: 'UtilizationReportPaginator';
  data: Array<UtilizationUserReport>;
  paginatorInfo: PaginatorInfo;
};

export enum UtilizationReportWhereColumn {
  TeamId = 'TEAM_ID',
  UserId = 'USER_ID',
  WorkTypeId = 'WORK_TYPE_ID'
}

export type UtilizationReportWhereConditions = {
  AND?: InputMaybe<Array<UtilizationReportWhereConditions>>;
  OR?: InputMaybe<Array<UtilizationReportWhereConditions>>;
  column?: InputMaybe<UtilizationReportWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type UtilizationTaskReport = {
  __typename?: 'UtilizationTaskReport';
  allocated_amount?: Maybe<Scalars['Int']['output']>;
  allocated_in_range_amount?: Maybe<Scalars['Int']['output']>;
  allocated_time?: Maybe<Scalars['Int']['output']>;
  allocated_time_in_range?: Maybe<Scalars['Int']['output']>;
  allocated_time_in_range_percent?: Maybe<Scalars['Int']['output']>;
  allocated_time_percent?: Maybe<Scalars['Int']['output']>;
  budgeted_time: Scalars['Int']['output'];
  budgeted_time_in_range?: Maybe<Scalars['Int']['output']>;
  over_budget_amount?: Maybe<Scalars['Int']['output']>;
  over_budget_time?: Maybe<Scalars['Int']['output']>;
  over_budget_time_in_percent?: Maybe<Scalars['Int']['output']>;
  remaining_amount?: Maybe<Scalars['Int']['output']>;
  remaining_time: Scalars['Int']['output'];
  remaining_time_in_percent?: Maybe<Scalars['Int']['output']>;
  remaining_time_in_range?: Maybe<Scalars['Int']['output']>;
  task: Task;
  total_task_budget_amount?: Maybe<Scalars['Int']['output']>;
  total_task_budget_in_range?: Maybe<Scalars['Int']['output']>;
  tracked_amount?: Maybe<Scalars['Int']['output']>;
  tracked_in_range_amount?: Maybe<Scalars['Int']['output']>;
  tracked_time?: Maybe<Scalars['Int']['output']>;
  tracked_time_in_range?: Maybe<Scalars['Int']['output']>;
  tracked_time_in_range_percent?: Maybe<Scalars['Int']['output']>;
  tracked_time_percent?: Maybe<Scalars['Int']['output']>;
};

export type UtilizationUserReport = {
  __typename?: 'UtilizationUserReport';
  report: UtilizationReport;
  user: User;
};

export type VatRate = {
  __typename?: 'VatRate';
  amount: Scalars['BigInt']['output'];
  default: Scalars['Boolean']['output'];
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  type?: Maybe<VatRateTypeEnum>;
};

export type VatRateInput = {
  amount: Scalars['BigInt']['input'];
  default: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum VatRateTypeEnum {
  High = 'HIGH',
  Low = 'LOW',
  None = 'NONE',
  Third = 'THIRD'
}

export type WeekTimeReport = {
  __typename?: 'WeekTimeReport';
  dailyTotals: Array<WeeklyTimeReportTotalsPerDay>;
  rows: Array<WeeklyTimeReportRow>;
  suggestions: Array<Task>;
};

export type WeeklyCapacities = {
  __typename?: 'WeeklyCapacities';
  friday: Scalars['BigInt']['output'];
  monday: Scalars['BigInt']['output'];
  saturday: Scalars['BigInt']['output'];
  sunday: Scalars['BigInt']['output'];
  thursday: Scalars['BigInt']['output'];
  tuesday: Scalars['BigInt']['output'];
  wednesday: Scalars['BigInt']['output'];
};

export type WeeklyCapacitiesInput = {
  friday: Scalars['BigInt']['input'];
  monday: Scalars['BigInt']['input'];
  saturday: Scalars['BigInt']['input'];
  sunday: Scalars['BigInt']['input'];
  thursday: Scalars['BigInt']['input'];
  tuesday: Scalars['BigInt']['input'];
  wednesday: Scalars['BigInt']['input'];
};

export type WeeklyTimeReportRow = {
  __typename?: 'WeeklyTimeReportRow';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  task: Task;
  timeTrackingWorkType: TimeTrackingWorkType;
  trackedTime: Array<WeeklyTimeReportRowDay>;
};

export type WeeklyTimeReportRowDay = {
  __typename?: 'WeeklyTimeReportRowDay';
  date: Scalars['Date']['output'];
  tracked_time: Scalars['BigInt']['output'];
};

export type WeeklyTimeReportTotalsPerDay = {
  __typename?: 'WeeklyTimeReportTotalsPerDay';
  date: Scalars['Date']['output'];
  total_tracked_time: Scalars['BigInt']['output'];
};

/** Dynamic WHERE conditions for queries. */
export type WhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  AND?: InputMaybe<Array<WhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  HAS?: InputMaybe<WhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  OR?: InputMaybe<Array<WhereConditions>>;
  /** The column that is used for the condition. */
  column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE condition queries. */
export type WhereConditionsRelation = {
  /** The amount to test. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  condition?: InputMaybe<WhereConditions>;
  /** The comparison operator to test against the amount. */
  operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  relation: Scalars['String']['input'];
};

export type WipOrderByClause = {
  column: WipOrderByColumnEnum;
  order: SortOrder;
};

export enum WipOrderByColumnEnum {
  BrandName = 'BRAND_NAME',
  Progress = 'PROGRESS',
  ProgressChange = 'PROGRESS_CHANGE',
  ProjectCode = 'PROJECT_CODE',
  ProjectManager = 'PROJECT_MANAGER',
  SpentBudget = 'SPENT_BUDGET',
  SpentTime = 'SPENT_TIME',
  TotalBudget = 'TOTAL_BUDGET'
}

export type WipPeriod = {
  __typename?: 'WipPeriod';
  ends_at?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  is_current: Scalars['Boolean']['output'];
  starts_at: Scalars['Date']['output'];
  title: Scalars['String']['output'];
};

export type WipQueryArgs = {
  orderBy?: InputMaybe<Array<WipOrderByClause>>;
  period_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<WipsWhereConditions>;
};

export enum WipsWhereColumn {
  BrandId = 'BRAND_ID',
  OtherProjectManagerId = 'OTHER_PROJECT_MANAGER_ID',
  ProjectManagerId = 'PROJECT_MANAGER_ID',
  Status = 'STATUS',
  TeamId = 'TEAM_ID'
}

export type WipsWhereConditions = {
  AND?: InputMaybe<Array<WipsWhereConditions>>;
  OR?: InputMaybe<Array<WipsWhereConditions>>;
  column?: InputMaybe<WipsWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type WorkInProgressItemStat = {
  __typename?: 'WorkInProgressItemStat';
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  is_closed: Scalars['Boolean']['output'];
  is_locked: Scalars['Boolean']['output'];
  our_work_budget_item_id: Scalars['ID']['output'];
  period: WipPeriod;
  profit_estimate: Scalars['BigInt']['output'];
  profit_estimate_percent: Scalars['BigInt']['output'];
  progress: Scalars['BigInt']['output'];
  progress_change: Scalars['BigInt']['output'];
  progress_change_percent: Scalars['BigInt']['output'];
  progress_percent: Scalars['BigInt']['output'];
  project: Project;
  remaining_budget: Scalars['BigInt']['output'];
  remaining_time: Scalars['Float']['output'];
  spent_budget: Scalars['BigInt']['output'];
  spent_budget_percent: Scalars['BigInt']['output'];
  spent_time: Scalars['Float']['output'];
  spent_time_estimate: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  total_budget: Scalars['BigInt']['output'];
  total_budget_change: Scalars['BigInt']['output'];
  total_time: Scalars['Float']['output'];
  work_in_progress_id: Scalars['ID']['output'];
};

export type WorkInProgressProjectStat = {
  __typename?: 'WorkInProgressProjectStat';
  budgetItemsStats?: Maybe<Array<WorkInProgressItemStat>>;
  id: Scalars['ID']['output'];
  is_closed: Scalars['Boolean']['output'];
  is_locked: Scalars['Boolean']['output'];
  period: WipPeriod;
  profit_estimate: Scalars['BigInt']['output'];
  profit_estimate_percent: Scalars['BigInt']['output'];
  progress: Scalars['BigInt']['output'];
  progress_change: Scalars['BigInt']['output'];
  progress_change_percent: Scalars['BigInt']['output'];
  progress_percent: Scalars['BigInt']['output'];
  project: Project;
  remaining_budget: Scalars['BigInt']['output'];
  remaining_time: Scalars['Float']['output'];
  spent_budget: Scalars['BigInt']['output'];
  spent_budget_percent: Scalars['BigInt']['output'];
  spent_time: Scalars['Float']['output'];
  spent_time_estimate: Scalars['Float']['output'];
  status: WorkInProgressStatusEnum;
  total_budget: Scalars['BigInt']['output'];
  total_budget_change: Scalars['BigInt']['output'];
  total_time: Scalars['Float']['output'];
};

/** A paginated list of WorkInProgressProjectStat items. */
export type WorkInProgressProjectStatPaginator = {
  __typename?: 'WorkInProgressProjectStatPaginator';
  /** A list of WorkInProgressProjectStat items. */
  data: Array<WorkInProgressProjectStat>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum WorkInProgressStatusEnum {
  Closed = 'CLOSED',
  Locked = 'LOCKED',
  Open = 'OPEN'
}

export type WorkspaceAccountingAccount = {
  __typename?: 'WorkspaceAccountingAccount';
  account_number: Scalars['String']['output'];
  accounting_type: Accounting_Account_Type;
  budget_categories?: Maybe<Array<AccountingAccountBudgetCategory>>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type WorkspaceAccountingAccountSettings = {
  __typename?: 'WorkspaceAccountingAccountSettings';
  accounting_accounts: Array<WorkspaceAccountingAccount>;
};

export type WorkspaceAccountingCentreSettings = {
  __typename?: 'WorkspaceAccountingCentreSettings';
  accounting_centres: Array<AccountingCentre>;
};

export type WorkspaceAccountingVatClassificationSettings = {
  __typename?: 'WorkspaceAccountingVatClassificationSettings';
  accounting_vat_classifications: Array<AccountingVatClassification>;
};

export type WorkspaceAutoExpenseEmailSettings = {
  __typename?: 'WorkspaceAutoExpenseEmailSettings';
  imap_encryption: ImapEncryptionEnum;
  imap_host: Scalars['String']['output'];
  imap_port: Scalars['Int']['output'];
  imap_username: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
};

export type WorkspaceBankAccount = {
  __typename?: 'WorkspaceBankAccount';
  account_holder_name?: Maybe<Scalars['String']['output']>;
  bank_account?: Maybe<Scalars['String']['output']>;
  bank_code?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  bic: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  iban: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type WorkspaceCompany = {
  __typename?: 'WorkspaceCompany';
  bankAccounts: Array<WorkspaceBankAccount>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  currency?: Maybe<Currency>;
  currency_id?: Maybe<Scalars['ID']['output']>;
  deleted: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internal_name: Scalars['String']['output'];
  invoicePdfSettings?: Maybe<WorkspaceCompanyInvoicePdfSettings>;
  is_default: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  registration_no?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  tax_no?: Maybe<Scalars['String']['output']>;
  vat_no?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceCompanyBankAccountSettingInput = {
  account_holder_name?: InputMaybe<Scalars['String']['input']>;
  bank_account?: InputMaybe<Scalars['String']['input']>;
  bank_code?: InputMaybe<Scalars['String']['input']>;
  bank_name?: InputMaybe<Scalars['String']['input']>;
  bic: Scalars['String']['input'];
  iban: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type WorkspaceCompanyInput = {
  bank_accounts: Array<WorkspaceCompanyBankAccountSettingInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['ID']['input']>;
  currency_id?: InputMaybe<Scalars['ID']['input']>;
  deleted: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  internal_name: Scalars['String']['input'];
  is_default: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  pdfSettings?: InputMaybe<WorkspaceInvoicePdfSettingsInput>;
  registration_no?: InputMaybe<Scalars['String']['input']>;
  sequences: Array<WorkspaceSequenceSettingInput>;
  street?: InputMaybe<Scalars['String']['input']>;
  tax_no?: InputMaybe<Scalars['String']['input']>;
  vat_no?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type WorkspaceCompanyInvoicePdfSettings = {
  __typename?: 'WorkspaceCompanyInvoicePdfSettings';
  text_on_invoice?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceCompanySetting = {
  __typename?: 'WorkspaceCompanySetting';
  bank_accounts: Array<WorkspaceBankAccount>;
  city?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['ID']['output']>;
  currency_id?: Maybe<Scalars['ID']['output']>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  internal_name: Scalars['String']['output'];
  is_default: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pdfSettings: WorkspaceInvoicePdfSettings;
  registration_no?: Maybe<Scalars['String']['output']>;
  sequences: Array<WorkspaceSequence>;
  street?: Maybe<Scalars['String']['output']>;
  tax_no?: Maybe<Scalars['String']['output']>;
  vat_no?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceFinancialSetting = {
  __typename?: 'WorkspaceFinancialSetting';
  currencies: Array<Currency>;
  default_show_billing_accounting_on_invoices: Scalars['Boolean']['output'];
  default_show_unit_price_on_invoices: Scalars['Boolean']['output'];
  invoice_attachment_name_templates?: Maybe<InvoiceAttachmentNameTemplates>;
  vat_rates: Array<VatRate>;
};

export type WorkspaceInvoicePdfSettings = {
  __typename?: 'WorkspaceInvoicePdfSettings';
  footer?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logo_assignable_file?: Maybe<AssignableFile>;
  show_amount_in_words: Scalars['Boolean']['output'];
  show_contact_person: Scalars['Boolean']['output'];
  show_date_of_supply: Scalars['Boolean']['output'];
  show_full_bank_account_information: Scalars['Boolean']['output'];
  show_payment_type: Scalars['Boolean']['output'];
  show_project_codes: Scalars['Boolean']['output'];
  show_tax_no: Scalars['Boolean']['output'];
  show_variable_symbol: Scalars['Boolean']['output'];
  stamp?: Maybe<Scalars['String']['output']>;
  stamp_assignable_file?: Maybe<AssignableFile>;
  text_on_invoice?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceInvoicePdfSettingsInput = {
  logo_assignable_file_id?: InputMaybe<Scalars['ID']['input']>;
  stamp_assignable_file_id?: InputMaybe<Scalars['ID']['input']>;
};

export type WorkspaceNotification = {
  __typename?: 'WorkspaceNotification';
  database_enabled: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mail_enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roles_to_notify?: Maybe<Array<Scalars['String']['output']>>;
  threshold?: Maybe<Scalars['BigInt']['output']>;
  threshold_type: NotificationThresholdTypeEnum;
  to_roles: Scalars['Boolean']['output'];
};

export type WorkspaceNotificationInput = {
  database_enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  mail_enabled: Scalars['Boolean']['input'];
  roles_to_notify?: InputMaybe<Array<Scalars['String']['input']>>;
  threshold?: InputMaybe<Scalars['BigInt']['input']>;
};

export type WorkspacePipedriveIntegration = {
  __typename?: 'WorkspacePipedriveIntegration';
  initialization_url: Scalars['String']['output'];
  settings?: Maybe<WorkspacePipedriveSettings>;
};

export type WorkspacePipedriveIntegrationSettingInput = {
  pipedrive_stage_id: Scalars['ID']['input'];
  project_billable: Scalars['Boolean']['input'];
  project_stage_id: Scalars['ID']['input'];
};

export type WorkspacePipedriveSettings = {
  __typename?: 'WorkspacePipedriveSettings';
  pipedrive_stage_id?: Maybe<Scalars['ID']['output']>;
  project_billable?: Maybe<Scalars['Boolean']['output']>;
  project_stage_id?: Maybe<Scalars['ID']['output']>;
};

export type WorkspacePlanningSettings = {
  __typename?: 'WorkspacePlanningSettings';
  default_user_plannable_capacity: Scalars['BigInt']['output'];
  default_utilization_range_from: Scalars['Int']['output'];
  default_utilization_range_to: Scalars['Int']['output'];
  disable_home_office_in_planning: Scalars['Boolean']['output'];
  hide_planning_total_daily_capacity: Scalars['Boolean']['output'];
  planning_alphabet_user_order: Scalars['Boolean']['output'];
  planning_sort_prioritize_time_specific_items: Scalars['Boolean']['output'];
  specific_time_in_planning_enabled: Scalars['Boolean']['output'];
  start_day_of_week: StartDayOfWeekEnum;
  working_from: Scalars['Time']['output'];
  working_to: Scalars['Time']['output'];
};

export type WorkspaceProjectSettings = {
  __typename?: 'WorkspaceProjectSettings';
  automate_invoicing_plan_approval: Scalars['Boolean']['output'];
  can_close_expense_budget_item_with_unapproved_expenses: Scalars['Boolean']['output'];
  create_default_task_enabled: Scalars['Boolean']['output'];
  create_default_task_only_to_our_work_category: Scalars['Boolean']['output'];
  enable_additional_brand_numeric_code: Scalars['Boolean']['output'];
  our_work_budget_categories_count: Scalars['BigInt']['output'];
  project_code_generator: ProjectCodeGeneratorEnum;
  project_code_length: Scalars['Int']['output'];
  project_code_with_year: Scalars['Boolean']['output'];
  project_count: Scalars['BigInt']['output'];
};

export type WorkspaceSequence = {
  __typename?: 'WorkspaceSequence';
  format: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  next_number: Scalars['Int']['output'];
  types: Array<SequenceTypesEnum>;
};

export type WorkspaceSequenceSettingInput = {
  format: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  next_number: Scalars['Int']['input'];
  types: Array<SequenceTypesEnum>;
};

export type WorkspaceSettings = {
  __typename?: 'WorkspaceSettings';
  auto_complete_allocation_types?: Maybe<Array<Maybe<CapacityAllocationTypeEnum>>>;
  auto_deadline_in_tasks: Scalars['Boolean']['output'];
  automate_invoicing_plan_approval: Scalars['Boolean']['output'];
  automatically_approved_expense_items: Scalars['Boolean']['output'];
  bank_api_active: Scalars['Boolean']['output'];
  bmail_activated: Scalars['Boolean']['output'];
  brand_template_id?: Maybe<Scalars['ID']['output']>;
  budget_pdf_export_settings?: Maybe<BudgetPdfSettings>;
  budget_xlsx_languages?: Maybe<Array<Scalars['String']['output']>>;
  can_close_expense_budget_item_with_unapproved_expenses: Scalars['Boolean']['output'];
  can_skip_invoice_date_validations: Scalars['Boolean']['output'];
  can_transfer_credit_between_teams_without_constraints: Scalars['Boolean']['output'];
  can_transfer_credit_with_date_without_constraints: Scalars['Boolean']['output'];
  companies: Array<WorkspaceCompany>;
  contractor_fields_extra_validation: Scalars['Boolean']['output'];
  country: Country;
  create_quote_only_after_approved_budgets: Scalars['Boolean']['output'];
  currency: Currency;
  currencyExchangeRatesStructured: Array<CurrencyExchangeRateStructured>;
  defaultVatRate: VatRate;
  default_payment_due: Scalars['BigInt']['output'];
  default_show_billing_accounting_on_invoices: Scalars['Boolean']['output'];
  default_show_unit_price_on_invoices: Scalars['Boolean']['output'];
  default_task_priority_id: Scalars['BigInt']['output'];
  default_task_status_id: Scalars['BigInt']['output'];
  default_user_plannable_capacity: Scalars['BigInt']['output'];
  default_utilization_range_from: Scalars['Int']['output'];
  default_utilization_range_to: Scalars['Int']['output'];
  disable_home_office_in_planning: Scalars['Boolean']['output'];
  enable_additional_brand_numeric_code: Scalars['Boolean']['output'];
  enable_allocation_meeting_play: Scalars['Boolean']['output'];
  enable_bank: Scalars['Boolean']['output'];
  enable_calendar_integration: Scalars['Boolean']['output'];
  enable_contractor_full_bank_account_data: Scalars['Boolean']['output'];
  enable_expense_email_import: Scalars['Boolean']['output'];
  exchange_rate_denomination: Scalars['BigInt']['output'];
  expense_auto_cost_centre_by_team: Scalars['Boolean']['output'];
  expense_effectix_custom_cost_ratio: Scalars['Boolean']['output'];
  expense_identification_fields_required: Scalars['Boolean']['output'];
  exportSettings: ExportSettings;
  financial_amount_by_percent: Scalars['Boolean']['output'];
  generate_numerical_brand_codes: Scalars['Boolean']['output'];
  google_email_integration_enabled: Scalars['Boolean']['output'];
  hide_expense_summary: Scalars['Boolean']['output'];
  hide_planning_total_daily_capacity: Scalars['Boolean']['output'];
  highlight_overtime_in_tasks: Scalars['Boolean']['output'];
  invoice_attachment_name_templates?: Maybe<InvoiceAttachmentNameTemplates>;
  invoicing_more_teams: Scalars['Boolean']['output'];
  locale: Scalars['String']['output'];
  moduleSettings: ModuleSettings;
  notification_email?: Maybe<Scalars['String']['output']>;
  notification_emails_enabled: Scalars['Boolean']['output'];
  only_from_calendar_integration: Scalars['Boolean']['output'];
  partner_access_enabled: Scalars['Boolean']['output'];
  pipedrive_enabled: Scalars['Boolean']['output'];
  planned_expenses_show_client_price: Scalars['Boolean']['output'];
  planning_alphabet_user_order: Scalars['Boolean']['output'];
  planning_sort_prioritize_time_specific_items: Scalars['Boolean']['output'];
  planning_view_settings?: Maybe<Array<PlanningViewSetting>>;
  prevent_saving_duplicated_expenses: Scalars['Boolean']['output'];
  require_already_paid_subfields_for_drafts: Scalars['Boolean']['output'];
  require_project_category: Scalars['Boolean']['output'];
  require_two_factor_authentication: Scalars['Boolean']['output'];
  setup_completed?: Maybe<Scalars['Boolean']['output']>;
  show_accounting_vat_classification: Scalars['Boolean']['output'];
  show_amounts_in_time_tracking_report: Scalars['Boolean']['output'];
  show_done_tasks: Scalars['Boolean']['output'];
  show_expense_item_vat_rate: Scalars['Boolean']['output'];
  show_mcp_settings: Scalars['Boolean']['output'];
  show_smtp_settings: Scalars['Boolean']['output'];
  smtpSettings?: Maybe<WorkspaceSmtpSettings>;
  specific_time_in_planning_enabled: Scalars['Boolean']['output'];
  start_day_of_week: StartDayOfWeekEnum;
  time_tracking_rate_length: Scalars['BigInt']['output'];
  time_tracking_rate_type: Scalars['String']['output'];
  time_tracking_running_timers_timeout: Scalars['BigInt']['output'];
  timetastic_integration: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  transfer_credit_directly_from_invoice: Scalars['Boolean']['output'];
  trial_from?: Maybe<Scalars['Date']['output']>;
  unpaid_banner_message?: Maybe<Scalars['String']['output']>;
  use_current_assignee: Scalars['Boolean']['output'];
  vapid_public_key: Scalars['String']['output'];
  working_from: Scalars['Time']['output'];
  working_to: Scalars['Time']['output'];
  xero_enabled: Scalars['Boolean']['output'];
};

export type WorkspaceSmtpSettings = {
  __typename?: 'WorkspaceSmtpSettings';
  active: Scalars['Boolean']['output'];
  google_auth_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_google_connected: Scalars['Boolean']['output'];
  is_microsoft_connected: Scalars['Boolean']['output'];
  mail_type?: Maybe<MailTypeEnum>;
  microsoft_auth_url?: Maybe<Scalars['String']['output']>;
  microsoft_shared_mailbox?: Maybe<Scalars['String']['output']>;
  smtp_encryption?: Maybe<Scalars['String']['output']>;
  smtp_from_address?: Maybe<Scalars['String']['output']>;
  smtp_from_name?: Maybe<Scalars['String']['output']>;
  smtp_host?: Maybe<Scalars['String']['output']>;
  smtp_password?: Maybe<Scalars['String']['output']>;
  smtp_port?: Maybe<Scalars['Int']['output']>;
  smtp_username?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceTaskPriority = {
  __typename?: 'WorkspaceTaskPriority';
  default: Scalars['Boolean']['output'];
  emoji?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  system_priority?: Maybe<TaskSystemPriorityEnum>;
};

export type WorkspaceTaskPriorityInput = {
  default: Scalars['Boolean']['input'];
  emoji?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  system_priority?: InputMaybe<TaskSystemPriorityEnum>;
};

export type WorkspaceTaskSettings = {
  __typename?: 'WorkspaceTaskSettings';
  show_done_tasks: Scalars['Boolean']['output'];
  task_priorities: Array<WorkspaceTaskPriority>;
  task_statuses: Array<WorkspaceTaskStatus>;
  use_current_assignee: Scalars['Boolean']['output'];
};

export type WorkspaceTaskStatus = {
  __typename?: 'WorkspaceTaskStatus';
  background_color: Scalars['String']['output'];
  default: Scalars['Boolean']['output'];
  done: Scalars['Boolean']['output'];
  foreground_color: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type WorkspaceTaskStatusInput = {
  background_color: Scalars['String']['input'];
  default: Scalars['Boolean']['input'];
  done: Scalars['Boolean']['input'];
  foreground_color: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type WorkspaceUserManagementSetting = {
  __typename?: 'WorkspaceUserManagementSetting';
  require_two_factor_authentication: Scalars['Boolean']['output'];
  teams: Array<Team>;
};

export type LockProjectInput = {
  orderBy?: InputMaybe<Array<WipOrderByClause>>;
  period_id: Scalars['ID']['input'];
  project_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<WipsWhereConditions>;
};

export type QuoteInput = {
  id: Scalars['ID']['input'];
  settings: BudgetExportOptionsInput;
};

export type QuoteSendInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  other_recipients: Array<InputMaybe<Scalars['String']['input']>>;
  recipients: Array<InputMaybe<Scalars['String']['input']>>;
  subject: Scalars['String']['input'];
};

export type StopTimerForCapacityAllocationItemInput = {
  capacity_allocation_item_id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
};

export type TimeMaterialsCommissionInputData = {
  commission: Scalars['BigInt']['input'];
  expense_budget_item_id: Scalars['ID']['input'];
};

export type TimeMaterialsInputData = {
  commission_data?: InputMaybe<Array<InputMaybe<TimeMaterialsCommissionInputData>>>;
  expense_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  from: Scalars['Date']['input'];
  groupBy: TimeMaterialsInvoiceDataGroupByEnum;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  project_id: Scalars['ID']['input'];
  to: Scalars['Date']['input'];
};

export type TimeMaterialsInvoiceWhereConditions = {
  AND?: InputMaybe<Array<TimeMaterialsInvoiceWhereConditions>>;
  OR?: InputMaybe<Array<TimeMaterialsInvoiceWhereConditions>>;
  column?: InputMaybe<TimeTrackingItemWhereColumn>;
  operator?: InputMaybe<SqlOperator>;
  value?: InputMaybe<Scalars['Mixed']['input']>;
};

export type TimeMaterialsQueryArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<TimeMaterialsInvoiceWhereConditions>;
};

export enum TimeTrackingItemWhereColumn {
  OurWorkBudgetItemId = 'OUR_WORK_BUDGET_ITEM_ID',
  TaskId = 'TASK_ID',
  TimeTrackingWorkTypeId = 'TIME_TRACKING_WORK_TYPE_ID',
  UserId = 'USER_ID'
}

export type UpdateBillingPlanBudgetInput = {
  billingPlanBudgetItem: Array<BillingPlanBudgetItemInput>;
  billing_item_type: BillingItemTypEnum;
  budget_item_id?: InputMaybe<Scalars['ID']['input']>;
  budget_item_type: BudgetItemTypeEnum;
  category_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateProjectBillingPlanBudgetInput = {
  billingPlanBudgets: Array<UpdateBillingPlanBudgetInput>;
  project_id: Scalars['ID']['input'];
};

export type UpdateProjectBillingPlanSettingsInput = {
  auto_create_invoice: Scalars['Boolean']['input'];
  auto_send_invoice: Scalars['Boolean']['input'];
  auto_send_thank_you: Scalars['Boolean']['input'];
  auto_send_thank_you_template?: InputMaybe<ProjectBillingPlanEmailTemplateInput>;
  billing_entity_id?: InputMaybe<Scalars['ID']['input']>;
  billing_item_type: BillingItemTypEnum;
  contact_id?: InputMaybe<Scalars['ID']['input']>;
  create_draft_invoice: Scalars['Boolean']['input'];
  create_summary_invoice_after_payment: Scalars['Boolean']['input'];
  date_of_supply_from_issue_date?: InputMaybe<Scalars['Int']['input']>;
  email_template: ProjectBillingPlanEmailTemplateInput;
  from: Scalars['Date']['input'];
  generate_invoice_items?: InputMaybe<ProjectBillingPlanSettingGenerateInvoiceItemsEnum>;
  internal_note?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  order_id?: InputMaybe<Scalars['ID']['input']>;
  project_id: Scalars['ID']['input'];
  text_on_invoice?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Date']['input'];
  vat_rate_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_bank_account_id?: InputMaybe<Scalars['ID']['input']>;
  workspace_company_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWorkspaceNotifications = {
  notifications: Array<WorkspaceNotificationInput>;
};

export type SubscribeToPushNotificationsMutationVariables = Exact<{
  endpoint: Scalars['String']['input'];
  keys: PushNotificationSubscriptionKeys;
}>;


export type SubscribeToPushNotificationsMutation = { __typename?: 'Mutation', subscribeToPushNotifications: boolean };

export type UnsubscribeToPushNotificationsMutationVariables = Exact<{
  endpoint: Scalars['String']['input'];
}>;


export type UnsubscribeToPushNotificationsMutation = { __typename?: 'Mutation', unsubscribeFromPushNotifications: boolean };

export type AddManualAccountMoveMutationVariables = Exact<{
  amount: Scalars['BigInt']['input'];
  currencyId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
  date: Scalars['Date']['input'];
}>;


export type AddManualAccountMoveMutation = { __typename?: 'Mutation', addManualAccountMove: { __typename?: 'BankAccountMove', id: string, bank_account_id?: string | null, amount: number, note: string, reference: string, vs?: string | null, ss?: string | null, ks?: string | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: Date, balance: number, iban?: string | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: Date, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | null } };

export type BankAccountsForPaymentsQueryVariables = Exact<{ [key: string]: never; }>;


export type BankAccountsForPaymentsQuery = { __typename?: 'Query', bankAccounts?: Array<{ __typename?: 'BankAccount', id: string, workspace_bank_account_id?: string | null, iban: string, name: string }> | null };

export type AddDocumentsToAccountMoveMutationVariables = Exact<{
  bankAccountMoveId: Scalars['ID']['input'];
  documents: Array<BankAccountMoveDocumentInput> | BankAccountMoveDocumentInput;
}>;


export type AddDocumentsToAccountMoveMutation = { __typename?: 'Mutation', addDocumentsToAccountMove: { __typename?: 'BankAccountMove', id: string, bank_account_id?: string | null, amount: number, note: string, reference: string, vs?: string | null, ss?: string | null, ks?: string | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: Date, balance: number, iban?: string | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: Date, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | null } };

export type ExpensesForPaymentMatchQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ExpenseQueryArgs>;
}>;


export type ExpensesForPaymentMatchQuery = { __typename?: 'Query', expenses?: { __typename?: 'ExpensePaginator', data: Array<{ __typename?: 'Expense', id: string, expense_no?: string | null, type: ExpenseTypeEnum, invoice_status: ExpenseInvoiceStatusEnum, paid_at?: Date | null, date_of_supply?: Date | null, due_date?: Date | null, has_master_agreement?: boolean | null, workspace_company_id?: string | null, variable_symbol?: string | null, iban?: string | null, exchange_rate?: number | null, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, projects: Array<{ __typename?: 'Project', id: string, code: string, title: string }>, stats: { __typename?: 'ExpenseStats', total_amount: number, total_amount_without_vat_in_currency: number, total_amount_with_vat_in_currency: number }, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', amount: number }> | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type InvoicesForPaymentMatchQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<OiQueryArgs>;
}>;


export type InvoicesForPaymentMatchQuery = { __typename?: 'Query', outgoingInvoices?: { __typename?: 'OutgoingInvoicePaginator', data: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string, abraflexi_exported?: boolean | null, xero_exported?: boolean | null, type: OutgoingInvoiceTypeEnum, paid_at?: Date | null, exchange_rate: number, issue_date: Date, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: Date, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | null }>, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, billingEntity: { __typename?: 'BillingEntity', legal_name: string, street: string, city: string }, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, stats: { __typename?: 'OutgoingInvoiceStats', total_amount_with_vat_in_currency: number, billing_amount_in_currency: number, billing_amount_with_vat_in_currency: number }, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', amount: number }> | null, relatesToOutgoingProformaInvoice?: { __typename?: 'OutgoingProformaInvoice', invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | null } | null } | null, invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type ProformasForPaymentMatchQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<OiProformaQueryArgs>;
}>;


export type ProformasForPaymentMatchQuery = { __typename?: 'Query', outgoingProformaInvoices?: { __typename?: 'OutgoingProformaInvoicePaginator', data: Array<{ __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string, abraflexi_exported?: boolean | null, paid_at?: Date | null, exchange_rate: number, issue_date: Date, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: Date, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | null }>, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, billingEntity: { __typename?: 'BillingEntity', legal_name: string, street: string, city: string }, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, stats: { __typename?: 'OutgoingProformaInvoiceStats', total_amount_with_vat_in_currency: number }, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', amount: number }> | null, proofOfPayments?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string, invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | null } | null }> | null, invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type MatchPaymentModalFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type MatchPaymentModalFilterOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | null }> };

export type AccountMoveFragment = { __typename?: 'BankAccountMove', id: string, bank_account_id?: string | null, amount: number, note: string, reference: string, vs?: string | null, ss?: string | null, ks?: string | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: Date, balance: number, iban?: string | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: Date, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | null };

export type ExcludeAccountMoveMutationVariables = Exact<{
  accountMoveId: Scalars['ID']['input'];
}>;


export type ExcludeAccountMoveMutation = { __typename?: 'Mutation', excludeBankAccountMove: { __typename?: 'BankAccountMove', id: string, bank_account_id?: string | null, amount: number, note: string, reference: string, vs?: string | null, ss?: string | null, ks?: string | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: Date, balance: number, iban?: string | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: Date, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | null } };

export type BankAccountMovesQueryVariables = Exact<{
  filters?: InputMaybe<BankAccountMoveQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BankAccountMovesQuery = { __typename?: 'Query', bankAccountMoves?: { __typename?: 'BankAccountMovePaginator', data: Array<{ __typename?: 'BankAccountMove', id: string, bank_account_id?: string | null, amount: number, note: string, reference: string, vs?: string | null, ss?: string | null, ks?: string | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: Date, balance: number, iban?: string | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: Date, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type BillingEntityModalFragment = { __typename?: 'BillingEntity', id: string, internal_name: string, legal_name: string, street: string, city: string, zip: string, registration_no?: string | null, tax_no?: string | null, vat_no?: string | null, applies_vat: boolean, payment_due: number, invoice_email?: string | null, note?: string | null, language: string, disable_email_notification: boolean, country: { __typename?: 'Country', id: string, name: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string, name: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string, iban: string } | null };

export type CreateBillingEntityMutationVariables = Exact<{
  input: CreateBillingEntityInput;
}>;


export type CreateBillingEntityMutation = { __typename?: 'Mutation', createBillingEntity: { __typename?: 'BillingEntity', id: string, internal_name: string, legal_name: string, street: string, city: string, zip: string, registration_no?: string | null, tax_no?: string | null, vat_no?: string | null, applies_vat: boolean, payment_due: number, invoice_email?: string | null, note?: string | null, language: string, disable_email_notification: boolean, country: { __typename?: 'Country', id: string, name: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string, name: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string, iban: string } | null } };

export type UpdateBillingEntityMutationVariables = Exact<{
  input: UpdateBillingEntityInput;
}>;


export type UpdateBillingEntityMutation = { __typename?: 'Mutation', updateBillingEntity: { __typename?: 'BillingEntity', id: string, internal_name: string, legal_name: string, street: string, city: string, zip: string, registration_no?: string | null, tax_no?: string | null, vat_no?: string | null, applies_vat: boolean, payment_due: number, invoice_email?: string | null, note?: string | null, language: string, disable_email_notification: boolean, country: { __typename?: 'Country', id: string, name: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string, name: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string, iban: string } | null } };

export type OptionsForBillingEntityQueryVariables = Exact<{ [key: string]: never; }>;


export type OptionsForBillingEntityQuery = { __typename?: 'Query', languagesForInvoicePdf: Array<string>, countrySimpleMap: Array<{ __typename?: 'CountrySimple', id: string, name: string }> };

export type BrandModalFragment = { __typename?: 'Brand', id: string, name: string, code: string, numeric_code?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, defaultBillingEntity?: { __typename?: 'BillingEntity', id: string } | null };

export type CreateBrandMutationVariables = Exact<{
  input: CreateBrandInput;
}>;


export type CreateBrandMutation = { __typename?: 'Mutation', createBrand: { __typename?: 'Brand', id: string, name: string, code: string, numeric_code?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, defaultBillingEntity?: { __typename?: 'BillingEntity', id: string } | null } };

export type UpdateBrandMutationVariables = Exact<{
  input: UpdateBrandInput;
}>;


export type UpdateBrandMutation = { __typename?: 'Mutation', updateBrand: { __typename?: 'Brand', id: string, name: string, code: string, numeric_code?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, defaultBillingEntity?: { __typename?: 'BillingEntity', id: string } | null } };

export type GetNextNumericalBrandCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNextNumericalBrandCodeQuery = { __typename?: 'Query', getNextNumericalBrandCode: string };

export type ClientOptionsForModalBrandQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientOptionsForModalBrandQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string }> };

export type BillingEntityOptionsForModalBrandQueryVariables = Exact<{
  client_id: Scalars['ID']['input'];
}>;


export type BillingEntityOptionsForModalBrandQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, name: string, billingEntities: Array<{ __typename?: 'BillingEntity', id: string, internal_name: string }>, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string } } | null };

export type GetBrandForCreditAccountsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBrandForCreditAccountsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, name: string, code: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, client: { __typename?: 'Client', id: string, name: string } } | null };

export type UpdateTimeTrackingRatesForBrandMutationVariables = Exact<{
  input: UpdateTimeTrackingRatesForBrandInput;
}>;


export type UpdateTimeTrackingRatesForBrandMutation = { __typename?: 'Mutation', updateTimeTrackingRatesForBrand: { __typename?: 'Brand', id: string, average_time_tracking_rate?: number | null, timeTrackingRates: Array<{ __typename?: 'TimeTrackingRate', rate: number, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string } }> } };

export type BrandDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BrandDetailQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string }>, brand?: { __typename?: 'Brand', id: string, name: string, code: string, numeric_code?: string | null, cloudUrl?: string | null, driveCloudUrl?: string | null, archived_at?: Date | null, average_time_tracking_rate?: number | null, calculated_average_time_tracking_rate?: number | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, responsiblePerson?: { __typename?: 'User', id: string } | null, otherResponsiblePersons: Array<{ __typename?: 'User', id: string }>, defaultBillingEntity?: { __typename?: 'BillingEntity', id: string } | null, pipedriveCustomFieldValues: Array<{ __typename?: 'PipedriveCustomFieldValue', value?: string | null, customField: { __typename?: 'PipedriveCustomField', label?: string | null } }>, client: { __typename?: 'Client', id: string, name: string, billingEntities: Array<{ __typename?: 'BillingEntity', id: string, internal_name: string }>, responsiblePerson?: { __typename?: 'User', id: string } | null, otherResponsiblePersons: Array<{ __typename?: 'User', id: string }> }, users: Array<{ __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, email: string, scope_access?: UserScopeAccessEnum | null, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null }>, contacts: Array<{ __typename?: 'Contact', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pipedriveCustomFieldValues: Array<{ __typename?: 'PipedriveCustomFieldValue', value?: string | null, customField: { __typename?: 'PipedriveCustomField', label?: string | null } }> }>, timeTrackingRates: Array<{ __typename?: 'TimeTrackingRate', rate: number, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string } }> } | null, timeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string }> };

export type GetBrandForDocumentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBrandForDocumentsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, name: string, code: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, client: { __typename?: 'Client', id: string, name: string } } | null };

export type GetBrandsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<BrandQueryArgs>;
}>;


export type GetBrandsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string }>, contacts: Array<{ __typename?: 'Contact', id: string, first_name?: string | null, last_name?: string | null }>, brandsSummary: { __typename?: 'BrandsSummary', brandIds: Array<string> }, brands?: { __typename?: 'BrandPaginator', data: Array<{ __typename?: 'Brand', id: string, name: string, code: string, archived_at?: Date | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, client: { __typename?: 'Client', id: string, name: string }, contacts: Array<{ __typename?: 'Contact', id: string, first_name?: string | null, last_name?: string | null }>, creditAccounts?: Array<{ __typename?: 'BrandCreditAccount', id: string }> | null, defaultBillingEntity?: { __typename?: 'BillingEntity', id: string } | null, pipedriveCustomFieldValues: Array<{ __typename?: 'PipedriveCustomFieldValue', value?: string | null, customField: { __typename?: 'PipedriveCustomField', label?: string | null } }>, stats: { __typename?: 'BrandStats', active_projects: number } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type DeleteBrandMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBrandMutation = { __typename?: 'Mutation', deleteBrand: { __typename?: 'Brand', id: string } };

export type ArchiveBrandMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveBrandMutation = { __typename?: 'Mutation', archiveBrand: { __typename?: 'Brand', id: string } };

export type UnarchiveBrandMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchiveBrandMutation = { __typename?: 'Mutation', unarchiveBrand: { __typename?: 'Brand', id: string } };

export type BudgetPdfSettingsFragment = { __typename?: 'BudgetPdfSettings', show_hours?: boolean | null, show_disclaimer?: boolean | null, signature?: boolean | null, show_summary?: boolean | null, show_client_name?: boolean | null, show_client_details?: boolean | null, language?: string | null, our_work_show_commission?: boolean | null, title_page_with_vat?: boolean | null, workspace_company_id: string, workspace_bank_account_id?: string | null, billing_entity_id?: string | null, hide_title_page?: boolean | null, add_billing_plan?: boolean | null, billing_plan_exchange_rate?: number | null, our_work_positions?: BudgetPdfExportOurWorkPositionsEnum | null, our_work_view?: BudgetPdfExportOurWorkViewEnum | null, our_work_description?: boolean | null, our_work_vat_in_items?: boolean | null, our_work_show_discount?: boolean | null, expense_show_commission?: boolean | null, expense_show_quantity?: boolean | null, expense_show_unit?: boolean | null, expense_show_discount?: boolean | null, expense_show_description?: boolean | null, expense_show_vat_in_items?: boolean | null, show_client_and_brand?: boolean | null, show_project_name_full?: boolean | null, use_client_name_from_billing_entity?: boolean | null, disclaimer?: Array<{ __typename?: 'BudgetPdfDisclaimer', language?: string | null, disclaimer?: string | null } | null> | null };

export type PreviewQuoteMutationVariables = Exact<{
  input: QuoteInput;
}>;


export type PreviewQuoteMutation = { __typename?: 'Mutation', previewQuote: { __typename?: 'Quote', url: string } };

export type SaveQuoteMutationVariables = Exact<{
  input: QuoteInput;
}>;


export type SaveQuoteMutation = { __typename?: 'Mutation', saveQuote: { __typename?: 'Quote', id: string, url: string } };

export type GetQuoteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetQuoteQuery = { __typename?: 'Query', GetQuote: { __typename?: 'Quote', id: string, url: string, number: string, status: QuoteStatus, total_amount: number, sent_to_client_date?: Date | null, client_approval_date?: Date | null, settings: { __typename?: 'BudgetPdfSettings', date?: Date | null, valid_until?: Date | null, show_hours?: boolean | null, show_disclaimer?: boolean | null, signature?: boolean | null, show_summary?: boolean | null, show_client_name?: boolean | null, show_client_details?: boolean | null, language?: string | null, our_work_show_commission?: boolean | null, title_page_with_vat?: boolean | null, workspace_company_id: string, workspace_bank_account_id?: string | null, billing_entity_id?: string | null, hide_title_page?: boolean | null, add_billing_plan?: boolean | null, billing_plan_exchange_rate?: number | null, our_work_positions?: BudgetPdfExportOurWorkPositionsEnum | null, our_work_view?: BudgetPdfExportOurWorkViewEnum | null, our_work_description?: boolean | null, our_work_vat_in_items?: boolean | null, our_work_show_discount?: boolean | null, expense_show_commission?: boolean | null, expense_show_quantity?: boolean | null, expense_show_unit?: boolean | null, expense_show_discount?: boolean | null, expense_show_description?: boolean | null, expense_show_vat_in_items?: boolean | null, show_client_and_brand?: boolean | null, show_project_name_full?: boolean | null, use_client_name_from_billing_entity?: boolean | null, disclaimer?: Array<{ __typename?: 'BudgetPdfDisclaimer', language?: string | null, disclaimer?: string | null } | null> | null }, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | null }, budgets: Array<{ __typename?: 'Budget', id: string, account_manager?: string | null, assignment_date?: Date | null, status: BudgetStatusEnum, client_approved?: boolean | null, price?: number | null, project?: { __typename?: 'Project', id: string, title: string } | null, brand?: { __typename?: 'Brand', id: string, name: string } | null, currency?: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | null } | null }>, Client?: { __typename?: 'Client', billingEntities: Array<{ __typename?: 'BillingEntity', id: string, internal_name: string, street: string, city: string, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string, deleted: boolean } }> } | null } };

export type BudgetGroupFragment = { __typename?: 'BudgetGroup', budget_name?: string | null, budget_number?: string | null, budgets?: Array<{ __typename?: 'Budget', id: string, project_id?: string | null, description?: string | null, account_manager?: string | null, assignment_date?: Date | null, status: BudgetStatusEnum, internally_approved?: boolean | null, client_approved?: boolean | null, is_active?: boolean | null, version?: number | null, price?: number | null, temporary_project_id?: string | null, created_at: Date, updated_at: Date, project?: { __typename?: 'Project', id: string, title: string } | null, brand?: { __typename?: 'Brand', id: string, name: string } | null, temporaryBrand?: { __typename?: 'TemporaryBrand', name?: string | null } | null, temporaryProject?: { __typename?: 'TemporaryProject', name?: string | null, is_archived?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, code: string, denomination: number } | null, quotes?: Array<{ __typename?: 'Quote', id: string, url: string, number: string }> | null } | null> | null };

export type CreateQuoteMutationVariables = Exact<{
  budget_ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateQuoteMutation = { __typename?: 'Mutation', createQuote: { __typename?: 'Quote', id: string, url: string } };

export type BudgetsExportQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  options?: InputMaybe<BudgetExportOptionsInput>;
}>;


export type BudgetsExportQuery = { __typename?: 'Query', budgetsExport: string };

export type BudgetsFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BudgetsFilterOptionsQuery = { __typename?: 'Query', brandsSimpleMap: Array<{ __typename?: 'BrandSimple', id: string, name: string }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string }> };

export type GetBudgetsQueryVariables = Exact<{
  filters?: InputMaybe<BudgetArgs>;
}>;


export type GetBudgetsQuery = { __typename?: 'Query', budgets: { __typename?: 'BudgetPaginator', allIds: Array<number>, data?: Array<{ __typename?: 'BudgetGroup', budget_name?: string | null, budget_number?: string | null, budgets?: Array<{ __typename?: 'Budget', id: string, project_id?: string | null, description?: string | null, account_manager?: string | null, assignment_date?: Date | null, status: BudgetStatusEnum, internally_approved?: boolean | null, client_approved?: boolean | null, is_active?: boolean | null, version?: number | null, price?: number | null, temporary_project_id?: string | null, created_at: Date, updated_at: Date, project?: { __typename?: 'Project', id: string, title: string } | null, brand?: { __typename?: 'Brand', id: string, name: string } | null, temporaryBrand?: { __typename?: 'TemporaryBrand', name?: string | null } | null, temporaryProject?: { __typename?: 'TemporaryProject', name?: string | null, is_archived?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, code: string, denomination: number } | null, quotes?: Array<{ __typename?: 'Quote', id: string, url: string, number: string }> | null } | null> | null }> | null, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type BudgetovacPositionsSetFragment = { __typename?: 'BudgetovacPositionsSet', id: string, name: string, active: boolean, client_id?: number | null, currency_code: string, internal_production_commission?: number | null, external_production_commission?: number | null, media_budget_commission?: number | null, extras_commission?: number | null, positions_prices: Array<{ __typename?: 'BudgetovacPositionPrice', alias: string, department_id?: string | null, department_name?: string | null, name: string, position_id: string, price: string }> };

export type BudgetovacPositionPriceFragment = { __typename?: 'BudgetovacPositionPrice', alias: string, department_id?: string | null, department_name?: string | null, name: string, position_id: string, price: string };

export type CreateBudgetovacPositionsSetMutationVariables = Exact<{
  input: CreateBudgetovacPositionsSetInput;
}>;


export type CreateBudgetovacPositionsSetMutation = { __typename?: 'Mutation', createBudgetovacPositionsSet: { __typename?: 'BudgetovacPositionsSet', id: string } };

export type UpdateBudgetovacPositionsSetMutationVariables = Exact<{
  input: UpdateBudgetovacPositionsSetInput;
}>;


export type UpdateBudgetovacPositionsSetMutation = { __typename?: 'Mutation', updateBudgetovacPositionsSet: { __typename?: 'BudgetovacPositionsSet', id: string } };

export type DeleteBudgetovacPositionsSetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBudgetovacPositionsSetMutation = { __typename?: 'Mutation', deleteBudgetovacPositionsSet: { __typename?: 'BudgetovacPositionsSet', id: string } };

export type SetActiveBudgetovacPositionsSetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type SetActiveBudgetovacPositionsSetMutation = { __typename?: 'Mutation', setActiveBudgetovacPositionsSet: { __typename?: 'BudgetovacPositionsSet', id: string } };

export type BudgetovacPositionsSetsQueryVariables = Exact<{
  client_id?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type BudgetovacPositionsSetsQuery = { __typename?: 'Query', budgetovacPositionsSets: Array<{ __typename?: 'BudgetovacBrandPositionsSet', client_id?: string | null, brand?: { __typename?: 'Brand', code: string, name: string } | null, budgetovacPositionSets: Array<{ __typename?: 'BudgetovacPositionsSet', id: string, name: string, active: boolean, client_id?: number | null, currency_code: string, internal_production_commission?: number | null, external_production_commission?: number | null, media_budget_commission?: number | null, extras_commission?: number | null, positions_prices: Array<{ __typename?: 'BudgetovacPositionPrice', alias: string, department_id?: string | null, department_name?: string | null, name: string, position_id: string, price: string }> }> }> };

export type BudgetovacPositionsSetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BudgetovacPositionsSetQuery = { __typename?: 'Query', budgetovacPositionsSet?: { __typename?: 'BudgetovacPositionsSet', id: string, name: string, active: boolean, client_id?: number | null, currency_code: string, internal_production_commission?: number | null, external_production_commission?: number | null, media_budget_commission?: number | null, extras_commission?: number | null, positions_prices: Array<{ __typename?: 'BudgetovacPositionPrice', alias: string, department_id?: string | null, department_name?: string | null, name: string, position_id: string, price: string }> } | null };

export type BudgetovacPositionsSetModalDependenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type BudgetovacPositionsSetModalDependenciesQuery = { __typename?: 'Query', budgetovacPositions: Array<{ __typename?: 'BudgetovacPosition', alias: string, price: number, is_default: boolean, id: string, name: string, department_id?: string | null }>, ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string, name: string }> | null, brandsSimpleMap: Array<{ __typename?: 'BrandSimple', id: string, name: string }> };

export type BudgetovacPositionFragment = { __typename?: 'BudgetovacPosition', id: string, name: string, department_id?: string | null };

export type CreateBudgetovacPositionMutationVariables = Exact<{
  input: CreateBudgetovacPositionInput;
}>;


export type CreateBudgetovacPositionMutation = { __typename?: 'Mutation', createBudgetovacPosition: { __typename?: 'BudgetovacPosition', alias: string, price: number, is_default: boolean, id: string, name: string, department_id?: string | null } };

export type UpdateBudgetovacPositionMutationVariables = Exact<{
  input: UpdateBudgetovacPositionInput;
}>;


export type UpdateBudgetovacPositionMutation = { __typename?: 'Mutation', updateBudgetovacPosition: { __typename?: 'BudgetovacPosition', id: string } };

export type DeleteBudgetovacPositionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBudgetovacPositionMutation = { __typename?: 'Mutation', deleteBudgetovacPosition: { __typename?: 'BudgetovacPosition', id: string } };

export type BudgetovacPositionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BudgetovacPositionsQuery = { __typename?: 'Query', budgetovacPositions: Array<{ __typename?: 'BudgetovacPosition', id: string, name: string, department_id?: string | null }> };

export type BudgetovacDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type BudgetovacDepartmentsQuery = { __typename?: 'Query', ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string, name: string }> | null };

export type DeleteQuoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteQuoteMutation = { __typename?: 'Mutation', deleteQuote: boolean };

export type ManualApproveQuoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ManualApproveQuoteMutation = { __typename?: 'Mutation', manualApproveQuote: { __typename?: 'Quote', id: string, status: QuoteStatus, client_approval_date?: Date | null } };

export type GetBudgetQuotesQueryVariables = Exact<{
  filters?: InputMaybe<QuotesArgs>;
}>;


export type GetBudgetQuotesQuery = { __typename?: 'Query', getBudgetQuotes: { __typename?: 'QuotesPaginator', data?: Array<{ __typename?: 'Quote', id: string, url: string, number: string, status: QuoteStatus, client_approval_date?: Date | null, sent_to_client_date?: Date | null, settings: { __typename?: 'BudgetPdfSettings', date?: Date | null }, budgets: Array<{ __typename?: 'Budget', id: string, project_id?: string | null, description?: string | null, account_manager?: string | null, assignment_date?: Date | null, status: BudgetStatusEnum, internally_approved?: boolean | null, client_approved?: boolean | null, is_active?: boolean | null, version?: number | null, price?: number | null, temporary_project_id?: string | null, created_at: Date, updated_at: Date, project?: { __typename?: 'Project', id: string, title: string } | null, brand?: { __typename?: 'Brand', id: string, name: string } | null, temporaryBrand?: { __typename?: 'TemporaryBrand', name?: string | null } | null, temporaryProject?: { __typename?: 'TemporaryProject', name?: string | null, is_archived?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, code: string, denomination: number } | null }> }> | null, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetClientQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClientQuery = { __typename?: 'Query', client?: { __typename?: 'Client', name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, brands: Array<{ __typename?: 'Brand', id: string }> } | null };

export type DeleteBillingEntityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBillingEntityMutation = { __typename?: 'Mutation', deleteBillingEntity: { __typename?: 'BillingEntity', id: string } };

export type DeleteContactMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteContactMutation = { __typename?: 'Mutation', deleteContact: { __typename?: 'Contact', id: string } };

export type UpdateClientMutationVariables = Exact<{
  input: UpdateClientInput;
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateClient: { __typename?: 'Client', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | null, country?: { __typename?: 'Country', id: string } | null } } };

export type DeleteClientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteClientMutation = { __typename?: 'Mutation', deleteClient: { __typename?: 'Client', id: string } };

export type CreateClientMutationVariables = Exact<{
  input: CreateClientInput;
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'Client', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | null, country?: { __typename?: 'Country', id: string } | null } } };

export type ClientDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ClientDetailQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, name: string, cloudUrl?: string | null, driveCloudUrl?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | null, country?: { __typename?: 'Country', id: string } | null }, responsiblePerson?: { __typename?: 'User', id: string } | null, otherResponsiblePersons: Array<{ __typename?: 'User', id: string }>, brands: Array<{ __typename?: 'Brand', id: string, name: string, archived_at?: Date | null, code: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, defaultBillingEntity?: { __typename?: 'BillingEntity', id: string } | null, pipedriveCustomFieldValues: Array<{ __typename?: 'PipedriveCustomFieldValue', value?: string | null, customField: { __typename?: 'PipedriveCustomField', label?: string | null } }> }>, billingEntities: Array<{ __typename?: 'BillingEntity', id: string, internal_name: string, legal_name: string, street: string, city: string, zip: string, registration_no?: string | null, tax_no?: string | null, vat_no?: string | null, applies_vat: boolean, payment_due: number, invoice_email?: string | null, note?: string | null, language: string, disable_email_notification: boolean, country: { __typename?: 'Country', id: string, name: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string, name: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string, iban: string } | null }>, contacts: Array<{ __typename?: 'Contact', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null }>, currencyExchangeRates: Array<{ __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }>, currencyExchangeRatesStructured: Array<{ __typename?: 'CurrencyExchangeRateStructured', exchangeRates: Array<{ __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: Date | null, valid_to?: Date | null }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> } | null, currencies?: Array<{ __typename?: 'Currency', id: string, code: string }> | null, countrySimpleMap: Array<{ __typename?: 'CountrySimple', id: string, name: string }> };

export type ClientFilterOptionsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<QueryContactsOrderByOrderByClause> | QueryContactsOrderByOrderByClause>;
}>;


export type ClientFilterOptionsQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'Contact', id: string, first_name?: string | null, last_name?: string | null }>, responsiblePersonsSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string }>, brandsSimpleMap: Array<{ __typename?: 'BrandSimple', id: string, name: string }> };

export type GetClientsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<ClientQueryArgs>;
}>;


export type GetClientsQuery = { __typename?: 'Query', clients?: { __typename?: 'ClientPaginator', data: Array<{ __typename?: 'Client', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | null, country?: { __typename?: 'Country', id: string } | null }, brands: Array<{ __typename?: 'Brand', id: string, name: string, projects: Array<{ __typename?: 'Project', id: string }> }>, responsiblePerson?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, contacts: Array<{ __typename?: 'Contact', first_name?: string | null, last_name?: string | null }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type AbraFlexiOiExportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AbraFlexiOiExportQuery = { __typename?: 'Query', abraFlexiOIExport?: string | null };

export type AbraFlexiOutgoingProformaInvoicesExportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AbraFlexiOutgoingProformaInvoicesExportQuery = { __typename?: 'Query', abraFlexiOutgoingProformaInvoicesExport?: string | null };

export type ExpenseAbraFlexiExportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ExpenseAbraFlexiExportQuery = { __typename?: 'Query', expenseAbraFlexiExport: string };

export type DocumentExportFragment = { __typename?: 'DocumentExport', type: string, exported_at: Date };

export type FinancialOiExportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type FinancialOiExportQuery = { __typename?: 'Query', financialOIExport?: string | null };

export type ExpenseXeroExportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ExpenseXeroExportQuery = { __typename?: 'Query', expenseXeroExport: string };

export type OutgoingInvoiceXeroExportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type OutgoingInvoiceXeroExportQuery = { __typename?: 'Query', xeroOIExport?: string | null };

export type ContractorModelFragment = { __typename?: 'Contractor', id: string, legal_name: string, street?: string | null, city?: string | null, zip?: string | null, registration_no?: string | null, tax_no?: string | null, vat_no?: string | null, national_id?: string | null, iban?: string | null, swift?: string | null, is_vat_payer?: boolean | null, business_form?: BusinessFormEnum | null, bank_account?: string | null, bank_account_code?: string | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | null };

export type ContractorDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContractorDetailQuery = { __typename?: 'Query', contractor?: { __typename?: 'Contractor', id: string, legal_name: string, street?: string | null, city?: string | null, zip?: string | null, registration_no?: string | null, tax_no?: string | null, vat_no?: string | null, national_id?: string | null, iban?: string | null, swift?: string | null, is_vat_payer?: boolean | null, business_form?: BusinessFormEnum | null, bank_account?: string | null, bank_account_code?: string | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | null } | null };

export type CreateContractorMutationVariables = Exact<{
  input: CreateContractorInput;
}>;


export type CreateContractorMutation = { __typename?: 'Mutation', createContractor: { __typename?: 'Contractor', id: string, legal_name: string, street?: string | null, city?: string | null, zip?: string | null, registration_no?: string | null, tax_no?: string | null, vat_no?: string | null, national_id?: string | null, iban?: string | null, swift?: string | null, is_vat_payer?: boolean | null, business_form?: BusinessFormEnum | null, bank_account?: string | null, bank_account_code?: string | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | null } };

export type UpdateContractorMutationVariables = Exact<{
  input: UpdateContractorInput;
}>;


export type UpdateContractorMutation = { __typename?: 'Mutation', updateContractor: { __typename?: 'Contractor', id: string, legal_name: string, street?: string | null, city?: string | null, zip?: string | null, registration_no?: string | null, tax_no?: string | null, vat_no?: string | null, national_id?: string | null, iban?: string | null, swift?: string | null, is_vat_payer?: boolean | null, business_form?: BusinessFormEnum | null, bank_account?: string | null, bank_account_code?: string | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | null } };

export type ModalContractorDependenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type ModalContractorDependenciesQuery = { __typename?: 'Query', countrySimpleMap: Array<{ __typename?: 'CountrySimple', id: string, name: string, code: string }>, accountingAccountsSimpleMap: Array<{ __typename?: 'AccountingAccount', id: string, title: string, account_number: string }> };

export type CompanyDataAutocompleteQueryVariables = Exact<{
  input: Scalars['String']['input'];
  country_id: Scalars['ID']['input'];
}>;


export type CompanyDataAutocompleteQuery = { __typename?: 'Query', getAutocompleteForCompanyData: { __typename?: 'AutocompleteCompanyData', suggestions: Array<string>, results: Array<{ __typename?: 'AutocompleteCompanyDataResult', legal_name?: string | null, city?: string | null, national_id?: string | null, cancelled: boolean }> } };

export type CompanyDataByRegistrationNoQueryVariables = Exact<{
  registration_no: Scalars['String']['input'];
  country_id: Scalars['ID']['input'];
}>;


export type CompanyDataByRegistrationNoQuery = { __typename?: 'Query', getCompanyDataByRegistrationNo?: { __typename?: 'CompanyData', legal_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, registration_no?: string | null, tax_no?: string | null, vat_no?: string | null, applies_vat: boolean, cancelled: boolean, bankAccounts: Array<{ __typename?: 'CompanyBankAccount', iban?: string | null, swift?: string | null }>, country?: { __typename?: 'Country', id: string, name: string, code: string, created_at?: Date | null, updated_at?: Date | null } | null } | null };

export type BankAccountConverterQueryVariables = Exact<{
  country_id: Scalars['ID']['input'];
  account_number: Scalars['String']['input'];
  account_code?: InputMaybe<Scalars['String']['input']>;
}>;


export type BankAccountConverterQuery = { __typename?: 'Query', bankAccountConverter: { __typename?: 'BankAccountConverter', iban?: string | null } };

export type GetContractorsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ContractorQueryArgs>;
}>;


export type GetContractorsQuery = { __typename?: 'Query', contractorsSummary: { __typename?: 'ContractorsSummary', contractorIds: Array<string> }, contractors?: { __typename?: 'ContractorPaginator', data: Array<{ __typename?: 'Contractor', id: string, iban?: string | null, registration_no?: string | null, legal_name: string, is_vat_payer?: boolean | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type DeleteContractorMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteContractorMutation = { __typename?: 'Mutation', deleteContractor: { __typename?: 'Contractor', id: string } };

export type DeleteContractorsBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteContractorsBulkMutation = { __typename?: 'Mutation', deleteContractorsBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type GetCreditAccountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCreditAccountQuery = { __typename?: 'Query', brandCreditAccount?: { __typename?: 'BrandCreditAccount', id: string, title: string, creditAccount: { __typename?: 'CreditAccount', id: string }, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, team: { __typename?: 'Team', id: string, name: string }, ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string, name: string }> | null, expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | null, credits: Array<{ __typename?: 'BrandCreditAccountCreditStats', id: string, credit: number, date: Date, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string } | null, originatesBrandCreditAccount?: { __typename?: 'BrandCreditAccount', id: string, title: string } | null }>, debits: Array<{ __typename?: 'BrandCreditAccountDebitStats', id: string, credit: number, performed_at: Date, expenseBudgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, code: string } } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, code: string } } | null, brandCreditAccount?: { __typename?: 'BrandCreditAccount', id: string, title: string } | null }>, stats: { __typename?: 'BrandCreditAccountStats', id: string, remaining_credit: number, total_credit: number, total_debit: number } } | null };

export type GetCreditAccountOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreditAccountOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string, name: string }> | null, expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | null, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }> };

export type UpdateCreditAccountMutationVariables = Exact<{
  input: UpdateBrandCreditAccountInput;
}>;


export type UpdateCreditAccountMutation = { __typename?: 'Mutation', updateBrandCreditAccount: { __typename?: 'BrandCreditAccount', id: string } };

export type CreateCreditAccountMutationVariables = Exact<{
  input: CreateBrandCreditAccountInput;
}>;


export type CreateCreditAccountMutation = { __typename?: 'Mutation', createBrandCreditAccount: { __typename?: 'BrandCreditAccount', id: string } };

export type GlobalCreditAccountDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GlobalCreditAccountDetailQuery = { __typename?: 'Query', globalCreditAccount?: { __typename?: 'GlobalCreditAccount', id: string, title: string, note?: string | null, created_at: Date, updated_at: Date, credits: Array<{ __typename?: 'GlobalCreditAccountCreditStats', id: string, credit: number, date: Date, expense?: { __typename?: 'Expense', id: string, expense_no?: string | null } | null, originatesGlobalCreditAccount?: { __typename?: 'GlobalCreditAccount', id: string, title: string } | null }>, debits: Array<{ __typename?: 'GlobalCreditAccountDebitStats', id: string, credit: number, performed_at: Date, credit_account_operation_id: string, expenseBudgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string } } | null }>, creditAccount: { __typename?: 'CreditAccount', id: string, created_at: Date, updated_at: Date, team?: { __typename?: 'Team', id: string, name: string } | null }, stats: { __typename?: 'GlobalCreditAccountStats', id: string, remaining_credit: number, total_credit: number, total_debit: number } } | null };

export type GlobalCreditAccountFragment = { __typename?: 'GlobalCreditAccount', id: string, title: string, note?: string | null, created_at: Date, updated_at: Date, creditAccount: { __typename?: 'CreditAccount', id: string, created_at: Date, updated_at: Date, team?: { __typename?: 'Team', id: string, name: string } | null }, stats: { __typename?: 'GlobalCreditAccountStats', id: string, remaining_credit: number, total_credit: number, total_debit: number }, credits: Array<{ __typename?: 'GlobalCreditAccountCreditStats', id: string, credit: number, date: Date }>, debits: Array<{ __typename?: 'GlobalCreditAccountDebitStats', id: string, credit: number, performed_at: Date, credit_account_operation_id: string, expenseBudgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | null }> };

export type CreateGlobalCreditAccountMutationVariables = Exact<{
  input: CreateGlobalCreditAccountInput;
}>;


export type CreateGlobalCreditAccountMutation = { __typename?: 'Mutation', createGlobalCreditAccount: { __typename?: 'GlobalCreditAccount', id: string } };

export type UpdateGlobalCreditAccountMutationVariables = Exact<{
  input: UpdateGlobalCreditAccountInput;
}>;


export type UpdateGlobalCreditAccountMutation = { __typename?: 'Mutation', updateGlobalCreditAccount: { __typename?: 'GlobalCreditAccount', id: string } };

export type DeleteGlobalCreditAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteGlobalCreditAccountMutation = { __typename?: 'Mutation', deleteGlobalCreditAccount: boolean };

export type GlobalCreditAccountsQueryVariables = Exact<{
  filters?: InputMaybe<GlobalCreditAccountQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GlobalCreditAccountsQuery = { __typename?: 'Query', globalCreditAccounts?: { __typename?: 'GlobalCreditAccountPaginator', data: Array<{ __typename?: 'GlobalCreditAccount', id: string, title: string, note?: string | null, created_at: Date, updated_at: Date, creditAccount: { __typename?: 'CreditAccount', id: string, created_at: Date, updated_at: Date, team?: { __typename?: 'Team', id: string, name: string } | null }, stats: { __typename?: 'GlobalCreditAccountStats', id: string, remaining_credit: number, total_credit: number, total_debit: number }, credits: Array<{ __typename?: 'GlobalCreditAccountCreditStats', id: string, credit: number, date: Date }>, debits: Array<{ __typename?: 'GlobalCreditAccountDebitStats', id: string, credit: number, performed_at: Date, credit_account_operation_id: string, expenseBudgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | null }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type CreditAccountsTableSummaryQueryVariables = Exact<{
  filters?: InputMaybe<CreditAccountQueryArgs>;
}>;


export type CreditAccountsTableSummaryQuery = { __typename?: 'Query', brandCreditAccountsSummary: { __typename?: 'BrandCreditAccountsSummary', brand_credit_accounts: number, total_credit: number, total_debit: number, remaining_credit: number } };

export type GetCreditAccountsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<CreditAccountQueryArgs>;
}>;


export type GetCreditAccountsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string, name: string }> | null, expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | null, brandCreditAccounts?: { __typename?: 'BrandCreditAccountPaginator', data: Array<{ __typename?: 'BrandCreditAccount', id: string, title: string, brand: { __typename?: 'Brand', name: string, id: string }, team: { __typename?: 'Team', id: string, name: string }, ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string, name: string }> | null, expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | null, stats: { __typename?: 'BrandCreditAccountStats', id: string, total_credit: number, remaining_credit: number, total_debit: number } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetContractsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ContractQueryArgs>;
}>;


export type GetContractsQuery = { __typename?: 'Query', contractsSummary: { __typename?: 'ContractsSummary', contractIds?: Array<string> | null }, contracts?: { __typename?: 'ContractPaginator', data: Array<{ __typename?: 'Contract', id: string, title: string, valid_from: Date, valid_to?: Date | null, type: ContractTypeEnum, cloudUrl?: string | null, driveCloudUrl?: string | null, projects?: Array<{ __typename?: 'Project', id: string, title: string, code: string } | null> | null, brands?: Array<{ __typename?: 'Brand', id: string, name: string } | null> | null, contractors?: Array<{ __typename?: 'Contractor', id: string, legal_name: string } | null> | null, clients?: Array<{ __typename?: 'Client', id: string, name: string } | null> | null, urls: { __typename?: 'MediaUrlList', preview?: string | null, download?: string | null }, files: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', hasMorePages: boolean, currentPage: number, perPage: number, total: number, count: number, firstItem?: number | null, lastItem?: number | null, lastPage: number } } | null };

export type ContractsExportQueryVariables = Exact<{
  filters?: InputMaybe<ContractQueryArgs>;
}>;


export type ContractsExportQuery = { __typename?: 'Query', contractsExport: string };

export type GetDocumentDependenciesQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['ID']['input']>;
  orIdIn?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetDocumentDependenciesQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string, brand: { __typename?: 'BrandSimple', id: string } }> };

export type GetDocumentDependenciesForClientQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type GetDocumentDependenciesForClientQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, name: string, brands: Array<{ __typename?: 'Brand', id: string, name: string }> } | null, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string, brand: { __typename?: 'BrandSimple', id: string } }>, contractorsSimpleMap: Array<{ __typename?: 'ContractorSimple', id: string, legal_name: string }> };

export type GetOrdersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<OrderQueryArgs>;
}>;


export type GetOrdersQuery = { __typename?: 'Query', ordersSummary: { __typename?: 'OrdersSummary', orderIds?: Array<string> | null }, orders?: { __typename?: 'OrderPaginator', data: Array<{ __typename?: 'Order', id: string, purchase_order_no?: string | null, date_of_order?: Date | null, cloudUrl?: string | null, driveCloudUrl?: string | null, outgoingInvoices: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string }>, projects?: Array<{ __typename?: 'Project', id: string, title: string, code: string } | null> | null, brand: { __typename?: 'Brand', id: string, name: string }, urls: { __typename?: 'MediaUrlList', preview?: string | null, download?: string | null }, files: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', hasMorePages: boolean, currentPage: number, perPage: number, total: number, count: number, firstItem?: number | null, lastItem?: number | null, lastPage: number } } | null };

export type GetOtherDocumentsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<OtherDocumentQueryArgs>;
}>;


export type GetOtherDocumentsQuery = { __typename?: 'Query', otherDocumentsSummary: { __typename?: 'OtherDocumentsSummary', otherDocumentIds?: Array<string> | null }, otherDocuments?: { __typename?: 'OtherDocumentPaginator', data: Array<{ __typename?: 'OtherDocument', id: string, title: string, cloudUrl?: string | null, driveCloudUrl?: string | null, projects?: Array<{ __typename?: 'Project', id: string, title: string, code: string } | null> | null, brands?: Array<{ __typename?: 'Brand', id: string, name: string } | null> | null, contractors?: Array<{ __typename?: 'Contractor', id: string, legal_name: string } | null> | null, clients?: Array<{ __typename?: 'Client', id: string, name: string } | null> | null, urls: { __typename?: 'MediaUrlList', preview?: string | null, download?: string | null }, files: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type UpdateOtherDocumentMutationVariables = Exact<{
  input: UpdateOtherDocumentInput;
}>;


export type UpdateOtherDocumentMutation = { __typename?: 'Mutation', updateOtherDocument: { __typename?: 'OtherDocument', id: string } };

export type CreateOtherDocumentMutationVariables = Exact<{
  input: CreateOtherDocumentInput;
}>;


export type CreateOtherDocumentMutation = { __typename?: 'Mutation', createOtherDocument: { __typename?: 'OtherDocument', id: string } };

export type DeleteOtherDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOtherDocumentMutation = { __typename?: 'Mutation', deleteOtherDocument: { __typename?: 'OtherDocument', id: string } };

export type DeleteOrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOrderMutation = { __typename?: 'Mutation', deleteOrder: { __typename?: 'Order', id: string } };

export type CreateContractMutationVariables = Exact<{
  input: CreateContractInput;
}>;


export type CreateContractMutation = { __typename?: 'Mutation', createContract: { __typename?: 'Contract', id: string, title: string, type: ContractTypeEnum } };

export type UpdateContractMutationVariables = Exact<{
  input: UpdateContractInput;
}>;


export type UpdateContractMutation = { __typename?: 'Mutation', updateContract: { __typename?: 'Contract', id: string } };

export type DeleteContractMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteContractMutation = { __typename?: 'Mutation', deleteContract: { __typename?: 'Contract', id: string } };

export type DeleteUploadedFileMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteUploadedFileMutation = { __typename?: 'Mutation', deleteUploadedFile: boolean };

export type CreateExternalLinkMutationVariables = Exact<{
  input: CreateExternalLinkInput;
}>;


export type CreateExternalLinkMutation = { __typename?: 'Mutation', createExternalLink: { __typename?: 'ExternalLink', id: string, title: string, link: string, model_id: string, model_type: ExternalLinkType } };

export type UpdateExternalLinkMutationVariables = Exact<{
  input: UpdateExternalLinkInput;
}>;


export type UpdateExternalLinkMutation = { __typename?: 'Mutation', updateExternalLink: { __typename?: 'ExternalLink', id: string, title: string, link: string, model_id: string, model_type: ExternalLinkType } };

export type DeleteExternalLinkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteExternalLinkMutation = { __typename?: 'Mutation', deleteExternalLink?: boolean | null };

export type ExternalLinkFragmentFragment = { __typename?: 'ExternalLink', id: string, title: string, link: string, model_id: string, model_type: ExternalLinkType };

export type AllExternalLinksQueryVariables = Exact<{
  model_type?: InputMaybe<ExternalLinkType>;
}>;


export type AllExternalLinksQuery = { __typename?: 'Query', externalLinks: Array<{ __typename?: 'ExternalLink', id: string, title: string, link: string, model_id: string, model_type: ExternalLinkType }> };

export type ProjectExternalLinksQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectExternalLinksQuery = { __typename?: 'Query', project?: { __typename?: 'Project', externalLinks: Array<{ __typename?: 'ExternalLink', id: string, title: string, link: string, model_id: string, model_type: ExternalLinkType }> } | null };

export type BrandExternalLinksQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BrandExternalLinksQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', externalLinks: Array<{ __typename?: 'ExternalLink', id: string, title: string, link: string, model_id: string, model_type: ExternalLinkType }> } | null };

export type ExternalLinksFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExternalLinksFilterOptionsQuery = { __typename?: 'Query', projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string }>, brandsSimpleMap: Array<{ __typename?: 'BrandSimple', id: string, name: string }> };

export type BudgetItemPlannedExpensesForCreateExpenseQueryVariables = Exact<{
  budgetItemId: Scalars['ID']['input'];
  budgetItemType: ExpenseBudgetItemTypeEnum;
}>;


export type BudgetItemPlannedExpensesForCreateExpenseQuery = { __typename?: 'Query', budgetItemPlannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | null, date?: Date | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }> };

export type CreateExpenseMutationVariables = Exact<{
  input: CreateExpenseInput;
}>;


export type CreateExpenseMutation = { __typename?: 'Mutation', createExpense: { __typename?: 'Expense', id: string, expense_no?: string | null, is_draft: boolean, for_approval: boolean, status: ExpenseStatusEnum, type: ExpenseTypeEnum, variable_symbol?: string | null, constant_symbol?: string | null, specific_symbol?: string | null, internal_number?: string | null, document_number?: string | null, note?: string | null, internal_note?: string | null, total_amount_includes_vat: boolean, user_created_date: Date, issue_date?: Date | null, date_of_supply?: Date | null, due_date?: Date | null, paid_at?: Date | null, has_master_agreement?: boolean | null, fond_contractor_id?: string | null, invoice_order_sequence_id?: string | null, legal_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, registration_no?: string | null, tax_no?: string | null, vat_no?: string | null, business_form?: BusinessFormEnum | null, national_id?: string | null, iban?: string | null, swift?: string | null, exchange_rate?: number | null, workspace_company_id?: string | null, workspace_bank_account_id?: string | null, bank_account?: string | null, bank_account_code?: string | null, updated_at: Date, payment_type?: { __typename?: 'PaymentType', id: string, name: string, system_name?: ExpensePaymentTypeEnum | null } | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | null, contractor?: { __typename?: 'Contractor', id: string } | null, contract?: { __typename?: 'Contract', id: string } | null, expenseVatItems: Array<{ __typename?: 'ExpenseVatItem', amount_in_currency: number, vat_in_currency: number, vat_percent_informative: number }>, currency: { __typename?: 'Currency', id: string, denomination: number }, expenseItemsStructured: Array<{ __typename?: 'StructuredExpenseItemsItem', total_amount: number, brand?: { __typename?: 'Brand', id: string, name: string } | null, expense_items: Array<{ __typename?: 'ExpenseItem', id: string, brand_id?: string | null, project_id?: string | null, amount_in_currency: number, amount_in_percent?: number | null, mandatory_id?: string | null, approved: boolean, budget_item_type: ExpenseBudgetItemTypeEnum, accounting_centre_id?: string | null, accounting_vat_classification_id?: string | null, expense_item_description_id?: string | null, tag_ids?: Array<string> | null, custom_cost_ratio?: string | null, vat_amount_in_currency?: number | null, globalCreditAccount?: { __typename?: 'GlobalCreditAccount', id: string, title: string, stats: { __typename?: 'GlobalCreditAccountStats', remaining_credit: number } } | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number, type?: VatRateTypeEnum | null, deleted: boolean } | null, approvals: Array<{ __typename?: 'ExpenseItemApproval', id: string, approved: boolean, created_at: Date, user: { __typename?: 'User', id: string, full_name: string } }>, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | null, date?: Date | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | { __typename?: 'OurWorkBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | null, date?: Date | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | null, accountingAccount?: { __typename?: 'AccountingAccount', id: string, title: string } | null, positions?: Array<{ __typename?: 'ExpenseItemPosition', time_tracking_work_type_id?: string | null, tracked_time?: number | null, report_date?: Date | null, task?: { __typename?: 'Task', id: string, name: string } | null }> | null, timeBillings: Array<{ __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean }> }> }>, stats: { __typename?: 'ExpenseStats', total_vat_in_currency: number, total_amount_with_vat_in_currency: number, total_amount: number, total_vat: number, total_amount_with_vat: number, total_amount_without_vat: number }, expense_documents: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } }>, lockedDocument?: { __typename?: 'LockDocument', locked_to: Date, user: { __typename?: 'User', id: string, full_name: string } } | null, emailData?: { __typename?: 'ExpenseEmailData', message_id: string, subject: string, from: string, text: string, received_at: Date } | null, relatedExpenses: Array<{ __typename?: 'Expense', id: string, expense_no?: string | null, type: ExpenseTypeEnum, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, stats: { __typename?: 'ExpenseStats', total_amount_with_vat_in_currency: number } }>, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: Date, deleted_at?: Date | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null } };

export type FindAddressForExpenseMutationVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAddressForExpenseMutation = { __typename?: 'Mutation', findAddressForExpense?: { __typename?: 'MapQuestAddress', street: string, city: string, zip: string, country?: { __typename?: 'Country', id: string, name: string, code: string } | null } | null };

export type UpdateExpenseMutationVariables = Exact<{
  input: UpdateExpenseInput;
}>;


export type UpdateExpenseMutation = { __typename?: 'Mutation', updateExpense: { __typename?: 'Expense', id: string, expense_no?: string | null, is_draft: boolean, for_approval: boolean, status: ExpenseStatusEnum, type: ExpenseTypeEnum, variable_symbol?: string | null, constant_symbol?: string | null, specific_symbol?: string | null, internal_number?: string | null, document_number?: string | null, note?: string | null, internal_note?: string | null, total_amount_includes_vat: boolean, user_created_date: Date, issue_date?: Date | null, date_of_supply?: Date | null, due_date?: Date | null, paid_at?: Date | null, has_master_agreement?: boolean | null, fond_contractor_id?: string | null, invoice_order_sequence_id?: string | null, legal_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, registration_no?: string | null, tax_no?: string | null, vat_no?: string | null, business_form?: BusinessFormEnum | null, national_id?: string | null, iban?: string | null, swift?: string | null, exchange_rate?: number | null, workspace_company_id?: string | null, workspace_bank_account_id?: string | null, bank_account?: string | null, bank_account_code?: string | null, updated_at: Date, payment_type?: { __typename?: 'PaymentType', id: string, name: string, system_name?: ExpensePaymentTypeEnum | null } | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | null, contractor?: { __typename?: 'Contractor', id: string } | null, contract?: { __typename?: 'Contract', id: string } | null, expenseVatItems: Array<{ __typename?: 'ExpenseVatItem', amount_in_currency: number, vat_in_currency: number, vat_percent_informative: number }>, currency: { __typename?: 'Currency', id: string, denomination: number }, expenseItemsStructured: Array<{ __typename?: 'StructuredExpenseItemsItem', total_amount: number, brand?: { __typename?: 'Brand', id: string, name: string } | null, expense_items: Array<{ __typename?: 'ExpenseItem', id: string, brand_id?: string | null, project_id?: string | null, amount_in_currency: number, amount_in_percent?: number | null, mandatory_id?: string | null, approved: boolean, budget_item_type: ExpenseBudgetItemTypeEnum, accounting_centre_id?: string | null, accounting_vat_classification_id?: string | null, expense_item_description_id?: string | null, tag_ids?: Array<string> | null, custom_cost_ratio?: string | null, vat_amount_in_currency?: number | null, globalCreditAccount?: { __typename?: 'GlobalCreditAccount', id: string, title: string, stats: { __typename?: 'GlobalCreditAccountStats', remaining_credit: number } } | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number, type?: VatRateTypeEnum | null, deleted: boolean } | null, approvals: Array<{ __typename?: 'ExpenseItemApproval', id: string, approved: boolean, created_at: Date, user: { __typename?: 'User', id: string, full_name: string } }>, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | null, date?: Date | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | { __typename?: 'OurWorkBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | null, date?: Date | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | null, accountingAccount?: { __typename?: 'AccountingAccount', id: string, title: string } | null, positions?: Array<{ __typename?: 'ExpenseItemPosition', time_tracking_work_type_id?: string | null, tracked_time?: number | null, report_date?: Date | null, task?: { __typename?: 'Task', id: string, name: string } | null }> | null, timeBillings: Array<{ __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean }> }> }>, stats: { __typename?: 'ExpenseStats', total_vat_in_currency: number, total_amount_with_vat_in_currency: number, total_amount: number, total_vat: number, total_amount_with_vat: number, total_amount_without_vat: number }, expense_documents: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } }>, lockedDocument?: { __typename?: 'LockDocument', locked_to: Date, user: { __typename?: 'User', id: string, full_name: string } } | null, emailData?: { __typename?: 'ExpenseEmailData', message_id: string, subject: string, from: string, text: string, received_at: Date } | null, relatedExpenses: Array<{ __typename?: 'Expense', id: string, expense_no?: string | null, type: ExpenseTypeEnum, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, stats: { __typename?: 'ExpenseStats', total_amount_with_vat_in_currency: number } }>, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: Date, deleted_at?: Date | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null } };

export type LockDocumentMutationVariables = Exact<{
  document_id: Scalars['ID']['input'];
  document_type: LockDocumentTypeEnum;
}>;


export type LockDocumentMutation = { __typename?: 'Mutation', lockDocument: { __typename?: 'LockDocument', document_id: string } };

export type UnlockDocumentMutationVariables = Exact<{
  document_id: Scalars['ID']['input'];
  document_type: LockDocumentTypeEnum;
}>;


export type UnlockDocumentMutation = { __typename?: 'Mutation', unlockDocument: { __typename?: 'LockDocument', document_id: string } };

export type ExpenseItemDescriptionFragment = { __typename?: 'ExpenseItemDesciption', id: string, title: string, deleted_at?: Date | null };

export type CreateExpenseItemDescriptionMutationVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type CreateExpenseItemDescriptionMutation = { __typename?: 'Mutation', createExpenseItemDescription?: { __typename?: 'ExpenseItemDesciption', id: string, title: string, deleted_at?: Date | null } | null };

export type UpdateExpenseItemDescriptionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}>;


export type UpdateExpenseItemDescriptionMutation = { __typename?: 'Mutation', updateExpenseItemDescription?: { __typename?: 'ExpenseItemDesciption', id: string, title: string, deleted_at?: Date | null } | null };

export type DeleteExpenseItemDescriptionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteExpenseItemDescriptionMutation = { __typename?: 'Mutation', deleteExpenseItemDescription?: boolean | null };

export type OurWorkBudgetItemByCodeFragment = { __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, project?: { __typename?: 'ProjectSimple', id: string, project_manager_id?: string | null, archived_at?: Date | null, finished_at?: Date | null, brand: { __typename?: 'BrandSimple', id: string, name: string } } | null };

export type ExpenseBudgetItemByCodeFragment = { __typename?: 'ExpenseBudgetItemSimple', id: string, title: string, project: { __typename?: 'ProjectSimple', id: string, project_manager_id?: string | null, archived_at?: Date | null, finished_at?: Date | null, brand: { __typename?: 'BrandSimple', id: string, name: string } } };

export type ContractForCreateExpenseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContractForCreateExpenseQuery = { __typename?: 'Query', contract?: { __typename?: 'Contract', id: string, type: ContractTypeEnum, files: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } }> } | null };

export type ContractorForCreateExpenseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContractorForCreateExpenseQuery = { __typename?: 'Query', contractor?: { __typename?: 'Contractor', id: string, legal_name: string, street?: string | null, city?: string | null, zip?: string | null, registration_no?: string | null, tax_no?: string | null, vat_no?: string | null, national_id?: string | null, iban?: string | null, swift?: string | null, is_vat_payer?: boolean | null, business_form?: BusinessFormEnum | null, bank_account?: string | null, bank_account_code?: string | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | null } | null };

export type DependenciesForCreateExpenseQueryVariables = Exact<{ [key: string]: never; }>;


export type DependenciesForCreateExpenseQuery = { __typename?: 'Query', currencies?: Array<{ __typename?: 'Currency', id: string, code: string, denomination: number }> | null, vatRates?: Array<{ __typename?: 'VatRate', deleted: boolean, type?: VatRateTypeEnum | null, id: string, amount: number }> | null, fondContractorsSimpleMap: Array<{ __typename?: 'FondContractorSimple', id: string, legal_name: string }>, accountingAccountsSimpleMap: Array<{ __typename?: 'AccountingAccount', id: string, title: string, account_number: string }>, paymentTypes: Array<{ __typename?: 'PaymentType', id: string, name: string, system_name?: ExpensePaymentTypeEnum | null }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string, code: string }> }>, accountingCentres: Array<{ __typename?: 'AccountingCentre', id: string, centre: string, title: string, type: Accounting_Centre_Type, deleted_at?: Date | null }>, expenseItemDescriptions?: Array<{ __typename?: 'ExpenseItemDesciption', id: string, title: string, deleted_at?: Date | null } | null> | null };

export type ExpenseForCreateExpenseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ExpenseForCreateExpenseQuery = { __typename?: 'Query', expense: { __typename?: 'Expense', id: string, expense_no?: string | null, is_draft: boolean, for_approval: boolean, status: ExpenseStatusEnum, type: ExpenseTypeEnum, variable_symbol?: string | null, constant_symbol?: string | null, specific_symbol?: string | null, internal_number?: string | null, document_number?: string | null, note?: string | null, internal_note?: string | null, total_amount_includes_vat: boolean, user_created_date: Date, issue_date?: Date | null, date_of_supply?: Date | null, due_date?: Date | null, paid_at?: Date | null, has_master_agreement?: boolean | null, fond_contractor_id?: string | null, invoice_order_sequence_id?: string | null, legal_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, registration_no?: string | null, tax_no?: string | null, vat_no?: string | null, business_form?: BusinessFormEnum | null, national_id?: string | null, iban?: string | null, swift?: string | null, exchange_rate?: number | null, workspace_company_id?: string | null, workspace_bank_account_id?: string | null, bank_account?: string | null, bank_account_code?: string | null, updated_at: Date, payment_type?: { __typename?: 'PaymentType', id: string, name: string, system_name?: ExpensePaymentTypeEnum | null } | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | null, contractor?: { __typename?: 'Contractor', id: string } | null, contract?: { __typename?: 'Contract', id: string } | null, expenseVatItems: Array<{ __typename?: 'ExpenseVatItem', amount_in_currency: number, vat_in_currency: number, vat_percent_informative: number }>, currency: { __typename?: 'Currency', id: string, denomination: number }, expenseItemsStructured: Array<{ __typename?: 'StructuredExpenseItemsItem', total_amount: number, brand?: { __typename?: 'Brand', id: string, name: string } | null, expense_items: Array<{ __typename?: 'ExpenseItem', id: string, brand_id?: string | null, project_id?: string | null, amount_in_currency: number, amount_in_percent?: number | null, mandatory_id?: string | null, approved: boolean, budget_item_type: ExpenseBudgetItemTypeEnum, accounting_centre_id?: string | null, accounting_vat_classification_id?: string | null, expense_item_description_id?: string | null, tag_ids?: Array<string> | null, custom_cost_ratio?: string | null, vat_amount_in_currency?: number | null, globalCreditAccount?: { __typename?: 'GlobalCreditAccount', id: string, title: string, stats: { __typename?: 'GlobalCreditAccountStats', remaining_credit: number } } | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number, type?: VatRateTypeEnum | null, deleted: boolean } | null, approvals: Array<{ __typename?: 'ExpenseItemApproval', id: string, approved: boolean, created_at: Date, user: { __typename?: 'User', id: string, full_name: string } }>, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | null, date?: Date | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | { __typename?: 'OurWorkBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | null, date?: Date | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | null, accountingAccount?: { __typename?: 'AccountingAccount', id: string, title: string } | null, positions?: Array<{ __typename?: 'ExpenseItemPosition', time_tracking_work_type_id?: string | null, tracked_time?: number | null, report_date?: Date | null, task?: { __typename?: 'Task', id: string, name: string } | null }> | null, timeBillings: Array<{ __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean }> }> }>, stats: { __typename?: 'ExpenseStats', total_vat_in_currency: number, total_amount_with_vat_in_currency: number, total_amount: number, total_vat: number, total_amount_with_vat: number, total_amount_without_vat: number }, expense_documents: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } }>, lockedDocument?: { __typename?: 'LockDocument', locked_to: Date, user: { __typename?: 'User', id: string, full_name: string } } | null, emailData?: { __typename?: 'ExpenseEmailData', message_id: string, subject: string, from: string, text: string, received_at: Date } | null, relatedExpenses: Array<{ __typename?: 'Expense', id: string, expense_no?: string | null, type: ExpenseTypeEnum, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, stats: { __typename?: 'ExpenseStats', total_amount_with_vat_in_currency: number } }>, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: Date, deleted_at?: Date | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null } };

export type IsExpenseLockedQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IsExpenseLockedQuery = { __typename?: 'Query', expense: { __typename?: 'Expense', lockedDocument?: { __typename?: 'LockDocument', locked_to: Date, user: { __typename?: 'User', id: string, full_name: string } } | null } };

export type GetExpenseUpdatedAtQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetExpenseUpdatedAtQuery = { __typename?: 'Query', expense: { __typename?: 'Expense', updated_at: Date } };

export type GetExpenseBudgetItemsByItemCodeQueryVariables = Exact<{
  item_code: Scalars['String']['input'];
}>;


export type GetExpenseBudgetItemsByItemCodeQuery = { __typename?: 'Query', expenseBudgetItemsByItemCode: Array<{ __typename?: 'ExpenseBudgetItemSimple', id: string, title: string, project: { __typename?: 'ProjectSimple', id: string, project_manager_id?: string | null, archived_at?: Date | null, finished_at?: Date | null, brand: { __typename?: 'BrandSimple', id: string, name: string } } }> };

export type GetOurWorkBudgetItemsByItemCodeQueryVariables = Exact<{
  item_code: Scalars['String']['input'];
}>;


export type GetOurWorkBudgetItemsByItemCodeQuery = { __typename?: 'Query', ourWorkBudgetItemsByItemCode: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, project?: { __typename?: 'ProjectSimple', id: string, project_manager_id?: string | null, archived_at?: Date | null, finished_at?: Date | null, brand: { __typename?: 'BrandSimple', id: string, name: string } } | null }> };

export type ProjectForCreateExpenseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectForCreateExpenseQuery = { __typename?: 'Query', projectForExpense: { __typename?: 'ProjectForExpense', id: string, title: string, code: string, finished_at?: Date | null, brand: { __typename?: 'BrandSimple', id: string }, team: { __typename?: 'Team', id: string, expense_cost_centre_id?: string | null }, expenses: Array<{ __typename?: 'ExpenseBudgetItemSimple', id: string, title: string, item_code?: string | null, payment_status: ExpenseInvoiceStatusEnum, type: ExpenseBudgetItemType, completed_at?: Date | null, category: { __typename?: 'ExpenseBudgetCategory', id: string, name: string }, stats: { __typename?: 'ExpenseBudgetItemStatsSimple', total_budget: number, planned_expenses: number, real_expenses: number } }>, ourWorkBudgetItems?: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, item_code?: string | null, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled: boolean, tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null }, stats: { __typename?: 'OurWorkBudgetItemStats', remaining_budget: number } }> | null } };

export type ContractorSelectOptionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ContractorQueryArgs>;
}>;


export type ContractorSelectOptionsQuery = { __typename?: 'Query', contractors?: { __typename?: 'ContractorPaginator', data: Array<{ __typename?: 'Contractor', id: string, legal_name: string }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type BillingEntitySelectOptionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<BillingEntityQueryArgs>;
}>;


export type BillingEntitySelectOptionsQuery = { __typename?: 'Query', billingEntities?: { __typename?: 'BillingEntityPaginator', data: Array<{ __typename?: 'BillingEntity', id: string, internal_name: string, street: string, city: string }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetExpensePredictionQueryVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type GetExpensePredictionQuery = { __typename?: 'Query', fetchOCRExpenseData?: { __typename?: 'OCRExpenseData', document_number?: string | null, for_approval?: boolean | null, type?: ExpenseTypeEnum | null, variable_symbol?: string | null, constant_symbol?: string | null, specific_symbol?: string | null, total_amount_includes_vat?: boolean | null, total_amount_with_vat_in_currency?: number | null, issue_date?: Date | null, date_of_supply?: Date | null, due_date?: Date | null, currency_id?: string | null, contractor_id?: string | null, legal_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, country_id?: string | null, registration_no?: string | null, tax_no?: string | null, vat_no?: string | null, business_form?: BusinessFormEnum | null, iban?: string | null, swift?: string | null, bank_account?: string | null, bank_account_code?: string | null, expense_items?: Array<{ __typename?: 'OCRExpenseItemData', amount?: number | null, approved?: boolean | null, description?: string | null, vat_rate?: number | null }> | null } | null };

export type TaskPositionsForExpenseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskPositionsForExpenseQuery = { __typename?: 'Query', task: { __typename?: 'Task', id: string, positions: Array<{ __typename?: 'TaskPosition', id: string, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } }> } };

export type ExpenseBudgetItemPlannedExpenseFieldsFragment = { __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | null, date?: Date | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> };

export type ExpenseFragment = { __typename?: 'Expense', id: string, expense_no?: string | null, is_draft: boolean, for_approval: boolean, status: ExpenseStatusEnum, type: ExpenseTypeEnum, variable_symbol?: string | null, constant_symbol?: string | null, specific_symbol?: string | null, internal_number?: string | null, document_number?: string | null, note?: string | null, internal_note?: string | null, total_amount_includes_vat: boolean, user_created_date: Date, issue_date?: Date | null, date_of_supply?: Date | null, due_date?: Date | null, paid_at?: Date | null, has_master_agreement?: boolean | null, fond_contractor_id?: string | null, invoice_order_sequence_id?: string | null, legal_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, registration_no?: string | null, tax_no?: string | null, vat_no?: string | null, business_form?: BusinessFormEnum | null, national_id?: string | null, iban?: string | null, swift?: string | null, exchange_rate?: number | null, workspace_company_id?: string | null, workspace_bank_account_id?: string | null, bank_account?: string | null, bank_account_code?: string | null, updated_at: Date, payment_type?: { __typename?: 'PaymentType', id: string, name: string, system_name?: ExpensePaymentTypeEnum | null } | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | null, contractor?: { __typename?: 'Contractor', id: string } | null, contract?: { __typename?: 'Contract', id: string } | null, expenseVatItems: Array<{ __typename?: 'ExpenseVatItem', amount_in_currency: number, vat_in_currency: number, vat_percent_informative: number }>, currency: { __typename?: 'Currency', id: string, denomination: number }, expenseItemsStructured: Array<{ __typename?: 'StructuredExpenseItemsItem', total_amount: number, brand?: { __typename?: 'Brand', id: string, name: string } | null, expense_items: Array<{ __typename?: 'ExpenseItem', id: string, brand_id?: string | null, project_id?: string | null, amount_in_currency: number, amount_in_percent?: number | null, mandatory_id?: string | null, approved: boolean, budget_item_type: ExpenseBudgetItemTypeEnum, accounting_centre_id?: string | null, accounting_vat_classification_id?: string | null, expense_item_description_id?: string | null, tag_ids?: Array<string> | null, custom_cost_ratio?: string | null, vat_amount_in_currency?: number | null, globalCreditAccount?: { __typename?: 'GlobalCreditAccount', id: string, title: string, stats: { __typename?: 'GlobalCreditAccountStats', remaining_credit: number } } | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number, type?: VatRateTypeEnum | null, deleted: boolean } | null, approvals: Array<{ __typename?: 'ExpenseItemApproval', id: string, approved: boolean, created_at: Date, user: { __typename?: 'User', id: string, full_name: string } }>, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | null, date?: Date | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | { __typename?: 'OurWorkBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | null, date?: Date | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | null, accountingAccount?: { __typename?: 'AccountingAccount', id: string, title: string } | null, positions?: Array<{ __typename?: 'ExpenseItemPosition', time_tracking_work_type_id?: string | null, tracked_time?: number | null, report_date?: Date | null, task?: { __typename?: 'Task', id: string, name: string } | null }> | null, timeBillings: Array<{ __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean }> }> }>, stats: { __typename?: 'ExpenseStats', total_vat_in_currency: number, total_amount_with_vat_in_currency: number, total_amount: number, total_vat: number, total_amount_with_vat: number, total_amount_without_vat: number }, expense_documents: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } }>, lockedDocument?: { __typename?: 'LockDocument', locked_to: Date, user: { __typename?: 'User', id: string, full_name: string } } | null, emailData?: { __typename?: 'ExpenseEmailData', message_id: string, subject: string, from: string, text: string, received_at: Date } | null, relatedExpenses: Array<{ __typename?: 'Expense', id: string, expense_no?: string | null, type: ExpenseTypeEnum, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, stats: { __typename?: 'ExpenseStats', total_amount_with_vat_in_currency: number } }>, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: Date, deleted_at?: Date | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null };

export type ExpenseItemsListItemFragment = { __typename?: 'ExpenseItem', id: string, amount: number, amount_in_currency: number, mandatory_id?: string | null, brand_id?: string | null, project_id?: string | null, tag_ids?: Array<string> | null, accounting_centre_id?: string | null, accounting_vat_classification_id?: string | null, budget_item_type: ExpenseBudgetItemTypeEnum, accountingAccount?: { __typename?: 'AccountingAccount', id: string, title: string, account_number: string } | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number } | null, description?: { __typename?: 'ExpenseItemDesciption', title: string } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null, timeBillings: Array<{ __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean, title?: string | null, project: { __typename?: 'Project', id: string } }>, expense: { __typename?: 'Expense', id: string, expense_no?: string | null, document_number?: string | null, invoice_status: ExpenseInvoiceStatusEnum, status: ExpenseStatusEnum, type: ExpenseTypeEnum, date_of_supply?: Date | null, due_date?: Date | null, paid_at?: Date | null, payment_status: PaymentStatusEnum, note?: string | null, internal_note?: string | null, workspace_company_id?: string | null, payment_type?: { __typename?: 'PaymentType', name: string } | null, currency: { __typename?: 'Currency', code: string, denomination: number }, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', amount_in_move_currency: number }> | null, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }> } };

export type ExpenseItemsListingQueryVariables = Exact<{
  filters?: InputMaybe<ExpenseItemsTimeBillingQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ExpenseItemsListingQuery = { __typename?: 'Query', expenseItemsForTimeBilling?: { __typename?: 'ExpenseItemPaginator', data: Array<{ __typename?: 'ExpenseItem', id: string, amount: number, amount_in_currency: number, mandatory_id?: string | null, brand_id?: string | null, project_id?: string | null, tag_ids?: Array<string> | null, accounting_centre_id?: string | null, accounting_vat_classification_id?: string | null, budget_item_type: ExpenseBudgetItemTypeEnum, accountingAccount?: { __typename?: 'AccountingAccount', id: string, title: string, account_number: string } | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number } | null, description?: { __typename?: 'ExpenseItemDesciption', title: string } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null, timeBillings: Array<{ __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean, title?: string | null, project: { __typename?: 'Project', id: string } }>, expense: { __typename?: 'Expense', id: string, expense_no?: string | null, document_number?: string | null, invoice_status: ExpenseInvoiceStatusEnum, status: ExpenseStatusEnum, type: ExpenseTypeEnum, date_of_supply?: Date | null, due_date?: Date | null, paid_at?: Date | null, payment_status: PaymentStatusEnum, note?: string | null, internal_note?: string | null, workspace_company_id?: string | null, payment_type?: { __typename?: 'PaymentType', name: string } | null, currency: { __typename?: 'Currency', code: string, denomination: number }, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', amount_in_move_currency: number }> | null, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }> } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type ExpenseItemsListingSummaryQueryVariables = Exact<{
  filters?: InputMaybe<ExpenseItemsTimeBillingQueryArgs>;
}>;


export type ExpenseItemsListingSummaryQuery = { __typename?: 'Query', expenseItemsForTimeBillingSummary: { __typename?: 'TimeBillingSummary', allIds: Array<string>, count: number, amount: number } };

export type ExpenseItemsListingFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpenseItemsListingFilterOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string }>, userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string }>, accountingCentres: Array<{ __typename?: 'AccountingCentre', id: string, title: string }> };

export type DeleteExpenseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteExpenseMutation = { __typename?: 'Mutation', deleteExpense: { __typename?: 'Expense', id: string } };

export type MarkExpenseAsPaidMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
}>;


export type MarkExpenseAsPaidMutation = { __typename?: 'Mutation', markExpenseAsPaid: { __typename?: 'Expense', id: string, paid_at?: Date | null } };

export type MarkExpenseAsUnpaidMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  remove_matched_payments?: Scalars['Boolean']['input'];
}>;


export type MarkExpenseAsUnpaidMutation = { __typename?: 'Mutation', markExpenseAsUnpaid: { __typename?: 'Expense', id: string, paid_at?: Date | null } };

export type MarkExpenseAsPaidBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
}>;


export type MarkExpenseAsPaidBulkMutation = { __typename?: 'Mutation', markExpenseAsPaidBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type CloneExpenseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CloneExpenseMutation = { __typename?: 'Mutation', cloneExpense: { __typename?: 'Expense', id: string, expense_no?: string | null, is_draft: boolean, for_approval: boolean, status: ExpenseStatusEnum, type: ExpenseTypeEnum, variable_symbol?: string | null, constant_symbol?: string | null, specific_symbol?: string | null, internal_number?: string | null, document_number?: string | null, note?: string | null, internal_note?: string | null, total_amount_includes_vat: boolean, user_created_date: Date, issue_date?: Date | null, date_of_supply?: Date | null, due_date?: Date | null, paid_at?: Date | null, has_master_agreement?: boolean | null, fond_contractor_id?: string | null, invoice_order_sequence_id?: string | null, legal_name?: string | null, street?: string | null, city?: string | null, zip?: string | null, registration_no?: string | null, tax_no?: string | null, vat_no?: string | null, business_form?: BusinessFormEnum | null, national_id?: string | null, iban?: string | null, swift?: string | null, exchange_rate?: number | null, workspace_company_id?: string | null, workspace_bank_account_id?: string | null, bank_account?: string | null, bank_account_code?: string | null, updated_at: Date, payment_type?: { __typename?: 'PaymentType', id: string, name: string, system_name?: ExpensePaymentTypeEnum | null } | null, country?: { __typename?: 'Country', id: string, name: string, code: string } | null, defaultAccountingAccount?: { __typename?: 'AccountingAccount', id: string } | null, contractor?: { __typename?: 'Contractor', id: string } | null, contract?: { __typename?: 'Contract', id: string } | null, expenseVatItems: Array<{ __typename?: 'ExpenseVatItem', amount_in_currency: number, vat_in_currency: number, vat_percent_informative: number }>, currency: { __typename?: 'Currency', id: string, denomination: number }, expenseItemsStructured: Array<{ __typename?: 'StructuredExpenseItemsItem', total_amount: number, brand?: { __typename?: 'Brand', id: string, name: string } | null, expense_items: Array<{ __typename?: 'ExpenseItem', id: string, brand_id?: string | null, project_id?: string | null, amount_in_currency: number, amount_in_percent?: number | null, mandatory_id?: string | null, approved: boolean, budget_item_type: ExpenseBudgetItemTypeEnum, accounting_centre_id?: string | null, accounting_vat_classification_id?: string | null, expense_item_description_id?: string | null, tag_ids?: Array<string> | null, custom_cost_ratio?: string | null, vat_amount_in_currency?: number | null, globalCreditAccount?: { __typename?: 'GlobalCreditAccount', id: string, title: string, stats: { __typename?: 'GlobalCreditAccountStats', remaining_credit: number } } | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number, type?: VatRateTypeEnum | null, deleted: boolean } | null, approvals: Array<{ __typename?: 'ExpenseItemApproval', id: string, approved: boolean, created_at: Date, user: { __typename?: 'User', id: string, full_name: string } }>, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | null, date?: Date | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | { __typename?: 'OurWorkBudgetItem', id: string, title: string, payment_status: ExpenseInvoiceStatusEnum, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, description?: string | null, date?: Date | null, budgeted_amount: number, client_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, usedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpenseUsed', id: string, used_amount: number, expenseItem: { __typename?: 'ExpenseItem', id: string } }> }>, project: { __typename?: 'Project', id: string, brand: { __typename?: 'Brand', id: string } } } | null, accountingAccount?: { __typename?: 'AccountingAccount', id: string, title: string } | null, positions?: Array<{ __typename?: 'ExpenseItemPosition', time_tracking_work_type_id?: string | null, tracked_time?: number | null, report_date?: Date | null, task?: { __typename?: 'Task', id: string, name: string } | null }> | null, timeBillings: Array<{ __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean }> }> }>, stats: { __typename?: 'ExpenseStats', total_vat_in_currency: number, total_amount_with_vat_in_currency: number, total_amount: number, total_vat: number, total_amount_with_vat: number, total_amount_without_vat: number }, expense_documents: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } }>, lockedDocument?: { __typename?: 'LockDocument', locked_to: Date, user: { __typename?: 'User', id: string, full_name: string } } | null, emailData?: { __typename?: 'ExpenseEmailData', message_id: string, subject: string, from: string, text: string, received_at: Date } | null, relatedExpenses: Array<{ __typename?: 'Expense', id: string, expense_no?: string | null, type: ExpenseTypeEnum, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, stats: { __typename?: 'ExpenseStats', total_amount_with_vat_in_currency: number } }>, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: Date, deleted_at?: Date | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null } };

export type BulkDeleteExpensesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkDeleteExpensesMutation = { __typename?: 'Mutation', bulkDeleteExpenses: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type GetExpensesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ExpenseQueryArgs>;
}>;


export type GetExpensesQuery = { __typename?: 'Query', expenses?: { __typename?: 'ExpensePaginator', data: Array<{ __typename?: 'Expense', id: string, invoice_status: ExpenseInvoiceStatusEnum, status: ExpenseStatusEnum, type: ExpenseTypeEnum, abraflexi_exported?: boolean | null, xero_exported?: boolean | null, variable_symbol?: string | null, has_master_agreement?: boolean | null, workspace_company_id?: string | null, iban?: string | null, date_of_supply?: Date | null, due_date?: Date | null, paid_at?: Date | null, user_created_date: Date, is_draft: boolean, expense_no?: string | null, exchange_rate?: number | null, note?: string | null, internal_note?: string | null, workspace_bank_account_id?: string | null, documentExports: Array<{ __typename?: 'DocumentExport', type: string, exported_at: Date }>, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null, projects: Array<{ __typename?: 'Project', id: string, code: string, title: string }>, stats: { __typename?: 'ExpenseStats', total_amount: number, total_amount_without_vat_in_currency: number, total_amount_with_vat_in_currency: number }, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, expenseItems: Array<{ __typename?: 'ExpenseItem', mandatory_id?: string | null, approved: boolean }>, expense_documents: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } }>, emailData?: { __typename?: 'ExpenseEmailData', text: string } | null, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, amount: number, amount_in_move_currency: number, exchange_rate: number, bank_account_move_id: string, bankAccountMove?: { __typename?: 'BankAccountMove', id: string, bank_account_id?: string | null, amount: number, note: string, reference: string, vs?: string | null, ss?: string | null, ks?: string | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: Date, balance: number, iban?: string | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: Date, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | null } | null }> | null, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean } | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: Date, deleted_at?: Date | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type ExpensesTableSummaryQueryVariables = Exact<{
  filters?: InputMaybe<ExpenseQueryArgs>;
}>;


export type ExpensesTableSummaryQuery = { __typename?: 'Query', expensesSummary: { __typename?: 'ExpensesSummary', expenseIds?: Array<string> | null, expenses: number, total_amount: number, total_vat: number, total_amount_with_vat: number, payments_due: number, payments_due_vat: number, payments_due_without_vat: number, overdue_by_less_than_30_days: number, overdue_by_less_than_30_days_vat: number, overdue_by_less_than_30_days_without_vat: number, overdue_by_31_to_90_days: number, overdue_by_31_to_90_days_vat: number, overdue_by_31_to_90_days_without_vat: number, overdue_by_91_to_365_days: number, overdue_by_91_to_365_days_vat: number, overdue_by_91_to_365_days_without_vat: number, overdue_by_more_than_365_days: number, overdue_by_more_than_365_days_vat: number, overdue_by_more_than_365_days_without_vat: number } };

export type ExpensesTableSelectedSummaryQueryVariables = Exact<{
  filters?: InputMaybe<ExpenseQueryArgs>;
}>;


export type ExpensesTableSelectedSummaryQuery = { __typename?: 'Query', expensesSummary: { __typename?: 'ExpensesSummary', total_amount: number, total_amount_with_vat: number } };

export type GetExpenseTimeBillingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetExpenseTimeBillingsQuery = { __typename?: 'Query', expense: { __typename?: 'Expense', id: string, expenseItems: Array<{ __typename?: 'ExpenseItem', id: string, timeBillings: Array<{ __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean }> }> } };

export type ExportExpensesSummaryQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ExportExpensesSummaryQuery = { __typename?: 'Query', expenseSummaryExportBulk: string };

export type GenerateExpensePaymentOrderQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  type: ExpensePaymentOrderExportType;
  payment_type_id: Scalars['ID']['input'];
}>;


export type GenerateExpensePaymentOrderQuery = { __typename?: 'Query', generateExpensePaymentOrder: { __typename?: 'ExpensePaymentOrderResponse', url?: string | null, unprocessable_expense_ids?: Array<string> | null } };

export type ExpenseExportQueryVariables = Exact<{
  filters?: InputMaybe<ExpenseQueryArgs>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ExpenseExportQuery = { __typename?: 'Query', expenseExport: string };

export type ExpenseXmlExportQueryVariables = Exact<{
  filters?: InputMaybe<ExpenseQueryArgs>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ExpenseXmlExportQuery = { __typename?: 'Query', expenseXMLExport: string };

export type ExpenseOmegaExportQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ExpenseOmegaExportQuery = { __typename?: 'Query', omegaExpenseExport?: string | null };

export type ExpenseAbraFlexiSelectedExportQueryVariables = Exact<{
  expense_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ExpenseAbraFlexiSelectedExportQuery = { __typename?: 'Query', expenseAbraFlexiExport: string };

export type ExpensePremierExportQueryVariables = Exact<{
  expense_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ExpensePremierExportQuery = { __typename?: 'Query', expensePremierExport: string };

export type ExpenseFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpenseFilterOptionsQuery = { __typename?: 'Query', projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, code: string, title: string }>, userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, paymentTypes: Array<{ __typename?: 'PaymentType', id: string, name: string, system_name?: ExpensePaymentTypeEnum | null }> };

export type PohodaExpenseExportQueryVariables = Exact<{
  expense_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PohodaExpenseExportQuery = { __typename?: 'Query', pohodaExpenseExport?: string | null };

export type ExpenseAttachmentsExportBulkQueryVariables = Exact<{
  selectedIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ExpenseAttachmentsExportBulkQuery = { __typename?: 'Query', ExpenseAttachmentsExport?: string | null };

export type VarioExpenseExportQueryVariables = Exact<{
  expense_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type VarioExpenseExportQuery = { __typename?: 'Query', varioExpenseExport?: string | null };

export type TransakcioExpenseExportQueryVariables = Exact<{
  expense_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type TransakcioExpenseExportQuery = { __typename?: 'Query', transakcioExpenseExport?: string | null };

export type AccountingAccountOptionPartsFragment = { __typename?: 'AccountingAccount', id: string, title: string, account_number: string };

export type AllocationsColumnHeader_UserFragment = { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, planningRanges: Array<{ __typename?: 'UserProfilePlanningRange', valid_from: Date, valid_to?: Date | null, daily_capacity?: number | null, type: { __typename?: 'PlanningRangeType', value: PlanningRangeTypeEnum }, weekly_capacities?: { __typename?: 'WeeklyCapacities', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number, saturday: number, sunday: number } | null }>, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null };

export type BillingEntityOptionPartsFragment = { __typename?: 'BillingEntity', id: string, internal_name: string, street: string, city: string };

export type BrandCreditAccountOptionPartsFragment = { __typename?: 'BrandCreditAccount', id: string, title: string };

export type BrandSimpleOptionPartsFragment = { __typename?: 'BrandSimple', id: string, name: string, code: string };

export type CapacityAllocationItemFragment = { __typename?: 'CapacityAllocationItem', id: string, date: Date, from_time?: Time | null, to_time?: Time | null, note?: string | null, total_time: number, type: CapacityAllocationTypeEnum, location?: string | null, global?: boolean | null, time_off_duration_type?: TimeOffDurationTypeEnum | null, time_tracking_work_type_id?: string | null, completed: boolean, meetLink?: string | null, eventLink?: string | null, teams?: Array<{ __typename?: 'TeamAttendee', team: { __typename?: 'Team', id: string } }> | null, user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | null }, timeOffType?: { __typename?: 'TimeOffType', id: string, name: string, affects_planning_capacity: boolean } | null, createdBy: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | null } };

export type ClientSimpleOptionPartsFragment = { __typename?: 'ClientSimple', id: string, name: string };

export type ContactOptionPartsFragment = { __typename?: 'Contact', id: string, first_name?: string | null, last_name?: string | null };

export type CountrySimpleOptionPartsFragment = { __typename?: 'CountrySimple', id: string, name: string, code: string };

export type CurrencyOptionPartsFragment = { __typename?: 'Currency', id: string, code: string, denomination: number };

export type MediaModelPartsFragment = { __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } };

export type PaginatorInfoFragment = { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number };

export type PipedriveCustomFieldFragment = { __typename?: 'PipedriveCustomFieldValue', value?: string | null, customField: { __typename?: 'PipedriveCustomField', label?: string | null } };

export type ProjectSimpleOptionPartsFragment = { __typename?: 'ProjectSimple', id: string, title: string, code: string, brand_id: string };

export type UserSimpleOptionPartsFragment = { __typename?: 'UserSimple', id: string, full_name: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null };

export type UserTooltipFragment = { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null };

export type VatRateOptionPartsFragment = { __typename?: 'VatRate', id: string, amount: number };

export type IsDateBeforeLastPlanningUpdateMutationVariables = Exact<{
  date?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type IsDateBeforeLastPlanningUpdateMutation = { __typename?: 'Mutation', isDateBeforeLastPlanningUpdate: boolean };

export type StopTimerForCapacityAllocationItemMutationVariables = Exact<{
  input: StopTimerForCapacityAllocationItemInput;
}>;


export type StopTimerForCapacityAllocationItemMutation = { __typename?: 'Mutation', stopTimerForCapacityAllocationItem: { __typename?: 'CapacityAllocationItem', id: string } };

export type UpdateAllocationItemDurationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  total_time: Scalars['BigInt']['input'];
  to_time?: InputMaybe<Scalars['Time']['input']>;
  user_id: Scalars['ID']['input'];
}>;


export type UpdateAllocationItemDurationMutation = { __typename?: 'Mutation', updateCapacityAllocationItem: { __typename?: 'CapacityAllocationItem', id: string, total_time: number, to_time?: Time | null } };

export type UpdateAllocationDurationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  total_time: Scalars['BigInt']['input'];
  to_time?: InputMaybe<Scalars['Time']['input']>;
  create_task_positions: Scalars['Boolean']['input'];
}>;


export type UpdateAllocationDurationMutation = { __typename?: 'Mutation', updateCapacityAllocation: { __typename?: 'CapacityAllocation', id: string, total_time: number, to_time?: Time | null } };

export type CapacityAllocationItemTimeTrackingItemsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  user_id: Scalars['ID']['input'];
  task_id: Scalars['ID']['input'];
}>;


export type CapacityAllocationItemTimeTrackingItemsQuery = { __typename?: 'Query', capacityAllocationItemTimeTrackingItems: Array<{ __typename?: 'TimeTrackingItem', id: string, tracked_time: number, note?: string | null, is_locked: boolean, billable: boolean, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } }>, task: { __typename?: 'Task', billable: boolean, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', project: { __typename?: 'Project', availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> } } | null } };

export type ContractsSimpleQueryVariables = Exact<{
  contractorId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ContractsSimpleQuery = { __typename?: 'Query', contractsSimpleMap?: Array<{ __typename?: 'ContractSimple', id: string, title: string }> | null };

export type ConvertAmountQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  workspaceCompanyId?: InputMaybe<Scalars['ID']['input']>;
  amount: Scalars['BigInt']['input'];
  currencyId: Scalars['ID']['input'];
  exchangeRate?: InputMaybe<Scalars['BigInt']['input']>;
  date: Scalars['Date']['input'];
  type: ExchangeRateSource;
}>;


export type ConvertAmountQuery = { __typename?: 'Query', convertAmountToWorkspaceCurrencyUsingExchangeRate?: { __typename?: 'ConvertedAmount', amount: number } | null };

export type GetExchangeRateQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  workspaceCompanyId?: InputMaybe<Scalars['ID']['input']>;
  currencyId: Scalars['ID']['input'];
  exchangeRate?: InputMaybe<Scalars['BigInt']['input']>;
  date: Scalars['Date']['input'];
  type: ExchangeRateSource;
}>;


export type GetExchangeRateQuery = { __typename?: 'Query', convertAmountToWorkspaceCurrencyUsingExchangeRate?: { __typename?: 'ConvertedAmount', exchange_rate: number } | null };

export type GetDuplicateExpensesIDsQueryVariables = Exact<{
  contractorId: Scalars['ID']['input'];
  variableSymbol: Scalars['String']['input'];
  excludeExpenseId?: InputMaybe<Scalars['ID']['input']>;
  documentNumber: Scalars['String']['input'];
}>;


export type GetDuplicateExpensesIDsQuery = { __typename?: 'Query', getDuplicateExpensesIDs: Array<string> };

export type LatestExpenseInternalNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestExpenseInternalNumberQuery = { __typename?: 'Query', getLatestExpenseInternalNumberPerType: Array<{ __typename?: 'LatestExpenseInternalNumberPerType', type: ExpenseTypeEnum, internal_number?: string | null }> };

export type PlanningDailyViewPeopleQueryVariables = Exact<{
  dailyViewFilters: PlanningDailyViewFilters;
}>;


export type PlanningDailyViewPeopleQuery = { __typename?: 'Query', planningDailyViewPeople: { __typename?: 'PlanningDailyViewPaginator', last_updated_at?: Date | null, data: Array<{ __typename?: 'PlanningDailyViewUserByDay', user: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, planningRanges: Array<{ __typename?: 'UserProfilePlanningRange', valid_from: Date, valid_to?: Date | null, daily_capacity?: number | null, type: { __typename?: 'PlanningRangeType', value: PlanningRangeTypeEnum }, weekly_capacities?: { __typename?: 'WeeklyCapacities', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number, saturday: number, sunday: number } | null }>, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }, items: Array<{ __typename?: 'PlanningDailyViewUserDay', capacity: number, workStatus: CapacityAllocationWorkStatus, date: Date, holiday?: string | null, total_tracked_for_date: number, items?: Array<{ __typename?: 'CapacityAllocationItem', id: string, completed: boolean, type: CapacityAllocationTypeEnum, total_time: number, from_time?: Time | null, to_time?: Time | null, date: Date, note?: string | null, global?: boolean | null, time_tracking_work_type_id?: string | null, teams?: Array<{ __typename?: 'TeamAttendee', team: { __typename?: 'Team', id: string } }> | null, createdBy: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | null }, userStats?: { __typename?: 'CapacityAllocationUserItemStats', tracked_time_for_item?: number | null, has_running_timer: boolean } | null, stats?: { __typename?: 'CapacityAllocationItemStats', capacity_allocation_id: string, capacity_allocation_item_id: string, capacity_allocation_created_by_id?: string | null, task_id?: string | null, task_name?: string | null, task_status_id?: string | null, task_status_name?: string | null, task_status_system_status?: TaskSystemStatusEnum | null, task_status_background_color?: string | null, task_status_foreground_color?: string | null, our_work_budget_item_id?: string | null, our_work_budget_item_title?: string | null, project_id?: string | null, project_code?: string | null, project_title?: string | null, tracking_enabled?: boolean | null, tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, time_off_type_id?: string | null, time_off_type_name?: string | null, time_off_type_affects_planning_capacity?: boolean | null, deadline?: Date | null, deadline_time?: Time | null, repetition: CapacityAllocationRepetitionTypeEnum, create_task_positions?: boolean | null, items_count: number, title?: string | null } | null }> | null }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CapacityAllocationItemStatsFragment = { __typename?: 'CapacityAllocationItemStats', capacity_allocation_id: string, capacity_allocation_item_id: string, capacity_allocation_created_by_id?: string | null, task_id?: string | null, task_name?: string | null, task_status_id?: string | null, task_status_name?: string | null, task_status_system_status?: TaskSystemStatusEnum | null, task_status_background_color?: string | null, task_status_foreground_color?: string | null, our_work_budget_item_id?: string | null, our_work_budget_item_title?: string | null, project_id?: string | null, project_code?: string | null, project_title?: string | null, tracking_enabled?: boolean | null, tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, time_off_type_id?: string | null, time_off_type_name?: string | null, time_off_type_affects_planning_capacity?: boolean | null, deadline?: Date | null, deadline_time?: Time | null, repetition: CapacityAllocationRepetitionTypeEnum, create_task_positions?: boolean | null, items_count: number, title?: string | null };

export type ProjectsSimpleQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['ID']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  orIdIn?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  withProBono?: InputMaybe<Scalars['Boolean']['input']>;
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
  my_projects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProjectsSimpleQuery = { __typename?: 'Query', projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, code: string, team_id: string, title: string, brand_id: string, billable: boolean, type: ProjectTypeEnum, project_manager_id?: string | null }> };

export type TrackedForDayQueryVariables = Exact<{
  user_id: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
}>;


export type TrackedForDayQuery = { __typename?: 'Query', timeTrackingItems: Array<{ __typename?: 'TimeTrackingItem', id: string, tracked_for_date: Date, tracked_time: number, tracked_time_with_running_timer: number, specific_time_from?: Time | null, specific_time_to?: Time | null, note?: string | null, auto_stopped: boolean, billable: boolean, is_locked: boolean, has_running_timer: boolean, timeBilling?: { __typename?: 'ProjectTimeBilling', id: string, name: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | null, user?: { __typename?: 'User', id: string } | null, capacityAllocationItem?: { __typename?: 'CapacityAllocationItem', id: string } | null, task: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, brand: { __typename?: 'Brand', id: string, name: string } } } | null }, timeTrackingBudgetItem: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled: boolean }, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', id: string, name: string } } }> };

export type UtilizationReportExportQueryVariables = Exact<{
  dataSource: UtilizationReportDataSource;
  where?: InputMaybe<UtilizationReportWhereConditions>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type UtilizationReportExportQuery = { __typename?: 'Query', utilizationReportExport: string };

export type UtilizationReportQueryVariables = Exact<{
  dataSource: UtilizationReportDataSource;
  where?: InputMaybe<UtilizationReportWhereConditions>;
  page: Scalars['BigInt']['input'];
  first: Scalars['BigInt']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<UtilizationReportOrderByClause> | UtilizationReportOrderByClause>;
}>;


export type UtilizationReportQuery = { __typename?: 'Query', utilizationReport: { __typename?: 'UtilizationReportPaginator', data: Array<{ __typename?: 'UtilizationUserReport', user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string, utilization_range_from: number, utilization_range_to: number, defaultWorktype: { __typename?: 'TimeTrackingWorkType', title: string } } | null, team?: { __typename?: 'Team', name: string } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, report: { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | null, combined_time_billable?: number | null, budgeted_time?: number | null, budgeted_time_billable?: number | null, allocated_time?: number | null, allocated_time_billable?: number | null, tracked_time?: number | null, tracked_time_billable?: number | null, utilization_percentage?: number | null, utilization_percentage_billable?: number | null, combined_amount_billable?: number | null, budgeted_amount_billable?: number | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type UtilizationReportFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type UtilizationReportFilterOptionsQuery = { __typename?: 'Query', teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | null }>, timeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> };

export type UtilizationReportGroupedByQueryVariables = Exact<{
  groupBy: UtilizationReportGroupBy;
  dataSource: UtilizationReportDataSource;
  where?: InputMaybe<UtilizationReportWhereConditions>;
  page: Scalars['BigInt']['input'];
  first: Scalars['BigInt']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<UtilizationReportOrderByClause> | UtilizationReportOrderByClause>;
  groupOrderBy?: InputMaybe<Array<UtilizationReportGroupOrderByClause> | UtilizationReportGroupOrderByClause>;
}>;


export type UtilizationReportGroupedByQuery = { __typename?: 'Query', utilizationReportGroups: { __typename?: 'UtilizationReportGroupPaginator', data: Array<{ __typename?: 'UtilizationReportGroup', group_title: string, report: { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | null, combined_time_billable?: number | null, budgeted_time?: number | null, budgeted_time_billable?: number | null, allocated_time?: number | null, allocated_time_billable?: number | null, tracked_time?: number | null, tracked_time_billable?: number | null, utilization_percentage?: number | null, utilization_percentage_billable?: number | null, combined_amount_billable?: number | null, budgeted_amount_billable?: number | null }, items: Array<{ __typename?: 'UtilizationUserReport', user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string, utilization_range_from: number, utilization_range_to: number, defaultWorktype: { __typename?: 'TimeTrackingWorkType', title: string } } | null, team?: { __typename?: 'Team', name: string } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, report: { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | null, combined_time_billable?: number | null, budgeted_time?: number | null, budgeted_time_billable?: number | null, allocated_time?: number | null, allocated_time_billable?: number | null, tracked_time?: number | null, tracked_time_billable?: number | null, utilization_percentage?: number | null, utilization_percentage_billable?: number | null, combined_amount_billable?: number | null, budgeted_amount_billable?: number | null } }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type UtilizationReportStatsQueryVariables = Exact<{
  dataSource: UtilizationReportDataSource;
  where?: InputMaybe<UtilizationReportWhereConditions>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type UtilizationReportStatsQuery = { __typename?: 'Query', utilizationReportSummary: { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | null, combined_time_billable?: number | null, budgeted_time?: number | null, budgeted_time_billable?: number | null, allocated_time?: number | null, allocated_time_billable?: number | null, tracked_time?: number | null, tracked_time_billable?: number | null, utilization_percentage?: number | null, utilization_percentage_billable?: number | null } };

export type UtilizationUserReportDataQueryVariables = Exact<{
  dataSource: UtilizationReportDataSource;
  userId: Scalars['ID']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type UtilizationUserReportDataQuery = { __typename?: 'Query', utilizationUserReport?: { __typename?: 'UtilizationUserReport', user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string, utilization_range_from: number, utilization_range_to: number, defaultWorktype: { __typename?: 'TimeTrackingWorkType', title: string } } | null, team?: { __typename?: 'Team', name: string } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, report: { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | null, combined_time_billable?: number | null, budgeted_time?: number | null, budgeted_time_billable?: number | null, allocated_time?: number | null, allocated_time_billable?: number | null, tracked_time?: number | null, tracked_time_billable?: number | null, utilization_percentage?: number | null, utilization_percentage_billable?: number | null } } | null, utilizationTaskReport: Array<{ __typename?: 'UtilizationTaskReport', budgeted_time: number, budgeted_time_in_range?: number | null, remaining_amount?: number | null, remaining_time: number, remaining_time_in_range?: number | null, remaining_time_in_percent?: number | null, tracked_amount?: number | null, tracked_in_range_amount?: number | null, tracked_time?: number | null, tracked_time_percent?: number | null, tracked_time_in_range?: number | null, tracked_time_in_range_percent?: number | null, allocated_amount?: number | null, allocated_in_range_amount?: number | null, allocated_time?: number | null, allocated_time_percent?: number | null, allocated_time_in_range?: number | null, allocated_time_in_range_percent?: number | null, over_budget_amount?: number | null, over_budget_time?: number | null, over_budget_time_in_percent?: number | null, total_task_budget_amount?: number | null, total_task_budget_in_range?: number | null, task: { __typename?: 'Task', id: string, name: string, status: { __typename?: 'TaskStatus', name: string, foreground_color: string, background_color: string }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, project: { __typename?: 'Project', title: string, id: string, code: string } } | null } }> };

export type TimeMaterialsBudgetItemFragmentFragment = { __typename?: 'TimeMaterialsBudgetItems', id: string, amount: number, invoiced: number, title: string, default_commission?: number | null, budget_category_id: string, data?: Array<{ __typename?: 'TimeMaterialsBudgetItemInvoiceData', id: string, name: string, tracked_time?: number | null, amount?: number | null } | null> | null };

export type TimeAndMaterialsInvoiceDataQueryVariables = Exact<{
  project_id: Scalars['ID']['input'];
  groupBy: TimeMaterialsInvoiceDataGroupByEnum;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  filters?: InputMaybe<TimeMaterialsQueryArgs>;
  outgoing_invoice_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TimeAndMaterialsInvoiceDataQuery = { __typename?: 'Query', timeMaterialsInvoiceData: { __typename?: 'TimeMaterialsDataForInvoicing', project: { __typename?: 'Project', id: string, title: string }, ourWorkBudgetItems: Array<{ __typename?: 'TimeMaterialsBudgetItems', id: string, amount: number, invoiced: number, title: string, default_commission?: number | null, budget_category_id: string, data?: Array<{ __typename?: 'TimeMaterialsBudgetItemInvoiceData', id: string, name: string, tracked_time?: number | null, amount?: number | null } | null> | null }>, expenseBudgetItems: Array<{ __typename?: 'TimeMaterialsBudgetItems', id: string, amount: number, invoiced: number, title: string, default_commission?: number | null, budget_category_id: string, data?: Array<{ __typename?: 'TimeMaterialsBudgetItemInvoiceData', id: string, name: string, tracked_time?: number | null, amount?: number | null } | null> | null }> } };

export type TimeAndMaterialsFilterOptionsQueryVariables = Exact<{
  projectId?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type TimeAndMaterialsFilterOptionsQuery = { __typename?: 'Query', userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string }>, ourWorkBudgetItemsSimpleMap: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string } }>, timeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> };

export type OutgoingInvoiceFormPartsFragment = { __typename?: 'OutgoingInvoice', id: string, vat_percent_informative?: number | null, vat_reverse_charge: boolean, old_invoice_alert_while_editing: boolean, exchange_rate: number, exchange_rate_source: ExchangeRateSource, workspace_exchange_rate: number, workspace_exchange_rate_source: ExchangeRateSource, workspace_company_id: string, workspace_bank_account_id: string, show_unit_price: boolean, show_billing_accounting: boolean, type: OutgoingInvoiceTypeEnum, invoice_order_sequence_id: string, credit_note_outgoing_invoice_id?: string | null, invoice_no: string, issue_date: Date, due_date: Date, date_of_supply: Date, request_for_invoicing_created_date?: Date | null, request_for_invoicing_submit_date?: Date | null, note?: string | null, internal_note?: string | null, text_on_invoice?: string | null, client: { __typename?: 'Client', id: string, billingEntities: Array<{ __typename?: 'BillingEntity', payment_due: number, applies_vat: boolean, id: string, internal_name: string, street: string, city: string, country: { __typename?: 'Country', id: string, code: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string } | null }> }, owner: { __typename?: 'User', id: string, full_name: string, codename?: string | null }, teams: Array<{ __typename?: 'Team', id: string }>, billingEntity: { __typename?: 'BillingEntity', id: string }, contact?: { __typename?: 'Contact', id: string } | null, projects: Array<{ __typename?: 'Project', id: string, type: ProjectTypeEnum, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, category: { __typename?: 'OurWorkBudgetCategory', id: string } }> }>, expensesWithoutOtherStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, category: { __typename?: 'ExpenseBudgetCategory', id: string } }> }> }>, currency: { __typename?: 'Currency', id: string, denomination: number, code: string }, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string } | null, orders: Array<{ __typename?: 'Order', id: string, purchase_order_no?: string | null }>, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', amount_in_currency: number, invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string, vat_percent_informative?: number | null, projects: Array<{ __typename?: 'Project', id: string }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, stats: { __typename?: 'OutgoingProformaInvoiceStats', id: string, total_amount_with_vat_in_currency: number, unused_amount_in_currency: number }, proofOfPayments?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string, summaryInvoicesForProofOfPayment?: Array<{ __typename?: 'OutgoingInvoice', id: string }> | null, stats: { __typename?: 'OutgoingInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number } }> | null } }>, invoiceItems: Array<{ __typename?: 'OutgoingInvoiceItem', description?: string | null, amount_in_currency: number, unit_price?: number | null, quantity: number, accounting_account_id?: string | null, accounting_centre_id?: string | null, tag_ids?: Array<string> | null, vat_percent_informative?: number | null }>, ourWorkBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceOurWorkBudgetSplitItem', our_work_budget_item_id: string, amount: number, amount_in_percent?: number | null }>, expenseBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceExpenseBudgetSplitItem', expense_budget_item_id: string, amount: number }>, prepaymentSplits: Array<{ __typename?: 'OutgoingInvoicePrepaymentSplitItem', brand_credit_account_id: string, amount: number, amount_left: number }>, budget_positions: Array<{ __typename?: 'BudgetPosition', uninvoiced_amount?: number | null, uninvoiced_time?: number | null, invoiced_amount?: number | null, total_invoiced_amount?: number | null, total_invoiced_time?: number | null, budgeted_amount?: number | null, budgeted_time?: number | null, title: string, time_tracking_work_type_id: string, our_work_budget_item_id?: string | null, tracked_amount?: number | null, tracked_time?: number | null, unit_amount?: number | null, quantity?: number | null }>, brands: Array<{ __typename?: 'Brand', id: string }>, filesToAttach: Array<{ __typename?: 'AssignableFile', public_id: string }>, timeMaterialsInvoiceData?: { __typename?: 'TimeMaterialsInvoiceData', project_id: string, ids?: Array<string> | null, expense_ids?: Array<string> | null, groupBy: TimeMaterialsInvoiceDataGroupByEnum, from: Date, to: Date, commission_data?: Array<{ __typename?: 'TimeMaterialsCommissionData', expense_budget_item_id: string, commission: number }> | null } | null, invoiceProofOfPayments: Array<{ __typename?: 'AttachedProofOfPaymentPivot', amount_in_currency: number, invoice: { __typename?: 'OutgoingInvoice', id: string } }>, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean } | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: Date, deleted_at?: Date | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null };

export type ProformaInvoiceFormPartsFragment = { __typename?: 'OutgoingProformaInvoice', id: string, vat_percent_informative?: number | null, vat_reverse_charge: boolean, exchange_rate: number, exchange_rate_source: ExchangeRateSource, workspace_exchange_rate: number, workspace_exchange_rate_source: ExchangeRateSource, workspace_company_id: string, workspace_bank_account_id: string, show_unit_price: boolean, show_billing_accounting: boolean, invoice_order_sequence_id: string, invoice_no: string, issue_date: Date, due_date: Date, request_for_invoicing_created_date?: Date | null, request_for_invoicing_submit_date?: Date | null, note?: string | null, internal_note?: string | null, text_on_invoice?: string | null, client: { __typename?: 'Client', id: string, billingEntities: Array<{ __typename?: 'BillingEntity', payment_due: number, applies_vat: boolean, id: string, internal_name: string, street: string, city: string, country: { __typename?: 'Country', id: string, code: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string } | null }> }, owner: { __typename?: 'User', id: string, full_name: string, codename?: string | null }, teams: Array<{ __typename?: 'Team', id: string }>, billingEntity: { __typename?: 'BillingEntity', id: string }, contact?: { __typename?: 'Contact', id: string } | null, projects: Array<{ __typename?: 'Project', id: string, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, category: { __typename?: 'OurWorkBudgetCategory', id: string } }> }>, expensesWithoutOtherStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, category: { __typename?: 'ExpenseBudgetCategory', id: string } }> }> }>, currency: { __typename?: 'Currency', id: string, denomination: number }, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string } | null, invoiceItems: Array<{ __typename?: 'OutgoingInvoiceItem', description?: string | null, amount_in_currency: number, unit_price?: number | null, quantity: number, accounting_account_id?: string | null, accounting_centre_id?: string | null, tag_ids?: Array<string> | null, vat_percent_informative?: number | null }>, ourWorkBudgetSplits?: Array<{ __typename?: 'RequestForInvoicingOurWorkBudgetSplitItem', our_work_budget_item_id?: string | null, amount?: number | null, amount_in_percent?: number | null }> | null, prepaymentSplits?: Array<{ __typename?: 'RequestForInvoicingPrepaymentSplitItem', brand_credit_account_id?: string | null, amount?: number | null }> | null, expenseBudgetSplits?: Array<{ __typename?: 'RequestForInvoicingExpenseBudgetSplitItem', expense_budget_item_id?: string | null, amount?: number | null }> | null, budget_positions: Array<{ __typename?: 'BudgetPosition', uninvoiced_amount?: number | null, uninvoiced_time?: number | null, invoiced_amount?: number | null, total_invoiced_amount?: number | null, total_invoiced_time?: number | null, budgeted_amount?: number | null, budgeted_time?: number | null, title: string, time_tracking_work_type_id: string, our_work_budget_item_id?: string | null, tracked_amount?: number | null, tracked_time?: number | null, unit_amount?: number | null, quantity?: number | null }>, brands: Array<{ __typename?: 'Brand', id: string }>, filesToAttach: Array<{ __typename?: 'AssignableFile', public_id: string }>, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: Date, deleted_at?: Date | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null };

export type RfiFormPartsFragment = { __typename?: 'RequestForInvoicing', id: string, vat_percent_informative?: number | null, vat_reverse_charge: boolean, exchange_rate: number, exchange_rate_source: ExchangeRateSource, workspace_exchange_rate: number, workspace_exchange_rate_source: ExchangeRateSource, workspace_company_id: string, workspace_bank_account_id?: string | null, show_unit_price: boolean, show_billing_accounting: boolean, credit_note_outgoing_invoice_id?: string | null, type: RequestForInvoicingTypeEnum, status: RequestForInvoicingStatusEnum, issue_date?: Date | null, due_date?: Date | null, date_of_supply?: Date | null, note?: string | null, internal_note?: string | null, text_on_invoice?: string | null, client: { __typename?: 'Client', id: string, billingEntities: Array<{ __typename?: 'BillingEntity', payment_due: number, applies_vat: boolean, id: string, internal_name: string, street: string, city: string, country: { __typename?: 'Country', id: string, code: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string } | null }> }, brands: Array<{ __typename?: 'Brand', id: string }>, owner?: { __typename?: 'User', id: string, full_name: string, codename?: string | null } | null, teams: Array<{ __typename?: 'Team', id: string }>, billingEntity?: { __typename?: 'BillingEntity', id: string } | null, contact?: { __typename?: 'Contact', id: string } | null, projects: Array<{ __typename?: 'Project', id: string, type: ProjectTypeEnum, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, category: { __typename?: 'OurWorkBudgetCategory', id: string } }> }>, expensesWithoutOtherStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, category: { __typename?: 'ExpenseBudgetCategory', id: string } }> }> }>, currency: { __typename?: 'Currency', id: string, denomination: number }, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string } | null, orders: Array<{ __typename?: 'Order', id: string, purchase_order_no?: string | null }>, proformaInvoices: Array<{ __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string, vat_percent_informative?: number | null, projects: Array<{ __typename?: 'Project', id: string }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, stats: { __typename?: 'OutgoingProformaInvoiceStats', id: string, total_amount_with_vat_in_currency: number, unused_amount_in_currency: number }, proofOfPayments?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string, summaryInvoicesForProofOfPayment?: Array<{ __typename?: 'OutgoingInvoice', id: string }> | null, stats: { __typename?: 'OutgoingInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number } }> | null }>, invoiceItems: Array<{ __typename?: 'OutgoingInvoiceItem', description?: string | null, amount_in_currency: number, unit_price?: number | null, quantity: number, accounting_account_id?: string | null, accounting_centre_id?: string | null, tag_ids?: Array<string> | null, vat_percent_informative?: number | null }>, ourWorkBudgetSplits: Array<{ __typename?: 'RequestForInvoicingOurWorkBudgetSplitItem', our_work_budget_item_id?: string | null, amount?: number | null, amount_in_percent?: number | null }>, prepaymentSplits: Array<{ __typename?: 'RequestForInvoicingPrepaymentSplitItem', brand_credit_account_id?: string | null, amount?: number | null }>, expenseBudgetSplits: Array<{ __typename?: 'RequestForInvoicingExpenseBudgetSplitItem', expense_budget_item_id?: string | null, amount?: number | null }>, budget_positions: Array<{ __typename?: 'BudgetPosition', uninvoiced_amount?: number | null, uninvoiced_time?: number | null, invoiced_amount?: number | null, total_invoiced_amount?: number | null, total_invoiced_time?: number | null, budgeted_amount?: number | null, budgeted_time?: number | null, title: string, time_tracking_work_type_id: string, our_work_budget_item_id?: string | null, tracked_amount?: number | null, tracked_time?: number | null, unit_amount?: number | null, quantity?: number | null }>, filesToAttach: Array<{ __typename?: 'AssignableFile', public_id: string }>, timeMaterialsInvoiceData?: { __typename?: 'TimeMaterialsInvoiceData', project_id: string, ids?: Array<string> | null, expense_ids?: Array<string> | null, groupBy: TimeMaterialsInvoiceDataGroupByEnum, from: Date, to: Date, commission_data?: Array<{ __typename?: 'TimeMaterialsCommissionData', expense_budget_item_id: string, commission: number }> | null } | null, proofOfPayments: Array<{ __typename?: 'OutgoingInvoice', id: string }> };

export type TimeMaterialsInvoiceDataFragmentFragment = { __typename?: 'TimeMaterialsInvoiceData', project_id: string, ids?: Array<string> | null, expense_ids?: Array<string> | null, groupBy: TimeMaterialsInvoiceDataGroupByEnum, from: Date, to: Date, commission_data?: Array<{ __typename?: 'TimeMaterialsCommissionData', expense_budget_item_id: string, commission: number }> | null };

export type BudgetPositionFragment = { __typename?: 'BudgetPosition', uninvoiced_amount?: number | null, uninvoiced_time?: number | null, invoiced_amount?: number | null, total_invoiced_amount?: number | null, total_invoiced_time?: number | null, budgeted_amount?: number | null, budgeted_time?: number | null, title: string, time_tracking_work_type_id: string, our_work_budget_item_id?: string | null, tracked_amount?: number | null, tracked_time?: number | null, unit_amount?: number | null, quantity?: number | null };

export type ProofOfPaymentFragment = { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, stats: { __typename?: 'OutgoingInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number } };

export type CreateOutgoingInvoiceMutationVariables = Exact<{
  request_for_invoicing_id: Scalars['ID']['input'];
  invoice_no?: InputMaybe<Scalars['String']['input']>;
  invoice_order_sequence_id: Scalars['ID']['input'];
  skip_date_validations: Scalars['Boolean']['input'];
}>;


export type CreateOutgoingInvoiceMutation = { __typename?: 'Mutation', createOutgoingInvoice: { __typename?: 'OutgoingInvoice', id: string } };

export type UpdateOutgoingInvoiceMutationVariables = Exact<{
  input: UpdateOutgoingInvoiceInput;
  skip_date_validations: Scalars['Boolean']['input'];
}>;


export type UpdateOutgoingInvoiceMutation = { __typename?: 'Mutation', updateOutgoingInvoice: { __typename?: 'OutgoingInvoice', id: string } };

export type CreateProformaInvoiceMutationVariables = Exact<{
  request_for_invoicing_id: Scalars['ID']['input'];
  invoice_no: Scalars['ID']['input'];
  invoice_order_sequence_id: Scalars['ID']['input'];
  skip_date_validations: Scalars['Boolean']['input'];
}>;


export type CreateProformaInvoiceMutation = { __typename?: 'Mutation', createOutgoingProformaInvoice: { __typename?: 'OutgoingProformaInvoice', id: string } };

export type UpdateProformaInvoiceMutationVariables = Exact<{
  input: UpdateOutgoingProformaInvoiceInput;
  skip_date_validations: Scalars['Boolean']['input'];
}>;


export type UpdateProformaInvoiceMutation = { __typename?: 'Mutation', updateOutgoingProformaInvoice: { __typename?: 'OutgoingProformaInvoice', id: string } };

export type CreateRequestForInvoicingMutationVariables = Exact<{
  input: CreateRequestForInvoicingInput;
  skip_date_validations: Scalars['Boolean']['input'];
}>;


export type CreateRequestForInvoicingMutation = { __typename?: 'Mutation', createRequestForInvoicing: { __typename?: 'RequestForInvoicing', id: string, workspace_bank_account_id?: string | null } };

export type UpdateRequestForInvoicingMutationVariables = Exact<{
  input: UpdateRequestForInvoicingInput;
  skip_date_validations: Scalars['Boolean']['input'];
}>;


export type UpdateRequestForInvoicingMutation = { __typename?: 'Mutation', updateRequestForInvoicing: { __typename?: 'RequestForInvoicing', id: string, workspace_bank_account_id?: string | null } };

export type BasicDataQueryVariables = Exact<{
  type?: InputMaybe<Accounting_Account_Type>;
}>;


export type BasicDataQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string, code: string }> }>, userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }>, vatRates?: Array<{ __typename?: 'VatRate', deleted: boolean, id: string, amount: number }> | null, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, accountingAccountsSimpleMap: Array<{ __typename?: 'AccountingAccount', id: string, title: string, account_number: string }>, accountingCentres: Array<{ __typename?: 'AccountingCentre', id: string, centre: string, title: string, type: Accounting_Centre_Type, deleted_at?: Date | null }>, invoicePaymentMethods: Array<{ __typename?: 'InvoicePaymentMethod', id: string, name: string }> };

export type GetTotalInWordsQueryVariables = Exact<{
  amount: Scalars['BigInt']['input'];
  language: Scalars['String']['input'];
}>;


export type GetTotalInWordsQuery = { __typename?: 'Query', getTotalInWords: string };

export type BillingEntitiesDataQueryVariables = Exact<{
  client_id: Scalars['ID']['input'];
}>;


export type BillingEntitiesDataQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, billingEntities: Array<{ __typename?: 'BillingEntity', payment_due: number, applies_vat: boolean, id: string, internal_name: string, street: string, city: string, country: { __typename?: 'Country', id: string, code: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string } | null }> } | null };

export type BrandsDataQueryVariables = Exact<{
  brand_ids: Scalars['Mixed']['input'];
  brandCount: Scalars['Int']['input'];
}>;


export type BrandsDataQuery = { __typename?: 'Query', brands?: { __typename?: 'BrandPaginator', data: Array<{ __typename?: 'Brand', id: string, name: string, defaultBillingEntity?: { __typename?: 'BillingEntity', id: string } | null, client: { __typename?: 'Client', id: string, name: string, workspaceCompany: { __typename?: 'WorkspaceCompany', vat_no?: string | null, id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | null, invoicePdfSettings?: { __typename?: 'WorkspaceCompanyInvoicePdfSettings', text_on_invoice?: string | null } | null, country?: { __typename?: 'Country', id: string } | null } }, contacts: Array<{ __typename?: 'Contact', id: string, first_name?: string | null, last_name?: string | null }>, creditAccounts?: Array<{ __typename?: 'BrandCreditAccount', id: string, title: string, stats: { __typename?: 'BrandCreditAccountStats', id: string, total_debit: number, remaining_credit: number } }> | null }> } | null };

export type BulkConvertAmountQueryVariables = Exact<{
  items: Array<AmountToConvert> | AmountToConvert;
  currency_id: Scalars['ID']['input'];
  exchange_rate: Scalars['BigInt']['input'];
  workspace_company_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BulkConvertAmountQuery = { __typename?: 'Query', bulkConvertAmountFromWorkspaceCurrencyUsingUserExchangeRates: Array<{ __typename?: 'ConvertedAmountWithIdentifier', amount: number, unit_price?: number | null, identifier: string }> };

export type DocumentsDataQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  brand_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DocumentsDataQuery = { __typename?: 'Query', otherDocumentsWithPdf: Array<{ __typename?: 'OtherDocument', id: string, brands?: Array<{ __typename?: 'Brand', id: string } | null> | null, projects?: Array<{ __typename?: 'Project', id: string } | null> | null, pdfFiles: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } }> }>, ordersWithPdf: Array<{ __typename?: 'Order', id: string, brand: { __typename?: 'Brand', id: string }, projects?: Array<{ __typename?: 'Project', id: string } | null> | null, pdfFiles: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } }> }> };

export type PdfFileFragment = { __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } };

export type OutgoingInvoiceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OutgoingInvoiceQuery = { __typename?: 'Query', outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, vat_percent_informative?: number | null, vat_reverse_charge: boolean, old_invoice_alert_while_editing: boolean, exchange_rate: number, exchange_rate_source: ExchangeRateSource, workspace_exchange_rate: number, workspace_exchange_rate_source: ExchangeRateSource, workspace_company_id: string, workspace_bank_account_id: string, show_unit_price: boolean, show_billing_accounting: boolean, type: OutgoingInvoiceTypeEnum, invoice_order_sequence_id: string, credit_note_outgoing_invoice_id?: string | null, invoice_no: string, issue_date: Date, due_date: Date, date_of_supply: Date, request_for_invoicing_created_date?: Date | null, request_for_invoicing_submit_date?: Date | null, note?: string | null, internal_note?: string | null, text_on_invoice?: string | null, client: { __typename?: 'Client', id: string, billingEntities: Array<{ __typename?: 'BillingEntity', payment_due: number, applies_vat: boolean, id: string, internal_name: string, street: string, city: string, country: { __typename?: 'Country', id: string, code: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string } | null }> }, owner: { __typename?: 'User', id: string, full_name: string, codename?: string | null }, teams: Array<{ __typename?: 'Team', id: string }>, billingEntity: { __typename?: 'BillingEntity', id: string }, contact?: { __typename?: 'Contact', id: string } | null, projects: Array<{ __typename?: 'Project', id: string, type: ProjectTypeEnum, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, category: { __typename?: 'OurWorkBudgetCategory', id: string } }> }>, expensesWithoutOtherStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, category: { __typename?: 'ExpenseBudgetCategory', id: string } }> }> }>, currency: { __typename?: 'Currency', id: string, denomination: number, code: string }, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string } | null, orders: Array<{ __typename?: 'Order', id: string, purchase_order_no?: string | null }>, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', amount_in_currency: number, invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string, vat_percent_informative?: number | null, projects: Array<{ __typename?: 'Project', id: string }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, stats: { __typename?: 'OutgoingProformaInvoiceStats', id: string, total_amount_with_vat_in_currency: number, unused_amount_in_currency: number }, proofOfPayments?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string, summaryInvoicesForProofOfPayment?: Array<{ __typename?: 'OutgoingInvoice', id: string }> | null, stats: { __typename?: 'OutgoingInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number } }> | null } }>, invoiceItems: Array<{ __typename?: 'OutgoingInvoiceItem', description?: string | null, amount_in_currency: number, unit_price?: number | null, quantity: number, accounting_account_id?: string | null, accounting_centre_id?: string | null, tag_ids?: Array<string> | null, vat_percent_informative?: number | null }>, ourWorkBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceOurWorkBudgetSplitItem', our_work_budget_item_id: string, amount: number, amount_in_percent?: number | null }>, expenseBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceExpenseBudgetSplitItem', expense_budget_item_id: string, amount: number }>, prepaymentSplits: Array<{ __typename?: 'OutgoingInvoicePrepaymentSplitItem', brand_credit_account_id: string, amount: number, amount_left: number }>, budget_positions: Array<{ __typename?: 'BudgetPosition', uninvoiced_amount?: number | null, uninvoiced_time?: number | null, invoiced_amount?: number | null, total_invoiced_amount?: number | null, total_invoiced_time?: number | null, budgeted_amount?: number | null, budgeted_time?: number | null, title: string, time_tracking_work_type_id: string, our_work_budget_item_id?: string | null, tracked_amount?: number | null, tracked_time?: number | null, unit_amount?: number | null, quantity?: number | null }>, brands: Array<{ __typename?: 'Brand', id: string }>, filesToAttach: Array<{ __typename?: 'AssignableFile', public_id: string }>, timeMaterialsInvoiceData?: { __typename?: 'TimeMaterialsInvoiceData', project_id: string, ids?: Array<string> | null, expense_ids?: Array<string> | null, groupBy: TimeMaterialsInvoiceDataGroupByEnum, from: Date, to: Date, commission_data?: Array<{ __typename?: 'TimeMaterialsCommissionData', expense_budget_item_id: string, commission: number }> | null } | null, invoiceProofOfPayments: Array<{ __typename?: 'AttachedProofOfPaymentPivot', amount_in_currency: number, invoice: { __typename?: 'OutgoingInvoice', id: string } }>, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean } | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: Date, deleted_at?: Date | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null } | null };

export type ProformaInvoiceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProformaInvoiceQuery = { __typename?: 'Query', outgoingProformaInvoice?: { __typename?: 'OutgoingProformaInvoice', id: string, vat_percent_informative?: number | null, vat_reverse_charge: boolean, exchange_rate: number, exchange_rate_source: ExchangeRateSource, workspace_exchange_rate: number, workspace_exchange_rate_source: ExchangeRateSource, workspace_company_id: string, workspace_bank_account_id: string, show_unit_price: boolean, show_billing_accounting: boolean, invoice_order_sequence_id: string, invoice_no: string, issue_date: Date, due_date: Date, request_for_invoicing_created_date?: Date | null, request_for_invoicing_submit_date?: Date | null, note?: string | null, internal_note?: string | null, text_on_invoice?: string | null, client: { __typename?: 'Client', id: string, billingEntities: Array<{ __typename?: 'BillingEntity', payment_due: number, applies_vat: boolean, id: string, internal_name: string, street: string, city: string, country: { __typename?: 'Country', id: string, code: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string } | null }> }, owner: { __typename?: 'User', id: string, full_name: string, codename?: string | null }, teams: Array<{ __typename?: 'Team', id: string }>, billingEntity: { __typename?: 'BillingEntity', id: string }, contact?: { __typename?: 'Contact', id: string } | null, projects: Array<{ __typename?: 'Project', id: string, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, category: { __typename?: 'OurWorkBudgetCategory', id: string } }> }>, expensesWithoutOtherStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, category: { __typename?: 'ExpenseBudgetCategory', id: string } }> }> }>, currency: { __typename?: 'Currency', id: string, denomination: number }, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string } | null, invoiceItems: Array<{ __typename?: 'OutgoingInvoiceItem', description?: string | null, amount_in_currency: number, unit_price?: number | null, quantity: number, accounting_account_id?: string | null, accounting_centre_id?: string | null, tag_ids?: Array<string> | null, vat_percent_informative?: number | null }>, ourWorkBudgetSplits?: Array<{ __typename?: 'RequestForInvoicingOurWorkBudgetSplitItem', our_work_budget_item_id?: string | null, amount?: number | null, amount_in_percent?: number | null }> | null, prepaymentSplits?: Array<{ __typename?: 'RequestForInvoicingPrepaymentSplitItem', brand_credit_account_id?: string | null, amount?: number | null }> | null, expenseBudgetSplits?: Array<{ __typename?: 'RequestForInvoicingExpenseBudgetSplitItem', expense_budget_item_id?: string | null, amount?: number | null }> | null, budget_positions: Array<{ __typename?: 'BudgetPosition', uninvoiced_amount?: number | null, uninvoiced_time?: number | null, invoiced_amount?: number | null, total_invoiced_amount?: number | null, total_invoiced_time?: number | null, budgeted_amount?: number | null, budgeted_time?: number | null, title: string, time_tracking_work_type_id: string, our_work_budget_item_id?: string | null, tracked_amount?: number | null, tracked_time?: number | null, unit_amount?: number | null, quantity?: number | null }>, brands: Array<{ __typename?: 'Brand', id: string }>, filesToAttach: Array<{ __typename?: 'AssignableFile', public_id: string }>, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: Date, deleted_at?: Date | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null } | null };

export type ProjectsDataQueryVariables = Exact<{
  project_ids: Scalars['Mixed']['input'];
  projectsCount: Scalars['Int']['input'];
}>;


export type ProjectsDataQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectPaginator', data: Array<{ __typename?: 'Project', id: string, title: string, code: string, start_date: Date, finished_at?: Date | null, archived_at?: Date | null, billable: boolean, status: ProjectStatusEnum, type: ProjectTypeEnum, projectManager: { __typename?: 'User', id: string }, contact?: { __typename?: 'Contact', id: string } | null, team: { __typename?: 'Team', id: string, name: string }, brand: { __typename?: 'Brand', id: string }, stats?: { __typename?: 'ProjectStats', id: string, credit: number, uninvoiced: number } | null, lastInvoice?: { __typename?: 'ProjectInvoiceStat', outgoing_invoice_date: Date, outgoingInvoice: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, type: OutgoingInvoiceTypeEnum } } | null, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', id: string, name: string, total_budget: number, budget_category_id: string, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, completed_at?: Date | null, requested_for_deletion_at?: Date | null, vat_percent_informative?: number | null, creditAccount: { __typename?: 'CreditAccount', id: string }, stats: { __typename?: 'OurWorkBudgetItemStats', total_budget: number, credit: number, uninvoiced: number }, budget_positions: Array<{ __typename?: 'BudgetPosition', uninvoiced_amount?: number | null, uninvoiced_time?: number | null, invoiced_amount?: number | null, total_invoiced_amount?: number | null, total_invoiced_time?: number | null, budgeted_amount?: number | null, budgeted_time?: number | null, title: string, time_tracking_work_type_id: string, our_work_budget_item_id?: string | null, tracked_amount?: number | null, tracked_time?: number | null, unit_amount?: number | null, quantity?: number | null }>, tasks: Array<{ __typename?: 'Task', id: string, name: string, positionsSpent: Array<{ __typename?: 'PositionSpent', spent: number, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', title: string } } | null>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', stats: { __typename?: 'OurWorkBudgetItemStats', spent_budget: number } } | null }> }> }>, expensesWithoutOtherStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, name: string, total_budget: number, budget_category_id: string, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, completed_at?: Date | null, requested_for_deletion_at?: Date | null, vat_percent_informative?: number | null, stats: { __typename?: 'ExpenseBudgetItemStats', total_budget: number, credit: number, uninvoiced: number, real_expenses: number, real_commission: number, real_commission_relative: string, planned_expenses: number, planned_commission: number, planned_commission_relative_computed: string } }> }>, ordersSimpleMap: Array<{ __typename?: 'OrderSimple', id: string, purchase_order_no?: string | null }> }> } | null };

export type RequestForInvoicingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RequestForInvoicingQuery = { __typename?: 'Query', requestForInvoicing?: { __typename?: 'RequestForInvoicing', id: string, vat_percent_informative?: number | null, vat_reverse_charge: boolean, exchange_rate: number, exchange_rate_source: ExchangeRateSource, workspace_exchange_rate: number, workspace_exchange_rate_source: ExchangeRateSource, workspace_company_id: string, workspace_bank_account_id?: string | null, show_unit_price: boolean, show_billing_accounting: boolean, credit_note_outgoing_invoice_id?: string | null, type: RequestForInvoicingTypeEnum, status: RequestForInvoicingStatusEnum, issue_date?: Date | null, due_date?: Date | null, date_of_supply?: Date | null, note?: string | null, internal_note?: string | null, text_on_invoice?: string | null, client: { __typename?: 'Client', id: string, billingEntities: Array<{ __typename?: 'BillingEntity', payment_due: number, applies_vat: boolean, id: string, internal_name: string, street: string, city: string, country: { __typename?: 'Country', id: string, code: string }, defaultCurrency: { __typename?: 'Currency', id: string, code: string }, workspaceCompany: { __typename?: 'WorkspaceCompany', id: string }, workspaceBankAccount?: { __typename?: 'WorkspaceBankAccount', id: string } | null }> }, brands: Array<{ __typename?: 'Brand', id: string }>, owner?: { __typename?: 'User', id: string, full_name: string, codename?: string | null } | null, teams: Array<{ __typename?: 'Team', id: string }>, billingEntity?: { __typename?: 'BillingEntity', id: string } | null, contact?: { __typename?: 'Contact', id: string } | null, projects: Array<{ __typename?: 'Project', id: string, type: ProjectTypeEnum, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, category: { __typename?: 'OurWorkBudgetCategory', id: string } }> }>, expensesWithoutOtherStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, category: { __typename?: 'ExpenseBudgetCategory', id: string } }> }> }>, currency: { __typename?: 'Currency', id: string, denomination: number }, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string } | null, orders: Array<{ __typename?: 'Order', id: string, purchase_order_no?: string | null }>, proformaInvoices: Array<{ __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string, vat_percent_informative?: number | null, projects: Array<{ __typename?: 'Project', id: string }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, stats: { __typename?: 'OutgoingProformaInvoiceStats', id: string, total_amount_with_vat_in_currency: number, unused_amount_in_currency: number }, proofOfPayments?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string, summaryInvoicesForProofOfPayment?: Array<{ __typename?: 'OutgoingInvoice', id: string }> | null, stats: { __typename?: 'OutgoingInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number } }> | null }>, invoiceItems: Array<{ __typename?: 'OutgoingInvoiceItem', description?: string | null, amount_in_currency: number, unit_price?: number | null, quantity: number, accounting_account_id?: string | null, accounting_centre_id?: string | null, tag_ids?: Array<string> | null, vat_percent_informative?: number | null }>, ourWorkBudgetSplits: Array<{ __typename?: 'RequestForInvoicingOurWorkBudgetSplitItem', our_work_budget_item_id?: string | null, amount?: number | null, amount_in_percent?: number | null }>, prepaymentSplits: Array<{ __typename?: 'RequestForInvoicingPrepaymentSplitItem', brand_credit_account_id?: string | null, amount?: number | null }>, expenseBudgetSplits: Array<{ __typename?: 'RequestForInvoicingExpenseBudgetSplitItem', expense_budget_item_id?: string | null, amount?: number | null }>, budget_positions: Array<{ __typename?: 'BudgetPosition', uninvoiced_amount?: number | null, uninvoiced_time?: number | null, invoiced_amount?: number | null, total_invoiced_amount?: number | null, total_invoiced_time?: number | null, budgeted_amount?: number | null, budgeted_time?: number | null, title: string, time_tracking_work_type_id: string, our_work_budget_item_id?: string | null, tracked_amount?: number | null, tracked_time?: number | null, unit_amount?: number | null, quantity?: number | null }>, filesToAttach: Array<{ __typename?: 'AssignableFile', public_id: string }>, timeMaterialsInvoiceData?: { __typename?: 'TimeMaterialsInvoiceData', project_id: string, ids?: Array<string> | null, expense_ids?: Array<string> | null, groupBy: TimeMaterialsInvoiceDataGroupByEnum, from: Date, to: Date, commission_data?: Array<{ __typename?: 'TimeMaterialsCommissionData', expense_budget_item_id: string, commission: number }> | null } | null, proofOfPayments: Array<{ __typename?: 'OutgoingInvoice', id: string }> } | null };

export type UnusedPaidProformaInvoicesQueryVariables = Exact<{
  project_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UnusedPaidProformaInvoicesQuery = { __typename?: 'Query', unusedPaidOutgoingProformaInvoices: Array<{ __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string, vat_percent_informative?: number | null, projects: Array<{ __typename?: 'Project', id: string }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, stats: { __typename?: 'OutgoingProformaInvoiceStats', id: string, total_amount_with_vat_in_currency: number, unused_amount_in_currency: number }, proofOfPayments?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string, summaryInvoicesForProofOfPayment?: Array<{ __typename?: 'OutgoingInvoice', id: string }> | null, stats: { __typename?: 'OutgoingInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number } }> | null }> };

export type ProformaInvoiceOptionsFragment = { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string, vat_percent_informative?: number | null, projects: Array<{ __typename?: 'Project', id: string }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, stats: { __typename?: 'OutgoingProformaInvoiceStats', id: string, total_amount_with_vat_in_currency: number, unused_amount_in_currency: number }, proofOfPayments?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string, summaryInvoicesForProofOfPayment?: Array<{ __typename?: 'OutgoingInvoice', id: string }> | null, stats: { __typename?: 'OutgoingInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number } }> | null };

export type OrdersQueryVariables = Exact<{
  filters?: InputMaybe<OrderQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrdersQuery = { __typename?: 'Query', orders?: { __typename?: 'OrderPaginator', data: Array<{ __typename?: 'Order', id: string, purchase_order_no?: string | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type OutgoingInvoiceDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OutgoingInvoiceDetailQuery = { __typename?: 'Query', outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, paid_at?: Date | null, exchange_rate: number, type: OutgoingInvoiceTypeEnum, invoice_no: string, issue_date: Date, due_date: Date, date_of_supply: Date, request_for_invoicing_created_date?: Date | null, request_for_invoicing_submit_date?: Date | null, note?: string | null, internal_note?: string | null, text_on_invoice?: string | null, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, amount: number, exchange_rate: number, date: Date, document_currency: { __typename?: 'Currency', code: string, denomination: number }, bankAccountMove?: { __typename?: 'BankAccountMove', id: string, bank_account_id?: string | null, amount: number, note: string, reference: string, vs?: string | null, ss?: string | null, ks?: string | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: Date, balance: number, iban?: string | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: Date, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | null } | null }> | null, teams: Array<{ __typename?: 'Team', name: string }>, brands: Array<{ __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, creditAccounts?: Array<{ __typename?: 'BrandCreditAccount', id: string, title: string }> | null }>, billingEntity: { __typename?: 'BillingEntity', city: string, legal_name: string, street: string, zip: string, invoice_email?: string | null, registration_no?: string | null, tax_no?: string | null, vat_no?: string | null, country: { __typename?: 'Country', id: string, name: string } }, contact?: { __typename?: 'Contact', first_name?: string | null, last_name?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, currency: { __typename?: 'Currency', id: string, denomination: number, code: string }, invoiceItems: Array<{ __typename?: 'OutgoingInvoiceItem', id: string, description?: string | null, amount_in_currency: number, vat_percent_informative?: number | null }>, orders: Array<{ __typename?: 'Order', id: string, purchase_order_no?: string | null, urls: { __typename?: 'MediaUrlList', preview?: string | null } }>, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', amount_in_currency: number, invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } }>, relatesToOutgoingProformaInvoice?: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } | null, stats: { __typename?: 'OutgoingInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number, total_vat_in_currency: number, vat_percent_informative?: number | null, total_amount_with_vat_in_currency_to_pay: number, total_amount_with_vat_in_currency_to_pay_from_proforma_payments: number }, ourWorkBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceOurWorkBudgetSplitItem', our_work_budget_item_id: string, amount: number, amount_in_percent?: number | null }>, expenseBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceExpenseBudgetSplitItem', expense_budget_item_id: string, amount: number }>, prepaymentSplits: Array<{ __typename?: 'OutgoingInvoicePrepaymentSplitItem', brand_credit_account_id: string, amount: number }>, projects: Array<{ __typename?: 'Project', id: string, code: string, title: string, team: { __typename?: 'Team', id: string, name: string }, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', id: string, name: string, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, stats: { __typename?: 'OurWorkBudgetItemStats', total_budget: number, credit: number, uninvoiced: number } }> }>, expensesStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, name: string, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, completed_at?: Date | null, stats: { __typename?: 'ExpenseBudgetItemStats', total_budget: number, real_expenses: number, planned_expenses: number, credit: number, real_commission: number, real_commission_relative: string, planned_commission: number, planned_commission_relative_computed: string } }> }> }>, filesToAttach: Array<{ __typename?: 'AssignableFile', public_id: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', original?: string | null } }>, invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | null, download?: string | null } | null, invoiceProofOfPayments: Array<{ __typename?: 'AttachedProofOfPaymentPivot', invoice: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string } }>, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, date_from: Date, date_to: Date, project: { __typename?: 'Project', id: string, title: string, code: string, numeric_code?: string | null } } | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: Date, deleted_at?: Date | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string, name: string } | null } | null };

export type ProformaInvoiceDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProformaInvoiceDetailQuery = { __typename?: 'Query', outgoingProformaInvoice?: { __typename?: 'OutgoingProformaInvoice', id: string, paid_at?: Date | null, exchange_rate: number, invoice_no: string, issue_date: Date, due_date: Date, request_for_invoicing_created_date?: Date | null, request_for_invoicing_submit_date?: Date | null, note?: string | null, internal_note?: string | null, text_on_invoice?: string | null, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, amount: number, exchange_rate: number, date: Date, document_currency: { __typename?: 'Currency', code: string, denomination: number }, bankAccountMove?: { __typename?: 'BankAccountMove', id: string, bank_account_id?: string | null, amount: number, note: string, reference: string, vs?: string | null, ss?: string | null, ks?: string | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: Date, balance: number, iban?: string | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: Date, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | null } | null }> | null, teams: Array<{ __typename?: 'Team', name: string }>, brands: Array<{ __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, creditAccounts?: Array<{ __typename?: 'BrandCreditAccount', id: string, title: string }> | null }>, billingEntity: { __typename?: 'BillingEntity', city: string, legal_name: string, street: string, zip: string, invoice_email?: string | null, registration_no?: string | null, tax_no?: string | null, vat_no?: string | null, country: { __typename?: 'Country', id: string, name: string } }, contact?: { __typename?: 'Contact', first_name?: string | null, last_name?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, invoiceItems: Array<{ __typename?: 'OutgoingInvoiceItem', id: string, description?: string | null, amount_in_currency: number, vat_percent_informative?: number | null }>, stats: { __typename?: 'OutgoingProformaInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number, total_vat_in_currency: number, vat_percent_informative?: number | null, unused_amount_in_currency: number, unused_amount: number }, projects: Array<{ __typename?: 'Project', id: string, code: string, title: string, team: { __typename?: 'Team', id: string, name: string }, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', id: string, name: string, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, stats: { __typename?: 'OurWorkBudgetItemStats', total_budget: number, credit: number, uninvoiced: number } }> }>, expensesStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, name: string, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, completed_at?: Date | null, stats: { __typename?: 'ExpenseBudgetItemStats', total_budget: number, real_expenses: number, planned_expenses: number, credit: number, real_commission: number, real_commission_relative: string, planned_commission: number, planned_commission_relative_computed: string } }> }> }>, filesToAttach: Array<{ __typename?: 'AssignableFile', public_id: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', original?: string | null } }>, invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | null, download?: string | null } | null, proofOfPayments?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string }> | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: Date, deleted_at?: Date | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string, name: string } | null } | null };

export type EmailDataFragment = { __typename?: 'InvoiceEmailData', id: string, recipients: Array<string | null>, subject: string, content: string, attachments?: Array<{ __typename?: 'InvoiceEmailDataAttachment', id: string, link: string, name: string, required: boolean } | null> | null };

export type EmailLogFragment = { __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: Date, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | null };

export type OutgoingInvoiceCorePartsFragment = { __typename?: 'OutgoingInvoice', type: OutgoingInvoiceTypeEnum, invoice_no: string, issue_date: Date, due_date: Date, date_of_supply: Date, request_for_invoicing_created_date?: Date | null, request_for_invoicing_submit_date?: Date | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } };

export type OutgoingInvoiceNotePartsFragment = { __typename?: 'OutgoingInvoice', note?: string | null, internal_note?: string | null, text_on_invoice?: string | null };

export type ProformaInvoiceCorePartsFragment = { __typename?: 'OutgoingProformaInvoice', invoice_no: string, issue_date: Date, due_date: Date, request_for_invoicing_created_date?: Date | null, request_for_invoicing_submit_date?: Date | null };

export type ProformaInvoiceNotePartsFragment = { __typename?: 'OutgoingProformaInvoice', note?: string | null, internal_note?: string | null, text_on_invoice?: string | null };

export type DeleteOutgoingProformaInvoiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOutgoingProformaInvoiceMutation = { __typename?: 'Mutation', deleteOutgoingProformaInvoice: boolean };

export type MarkProformaAsPaidMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
  create_summary_invoice?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MarkProformaAsPaidMutation = { __typename?: 'Mutation', markOutgoingProformaInvoiceAsPaid: { __typename?: 'OutgoingProformaInvoice', id: string } };

export type MarkProformaAsUnpaidMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  remove_matched_payments?: Scalars['Boolean']['input'];
}>;


export type MarkProformaAsUnpaidMutation = { __typename?: 'Mutation', markOutgoingProformaInvoiceAsUnpaid: { __typename?: 'OutgoingProformaInvoice', id: string, paid_at?: Date | null } };

export type SendProformaMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SendProformaMutation = { __typename?: 'Mutation', sendOutgoingProformaInvoice: boolean };

export type SendProformaBulkMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SendProformaBulkMutation = { __typename?: 'Mutation', sendOutgoingProformaInvoiceBulk: boolean };

export type SendOutgoingProformaMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  subject?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type SendOutgoingProformaMutation = { __typename?: 'Mutation', sendOutgoingProformaInvoice: boolean };

export type BulkDownloadProformaInvoicesQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkDownloadProformaInvoicesQuery = { __typename?: 'Query', bulkDownloadOutgoingProformaInvoices?: string | null };

export type GetProformaEmailDataQueryVariables = Exact<{
  proforma_invoice_id: Scalars['ID']['input'];
}>;


export type GetProformaEmailDataQuery = { __typename?: 'Query', getProformaInvoiceEmailData?: { __typename?: 'InvoiceEmailData', id: string, recipients: Array<string | null>, subject: string, content: string, attachments?: Array<{ __typename?: 'InvoiceEmailDataAttachment', id: string, link: string, name: string, required: boolean } | null> | null } | null };

export type ProformaInvoicesOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProformaInvoicesOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string, code: string }> }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | null }> };

export type ProformaInvoicesTableDataQueryVariables = Exact<{
  filters?: InputMaybe<OiProformaQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProformaInvoicesTableDataQuery = { __typename?: 'Query', outgoingProformaInvoices?: { __typename?: 'OutgoingProformaInvoicePaginator', data: Array<{ __typename?: 'OutgoingProformaInvoice', id: string, abraflexi_exported?: boolean | null, paid_at?: Date | null, note?: string | null, internal_note?: string | null, workspace_company_id: string, exchange_rate: number, invoice_no: string, issue_date: Date, due_date: Date, request_for_invoicing_created_date?: Date | null, request_for_invoicing_submit_date?: Date | null, documentExports: Array<{ __typename?: 'DocumentExport', type: string, exported_at: Date }>, summaryInvoices?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string }> | null, invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | null, download?: string | null } | null, proofOfPayments?: Array<{ __typename?: 'OutgoingInvoice', id: string, invoice_no: string, invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | null, download?: string | null } | null }> | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number }, owner: { __typename?: 'User', id: string }, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }>, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: Date, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | null }>, stats: { __typename?: 'OutgoingProformaInvoiceStats', total_amount_in_currency: number, total_amount_with_vat_in_currency: number, unused_amount_in_currency: number }, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, amount: number, amount_in_move_currency: number, bank_account_move_id: string, exchange_rate: number, bankAccountMove?: { __typename?: 'BankAccountMove', id: string, bank_account_id?: string | null, amount: number, note: string, reference: string, vs?: string | null, ss?: string | null, ks?: string | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: Date, balance: number, iban?: string | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: Date, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | null } | null }> | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: Date, deleted_at?: Date | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string, name: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type ProformaInvoicesTableSummaryQueryVariables = Exact<{
  filters?: InputMaybe<OiProformaQueryArgs>;
}>;


export type ProformaInvoicesTableSummaryQuery = { __typename?: 'Query', outgoingProformaInvoicesSummary: { __typename?: 'OutgoingProformaInvoicesSummary', outgoingInvoiceIds: Array<string>, invoices: number, total_amount: number, total_amount_with_vat: number, payments_due: number, overdue_by_less_than_30_days: number, overdue_by_31_to_90_days: number, overdue_by_91_to_365_days: number, overdue_by_more_than_365_days: number } };

export type ProformaOmegaExportQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ProformaOmegaExportQuery = { __typename?: 'Query', omegaProformaExport?: string | null };

export type ProformaPohodaExportQueryVariables = Exact<{
  outgoingProformaInvoiceIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ProformaPohodaExportQuery = { __typename?: 'Query', pohodaOPIExport?: string | null };

export type ProformaPremierExportQueryVariables = Exact<{
  outgoing_proforma_invoice_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ProformaPremierExportQuery = { __typename?: 'Query', premierProformaOIExport?: string | null };

export type RequestForInvoicingCorePartsFragment = { __typename?: 'RequestForInvoicing', type: RequestForInvoicingTypeEnum, status: RequestForInvoicingStatusEnum, issue_date?: Date | null, due_date?: Date | null, date_of_supply?: Date | null };

export type RequestForInvoicingNotePartsFragment = { __typename?: 'RequestForInvoicing', note?: string | null, internal_note?: string | null, text_on_invoice?: string | null };

export type DeleteRequestForInvoicingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRequestForInvoicingMutation = { __typename?: 'Mutation', deleteRequestForInvoicing: { __typename?: 'RequestForInvoicing', id: string } };

export type SubmitRequestForInvoicingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SubmitRequestForInvoicingMutation = { __typename?: 'Mutation', submitRequestForInvoicing: { __typename?: 'RequestForInvoicing', id: string } };

export type DeleteRequestsForInvoicingBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteRequestsForInvoicingBulkMutation = { __typename?: 'Mutation', deleteRequestsForInvoicingBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type SubmitRequestsForInvoicingBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SubmitRequestsForInvoicingBulkMutation = { __typename?: 'Mutation', submitRequestsForInvoicingBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type GetRequestsForInvoicingQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<RequestForInvoicingQueryArgs>;
}>;


export type GetRequestsForInvoicingQuery = { __typename?: 'Query', requestsForInvoicingSummary: { __typename?: 'RequestsForInvoicingSummary', requestForInvoicingIds: Array<string> }, requestsForInvoicing?: { __typename?: 'RequestForInvoicingPaginator', data: Array<{ __typename?: 'RequestForInvoicing', id: string, type: RequestForInvoicingTypeEnum, status: RequestForInvoicingStatusEnum, date_of_supply?: Date | null, created_at: Date, submit_date?: Date | null, note?: string | null, internal_note?: string | null, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, stats: { __typename?: 'RequestForInvoicingStats', total_amount: number, total_amount_with_vat: number }, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }>, owner?: { __typename?: 'User', id: string } | null, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string, name: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetRequestsForInvoicingSummaryQueryVariables = Exact<{
  filters?: InputMaybe<RequestForInvoicingQueryArgs>;
}>;


export type GetRequestsForInvoicingSummaryQuery = { __typename?: 'Query', requestsForInvoicingSummary: { __typename?: 'RequestsForInvoicingSummary', requestForInvoicingIds: Array<string> } };

export type RequestsForInvoicingFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type RequestsForInvoicingFiltersQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | null }>, brandsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }> };

export type InvoiceBudgetItemListItemFragment = { __typename?: 'OIBudgetItemForTimeBilling', outgoing_invoice_id: string, budget_item_id: string, budget_item_type: BudgetItemTypeEnum, amount: number, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null, outgoingInvoice: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: Date, date_of_supply: Date, due_date: Date, paid_at?: Date | null, payment_status: PaymentStatusEnum, type: OutgoingInvoiceTypeEnum, note?: string | null, internal_note?: string | null, text_on_invoice?: string | null, abraflexi_exported?: boolean | null, xero_exported?: boolean | null, has_proforma_payments: boolean, workspace_company_id: string, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } }>, currency: { __typename?: 'Currency', code: string, denomination: number }, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', amount_in_move_currency: number }> | null, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string }, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }>, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string, name: string } | null, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean, title?: string | null, project: { __typename?: 'Project', id: string } } | null, documentExports: Array<{ __typename?: 'DocumentExport', id: string, type: string, exported_at: Date }>, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: Date, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | null }>, ourWorkBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceOurWorkBudgetSplitItem', id: string, amount: number }>, expenseBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceExpenseBudgetSplitItem', id: string, amount: number }> } };

export type OutgoingInvoiceItemsListingQueryVariables = Exact<{
  filters?: InputMaybe<OiBudgetItemsTimeBillingQueryArgs>;
}>;


export type OutgoingInvoiceItemsListingQuery = { __typename?: 'Query', oiBudgetItemsForTimeBilling: { __typename?: 'OIBudgetItemsForTimeBillingPaginator', data: Array<{ __typename?: 'OIBudgetItemForTimeBilling', outgoing_invoice_id: string, budget_item_id: string, budget_item_type: BudgetItemTypeEnum, amount: number, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null, outgoingInvoice: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: Date, date_of_supply: Date, due_date: Date, paid_at?: Date | null, payment_status: PaymentStatusEnum, type: OutgoingInvoiceTypeEnum, note?: string | null, internal_note?: string | null, text_on_invoice?: string | null, abraflexi_exported?: boolean | null, xero_exported?: boolean | null, has_proforma_payments: boolean, workspace_company_id: string, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } }>, currency: { __typename?: 'Currency', code: string, denomination: number }, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', amount_in_move_currency: number }> | null, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string }, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }>, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string, name: string } | null, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean, title?: string | null, project: { __typename?: 'Project', id: string } } | null, documentExports: Array<{ __typename?: 'DocumentExport', id: string, type: string, exported_at: Date }>, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: Date, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | null }>, ourWorkBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceOurWorkBudgetSplitItem', id: string, amount: number }>, expenseBudgetSplits: Array<{ __typename?: 'OutgoingInvoiceExpenseBudgetSplitItem', id: string, amount: number }> } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type OutgoingInvoiceItemsListingSummaryQueryVariables = Exact<{
  filters?: InputMaybe<OiBudgetItemsTimeBillingQueryArgs>;
}>;


export type OutgoingInvoiceItemsListingSummaryQuery = { __typename?: 'Query', oiBudgetItemsForTimeBillingSummary: { __typename?: 'TimeBillingSummary', count: number, amount: number } };

export type OutgoingInvoiceItemsListingFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OutgoingInvoiceItemsListingFilterOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string }>, projectCategories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }> };

export type OutgoingInvoiceItemsListingBudgetItemFilterOptionsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type OutgoingInvoiceItemsListingBudgetItemFilterOptionsQuery = { __typename?: 'Query', ourWorkBudgetItemsSimpleMap: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string } }>, expenseBudgetItemsSimpleMap: Array<{ __typename?: 'ExpenseBudgetItemSimple', id: string, title: string, category: { __typename?: 'ExpenseBudgetCategory', name: string } }> };

export type MarkOutgoingInvoiceAsPaidMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
}>;


export type MarkOutgoingInvoiceAsPaidMutation = { __typename?: 'Mutation', markOutgoingInvoiceAsPaid: { __typename?: 'OutgoingInvoice', id: string } };

export type MarkOutgoingInvoiceAsUnpaidMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  remove_matched_payments?: Scalars['Boolean']['input'];
}>;


export type MarkOutgoingInvoiceAsUnpaidMutation = { __typename?: 'Mutation', markOutgoingInvoiceAsUnpaid: { __typename?: 'OutgoingInvoice', id: string, paid_at?: Date | null } };

export type MarkOutgoingInvoiceAsPaidBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
}>;


export type MarkOutgoingInvoiceAsPaidBulkMutation = { __typename?: 'Mutation', markOutgoingInvoiceAsPaidBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type SendOutgoingInvoiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  subject?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type SendOutgoingInvoiceMutation = { __typename?: 'Mutation', sendOutgoingInvoice: boolean };

export type SendOutgoingInvoiceBulkMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SendOutgoingInvoiceBulkMutation = { __typename?: 'Mutation', sendOutgoingInvoiceBulk: boolean };

export type UpdateOutgoingInvoiceNumberMutationVariables = Exact<{
  input?: InputMaybe<UpdateOutgoingInvoiceNumberInput>;
}>;


export type UpdateOutgoingInvoiceNumberMutation = { __typename?: 'Mutation', updateOutgoingInvoiceNumber: { __typename?: 'OutgoingInvoice', id: string } };

export type DeleteOutgoingInvoiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOutgoingInvoiceMutation = { __typename?: 'Mutation', deleteOutgoingInvoice: boolean };

export type GetOutgoingInvoicesFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOutgoingInvoicesFilterOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | null }>, projectCategories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, code: string, title: string }> };

export type GetInvoiceEmailDataQueryVariables = Exact<{
  outgoing_invoice_id: Scalars['ID']['input'];
}>;


export type GetInvoiceEmailDataQuery = { __typename?: 'Query', getInvoiceEmailData?: { __typename?: 'InvoiceEmailData', id: string, recipients: Array<string | null>, subject: string, content: string, attachments?: Array<{ __typename?: 'InvoiceEmailDataAttachment', id: string, link: string, name: string, required: boolean } | null> | null } | null };

export type GetOutgoingInvoiceSuggestedNumberQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetOutgoingInvoiceSuggestedNumberQuery = { __typename?: 'Query', outgoingInvoice?: { __typename?: 'OutgoingInvoice', sequence?: { __typename?: 'Sequence', next_invoice_no: string } | null } | null };

export type GetOutgoingInvoicesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<OiQueryArgs>;
}>;


export type GetOutgoingInvoicesQuery = { __typename?: 'Query', outgoingInvoices?: { __typename?: 'OutgoingInvoicePaginator', data: Array<{ __typename?: 'OutgoingInvoice', id: string, paid_at?: Date | null, note?: string | null, internal_note?: string | null, abraflexi_exported?: boolean | null, xero_exported?: boolean | null, workspace_company_id: string, exchange_rate: number, has_proforma_payments: boolean, type: OutgoingInvoiceTypeEnum, invoice_no: string, issue_date: Date, due_date: Date, date_of_supply: Date, request_for_invoicing_created_date?: Date | null, request_for_invoicing_submit_date?: Date | null, documentExports: Array<{ __typename?: 'DocumentExport', type: string, exported_at: Date }>, invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | null, download?: string | null } | null, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } }>, relatesToOutgoingProformaInvoice?: { __typename?: 'OutgoingProformaInvoice', id: string, invoicePdf?: { __typename?: 'MediaUrlList', preview?: string | null, download?: string | null } | null } | null, owner: { __typename?: 'User', id: string, email: string }, contact?: { __typename?: 'Contact', email?: string | null } | null, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, billingEntity: { __typename?: 'BillingEntity', invoice_email?: string | null, internal_name: string, street: string, city: string }, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }>, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: Date, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | null }>, stats: { __typename?: 'OutgoingInvoiceStats', total_amount: number, total_amount_with_vat: number, total_amount_in_currency: number, total_amount_with_vat_in_currency: number, billing_amount: number, billing_amount_with_vat: number }, accountMoves?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, amount: number, amount_in_move_currency: number, exchange_rate: number, bankAccountMove?: { __typename?: 'BankAccountMove', id: string, bank_account_id?: string | null, amount: number, note: string, reference: string, vs?: string | null, ss?: string | null, ks?: string | null, status: BankAccountMoveStatusEnum, type: BankAccountMoveTypeEnum, date: Date, balance: number, iban?: string | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | null }, documents?: Array<{ __typename?: 'BankAccountMoveDocument', id: string, bank_account_move_id: string, document_id: string, document_type: BankDocumentTypeEnum, document_no: string, amount: number, date: Date, exchange_rate: number, document_currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }> | null } | null }> | null, projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, is_locked: boolean } | null, modelLock?: { __typename?: 'ModelLock', id: string, locked_at: Date, deleted_at?: Date | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null, invoicePaymentMethod?: { __typename?: 'InvoicePaymentMethod', id: string, name: string } | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetOutgoingInvoicePrepaymentSplitsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOutgoingInvoicePrepaymentSplitsQuery = { __typename?: 'Query', outgoingInvoice?: { __typename?: 'OutgoingInvoice', prepaymentSplits: Array<{ __typename?: 'OutgoingInvoicePrepaymentSplitItem', id: string, brandCreditAccount?: { __typename?: 'BrandCreditAccount', id: string, title: string } | null }> } | null };

export type CfExportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type CfExportQuery = { __typename?: 'Query', cfExport: string };

export type NotPaidOiExportQueryVariables = Exact<{
  filters?: InputMaybe<OiQueryArgs>;
  date?: InputMaybe<Scalars['Date']['input']>;
}>;


export type NotPaidOiExportQuery = { __typename?: 'Query', notPaidOIExport: string };

export type ClientOiExportQueryVariables = Exact<{
  filters?: InputMaybe<OiQueryArgs>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ClientOiExportQuery = { __typename?: 'Query', clientOIExport: string };

export type MrpOiExportQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type MrpOiExportQuery = { __typename?: 'Query', mrpOIExport: string };

export type PohodaOiExportQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PohodaOiExportQuery = { __typename?: 'Query', pohodaOIExport?: string | null };

export type PremierOiExportQueryVariables = Exact<{
  outgoing_invoice_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PremierOiExportQuery = { __typename?: 'Query', premierOIExport?: string | null };

export type ProlucOiExportQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type ProlucOiExportQuery = { __typename?: 'Query', prolucOIExport?: string | null };

export type BulkDownloadOutgoingInvoicesQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkDownloadOutgoingInvoicesQuery = { __typename?: 'Query', bulkDownloadOutgoingInvoices?: string | null };

export type VarioOiExportQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type VarioOiExportQuery = { __typename?: 'Query', varioOIExport?: string | null };

export type OutgoingInvoiceOmegaExportQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OutgoingInvoiceOmegaExportQuery = { __typename?: 'Query', omegaExport?: string | null };

export type OutgoingInvoiceAbraFlexiExportQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OutgoingInvoiceAbraFlexiExportQuery = { __typename?: 'Query', abraFlexiOIExport?: string | null };

export type OutgoingInvoicesTableSummaryQueryVariables = Exact<{
  filters?: InputMaybe<OiQueryArgs>;
}>;


export type OutgoingInvoicesTableSummaryQuery = { __typename?: 'Query', outgoingInvoicesSummary: { __typename?: 'OutgoingInvoicesSummary', outgoingInvoiceIds: Array<string>, total_amount: number, total_vat: number, total_amount_with_vat: number, billing_amount: number, billing_amount_vat: number, billing_amount_with_vat: number, paid_amount: number, unpaid_amount: number, payments_due_without_vat: number, payments_due_vat: number, payments_due: number, overdue: number, overdue_vat: number, overdue_without_vat: number, overdue_by_less_than_30_days_without_vat: number, overdue_by_less_than_30_days_vat: number, overdue_by_less_than_30_days: number, overdue_by_31_to_90_days_without_vat: number, overdue_by_31_to_90_days_vat: number, overdue_by_31_to_90_days: number, overdue_by_91_to_365_days_without_vat: number, overdue_by_91_to_365_days_vat: number, overdue_by_91_to_365_days: number, overdue_by_more_than_365_days_without_vat: number, overdue_by_more_than_365_days_vat: number, overdue_by_more_than_365_days: number, invoices: number } };

export type InvoicePaymentMethodFragment = { __typename?: 'InvoicePaymentMethod', id: string, name: string };

export type ChangeOutgoingInvoiceDatesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  issue_date: Scalars['Date']['input'];
  date_of_supply: Scalars['Date']['input'];
  due_date: Scalars['Date']['input'];
  paid_at?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ChangeOutgoingInvoiceDatesMutation = { __typename?: 'Mutation', changeOutgoingInvoiceDates?: boolean | null };

export type ChangeOutgoingProformaInvoiceDatesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  issue_date: Scalars['Date']['input'];
  due_date: Scalars['Date']['input'];
  paid_at?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ChangeOutgoingProformaInvoiceDatesMutation = { __typename?: 'Mutation', changeOutgoingProformaInvoiceDates?: boolean | null };

export type ProjectBillingRowFragment = { __typename?: 'ProjectBilling', planned_amount: number, planned_our_work: number, planned_prepayments: number, invoiced_amount: number, invoiced_our_work: number, invoiced_prepayments: number, automatically_invoiced: number, manually_invoiced: number, balance: number, billing_type: ProjectBillingTypeEnum, has_billing_plan: boolean, planned_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, invoiced_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, project: { __typename?: 'Project', id: string, code: string, title: string, projectManager: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } }, items: Array<{ __typename?: 'ProjectBillingItem', id: string, planned_amount: number, planned_our_work: number, planned_prepayments: number, invoiced_amount: number, invoiced_our_work: number, invoiced_prepayments: number, automatically_invoiced: number, manually_invoiced: number, balance: number, issue_date?: Date | null, date_of_supply?: Date | null, due_date?: Date | null, type?: ProjectBillingDocumentTypeEnum | null, invoice_no?: string | null, paid_at?: Date | null, paid_amount: number, status: ProjectBillingItemStatusEnum, delivered: boolean, note?: string | null, item_type: ProjectBillingItemTypeEnum, invoice_type?: BillingPlanBudgetItemInvoiceTypeEnum | null, billing_item_type?: BillingItemTypEnum | null, payment_status?: PaymentStatusEnum | null, planned_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, invoiced_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, brandCreditAccount?: { __typename?: 'BrandCreditAccount', id: string, title: string } | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string } | null, outgoingProformaInvoice?: { __typename?: 'OutgoingProformaInvoice', id: string } | null, requestForInvoicing?: { __typename?: 'RequestForInvoicing', id: string } | null }> };

export type ProjectBillingSubRowFragment = { __typename?: 'ProjectBillingItem', id: string, planned_amount: number, planned_our_work: number, planned_prepayments: number, invoiced_amount: number, invoiced_our_work: number, invoiced_prepayments: number, automatically_invoiced: number, manually_invoiced: number, balance: number, issue_date?: Date | null, date_of_supply?: Date | null, due_date?: Date | null, type?: ProjectBillingDocumentTypeEnum | null, invoice_no?: string | null, paid_at?: Date | null, paid_amount: number, status: ProjectBillingItemStatusEnum, delivered: boolean, note?: string | null, item_type: ProjectBillingItemTypeEnum, invoice_type?: BillingPlanBudgetItemInvoiceTypeEnum | null, billing_item_type?: BillingItemTypEnum | null, payment_status?: PaymentStatusEnum | null, planned_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, invoiced_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, brandCreditAccount?: { __typename?: 'BrandCreditAccount', id: string, title: string } | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string } | null, outgoingProformaInvoice?: { __typename?: 'OutgoingProformaInvoice', id: string } | null, requestForInvoicing?: { __typename?: 'RequestForInvoicing', id: string } | null };

export type ProjectBillingsSummaryFragmentFragment = { __typename?: 'ProjectBillingsSummary', total_paid_amount: number, total_unpaid_amount: number, total_planned_amount: number, total_planned_our_work: number, total_planned_prepayments: number, total_invoiced_amount: number, total_invoiced_our_work: number, total_invoiced_prepayments: number, total_planned_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, total_invoiced_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }> };

export type ProjectBillingsListQueryVariables = Exact<{
  filters?: InputMaybe<ProjectBillingsQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProjectBillingsListQuery = { __typename?: 'Query', projectBillings?: { __typename?: 'ProjectBillingPaginator', data: Array<{ __typename?: 'ProjectBilling', planned_amount: number, planned_our_work: number, planned_prepayments: number, invoiced_amount: number, invoiced_our_work: number, invoiced_prepayments: number, automatically_invoiced: number, manually_invoiced: number, balance: number, billing_type: ProjectBillingTypeEnum, has_billing_plan: boolean, planned_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, invoiced_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, project: { __typename?: 'Project', id: string, code: string, title: string, projectManager: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } }, items: Array<{ __typename?: 'ProjectBillingItem', id: string, planned_amount: number, planned_our_work: number, planned_prepayments: number, invoiced_amount: number, invoiced_our_work: number, invoiced_prepayments: number, automatically_invoiced: number, manually_invoiced: number, balance: number, issue_date?: Date | null, date_of_supply?: Date | null, due_date?: Date | null, type?: ProjectBillingDocumentTypeEnum | null, invoice_no?: string | null, paid_at?: Date | null, paid_amount: number, status: ProjectBillingItemStatusEnum, delivered: boolean, note?: string | null, item_type: ProjectBillingItemTypeEnum, invoice_type?: BillingPlanBudgetItemInvoiceTypeEnum | null, billing_item_type?: BillingItemTypEnum | null, payment_status?: PaymentStatusEnum | null, planned_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, invoiced_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, brandCreditAccount?: { __typename?: 'BrandCreditAccount', id: string, title: string } | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string } | null, outgoingProformaInvoice?: { __typename?: 'OutgoingProformaInvoice', id: string } | null, requestForInvoicing?: { __typename?: 'RequestForInvoicing', id: string } | null }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type ProjectBillingsSummaryQueryVariables = Exact<{
  filters?: InputMaybe<ProjectBillingsQueryArgs>;
}>;


export type ProjectBillingsSummaryQuery = { __typename?: 'Query', projectBillingsSummary: { __typename?: 'ProjectBillingsSummary', total_paid_amount: number, total_unpaid_amount: number, total_planned_amount: number, total_planned_our_work: number, total_planned_prepayments: number, total_invoiced_amount: number, total_invoiced_our_work: number, total_invoiced_prepayments: number, total_planned_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }>, total_invoiced_expense_categories: Array<{ __typename?: 'ProjectBillingExpenseCategoryAmount', amount: number, category_id: string, category_name: string }> } };

export type ProjectBillingsFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectBillingsFilterOptionsQuery = { __typename?: 'Query', projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, code: string, title: string }>, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | null, projectCategories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }> };

export type InvoicingPlanExportBasicQueryVariables = Exact<{
  month: Scalars['BigInt']['input'];
  year: Scalars['BigInt']['input'];
}>;


export type InvoicingPlanExportBasicQuery = { __typename?: 'Query', exportBillingPlan: string };

export type InvoicingPlanExportDetailedQueryVariables = Exact<{
  filters?: InputMaybe<ProjectBillingsQueryArgs>;
}>;


export type InvoicingPlanExportDetailedQuery = { __typename?: 'Query', projectBillingsExport: string };

export type CreateBillingPlanMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type CreateBillingPlanMutation = { __typename?: 'Mutation', createBillingPlan: Array<{ __typename?: 'BillingPlanByMonths', id: string }> };

export type UpdateBillingPlanMutationVariables = Exact<{
  input: UpdateBillingPlanInput;
}>;


export type UpdateBillingPlanMutation = { __typename?: 'Mutation', updateBillingPlan: Array<{ __typename?: 'BillingPlanByMonths', id: string }> };

export type ProjectBillingPlanDataQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectBillingPlanDataQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, start_date: Date, expected_end_date?: Date | null, stats?: { __typename?: 'ProjectStats', id: string, total_budget: number } | null, billingPlanByMonths: Array<{ __typename?: 'BillingPlanByMonths', id: string, period: string, invoiced_amount: number, items: Array<{ __typename?: 'BillingPlanItem', id: string, amount: number, date: Date }> }> } | null };

export type InvoicingPlanAdvancedListFragment = { __typename?: 'BillingPlanBudgetCache', id: string, type: BillingPlanBudgetItemInvoiceTypeEnum, planned_amount: number, issue_date: Date, date_of_supply: Date, due_date: Date, invoiced_amount: number, billing_plan_invoice_id?: string | null, invoice_no?: string | null, request_for_invoicing_id?: string | null, paid_amount: number, paid_at?: Date | null, email_sent: boolean, created_at: Date, updated_at: Date, message?: string | null, status: BillingPlanBudgetCacheStatusEnum, project: { __typename?: 'Project', id: string, title: string, code: string, billable: boolean, projectManager: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } }, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } };

export type CreateInvoiceFromBillingPlanMutationVariables = Exact<{
  input?: InputMaybe<CreateInvoiceFromBillingPlanInput>;
}>;


export type CreateInvoiceFromBillingPlanMutation = { __typename?: 'Mutation', createInvoiceFromBillingPlan: { __typename?: 'RequestForInvoicing', id: string } };

export type InvoicingPlanFutureListQueryVariables = Exact<{
  filters: BillingPlanCacheOverviewQueryArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InvoicingPlanFutureListQuery = { __typename?: 'Query', billingPlanCacheOverview?: { __typename?: 'BillingPlanBudgetCachePaginator', data: Array<{ __typename?: 'BillingPlanBudgetCache', id: string, type: BillingPlanBudgetItemInvoiceTypeEnum, planned_amount: number, issue_date: Date, date_of_supply: Date, due_date: Date, invoiced_amount: number, billing_plan_invoice_id?: string | null, invoice_no?: string | null, request_for_invoicing_id?: string | null, paid_amount: number, paid_at?: Date | null, email_sent: boolean, created_at: Date, updated_at: Date, message?: string | null, status: BillingPlanBudgetCacheStatusEnum, project: { __typename?: 'Project', id: string, title: string, code: string, billable: boolean, projectManager: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } }, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type InvoicingPlanFutureListSummaryQueryVariables = Exact<{
  filters: BillingPlanCacheOverviewQueryArgs;
}>;


export type InvoicingPlanFutureListSummaryQuery = { __typename?: 'Query', billingPlanCacheOverviewSummary: { __typename?: 'BillingPlanCacheOverviewSummary', projects: number, planned_amount: number, invoiced_amount: number, uninvoiced_amount: number } };

export type InvoicingPlanFutureListFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type InvoicingPlanFutureListFilterOptionsQuery = { __typename?: 'Query', projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, code: string, title: string }>, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }> };

export type NotificationFragment = { __typename?: 'Notification', id: string, type: NotificationType, message: string, object_id?: string | null, created_at?: Date | null, read_at?: Date | null, url?: string | null };

export type MarkNotificationAsReadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', markNotificationAsRead: { __typename?: 'Notification', id: string, type: NotificationType, message: string, object_id?: string | null, created_at?: Date | null, read_at?: Date | null, url?: string | null } };

export type MarkNotificationAsUnreadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarkNotificationAsUnreadMutation = { __typename?: 'Mutation', markNotificationAsUnread: { __typename?: 'Notification', id: string, type: NotificationType, message: string, object_id?: string | null, created_at?: Date | null, read_at?: Date | null, url?: string | null } };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{
  groups?: InputMaybe<Array<InputMaybe<NotificationGroup>> | InputMaybe<NotificationGroup>>;
}>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'Mutation', markAllNotificationsAsRead: boolean };

export type NotificationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<InputMaybe<NotificationGroup>> | InputMaybe<NotificationGroup>>;
  type?: InputMaybe<NotificationType>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications?: { __typename?: 'NotificationPaginator', data: Array<{ __typename?: 'Notification', id: string, type: NotificationType, message: string, object_id?: string | null, created_at?: Date | null, read_at?: Date | null, url?: string | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type UnreadNotificationsCountQueryVariables = Exact<{
  groups?: InputMaybe<Array<InputMaybe<NotificationGroup>> | InputMaybe<NotificationGroup>>;
}>;


export type UnreadNotificationsCountQuery = { __typename?: 'Query', unreadNotificationsCount: number };

export type TaskNotificationsNotificationFragment = { __typename?: 'Notification', id: string, message: string, type: NotificationType, read_at?: Date | null, created_at?: Date | null };

export type TaskNotificationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TaskNotificationsQuery = { __typename?: 'Query', taskAndCommunicationNotifications: { __typename?: 'TaskAndCommunicationNotificationsPaginator', data: Array<{ __typename?: 'NotificationPerTask', task: { __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null }, notifications: Array<{ __typename?: 'Notification', id: string, message: string, type: NotificationType, read_at?: Date | null, created_at?: Date | null }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type TaskNotificationsForScopedUserQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TaskNotificationsForScopedUserQuery = { __typename?: 'Query', taskAndCommunicationNotifications: { __typename?: 'TaskAndCommunicationNotificationsPaginator', data: Array<{ __typename?: 'NotificationPerTask', task: { __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null }, notifications: Array<{ __typename?: 'Notification', id: string, message: string, type: NotificationType, read_at?: Date | null, created_at?: Date | null }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type BillingPlanFragment = { __typename?: 'BillingPlanBudget', id?: string | null, budget_item_id?: string | null, budget_item_type: BudgetItemTypeEnum, total_budget: number, title: string, billing_item_type: BillingItemTypEnum, category: { __typename?: 'BillingPlanBudgetItemCategory', id: string, name: string }, billingPlanBudgetItem?: Array<{ __typename?: 'BillingPlanBudgetItem', invoice_type?: BillingPlanBudgetItemInvoiceTypeEnum | null, day?: number | null, accounting_centre_id?: string | null, accounting_account_id?: string | null, months: Array<{ __typename?: 'BillingPlanMonth', value: number, date: Date, billingPlanInvoice?: Array<{ __typename?: 'BillingPlanBudgetInvoice', amount: number, invoice_type: BillingPlanBudgetInvoiceTypeEnum, invoice_id: string, date: Date } | null> | null }> }> | null };

export type BillingPlanSettingsProjectFragment = { __typename?: 'Project', title: string, code: string, start_date: Date, expected_end_date?: Date | null, brand: { __typename?: 'Brand', image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, defaultBillingEntity?: { __typename?: 'BillingEntity', invoice_email?: string | null } | null }, contact?: { __typename?: 'Contact', email?: string | null } | null, projectManager: { __typename?: 'User', email: string }, billingPlanSetting?: { __typename?: 'ProjectBillingPlanSetting', to: Date, from: Date, auto_send_invoice: boolean, auto_send_thank_you: boolean, auto_create_invoice: boolean, generate_invoice_items?: ProjectBillingPlanSettingGenerateInvoiceItemsEnum | null, billing_item_type: BillingItemTypEnum, vat_rate_id?: string | null, date_of_supply_from_issue_date?: number | null, workspace_company_id?: string | null, workspace_bank_account_id?: string | null, billing_entity_id?: string | null, contact_id?: string | null, text_on_invoice?: string | null, internal_note?: string | null, note?: string | null, create_draft_invoice: boolean, order_id?: string | null, create_summary_invoice_after_payment: boolean, locked_at?: Date | null, email_template?: { __typename?: 'ProjectBillingPlanEmailTemplate', subject?: string | null, content?: string | null, recipients?: Array<string | null> | null } | null, auto_send_thank_you_template?: { __typename?: 'ProjectBillingPlanEmailTemplate', subject?: string | null, content?: string | null, recipients?: Array<string | null> | null } | null, lockedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null };

export type UpdateProjectBillingPlanMutationVariables = Exact<{
  input?: InputMaybe<UpdateProjectBillingPlanBudgetInput>;
}>;


export type UpdateProjectBillingPlanMutation = { __typename?: 'Mutation', updateProjectBillingPlanBudget: Array<{ __typename?: 'BillingPlanBudget', id?: string | null, budget_item_id?: string | null, budget_item_type: BudgetItemTypeEnum, total_budget: number, title: string, billing_item_type: BillingItemTypEnum, category: { __typename?: 'BillingPlanBudgetItemCategory', id: string, name: string }, billingPlanBudgetItem?: Array<{ __typename?: 'BillingPlanBudgetItem', invoice_type?: BillingPlanBudgetItemInvoiceTypeEnum | null, day?: number | null, accounting_centre_id?: string | null, accounting_account_id?: string | null, months: Array<{ __typename?: 'BillingPlanMonth', value: number, date: Date, billingPlanInvoice?: Array<{ __typename?: 'BillingPlanBudgetInvoice', amount: number, invoice_type: BillingPlanBudgetInvoiceTypeEnum, invoice_id: string, date: Date } | null> | null }> }> | null }> };

export type UpdateProjectBillingPlanSettingsMutationVariables = Exact<{
  input?: InputMaybe<UpdateProjectBillingPlanSettingsInput>;
}>;


export type UpdateProjectBillingPlanSettingsMutation = { __typename?: 'Mutation', updateProjectBillingPlanSettings: { __typename?: 'Project', title: string, code: string, start_date: Date, expected_end_date?: Date | null, brand: { __typename?: 'Brand', image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, defaultBillingEntity?: { __typename?: 'BillingEntity', invoice_email?: string | null } | null }, contact?: { __typename?: 'Contact', email?: string | null } | null, projectManager: { __typename?: 'User', email: string }, billingPlanSetting?: { __typename?: 'ProjectBillingPlanSetting', to: Date, from: Date, auto_send_invoice: boolean, auto_send_thank_you: boolean, auto_create_invoice: boolean, generate_invoice_items?: ProjectBillingPlanSettingGenerateInvoiceItemsEnum | null, billing_item_type: BillingItemTypEnum, vat_rate_id?: string | null, date_of_supply_from_issue_date?: number | null, workspace_company_id?: string | null, workspace_bank_account_id?: string | null, billing_entity_id?: string | null, contact_id?: string | null, text_on_invoice?: string | null, internal_note?: string | null, note?: string | null, create_draft_invoice: boolean, order_id?: string | null, create_summary_invoice_after_payment: boolean, locked_at?: Date | null, email_template?: { __typename?: 'ProjectBillingPlanEmailTemplate', subject?: string | null, content?: string | null, recipients?: Array<string | null> | null } | null, auto_send_thank_you_template?: { __typename?: 'ProjectBillingPlanEmailTemplate', subject?: string | null, content?: string | null, recipients?: Array<string | null> | null } | null, lockedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null } };

export type LockProjectBillingPlanMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type LockProjectBillingPlanMutation = { __typename?: 'Mutation', lockBillingPlanForProject?: { __typename?: 'Project', billingPlanSetting?: { __typename?: 'ProjectBillingPlanSetting', locked_at?: Date | null, lockedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null } | null };

export type BillingPlanQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  billingItemType: BillingItemTypEnum;
}>;


export type BillingPlanQuery = { __typename?: 'Query', billingPlanBudget: Array<{ __typename?: 'BillingPlanBudget', id?: string | null, budget_item_id?: string | null, budget_item_type: BudgetItemTypeEnum, total_budget: number, title: string, billing_item_type: BillingItemTypEnum, category: { __typename?: 'BillingPlanBudgetItemCategory', id: string, name: string }, billingPlanBudgetItem?: Array<{ __typename?: 'BillingPlanBudgetItem', invoice_type?: BillingPlanBudgetItemInvoiceTypeEnum | null, day?: number | null, accounting_centre_id?: string | null, accounting_account_id?: string | null, months: Array<{ __typename?: 'BillingPlanMonth', value: number, date: Date, billingPlanInvoice?: Array<{ __typename?: 'BillingPlanBudgetInvoice', amount: number, invoice_type: BillingPlanBudgetInvoiceTypeEnum, invoice_id: string, date: Date } | null> | null }> }> | null }> };

export type BillingPlanOptionsQueryVariables = Exact<{
  accountingCentreType: Accounting_Centre_Type;
}>;


export type BillingPlanOptionsQuery = { __typename?: 'Query', accountingCentres: Array<{ __typename?: 'AccountingCentre', id: string, centre: string, title: string, type: Accounting_Centre_Type, deleted_at?: Date | null }> };

export type BillingPlanSettingsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type BillingPlanSettingsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', title: string, code: string, start_date: Date, expected_end_date?: Date | null, brand: { __typename?: 'Brand', image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, defaultBillingEntity?: { __typename?: 'BillingEntity', invoice_email?: string | null } | null }, contact?: { __typename?: 'Contact', email?: string | null } | null, projectManager: { __typename?: 'User', email: string }, billingPlanSetting?: { __typename?: 'ProjectBillingPlanSetting', to: Date, from: Date, auto_send_invoice: boolean, auto_send_thank_you: boolean, auto_create_invoice: boolean, generate_invoice_items?: ProjectBillingPlanSettingGenerateInvoiceItemsEnum | null, billing_item_type: BillingItemTypEnum, vat_rate_id?: string | null, date_of_supply_from_issue_date?: number | null, workspace_company_id?: string | null, workspace_bank_account_id?: string | null, billing_entity_id?: string | null, contact_id?: string | null, text_on_invoice?: string | null, internal_note?: string | null, note?: string | null, create_draft_invoice: boolean, order_id?: string | null, create_summary_invoice_after_payment: boolean, locked_at?: Date | null, email_template?: { __typename?: 'ProjectBillingPlanEmailTemplate', subject?: string | null, content?: string | null, recipients?: Array<string | null> | null } | null, auto_send_thank_you_template?: { __typename?: 'ProjectBillingPlanEmailTemplate', subject?: string | null, content?: string | null, recipients?: Array<string | null> | null } | null, lockedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null } | null, EmailTemplates: Array<{ __typename?: 'EmailTemplate', id: string, type: EmailTemplateTypeEnum, subject?: string | null, content?: string | null }>, vatRates?: Array<{ __typename?: 'VatRate', id: string, amount: number, deleted: boolean, default: boolean }> | null };

export type BillingPlanIssueInvoicesOptionsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type BillingPlanIssueInvoicesOptionsQuery = { __typename?: 'Query', vatRates?: Array<{ __typename?: 'VatRate', id: string, amount: number, default: boolean }> | null, project?: { __typename?: 'Project', brand: { __typename?: 'Brand', contacts: Array<{ __typename?: 'Contact', id: string, first_name?: string | null, last_name?: string | null, email?: string | null }>, client: { __typename?: 'Client', billingEntities: Array<{ __typename?: 'BillingEntity', id: string, street: string, city: string, internal_name: string, applies_vat: boolean, invoice_email?: string | null, defaultCurrency: { __typename?: 'Currency', id: string, code: string } }>, currencyExchangeRates: Array<{ __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, currency: { __typename?: 'Currency', id: string, code: string } }> } }, ordersSimpleMap: Array<{ __typename?: 'OrderSimple', id: string, purchase_order_no?: string | null }> } | null };

export type IsBillingPlanLockedQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type IsBillingPlanLockedQuery = { __typename?: 'Query', project?: { __typename?: 'Project', billingPlanSetting?: { __typename?: 'ProjectBillingPlanSetting', locked_at?: Date | null, lockedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null } | null };

export type GetBudgetExceededQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type GetBudgetExceededQuery = { __typename?: 'Query', teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | null }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projects?: { __typename?: 'ProjectPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', hasMorePages: boolean, currentPage: number, perPage: number, total: number, count: number, firstItem?: number | null, lastItem?: number | null, lastPage: number }, data: Array<{ __typename?: 'Project', id: string, title: string, code: string, billable: boolean, type: ProjectTypeEnum, brand: { __typename?: 'Brand', id: string, name: string, client: { __typename?: 'Client', image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } }, projectManager: { __typename?: 'User', codename?: string | null, full_name: string, id: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }, expenses: Array<{ __typename?: 'ExpenseBudgetItem', title: string, id: string, stats: { __typename?: 'ExpenseBudgetItemStats', planned_expenses: number, real_expenses: number, planned_commission: number, credit: number, total_budget: number, budget_exceeded: number, real_expenses_percent: number, real_commission: number, real_commission_relative: string, planned_commission_relative_computed: string, planned_profit: number } }>, ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, stats: { __typename?: 'OurWorkBudgetItemStats', credit: number, total_budget: number, spent_budget: number, budget_exceeded: number, spent_budget_percent: number, spent_time: number, invoiced_percent: number, remaining_budget: number, remaining_time: number } }>, stats?: { __typename?: 'ProjectStats', budget_exceeded: number } | null }> } | null };

export type UpdateProjectBudgetMutationVariables = Exact<{
  input: UpdateProjectBudgetInput;
}>;


export type UpdateProjectBudgetMutation = { __typename?: 'Mutation', updateProjectBudget: { __typename?: 'Project', id: string, title: string, code: string, billable: boolean, uses_budgetovac: boolean, finished_at?: Date | null, type: ProjectTypeEnum, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, budgetovacBudget?: { __typename?: 'ProjectBudgetPivot', budget_id?: string | null, newer_final_version_available: boolean } | null, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', name: string, budget_category_id: string, total_budget: number, credit: number, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, stats: { __typename?: 'OurWorkBudgetItemStats', credit: number, total_budget: number } }> }>, expensesWithoutOtherStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', name: string, budget_category_id: string, total_budget: number, credit: number, real_expenses: number, real_expenses_without_other: number, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, type: ExpenseBudgetItemType, completed_at?: Date | null, stats: { __typename?: 'ExpenseBudgetItemStats', real_expenses: number, credit: number, total_budget: number, planned_commission: number, planned_expenses: number } }> }>, stats?: { __typename?: 'ProjectStats', total_budget: number, credit: number, planned_commission: number, ourWork: { __typename?: 'ProjectOurWorkStats', total_budget: number }, expenses: { __typename?: 'ProjectExpenseStats', planned_expenses: number } } | null } };

export type ProjectForBudgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectForBudgetQuery = { __typename?: 'Query', expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | null, ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string, name: string }> | null, project?: { __typename?: 'Project', id: string, title: string, code: string, billable: boolean, uses_budgetovac: boolean, finished_at?: Date | null, type: ProjectTypeEnum, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, budgetovacBudget?: { __typename?: 'ProjectBudgetPivot', budget_id?: string | null, newer_final_version_available: boolean } | null, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', name: string, budget_category_id: string, total_budget: number, credit: number, budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, stats: { __typename?: 'OurWorkBudgetItemStats', credit: number, total_budget: number } }> }>, expensesWithoutOtherStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', name: string, budget_category_id: string, total_budget: number, credit: number, real_expenses: number, real_expenses_without_other: number, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, type: ExpenseBudgetItemType, completed_at?: Date | null, stats: { __typename?: 'ExpenseBudgetItemStats', real_expenses: number, credit: number, total_budget: number, planned_commission: number, planned_expenses: number } }> }>, stats?: { __typename?: 'ProjectStats', total_budget: number, credit: number, planned_commission: number, ourWork: { __typename?: 'ProjectOurWorkStats', total_budget: number }, expenses: { __typename?: 'ProjectExpenseStats', planned_expenses: number } } | null } | null, projectDatesForBudgetChange: { __typename?: 'ProjectDatesForBudgetChange', lowestPossibleDateForBudgetChange: Date, defaultDateForBudgetChange: Date } };

export type ProjectForBudgetsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectForBudgetsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, finished_at?: Date | null, uses_budgetovac: boolean, code: string, numeric_code?: string | null, title: string, billable: boolean, budgetovacBudget?: { __typename?: 'ProjectBudgetPivot', budget_id?: string | null } | null, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } } | null };

export type BudgetInternalApproveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BudgetInternalApproveMutation = { __typename?: 'Mutation', budgetInternalApprove: { __typename?: 'Budget', id: string } };

export type ChangeBudgetAssignedAtMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
}>;


export type ChangeBudgetAssignedAtMutation = { __typename?: 'Mutation', changeBudgetAssignedAt: { __typename?: 'Budget', id: string, assignment_date?: Date | null } };

export type BudgetGroupsForProjectsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type BudgetGroupsForProjectsQuery = { __typename?: 'Query', budgetsForProject?: Array<{ __typename?: 'BudgetGroup', budget_name?: string | null, budget_number?: string | null, budgets?: Array<{ __typename?: 'Budget', id: string, project_id?: string | null, description?: string | null, account_manager?: string | null, assignment_date?: Date | null, status: BudgetStatusEnum, internally_approved?: boolean | null, client_approved?: boolean | null, is_active?: boolean | null, version?: number | null, price?: number | null, temporary_project_id?: string | null, created_at: Date, updated_at: Date, project?: { __typename?: 'Project', id: string, title: string } | null, brand?: { __typename?: 'Brand', id: string, name: string } | null, temporaryBrand?: { __typename?: 'TemporaryBrand', name?: string | null } | null, temporaryProject?: { __typename?: 'TemporaryProject', name?: string | null, is_archived?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, code: string, denomination: number } | null, quotes?: Array<{ __typename?: 'Quote', id: string, url: string, number: string }> | null } | null> | null }> | null };

export type ProjectTitleQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectTitleQuery = { __typename?: 'Query', project?: { __typename?: 'Project', lowestPossibleDateForStartDateChange?: Date | null, code: string, numeric_code?: string | null, title: string, billable: boolean, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } } | null };

export type GetProjectBudgetExceededCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectBudgetExceededCountQuery = { __typename?: 'Query', getActiveProjectBudgetExceededCount: number };

export type GetProjectUsesBudgetovacQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectUsesBudgetovacQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, uses_budgetovac: boolean, finished_at?: Date | null } | null };

export type CreateProjectFromTemplateMutationVariables = Exact<{
  input: CreateProjectFromTemplateInput;
}>;


export type CreateProjectFromTemplateMutation = { __typename?: 'Mutation', createProjectFromTemplate: { __typename?: 'Project', id: string } };

export type GetBrandContactsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBrandContactsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, name: string, code: string, contacts: Array<{ __typename?: 'Contact', id: string, first_name?: string | null, last_name?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }> } | null };

export type GetPmQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPmQuery = { __typename?: 'Query', user?: { __typename?: 'User', team?: { __typename?: 'Team', id: string } | null } | null };

export type RateCardsQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RateCardsQuery = { __typename?: 'Query', projectRateCard: Array<{ __typename?: 'ProjectRateCard', id: string, name: string, currency_iso?: string | null } | null> };

export type GetProjectFromTemplateQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetProjectFromTemplateQuery = { __typename?: 'Query', project?: { __typename?: 'Project', title: string, type: ProjectTypeEnum, start_date: Date, billable: boolean, note?: string | null, rate_card_id?: string | null, categories: Array<{ __typename?: 'ProjectCategory', id: string }>, brand: { __typename?: 'Brand', id: string }, contact?: { __typename?: 'Contact', id: string } | null, team: { __typename?: 'Team', id: string }, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | null } | null };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', id: string } };

export type GetProjectCreateDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectCreateDataQuery = { __typename?: 'Query', lowestDateWithOpenProgress?: Date | null, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, name: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }> };

export type ProjectDetailForClientQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectDetailForClientQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, title: string, code: string, note?: string | null, status: ProjectStatusEnum, finished_at?: Date | null, archived_at?: Date | null, cloudUrl?: string | null, driveCloudUrl?: string | null, type: ProjectTypeEnum, start_date: Date, expected_end_date?: Date | null, externalLinks: Array<{ __typename?: 'ExternalLink', id: string, title: string, link: string, model_id: string, model_type: ExternalLinkType }>, finishedBy?: { __typename?: 'User', id: string, full_name: string } | null, archivedBy?: { __typename?: 'User', id: string, full_name: string } | null, otherProjectManagers?: Array<{ __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }> | null, contact?: { __typename?: 'Contact', id: string, phone?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, projectManager: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | null, team?: { __typename?: 'Team', name: string } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, team: { __typename?: 'Team', name: string }, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } } | null };

export type TasksForClientQueryVariables = Exact<{
  filters?: InputMaybe<TaskQueryArgs>;
}>;


export type TasksForClientQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskPaginator', data: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null }> | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null }> } | null };

export type OurWorkOverviewFragment = { __typename?: 'OurWorkOverviewBudgetItem', id: string, name: string, total_budget: number, credit: number, budgetItems: Array<{ __typename?: 'OurWorkBudgetItemOverview', id: string, title: string, item_code?: string | null, completed_at?: Date | null, requested_for_deletion_at?: Date | null, hidden: boolean, order: number, note?: string | null, deadline?: Date | null, done_task_count: number, task_count: number, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string }>, lastWorkInProgressItemStat?: { __typename?: 'WorkInProgressItemStat', work_in_progress_id: string, progress_percent: number } | null, stats: { __typename?: 'OurWorkBudgetItemStats', total_budget: number, total_time: number, spent_budget: number, spent_time: number, remaining_time: number, remaining_budget: number, credit: number, invoiced_percent: number, spent_budget_percent: number, credit_balance: number, invoiceable: number, uninvoiced: number, net_profit: number, net_margin_percent: number, efficiency_percent: number }, expenseStats: Array<{ __typename?: 'OurWorkBudgetItemExpenseStats', id: string, tracked_time?: number | null, report_date?: Date | null, expense_item_amount: number, task?: { __typename?: 'Task', id: string, name: string } | null, expense: { __typename?: 'Expense', id: string, expense_no?: string | null }, position?: { __typename?: 'TimeTrackingWorkType', title: string } | null }>, tasks: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, subtasks?: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null }> | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null }> }> };

export type ExpenseStructuredBudgetItemFragmentFragment = { __typename?: 'ExpenseBudgetItem', id: string, item_code?: string | null, title: string, type: ExpenseBudgetItemType, completed_at?: Date | null, requested_for_deletion_at?: Date | null, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string }>, expenseStats: Array<{ __typename?: 'ExpenseBudgetItemExpenseStats', expense: { __typename?: 'Expense', status: ExpenseStatusEnum } }>, stats: { __typename?: 'ExpenseBudgetItemStats', total_budget: number, client_price: number, real_expenses: number, real_commission: number, planned_expenses: number, planned_commission: number, planned_profit: number, real_expenses_percent: number, real_commission_relative: string, planned_commission_relative_computed: string, credit: number, credit_balance: number, invoiced_percent: number, invoiceable: number, uninvoiced: number, profit: number, profit_percent: number } };

export type OurWorkBudgetItemOverviewTasksFragmentFragment = { __typename?: 'OurWorkBudgetItemOverview', tasks: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, subtasks?: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null }> | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null }> };

export type OurWorkBudgetItemOverviewFragmentFragment = { __typename?: 'OurWorkBudgetItemOverview', id: string, title: string, item_code?: string | null, completed_at?: Date | null, requested_for_deletion_at?: Date | null, hidden: boolean, order: number, note?: string | null, deadline?: Date | null, done_task_count: number, task_count: number, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string }>, lastWorkInProgressItemStat?: { __typename?: 'WorkInProgressItemStat', work_in_progress_id: string, progress_percent: number } | null, stats: { __typename?: 'OurWorkBudgetItemStats', total_budget: number, total_time: number, spent_budget: number, spent_time: number, remaining_time: number, remaining_budget: number, credit: number, invoiced_percent: number, spent_budget_percent: number, credit_balance: number, invoiceable: number, uninvoiced: number, net_profit: number, net_margin_percent: number, efficiency_percent: number }, expenseStats: Array<{ __typename?: 'OurWorkBudgetItemExpenseStats', id: string, tracked_time?: number | null, report_date?: Date | null, expense_item_amount: number, task?: { __typename?: 'Task', id: string, name: string } | null, expense: { __typename?: 'Expense', id: string, expense_no?: string | null }, position?: { __typename?: 'TimeTrackingWorkType', title: string } | null }>, tasks: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, subtasks?: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null }> | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null }> };

export type ProjectDetailPlannedExpenseFieldsFragment = { __typename?: 'BudgetItemPlannedExpense', id: string, budget_item_id: string, budget_item_type: string, description?: string | null, date?: Date | null, client_amount: number, budgeted_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null };

export type ProjectDetailCreateBudgetItemPlannedExpensesMutationVariables = Exact<{
  input: CreateBudgetItemPlannedExpensesInput;
}>;


export type ProjectDetailCreateBudgetItemPlannedExpensesMutation = { __typename?: 'Mutation', createBudgetItemPlannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, budget_item_id: string, budget_item_type: string, description?: string | null, date?: Date | null, client_amount: number, budgeted_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null }> };

export type ProjectDetailCreateBudgetItemPlannedExpensesBulkMutationVariables = Exact<{
  items: Array<CreateBudgetItemPlannedExpensesInput> | CreateBudgetItemPlannedExpensesInput;
}>;


export type ProjectDetailCreateBudgetItemPlannedExpensesBulkMutation = { __typename?: 'Mutation', createBudgetItemPlannedExpensesBulk: Array<Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, budget_item_id: string, budget_item_type: string, description?: string | null, date?: Date | null, client_amount: number, budgeted_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null }>> };

export type InvoiceProjectByCurrentMonthBillingPlanMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  type: RequestForInvoicingTypeEnum;
}>;


export type InvoiceProjectByCurrentMonthBillingPlanMutation = { __typename?: 'Mutation', invoiceProjectByCurrentMonthBillingPlan?: { __typename?: 'RequestForInvoicing', id: string } | null };

export type ResetBillingPlanNotificationsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  type: BillingPlanNotificationTypeEnum;
}>;


export type ResetBillingPlanNotificationsMutation = { __typename?: 'Mutation', resetBillingPlanNotifications: { __typename?: 'Project', id: string, billingPlanNotifications?: { __typename?: 'BillingPlanNotifications', project_budget_changed: boolean, project_dates_changed: boolean } | null } };

export type UpdateOurWorkBudgetItemsMutationVariables = Exact<{
  budgetItems: Array<UpdateBudgetItem> | UpdateBudgetItem;
}>;


export type UpdateOurWorkBudgetItemsMutation = { __typename?: 'Mutation', updateOurWorkBudgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string }> };

export type CreateExpenseBudgetItemMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  expenseBudgetCategoryId: Scalars['ID']['input'];
}>;


export type CreateExpenseBudgetItemMutation = { __typename?: 'Mutation', createExpenseBudgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, item_code?: string | null, title: string, type: ExpenseBudgetItemType, completed_at?: Date | null, requested_for_deletion_at?: Date | null, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string }>, expenseStats: Array<{ __typename?: 'ExpenseBudgetItemExpenseStats', expense: { __typename?: 'Expense', status: ExpenseStatusEnum } }>, stats: { __typename?: 'ExpenseBudgetItemStats', total_budget: number, client_price: number, real_expenses: number, real_commission: number, planned_expenses: number, planned_commission: number, planned_profit: number, real_expenses_percent: number, real_commission_relative: string, planned_commission_relative_computed: string, credit: number, credit_balance: number, invoiced_percent: number, invoiceable: number, uninvoiced: number, profit: number, profit_percent: number } } | null };

export type CreateOurWorkBudgetItemMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}>;


export type CreateOurWorkBudgetItemMutation = { __typename?: 'Mutation', createOurWorkBudgetItem?: { __typename?: 'OurWorkBudgetItemOverview', id: string, title: string, item_code?: string | null, completed_at?: Date | null, requested_for_deletion_at?: Date | null, hidden: boolean, order: number, note?: string | null, deadline?: Date | null, done_task_count: number, task_count: number, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string }>, lastWorkInProgressItemStat?: { __typename?: 'WorkInProgressItemStat', work_in_progress_id: string, progress_percent: number } | null, stats: { __typename?: 'OurWorkBudgetItemStats', total_budget: number, total_time: number, spent_budget: number, spent_time: number, remaining_time: number, remaining_budget: number, credit: number, invoiced_percent: number, spent_budget_percent: number, credit_balance: number, invoiceable: number, uninvoiced: number, net_profit: number, net_margin_percent: number, efficiency_percent: number }, expenseStats: Array<{ __typename?: 'OurWorkBudgetItemExpenseStats', id: string, tracked_time?: number | null, report_date?: Date | null, expense_item_amount: number, task?: { __typename?: 'Task', id: string, name: string } | null, expense: { __typename?: 'Expense', id: string, expense_no?: string | null }, position?: { __typename?: 'TimeTrackingWorkType', title: string } | null }>, tasks: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, subtasks?: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null }> | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null }> } | null };

export type CreateTasksFromTemplateGroupMutationVariables = Exact<{
  ourWorkBudgetItemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  taskTemplateGroupId: Scalars['ID']['input'];
}>;


export type CreateTasksFromTemplateGroupMutation = { __typename?: 'Mutation', createTasksFromTaskTemplateGroup: boolean };

export type OurWorkOverviewForProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type OurWorkOverviewForProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', ourWorkOverview: Array<{ __typename?: 'OurWorkOverviewBudgetItem', id: string, name: string, total_budget: number, credit: number, budgetItems: Array<{ __typename?: 'OurWorkBudgetItemOverview', id: string, title: string, item_code?: string | null, completed_at?: Date | null, requested_for_deletion_at?: Date | null, hidden: boolean, order: number, note?: string | null, deadline?: Date | null, done_task_count: number, task_count: number, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string }>, lastWorkInProgressItemStat?: { __typename?: 'WorkInProgressItemStat', work_in_progress_id: string, progress_percent: number } | null, stats: { __typename?: 'OurWorkBudgetItemStats', total_budget: number, total_time: number, spent_budget: number, spent_time: number, remaining_time: number, remaining_budget: number, credit: number, invoiced_percent: number, spent_budget_percent: number, credit_balance: number, invoiceable: number, uninvoiced: number, net_profit: number, net_margin_percent: number, efficiency_percent: number }, expenseStats: Array<{ __typename?: 'OurWorkBudgetItemExpenseStats', id: string, tracked_time?: number | null, report_date?: Date | null, expense_item_amount: number, task?: { __typename?: 'Task', id: string, name: string } | null, expense: { __typename?: 'Expense', id: string, expense_no?: string | null }, position?: { __typename?: 'TimeTrackingWorkType', title: string } | null }>, tasks: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, subtasks?: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null }> | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null }> }> }> } | null };

export type OurWorkOverviewDoneTasksForProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  budgetItemId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type OurWorkOverviewDoneTasksForProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', ourWorkOverview: Array<{ __typename?: 'OurWorkOverviewBudgetItem', budgetItems: Array<{ __typename?: 'OurWorkBudgetItemOverview', id: string, tasks: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, subtasks?: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null }> | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null }> }> }> } | null };

export type ProjectDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectDetailQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, title: string, code: string, numeric_code?: string | null, note?: string | null, status: ProjectStatusEnum, billable: boolean, is_pinned: boolean, is_starred: boolean, uses_budgetovac: boolean, finished_at?: Date | null, archived_at?: Date | null, cloudUrl?: string | null, driveCloudUrl?: string | null, billingPlanIsMissing: boolean, type: ProjectTypeEnum, start_date: Date, expected_end_date?: Date | null, is_template: boolean, currentMonthBillingPlanOutgoingInvoice: number, currentMonthBillingPlanOutgoingProformaInvoice: number, externalLinks: Array<{ __typename?: 'ExternalLink', id: string, title: string, link: string, model_id: string, model_type: ExternalLinkType }>, categories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }>, billingPlanNotifications?: { __typename?: 'BillingPlanNotifications', project_dates_changed: boolean, project_budget_changed: boolean } | null, finishedBy?: { __typename?: 'User', id: string, full_name: string } | null, archivedBy?: { __typename?: 'User', id: string, full_name: string } | null, budgetovacBudget?: { __typename?: 'ProjectBudgetPivot', budget_id?: string | null, internally_approved?: boolean | null, newer_final_version_available: boolean } | null, budgetovacBudgets?: Array<{ __typename?: 'Budget', id: string, internally_approved?: boolean | null, is_active?: boolean | null }> | null, lastWorkInProgressProjectStat?: { __typename?: 'WorkInProgressProjectStat', progress_percent: number } | null, orders?: { __typename?: 'OrderPaginator', data: Array<{ __typename?: 'Order', id: string, purchase_order_no?: string | null }> } | null, projectManager: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }, otherProjectManagers?: Array<{ __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }> | null, contact?: { __typename?: 'Contact', id: string, phone?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, team: { __typename?: 'Team', id: string, name: string }, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, statsCached?: { __typename?: 'ProjectStats', total_budget: number, invoiceable: number, uninvoiced: number, credit: number, credit_balance: number, credit_direct: number, credit_from_prepayments: number, unused_sum_from_proformas: number, over_invoiced: number, net_profit: number, net_margin_percent: number, gross_income: number, outgoing_invoice_amount: number, outgoing_invoice_paid: number, outgoing_proforma_invoice_amount: number, outgoing_proforma_invoice_paid: number, outgoing_proforma_invoice_settled: number, outgoing_proforma_invoice_unsettled: number, credit_from_unused_prepayments: number, ourWork: { __typename?: 'ProjectOurWorkStats', spent_time: number, remaining_time: number, total_time: number, total_budget: number, spent_budget: number, spent_budget_percent: number, remaining_budget: number, credit: number, invoiced_percent: number, invoiceable: number, uninvoiced: number, all_items_completed: boolean, net_profit: number, net_margin_percent: number, efficiency_percent: number }, expenses: { __typename?: 'ProjectExpenseStats', total_budget: number, planned_expenses: number, planned_commission: number, planned_profit: number, planned_commission_relative_computed: string, real_expenses: number, real_commission: number, real_expenses_percent: number, real_commission_relative: string, credit: number, credit_balance: number, invoiced_percent: number, invoiceable: number, uninvoiced: number, all_items_completed: boolean } } | null, expensesStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, budget_category_id: string, name: string, total_budget: number, credit: number, budgetItems: Array<{ __typename?: 'ExpenseBudgetItem', id: string, item_code?: string | null, title: string, type: ExpenseBudgetItemType, completed_at?: Date | null, requested_for_deletion_at?: Date | null, plannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string }>, expenseStats: Array<{ __typename?: 'ExpenseBudgetItemExpenseStats', expense: { __typename?: 'Expense', status: ExpenseStatusEnum } }>, stats: { __typename?: 'ExpenseBudgetItemStats', total_budget: number, client_price: number, real_expenses: number, real_commission: number, planned_expenses: number, planned_commission: number, planned_profit: number, real_expenses_percent: number, real_commission_relative: string, planned_commission_relative_computed: string, credit: number, credit_balance: number, invoiced_percent: number, invoiceable: number, uninvoiced: number, profit: number, profit_percent: number } }> }>, invoiceStats: Array<{ __typename?: 'ProjectInvoiceStat', id: string }>, proformaInvoices: Array<{ __typename?: 'OutgoingProformaInvoice', id: string }>, prepaymentStats: Array<{ __typename?: 'ProjectPrepaymentStat', id: string }>, currentMonthBillingPlanStats: { __typename?: 'BillingPlanStats', current_month_planned: number, show_invoice_date_approaching_warning: boolean }, billingPlanSetting?: { __typename?: 'ProjectBillingPlanSetting', project_id: string } | null, billingPlanByMonths: Array<{ __typename?: 'BillingPlanByMonths', id: string }>, project_stage?: { __typename?: 'ProjectStage', id: string, name: string, system_name?: string | null } | null, pipedriveCustomFieldValues: Array<{ __typename?: 'PipedriveCustomFieldValue', value?: string | null, customField: { __typename?: 'PipedriveCustomField', label?: string | null } }> } | null };

export type ProjectGraphQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  ourWorkBudgetItemIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ProjectGraphQuery = { __typename?: 'Query', projectGraph: { __typename?: 'ProjectGraph', totalBudgetData: Array<{ __typename?: 'DateIntegerDataPoint', date: Date, amount: number }>, spentBudgetData: Array<{ __typename?: 'DateIntegerDataPoint', date: Date, amount: number }> } };

export type ProjectDetailBudgetItemPlannedExpensesQueryVariables = Exact<{
  budgetItemId: Scalars['ID']['input'];
  budgetItemType: ExpenseBudgetItemTypeEnum;
}>;


export type ProjectDetailBudgetItemPlannedExpensesQuery = { __typename?: 'Query', budgetItemPlannedExpenses: Array<{ __typename?: 'BudgetItemPlannedExpense', id: string, budget_item_id: string, budget_item_type: string, description?: string | null, date?: Date | null, client_amount: number, budgeted_amount: number, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null }> };

export type ProjectDocumentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectDocumentsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', code: string, numeric_code?: string | null, title: string, billable: boolean, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } } | null };

export type UpdateProjectMutationVariables = Exact<{
  input: UpdateProjectInput;
  propagate_billable: Scalars['Boolean']['input'];
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string } };

export type GetProjectEditDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectEditDataQuery = { __typename?: 'Query', lowestDateWithOpenProgress?: Date | null, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | null, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }>, project?: { __typename?: 'Project', title: string, code: string, note?: string | null, start_date: Date, expected_end_date?: Date | null, billable: boolean, type: ProjectTypeEnum, finished_at?: Date | null, uses_budgetovac: boolean, lowestPossibleDateForStartDateChange?: Date | null, rate_card_id?: string | null, is_template: boolean, users: Array<{ __typename?: 'User', id: string }>, categories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }>, team: { __typename?: 'Team', id: string, name: string }, brand: { __typename?: 'Brand', id: string, name: string }, contact?: { __typename?: 'Contact', id: string } | null, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | null, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, tasks: Array<{ __typename?: 'Task', id: string }> }> }> } | null };

export type ClientsProjectListTableDataQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type ClientsProjectListTableDataQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectPaginator', data: Array<{ __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, users: Array<{ __typename?: 'User', full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null }>, projectManager: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }, stats?: { __typename?: 'ProjectStats', invoiced_percent: number } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type ClientsProjectListFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientsProjectListFilterOptionsQuery = { __typename?: 'Query', teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, name: string, codename?: string | null, full_name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }> };

export type CloseWipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CloseWipMutation = { __typename?: 'Mutation', closeWip: { __typename?: 'WorkInProgressProjectStat', is_closed: boolean } };

export type CloseWipBulkMutationVariables = Exact<{
  periodId: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<WipsWhereConditions>;
}>;


export type CloseWipBulkMutation = { __typename?: 'Mutation', closeWipBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type LockWipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LockWipMutation = { __typename?: 'Mutation', lockWip: { __typename?: 'WorkInProgressProjectStat', is_locked: boolean } };

export type LockWipBulkMutationVariables = Exact<{
  periodId: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<WipsWhereConditions>;
}>;


export type LockWipBulkMutation = { __typename?: 'Mutation', lockWipBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type OpenWipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OpenWipMutation = { __typename?: 'Mutation', openWip: { __typename?: 'WorkInProgressProjectStat', is_closed: boolean } };

export type OpenWipBulkMutationVariables = Exact<{
  periodId: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<WipsWhereConditions>;
}>;


export type OpenWipBulkMutation = { __typename?: 'Mutation', openWipBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type WipItemStatAffectedValuesFragment = { __typename?: 'WorkInProgressItemStat', progress: number, progress_percent: number, progress_change: number, progress_change_percent: number, spent_time_estimate: number };

export type SubmitProgressMutationVariables = Exact<{
  input: SubmitProgressInput;
}>;


export type SubmitProgressMutation = { __typename?: 'Mutation', submitProgress: { __typename?: 'SubmitProgressResult', changedWorkInProgressItemStats: Array<{ __typename?: 'WorkInProgressItemStat', our_work_budget_item_id: string, work_in_progress_id: string, progress: number, progress_percent: number, progress_change: number, progress_change_percent: number, spent_time_estimate: number }>, lastWorkInProgressProjectStat: { __typename?: 'WorkInProgressProjectStat', progress: number, progress_percent: number, progress_change: number, progress_change_percent: number, spent_time_estimate: number } } };

export type SubmitProgressBulkMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  progress: Scalars['BigInt']['input'];
}>;


export type SubmitProgressBulkMutation = { __typename?: 'Mutation', submitProgressBulk: Array<{ __typename?: 'OurWorkBudgetItem', id: string, lastWorkInProgressItemStat?: { __typename?: 'WorkInProgressItemStat', id: string, work_in_progress_id: string, progress: number, progress_percent: number, progress_change: number, progress_change_percent: number, spent_time_estimate: number } | null }> };

export type UnlockWipMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnlockWipMutation = { __typename?: 'Mutation', unlockWip: { __typename?: 'WorkInProgressProjectStat', is_locked: boolean } };

export type UnlockWipBulkMutationVariables = Exact<{
  periodId: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<WipsWhereConditions>;
}>;


export type UnlockWipBulkMutation = { __typename?: 'Mutation', unlockWipBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type ProjectProgressStatisticsExportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  wip_period_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ProjectProgressStatisticsExportQuery = { __typename?: 'Query', projectProgressStatisticsExport: string };

export type ProjectWipExportQueryVariables = Exact<{
  period_id: Scalars['ID']['input'];
}>;


export type ProjectWipExportQuery = { __typename?: 'Query', projectWipExport: string };

export type ProjectsCommissionExportQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ProjectsCommissionExportQuery = { __typename?: 'Query', projectsCommissionExport: string };

export type ProjectsWipFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectsWipFilterOptionsQuery = { __typename?: 'Query', teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, roles: Array<{ __typename?: 'Role', id: string, name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | null }>, wipPeriodsMap: Array<{ __typename?: 'WipPeriod', id: string, title: string, starts_at: Date, ends_at?: Date | null, is_current: boolean }> };

export type ProjectsWipSummaryQueryVariables = Exact<{
  filters?: InputMaybe<WipQueryArgs>;
}>;


export type ProjectsWipSummaryQuery = { __typename?: 'Query', wipProjectsPeriodSummary: { __typename?: 'PeriodSummary', progress_change: number, progress_change_billable: number, profit_estimate: number, is_period_closed: boolean, is_period_locked: boolean, is_previous_period_closed?: boolean | null } };

export type ProjectsWipTableDataQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<WipQueryArgs>;
}>;


export type ProjectsWipTableDataQuery = { __typename?: 'Query', projectsWithPeriods?: { __typename?: 'WorkInProgressProjectStatPaginator', data: Array<{ __typename?: 'WorkInProgressProjectStat', id: string, total_budget: number, total_budget_change: number, spent_budget: number, spent_budget_percent: number, spent_time: number, remaining_budget: number, remaining_time: number, progress_percent: number, progress_change: number, progress_change_percent: number, profit_estimate: number, profit_estimate_percent: number, is_locked: boolean, is_closed: boolean, project: { __typename?: 'Project', id: string, title: string, code: string, billable: boolean, projectManager: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | null, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, categories: Array<{ __typename?: 'ProjectCategory', name: string }> }, budgetItemsStats?: Array<{ __typename?: 'WorkInProgressItemStat', our_work_budget_item_id: string, work_in_progress_id: string, title: string, total_budget: number, spent_budget: number, spent_budget_percent: number, spent_time: number, remaining_budget: number, remaining_time: number, progress_percent: number, progress_change: number, progress_change_percent: number, profit_estimate: number, profit_estimate_percent: number, total_budget_change: number, is_locked: boolean, is_closed: boolean, deleted: boolean }> | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type ProjectsEffectivenessExportQueryVariables = Exact<{
  filters?: InputMaybe<ProjectQueryArgs>;
  startDate?: InputMaybe<DateRange>;
  finishedAt?: InputMaybe<DateRange>;
  dateOfSupply?: InputMaybe<DateRange>;
}>;


export type ProjectsEffectivenessExportQuery = { __typename?: 'Query', projectsEffectivenessExport: string };

export type MlggkProjectsEffectivenessExportQueryVariables = Exact<{
  filters?: InputMaybe<ProjectQueryArgs>;
  startDate?: InputMaybe<DateRange>;
  finishedAt?: InputMaybe<DateRange>;
  dateOfSupply?: InputMaybe<DateRange>;
}>;


export type MlggkProjectsEffectivenessExportQuery = { __typename?: 'Query', mlggkProjectsEffectivenessExport: string };

export type TriadProjectsEffectivenessExportQueryVariables = Exact<{
  filters?: InputMaybe<ProjectQueryArgs>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type TriadProjectsEffectivenessExportQuery = { __typename?: 'Query', triadProjectsEffectivenessExport: string };

export type StarProjectMutationVariables = Exact<{
  project_id: Scalars['ID']['input'];
  options?: InputMaybe<ProjectStarOptions>;
}>;


export type StarProjectMutation = { __typename?: 'Mutation', starProject: { __typename?: 'Star', id: string, starable_id: string, starable_type: StarsStarableTypeEnum, created_at: Date, updated_at?: Date | null } };

export type UnstarProjectMutationVariables = Exact<{
  project_id: Scalars['ID']['input'];
  options?: InputMaybe<ProjectStarOptions>;
}>;


export type UnstarProjectMutation = { __typename?: 'Mutation', unstarProject: boolean };

export type BulkStarProjectsMutationVariables = Exact<{
  project_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  options?: InputMaybe<ProjectStarOptions>;
}>;


export type BulkStarProjectsMutation = { __typename?: 'Mutation', bulkStarProjects: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type BulkUnstarProjectsMutationVariables = Exact<{
  project_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  options?: InputMaybe<ProjectStarOptions>;
}>;


export type BulkUnstarProjectsMutation = { __typename?: 'Mutation', bulkUnstarProjects: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type FinishedProjectListTableDataSimpleQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type FinishedProjectListTableDataSimpleQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectPaginator', data: Array<{ __typename?: 'Project', id: string, title: string, code: string, is_pinned: boolean, is_starred: boolean, billable: boolean, is_template: boolean, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, projectManager: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type FinishedProjectListTableDataQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type FinishedProjectListTableDataQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectPaginator', data: Array<{ __typename?: 'Project', id: string, title: string, code: string, note?: string | null, billable: boolean, is_pinned: boolean, is_starred: boolean, type: ProjectTypeEnum, finished_at?: Date | null, archived_at?: Date | null, cloudUrl?: string | null, driveCloudUrl?: string | null, is_template: boolean, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, projectManager: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | null, categories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }>, ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, stats: { __typename?: 'OurWorkBudgetItemStats', invoiced_percent: number, efficiency_percent: number, remaining_budget: number, net_margin_percent: number, net_profit: number } }>, expenses: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, category: { __typename?: 'ExpenseBudgetCategory', name: string }, stats: { __typename?: 'ExpenseBudgetItemStats', profit: number, profit_percent: number, invoiced_percent: number } }>, statsCached?: { __typename?: 'ProjectStats', id: string, profit: number, credit: number, unused_sum_from_proformas: number, net_profit: number, net_margin_percent: number, invoiced_percent: number, ourWork: { __typename?: 'ProjectOurWorkStats', id: string, efficiency_percent: number, remaining_budget: number } } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type ProjectListFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectListFilterOptionsQuery = { __typename?: 'Query', teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, name: string, codename?: string | null, full_name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }> };

export type ProjectListTableDataSimpleQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type ProjectListTableDataSimpleQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectPaginator', data: Array<{ __typename?: 'Project', id: string, title: string, code: string, numeric_code?: string | null, is_pinned: boolean, is_starred: boolean, billable: boolean, is_template: boolean, project_stage?: { __typename?: 'ProjectStage', id: string, name: string, system_name?: string | null } | null, projectManager: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }, ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string }>, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type ProjectSubrowsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectSubrowsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, lastWorkInProgressItemStat?: { __typename?: 'WorkInProgressItemStat', work_in_progress_id: string, progress_percent: number, progress: number, spent_time_estimate: number } | null, stats: { __typename?: 'OurWorkBudgetItemStats', id: string, total_budget: number, spent_budget_percent: number, spent_budget: number, spent_time: number, budget_exceeded: number, credit_balance: number, invoiced_percent: number } }> } | null };

export type ProjectsSubrowsForPageQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type ProjectsSubrowsForPageQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectPaginator', data: Array<{ __typename?: 'Project', id: string, ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, lastWorkInProgressItemStat?: { __typename?: 'WorkInProgressItemStat', work_in_progress_id: string, progress_percent: number, progress: number, spent_time_estimate: number } | null, stats: { __typename?: 'OurWorkBudgetItemStats', id: string, total_budget: number, spent_budget_percent: number, spent_budget: number, spent_time: number, budget_exceeded: number, credit_balance: number, invoiced_percent: number } }> }> } | null };

export type ProjectListTableDataQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type ProjectListTableDataQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectPaginator', data: Array<{ __typename?: 'Project', id: string, title: string, code: string, numeric_code?: string | null, note?: string | null, billable: boolean, is_pinned: boolean, is_starred: boolean, type: ProjectTypeEnum, finished_at?: Date | null, archived_at?: Date | null, billingPlanIsMissing: boolean, cloudUrl?: string | null, driveCloudUrl?: string | null, is_template: boolean, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, project_stage?: { __typename?: 'ProjectStage', id: string, name: string, system_name?: string | null } | null, lastWorkInProgressProjectStat?: { __typename?: 'WorkInProgressProjectStat', progress_percent: number, progress: number, spent_time_estimate: number } | null, budgetovacBudget?: { __typename?: 'ProjectBudgetPivot', budget_id?: string | null, internally_approved?: boolean | null, newer_final_version_available: boolean } | null, budgetovacBudgets?: Array<{ __typename?: 'Budget', id: string, internally_approved?: boolean | null, is_active?: boolean | null }> | null, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, projectManager: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | null, categories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }>, ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string }>, ourWorkOverview: Array<{ __typename?: 'OurWorkOverviewBudgetItem', id: string, name: string, budget_exceeded: number }>, expensesStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItem', id: string, name: string, budget_exceeded: number }>, statsCached?: { __typename?: 'ProjectStats', id: string, budget_exceeded: number, credit_balance: number, invoiced_percent: number, total_budget: number, ourWork: { __typename?: 'ProjectOurWorkStats', id: string, total_budget: number, spent_budget: number, spent_time: number, spent_budget_percent: number }, expenses: { __typename?: 'ProjectExpenseStats', id: string, all_items_completed: boolean, planned_expenses: number, planned_commission: number, planned_commission_relative_computed: string, real_expenses: number, real_commission: number, real_commission_relative: string } } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type ProjectListTableSummaryQueryVariables = Exact<{
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type ProjectListTableSummaryQuery = { __typename?: 'Query', projectsSummary: { __typename?: 'ProjectsSummary', total_budget: number, our_work_total_budget: number, our_work_spent_budget: number, our_work_credit_balance: number, our_work_credit_proforma_balance: number, expenses_credit_balance: number, expenses_credit_proforma_balance: number, uninvoiced: number, proforma_uninvoiced: number, projectIds: Array<string>, real_expenses: number } };

export type FinishedProjectListTableSummaryQueryVariables = Exact<{
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type FinishedProjectListTableSummaryQuery = { __typename?: 'Query', projectsSummary: { __typename?: 'ProjectsSummary', projectIds: Array<string>, profit: number, net_profit: number, gross_income: number, net_margin_percent?: number | null, our_work_efficiency: number, credit: number } };

export type PlannedExpensesProjectFragment = { __typename?: 'PlannedExpensesProject', id: string, uninvoiced_amount: number, actual_profit_amount: number, actual_profit_percentage: number, total_planned_client_amount: number, total_planned_budgeted_amount: number, total_budget: number, total_budgeted_with_commission: number, total_buy_price: number, total_expenses_received: number, expenses_received_percentage: number, total_invoiced_amount: number, invoiced_amount_percentage: number, to_plan_buy_price: number, to_plan_buy_price_percentage: number, to_plan_client_price: number, to_plan_client_price_percentage: number, profit_estimate: number, profit_estimate_percentage: number, project: { __typename?: 'Project', id: string, code: string, title: string, brand: { __typename?: 'Brand', id: string, name: string }, projectManager: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } }, budget_items: Array<{ __typename?: 'PlannedExpensesBudgetItem', id: string, title: string, item_code?: string | null, category_name: string, buy_price: number, uninvoiced_amount: number, planned_client_amount: number, planned_budgeted_amount: number, expenses_received: number, expenses_received_percentage: number, invoiced_amount: number, invoiced_amount_percentage: number, actual_profit_amount: number, actual_profit_percentage: number, total_budget: number, total_budgeted_with_commission: number, to_plan_buy_price: number, to_plan_buy_price_percentage: number, to_plan_client_price: number, to_plan_client_price_percentage: number, profit_estimate: number, profit_estimate_percentage: number }> };

export type PlannedExpensesBudgetItemFragment = { __typename?: 'PlannedExpensesBudgetItem', id: string, title: string, item_code?: string | null, category_name: string, buy_price: number, uninvoiced_amount: number, planned_client_amount: number, planned_budgeted_amount: number, expenses_received: number, expenses_received_percentage: number, invoiced_amount: number, invoiced_amount_percentage: number, actual_profit_amount: number, actual_profit_percentage: number, total_budget: number, total_budgeted_with_commission: number, to_plan_buy_price: number, to_plan_buy_price_percentage: number, to_plan_client_price: number, to_plan_client_price_percentage: number, profit_estimate: number, profit_estimate_percentage: number };

export type PlannedExpensesSummaryFragment = { __typename?: 'PlannedExpensesSummary', uninvoiced_amount: number, uninvoiced_amount_percentage: number, actual_profit_amount: number, actual_profit_percentage: number, total_planned_client_amount: number, planned_client_amount_percentage: number, total_planned_budgeted_amount: number, planned_budgeted_amount_percentage: number, total_budget: number, total_budgeted_with_commission: number, total_buy_price: number, total_expenses_received: number, expenses_received_percentage: number, total_invoiced_amount: number, invoiced_amount_percentage: number, to_plan_buy_price: number, to_plan_buy_price_percentage: number, to_plan_client_price: number, to_plan_client_price_percentage: number, profit_estimate: number, profit_estimate_percentage: number };

export type PlannedExpensesOverviewQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<PlannedExpensesQueryArgs>;
}>;


export type PlannedExpensesOverviewQuery = { __typename?: 'Query', plannedExpensesOverview?: { __typename?: 'PlannedExpensesProjectPaginator', data: Array<{ __typename?: 'PlannedExpensesProject', id: string, uninvoiced_amount: number, actual_profit_amount: number, actual_profit_percentage: number, total_planned_client_amount: number, total_planned_budgeted_amount: number, total_budget: number, total_budgeted_with_commission: number, total_buy_price: number, total_expenses_received: number, expenses_received_percentage: number, total_invoiced_amount: number, invoiced_amount_percentage: number, to_plan_buy_price: number, to_plan_buy_price_percentage: number, to_plan_client_price: number, to_plan_client_price_percentage: number, profit_estimate: number, profit_estimate_percentage: number, project: { __typename?: 'Project', id: string, code: string, title: string, brand: { __typename?: 'Brand', id: string, name: string }, projectManager: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } }, budget_items: Array<{ __typename?: 'PlannedExpensesBudgetItem', id: string, title: string, item_code?: string | null, category_name: string, buy_price: number, uninvoiced_amount: number, planned_client_amount: number, planned_budgeted_amount: number, expenses_received: number, expenses_received_percentage: number, invoiced_amount: number, invoiced_amount_percentage: number, actual_profit_amount: number, actual_profit_percentage: number, total_budget: number, total_budgeted_with_commission: number, to_plan_buy_price: number, to_plan_buy_price_percentage: number, to_plan_client_price: number, to_plan_client_price_percentage: number, profit_estimate: number, profit_estimate_percentage: number }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type PlannedExpensesOverviewSummaryQueryVariables = Exact<{
  filters?: InputMaybe<PlannedExpensesQueryArgs>;
}>;


export type PlannedExpensesOverviewSummaryQuery = { __typename?: 'Query', plannedExpensesOverviewSummary: { __typename?: 'PlannedExpensesSummary', uninvoiced_amount: number, uninvoiced_amount_percentage: number, actual_profit_amount: number, actual_profit_percentage: number, total_planned_client_amount: number, planned_client_amount_percentage: number, total_planned_budgeted_amount: number, planned_budgeted_amount_percentage: number, total_budget: number, total_budgeted_with_commission: number, total_buy_price: number, total_expenses_received: number, expenses_received_percentage: number, total_invoiced_amount: number, invoiced_amount_percentage: number, to_plan_buy_price: number, to_plan_buy_price_percentage: number, to_plan_client_price: number, to_plan_client_price_percentage: number, profit_estimate: number, profit_estimate_percentage: number } };

export type PlannedExpensesFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlannedExpensesFilterOptionsQuery = { __typename?: 'Query', teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, codename?: string | null, full_name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectCategories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }>, projectStages: Array<{ __typename?: 'ProjectStage', id: string, name: string }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, code: string, title: string }> };

export type GetProjectSettingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectSettingsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, uses_budgetovac: boolean, finished_at?: Date | null, average_time_tracking_rate?: number | null, calculated_average_time_tracking_rate?: number | null, rate_card_id?: string | null, rate_card_exchange_rate: number, type: ProjectTypeEnum, code: string, numeric_code?: string | null, title: string, billable: boolean, timeTrackingRates: Array<{ __typename?: 'TimeTrackingRate', rate: number, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string } }>, ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean } }>, budgetovacBudget?: { __typename?: 'ProjectBudgetPivot', budget_id?: string | null } | null, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } } | null };

export type UpdateTimeTrackingSettingsForProjectMutationVariables = Exact<{
  input: UpdateTimeTrackingSettingsInput;
}>;


export type UpdateTimeTrackingSettingsForProjectMutation = { __typename?: 'Mutation', updateTimeTrackingSettingsForProject: { __typename?: 'Project', ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean } }> } };

export type UpdateTimeTrackingRatesForProjectMutationVariables = Exact<{
  input: UpdateTimeTrackingRatesForProjectInput;
}>;


export type UpdateTimeTrackingRatesForProjectMutation = { __typename?: 'Mutation', updateTimeTrackingRatesForProject: { __typename?: 'Project', average_time_tracking_rate?: number | null, timeTrackingRates: Array<{ __typename?: 'TimeTrackingRate', rate: number, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string } }> } };

export type ChangeRateCardOnProjectMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  rateCardId: Scalars['ID']['input'];
  exchangeRate?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type ChangeRateCardOnProjectMutation = { __typename?: 'Mutation', changeRateCardOnProject?: { __typename?: 'Project', rate_card_id?: string | null } | null };

export type DistributionModalTableItemFragment = { __typename?: 'TimeTrackingReport', id: string, tracked_for_date: Date, user_full_name?: string | null, user_id?: string | null, task_name: string, task_id: string, our_work_budget_item_title: string, note?: string | null, tracked_time: number, billable: boolean, hourly_rate?: number | null, amount?: number | null };

export type DistributionModalTableDataQueryVariables = Exact<{
  first: Scalars['BigInt']['input'];
  page?: InputMaybe<Scalars['BigInt']['input']>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
  orderBy?: InputMaybe<Array<TimeTrackingItemOrderByClause> | TimeTrackingItemOrderByClause>;
}>;


export type DistributionModalTableDataQuery = { __typename?: 'Query', getTimeTrackingItems: { __typename?: 'GetTimeTrackingItemsPaginator', data: Array<{ __typename?: 'TimeTrackingReport', id: string, tracked_for_date: Date, user_full_name?: string | null, user_id?: string | null, task_name: string, task_id: string, our_work_budget_item_title: string, note?: string | null, tracked_time: number, billable: boolean, hourly_rate?: number | null, amount?: number | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type DistributionModalFilterOptionsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  userSimpleWhere?: InputMaybe<UsersWhereConditions>;
}>;


export type DistributionModalFilterOptionsQuery = { __typename?: 'Query', ourWorkBudgetItemsSimpleMap: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null } }>, timeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string }>, userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, name: string, full_name: string, codename?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }> };

export type TimeBillingExpenseItemsForModalQueryVariables = Exact<{
  filters?: InputMaybe<ExpenseItemsTimeBillingQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TimeBillingExpenseItemsForModalQuery = { __typename?: 'Query', expenseItemsForTimeBilling?: { __typename?: 'ExpenseItemPaginator', data: Array<{ __typename?: 'ExpenseItem', id: string, amount: number, budget_item_type: ExpenseBudgetItemTypeEnum, description?: { __typename?: 'ExpenseItemDesciption', title: string } | null, expense: { __typename?: 'Expense', id: string, expense_no?: string | null, document_number?: string | null, date_of_supply?: Date | null, contractor?: { __typename?: 'Contractor', legal_name: string } | null }, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type TimeBillingOiBudgetItemsForModalQueryVariables = Exact<{
  filters?: InputMaybe<OiBudgetItemsTimeBillingQueryArgs>;
}>;


export type TimeBillingOiBudgetItemsForModalQuery = { __typename?: 'Query', oiBudgetItemsForTimeBilling: { __typename?: 'OIBudgetItemsForTimeBillingPaginator', data: Array<{ __typename?: 'OIBudgetItemForTimeBilling', outgoing_invoice_id: string, budget_item_id: string, budget_item_type: BudgetItemTypeEnum, amount: number, outgoingInvoice: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: Date, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } }, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type TimeBillingSourcesEditModalFilterOptionsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type TimeBillingSourcesEditModalFilterOptionsQuery = { __typename?: 'Query', ourWorkBudgetItemsSimpleMap: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string } }>, expenseBudgetItemsSimpleMap: Array<{ __typename?: 'ExpenseBudgetItemSimple', id: string, title: string, category: { __typename?: 'ExpenseBudgetCategory', name: string } }> };

export type ProjectTimeBillingUserRowPreviewFragment = { __typename?: 'ProjectTimeBillingUserRowPreview', user_id?: string | null, time_tracking_work_type_id?: string | null, team_id?: string | null, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | null, team?: { __typename?: 'Team', id: string, name: string } | null };

export type ProjectTimeBillingUserRowFragment = { __typename?: 'ProjectTimeBillingUserRow', id: string, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | null, team?: { __typename?: 'Team', id: string, name: string } | null };

export type ProjectTimeBillingSourcePreviewFragment = { __typename?: 'ProjectTimeBillingSourcePreview', source_type: TimeBillingSourceTypeEnum, source_id?: string | null, outgoing_invoice_id?: string | null, budget_item_id?: string | null, budget_item_type?: BudgetItemTypeEnum | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null } | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | null, document_number?: string | null, date_of_supply?: Date | null, note?: string | null, contractor?: { __typename?: 'Contractor', legal_name: string } | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | null } | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: Date, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null };

export type ProjectTimeBillingSourceFragment = { __typename?: 'ProjectTimeBillingSource', source_type: TimeBillingSourceTypeEnum, source_id?: string | null, outgoing_invoice_id?: string | null, budget_item_id?: string | null, budget_item_type?: BudgetItemTypeEnum | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null } | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | null, document_number?: string | null, date_of_supply?: Date | null, note?: string | null, contractor?: { __typename?: 'Contractor', legal_name: string } | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | null } | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: Date, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null };

export type ProjectTimeBillingComponentPreviewFragment = { __typename?: 'ProjectTimeBillingComponentPreview', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean, source_id?: string | null, source_type?: TimeBillingSourceTypeEnum | null };

export type ProjectTimeBillingComponentFragment = { __typename?: 'ProjectTimeBillingComponent', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean };

export type ProjectTimeBillingComputedFragment = { __typename?: 'ProjectTimeBillingComputed', date_from: Date, date_to: Date, computed_total_amount: number, sources: Array<{ __typename?: 'ProjectTimeBillingSourcePreview', source_type: TimeBillingSourceTypeEnum, source_id?: string | null, outgoing_invoice_id?: string | null, budget_item_id?: string | null, budget_item_type?: BudgetItemTypeEnum | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null } | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | null, document_number?: string | null, date_of_supply?: Date | null, note?: string | null, contractor?: { __typename?: 'Contractor', legal_name: string } | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | null } | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: Date, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null }>, components: Array<{ __typename?: 'ProjectTimeBillingComponentPreview', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean, source_id?: string | null, source_type?: TimeBillingSourceTypeEnum | null }>, userRows: Array<{ __typename?: 'ProjectTimeBillingUserRowPreview', user_id?: string | null, time_tracking_work_type_id?: string | null, team_id?: string | null, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | null, team?: { __typename?: 'Team', id: string, name: string } | null }>, distributions: Array<{ __typename?: 'ProjectTimeBillingDistributionPreview', time_tracking_item_id: string }> };

export type ProjectTimeBillingListItemFragment = { __typename?: 'ProjectTimeBilling', id: string, title?: string | null, date_from: Date, date_to: Date, type: TimeBillingTypeEnum, final_total_amount: number, final_total_note?: string | null, is_locked: boolean, locked_at?: Date | null, created_at: Date, lockedByUser?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, createdByUser: { __typename?: 'User', id: string, full_name: string } };

export type ProjectTimeBillingDistributionPreviewFragment = { __typename?: 'ProjectTimeBillingDistributionPreview', time_tracking_item_id: string, invoiced_seconds: number, overserviced_seconds: number, uninvoiced_seconds: number, timeTrackingItem: { __typename?: 'TimeTrackingItem', tracked_for_date: Date, tracked_time: number, note?: string | null, billable: boolean, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, task: { __typename?: 'Task', id: string, name: string } } };

export type ProjectTimeBillingDetailFragment = { __typename?: 'ProjectTimeBilling', id: string, title?: string | null, date_from: Date, date_to: Date, type: TimeBillingTypeEnum, final_total_amount: number, final_total_note?: string | null, is_locked: boolean, locked_at?: Date | null, created_at: Date, sources: Array<{ __typename?: 'ProjectTimeBillingSource', source_type: TimeBillingSourceTypeEnum, source_id?: string | null, outgoing_invoice_id?: string | null, budget_item_id?: string | null, budget_item_type?: BudgetItemTypeEnum | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null } | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | null, document_number?: string | null, date_of_supply?: Date | null, note?: string | null, contractor?: { __typename?: 'Contractor', legal_name: string } | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | null } | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: Date, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null }>, components: Array<{ __typename?: 'ProjectTimeBillingComponent', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean }>, userRows: Array<{ __typename?: 'ProjectTimeBillingUserRow', id: string, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | null, team?: { __typename?: 'Team', id: string, name: string } | null }>, distributions: Array<{ __typename?: 'ProjectTimeBillingDistribution', time_tracking_item_id: string }>, lockedByUser?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, createdByUser: { __typename?: 'User', id: string, full_name: string } };

export type CreateProjectTimeBillingMutationVariables = Exact<{
  input: CreateProjectTimeBillingInput;
}>;


export type CreateProjectTimeBillingMutation = { __typename?: 'Mutation', createProjectTimeBilling: { __typename?: 'ProjectTimeBilling', id: string, title?: string | null, date_from: Date, date_to: Date, type: TimeBillingTypeEnum, final_total_amount: number, final_total_note?: string | null, is_locked: boolean, locked_at?: Date | null, created_at: Date, sources: Array<{ __typename?: 'ProjectTimeBillingSource', source_type: TimeBillingSourceTypeEnum, source_id?: string | null, outgoing_invoice_id?: string | null, budget_item_id?: string | null, budget_item_type?: BudgetItemTypeEnum | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null } | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | null, document_number?: string | null, date_of_supply?: Date | null, note?: string | null, contractor?: { __typename?: 'Contractor', legal_name: string } | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | null } | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: Date, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null }>, components: Array<{ __typename?: 'ProjectTimeBillingComponent', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean }>, userRows: Array<{ __typename?: 'ProjectTimeBillingUserRow', id: string, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | null, team?: { __typename?: 'Team', id: string, name: string } | null }>, distributions: Array<{ __typename?: 'ProjectTimeBillingDistribution', time_tracking_item_id: string }>, lockedByUser?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, createdByUser: { __typename?: 'User', id: string, full_name: string } } };

export type UpdateProjectTimeBillingMutationVariables = Exact<{
  input: UpdateProjectTimeBillingInput;
}>;


export type UpdateProjectTimeBillingMutation = { __typename?: 'Mutation', updateProjectTimeBilling: { __typename?: 'ProjectTimeBilling', id: string, title?: string | null, date_from: Date, date_to: Date, type: TimeBillingTypeEnum, final_total_amount: number, final_total_note?: string | null, is_locked: boolean, locked_at?: Date | null, created_at: Date, sources: Array<{ __typename?: 'ProjectTimeBillingSource', source_type: TimeBillingSourceTypeEnum, source_id?: string | null, outgoing_invoice_id?: string | null, budget_item_id?: string | null, budget_item_type?: BudgetItemTypeEnum | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null } | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | null, document_number?: string | null, date_of_supply?: Date | null, note?: string | null, contractor?: { __typename?: 'Contractor', legal_name: string } | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | null } | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: Date, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null }>, components: Array<{ __typename?: 'ProjectTimeBillingComponent', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean }>, userRows: Array<{ __typename?: 'ProjectTimeBillingUserRow', id: string, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | null, team?: { __typename?: 'Team', id: string, name: string } | null }>, distributions: Array<{ __typename?: 'ProjectTimeBillingDistribution', time_tracking_item_id: string }>, lockedByUser?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, createdByUser: { __typename?: 'User', id: string, full_name: string } } };

export type LockProjectTimeBillingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LockProjectTimeBillingMutation = { __typename?: 'Mutation', lockProjectTimeBilling: { __typename?: 'ProjectTimeBilling', id: string, title?: string | null, date_from: Date, date_to: Date, type: TimeBillingTypeEnum, final_total_amount: number, final_total_note?: string | null, is_locked: boolean, locked_at?: Date | null, created_at: Date, sources: Array<{ __typename?: 'ProjectTimeBillingSource', source_type: TimeBillingSourceTypeEnum, source_id?: string | null, outgoing_invoice_id?: string | null, budget_item_id?: string | null, budget_item_type?: BudgetItemTypeEnum | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null } | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | null, document_number?: string | null, date_of_supply?: Date | null, note?: string | null, contractor?: { __typename?: 'Contractor', legal_name: string } | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | null } | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: Date, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null }>, components: Array<{ __typename?: 'ProjectTimeBillingComponent', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean }>, userRows: Array<{ __typename?: 'ProjectTimeBillingUserRow', id: string, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | null, team?: { __typename?: 'Team', id: string, name: string } | null }>, distributions: Array<{ __typename?: 'ProjectTimeBillingDistribution', time_tracking_item_id: string }>, lockedByUser?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, createdByUser: { __typename?: 'User', id: string, full_name: string } } };

export type UnlockProjectTimeBillingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnlockProjectTimeBillingMutation = { __typename?: 'Mutation', unlockProjectTimeBilling: { __typename?: 'ProjectTimeBilling', id: string, title?: string | null, date_from: Date, date_to: Date, type: TimeBillingTypeEnum, final_total_amount: number, final_total_note?: string | null, is_locked: boolean, locked_at?: Date | null, created_at: Date, sources: Array<{ __typename?: 'ProjectTimeBillingSource', source_type: TimeBillingSourceTypeEnum, source_id?: string | null, outgoing_invoice_id?: string | null, budget_item_id?: string | null, budget_item_type?: BudgetItemTypeEnum | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null } | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | null, document_number?: string | null, date_of_supply?: Date | null, note?: string | null, contractor?: { __typename?: 'Contractor', legal_name: string } | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | null } | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: Date, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null }>, components: Array<{ __typename?: 'ProjectTimeBillingComponent', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean }>, userRows: Array<{ __typename?: 'ProjectTimeBillingUserRow', id: string, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | null, team?: { __typename?: 'Team', id: string, name: string } | null }>, distributions: Array<{ __typename?: 'ProjectTimeBillingDistribution', time_tracking_item_id: string }>, lockedByUser?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, createdByUser: { __typename?: 'User', id: string, full_name: string } } };

export type DeleteProjectTimeBillingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectTimeBillingMutation = { __typename?: 'Mutation', deleteProjectTimeBilling: boolean };

export type CreateDataForProjectTimeBillingQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
}>;


export type CreateDataForProjectTimeBillingQuery = { __typename?: 'Query', createDataForProjectTimeBilling: { __typename?: 'ProjectTimeBillingComputed', date_from: Date, date_to: Date, computed_total_amount: number, sources: Array<{ __typename?: 'ProjectTimeBillingSourcePreview', source_type: TimeBillingSourceTypeEnum, source_id?: string | null, outgoing_invoice_id?: string | null, budget_item_id?: string | null, budget_item_type?: BudgetItemTypeEnum | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null } | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | null, document_number?: string | null, date_of_supply?: Date | null, note?: string | null, contractor?: { __typename?: 'Contractor', legal_name: string } | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | null } | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: Date, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null }>, components: Array<{ __typename?: 'ProjectTimeBillingComponentPreview', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean, source_id?: string | null, source_type?: TimeBillingSourceTypeEnum | null }>, userRows: Array<{ __typename?: 'ProjectTimeBillingUserRowPreview', user_id?: string | null, time_tracking_work_type_id?: string | null, team_id?: string | null, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | null, team?: { __typename?: 'Team', id: string, name: string } | null }>, distributions: Array<{ __typename?: 'ProjectTimeBillingDistributionPreview', time_tracking_item_id: string }> } };

export type ProjectTimeBillingsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QueryProjectTimeBillingsOrderByOrderByClause> | QueryProjectTimeBillingsOrderByOrderByClause>;
}>;


export type ProjectTimeBillingsQuery = { __typename?: 'Query', projectTimeBillings?: { __typename?: 'ProjectTimeBillingPaginator', data: Array<{ __typename?: 'ProjectTimeBilling', id: string, title?: string | null, date_from: Date, date_to: Date, type: TimeBillingTypeEnum, final_total_amount: number, final_total_note?: string | null, is_locked: boolean, locked_at?: Date | null, created_at: Date, lockedByUser?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, createdByUser: { __typename?: 'User', id: string, full_name: string } }>, paginatorInfo: { __typename?: 'PaginatorInfo', currentPage: number, lastPage: number, total: number, hasMorePages: boolean } } | null };

export type ProjectTimeBillingDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectTimeBillingDetailQuery = { __typename?: 'Query', projectTimeBilling?: { __typename?: 'ProjectTimeBilling', id: string, title?: string | null, date_from: Date, date_to: Date, type: TimeBillingTypeEnum, final_total_amount: number, final_total_note?: string | null, is_locked: boolean, locked_at?: Date | null, created_at: Date, sources: Array<{ __typename?: 'ProjectTimeBillingSource', source_type: TimeBillingSourceTypeEnum, source_id?: string | null, outgoing_invoice_id?: string | null, budget_item_id?: string | null, budget_item_type?: BudgetItemTypeEnum | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null } | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | null, document_number?: string | null, date_of_supply?: Date | null, note?: string | null, contractor?: { __typename?: 'Contractor', legal_name: string } | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | null } | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: Date, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null }>, components: Array<{ __typename?: 'ProjectTimeBillingComponent', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean }>, userRows: Array<{ __typename?: 'ProjectTimeBillingUserRow', id: string, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | null, team?: { __typename?: 'Team', id: string, name: string } | null }>, distributions: Array<{ __typename?: 'ProjectTimeBillingDistribution', time_tracking_item_id: string }>, lockedByUser?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, createdByUser: { __typename?: 'User', id: string, full_name: string } } | null };

export type PreviewProjectTimeBillingQueryVariables = Exact<{
  input: PreviewProjectTimeBillingInput;
}>;


export type PreviewProjectTimeBillingQuery = { __typename?: 'Query', previewProjectTimeBilling: { __typename?: 'ProjectTimeBillingComputed', date_from: Date, date_to: Date, computed_total_amount: number, sources: Array<{ __typename?: 'ProjectTimeBillingSourcePreview', source_type: TimeBillingSourceTypeEnum, source_id?: string | null, outgoing_invoice_id?: string | null, budget_item_id?: string | null, budget_item_type?: BudgetItemTypeEnum | null, amount: number, expenseItem?: { __typename?: 'ExpenseItem', id: string, amount: number, description?: { __typename?: 'ExpenseItemDesciption', title: string } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null } | null, expense?: { __typename?: 'Expense', id: string, expense_no?: string | null, document_number?: string | null, date_of_supply?: Date | null, note?: string | null, contractor?: { __typename?: 'Contractor', legal_name: string } | null, emailData?: { __typename?: 'ExpenseEmailData', text: string } | null } | null, outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, issue_date: Date, billingEntity: { __typename?: 'BillingEntity', internal_name: string, street: string, city: string } } | null, budgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null }>, components: Array<{ __typename?: 'ProjectTimeBillingComponentPreview', key: TimeBillingComponentKeyEnum, amount: number, use_in_total: boolean, source_id?: string | null, source_type?: TimeBillingSourceTypeEnum | null }>, userRows: Array<{ __typename?: 'ProjectTimeBillingUserRowPreview', user_id?: string | null, time_tracking_work_type_id?: string | null, team_id?: string | null, tracked_time: number, tracked_hours: number, client_rate: number, spent: number, effective_hourly_rate: number, amount: number, invoiced_time: number, overserviced_time: number, effective_hourly_rate_invoiced: number, user?: { __typename?: 'User', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } | null, position?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | null, team?: { __typename?: 'Team', id: string, name: string } | null }>, distributions: Array<{ __typename?: 'ProjectTimeBillingDistributionPreview', time_tracking_item_id: string }> } };

export type UpdateProjectTimeBreakdownItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  budgeted: Scalars['Int']['input'];
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
}>;


export type UpdateProjectTimeBreakdownItemMutation = { __typename?: 'Mutation', updateProjectTimeBreakdown: { __typename?: 'ProjectTimeBreakdown', id: string } };

export type TimeTrackingProjectReportQueryVariables = Exact<{
  filters?: InputMaybe<TimeTrackingProjectReportQueryArgs>;
}>;


export type TimeTrackingProjectReportQuery = { __typename?: 'Query', timeTrackingProjectReport?: Array<{ __typename?: 'TimeTrackingProjectReport', user_id?: string | null, team_id?: string | null, user_full_name?: string | null, tracked_time: number, amount: number, invoiced_amount: number, time_tracking_work_type_title?: string | null, group_tracked_time: number, group_amount: number, our_work_budget_item_title?: string | null, hourly_rate?: number | null, internal_hourly_rate?: number | null, image?: string | null, time_tracking_work_type_id?: string | null, our_work_budget_item_id?: string | null, personal_expense?: number | null, personal_profitability?: number | null, invoiced_personal_profitability?: number | null, billable_all: boolean, invoiced_seconds?: number | null, overserviced_seconds?: number | null, uninvoiced_seconds?: number | null } | null> | null };

export type ProjectOurWorkItemsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectOurWorkItemsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', uses_budgetovac: boolean, start_date: Date, finished_at?: Date | null, expected_end_date?: Date | null, code: string, numeric_code?: string | null, title: string, billable: boolean, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string }> } | null };

export type ProjectTimeBreakdownQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectTimeBreakdownQuery = { __typename?: 'Query', projectTimeBreakdowns: Array<{ __typename?: 'ProjectTimeBreakdownResponse', id: string, title: string, tracked_time: number, tracked_amount: number, budgeted: number, budgeted_time: number, personal_expenses: number, profit: number, time_breakdown: Array<{ __typename?: 'ProjectTimeBreakdownDetail', id: string, date_from?: Date | null, date_to?: Date | null, tracked_time: number, tracked_amount: number, budgeted: number, budgeted_time: number, personal_expenses: number, profit: number }> }> };

export type BrandTableDataFragment = { __typename?: 'BrandWithRevenueResult', id: string, name: string, gross_income_for_date_range: number, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null };

export type BrandReportOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandReportOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string }> };

export type BrandProfitAndRevenueSummaryQueryVariables = Exact<{
  filters?: InputMaybe<BrandRevenueQueryArgs>;
}>;


export type BrandProfitAndRevenueSummaryQuery = { __typename?: 'Query', brandRevenueSummary: { __typename?: 'BrandRevenueSummary', our_work_revenue_for_date_range: number, our_work_billings_for_date_range: number, our_work_revenue_for_date_range_percentage: number, gross_profit_for_date_range: number, gross_income_for_date_range: number, total_invoiced: number, expense_revenue_for_date_range: Array<{ __typename?: 'ExpenseRevenueByCategory', profit: number, profit_percentage: number, billings: number, category: { __typename?: 'ExpenseBudgetCategory', id: string, name: string } }>, brand_profit_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | null, brand_revenue_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | null, client_revenue_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | null } };

export type BrandProfitAndRevenueTableDataQueryVariables = Exact<{
  filters?: InputMaybe<BrandRevenueQueryArgs>;
}>;


export type BrandProfitAndRevenueTableDataQuery = { __typename?: 'Query', expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | null, brandRevenue: { __typename?: 'BrandRevenue', result: Array<{ __typename?: 'BrandWithRevenueResult', gross_profit_for_date_range: number, our_work_revenue_for_date_range: number, filtered_profit_share: number, total_profit_share: number, total_invoiced: number, our_work_billings_for_date_range: number, filtered_revenue_share: number, total_revenue_share: number, id: string, name: string, gross_income_for_date_range: number, expenses_profit_for_date_range: Array<{ __typename?: 'ProjectRevenueProfitByExpenseCategory', expense_budget_category_id: string, profit?: number | null }>, expenses_billings_for_date_range: Array<{ __typename?: 'ProjectRevenueBillingsByExpenseCategory', expense_budget_category_id: string, billings?: number | null }>, brands?: Array<{ __typename?: 'BrandWithRevenue', id: string, name: string, gross_income_for_date_range: number, gross_profit_for_date_range: number, our_work_revenue_for_date_range: number, filtered_profit_share: number, total_profit_share: number, total_invoiced: number, our_work_billings_for_date_range: number, filtered_revenue_share: number, total_revenue_share: number, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, expenses_profit_for_date_range: Array<{ __typename?: 'ProjectRevenueProfitByExpenseCategory', expense_budget_category_id: string, profit?: number | null }>, expenses_billings_for_date_range: Array<{ __typename?: 'ProjectRevenueBillingsByExpenseCategory', expense_budget_category_id: string, billings?: number | null }> }> | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type BrandProfitSummaryQueryVariables = Exact<{
  filters?: InputMaybe<BrandRevenueQueryArgs>;
}>;


export type BrandProfitSummaryQuery = { __typename?: 'Query', brandRevenueSummary: { __typename?: 'BrandRevenueSummary', our_work_revenue_for_date_range: number, our_work_revenue_for_date_range_percentage: number, gross_profit_for_date_range: number, expense_revenue_for_date_range: Array<{ __typename?: 'ExpenseRevenueByCategory', profit: number, profit_percentage: number, billings: number, category: { __typename?: 'ExpenseBudgetCategory', id: string, name: string } }>, brand_profit_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | null, profit_top_clients?: Array<{ __typename?: 'TopClient', name: string, total_value: number, brands: Array<{ __typename?: 'TopBrand', name: string, value: number }> }> | null } };

export type BrandProfitTableDataQueryVariables = Exact<{
  filters?: InputMaybe<BrandRevenueQueryArgs>;
}>;


export type BrandProfitTableDataQuery = { __typename?: 'Query', expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | null, brandRevenue: { __typename?: 'BrandRevenue', result: Array<{ __typename?: 'BrandWithRevenueResult', gross_profit_for_date_range: number, our_work_revenue_for_date_range: number, filtered_profit_share: number, total_profit_share: number, id: string, name: string, gross_income_for_date_range: number, expenses_profit_for_date_range: Array<{ __typename?: 'ProjectRevenueProfitByExpenseCategory', expense_budget_category_id: string, profit?: number | null }>, brands?: Array<{ __typename?: 'BrandWithRevenue', id: string, name: string, gross_income_for_date_range: number, gross_profit_for_date_range: number, our_work_revenue_for_date_range: number, filtered_profit_share: number, total_profit_share: number, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, expenses_profit_for_date_range: Array<{ __typename?: 'ProjectRevenueProfitByExpenseCategory', expense_budget_category_id: string, profit?: number | null }> }> | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type BrandRevenueSummaryQueryVariables = Exact<{
  filters?: InputMaybe<BrandRevenueQueryArgs>;
}>;


export type BrandRevenueSummaryQuery = { __typename?: 'Query', brandRevenueSummary: { __typename?: 'BrandRevenueSummary', our_work_billings_for_date_range: number, gross_income_for_date_range: number, total_invoiced: number, expense_revenue_for_date_range: Array<{ __typename?: 'ExpenseRevenueByCategory', profit: number, billings: number, category: { __typename?: 'ExpenseBudgetCategory', id: string, name: string } }>, brand_revenue_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | null, client_revenue_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | null, revenue_top_clients?: Array<{ __typename?: 'TopClient', name: string, total_value: number, brands: Array<{ __typename?: 'TopBrand', name: string, value: number }> }> | null } };

export type BrandRevenueTableDataQueryVariables = Exact<{
  filters?: InputMaybe<BrandRevenueQueryArgs>;
}>;


export type BrandRevenueTableDataQuery = { __typename?: 'Query', expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | null, brandRevenue: { __typename?: 'BrandRevenue', result: Array<{ __typename?: 'BrandWithRevenueResult', total_invoiced: number, our_work_billings_for_date_range: number, filtered_revenue_share: number, total_revenue_share: number, id: string, name: string, gross_income_for_date_range: number, expenses_billings_for_date_range: Array<{ __typename?: 'ProjectRevenueBillingsByExpenseCategory', expense_budget_category_id: string, billings?: number | null }>, brands?: Array<{ __typename?: 'BrandWithRevenue', id: string, name: string, gross_income_for_date_range: number, total_invoiced: number, our_work_billings_for_date_range: number, filtered_revenue_share: number, total_revenue_share: number, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, expenses_billings_for_date_range: Array<{ __typename?: 'ProjectRevenueBillingsByExpenseCategory', expense_budget_category_id: string, billings?: number | null }> }> | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type ProfitAndLossReportColumnFragment = { __typename?: 'ProfitLossReportColumn', title: string, expenses_amount: number, invoiced_amount: number, balance_amount: number };

export type ProfitAndLossReportQueryVariables = Exact<{
  where?: InputMaybe<ProfitLossReportWhereConditions>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  rows: ProfitLossReportRows;
  columns?: InputMaybe<ProfitLossReportColumns>;
  page: Scalars['BigInt']['input'];
  first: Scalars['BigInt']['input'];
  includeDraftExpenses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProfitAndLossReportQuery = { __typename?: 'Query', profitLossReport: { __typename?: 'ProfitLossReportGroupPaginator', data: Array<{ __typename?: 'ProfitLossReportGroup', id: string, title: string, columns: Array<{ __typename?: 'ProfitLossReportColumn', title: string, expenses_amount: number, invoiced_amount: number, balance_amount: number }>, items: Array<{ __typename?: 'ProfitLossReport', id: string, title: string, columns: Array<{ __typename?: 'ProfitLossReportColumn', title: string, expenses_amount: number, invoiced_amount: number, balance_amount: number }> }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type ProfitAndLossReportSummaryQueryVariables = Exact<{
  where?: InputMaybe<ProfitLossReportWhereConditions>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  columns?: InputMaybe<ProfitLossReportColumns>;
  includeDraftExpenses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProfitAndLossReportSummaryQuery = { __typename?: 'Query', profitLossReportSummary: { __typename?: 'ProfitLossReportSummary', data: Array<{ __typename?: 'ProfitLossReportColumn', title: string, expenses_amount: number, invoiced_amount: number, balance_amount: number }> } };

export type ProfitAndLossFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfitAndLossFilterOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string, code: string }> }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }>, projectCategories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }>, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string }> };

export type ProjectTableDataFragment = { __typename?: 'ProjectWithRevenueItem', id: string, title: string, code: string, note?: string | null, finished_at?: Date | null, archived_at?: Date | null, status: ProjectStatusEnum, gross_income_for_date_range: number, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, projectManager: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } };

export type UpdateProjectNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  isTemplate: Scalars['Boolean']['input'];
}>;


export type UpdateProjectNoteMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string, note?: string | null } };

export type UpdateOwbiNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOwbiNoteMutation = { __typename?: 'Mutation', updateOurWorkBudgetItemNote: { __typename?: 'OurWorkBudgetItem', id: string, note?: string | null } };

export type UpdateExbiNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateExbiNoteMutation = { __typename?: 'Mutation', updateExpenseBudgetItemNote: { __typename?: 'ExpenseBudgetItem', id: string, note?: string | null } };

export type ProjectReportOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectReportOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }> };

export type ProjectRevenueDetailQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type ProjectRevenueDetailQuery = { __typename?: 'Query', projectRevenueDetail: { __typename?: 'ProjectWithRevenue', ourWork: Array<{ __typename?: 'OurWorkBudgetItemWithRevenue', billings_for_date_range?: number | null, revenue_for_date_range?: number | null, ourWorkBudgetItem: { __typename?: 'OurWorkBudgetItem', id: string, title: string, note?: string | null, stats: { __typename?: 'OurWorkBudgetItemStats', net_profit: number, net_margin_percent: number } } }>, expensesStructured: Array<{ __typename?: 'ExpenseStructuredBudgetItemWithRevenue', expenseBudgetCategory: { __typename?: 'ExpenseBudgetCategory', id: string, name: string }, budgetItems: Array<{ __typename?: 'ExpenseBudgetItemWithRevenue', billings_for_date_range?: number | null, profit_for_date_range?: number | null, expenseBudgetItem: { __typename?: 'ExpenseBudgetItem', completed_at?: Date | null, id: string, type: ExpenseBudgetItemType, title: string, note?: string | null, category: { __typename?: 'ExpenseBudgetCategory', name: string }, stats: { __typename?: 'ExpenseBudgetItemStats', credit: number, profit: number, profit_percent: number, real_expenses: number } } }> }> } };

export type ProjectsReportExportQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type ProjectsReportExportQuery = { __typename?: 'Query', projectsProfitExport: string };

export type ProjectProfitAndRevenueSummaryQueryVariables = Exact<{
  filters?: InputMaybe<ProjectRevenueQueryArgs>;
}>;


export type ProjectProfitAndRevenueSummaryQuery = { __typename?: 'Query', projectRevenueSummary: { __typename?: 'ProjectRevenueSummary', our_work_revenue_for_date_range: number, our_work_billings_for_date_range: number, our_work_revenue_for_date_range_percentage: number, gross_profit_for_date_range: number, gross_income_for_date_range: number, total_invoiced: number, expense_revenue_for_date_range: Array<{ __typename?: 'ExpenseRevenueByCategory', profit: number, profit_percentage: number, billings: number, category: { __typename?: 'ExpenseBudgetCategory', id: string, name: string } }>, brand_profit_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | null, brand_revenue_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | null, client_revenue_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | null } };

export type ProjectProfitAndRevenueTableDataQueryVariables = Exact<{
  filters?: InputMaybe<ProjectRevenueQueryArgs>;
}>;


export type ProjectProfitAndRevenueTableDataQuery = { __typename?: 'Query', expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | null, projectRevenue: { __typename?: 'ProjectRevenue', projects: Array<{ __typename?: 'ProjectWithRevenueItem', gross_profit_for_date_range: number, filtered_profit_share: number, total_profit_share: number, our_work_revenue_for_date_range: number, total_invoiced: number, our_work_billings_for_date_range: number, total_revenue_share: number, filtered_revenue_share: number, id: string, title: string, code: string, note?: string | null, finished_at?: Date | null, archived_at?: Date | null, status: ProjectStatusEnum, gross_income_for_date_range: number, expenses_profit_for_date_range: Array<{ __typename?: 'ProjectRevenueProfitByExpenseCategory', expense_budget_category_id: string, profit?: number | null }>, expenses_billings_for_date_range: Array<{ __typename?: 'ProjectRevenueBillingsByExpenseCategory', expense_budget_category_id: string, billings?: number | null }>, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, projectManager: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type ProjectProfitSummaryQueryVariables = Exact<{
  filters?: InputMaybe<ProjectRevenueQueryArgs>;
}>;


export type ProjectProfitSummaryQuery = { __typename?: 'Query', projectRevenueSummary: { __typename?: 'ProjectRevenueSummary', our_work_revenue_for_date_range: number, our_work_revenue_for_date_range_percentage: number, gross_profit_for_date_range: number, expense_revenue_for_date_range: Array<{ __typename?: 'ExpenseRevenueByCategory', profit: number, profit_percentage: number, billings: number, category: { __typename?: 'ExpenseBudgetCategory', id: string, name: string } }>, brand_profit_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | null, profit_top_projects?: Array<{ __typename?: 'TopProject', title: string, total_value: number, our_work: { __typename?: 'OurWorkTopProject', value: number }, expense_budget_categories?: Array<{ __typename?: 'ExpenseBudgetCategoryTopProject', value: number, expense_budget_item_id: string } | null> | null }> | null } };

export type ProjectProfitTableDataQueryVariables = Exact<{
  filters?: InputMaybe<ProjectRevenueQueryArgs>;
}>;


export type ProjectProfitTableDataQuery = { __typename?: 'Query', expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | null, projectRevenue: { __typename?: 'ProjectRevenue', projects: Array<{ __typename?: 'ProjectWithRevenueItem', gross_profit_for_date_range: number, filtered_profit_share: number, total_profit_share: number, our_work_revenue_for_date_range: number, id: string, title: string, code: string, note?: string | null, finished_at?: Date | null, archived_at?: Date | null, status: ProjectStatusEnum, gross_income_for_date_range: number, expenses_profit_for_date_range: Array<{ __typename?: 'ProjectRevenueProfitByExpenseCategory', expense_budget_category_id: string, profit?: number | null }>, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, projectManager: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type ProjectRevenueSummaryQueryVariables = Exact<{
  filters?: InputMaybe<ProjectRevenueQueryArgs>;
}>;


export type ProjectRevenueSummaryQuery = { __typename?: 'Query', projectRevenueSummary: { __typename?: 'ProjectRevenueSummary', our_work_billings_for_date_range: number, gross_income_for_date_range: number, total_invoiced: number, expense_revenue_for_date_range: Array<{ __typename?: 'ExpenseRevenueByCategory', profit: number, billings: number, category: { __typename?: 'ExpenseBudgetCategory', id: string, name: string } }>, brand_revenue_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | null, client_revenue_share?: Array<{ __typename?: 'BrandRevenueShare', name: string, value: number }> | null, revenue_top_projects?: Array<{ __typename?: 'TopProject', title: string, total_value: number, our_work: { __typename?: 'OurWorkTopProject', value: number }, expense_budget_categories?: Array<{ __typename?: 'ExpenseBudgetCategoryTopProject', value: number, expense_budget_item_id: string } | null> | null }> | null } };

export type ProjectRevenueTableDataQueryVariables = Exact<{
  filters?: InputMaybe<ProjectRevenueQueryArgs>;
}>;


export type ProjectRevenueTableDataQuery = { __typename?: 'Query', expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | null, projectRevenue: { __typename?: 'ProjectRevenue', projects: Array<{ __typename?: 'ProjectWithRevenueItem', total_invoiced: number, total_revenue_share: number, filtered_revenue_share: number, our_work_billings_for_date_range: number, id: string, title: string, code: string, note?: string | null, finished_at?: Date | null, archived_at?: Date | null, status: ProjectStatusEnum, gross_income_for_date_range: number, expenses_billings_for_date_range: Array<{ __typename?: 'ProjectRevenueBillingsByExpenseCategory', expense_budget_category_id: string, billings?: number | null }>, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, projectManager: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type ProjectsAllQueryVariables = Exact<{
  filters?: InputMaybe<ProjectAllQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProjectsAllQuery = { __typename?: 'Query', projectsAll?: { __typename?: 'ProjectSimplePaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'ProjectSimple', id: string, code: string, title: string }> } | null };

export type UserMonthlyReportDataQueryVariables = Exact<{
  month: Scalars['BigInt']['input'];
  year: Scalars['BigInt']['input'];
  first?: InputMaybe<Scalars['BigInt']['input']>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  orderBy?: InputMaybe<UserMonthlyReportOrderByClause>;
}>;


export type UserMonthlyReportDataQuery = { __typename?: 'Query', userMonthlyReport: { __typename?: 'UserMonthlyReportPaginator', teams: Array<{ __typename?: 'Team', id: string, name: string, is_default: boolean, user_count: number }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'UserMonthlyReport', id: string, user_full_name: string, user_image?: string | null, total_tracked_time: number, tracked_time_per_team: Array<{ __typename?: 'UserMonthlyReportPerTeam', team_id: string, tracked_time: number, tracked_time_percentage: string }> }> } };

export type UserMonthlyReportExportQueryVariables = Exact<{
  month: Scalars['BigInt']['input'];
  year: Scalars['BigInt']['input'];
}>;


export type UserMonthlyReportExportQuery = { __typename?: 'Query', userMonthlyReportExport: string };

export type UserProfitReportFragment = { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | null, combined_time_billable?: number | null, budgeted_time?: number | null, budgeted_time_billable?: number | null, allocated_time?: number | null, allocated_time_billable?: number | null, tracked_time?: number | null, tracked_time_billable?: number | null, utilization_percentage?: number | null, utilization_percentage_billable?: number | null, internal_cost?: number | null, combined_amount_billable?: number | null, budgeted_amount_billable?: number | null, combined_profit_amount?: number | null, budgeted_profit_amount?: number | null };

export type UserProfitUserFragment = { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string, utilization_range_from: number, utilization_range_to: number, defaultWorktype: { __typename?: 'TimeTrackingWorkType', title: string } } | null, team?: { __typename?: 'Team', name: string } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null };

export type UserProfitReportQueryVariables = Exact<{
  dataSource: UtilizationReportDataSource;
  where?: InputMaybe<UtilizationReportWhereConditions>;
  page: Scalars['BigInt']['input'];
  first: Scalars['BigInt']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<UtilizationReportOrderByClause> | UtilizationReportOrderByClause>;
}>;


export type UserProfitReportQuery = { __typename?: 'Query', utilizationReport: { __typename?: 'UtilizationReportPaginator', data: Array<{ __typename?: 'UtilizationUserReport', user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string, utilization_range_from: number, utilization_range_to: number, defaultWorktype: { __typename?: 'TimeTrackingWorkType', title: string } } | null, team?: { __typename?: 'Team', name: string } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, report: { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | null, combined_time_billable?: number | null, budgeted_time?: number | null, budgeted_time_billable?: number | null, allocated_time?: number | null, allocated_time_billable?: number | null, tracked_time?: number | null, tracked_time_billable?: number | null, utilization_percentage?: number | null, utilization_percentage_billable?: number | null, internal_cost?: number | null, combined_amount_billable?: number | null, budgeted_amount_billable?: number | null, combined_profit_amount?: number | null, budgeted_profit_amount?: number | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type UserProfitReportGroupedByQueryVariables = Exact<{
  groupBy: UtilizationReportGroupBy;
  dataSource: UtilizationReportDataSource;
  where?: InputMaybe<UtilizationReportWhereConditions>;
  page: Scalars['BigInt']['input'];
  first: Scalars['BigInt']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<UtilizationReportOrderByClause> | UtilizationReportOrderByClause>;
  groupOrderBy?: InputMaybe<Array<UtilizationReportGroupOrderByClause> | UtilizationReportGroupOrderByClause>;
}>;


export type UserProfitReportGroupedByQuery = { __typename?: 'Query', utilizationReportGroups: { __typename?: 'UtilizationReportGroupPaginator', data: Array<{ __typename?: 'UtilizationReportGroup', group_title: string, report: { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | null, combined_time_billable?: number | null, budgeted_time?: number | null, budgeted_time_billable?: number | null, allocated_time?: number | null, allocated_time_billable?: number | null, tracked_time?: number | null, tracked_time_billable?: number | null, utilization_percentage?: number | null, utilization_percentage_billable?: number | null, internal_cost?: number | null, combined_amount_billable?: number | null, budgeted_amount_billable?: number | null, combined_profit_amount?: number | null, budgeted_profit_amount?: number | null }, items: Array<{ __typename?: 'UtilizationUserReport', user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string, utilization_range_from: number, utilization_range_to: number, defaultWorktype: { __typename?: 'TimeTrackingWorkType', title: string } } | null, team?: { __typename?: 'Team', name: string } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, report: { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | null, combined_time_billable?: number | null, budgeted_time?: number | null, budgeted_time_billable?: number | null, allocated_time?: number | null, allocated_time_billable?: number | null, tracked_time?: number | null, tracked_time_billable?: number | null, utilization_percentage?: number | null, utilization_percentage_billable?: number | null, internal_cost?: number | null, combined_amount_billable?: number | null, budgeted_amount_billable?: number | null, combined_profit_amount?: number | null, budgeted_profit_amount?: number | null } }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type UserProfitReportStatsQueryVariables = Exact<{
  dataSource: UtilizationReportDataSource;
  where?: InputMaybe<UtilizationReportWhereConditions>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type UserProfitReportStatsQuery = { __typename?: 'Query', utilizationReportSummary: { __typename?: 'UtilizationReport', total_time: number, available_time: number, remaining_time: number, time_off: number, overtime: number, combined_time?: number | null, combined_time_billable?: number | null, budgeted_time?: number | null, budgeted_time_billable?: number | null, allocated_time?: number | null, allocated_time_billable?: number | null, tracked_time?: number | null, tracked_time_billable?: number | null, utilization_percentage?: number | null, utilization_percentage_billable?: number | null, internal_cost?: number | null, combined_amount_billable?: number | null, budgeted_amount_billable?: number | null, combined_profit_amount?: number | null, budgeted_profit_amount?: number | null } };

export type UserProfitReportExportQueryVariables = Exact<{
  dataSource: UtilizationReportDataSource;
  where?: InputMaybe<UtilizationReportWhereConditions>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type UserProfitReportExportQuery = { __typename?: 'Query', utilizationReportExport: string };

export type TaskUserFragment = { __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null };

export type TaskPositionUserFragment = { __typename?: 'TaskPosition', id: string, planned_time: number, spent_time: number, user?: { __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } };

export type TaskBaseFragment = { __typename?: 'Task', id: string, name: string, deadline?: Date | null, from?: Date | null, to?: Date | null, is_starred: boolean, billable: boolean, is_template: boolean, task_template_group_id?: string | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, currentAssignee?: { __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, users: Array<{ __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }>, positions: Array<{ __typename?: 'TaskPosition', id: string, planned_time: number, spent_time: number, user?: { __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null } } | null };

export type TaskScheduleFragment = { __typename?: 'Task', id: string, from?: Date | null, to?: Date | null, deadline?: Date | null };

export type UpdateTaskCurrentAssigneeMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateTaskCurrentAssigneeMutation = { __typename?: 'Mutation', updateTaskCurrentAssignee: { __typename?: 'Task', id: string, currentAssignee?: { __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, positions: Array<{ __typename?: 'TaskPosition', id: string, planned_time: number, spent_time: number, user?: { __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } }>, users: Array<{ __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }> } };

export type UpdateTaskAssigneesMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  positions: Array<TaskPositionInput> | TaskPositionInput;
}>;


export type UpdateTaskAssigneesMutation = { __typename?: 'Mutation', updateTaskAssignees: { __typename?: 'Task', id: string, currentAssignee?: { __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, positions: Array<{ __typename?: 'TaskPosition', id: string, planned_time: number, spent_time: number, user?: { __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } }>, users: Array<{ __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }>, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null } };

export type UpdateTaskDeadlineMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type UpdateTaskDeadlineMutation = { __typename?: 'Mutation', updateTaskDeadline: { __typename?: 'Task', id: string, from?: Date | null, to?: Date | null, deadline?: Date | null } };

export type UpdateTaskDurationMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type UpdateTaskDurationMutation = { __typename?: 'Mutation', updateTaskDuration: { __typename?: 'Task', id: string, from?: Date | null, to?: Date | null, deadline?: Date | null } };

export type UpdateTaskBillableMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  billable: Scalars['Boolean']['input'];
  propagateBillable: Scalars['Boolean']['input'];
}>;


export type UpdateTaskBillableMutation = { __typename?: 'Mutation', updateTaskBillable: { __typename?: 'Task', id: string, billable: boolean } };

export type AddTaskAssigneeMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  position: TaskPositionInput;
}>;


export type AddTaskAssigneeMutation = { __typename?: 'Mutation', addTaskAssignee: { __typename?: 'Task', id: string, currentAssignee?: { __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, positions: Array<{ __typename?: 'TaskPosition', id: string, planned_time: number, spent_time: number, user?: { __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } }>, users: Array<{ __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }>, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null } };

export type BoardTaskUserFragment = { __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null };

export type BoardTaskFragment = { __typename?: 'Task', id: string, name: string, deadline?: Date | null, is_starred: boolean, is_template: boolean, billable: boolean, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, currentAssignee?: { __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null } | null, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null }>, positions: Array<{ __typename?: 'TaskPosition', id: string, spent_time: number, user?: { __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null } | null, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null } } | null };

export type BoardSettingsFragment = { __typename?: 'TaskBoardSettings', board_key: string, hidden_columns: Array<string>, collapsed_columns: Array<string>, column_order: Array<string>, sort?: { __typename?: 'TaskBoardSort', column: string, direction: SortOrder } | null };

export type UpdateTaskBoardSettingsMutationVariables = Exact<{
  input: UpdateTaskBoardSettingsInput;
}>;


export type UpdateTaskBoardSettingsMutation = { __typename?: 'Mutation', updateTaskBoardSettings: { __typename?: 'TaskBoardSettings', board_key: string, hidden_columns: Array<string>, collapsed_columns: Array<string>, column_order: Array<string>, sort?: { __typename?: 'TaskBoardSort', column: string, direction: SortOrder } | null } };

export type MoveTaskOnBoardMutationVariables = Exact<{
  input: MoveTaskOnBoardInput;
}>;


export type MoveTaskOnBoardMutation = { __typename?: 'Mutation', moveTaskOnBoard: { __typename?: 'Task', id: string, name: string, deadline?: Date | null, from?: Date | null, to?: Date | null, is_starred: boolean, billable: boolean, is_template: boolean, task_template_group_id?: string | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, currentAssignee?: { __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, users: Array<{ __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }>, positions: Array<{ __typename?: 'TaskPosition', id: string, planned_time: number, spent_time: number, user?: { __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null } } | null } };

export type TaskBoardColumnCountsQueryVariables = Exact<{
  filters: TaskQueryArgs;
  groupBy: TaskBoardGroupByEnum;
  groupValues?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeComplete?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TaskBoardColumnCountsQuery = { __typename?: 'Query', taskBoardColumnCounts: { __typename?: 'TaskBoardColumnCountPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'TaskBoardColumnCount', group_value?: string | null, group_label?: string | null, total: number, spent_time: number, planned_time: number }> } };

export type TaskBoardColumnTasksQueryVariables = Exact<{
  filters: TaskQueryArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TaskBoardColumnTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'Task', id: string, name: string, deadline?: Date | null, from?: Date | null, to?: Date | null, is_starred: boolean, billable: boolean, is_template: boolean, task_template_group_id?: string | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, currentAssignee?: { __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, users: Array<{ __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }>, positions: Array<{ __typename?: 'TaskPosition', id: string, planned_time: number, spent_time: number, user?: { __typename?: 'User', id: string, codename?: string | null, first_name: string, last_name: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string } }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null } } | null }> } | null };

export type TaskBoardSettingsQueryVariables = Exact<{
  boardKey: Scalars['String']['input'];
}>;


export type TaskBoardSettingsQuery = { __typename?: 'Query', taskBoardSettings?: { __typename?: 'TaskBoardSettings', board_key: string, hidden_columns: Array<string>, collapsed_columns: Array<string>, column_order: Array<string>, sort?: { __typename?: 'TaskBoardSort', column: string, direction: SortOrder } | null } | null };

export type ListingClientTaskBaseFragment = { __typename?: 'Task', id: string, name: string, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, from?: Date | null, to?: Date | null, created_at?: Date | null, deadline?: Date | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null };

export type ListingClientTaskFragment = { __typename?: 'Task', id: string, name: string, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, from?: Date | null, to?: Date | null, created_at?: Date | null, deadline?: Date | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, from?: Date | null, to?: Date | null, created_at?: Date | null, deadline?: Date | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null }> | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null };

export type ListingInternalTaskBaseFragment = { __typename?: 'Task', billable: boolean, is_starred: boolean, id: string, name: string, is_template: boolean, task_template_group_id?: string | null, from?: Date | null, to?: Date | null, created_at?: Date | null, deadline?: Date | null, positions: Array<{ __typename?: 'TaskPosition', spent_time: number, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, parent?: { __typename?: 'Task', id: string, name: string } | null };

export type ListingInternalTaskFragment = { __typename?: 'Task', billable: boolean, is_starred: boolean, id: string, name: string, is_template: boolean, task_template_group_id?: string | null, from?: Date | null, to?: Date | null, created_at?: Date | null, deadline?: Date | null, subtasks?: Array<{ __typename?: 'Task', billable: boolean, is_starred: boolean, id: string, name: string, is_template: boolean, task_template_group_id?: string | null, from?: Date | null, to?: Date | null, created_at?: Date | null, deadline?: Date | null, positions: Array<{ __typename?: 'TaskPosition', spent_time: number, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, parent?: { __typename?: 'Task', id: string, name: string } | null }> | null, positions: Array<{ __typename?: 'TaskPosition', spent_time: number, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, parent?: { __typename?: 'Task', id: string, name: string } | null };

export type BulkTasksDeleteMutationVariables = Exact<{
  taskIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkTasksDeleteMutation = { __typename?: 'Mutation', bulkDeleteTasks: boolean };

export type BulkTasksEditMutationVariables = Exact<{
  taskIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  duplicateTasks: Scalars['Boolean']['input'];
  data: BulkEditTaskInput;
}>;


export type BulkTasksEditMutation = { __typename?: 'Mutation', bulkEditTasks: boolean };

export type ListingClientTasksQueryVariables = Exact<{
  filters: TaskQueryArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListingClientTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'Task', id: string, name: string, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, from?: Date | null, to?: Date | null, created_at?: Date | null, deadline?: Date | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, from?: Date | null, to?: Date | null, created_at?: Date | null, deadline?: Date | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null }> | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null }> } | null };

export type ListingInternalTasksQueryVariables = Exact<{
  filters: TaskQueryArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListingInternalTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'Task', billable: boolean, is_starred: boolean, id: string, name: string, is_template: boolean, task_template_group_id?: string | null, from?: Date | null, to?: Date | null, created_at?: Date | null, deadline?: Date | null, subtasks?: Array<{ __typename?: 'Task', billable: boolean, is_starred: boolean, id: string, name: string, is_template: boolean, task_template_group_id?: string | null, from?: Date | null, to?: Date | null, created_at?: Date | null, deadline?: Date | null, positions: Array<{ __typename?: 'TaskPosition', spent_time: number, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, parent?: { __typename?: 'Task', id: string, name: string } | null }> | null, positions: Array<{ __typename?: 'TaskPosition', spent_time: number, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, parent?: { __typename?: 'Task', id: string, name: string } | null }> } | null };

export type AllTaskIdsQueryVariables = Exact<{
  filters: TaskQueryArgs;
}>;


export type AllTaskIdsQuery = { __typename?: 'Query', taskIds?: Array<string> | null };

export type PrepareTaskDataForBulkActionsQueryVariables = Exact<{
  taskIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  destinationBudgetItemId: Scalars['ID']['input'];
}>;


export type PrepareTaskDataForBulkActionsQuery = { __typename?: 'Query', prepareTaskDataForBulkActions: { __typename?: 'TaskBulkActionsData', has_subtasks: boolean, available_positions: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, unavailable_positions: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> } };

export type BulkTasksOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BulkTasksOptionsQuery = { __typename?: 'Query', taskStatuses: Array<{ __typename?: 'TaskStatus', name: string, id: string }> };

export type TaskBasicInfoFragment = { __typename?: 'Task', id: string, name: string, deadline?: Date | null, scopedCommentCount: number, is_template: boolean, task_template_group_id?: string | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', id: string, codename?: string | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null }> | null, parent?: { __typename?: 'Task', id: string } | null };

export type TaskExtendedInfoFragment = { __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, subtasks?: Array<{ __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null }> | null };

export type TasksQueryVariables = Exact<{
  filters: TaskQueryArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'Task', id: string, name: string, deadline?: Date | null, scopedCommentCount: number, is_template: boolean, task_template_group_id?: string | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', id: string, codename?: string | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | null, parent?: { __typename?: 'Task', id: string } | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> } | null };

export type TasksForScopedUsersQueryVariables = Exact<{
  filters: TaskQueryArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TasksForScopedUsersQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'Task', id: string, name: string, deadline?: Date | null, scopedCommentCount: number, is_template: boolean, task_template_group_id?: string | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', id: string, codename?: string | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null }> | null, parent?: { __typename?: 'Task', id: string } | null }> } | null };

export type TasksFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TasksFilterOptionsQuery = { __typename?: 'Query', teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | null }>, taskStatuses: Array<{ __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }>, taskPriorities: Array<{ __typename?: 'TaskPriority', name: string, id: string }>, timeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, code: string, title: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | null }> };

export type BudgetItemsFilterOptionsQueryVariables = Exact<{
  project_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type BudgetItemsFilterOptionsQuery = { __typename?: 'Query', ourWorkBudgetItemsSimpleMap: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, item_code?: string | null }> };

export type CreateCapacityAllocationMutationVariables = Exact<{
  input: CreateCapacityAllocationInput;
}>;


export type CreateCapacityAllocationMutation = { __typename?: 'Mutation', createCapacityAllocation: { __typename?: 'CapacityAllocation', id: string } };

export type UpdateCapacityAllocationMutationVariables = Exact<{
  input: UpdateCapacityAllocationInput;
}>;


export type UpdateCapacityAllocationMutation = { __typename?: 'Mutation', updateCapacityAllocation: { __typename?: 'CapacityAllocation', id: string } };

export type UpdateCapacityAllocationForDayMutationVariables = Exact<{
  input: UpdateCapacityAllocationForDayInput;
}>;


export type UpdateCapacityAllocationForDayMutation = { __typename?: 'Mutation', UpdateCapacityAllocationForDay: { __typename?: 'CapacityAllocation', id: string } };

export type UpdateCapacityAllocationItemMutationVariables = Exact<{
  input: UpdateCapacityAllocationItemInput;
}>;


export type UpdateCapacityAllocationItemMutation = { __typename?: 'Mutation', updateCapacityAllocationItem: { __typename?: 'CapacityAllocationItem', id: string } };

export type CopyCapacityAllocationItemMutationVariables = Exact<{
  input: MoveCapacityAllocationItemInput;
}>;


export type CopyCapacityAllocationItemMutation = { __typename?: 'Mutation', copyCapacityAllocationItem: { __typename?: 'CapacityAllocationItem', id: string, date: Date, from_time?: Time | null, to_time?: Time | null, note?: string | null, total_time: number, type: CapacityAllocationTypeEnum, location?: string | null, global?: boolean | null, time_off_duration_type?: TimeOffDurationTypeEnum | null, time_tracking_work_type_id?: string | null, completed: boolean, meetLink?: string | null, eventLink?: string | null, stats?: { __typename?: 'CapacityAllocationItemStats', capacity_allocation_id: string, capacity_allocation_item_id: string, capacity_allocation_created_by_id?: string | null, task_id?: string | null, task_name?: string | null, task_status_id?: string | null, task_status_name?: string | null, task_status_system_status?: TaskSystemStatusEnum | null, task_status_background_color?: string | null, task_status_foreground_color?: string | null, our_work_budget_item_id?: string | null, our_work_budget_item_title?: string | null, project_id?: string | null, project_code?: string | null, project_title?: string | null, tracking_enabled?: boolean | null, tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, time_off_type_id?: string | null, time_off_type_name?: string | null, time_off_type_affects_planning_capacity?: boolean | null, deadline?: Date | null, deadline_time?: Time | null, repetition: CapacityAllocationRepetitionTypeEnum, create_task_positions?: boolean | null, items_count: number, title?: string | null } | null, userItems: Array<{ __typename?: 'CapacityAllocationItem', id: string, date: Date, from_time?: Time | null, to_time?: Time | null, note?: string | null, total_time: number, type: CapacityAllocationTypeEnum, location?: string | null, global?: boolean | null, time_off_duration_type?: TimeOffDurationTypeEnum | null, time_tracking_work_type_id?: string | null, completed: boolean, meetLink?: string | null, eventLink?: string | null, capacityAllocation: { __typename?: 'CapacityAllocation', id: string }, stats?: { __typename?: 'CapacityAllocationItemStats', capacity_allocation_id: string, capacity_allocation_item_id: string, capacity_allocation_created_by_id?: string | null, task_id?: string | null, task_name?: string | null, task_status_id?: string | null, task_status_name?: string | null, task_status_system_status?: TaskSystemStatusEnum | null, task_status_background_color?: string | null, task_status_foreground_color?: string | null, our_work_budget_item_id?: string | null, our_work_budget_item_title?: string | null, project_id?: string | null, project_code?: string | null, project_title?: string | null, tracking_enabled?: boolean | null, tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, time_off_type_id?: string | null, time_off_type_name?: string | null, time_off_type_affects_planning_capacity?: boolean | null, deadline?: Date | null, deadline_time?: Time | null, repetition: CapacityAllocationRepetitionTypeEnum, create_task_positions?: boolean | null, items_count: number, title?: string | null } | null, teams?: Array<{ __typename?: 'TeamAttendee', team: { __typename?: 'Team', id: string } }> | null, user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | null }, timeOffType?: { __typename?: 'TimeOffType', id: string, name: string, affects_planning_capacity: boolean } | null, createdBy: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | null } }>, teams?: Array<{ __typename?: 'TeamAttendee', team: { __typename?: 'Team', id: string } }> | null, user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | null }, timeOffType?: { __typename?: 'TimeOffType', id: string, name: string, affects_planning_capacity: boolean } | null, createdBy: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | null } } };

export type MoveCapacityAllocationItemMutationVariables = Exact<{
  input: MoveCapacityAllocationItemInput;
}>;


export type MoveCapacityAllocationItemMutation = { __typename?: 'Mutation', moveCapacityAllocationItem: { __typename?: 'CapacityAllocationItem', id: string, completed: boolean, userItems: Array<{ __typename?: 'CapacityAllocationItem', id: string, date: Date, from_time?: Time | null, to_time?: Time | null, note?: string | null, total_time: number, type: CapacityAllocationTypeEnum, location?: string | null, global?: boolean | null, time_off_duration_type?: TimeOffDurationTypeEnum | null, time_tracking_work_type_id?: string | null, completed: boolean, meetLink?: string | null, eventLink?: string | null, capacityAllocation: { __typename?: 'CapacityAllocation', id: string }, stats?: { __typename?: 'CapacityAllocationItemStats', capacity_allocation_id: string, capacity_allocation_item_id: string, capacity_allocation_created_by_id?: string | null, task_id?: string | null, task_name?: string | null, task_status_id?: string | null, task_status_name?: string | null, task_status_system_status?: TaskSystemStatusEnum | null, task_status_background_color?: string | null, task_status_foreground_color?: string | null, our_work_budget_item_id?: string | null, our_work_budget_item_title?: string | null, project_id?: string | null, project_code?: string | null, project_title?: string | null, tracking_enabled?: boolean | null, tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, time_off_type_id?: string | null, time_off_type_name?: string | null, time_off_type_affects_planning_capacity?: boolean | null, deadline?: Date | null, deadline_time?: Time | null, repetition: CapacityAllocationRepetitionTypeEnum, create_task_positions?: boolean | null, items_count: number, title?: string | null } | null, teams?: Array<{ __typename?: 'TeamAttendee', team: { __typename?: 'Team', id: string } }> | null, user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | null }, timeOffType?: { __typename?: 'TimeOffType', id: string, name: string, affects_planning_capacity: boolean } | null, createdBy: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | null } }>, timeTrackingWorkType?: { __typename?: 'TimeTrackingWorkType', id: string, title: string } | null, user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } } };

export type ReorderCapacityAllocationUserItemsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ReorderCapacityAllocationUserItemsMutation = { __typename?: 'Mutation', reorderCapacityAllocationItems?: Array<{ __typename?: 'CapacityAllocationItem', id: string }> | null };

export type ValidateCreateTimeTrackingItemMutationVariables = Exact<{
  user_id?: InputMaybe<Scalars['ID']['input']>;
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ValidateCreateTimeTrackingItemMutation = { __typename?: 'Mutation', validateCreateTimeTrackingItem: boolean };

export type UpdateTimeTrackingWorkTypeInTrackingMutationVariables = Exact<{
  user_id?: InputMaybe<Scalars['ID']['input']>;
  task_id: Scalars['ID']['input'];
  old_time_tracking_work_type_id: Scalars['ID']['input'];
  new_time_tracking_work_type_id: Scalars['ID']['input'];
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateTimeTrackingWorkTypeInTrackingMutation = { __typename?: 'Mutation', updateTimeTrackingWorkTypeInTracking: boolean };

export type UpdatePlanningUsersOrderMutationVariables = Exact<{
  user_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  type: PlanningOrderTypeEnum;
  model_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdatePlanningUsersOrderMutation = { __typename?: 'Mutation', updatePlanningUsersOrder: boolean };

export type GetAllocationModalOptionsQueryVariables = Exact<{
  where?: InputMaybe<UsersWhereConditions>;
}>;


export type GetAllocationModalOptionsQuery = { __typename?: 'Query', userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | null, team_id?: string | null, profile?: { __typename?: 'UserProfile', plannable: boolean } | null }> };

export type GetTaskPositionsQueryVariables = Exact<{
  task_id: Scalars['ID']['input'];
}>;


export type GetTaskPositionsQuery = { __typename?: 'Query', task: { __typename?: 'Task', ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', project: { __typename?: 'Project', availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> } } | null } };

export type IsUserInTaskQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type IsUserInTaskQuery = { __typename?: 'Query', isUserInTask: boolean };

export type ModalCapacityAllocationTaskOptionsQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;


export type ModalCapacityAllocationTaskOptionsQuery = { __typename?: 'Query', task: { __typename?: 'Task', from?: Date | null, to?: Date | null, planned_time: number, deadline?: Date | null, stats?: { __typename?: 'TaskStats', planned_time: number, history_spent_time: number, allocated_time: number, left_to_allocate: number } | null, positions: Array<{ __typename?: 'TaskPosition', timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, user?: { __typename?: 'User', id: string } | null }> } };

export type ModalCapacityAllocationProjectOptionsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ModalCapacityAllocationProjectOptionsQuery = { __typename?: 'Query', projectForTask: { __typename?: 'ProjectForTask', id: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> } };

export type PlanningFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlanningFilterOptionsQuery = { __typename?: 'Query', taskStatuses: Array<{ __typename?: 'TaskStatus', id: string, name: string }>, taskPriorities: Array<{ __typename?: 'TaskPriority', id: string, name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | null }>, timeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }> };

export type ProjectTemplateFragment = { __typename?: 'Project', id: string, title: string, code: string, billable: boolean, note?: string | null, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, categories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }>, statsCached?: { __typename?: 'ProjectStats', id: string, total_budget: number, ourWork: { __typename?: 'ProjectOurWorkStats', id: string, total_budget: number }, expenses: { __typename?: 'ProjectExpenseStats', id: string, planned_expenses: number } } | null };

export type ProjectTemplatesQueryVariables = Exact<{
  filters?: InputMaybe<ProjectQueryArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProjectTemplatesQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectPaginator', data: Array<{ __typename?: 'Project', id: string, title: string, code: string, billable: boolean, note?: string | null, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }, categories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }>, statsCached?: { __typename?: 'ProjectStats', id: string, total_budget: number, ourWork: { __typename?: 'ProjectOurWorkStats', id: string, total_budget: number }, expenses: { __typename?: 'ProjectExpenseStats', id: string, planned_expenses: number } } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type ProjectTemplatesFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectTemplatesFilterOptionsQuery = { __typename?: 'Query', teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, name: string, codename?: string | null, full_name: string }>, clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }> };

export type TaskGroupTemplateFragment = { __typename?: 'TaskTemplateGroup', id: string, name: string, tasks?: Array<{ __typename?: 'Task', id: string, name: string, deadline?: Date | null, scopedCommentCount: number, is_template: boolean, task_template_group_id?: string | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', id: string, codename?: string | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | null, parent?: { __typename?: 'Task', id: string } | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | null };

export type CreateTaskGroupTemplateMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateTaskGroupTemplateMutation = { __typename?: 'Mutation', createTaskTemplateGroup: { __typename?: 'TaskTemplateGroup', id: string, name: string, tasks?: Array<{ __typename?: 'Task', id: string, name: string, deadline?: Date | null, scopedCommentCount: number, is_template: boolean, task_template_group_id?: string | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', id: string, codename?: string | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | null, parent?: { __typename?: 'Task', id: string } | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | null } };

export type UpdateTaskGroupTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateTaskGroupTemplateMutation = { __typename?: 'Mutation', updateTaskTemplateGroup: { __typename?: 'TaskTemplateGroup', id: string, name: string, tasks?: Array<{ __typename?: 'Task', id: string, name: string, deadline?: Date | null, scopedCommentCount: number, is_template: boolean, task_template_group_id?: string | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', id: string, codename?: string | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | null, parent?: { __typename?: 'Task', id: string } | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | null } };

export type DeleteTaskGroupTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTaskGroupTemplateMutation = { __typename?: 'Mutation', deleteTaskTemplateGroup: boolean };

export type TaskGroupTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type TaskGroupTemplatesQuery = { __typename?: 'Query', taskTemplateGroups: Array<{ __typename?: 'TaskTemplateGroup', id: string, name: string, tasks?: Array<{ __typename?: 'Task', id: string, name: string, deadline?: Date | null, scopedCommentCount: number, is_template: boolean, task_template_group_id?: string | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', id: string, codename?: string | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | null, parent?: { __typename?: 'Task', id: string } | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | null } | null> };

export type TaskGroupTemplatesSimpleQueryVariables = Exact<{ [key: string]: never; }>;


export type TaskGroupTemplatesSimpleQuery = { __typename?: 'Query', taskTemplateGroups: Array<{ __typename?: 'TaskTemplateGroup', id: string, name: string } | null> };

export type TaskGroupTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskGroupTemplateQuery = { __typename?: 'Query', taskTemplateGroup: { __typename?: 'TaskTemplateGroup', id: string, name: string, tasks?: Array<{ __typename?: 'Task', id: string, name: string, deadline?: Date | null, scopedCommentCount: number, is_template: boolean, task_template_group_id?: string | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', id: string, codename?: string | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, uses_budgetovac: boolean, code: string, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, subtasks?: Array<{ __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, billable: boolean, commentCount: number, unreadCommentsCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | null, parent?: { __typename?: 'Task', id: string } | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }> }> | null } };

export type TimeTrackingReportItemFragment = { __typename?: 'TimeTrackingReport', id: string, tracked_time: number, tracked_for_date: Date, brand_id: string, brand_name: string, client_name: string, project_id: string, project_title: string, project_code: string, project_time_billing_id?: string | null, project_time_billing_project_id?: string | null, project_time_billing_name?: string | null, project_time_billing_project_name?: string | null, project_time_billing_is_locked?: boolean | null, our_work_budget_item_title: string, time_tracking_work_type_title: string, time_tracking_work_type_id: string, team_name?: string | null, task_id: string, task_name: string, user_full_name?: string | null, note?: string | null, invoiced_seconds: number, overserviced_seconds: number, uninvoiced_seconds: number, amount?: number | null, hourly_rate?: number | null, locked_at?: Date | null, locked_by_user_first_name?: string | null, locked_by_user_last_name?: string | null };

export type MoveTimeTrackingItemsToWorkTypeMutationVariables = Exact<{
  item_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  work_type_id: Scalars['ID']['input'];
}>;


export type MoveTimeTrackingItemsToWorkTypeMutation = { __typename?: 'Mutation', moveTimeTrackingItemsToWorkType: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type MoveTimeTrackingItemsToTaskMutationVariables = Exact<{
  item_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_mapping: Array<TimeTrackingWorkTypeMapping> | TimeTrackingWorkTypeMapping;
}>;


export type MoveTimeTrackingItemsToTaskMutation = { __typename?: 'Mutation', moveTimeTrackingItemsToTask: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type UnlockTimeTrackingItemsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UnlockTimeTrackingItemsMutation = { __typename?: 'Mutation', unlockTimeTrackingItems: { __typename?: 'BulkActionResponse', total: number, failed: number, successful: number } };

export type BulkDeleteTimeTrackingItemsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkDeleteTimeTrackingItemsMutation = { __typename?: 'Mutation', bulkDeleteTimeTrackingItems: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type UpdateTimeTrackingItemsBillableMutationVariables = Exact<{
  timeTrackingItemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  billable: Scalars['Boolean']['input'];
}>;


export type UpdateTimeTrackingItemsBillableMutation = { __typename?: 'Mutation', updateTimeTrackingItemsBillable: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type TimeTrackingReportSummaryQueryVariables = Exact<{
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type TimeTrackingReportSummaryQuery = { __typename?: 'Query', getTimeTrackingItemsSummary: { __typename?: 'GetTimeTrackingItemsSummary', ids: Array<string>, tracked_time: number } };

export type TimeTrackingReportSelectedSummaryQueryVariables = Exact<{
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type TimeTrackingReportSelectedSummaryQuery = { __typename?: 'Query', getTimeTrackingItemsSummary: { __typename?: 'GetTimeTrackingItemsSummary', tracked_time: number, invoiced_seconds: number, overserviced_seconds: number, uninvoiced_seconds: number, amount: number, invoiced_amount: number, overserviced_amount: number, uninvoiced_amount: number } };

export type TimeTrackingReportGroupedByQueryVariables = Exact<{
  groupBy?: InputMaybe<TimeTrackingReportGroupBy>;
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
  first?: InputMaybe<Scalars['BigInt']['input']>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  orderBy?: InputMaybe<Array<TimeTrackingItemOrderByClause> | TimeTrackingItemOrderByClause>;
}>;


export type TimeTrackingReportGroupedByQuery = { __typename?: 'Query', timeTrackingReport: { __typename?: 'TimeTrackingReportPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'TimeTrackingReportGroup', groupBy?: string | null, trackedTime: number, items: Array<{ __typename?: 'TimeTrackingReport', id: string, tracked_time: number, tracked_for_date: Date, brand_id: string, brand_name: string, client_name: string, project_id: string, project_title: string, project_code: string, project_time_billing_id?: string | null, project_time_billing_project_id?: string | null, project_time_billing_name?: string | null, project_time_billing_project_name?: string | null, project_time_billing_is_locked?: boolean | null, our_work_budget_item_title: string, time_tracking_work_type_title: string, time_tracking_work_type_id: string, team_name?: string | null, task_id: string, task_name: string, user_full_name?: string | null, note?: string | null, invoiced_seconds: number, overserviced_seconds: number, uninvoiced_seconds: number, amount?: number | null, hourly_rate?: number | null, locked_at?: Date | null, locked_by_user_first_name?: string | null, locked_by_user_last_name?: string | null }> }> } };

export type TimeTrackingUngroupedItemsQueryVariables = Exact<{
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
  first?: InputMaybe<Scalars['BigInt']['input']>;
  page?: InputMaybe<Scalars['BigInt']['input']>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  orderBy?: InputMaybe<Array<TimeTrackingItemOrderByClause> | TimeTrackingItemOrderByClause>;
}>;


export type TimeTrackingUngroupedItemsQuery = { __typename?: 'Query', getTimeTrackingItems: { __typename?: 'GetTimeTrackingItemsPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'TimeTrackingReport', id: string, tracked_time: number, tracked_for_date: Date, brand_id: string, brand_name: string, client_name: string, project_id: string, project_title: string, project_code: string, project_time_billing_id?: string | null, project_time_billing_project_id?: string | null, project_time_billing_name?: string | null, project_time_billing_project_name?: string | null, project_time_billing_is_locked?: boolean | null, our_work_budget_item_title: string, time_tracking_work_type_title: string, time_tracking_work_type_id: string, team_name?: string | null, task_id: string, task_name: string, user_full_name?: string | null, note?: string | null, invoiced_seconds: number, overserviced_seconds: number, uninvoiced_seconds: number, amount?: number | null, hourly_rate?: number | null, locked_at?: Date | null, locked_by_user_first_name?: string | null, locked_by_user_last_name?: string | null }> } };

export type TimeTrackingReportExportQueryVariables = Exact<{
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
}>;


export type TimeTrackingReportExportQuery = { __typename?: 'Query', timeTrackingReportExport: string };

export type TimeTrackingEffectivenessReportExportQueryVariables = Exact<{
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
}>;


export type TimeTrackingEffectivenessReportExportQuery = { __typename?: 'Query', userEffectivenessReportExport: string };

export type TimeTrackingTimeOffsExportQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type TimeTrackingTimeOffsExportQuery = { __typename?: 'Query', timeOffsExport: string };

export type TimeTrackingReportExportPdfQueryVariables = Exact<{
  where?: InputMaybe<TimeTrackingReportsWhereConditions>;
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  type: TimeTrackingReportExportType;
}>;


export type TimeTrackingReportExportPdfQuery = { __typename?: 'Query', timeTrackingReportExportPdf: string };

export type GetTasksSimpleMapOptionsQueryVariables = Exact<{
  our_work_budget_item_id?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  parent_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetTasksSimpleMapOptionsQuery = { __typename?: 'Query', tasksSimpleMap: Array<{ __typename?: 'TaskSimple', id: string, name: string, parent?: { __typename?: 'Task', id: string } | null }> };

export type GetOurWorkBudgetItemsSimpleMapOptionsQueryVariables = Exact<{
  project_id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetOurWorkBudgetItemsSimpleMapOptionsQuery = { __typename?: 'Query', ourWorkBudgetItemsSimpleMap: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, project?: { __typename?: 'ProjectSimple', id: string } | null, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null } }> };

export type TimeTrackingReportOptionsQueryVariables = Exact<{
  userSimpleWhere?: InputMaybe<UsersWhereConditions>;
}>;


export type TimeTrackingReportOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', id: string, name: string, brands: Array<{ __typename?: 'BrandSimple', id: string, name: string }> }>, timeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string }>, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string, brand_id: string, archived_at?: Date | null, finished_at?: Date | null }>, userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, name: string, full_name: string, team_id?: string | null, codename?: string | null, archived_at?: Date | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }>, projectCategories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }> };

export type GetProjectsWithPositionsQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetProjectsWithPositionsQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', projects: Array<{ __typename?: 'Project', id: string, code: string, title: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> }> } | null };

export type AvailableWorkTypesForBulkMovingTimeTrackingItemsQueryVariables = Exact<{
  itemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AvailableWorkTypesForBulkMovingTimeTrackingItemsQuery = { __typename?: 'Query', getAvailableWorkTypesForBulkMovingTimeTrackingItems: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> };

export type TimeTrackingItemsWorkTypesQueryVariables = Exact<{
  itemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type TimeTrackingItemsWorkTypesQuery = { __typename?: 'Query', timeTrackingItemsWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> };

export type CheckTimeTrackingItemsLockedQueryVariables = Exact<{
  itemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CheckTimeTrackingItemsLockedQuery = { __typename?: 'Query', checkTimeTrackingItemsLocked: Array<string> };

export type AddRowToWeekTimeReportMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AddRowToWeekTimeReportMutation = { __typename?: 'Mutation', addRowToWeekTimeReport: { __typename?: 'WeeklyTimeReportRow', task: { __typename?: 'Task', id: string } } };

export type CreateOrUpdateTrackedTimeForDayMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
  tracked_for_date: Scalars['Date']['input'];
  tracked_time: Scalars['BigInt']['input'];
}>;


export type CreateOrUpdateTrackedTimeForDayMutation = { __typename?: 'Mutation', createOrUpdateTrackedTimeForDay: boolean };

export type CreateTimeTrackingItemMutationVariables = Exact<{
  user_id?: InputMaybe<Scalars['ID']['input']>;
  task_id: Scalars['ID']['input'];
  tracked_for_date: Scalars['Date']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  tracked_time?: InputMaybe<Scalars['BigInt']['input']>;
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  specificTimeFrom?: InputMaybe<Scalars['Time']['input']>;
  specificTimeTo?: InputMaybe<Scalars['Time']['input']>;
}>;


export type CreateTimeTrackingItemMutation = { __typename?: 'Mutation', createTimeTrackingItem: { __typename?: 'TimeTrackingItem', id: string } };

export type DeleteTimeTrackingItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTimeTrackingItemMutation = { __typename?: 'Mutation', deleteTimeTrackingItem: { __typename?: 'TimeTrackingItem', id: string } };

export type RemoveRowFromWeekTimeReportMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
  first_date_of_week: Scalars['Date']['input'];
}>;


export type RemoveRowFromWeekTimeReportMutation = { __typename?: 'Mutation', removeRowFromWeekTimeReport?: { __typename?: 'WeeklyTimeReportRow', task: { __typename?: 'Task', id: string } } | null };

export type StartTimerMutationVariables = Exact<{
  time_tracking_item_id: Scalars['ID']['input'];
}>;


export type StartTimerMutation = { __typename?: 'Mutation', startTimer: boolean };

export type StopTimerMutationVariables = Exact<{
  time_tracking_item_id: Scalars['ID']['input'];
}>;


export type StopTimerMutation = { __typename?: 'Mutation', stopTimer: boolean };

export type UpdateTimeTrackingItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  task_id: Scalars['ID']['input'];
  tracked_for_date: Scalars['Date']['input'];
  time_tracking_work_type_id: Scalars['ID']['input'];
  tracked_time?: InputMaybe<Scalars['BigInt']['input']>;
  specificTimeFrom?: InputMaybe<Scalars['Time']['input']>;
  specificTimeTo?: InputMaybe<Scalars['Time']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  capacity_allocation_item_id?: InputMaybe<Scalars['ID']['input']>;
  billable?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateTimeTrackingItemMutation = { __typename?: 'Mutation', updateTimeTrackingItem: { __typename?: 'TimeTrackingItem', id: string } };

export type TimeTrackingEntryFragment = { __typename?: 'TimeTrackingItem', id: string, tracked_for_date: Date, tracked_time: number, tracked_time_with_running_timer: number, specific_time_from?: Time | null, specific_time_to?: Time | null, note?: string | null, auto_stopped: boolean, billable: boolean, is_locked: boolean, has_running_timer: boolean, timeBilling?: { __typename?: 'ProjectTimeBilling', id: string, name: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | null, user?: { __typename?: 'User', id: string } | null, capacityAllocationItem?: { __typename?: 'CapacityAllocationItem', id: string } | null, task: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, brand: { __typename?: 'Brand', id: string, name: string } } } | null }, timeTrackingBudgetItem: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled: boolean }, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', id: string, name: string } } };

export type TimeTrackingBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type TimeTrackingBrandsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', brands: Array<{ __typename?: 'BrandSimple', id: string, name: string, code: string }> }> };

export type TimeTrackingItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TimeTrackingItemQuery = { __typename?: 'Query', timeTrackingItem: { __typename?: 'TimeTrackingItem', id: string, tracked_for_date: Date, tracked_time: number, tracked_time_with_running_timer: number, specific_time_from?: Time | null, specific_time_to?: Time | null, note?: string | null, auto_stopped: boolean, billable: boolean, is_locked: boolean, has_running_timer: boolean, timeBilling?: { __typename?: 'ProjectTimeBilling', id: string, name: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | null, user?: { __typename?: 'User', id: string } | null, capacityAllocationItem?: { __typename?: 'CapacityAllocationItem', id: string } | null, task: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, brand: { __typename?: 'Brand', id: string, name: string } } } | null }, timeTrackingBudgetItem: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled: boolean }, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', id: string, name: string } } } };

export type TimeTrackingItemsQueryVariables = Exact<{
  user_id: Scalars['ID']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type TimeTrackingItemsQuery = { __typename?: 'Query', timeTrackingSummaryPerDay?: Array<{ __typename?: 'TimeTrackingSummaryPerDay', date: Date, tracked_time: number, auto_stopped: boolean }> | null, timeTrackingItems: Array<{ __typename?: 'TimeTrackingItem', id: string, tracked_for_date: Date, tracked_time: number, tracked_time_with_running_timer: number, specific_time_from?: Time | null, specific_time_to?: Time | null, note?: string | null, auto_stopped: boolean, billable: boolean, is_locked: boolean, has_running_timer: boolean, timeBilling?: { __typename?: 'ProjectTimeBilling', id: string, name: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | null, user?: { __typename?: 'User', id: string } | null, capacityAllocationItem?: { __typename?: 'CapacityAllocationItem', id: string } | null, task: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, brand: { __typename?: 'Brand', id: string, name: string } } } | null }, timeTrackingBudgetItem: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled: boolean }, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', id: string, name: string } } }>, runningTimer?: { __typename?: 'Timer', id: string, timeTrackingItem?: { __typename?: 'TimeTrackingItem', id: string, tracked_for_date: Date } | null } | null };

export type TimeTrackingOptionsForProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
}>;


export type TimeTrackingOptionsForProjectQuery = { __typename?: 'Query', timeTrackingOptionsForProject: { __typename?: 'TimeTrackingOptionsForProject', ourWork: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled: boolean, tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null }, category: { __typename?: 'OurWorkBudgetCategory', name: string }, tasks: Array<{ __typename?: 'TaskSimple', id: string, name: string, positions: Array<{ __typename?: 'TaskPosition', timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string }, user?: { __typename?: 'User', id: string } | null }> }> }>, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> } };

export type TimeTrackingProjectsQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TimeTrackingProjectsQuery = { __typename?: 'Query', projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', billable: boolean, id: string, title: string, code: string, brand_id: string }> };

export type TimeTrackingUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type TimeTrackingUsersQuery = { __typename?: 'Query', userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, codename?: string | null, full_name: string, team_id?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }> };

export type WeekTimeReportQueryVariables = Exact<{
  user_id: Scalars['ID']['input'];
  from: Scalars['Date']['input'];
}>;


export type WeekTimeReportQuery = { __typename?: 'Query', weekTimeReport: { __typename?: 'WeekTimeReport', rows: Array<{ __typename?: 'WeeklyTimeReportRow', task: { __typename?: 'Task', id: string, name: string, billable: boolean, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', id: string, name: string } } } | null }, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, trackedTime: Array<{ __typename?: 'WeeklyTimeReportRowDay', date: Date, tracked_time: number }> }>, dailyTotals: Array<{ __typename?: 'WeeklyTimeReportTotalsPerDay', date: Date, total_tracked_time: number }> } };

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'User', id: string } };

export type GetUsersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<UserQueryArgs>;
}>;


export type GetUsersQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string, name: string }>, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }>, brandsSimpleMap: Array<{ __typename?: 'BrandSimple', id: string, name: string }>, usersSummary: { __typename?: 'UsersSummary', userIds: Array<string> }, users?: { __typename?: 'UserPaginator', data: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string, codename?: string | null, email: string, phone?: string | null, note?: string | null, archived_at?: Date | null, PMActiveProjectsCount: number, enabled_two_factor_authentication: boolean, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, team?: { __typename?: 'Team', id: string, name: string } | null, roles: Array<{ __typename?: 'Role', id: string, name: string }>, profile?: { __typename?: 'UserProfile', hex_color: string, plannable: boolean, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string } } | null, permissions: { __typename?: 'PermissionList', user_haveProjectsAssigned: boolean } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type ProjectManagerOptionsForUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectManagerOptionsForUsersQuery = { __typename?: 'Query', projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | null }> };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'User', id: string } };

export type ScheduleUserArchivalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
  project_manager_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ScheduleUserArchivalMutation = { __typename?: 'Mutation', scheduleUserArchival: { __typename?: 'User', id: string } };

export type ScheduleUserActivationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ScheduleUserActivationMutation = { __typename?: 'Mutation', scheduleUserActivation: { __typename?: 'User', id: string } };

export type ReassignActiveProjectsAndOwnedInvoicesMutationVariables = Exact<{
  fromUser: Scalars['ID']['input'];
  toUser: Scalars['ID']['input'];
}>;


export type ReassignActiveProjectsAndOwnedInvoicesMutation = { __typename?: 'Mutation', reassignActiveProjectsAndOwnedInvoices: boolean };

export type UpdateUserPasswordMutationVariables = Exact<{
  input: UpdateUserPasswordInput;
}>;


export type UpdateUserPasswordMutation = { __typename?: 'Mutation', updateUserPassword: { __typename?: 'User', id: string } };

export type UserForEditBasicFragment = { __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string, codename?: string | null, created_at: Date, email: string, phone?: string | null, note?: string | null, archived_at?: Date | null, PMActiveProjectsCount: number, enabled_two_factor_authentication: boolean, mcp_connected: boolean, muted_mail_notifications: boolean, calendar_integrations?: Array<CalendarTypeEnum | null> | null, calendar_sync_direction?: CalendarSyncDirectionEnum | null, calendar_sync_allocation_types?: Array<CapacityAllocationTypeEnum | null> | null, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, statusRanges: Array<{ __typename?: 'UserStatusRange', id: string, valid_from: Date, valid_to?: Date | null, active: boolean, projectManager?: { __typename?: 'User', id: string } | null }>, permissions: { __typename?: 'PermissionList', user_haveProjectsAssigned: boolean }, mcpTokens: Array<{ __typename?: 'McpToken', id: string, mcp_name?: string | null, created_at: Date }>, team?: { __typename?: 'Team', id: string, name: string } | null, roles: Array<{ __typename?: 'Role', id: string, name: string }>, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, tasks: Array<{ __typename?: 'Task', id: string }> };

export type GetScopedUserForEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetScopedUserForEditQuery = { __typename?: 'Query', user?: { __typename?: 'User', scope_access?: UserScopeAccessEnum | null, id: string, first_name: string, last_name: string, full_name: string, codename?: string | null, created_at: Date, email: string, phone?: string | null, note?: string | null, archived_at?: Date | null, PMActiveProjectsCount: number, enabled_two_factor_authentication: boolean, mcp_connected: boolean, muted_mail_notifications: boolean, calendar_integrations?: Array<CalendarTypeEnum | null> | null, calendar_sync_direction?: CalendarSyncDirectionEnum | null, calendar_sync_allocation_types?: Array<CapacityAllocationTypeEnum | null> | null, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string }>, tasks: Array<{ __typename?: 'Task', id: string, name: string, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | null } }>, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, statusRanges: Array<{ __typename?: 'UserStatusRange', id: string, valid_from: Date, valid_to?: Date | null, active: boolean, projectManager?: { __typename?: 'User', id: string } | null }>, permissions: { __typename?: 'PermissionList', user_haveProjectsAssigned: boolean }, mcpTokens: Array<{ __typename?: 'McpToken', id: string, mcp_name?: string | null, created_at: Date }>, team?: { __typename?: 'Team', id: string, name: string } | null, roles: Array<{ __typename?: 'Role', id: string, name: string }>, brands: Array<{ __typename?: 'Brand', id: string, name: string }> } | null };

export type GetUserForEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserForEditQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string, codename?: string | null, created_at: Date, email: string, phone?: string | null, note?: string | null, archived_at?: Date | null, PMActiveProjectsCount: number, enabled_two_factor_authentication: boolean, mcp_connected: boolean, muted_mail_notifications: boolean, calendar_integrations?: Array<CalendarTypeEnum | null> | null, calendar_sync_direction?: CalendarSyncDirectionEnum | null, calendar_sync_allocation_types?: Array<CapacityAllocationTypeEnum | null> | null, profile?: { __typename?: 'UserProfile', hex_color: string, plannable: boolean, rates: Array<{ __typename?: 'UserProfileRate', id: string, valid_from: Date, valid_to?: Date | null, rate: number }>, planningRanges: Array<{ __typename?: 'UserProfilePlanningRange', id: string, valid_from: Date, valid_to?: Date | null, utilising: boolean, daily_capacity?: number | null, type: { __typename?: 'PlanningRangeType', value: PlanningRangeTypeEnum }, weekly_capacities?: { __typename?: 'WeeklyCapacities', monday: number, tuesday: number, wednesday: number, thursday: number, friday: number, saturday: number, sunday: number } | null }>, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string } } | null, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, statusRanges: Array<{ __typename?: 'UserStatusRange', id: string, valid_from: Date, valid_to?: Date | null, active: boolean, projectManager?: { __typename?: 'User', id: string } | null }>, permissions: { __typename?: 'PermissionList', user_haveProjectsAssigned: boolean }, mcpTokens: Array<{ __typename?: 'McpToken', id: string, mcp_name?: string | null, created_at: Date }>, team?: { __typename?: 'Team', id: string, name: string } | null, roles: Array<{ __typename?: 'Role', id: string, name: string }>, brands: Array<{ __typename?: 'Brand', id: string, name: string }>, tasks: Array<{ __typename?: 'Task', id: string }> } | null };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string } };

export type CreateScopedUserMutationVariables = Exact<{
  input: CreateScopedUserInput;
}>;


export type CreateScopedUserMutation = { __typename?: 'Mutation', createScopedUser: { __typename?: 'User', id: string } };

export type DisableTwoFactorAuthenticationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisableTwoFactorAuthenticationMutation = { __typename?: 'Mutation', disableTwoFactorAuthentication: { __typename?: 'User', id: string, enabled_two_factor_authentication: boolean } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string } };

export type SetUserProfileRatesMutationVariables = Exact<{
  user_id: Scalars['ID']['input'];
  rates: Array<UserProfileRateInput> | UserProfileRateInput;
}>;


export type SetUserProfileRatesMutation = { __typename?: 'Mutation', setUserProfileRates: { __typename?: 'UserProfile', rates: Array<{ __typename?: 'UserProfileRate', id: string }> } };

export type ConnectToMcpMutationVariables = Exact<{
  input: ConnectToMcpInput;
}>;


export type ConnectToMcpMutation = { __typename?: 'Mutation', connectToMcp: { __typename?: 'ConnectToMcpPayload', status: string, message: string } };

export type DisconnectFromMcpMutationVariables = Exact<{
  input: DisconnectFromMcpInput;
}>;


export type DisconnectFromMcpMutation = { __typename?: 'Mutation', disconnectFromMcp: { __typename?: 'ConnectToMcpPayload', status: string, message: string } };

export type SetUserProfilePlanningRangesMutationVariables = Exact<{
  user_id: Scalars['ID']['input'];
  planningRanges: Array<PlanningRangeInput> | PlanningRangeInput;
}>;


export type SetUserProfilePlanningRangesMutation = { __typename?: 'Mutation', setUserProfilePlanningRanges: { __typename?: 'UserProfile', planningRanges: Array<{ __typename?: 'UserProfilePlanningRange', id: string }> } };

export type GetNewSequenceNumberQueryVariables = Exact<{
  invoice_type?: InputMaybe<SequenceTypesEnum>;
  date: Scalars['Date']['input'];
  workspace_company_id: Scalars['ID']['input'];
  documentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetNewSequenceNumberQuery = { __typename?: 'Query', getNewInvoiceNumber: Array<{ __typename?: 'InvoiceSequenceData', id: string, document_no: string }> };

export type CheckSequenceNumberExistQueryVariables = Exact<{
  document_no?: InputMaybe<Scalars['String']['input']>;
  invoice_type?: InputMaybe<SequenceTypesEnum>;
  date: Scalars['Date']['input'];
  document_id?: InputMaybe<Scalars['ID']['input']>;
  invoice_order_sequence_id: Scalars['ID']['input'];
  workspace_company_id: Scalars['ID']['input'];
}>;


export type CheckSequenceNumberExistQuery = { __typename?: 'Query', checkInvoiceNumberExist?: boolean | null };

export type UpdateProjectCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProjectCategoryMutation = { __typename?: 'Mutation', updateProjectCategory: { __typename?: 'ProjectCategory', id: string, name: string } };

export type DeleteProjectCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectCategoryMutation = { __typename?: 'Mutation', deleteProjectCategory: { __typename?: 'ProjectCategory', id: string } };

export type CreateProjectCategoryMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateProjectCategoryMutation = { __typename?: 'Mutation', createProjectCategory: { __typename?: 'ProjectCategory', id: string, name: string } };

export type GetProjectCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectCategoriesQuery = { __typename?: 'Query', projectCategories: Array<{ __typename?: 'ProjectCategory', id: string, name: string }> };

export type MarkTaskNotificationsAsUnreadMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
}>;


export type MarkTaskNotificationsAsUnreadMutation = { __typename?: 'Mutation', markTaskAndCommunicationNotificationAsUnread: boolean };

export type UpdateTaskScopesMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type UpdateTaskScopesMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'Task', id: string } };

export type UpdateProjectScopesMutationVariables = Exact<{
  input: UpdateProjectInput;
}>;


export type UpdateProjectScopesMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', id: string } };

export type AttachmentFragment = { __typename?: 'AssignableFile', public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null, viewable?: string | null, original?: string | null } };

export type CreateAssignableFileMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type CreateAssignableFileMutation = { __typename?: 'Mutation', createAssignableFile: { __typename?: 'AssignableFile', public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null, viewable?: string | null, original?: string | null } } };

export type UsersSimpleMapQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  allowedScopes?: InputMaybe<Scalars['Mixed']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  mentions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UsersSimpleMapQuery = { __typename?: 'Query', userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }> };

export type GetDefaultUserMentionsQueryVariables = Exact<{
  where?: InputMaybe<UsersWhereConditions>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetDefaultUserMentionsQuery = { __typename?: 'Query', userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }> };

export type UserToolTip_UserFragmentFragment = { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null };

export type UsersAllocatedTimeQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  types: Array<CapacityAllocationTypeEnum> | CapacityAllocationTypeEnum;
  user_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UsersAllocatedTimeQuery = { __typename?: 'Query', GetUsersAllocatedTime?: Array<{ __typename?: 'UserAllocatedTime', user_id: string, dates?: Array<{ __typename?: 'UserAllocatedTimeDate', date: Date, planned_capacity: number, data?: Array<{ __typename?: 'UserAllocatedTimeData', from_time?: Time | null, to_time?: Time | null, type: CapacityAllocationTypeEnum, value: number }> | null }> | null }> | null };

export type CheckForAllocationConflictsQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
  user_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  from_time?: InputMaybe<Scalars['Time']['input']>;
  to_time?: InputMaybe<Scalars['Time']['input']>;
  types: Array<CapacityAllocationTypeEnum> | CapacityAllocationTypeEnum;
  repetition_settings?: InputMaybe<Array<InputMaybe<RepetitionSettingsDaysEnum>> | InputMaybe<RepetitionSettingsDaysEnum>>;
}>;


export type CheckForAllocationConflictsQuery = { __typename?: 'Query', GetUsersAllocationConflicts?: Array<{ __typename?: 'UserAllocationConflicts', user_id: string, conflict: boolean }> | null };

export type BrandForNavigationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BrandForNavigationQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, name: string, code: string } | null };

export type GetSubmittedRfiCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubmittedRfiCountQuery = { __typename?: 'Query', getSubmittedRfiCount: number };

export type ProjectForNavigationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProjectForNavigationQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, title: string, code: string, finished_at?: Date | null, uses_budgetovac: boolean, type: ProjectTypeEnum, is_template: boolean } | null };

export type ContractorForNavigationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContractorForNavigationQuery = { __typename?: 'Query', contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null };

export type CreditAccountForNavigationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CreditAccountForNavigationQuery = { __typename?: 'Query', brandCreditAccount?: { __typename?: 'BrandCreditAccount', id: string, title: string } | null };

export type ExpenseForNavigationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ExpenseForNavigationQuery = { __typename?: 'Query', expense: { __typename?: 'Expense', id: string, expense_no?: string | null, is_draft: boolean } };

export type OutgoingInvoiceForNavigationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OutgoingInvoiceForNavigationQuery = { __typename?: 'Query', outgoingInvoice?: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, type: OutgoingInvoiceTypeEnum } | null };

export type ProformaInvoiceForNavigationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProformaInvoiceForNavigationQuery = { __typename?: 'Query', outgoingProformaInvoice?: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } | null };

export type GetRequestForInvoicingTypeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRequestForInvoicingTypeQuery = { __typename?: 'Query', requestForInvoicing?: { __typename?: 'RequestForInvoicing', id: string, type: RequestForInvoicingTypeEnum } | null };

export type QuoteForNavigationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type QuoteForNavigationQuery = { __typename?: 'Query', GetQuote: { __typename?: 'Quote', id: string, number: string } };

export type AccessTokenForBudgetovacQueryVariables = Exact<{
  appName?: InputMaybe<ThirdPartyEnum>;
}>;


export type AccessTokenForBudgetovacQuery = { __typename?: 'Query', getAccessTokenForThirdParty?: string | null };

export type RunningTimerQueryVariables = Exact<{
  user_id: Scalars['ID']['input'];
}>;


export type RunningTimerQuery = { __typename?: 'Query', runningTimer?: { __typename?: 'Timer', id: string, timeTrackingItem?: { __typename?: 'TimeTrackingItem', id: string, tracked_for_date: Date, tracked_time: number, tracked_time_with_running_timer: number, specific_time_from?: Time | null, specific_time_to?: Time | null, note?: string | null, auto_stopped: boolean, billable: boolean, is_locked: boolean, has_running_timer: boolean, timeBilling?: { __typename?: 'ProjectTimeBilling', id: string, name: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | null, user?: { __typename?: 'User', id: string } | null, capacityAllocationItem?: { __typename?: 'CapacityAllocationItem', id: string } | null, task: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, brand: { __typename?: 'Brand', id: string, name: string } } } | null }, timeTrackingBudgetItem: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled: boolean }, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', id: string, name: string } } } | null } | null };

export type AddScopedUsersToTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  user_ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  isTemplate: Scalars['Boolean']['input'];
}>;


export type AddScopedUsersToTaskMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'Task', id: string, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null }> } };

export type CreateLinkTaskMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
  link_type_id: Scalars['ID']['input'];
  linked_task_id: Scalars['ID']['input'];
}>;


export type CreateLinkTaskMutation = { __typename?: 'Mutation', addTaskLink?: { __typename?: 'TaskLink', id: string, linked_task: { __typename?: 'Task', id: string, name: string, commentCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, item_code?: string | null } | null }, link_type?: { __typename?: 'TaskLinkType', id: string, name: string } | null } | null };

export type CreateTaskCommentMutationVariables = Exact<{
  input: CreateTaskCommentInput;
}>;


export type CreateTaskCommentMutation = { __typename?: 'Mutation', createTaskComment: { __typename?: 'TaskComment', id: string, body: string, timestamp?: Date | null, has_edits?: boolean | null, user: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }, reactions?: Array<{ __typename?: 'TaskCommentReaction', id: string, emoji_id: string, user: { __typename?: 'User', id: string, full_name: string } } | null> | null, files: Array<{ __typename?: 'AssignableFile', public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null, viewable?: string | null, original?: string | null } }> } };

export type DeleteAssignableFileMutationVariables = Exact<{
  publicId: Scalars['String']['input'];
}>;


export type DeleteAssignableFileMutation = { __typename?: 'Mutation', deleteAssignableFile?: { __typename?: 'BooleanResult', result?: boolean | null } | null };

export type DeleteLinkTaskMutationVariables = Exact<{
  task_link_id: Scalars['ID']['input'];
}>;


export type DeleteLinkTaskMutation = { __typename?: 'Mutation', deleteTaskLink: { __typename?: 'TaskLink', id: string } };

export type DeleteTaskCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTaskCommentMutation = { __typename?: 'Mutation', deleteTaskComment: { __typename?: 'TaskComment', id: string } };

export type DuplicateTaskMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
  task_input?: InputMaybe<CreateTaskInput>;
  with_attachments?: InputMaybe<Scalars['Boolean']['input']>;
  with_links?: InputMaybe<Scalars['Boolean']['input']>;
  with_comments?: InputMaybe<Scalars['Boolean']['input']>;
  performed_by_user_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DuplicateTaskMutation = { __typename?: 'Mutation', duplicateTask: { __typename?: 'Task', revision: string, cloudUrl?: string | null, driveCloudUrl?: string | null, billable: boolean, commentCount: number, scopedCommentCount: number, otherPeopleTrackedTotal: number, task_template_group_id?: string | null, unreadCommentsCount: number, created_at?: Date | null, from?: Date | null, days_to_from?: number | null, to?: Date | null, days_to_to?: number | null, attachments_download_url: string, clientCommentCount: number, partnerCommentCount: number, id: string, name: string, is_template: boolean, is_starred: boolean, deadline?: Date | null, days_to_deadline?: number | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, otherPeopleTracked?: Array<{ __typename?: 'OtherPeopleTracked', time_tracking_work_type_id: string, tracked_time: number, user: { __typename?: 'User', full_name: string } }> | null, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null }>, createdBy?: { __typename?: 'User', id: string, full_name: string, codename?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, linkedTasks?: Array<{ __typename?: 'TaskLink', id: string, link_type?: { __typename?: 'TaskLinkType', name: string } | null, linked_task: { __typename?: 'Task', id: string, name: string, commentCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, item_code?: string | null } | null } }> | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, positions: Array<{ __typename?: 'TaskPosition', planned_time: number, id: string, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', uses_budgetovac: boolean, id: string, code: string, title: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | null, brand: { __typename?: 'Brand', id: string, name: string, client: { __typename?: 'Client', id: string, name: string } } }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_to?: Date | null, tracking_enabled_from?: Date | null }, category: { __typename?: 'OurWorkBudgetCategory', name: string } } | null, parent?: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, project: { __typename?: 'Project', id: string, code: string, title: string } } | null, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | null } } | null, taskWatchers: Array<{ __typename?: 'TaskWatcher', user_id: string } | null>, currentAssignee?: { __typename?: 'User', id: string } | null, description?: { __typename?: 'TaskDescription', body?: string | null, mentioned_user_ids?: Array<string> | null, mentioned_team_ids?: Array<string> | null, mentioned_assignees?: boolean | null } | null, files: Array<{ __typename?: 'AssignableFile', created_at: Date, public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null, viewable?: string | null, original?: string | null } }>, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null } } };

export type EditTaskWatchersMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type EditTaskWatchersMutation = { __typename?: 'Mutation', editTaskWatchers: { __typename?: 'Task', taskWatchers: Array<{ __typename?: 'TaskWatcher', user_id: string } | null> } };

export type LastSeenCommentMutationVariables = Exact<{
  comment_id: Scalars['ID']['input'];
}>;


export type LastSeenCommentMutation = { __typename?: 'Mutation', lastSeen?: { __typename?: 'Task', id: string } | null };

export type MarkTaskNotificationsAsReadMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
}>;


export type MarkTaskNotificationsAsReadMutation = { __typename?: 'Mutation', markTaskAndCommunicationNotificationAsRead: boolean };

export type ToggleTaskCommentReactionMutationVariables = Exact<{
  input: ToggleTaskCommentReactionInput;
}>;


export type ToggleTaskCommentReactionMutation = { __typename?: 'Mutation', toggleTaskCommentReaction?: Array<{ __typename?: 'TaskCommentReaction', id: string, emoji_id: string, user: { __typename?: 'User', id: string, full_name: string } }> | null };

export type UpdateTaskCommentMutationVariables = Exact<{
  input: UpdateTaskCommentInput;
}>;


export type UpdateTaskCommentMutation = { __typename?: 'Mutation', updateTaskComment: { __typename?: 'TaskComment', id: string, body: string, timestamp?: Date | null, has_edits?: boolean | null, user: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }, reactions?: Array<{ __typename?: 'TaskCommentReaction', id: string, emoji_id: string, user: { __typename?: 'User', id: string, full_name: string } } | null> | null, files: Array<{ __typename?: 'AssignableFile', public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null, viewable?: string | null, original?: string | null } }> } };

export type UpdateTaskDescriptionMutationVariables = Exact<{
  input: UpdateTaskDescriptionInput;
}>;


export type UpdateTaskDescriptionMutation = { __typename?: 'Mutation', updateTaskDescription: { __typename?: 'Task', id: string, revision: string, description?: { __typename?: 'TaskDescription', body?: string | null, mentioned_user_ids?: Array<string> | null, mentioned_team_ids?: Array<string> | null, mentioned_assignees?: boolean | null } | null } };

export type UpdateTaskFilesMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
  files: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateTaskFilesMutation = { __typename?: 'Mutation', addTaskFiles: { __typename?: 'Task', id: string, files: Array<{ __typename?: 'AssignableFile', created_at: Date, public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null, viewable?: string | null, original?: string | null } }> } };

export type UpdateTaskPriorityMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
  priority_id: Scalars['ID']['input'];
}>;


export type UpdateTaskPriorityMutation = { __typename?: 'Mutation', updateTaskPriority: { __typename?: 'Task', id: string, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null } } };

export type UpdateTaskStatusMutationVariables = Exact<{
  task_id: Scalars['ID']['input'];
  status_id: Scalars['ID']['input'];
}>;


export type UpdateTaskStatusMutation = { __typename?: 'Mutation', updateTaskStatus: { __typename?: 'Task', id: string, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null } } };

export type CheckTaskRevisionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CheckTaskRevisionQuery = { __typename?: 'Query', task: { __typename?: 'Task', id: string, revision: string } };

export type CommentFragment = { __typename?: 'TaskComment', id: string, body: string, timestamp?: Date | null, has_edits?: boolean | null, user: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }, reactions?: Array<{ __typename?: 'TaskCommentReaction', id: string, emoji_id: string, user: { __typename?: 'User', id: string, full_name: string } } | null> | null, files: Array<{ __typename?: 'AssignableFile', public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null, viewable?: string | null, original?: string | null } }> };

export type GetTaskCommunicationFilesQueryVariables = Exact<{
  task_id: Scalars['ID']['input'];
  scope?: InputMaybe<UserScopeEnum>;
}>;


export type GetTaskCommunicationFilesQuery = { __typename?: 'Query', taskCommentFiles: Array<{ __typename?: 'AssignableFile', public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null, viewable?: string | null, original?: string | null } }> };

export type GetTaskLinkTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaskLinkTypesQuery = { __typename?: 'Query', taskLinkTypes: Array<{ __typename?: 'TaskLinkType', id: string, name: string }> };

export type GetTaskLinksQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTaskLinksQuery = { __typename?: 'Query', task: { __typename?: 'Task', linkedTasks?: Array<{ __typename?: 'TaskLink', link_type?: { __typename?: 'TaskLinkType', name: string } | null, linked_task: { __typename?: 'Task', name: string, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null } } }> | null } };

export type TaskFragmentForScopedUserFragment = { __typename?: 'Task', created_at?: Date | null, from?: Date | null, days_to_from?: number | null, to?: Date | null, days_to_to?: number | null, attachments_download_url: string, clientCommentCount: number, partnerCommentCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null }>, currentAssignee?: { __typename?: 'User', id: string } | null, createdBy?: { __typename?: 'User', id: string, full_name: string, codename?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, description?: { __typename?: 'TaskDescription', body?: string | null, mentioned_user_ids?: Array<string> | null, mentioned_team_ids?: Array<string> | null, mentioned_assignees?: boolean | null } | null, positions: Array<{ __typename?: 'TaskPosition', id: string, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', uses_budgetovac: boolean, id: string, code: string, title: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | null, brand: { __typename?: 'Brand', id: string, name: string, client: { __typename?: 'Client', id: string, name: string } } } } | null, files: Array<{ __typename?: 'AssignableFile', created_at: Date, public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null, viewable?: string | null, original?: string | null } }>, parent?: { __typename?: 'Task', id: string, name: string, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', project: { __typename?: 'Project', id: string, code: string, title: string } } | null } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null } };

export type TaskFragmentFragment = { __typename?: 'Task', revision: string, cloudUrl?: string | null, driveCloudUrl?: string | null, billable: boolean, commentCount: number, scopedCommentCount: number, otherPeopleTrackedTotal: number, task_template_group_id?: string | null, created_at?: Date | null, from?: Date | null, days_to_from?: number | null, to?: Date | null, days_to_to?: number | null, attachments_download_url: string, clientCommentCount: number, partnerCommentCount: number, id: string, name: string, is_template: boolean, is_starred: boolean, deadline?: Date | null, days_to_deadline?: number | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, otherPeopleTracked?: Array<{ __typename?: 'OtherPeopleTracked', time_tracking_work_type_id: string, tracked_time: number, user: { __typename?: 'User', full_name: string } }> | null, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null }>, createdBy?: { __typename?: 'User', id: string, full_name: string, codename?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, linkedTasks?: Array<{ __typename?: 'TaskLink', id: string, link_type?: { __typename?: 'TaskLinkType', name: string } | null, linked_task: { __typename?: 'Task', id: string, name: string, commentCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, item_code?: string | null } | null } }> | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, positions: Array<{ __typename?: 'TaskPosition', planned_time: number, id: string, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', uses_budgetovac: boolean, id: string, code: string, title: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | null, brand: { __typename?: 'Brand', id: string, name: string, client: { __typename?: 'Client', id: string, name: string } } }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_to?: Date | null, tracking_enabled_from?: Date | null } } | null, parent?: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, project: { __typename?: 'Project', id: string, code: string, title: string } } | null, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | null } } | null, taskWatchers: Array<{ __typename?: 'TaskWatcher', user_id: string } | null>, currentAssignee?: { __typename?: 'User', id: string } | null, description?: { __typename?: 'TaskDescription', body?: string | null, mentioned_user_ids?: Array<string> | null, mentioned_team_ids?: Array<string> | null, mentioned_assignees?: boolean | null } | null, files: Array<{ __typename?: 'AssignableFile', created_at: Date, public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null, viewable?: string | null, original?: string | null } }>, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null } };

export type TaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskQuery = { __typename?: 'Query', taskPositionStat: Array<{ __typename?: 'TaskPositionStat', planned_time: number, spent_time: number, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, task: { __typename?: 'Task', revision: string, cloudUrl?: string | null, driveCloudUrl?: string | null, billable: boolean, commentCount: number, scopedCommentCount: number, otherPeopleTrackedTotal: number, task_template_group_id?: string | null, created_at?: Date | null, from?: Date | null, days_to_from?: number | null, to?: Date | null, days_to_to?: number | null, attachments_download_url: string, clientCommentCount: number, partnerCommentCount: number, id: string, name: string, is_template: boolean, is_starred: boolean, deadline?: Date | null, days_to_deadline?: number | null, subtasks?: Array<{ __typename?: 'Task', revision: string, cloudUrl?: string | null, driveCloudUrl?: string | null, billable: boolean, commentCount: number, scopedCommentCount: number, otherPeopleTrackedTotal: number, task_template_group_id?: string | null, created_at?: Date | null, from?: Date | null, days_to_from?: number | null, to?: Date | null, days_to_to?: number | null, attachments_download_url: string, clientCommentCount: number, partnerCommentCount: number, id: string, name: string, is_template: boolean, is_starred: boolean, deadline?: Date | null, days_to_deadline?: number | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, otherPeopleTracked?: Array<{ __typename?: 'OtherPeopleTracked', time_tracking_work_type_id: string, tracked_time: number, user: { __typename?: 'User', full_name: string } }> | null, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null }>, createdBy?: { __typename?: 'User', id: string, full_name: string, codename?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, linkedTasks?: Array<{ __typename?: 'TaskLink', id: string, link_type?: { __typename?: 'TaskLinkType', name: string } | null, linked_task: { __typename?: 'Task', id: string, name: string, commentCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, item_code?: string | null } | null } }> | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, positions: Array<{ __typename?: 'TaskPosition', planned_time: number, id: string, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', uses_budgetovac: boolean, id: string, code: string, title: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | null, brand: { __typename?: 'Brand', id: string, name: string, client: { __typename?: 'Client', id: string, name: string } } }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_to?: Date | null, tracking_enabled_from?: Date | null } } | null, parent?: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, project: { __typename?: 'Project', id: string, code: string, title: string } } | null, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | null } } | null, taskWatchers: Array<{ __typename?: 'TaskWatcher', user_id: string } | null>, currentAssignee?: { __typename?: 'User', id: string } | null, description?: { __typename?: 'TaskDescription', body?: string | null, mentioned_user_ids?: Array<string> | null, mentioned_team_ids?: Array<string> | null, mentioned_assignees?: boolean | null } | null, files: Array<{ __typename?: 'AssignableFile', created_at: Date, public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null, viewable?: string | null, original?: string | null } }>, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null } }> | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, otherPeopleTracked?: Array<{ __typename?: 'OtherPeopleTracked', time_tracking_work_type_id: string, tracked_time: number, user: { __typename?: 'User', full_name: string } }> | null, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null }>, createdBy?: { __typename?: 'User', id: string, full_name: string, codename?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, linkedTasks?: Array<{ __typename?: 'TaskLink', id: string, link_type?: { __typename?: 'TaskLinkType', name: string } | null, linked_task: { __typename?: 'Task', id: string, name: string, commentCount: number, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, item_code?: string | null } | null } }> | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, positions: Array<{ __typename?: 'TaskPosition', planned_time: number, id: string, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', uses_budgetovac: boolean, id: string, code: string, title: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | null, brand: { __typename?: 'Brand', id: string, name: string, client: { __typename?: 'Client', id: string, name: string } } }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_to?: Date | null, tracking_enabled_from?: Date | null } } | null, parent?: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, project: { __typename?: 'Project', id: string, code: string, title: string } } | null, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | null } } | null, taskWatchers: Array<{ __typename?: 'TaskWatcher', user_id: string } | null>, currentAssignee?: { __typename?: 'User', id: string } | null, description?: { __typename?: 'TaskDescription', body?: string | null, mentioned_user_ids?: Array<string> | null, mentioned_team_ids?: Array<string> | null, mentioned_assignees?: boolean | null } | null, files: Array<{ __typename?: 'AssignableFile', created_at: Date, public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null, viewable?: string | null, original?: string | null } }>, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null } }, taskStatuses: Array<{ __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }>, taskPriorities: Array<{ __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }> };

export type TaskForScopedUsersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskForScopedUsersQuery = { __typename?: 'Query', task: { __typename?: 'Task', created_at?: Date | null, from?: Date | null, days_to_from?: number | null, to?: Date | null, days_to_to?: number | null, attachments_download_url: string, clientCommentCount: number, partnerCommentCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null }>, currentAssignee?: { __typename?: 'User', id: string } | null, createdBy?: { __typename?: 'User', id: string, full_name: string, codename?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, description?: { __typename?: 'TaskDescription', body?: string | null, mentioned_user_ids?: Array<string> | null, mentioned_team_ids?: Array<string> | null, mentioned_assignees?: boolean | null } | null, positions: Array<{ __typename?: 'TaskPosition', id: string, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', uses_budgetovac: boolean, id: string, code: string, title: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | null, brand: { __typename?: 'Brand', id: string, name: string, client: { __typename?: 'Client', id: string, name: string } } } } | null, files: Array<{ __typename?: 'AssignableFile', created_at: Date, public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null, viewable?: string | null, original?: string | null } }>, parent?: { __typename?: 'Task', id: string, name: string, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', project: { __typename?: 'Project', id: string, code: string, title: string } } | null } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null } }, taskStatuses: Array<{ __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string }>, taskPriorities: Array<{ __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }> };

export type TaskCommentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<UserScopeEnum>;
  lastCommentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TaskCommentsQuery = { __typename?: 'Query', taskComments?: { __typename?: 'TaskCommentPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'TaskComment', id: string, body: string, timestamp?: Date | null, has_edits?: boolean | null, user: { __typename?: 'User', id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null }, reactions?: Array<{ __typename?: 'TaskCommentReaction', id: string, emoji_id: string, user: { __typename?: 'User', id: string, full_name: string } } | null> | null, files: Array<{ __typename?: 'AssignableFile', public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null, viewable?: string | null, original?: string | null } }> }> } | null };

export type TaskStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type TaskStatusesQuery = { __typename?: 'Query', taskStatuses: Array<{ __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }> };

export type HasTaskPermissionQueryVariables = Exact<{
  task_id: Scalars['ID']['input'];
  type: TaskPermissionTypeEnum;
}>;


export type HasTaskPermissionQuery = { __typename?: 'Query', hasTaskPermission: boolean };

export type CompleteExpenseBudgetItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  completed_at?: InputMaybe<Scalars['Date']['input']>;
}>;


export type CompleteExpenseBudgetItemMutation = { __typename?: 'Mutation', completeExpenseBudgetItem: { __typename?: 'ExpenseBudgetItem', id: string, completed_at?: Date | null, stats: { __typename?: 'ExpenseBudgetItemStats', planned_commission: number, planned_commission_relative_computed: string, real_commission: number, real_commission_relative: string } } };

export type EbiCompleteDataFragment = { __typename?: 'ExpenseBudgetItem', id: string, completed_at?: Date | null, stats: { __typename?: 'ExpenseBudgetItemStats', planned_commission: number, planned_commission_relative_computed: string, real_commission: number, real_commission_relative: string } };

export type ReopenExpenseBudgetItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReopenExpenseBudgetItemMutation = { __typename?: 'Mutation', reopenExpenseBudgetItem: { __typename?: 'ExpenseBudgetItem', id: string, completed_at?: Date | null, stats: { __typename?: 'ExpenseBudgetItemStats', planned_commission: number, planned_commission_relative_computed: string, real_commission: number, real_commission_relative: string } } };

export type ReturnGlobalCreditMutationVariables = Exact<{
  amount: Scalars['BigInt']['input'];
  expense_budget_item_id: Scalars['ID']['input'];
  global_credit_account_id: Scalars['ID']['input'];
  credit_account_operation_id: Scalars['ID']['input'];
}>;


export type ReturnGlobalCreditMutation = { __typename?: 'Mutation', returnGlobalCreditFromExpenseItem: boolean };

export type TransferGlobalCreditMutationVariables = Exact<{
  amount: Scalars['BigInt']['input'];
  fromCreditAccountId: Scalars['ID']['input'];
  toCreditAccountId: Scalars['ID']['input'];
  performedAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type TransferGlobalCreditMutation = { __typename?: 'Mutation', transferGlobalCredit: boolean };

export type ExpenseBudgetItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ExpenseBudgetItemQuery = { __typename?: 'Query', expenseBudgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, type: ExpenseBudgetItemType, title: string, completed_at?: Date | null, project: { __typename?: 'Project', id: string, billable: boolean, brand: { __typename?: 'Brand', id: string } }, expenseStats: Array<{ __typename?: 'ExpenseBudgetItemExpenseStats', id: string, amount: number, date?: Date | null, expense: { __typename?: 'Expense', id: string, status: ExpenseStatusEnum }, contractor?: { __typename?: 'Contractor', id: string, legal_name: string } | null }>, creditAccount?: { __typename?: 'CreditAccount', id: string } | null, stats: { __typename?: 'ExpenseBudgetItemStats', real_expenses: number, planned_commission: number, planned_commission_relative_computed: string, real_commission: number, real_commission_relative: string }, globalPrepaymentStats: Array<{ __typename?: 'ExpenseBudgetItemGlobalPrepaymentStats', id: string, credit: number, date: Date, credit_account_operation_id: string, expenseBudgetItem: { __typename?: 'ExpenseBudgetItem', id: string, title: string }, globalCreditAccount: { __typename?: 'GlobalCreditAccount', id: string, title: string } }> } | null };

export type ContactFragment = { __typename?: 'Contact', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null };

export type CreateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact: { __typename?: 'Contact', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } };

export type UpdateContactMutationVariables = Exact<{
  input: UpdateContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact: { __typename?: 'Contact', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } };

export type ExchangeRateFragment = { __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: Date | null, valid_to?: Date | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } };

export type CreateCurrencyExchangeRateForClientMutationVariables = Exact<{
  input: CreateCurrencyExchangeRateInput;
}>;


export type CreateCurrencyExchangeRateForClientMutation = { __typename?: 'Mutation', createCurrencyExchangeRate: { __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: Date | null, valid_to?: Date | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } } };

export type UpdateCurrencyExchangeRateForClientMutationVariables = Exact<{
  input: UpdateCurrencyExchangeRateInput;
}>;


export type UpdateCurrencyExchangeRateForClientMutation = { __typename?: 'Mutation', updateCurrencyExchangeRate: { __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: Date | null, valid_to?: Date | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } } };

export type CreateCurrencyExchangeRateForWorkspaceMutationVariables = Exact<{
  input: CreateExchangeRateSettingsInput;
}>;


export type CreateCurrencyExchangeRateForWorkspaceMutation = { __typename?: 'Mutation', createExchangeRateForWorkspace: { __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: Date | null, valid_to?: Date | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } } };

export type UpdateCurrencyExchangeRateForWorkspaceMutationVariables = Exact<{
  input: UpdateExchangeRateSettingsInput;
}>;


export type UpdateCurrencyExchangeRateForWorkspaceMutation = { __typename?: 'Mutation', updateExchangeRateForWorkspace: { __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: Date | null, valid_to?: Date | null, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } } };

export type CompleteExpenseBulkMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  completed_at?: InputMaybe<Scalars['Date']['input']>;
}>;


export type CompleteExpenseBulkMutation = { __typename?: 'Mutation', completeExpenseBudgetItemBulk: Array<{ __typename?: 'ExpenseBudgetItem', id: string, completed_at?: Date | null }> };

export type CompleteExpenseBulkDataFragment = { __typename?: 'ExpenseBudgetItem', id: string, completed_at?: Date | null };

export type FinishProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FinishProjectMutation = { __typename?: 'Mutation', finishProject: { __typename?: 'Project', id: string, status: ProjectStatusEnum, finished_at?: Date | null, finishedBy?: { __typename?: 'User', id: string, full_name: string } | null } };

export type FinishedProjectDataFragment = { __typename?: 'Project', id: string, status: ProjectStatusEnum, finished_at?: Date | null, finishedBy?: { __typename?: 'User', id: string, full_name: string } | null };

export type RedistributeProjectCreditMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RedistributeProjectCreditMutation = { __typename?: 'Mutation', redistributeProjectCredit: { __typename?: 'Project', id: string } };

export type ModalFinishProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ModalFinishProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, billable: boolean } | null, getProjectCanBeFinishedSummary: { __typename?: 'ProjectFinishSummary', id: string, project_already_finished: boolean, can_be_finished_without_further_changes: boolean, can_redistribute_credit_automatically: boolean, overinvoiced_for_project: boolean, underinvoiced_for_project: boolean, incomplete_expense_budget_items: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, stats: { __typename?: 'ExpenseBudgetItemStats', id: string, real_expenses_percent: number, real_expenses: number, real_commission: number, real_commission_relative: string } }>, incomplete_our_work_budget_items: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, stats: { __typename?: 'OurWorkBudgetItemStats', id: string, spent_time: number, spent_budget: number }, lastWorkInProgressItemStat?: { __typename?: 'WorkInProgressItemStat', work_in_progress_id: string, progress_percent: number } | null }>, underinvoiced_our_work_budget_items: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, stats: { __typename?: 'OurWorkBudgetItemStats', id: string, uninvoiced: number, credit: number, total_budget: number } }>, underinvoiced_expense_budget_items: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, stats: { __typename?: 'ExpenseBudgetItemStats', id: string, uninvoiced: number, credit: number, total_budget: number } }>, overinvoiced_our_work_budget_items: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, stats: { __typename?: 'OurWorkBudgetItemStats', id: string, credit: number, total_budget: number, over_invoiced: number } }>, overinvoiced_expense_budget_items: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, stats: { __typename?: 'ExpenseBudgetItemStats', id: string, credit: number, total_budget: number, over_invoiced: number } }> } };

export type ModalGetCreditDependenciesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ModalGetCreditDependenciesQuery = { __typename?: 'Query', brand?: { __typename?: 'Brand', id: string, creditAccounts?: Array<{ __typename?: 'BrandCreditAccount', id: string, title: string, creditAccount: { __typename?: 'CreditAccount', id: string }, stats: { __typename?: 'BrandCreditAccountStats', id: string, remaining_credit: number } }> | null } | null };

export type InvoiceProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  expense_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
  our_work_budget_item_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type InvoiceProjectMutation = { __typename?: 'Mutation', invoiceProject?: { __typename?: 'RequestForInvoicing', id: string } | null };

export type OutgoingInvoiceOfInvoiceStatsFragment = { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, date_of_supply: Date, type: OutgoingInvoiceTypeEnum, has_proforma_payments: boolean, abraflexi_exported?: boolean | null, xero_exported?: boolean | null, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } }>, stats: { __typename?: 'OutgoingInvoiceStats', billing_amount: number }, documentExports: Array<{ __typename?: 'DocumentExport', type: string, exported_at: Date }>, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: Date, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | null }> };

export type ModalInvoicesOurWorkBiQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ModalInvoicesOurWorkBiQuery = { __typename?: 'Query', ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, billable: boolean, brand: { __typename?: 'Brand', id: string } }, creditAccount: { __typename?: 'CreditAccount', id: string }, invoiceStats: Array<{ __typename?: 'OurWorkBudgetItemInvoiceStats', id: string, credit: number, outgoingInvoice: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, date_of_supply: Date, type: OutgoingInvoiceTypeEnum, has_proforma_payments: boolean, abraflexi_exported?: boolean | null, xero_exported?: boolean | null, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } }>, stats: { __typename?: 'OutgoingInvoiceStats', billing_amount: number }, documentExports: Array<{ __typename?: 'DocumentExport', type: string, exported_at: Date }>, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: Date, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | null }> } }>, outgoingProformaInvoiceStats: Array<{ __typename?: 'OurWorkBudgetItemProformaStats', id: string, amount: number, invoice_no: string, date: Date }>, prepaymentStats: Array<{ __typename?: 'OurWorkBudgetItemPrepaymentStats', id: string, date: Date, credit: number, credit_account_operation_id: string, brandCreditAccount: { __typename?: 'BrandCreditAccount', id: string, title: string }, ourWorkBudgetItem: { __typename?: 'OurWorkBudgetItem', id: string, title: string } }>, stats: { __typename?: 'OurWorkBudgetItemStats', id: string, credit: number, credit_direct: number, credit_from_prepayments: number, uninvoiced: number } } | null };

export type ModalInvoicesExpenseBiQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ModalInvoicesExpenseBiQuery = { __typename?: 'Query', expenseBudgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, billable: boolean, brand: { __typename?: 'Brand', id: string } }, creditAccount?: { __typename?: 'CreditAccount', id: string } | null, invoiceStats: Array<{ __typename?: 'ExpenseBudgetItemInvoiceStats', id: string, credit: number, outgoingInvoice: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, date_of_supply: Date, type: OutgoingInvoiceTypeEnum, has_proforma_payments: boolean, abraflexi_exported?: boolean | null, xero_exported?: boolean | null, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } }>, stats: { __typename?: 'OutgoingInvoiceStats', billing_amount: number }, documentExports: Array<{ __typename?: 'DocumentExport', type: string, exported_at: Date }>, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: Date, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | null }> } }>, outgoingProformaInvoiceStats: Array<{ __typename?: 'OurWorkBudgetItemProformaStats', id: string, amount: number, invoice_no: string, date: Date }>, prepaymentStats: Array<{ __typename?: 'ExpenseBudgetItemPrepaymentStats', id: string, date: Date, credit: number, credit_account_operation_id: string, brandCreditAccount: { __typename?: 'BrandCreditAccount', id: string, title: string }, expenseBudgetItem: { __typename?: 'ExpenseBudgetItem', id: string, title: string } }>, stats: { __typename?: 'ExpenseBudgetItemStats', id: string, credit: number, credit_direct: number, credit_from_prepayments: number, uninvoiced: number } } | null };

export type ModalInvoicesProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ModalInvoicesProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, billable: boolean, proformaInvoices: Array<{ __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string, issue_date: Date, abraflexi_exported?: boolean | null, documentExports: Array<{ __typename?: 'DocumentExport', type: string, exported_at: Date }>, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: Date, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | null }>, stats: { __typename?: 'OutgoingProformaInvoiceStats', total_amount: number } }>, invoiceStats: Array<{ __typename?: 'ProjectInvoiceStat', id: string, credit: number, outgoingInvoice: { __typename?: 'OutgoingInvoice', id: string, invoice_no: string, date_of_supply: Date, type: OutgoingInvoiceTypeEnum, has_proforma_payments: boolean, abraflexi_exported?: boolean | null, xero_exported?: boolean | null, proformaInvoicesPivot: Array<{ __typename?: 'AttachedOutgoingProformaInvoicePivot', invoice: { __typename?: 'OutgoingProformaInvoice', id: string, invoice_no: string } }>, stats: { __typename?: 'OutgoingInvoiceStats', billing_amount: number }, documentExports: Array<{ __typename?: 'DocumentExport', type: string, exported_at: Date }>, emailLogs: Array<{ __typename?: 'OutgoingInvoiceEmailLog', id: string, type: string, accepted_delivery: boolean, sent_at: Date, recipients: Array<{ __typename?: 'Recipient', email: string }>, recipientLog?: Array<{ __typename?: 'RecipientLog', recipient: string, status: RecipientLogStatus }> | null }> } }>, prepaymentStats: Array<{ __typename?: 'ProjectPrepaymentStat', id: string, date: Date, credit: number, brandCreditAccount: { __typename?: 'BrandCreditAccount', id: string, title: string }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string } | null, expenseBudgetItem?: { __typename?: 'ExpenseBudgetItem', id: string, title: string } | null }>, statsCached?: { __typename?: 'ProjectStats', id: string, credit_direct: number, credit_from_prepayments: number, unused_sum_from_proformas: number } | null } | null };

export type ModalOrderDataFragment = { __typename?: 'Order', id: string, purchase_order_no?: string | null, date_of_order?: Date | null, projects?: Array<{ __typename?: 'Project', id: string } | null> | null, brand: { __typename?: 'Brand', id: string }, files: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } }>, pdfFiles: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } }> };

export type CreateOrderMutationVariables = Exact<{
  input: CreateOrderInput;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder: { __typename?: 'Order', id: string, purchase_order_no?: string | null, date_of_order?: Date | null, projects?: Array<{ __typename?: 'Project', id: string } | null> | null, brand: { __typename?: 'Brand', id: string }, files: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } }>, pdfFiles: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } }> } };

export type UpdateOrderMutationVariables = Exact<{
  input: UpdateOrderInput;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder: { __typename?: 'Order', id: string, purchase_order_no?: string | null, date_of_order?: Date | null, projects?: Array<{ __typename?: 'Project', id: string } | null> | null, brand: { __typename?: 'Brand', id: string }, files: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } }>, pdfFiles: Array<{ __typename?: 'AssignableFile', public_id: string, mime_type: string, size: string, name: string, filename: string, urls: { __typename?: 'AssignableFileUrlPair', viewable?: string | null, original?: string | null } }> } };

export type ModalCreateOrderBrandOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ModalCreateOrderBrandOptionsQuery = { __typename?: 'Query', clientsSimpleMap: Array<{ __typename?: 'ClientSimple', brands: Array<{ __typename?: 'BrandSimple', id: string, name: string, code: string }> }> };

export type ModalCreateOrderProjectOptionsQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
}>;


export type ModalCreateOrderProjectOptionsQuery = { __typename?: 'Query', projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string, brand_id: string }> };

export type ReturnCreditFromOurWorkMutationVariables = Exact<{
  amount: Scalars['BigInt']['input'];
  our_work_budget_item_id: Scalars['ID']['input'];
  brand_credit_account_id: Scalars['ID']['input'];
  credit_account_operation_id: Scalars['ID']['input'];
}>;


export type ReturnCreditFromOurWorkMutation = { __typename?: 'Mutation', returnCreditFromOurWorkBudgetItem: boolean };

export type ReturnCreditFromExpenseMutationVariables = Exact<{
  amount: Scalars['BigInt']['input'];
  expense_budget_item_id: Scalars['ID']['input'];
  brand_credit_account_id: Scalars['ID']['input'];
  credit_account_operation_id: Scalars['ID']['input'];
}>;


export type ReturnCreditFromExpenseMutation = { __typename?: 'Mutation', returnCreditFromExpenseBudgetItem: boolean };

export type SendQuoteMutationVariables = Exact<{
  input: QuoteSendInput;
}>;


export type SendQuoteMutation = { __typename?: 'Mutation', sendQuote: { __typename?: 'Quote', id: string } };

export type CreateTaskMutationVariables = Exact<{
  input: CreateTaskInput;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask: { __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null } };

export type CreateScopedTaskMutationVariables = Exact<{
  input: CreateScopedTaskInput;
}>;


export type CreateScopedTaskMutation = { __typename?: 'Mutation', createScopedTask: { __typename?: 'Task', created_at?: Date | null, from?: Date | null, days_to_from?: number | null, to?: Date | null, days_to_to?: number | null, attachments_download_url: string, clientCommentCount: number, partnerCommentCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null }>, currentAssignee?: { __typename?: 'User', id: string } | null, createdBy?: { __typename?: 'User', id: string, full_name: string, codename?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, description?: { __typename?: 'TaskDescription', body?: string | null, mentioned_user_ids?: Array<string> | null, mentioned_team_ids?: Array<string> | null, mentioned_assignees?: boolean | null } | null, positions: Array<{ __typename?: 'TaskPosition', id: string, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', uses_budgetovac: boolean, id: string, code: string, title: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | null, brand: { __typename?: 'Brand', id: string, name: string, client: { __typename?: 'Client', id: string, name: string } } } } | null, files: Array<{ __typename?: 'AssignableFile', created_at: Date, public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null, viewable?: string | null, original?: string | null } }>, parent?: { __typename?: 'Task', id: string, name: string, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', project: { __typename?: 'Project', id: string, code: string, title: string } } | null } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null } } };

export type DeleteTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteTask: { __typename?: 'Task', id: string } };

export type SimpleTaskForClientFragment = { __typename?: 'Task', id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null };

export type SimpleTaskFragment = { __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null };

export type UpdateTaskMutationVariables = Exact<{
  input: UpdateTaskInput;
  propagate_billable: Scalars['Boolean']['input'];
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'Task', billable: boolean, commentCount: number, unreadCommentsCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, stats?: { __typename?: 'TaskStats', planned_time: number, spent_time: number } | null, scopes: Array<{ __typename?: 'UserScope', value: UserScopeEnum }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', title: string, id: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean }, project: { __typename?: 'Project', id: string, code: string, title: string, uses_budgetovac: boolean, brand: { __typename?: 'Brand', name: string, client: { __typename?: 'Client', name: string } } } } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }, positions: Array<{ __typename?: 'TaskPosition', user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, parent?: { __typename?: 'Task', id: string, name: string } | null } };

export type UpdateScopedTaskMutationVariables = Exact<{
  input: UpdateScopedTaskInput;
}>;


export type UpdateScopedTaskMutation = { __typename?: 'Mutation', updateScopedTask: { __typename?: 'Task', created_at?: Date | null, from?: Date | null, days_to_from?: number | null, to?: Date | null, days_to_to?: number | null, attachments_download_url: string, clientCommentCount: number, partnerCommentCount: number, id: string, name: string, scopedCommentCount: number, is_template: boolean, is_starred: boolean, task_template_group_id?: string | null, deadline?: Date | null, days_to_deadline?: number | null, users: Array<{ __typename?: 'User', id: string, first_name: string, last_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null }>, currentAssignee?: { __typename?: 'User', id: string } | null, createdBy?: { __typename?: 'User', id: string, full_name: string, codename?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null, description?: { __typename?: 'TaskDescription', body?: string | null, mentioned_user_ids?: Array<string> | null, mentioned_team_ids?: Array<string> | null, mentioned_assignees?: boolean | null } | null, positions: Array<{ __typename?: 'TaskPosition', id: string, user?: { __typename?: 'User', first_name: string, last_name: string, id: string, codename?: string | null, full_name: string, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string } } | null, team?: { __typename?: 'Team', id: string, name: string } | null } | null }>, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, project: { __typename?: 'Project', uses_budgetovac: boolean, id: string, code: string, title: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, projectManager: { __typename?: 'User', id: string }, otherProjectManagers?: Array<{ __typename?: 'User', id: string }> | null, brand: { __typename?: 'Brand', id: string, name: string, client: { __typename?: 'Client', id: string, name: string } } } } | null, files: Array<{ __typename?: 'AssignableFile', created_at: Date, public_id: string, filename: string, mime_type: string, urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null, viewable?: string | null, original?: string | null } }>, parent?: { __typename?: 'Task', id: string, name: string, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', project: { __typename?: 'Project', id: string, code: string, title: string } } | null } | null, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string, system_status?: TaskSystemStatusEnum | null }, priority: { __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null } } };

export type AvailableTaskPositionsHoursByOurWorkBudgetQueryVariables = Exact<{
  our_work_budget_item_id: Scalars['ID']['input'];
}>;


export type AvailableTaskPositionsHoursByOurWorkBudgetQuery = { __typename?: 'Query', availableTaskPositionsHoursByOurWorkBudget?: Array<{ __typename?: 'TaskPositionHour', time_tracking_work_type_id: string, planned_time: number }> | null };

export type GetPrioritiesOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPrioritiesOptionsQuery = { __typename?: 'Query', taskPriorities: Array<{ __typename?: 'TaskPriority', name: string, id: string }> };

export type GetProjectBillableQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetProjectBillableQuery = { __typename?: 'Query', projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, billable: boolean }> };

export type GetProjectOptionsQueryVariables = Exact<{
  withTemplates?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProjectOptionsQuery = { __typename?: 'Query', projectsSimpleMap: Array<{ __typename?: 'ProjectSimple', id: string, title: string, code: string }> };

export type GetStatusOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStatusOptionsQuery = { __typename?: 'Query', taskStatuses: Array<{ __typename?: 'TaskStatus', name: string, id: string }> };

export type TimeTrackingWorkTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type TimeTrackingWorkTypesQuery = { __typename?: 'Query', timeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> };

export type GetUnmatchedWorkTypesForTaskMoveQueryVariables = Exact<{
  taskIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  newProjectId: Scalars['ID']['input'];
}>;


export type GetUnmatchedWorkTypesForTaskMoveQuery = { __typename?: 'Query', getUnmatchedWorkTypesForTaskMove: { __typename?: 'TaskMoveUnmatchedData', has_time_tracking_entries: boolean, unmatched_work_types: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, target_available_work_types: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> } };

export type ModalTaskDependenciesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ModalTaskDependenciesQuery = { __typename?: 'Query', projectForTask: { __typename?: 'ProjectForTask', id: string, code: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }>, ourWork: Array<{ __typename?: 'OurWorkBudgetItemSimple', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled: boolean, tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null } }> } };

export type TransferCreditMutationVariables = Exact<{
  amount: Scalars['BigInt']['input'];
  from_credit_account_id: Scalars['ID']['input'];
  to_credit_account_id: Scalars['ID']['input'];
  outgoing_invoice_id?: InputMaybe<Scalars['ID']['input']>;
  performed_at?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type TransferCreditMutation = { __typename?: 'Mutation', transferCredit: boolean };

export type GetModalTransferCreditDependenciesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetModalTransferCreditDependenciesQuery = { __typename?: 'Query', brandCreditAccount?: { __typename?: 'BrandCreditAccount', id: string, creditAccount: { __typename?: 'CreditAccount', id: string }, stats: { __typename?: 'BrandCreditAccountStats', remaining_credit: number }, ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string }> | null, expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string }> | null, brand: { __typename?: 'Brand', client: { __typename?: 'Client', id: string, brands: Array<{ __typename?: 'Brand', id: string, name: string, projects: Array<{ __typename?: 'Project', id: string, title: string, code: string, billable: boolean, finished_at?: Date | null }>, creditAccounts?: Array<{ __typename?: 'BrandCreditAccount', id: string, title: string, creditAccount: { __typename?: 'CreditAccount', id: string }, ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string }> | null, expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string }> | null }> | null }> } } } | null };

export type GetProjectBudgetItemsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectBudgetItemsQuery = { __typename?: 'Query', project?: { __typename?: 'Project', ourWork: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, creditAccount: { __typename?: 'CreditAccount', id: string }, stats: { __typename?: 'OurWorkBudgetItemStats', uninvoiced: number, credit: number }, category: { __typename?: 'OurWorkBudgetCategory', id: string, name: string } }>, expenses: Array<{ __typename?: 'ExpenseBudgetItem', id: string, title: string, type: ExpenseBudgetItemType, creditAccount?: { __typename?: 'CreditAccount', id: string } | null, stats: { __typename?: 'ExpenseBudgetItemStats', uninvoiced: number, credit: number }, category: { __typename?: 'ExpenseBudgetCategory', id: string, name: string } }> } | null };

export type CheckIfCreditAccountsBelongToTheSameTeamQueryVariables = Exact<{
  credit_account_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CheckIfCreditAccountsBelongToTheSameTeamQuery = { __typename?: 'Query', checkIfCreditAccountsBelongToTheSameTeam: boolean };

export type ProjectTitleFragment = { __typename?: 'Project', code: string, numeric_code?: string | null, title: string, billable: boolean, brand: { __typename?: 'Brand', id: string, name: string, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null } };

export type WipForBudgetAndPeriodQueryVariables = Exact<{
  our_work_budget_item_id: Scalars['ID']['input'];
  period_id: Scalars['ID']['input'];
}>;


export type WipForBudgetAndPeriodQuery = { __typename?: 'Query', wipForBudgetAndPeriod?: { __typename?: 'WorkInProgressItemStat', id: string, progress_percent: number, work_in_progress_id: string, is_closed: boolean, is_locked: boolean } | null };

export type WipPeriodsQueryVariables = Exact<{
  budgetItemId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type WipPeriodsQuery = { __typename?: 'Query', wipPeriodsMap: Array<{ __typename?: 'WipPeriod', id: string, title: string, starts_at: Date, ends_at?: Date | null, is_current: boolean }> };

export type AccessTokenForPlanovacQueryVariables = Exact<{
  appName?: InputMaybe<ThirdPartyEnum>;
}>;


export type AccessTokenForPlanovacQuery = { __typename?: 'Query', getAccessTokenForThirdParty?: string | null };

export type ArchiveProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveProjectMutation = { __typename?: 'Mutation', archiveProject: { __typename?: 'Project', id: string, status: ProjectStatusEnum, archived_at?: Date | null, archivedBy?: { __typename?: 'User', id: string, full_name: string } | null } };

export type ArchiveProjectsBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ArchiveProjectsBulkMutation = { __typename?: 'Mutation', archiveProjectsBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type UnarchiveProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnarchiveProjectMutation = { __typename?: 'Mutation', unarchiveProject: { __typename?: 'Project', id: string, status: ProjectStatusEnum, archived_at?: Date | null, archivedBy?: { __typename?: 'User', id: string, full_name: string } | null } };

export type UnarchiveProjectsBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UnarchiveProjectsBulkMutation = { __typename?: 'Mutation', unarchiveProjectsBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type ArchivedProjectDataFragment = { __typename?: 'Project', id: string, status: ProjectStatusEnum, archived_at?: Date | null, archivedBy?: { __typename?: 'User', id: string, full_name: string } | null };

export type BulkProjectUpdateMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: BulkUpdateProjectsInput;
}>;


export type BulkProjectUpdateMutation = { __typename?: 'Mutation', bulkUpdateProjects: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: { __typename?: 'Project', id: string } };

export type DeleteProjectsBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteProjectsBulkMutation = { __typename?: 'Mutation', deleteProjectsBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type InvoiceProjectByTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  invoice_type: RequestForInvoicingTypeEnum;
}>;


export type InvoiceProjectByTypeMutation = { __typename?: 'Mutation', invoiceProject?: { __typename?: 'RequestForInvoicing', id: string } | null };

export type InvoiceProjectsByTypeBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  invoice_type: RequestForInvoicingTypeEnum;
}>;


export type InvoiceProjectsByTypeBulkMutation = { __typename?: 'Mutation', invoiceProjectsBulk?: { __typename?: 'RequestForInvoicing', id: string } | null };

export type PinProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PinProjectMutation = { __typename?: 'Mutation', pinProject: { __typename?: 'Project', id: string, is_pinned: boolean } };

export type PinProjectsBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PinProjectsBulkMutation = { __typename?: 'Mutation', pinProjectsBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type UnpinProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnpinProjectMutation = { __typename?: 'Mutation', unpinProject: { __typename?: 'Project', id: string, is_pinned: boolean } };

export type UnpinProjectsBulkMutationVariables = Exact<{
  id: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UnpinProjectsBulkMutation = { __typename?: 'Mutation', unpinProjectsBulk: { __typename?: 'BulkActionResponse', total: number, successful: number, failed: number } };

export type ProformaInvoiceProjectMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProformaInvoiceProjectMutation = { __typename?: 'Mutation', proformaInvoiceProject?: { __typename?: 'RequestForInvoicing', id: string } | null };

export type ReopenProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReopenProjectMutation = { __typename?: 'Mutation', reopenProject: { __typename?: 'Project', id: string, status: ProjectStatusEnum, finished_at?: Date | null, finishedBy?: { __typename?: 'User', id: string, full_name: string } | null } };

export type TimeTrackingPopoverItemsQueryVariables = Exact<{
  user_id: Scalars['ID']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type TimeTrackingPopoverItemsQuery = { __typename?: 'Query', timeTrackingItems: Array<{ __typename?: 'TimeTrackingItem', id: string, tracked_for_date: Date, tracked_time: number, tracked_time_with_running_timer: number, specific_time_from?: Time | null, specific_time_to?: Time | null, note?: string | null, auto_stopped: boolean, billable: boolean, is_locked: boolean, has_running_timer: boolean, timeBilling?: { __typename?: 'ProjectTimeBilling', id: string, name: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | null, user?: { __typename?: 'User', id: string } | null, capacityAllocationItem?: { __typename?: 'CapacityAllocationItem', id: string } | null, task: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, brand: { __typename?: 'Brand', id: string, name: string } } } | null }, timeTrackingBudgetItem: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled: boolean }, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', id: string, name: string } } }>, runningTimer?: { __typename?: 'Timer', id: string, timeTrackingItem?: { __typename?: 'TimeTrackingItem', id: string, tracked_for_date: Date, tracked_time: number, tracked_time_with_running_timer: number, specific_time_from?: Time | null, specific_time_to?: Time | null, note?: string | null, auto_stopped: boolean, billable: boolean, is_locked: boolean, has_running_timer: boolean, timeBilling?: { __typename?: 'ProjectTimeBilling', id: string, name: string, is_locked: boolean, project: { __typename?: 'Project', id: string } } | null, user?: { __typename?: 'User', id: string } | null, capacityAllocationItem?: { __typename?: 'CapacityAllocationItem', id: string } | null, task: { __typename?: 'Task', id: string, name: string, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string, brand: { __typename?: 'Brand', id: string, name: string } } } | null }, timeTrackingBudgetItem: { __typename?: 'TimeTrackingBudgetItem', id: string, tracking_enabled: boolean }, timeTrackingWorkType: { __typename?: 'TimeTrackingWorkType', id: string, title: string }, project: { __typename?: 'Project', id: string, title: string, code: string, brand: { __typename?: 'Brand', id: string, name: string } } } | null } | null };

export type AddAccountMovesToDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  documentType: BankDocumentTypeEnum;
  date: Scalars['Date']['input'];
  bankAccountMoves: Array<BankAccountMoveToDocumentInput> | BankAccountMoveToDocumentInput;
}>;


export type AddAccountMovesToDocumentMutation = { __typename?: 'Mutation', addBankAccountMovesToDocument?: boolean | null };

export type FilterTemplateFragmentFragment = { __typename?: 'FilterTemplate', id: string, model_id?: string | null, model_type: string, type?: string | null, name: string, params?: string | null, user_id?: string | null };

export type CreateFilterTemplateMutationVariables = Exact<{
  input: FilterTemplateInput;
}>;


export type CreateFilterTemplateMutation = { __typename?: 'Mutation', createFilterTemplate: { __typename?: 'FilterTemplate', id: string, model_id?: string | null, model_type: string, type?: string | null, name: string, params?: string | null, user_id?: string | null } };

export type DeleteFilterTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFilterTemplateMutation = { __typename?: 'Mutation', deleteFilterTemplate: boolean };

export type FilterTemplatesQueryVariables = Exact<{
  modelId?: InputMaybe<Scalars['ID']['input']>;
  modelType: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type FilterTemplatesQuery = { __typename?: 'Query', filterTemplates: Array<{ __typename?: 'FilterTemplate', id: string, model_id?: string | null, model_type: string, type?: string | null, name: string, params?: string | null, user_id?: string | null }> };

export type WorkspaceAccountingAccountSettingsFragment = { __typename?: 'WorkspaceAccountingAccountSettings', accounting_accounts: Array<{ __typename?: 'WorkspaceAccountingAccount', id: string, account_number: string, title: string, accounting_type: Accounting_Account_Type, budget_categories?: Array<{ __typename?: 'AccountingAccountBudgetCategory', accounting_account_id: string, budget_category_id: string, budget_category_type: string }> | null }> };

export type CostCenterFragment = { __typename?: 'AccountingCentre', id: string, centre: string, title: string, type: Accounting_Centre_Type, deleted_at?: Date | null };

export type UpdateWorkspaceSettingsMutationVariables = Exact<{
  notifications: UpdateWorkspaceNotifications;
  tasks: InputWorkspaceTaskSettings;
  companies: InputWorkspaceCompanySetting;
  financial: InputWorkspaceFinancialSetting;
  accountingAccounts: InputUpdateWorkspaceAccountingAccountSettings;
  costCenters: InputUpdateWorkspaceAccountingCentreSettings;
  accountingVatClassifications: InputUpdateWorkspaceAccountingVatClassificationSettings;
  userManagement: InputWorkspaceUserManagementSetting;
  planningUtilization: InputWorkspacePlanningSetting;
  planningViewSettings: UpdatePlanningSettings;
  projects: InputUpdateWorkspaceProjectSettings;
  pipedrive?: InputMaybe<InputUpdateWorkspacePipedriveIntegration>;
}>;


export type UpdateWorkspaceSettingsMutation = { __typename?: 'Mutation', UpdateWorkspaceNotifications: Array<{ __typename?: 'WorkspaceNotification', id: string }>, updateWorkspaceTaskSettings: { __typename?: 'WorkspaceTaskSettings', show_done_tasks: boolean, use_current_assignee: boolean }, updateWorkspaceCompanies: Array<{ __typename?: 'WorkspaceCompanySetting', id: string }>, updateWorkspaceFinancialSettings: { __typename?: 'WorkspaceFinancialSetting', vat_rates: Array<{ __typename?: 'VatRate', id: string }> }, updateWorkspaceAccountingAccountSettings: { __typename?: 'WorkspaceAccountingAccountSettings', accounting_accounts: Array<{ __typename?: 'WorkspaceAccountingAccount', id: string }> }, updateWorkspaceAccountingCentreSettings: { __typename?: 'WorkspaceAccountingCentreSettings', accounting_centres: Array<{ __typename?: 'AccountingCentre', id: string }> }, updateWorkspaceAccountingVatClassificationSettings: { __typename?: 'WorkspaceAccountingVatClassificationSettings', accounting_vat_classifications: Array<{ __typename?: 'AccountingVatClassification', id: string }> }, updateWorkspaceUserManagementSettings: { __typename?: 'WorkspaceUserManagementSetting', require_two_factor_authentication: boolean }, updateWorkspacePlanningSettings: { __typename?: 'WorkspacePlanningSettings', specific_time_in_planning_enabled: boolean }, updatePlanningSettings: { __typename?: 'WorkspaceSettings', title?: string | null }, updateWorkspaceProjectSettings: { __typename?: 'WorkspaceProjectSettings', project_code_with_year: boolean }, updateWorkspacePipedriveIntegration: { __typename?: 'WorkspacePipedriveIntegration', settings?: { __typename?: 'WorkspacePipedriveSettings', pipedrive_stage_id?: string | null, project_stage_id?: string | null, project_billable?: boolean | null } | null } };

export type TestImapConnectionMutationVariables = Exact<{ [key: string]: never; }>;


export type TestImapConnectionMutation = { __typename?: 'Mutation', testWorkspaceAutoExpenseEmail: string };

export type CreateWorkspaceSmtpSettingsMutationVariables = Exact<{
  input: CreateWorkspaceSmtpSettingsInput;
}>;


export type CreateWorkspaceSmtpSettingsMutation = { __typename?: 'Mutation', createWorkspaceSmtpSettings: { __typename?: 'WorkspaceSmtpSettings', id: string, active: boolean, smtp_host?: string | null, smtp_port?: number | null, smtp_username?: string | null, smtp_encryption?: string | null, smtp_from_address?: string | null, smtp_from_name?: string | null } };

export type UpdateWorkspaceSmtpSettingsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateWorkspaceSmtpSettingsInput;
}>;


export type UpdateWorkspaceSmtpSettingsMutation = { __typename?: 'Mutation', updateWorkspaceSmtpSettings: { __typename?: 'WorkspaceSmtpSettings', id: string, active: boolean, smtp_host?: string | null, smtp_port?: number | null, smtp_username?: string | null, smtp_encryption?: string | null, smtp_from_address?: string | null, smtp_from_name?: string | null } };

export type TestSmtpConnectionMutationVariables = Exact<{
  input: TestSmtpConnectionInput;
}>;


export type TestSmtpConnectionMutation = { __typename?: 'Mutation', testSmtpConnection: { __typename?: 'SmtpTestResult', error?: string | null, message: string, success: boolean } };

export type SendTestEmailMutationVariables = Exact<{
  input: CreateWorkspaceSmtpSettingsInput;
}>;


export type SendTestEmailMutation = { __typename?: 'Mutation', sendTestEmail: { __typename?: 'SmtpTestResult', error?: string | null, message: string, success: boolean } };

export type GlobalWorkspaceSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalWorkspaceSettingsQuery = { __typename?: 'Query', currencies?: Array<{ __typename?: 'Currency', id: string, code: string, denomination: number }> | null, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string, is_default: boolean, user_count: number }>, taskPriorities: Array<{ __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }>, workspaceAccountingAccountSetting: { __typename?: 'WorkspaceAccountingAccountSettings', accounting_accounts: Array<{ __typename?: 'WorkspaceAccountingAccount', id: string, account_number: string, title: string, accounting_type: Accounting_Account_Type, budget_categories?: Array<{ __typename?: 'AccountingAccountBudgetCategory', accounting_account_id: string, budget_category_id: string, budget_category_type: string }> | null }> }, workspaceAccountingVatClassificationSetting: { __typename?: 'WorkspaceAccountingVatClassificationSettings', accounting_vat_classifications: Array<{ __typename?: 'AccountingVatClassification', id: string, centre: string, title: string, type: Accounting_Centre_Type, vat_rate_id?: string | null, deleted_at?: Date | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number } | null }> }, workspaceSettings?: { __typename?: 'WorkspaceSettings', title?: string | null, setup_completed?: boolean | null, default_payment_due: number, exchange_rate_denomination: number, generate_numerical_brand_codes: boolean, time_tracking_rate_type: string, time_tracking_rate_length: number, transfer_credit_directly_from_invoice: boolean, require_two_factor_authentication: boolean, invoicing_more_teams: boolean, can_transfer_credit_with_date_without_constraints: boolean, default_task_priority_id: number, default_task_status_id: number, automatically_approved_expense_items: boolean, can_close_expense_budget_item_with_unapproved_expenses: boolean, show_expense_item_vat_rate: boolean, show_accounting_vat_classification: boolean, trial_from?: Date | null, unpaid_banner_message?: string | null, default_user_plannable_capacity: number, specific_time_in_planning_enabled: boolean, timetastic_integration: boolean, working_from: Time, working_to: Time, can_skip_invoice_date_validations: boolean, show_done_tasks: boolean, use_current_assignee: boolean, planning_alphabet_user_order: boolean, hide_expense_summary: boolean, disable_home_office_in_planning: boolean, hide_planning_total_daily_capacity: boolean, start_day_of_week: StartDayOfWeekEnum, xero_enabled: boolean, default_utilization_range_from: number, default_utilization_range_to: number, auto_deadline_in_tasks: boolean, budget_xlsx_languages?: Array<string> | null, locale: string, vapid_public_key: string, default_show_unit_price_on_invoices: boolean, default_show_billing_accounting_on_invoices: boolean, automate_invoicing_plan_approval: boolean, enable_bank: boolean, bank_api_active: boolean, enable_contractor_full_bank_account_data: boolean, pipedrive_enabled: boolean, expense_effectix_custom_cost_ratio: boolean, partner_access_enabled: boolean, enable_expense_email_import: boolean, google_email_integration_enabled: boolean, create_quote_only_after_approved_budgets: boolean, show_smtp_settings: boolean, show_mcp_settings: boolean, brand_template_id?: string | null, enable_additional_brand_numeric_code: boolean, show_amounts_in_time_tracking_report: boolean, highlight_overtime_in_tasks: boolean, enable_allocation_meeting_play: boolean, auto_complete_allocation_types?: Array<CapacityAllocationTypeEnum | null> | null, expense_identification_fields_required: boolean, contractor_fields_extra_validation: boolean, planned_expenses_show_client_price: boolean, prevent_saving_duplicated_expenses: boolean, financial_amount_by_percent: boolean, enable_calendar_integration: boolean, only_from_calendar_integration: boolean, require_already_paid_subfields_for_drafts: boolean, require_project_category: boolean, planning_view_settings?: Array<{ __typename?: 'PlanningViewSetting', name: string, value: string }> | null, country: { __typename?: 'Country', id: string, name: string, code: string }, currency: { __typename?: 'Currency', id: string, denomination: number, code: string }, defaultVatRate: { __typename?: 'VatRate', deleted: boolean, type?: VatRateTypeEnum | null, id: string, amount: number }, moduleSettings: { __typename?: 'ModuleSettings', billing_plan: boolean, budgetovac: boolean, clients: boolean, contractors: boolean, documents: boolean, expenses: boolean, invoices: boolean, planovac: boolean, projects: boolean, reports: boolean, time_tracking: boolean, time_billing: boolean }, exportSettings: { __typename?: 'ExportSettings', expenses: boolean, mrp: boolean, pohoda: boolean, premier: boolean, proluc: boolean, triad_project_effectiveness: boolean, project_effectiveness: boolean, project_progress_statistics: boolean, project_status: boolean, unpaid_outgoing_invoices: boolean, mlggk_project_effectiveness: boolean, xero: boolean, vario: boolean, transakcio: boolean, omega: boolean }, currencyExchangeRatesStructured: Array<{ __typename?: 'CurrencyExchangeRateStructured', exchangeRates: Array<{ __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: Date | null, valid_to?: Date | null }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }>, budget_pdf_export_settings?: { __typename?: 'BudgetPdfSettings', show_hours?: boolean | null, show_disclaimer?: boolean | null, signature?: boolean | null, show_summary?: boolean | null, show_client_name?: boolean | null, show_client_details?: boolean | null, language?: string | null, our_work_show_commission?: boolean | null, title_page_with_vat?: boolean | null, workspace_company_id: string, workspace_bank_account_id?: string | null, billing_entity_id?: string | null, hide_title_page?: boolean | null, add_billing_plan?: boolean | null, billing_plan_exchange_rate?: number | null, our_work_positions?: BudgetPdfExportOurWorkPositionsEnum | null, our_work_view?: BudgetPdfExportOurWorkViewEnum | null, our_work_description?: boolean | null, our_work_vat_in_items?: boolean | null, our_work_show_discount?: boolean | null, expense_show_commission?: boolean | null, expense_show_quantity?: boolean | null, expense_show_unit?: boolean | null, expense_show_discount?: boolean | null, expense_show_description?: boolean | null, expense_show_vat_in_items?: boolean | null, show_client_and_brand?: boolean | null, show_project_name_full?: boolean | null, use_client_name_from_billing_entity?: boolean | null, disclaimer?: Array<{ __typename?: 'BudgetPdfDisclaimer', language?: string | null, disclaimer?: string | null } | null> | null } | null, companies: Array<{ __typename?: 'WorkspaceCompany', id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | null, bankAccounts: Array<{ __typename?: 'WorkspaceBankAccount', id: string, iban: string, account_holder_name?: string | null, deleted: boolean }>, country?: { __typename?: 'Country', id: string } | null }> } | null };

export type TeamUsersQueryVariables = Exact<{
  team_id: Scalars['Mixed']['input'];
}>;


export type TeamUsersQuery = { __typename?: 'Query', userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null }> };

export type WorkspaceSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspaceSettingsQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', name: string }>, workspaceSettings?: { __typename?: 'WorkspaceSettings', bmail_activated: boolean } | null, countrySimpleMap: Array<{ __typename?: 'CountrySimple', id: string, name: string }>, WorkspaceNotifications: Array<{ __typename?: 'WorkspaceNotification', database_enabled: boolean, description?: string | null, id: string, mail_enabled: boolean, name: string, roles_to_notify?: Array<string> | null, threshold?: number | null, threshold_type: NotificationThresholdTypeEnum, to_roles: boolean }>, workspaceTaskSettings: { __typename?: 'WorkspaceTaskSettings', show_done_tasks: boolean, use_current_assignee: boolean, task_statuses: Array<{ __typename?: 'WorkspaceTaskStatus', background_color: string, default: boolean, done: boolean, foreground_color: string, id?: string | null, name: string, order: number }>, task_priorities: Array<{ __typename?: 'WorkspaceTaskPriority', default: boolean, id?: string | null, name: string, order: number, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }> }, workspaceCompaniesSettings: Array<{ __typename?: 'WorkspaceCompanySetting', city?: string | null, country_id?: string | null, currency_id?: string | null, deleted: boolean, id: string, internal_name: string, is_default: boolean, name: string, registration_no?: string | null, street?: string | null, tax_no?: string | null, vat_no?: string | null, zip?: string | null, bank_accounts: Array<{ __typename?: 'WorkspaceBankAccount', account_holder_name?: string | null, bank_account?: string | null, bank_code?: string | null, bank_name?: string | null, bic: string, deleted: boolean, iban: string, id: string }>, sequences: Array<{ __typename?: 'WorkspaceSequence', id?: string | null, format: string, next_number: number, types: Array<SequenceTypesEnum> }>, pdfSettings: { __typename?: 'WorkspaceInvoicePdfSettings', logo_assignable_file?: { __typename?: 'AssignableFile', public_id: string, urls: { __typename?: 'AssignableFileUrlPair', original?: string | null } } | null, stamp_assignable_file?: { __typename?: 'AssignableFile', public_id: string, urls: { __typename?: 'AssignableFileUrlPair', original?: string | null } } | null } }>, workspaceFinancialSettings: { __typename?: 'WorkspaceFinancialSetting', default_show_unit_price_on_invoices: boolean, default_show_billing_accounting_on_invoices: boolean, invoice_attachment_name_templates?: { __typename?: 'InvoiceAttachmentNameTemplates', outgoing_invoice?: string | null, outgoing_proforma?: string | null, payment_receipt?: string | null } | null, vat_rates: Array<{ __typename?: 'VatRate', id: string, amount: number, deleted: boolean, default: boolean }>, currencies: Array<{ __typename?: 'Currency', id: string, code: string, exchange_rate?: number | null, denomination: number }> }, defaultCurrencies?: Array<{ __typename?: 'DefaultCurrency', code: string, symbol: string } | null> | null, workspaceAccountingAccountSetting: { __typename?: 'WorkspaceAccountingAccountSettings', accounting_accounts: Array<{ __typename?: 'WorkspaceAccountingAccount', id: string, account_number: string, title: string, accounting_type: Accounting_Account_Type, budget_categories?: Array<{ __typename?: 'AccountingAccountBudgetCategory', accounting_account_id: string, budget_category_id: string, budget_category_type: string }> | null }> }, ourWorkBudgetCategories?: Array<{ __typename?: 'OurWorkBudgetCategory', id: string, name: string }> | null, expenseBudgetCategories?: Array<{ __typename?: 'ExpenseBudgetCategory', id: string, name: string }> | null, workspaceAccountingCentreSetting: { __typename?: 'WorkspaceAccountingCentreSettings', accounting_centres: Array<{ __typename?: 'AccountingCentre', id: string, centre: string, title: string, type: Accounting_Centre_Type, deleted_at?: Date | null }> }, workspaceAccountingVatClassificationSetting: { __typename?: 'WorkspaceAccountingVatClassificationSettings', accounting_vat_classifications: Array<{ __typename?: 'AccountingVatClassification', id: string, type: Accounting_Centre_Type, vat_rate_id?: string | null, centre: string, title: string, deleted_at?: Date | null }> }, workspaceUserManagementSetting: { __typename?: 'WorkspaceUserManagementSetting', require_two_factor_authentication: boolean, teams: Array<{ __typename?: 'Team', id: string, name: string, deleted_at?: Date | null, is_default: boolean, user_count: number }> }, updateWorkspacePlanningSettings: { __typename?: 'WorkspacePlanningSettings', working_from: Time, working_to: Time, default_user_plannable_capacity: number, specific_time_in_planning_enabled: boolean, hide_planning_total_daily_capacity: boolean, planning_alphabet_user_order: boolean, disable_home_office_in_planning: boolean, start_day_of_week: StartDayOfWeekEnum, default_utilization_range_from: number, default_utilization_range_to: number, planning_sort_prioritize_time_specific_items: boolean }, workspaceProjectSettings: { __typename?: 'WorkspaceProjectSettings', project_code_generator: ProjectCodeGeneratorEnum, project_code_length: number, project_code_with_year: boolean, can_close_expense_budget_item_with_unapproved_expenses: boolean, create_default_task_enabled: boolean, create_default_task_only_to_our_work_category: boolean, our_work_budget_categories_count: number, project_count: number, automate_invoicing_plan_approval: boolean, enable_additional_brand_numeric_code: boolean }, banksQuery?: Array<{ __typename?: 'Bank', api_id: string, name: string, logo: string, url: string }> | null, workspacePipedriveIntegration: { __typename?: 'WorkspacePipedriveIntegration', initialization_url: string, settings?: { __typename?: 'WorkspacePipedriveSettings', pipedrive_stage_id?: string | null, project_stage_id?: string | null, project_billable?: boolean | null } | null }, workspaceAutoExpenseEmailSettings?: { __typename?: 'WorkspaceAutoExpenseEmailSettings', imap_host: string, imap_port: number, imap_username: string, imap_encryption: ImapEncryptionEnum, is_active: boolean } | null, workspaceSmtpSettings?: { __typename?: 'WorkspaceSmtpSettings', id: string, active: boolean, is_google_connected: boolean, is_microsoft_connected: boolean, smtp_host?: string | null, smtp_port?: number | null, smtp_username?: string | null, smtp_encryption?: string | null, smtp_from_address?: string | null, smtp_from_name?: string | null } | null };

export type TaskStatsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TaskStatsQuery = { __typename?: 'Query', task: { __typename?: 'Task', stats?: { __typename?: 'TaskStats', spent_time: number, planned_time: number } | null } };

export type WorkspaceAccountingVatClassificationSettingFragment = { __typename?: 'WorkspaceAccountingVatClassificationSettings', accounting_vat_classifications: Array<{ __typename?: 'AccountingVatClassification', id: string, centre: string, title: string, type: Accounting_Centre_Type, vat_rate_id?: string | null, deleted_at?: Date | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number } | null }> };

export type WorkspaceCompanyFragment = { __typename?: 'WorkspaceCompany', id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | null, country?: { __typename?: 'Country', id: string } | null };

export type MeFragment = { __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string, email: string, codename?: string | null, enabled_two_factor_authentication: boolean, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string, default_rate: number } } | null, team?: { __typename?: 'Team', id: string, name: string } | null, roles: Array<{ __typename?: 'Role', id: string, name: string, documentLimits?: Array<{ __typename?: 'RoleDocumentLimit', document_type: DocumentLimitTypeEnum, limit: number }> | null }>, permissions: { __typename?: 'PermissionList', bank_read_all: boolean, brand_read: boolean, brand_create: boolean, brand_update: boolean, brand_delete: boolean, brand_archive: boolean, brand_updateManagers: boolean, client_read: boolean, client_create: boolean, client_update: boolean, client_delete: boolean, client_updateManagers: boolean, contractor_read: boolean, contractor_create: boolean, contractor_update: boolean, contractor_delete: boolean, user_read_all: boolean, user_read_own: boolean, user_create: boolean, user_scopeCreate: boolean, user_update_all: boolean, user_update_own: boolean, user_updatePersonalData: boolean, user_updateWorkData: boolean, user_updateScopeUser: boolean, user_updatePlanningData: boolean, user_updateAllfredData: boolean, user_delete: boolean, user_haveProjectsAssigned: boolean, user_profile_read: boolean, user_profile_update: boolean, user_password_update: boolean, user_accessAccountingAttributes: boolean, user_scope_all: boolean, user_scope_own: boolean, brandCreditAccount_read_all: boolean, brandCreditAccount_read_team: boolean, brandCreditAccount_read_own: boolean, brandCreditAccount_create: boolean, brandCreditAccount_update_all: boolean, brandCreditAccount_update_team: boolean, brandCreditAccount_update_own: boolean, brandCreditAccount_delete_all: boolean, brandCreditAccount_delete_team: boolean, brandCreditAccount_delete_own: boolean, brandCreditAccount_setBudgetCategories: boolean, credit_transfer_fromBudgetItem: boolean, credit_transfer_fromBrandCreditAccount: boolean, credit_transfer_betweenTeams: boolean, credit_transfer_withDate: boolean, credit_prepayment: boolean, contract_read: boolean, contract_create: boolean, contract_update: boolean, contract_delete: boolean, order_read: boolean, order_create: boolean, order_update: boolean, order_delete: boolean, otherDocument_read: boolean, otherDocument_create: boolean, otherDocument_update: boolean, otherDocument_delete: boolean, expense_read_all: boolean, expense_read_own: boolean, expense_read_team: boolean, expense_read_excludeRestrictedTeams: boolean, expense_create: boolean, expense_update_all: boolean, expense_update_own: boolean, expense_update_team: boolean, expense_delete_all: boolean, expense_delete_own: boolean, expense_delete_team: boolean, expense_markAsPaid: boolean, expense_deleteFiles: boolean, expense_approve: boolean, expense_accessAccountingAttributes: boolean, expense_accessImported: boolean, expense_canApproveBudgetItem: boolean, expense_modelLock: boolean, requestForInvoicing_read_all: boolean, requestForInvoicing_read_own: boolean, requestForInvoicing_read_team: boolean, requestForInvoicing_create_all: boolean, requestForInvoicing_create_own: boolean, requestForInvoicing_create_team: boolean, requestForInvoicing_update_all: boolean, requestForInvoicing_update_own: boolean, requestForInvoicing_update_team: boolean, requestForInvoicing_delete_all: boolean, requestForInvoicing_delete_own: boolean, requestForInvoicing_delete_team: boolean, requestForInvoicing_accessAccountingAttributes: boolean, requestForInvoicing_querySubmittedCount_all: boolean, requestForInvoicing_querySubmittedCount_own: boolean, outgoingInvoice_read_all: boolean, outgoingInvoice_read_own: boolean, outgoingInvoice_read_team: boolean, outgoingInvoice_create: boolean, outgoingInvoice_update_all: boolean, outgoingInvoice_update_own: boolean, outgoingInvoice_update_team: boolean, outgoingInvoice_delete_all: boolean, outgoingInvoice_delete_own: boolean, outgoingInvoice_delete_team: boolean, outgoingInvoice_accessAccountingAttributes: boolean, outgoingInvoice_markAsPaid: boolean, outgoingInvoice_sendToClient: boolean, outgoingInvoice_updateInvoiceNumber: boolean, outgoingInvoice_modelLock: boolean, project_accessAccountingAttributes: boolean, project_viewAllFields: boolean, project_read_all: boolean, project_read_own: boolean, project_read_team: boolean, project_read_excludeRestrictedTeams: boolean, project_create_all: boolean, project_create_own: boolean, project_create_team: boolean, project_update_all: boolean, project_update_own: boolean, project_update_team: boolean, project_delete_all: boolean, project_delete_own: boolean, project_delete_team: boolean, project_pin_all: boolean, project_pin_own: boolean, project_pin_team: boolean, project_finish_all: boolean, project_finish_own: boolean, project_finish_team: boolean, project_reopen_all: boolean, project_reopen_own: boolean, project_reopen_team: boolean, project_archive_all: boolean, project_archive_own: boolean, project_archive_team: boolean, project_duplicate_all: boolean, project_duplicate_own: boolean, project_duplicate_team: boolean, project_timeTrackingReport_read_all: boolean, project_timeTrackingReport_read_own: boolean, project_timeTrackingReport_read_team: boolean, project_budget_update_all: boolean, project_budget_update_own: boolean, project_budget_update_team: boolean, project_budget_completeExpenseBudgetItem_all: boolean, project_budget_completeExpenseBudgetItem_own: boolean, project_budget_completeExpenseBudgetItem_team: boolean, project_budget_reopenExpenseBudgetItem_all: boolean, project_budget_reopenExpenseBudgetItem_own: boolean, project_budget_reopenExpenseBudgetItem_team: boolean, project_lockBillingPlan: boolean, project_billingTime_lock: boolean, projectCategory_query: boolean, projectCategory_create: boolean, projectCategory_update: boolean, projectCategory_delete: boolean, wip_submit_all: boolean, wip_submit_own: boolean, wip_submit_team: boolean, wip_lock_all: boolean, wip_lock_own: boolean, wip_lock_team: boolean, wip_read_all: boolean, wip_read_own: boolean, wip_read_team: boolean, wip_unlock_all: boolean, wip_unlock_own: boolean, wip_unlock_team: boolean, wip_close_all: boolean, wip_close_own: boolean, wip_close_team: boolean, wip_open_all: boolean, wip_open_own: boolean, wip_open_team: boolean, timeTracking_read_all: boolean, timeTracking_read_own: boolean, timeTracking_read_team: boolean, timeTracking_create_all: boolean, timeTracking_create_own: boolean, timeTracking_create_team: boolean, timeTracking_update_all: boolean, timeTracking_update_own: boolean, timeTracking_update_team: boolean, timeTracking_delete_all: boolean, timeTracking_delete_own: boolean, timeTracking_delete_team: boolean, timeTracking_timer_use_all: boolean, timeTracking_timer_use_own: boolean, timeTracking_timer_use_team: boolean, timeTracking_timer_use_manual: boolean, timeTracking_report_read_all: boolean, timeTracking_report_read_team: boolean, timeTracking_report_read_own: boolean, timeTracking_userMonthlyReport_read: boolean, billingPlan_create: boolean, billingPlan_update: boolean, billingPlan_listing: boolean, integration_budgetovac: boolean, integration_forecasting: boolean, task_viewAllFields: boolean, task_read_all: boolean, task_read_own: boolean, task_create_all: boolean, task_create_scoped: boolean, task_update_all: boolean, task_update_own: boolean, task_update_scoped: boolean, task_delete_all: boolean, task_delete_own: boolean, task_update_status_own: boolean, task_update_status_all: boolean, task_update_current_assignee_own: boolean, task_update_current_assignee_all: boolean, taskComment_create: boolean, taskComment_update_own: boolean, taskComment_update_all: boolean, taskComment_delete_own: boolean, taskComment_delete_all?: boolean | null, assignableFile_create: boolean, assignableFile_delete_all: boolean, assignableFile_delete_own: boolean, planning_create_all: boolean, planning_create_own: boolean, planning_update_all: boolean, planning_update_own: boolean, planning_delete_all: boolean, planning_delete_own: boolean, planning_complete_all: boolean, planning_complete_own: boolean, planning_play_own: boolean, planning_read_all: boolean, planning_read_own: boolean, planning_show_daily_capacity: boolean, profitLossReport_query_all: boolean, workspaceSetting_edit: boolean, notificationSetting_query: boolean, notificationSetting_update: boolean, utilizationReport_query_all: boolean, utilizationReport_query_own: boolean, utilizationReport_query_team: boolean, utilizationReportProfit_query_all: boolean, budget_read_all: boolean, budget_read_own: boolean, budget_read_team: boolean, quote_create_withoutInternalApproved: boolean, quote_manualApprove: boolean } };

export type WorkspaceSettingsFragment = { __typename?: 'WorkspaceSettings', title?: string | null, setup_completed?: boolean | null, default_payment_due: number, exchange_rate_denomination: number, generate_numerical_brand_codes: boolean, time_tracking_rate_type: string, time_tracking_rate_length: number, transfer_credit_directly_from_invoice: boolean, require_two_factor_authentication: boolean, invoicing_more_teams: boolean, can_transfer_credit_with_date_without_constraints: boolean, default_task_priority_id: number, default_task_status_id: number, automatically_approved_expense_items: boolean, can_close_expense_budget_item_with_unapproved_expenses: boolean, show_expense_item_vat_rate: boolean, show_accounting_vat_classification: boolean, trial_from?: Date | null, unpaid_banner_message?: string | null, default_user_plannable_capacity: number, specific_time_in_planning_enabled: boolean, timetastic_integration: boolean, working_from: Time, working_to: Time, can_skip_invoice_date_validations: boolean, show_done_tasks: boolean, use_current_assignee: boolean, planning_alphabet_user_order: boolean, hide_expense_summary: boolean, disable_home_office_in_planning: boolean, hide_planning_total_daily_capacity: boolean, start_day_of_week: StartDayOfWeekEnum, xero_enabled: boolean, default_utilization_range_from: number, default_utilization_range_to: number, auto_deadline_in_tasks: boolean, budget_xlsx_languages?: Array<string> | null, locale: string, vapid_public_key: string, default_show_unit_price_on_invoices: boolean, default_show_billing_accounting_on_invoices: boolean, automate_invoicing_plan_approval: boolean, enable_bank: boolean, bank_api_active: boolean, enable_contractor_full_bank_account_data: boolean, pipedrive_enabled: boolean, expense_effectix_custom_cost_ratio: boolean, partner_access_enabled: boolean, enable_expense_email_import: boolean, google_email_integration_enabled: boolean, create_quote_only_after_approved_budgets: boolean, show_smtp_settings: boolean, show_mcp_settings: boolean, brand_template_id?: string | null, enable_additional_brand_numeric_code: boolean, show_amounts_in_time_tracking_report: boolean, highlight_overtime_in_tasks: boolean, enable_allocation_meeting_play: boolean, auto_complete_allocation_types?: Array<CapacityAllocationTypeEnum | null> | null, expense_identification_fields_required: boolean, contractor_fields_extra_validation: boolean, planned_expenses_show_client_price: boolean, prevent_saving_duplicated_expenses: boolean, financial_amount_by_percent: boolean, enable_calendar_integration: boolean, only_from_calendar_integration: boolean, require_already_paid_subfields_for_drafts: boolean, require_project_category: boolean, planning_view_settings?: Array<{ __typename?: 'PlanningViewSetting', name: string, value: string }> | null, country: { __typename?: 'Country', id: string, name: string, code: string }, currency: { __typename?: 'Currency', id: string, denomination: number, code: string }, defaultVatRate: { __typename?: 'VatRate', deleted: boolean, type?: VatRateTypeEnum | null, id: string, amount: number }, moduleSettings: { __typename?: 'ModuleSettings', billing_plan: boolean, budgetovac: boolean, clients: boolean, contractors: boolean, documents: boolean, expenses: boolean, invoices: boolean, planovac: boolean, projects: boolean, reports: boolean, time_tracking: boolean, time_billing: boolean }, exportSettings: { __typename?: 'ExportSettings', expenses: boolean, mrp: boolean, pohoda: boolean, premier: boolean, proluc: boolean, triad_project_effectiveness: boolean, project_effectiveness: boolean, project_progress_statistics: boolean, project_status: boolean, unpaid_outgoing_invoices: boolean, mlggk_project_effectiveness: boolean, xero: boolean, vario: boolean, transakcio: boolean, omega: boolean }, currencyExchangeRatesStructured: Array<{ __typename?: 'CurrencyExchangeRateStructured', exchangeRates: Array<{ __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: Date | null, valid_to?: Date | null }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }>, budget_pdf_export_settings?: { __typename?: 'BudgetPdfSettings', show_hours?: boolean | null, show_disclaimer?: boolean | null, signature?: boolean | null, show_summary?: boolean | null, show_client_name?: boolean | null, show_client_details?: boolean | null, language?: string | null, our_work_show_commission?: boolean | null, title_page_with_vat?: boolean | null, workspace_company_id: string, workspace_bank_account_id?: string | null, billing_entity_id?: string | null, hide_title_page?: boolean | null, add_billing_plan?: boolean | null, billing_plan_exchange_rate?: number | null, our_work_positions?: BudgetPdfExportOurWorkPositionsEnum | null, our_work_view?: BudgetPdfExportOurWorkViewEnum | null, our_work_description?: boolean | null, our_work_vat_in_items?: boolean | null, our_work_show_discount?: boolean | null, expense_show_commission?: boolean | null, expense_show_quantity?: boolean | null, expense_show_unit?: boolean | null, expense_show_discount?: boolean | null, expense_show_description?: boolean | null, expense_show_vat_in_items?: boolean | null, show_client_and_brand?: boolean | null, show_project_name_full?: boolean | null, use_client_name_from_billing_entity?: boolean | null, disclaimer?: Array<{ __typename?: 'BudgetPdfDisclaimer', language?: string | null, disclaimer?: string | null } | null> | null } | null, companies: Array<{ __typename?: 'WorkspaceCompany', id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | null, bankAccounts: Array<{ __typename?: 'WorkspaceBankAccount', id: string, iban: string, account_holder_name?: string | null, deleted: boolean }>, country?: { __typename?: 'Country', id: string } | null }> };

export type LoginQueryVariables = Exact<{ [key: string]: never; }>;


export type LoginQuery = { __typename?: 'Query', currencies?: Array<{ __typename?: 'Currency', id: string, code: string, denomination: number, exchange_rate?: number | null }> | null, me?: { __typename?: 'User', id: string, first_name: string, last_name: string, full_name: string, email: string, codename?: string | null, enabled_two_factor_authentication: boolean, scope?: { __typename?: 'UserScope', value: UserScopeEnum } | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string, defaultWorktype: { __typename?: 'TimeTrackingWorkType', id: string, title: string, default_rate: number } } | null, team?: { __typename?: 'Team', id: string, name: string } | null, roles: Array<{ __typename?: 'Role', id: string, name: string, documentLimits?: Array<{ __typename?: 'RoleDocumentLimit', document_type: DocumentLimitTypeEnum, limit: number }> | null }>, permissions: { __typename?: 'PermissionList', bank_read_all: boolean, brand_read: boolean, brand_create: boolean, brand_update: boolean, brand_delete: boolean, brand_archive: boolean, brand_updateManagers: boolean, client_read: boolean, client_create: boolean, client_update: boolean, client_delete: boolean, client_updateManagers: boolean, contractor_read: boolean, contractor_create: boolean, contractor_update: boolean, contractor_delete: boolean, user_read_all: boolean, user_read_own: boolean, user_create: boolean, user_scopeCreate: boolean, user_update_all: boolean, user_update_own: boolean, user_updatePersonalData: boolean, user_updateWorkData: boolean, user_updateScopeUser: boolean, user_updatePlanningData: boolean, user_updateAllfredData: boolean, user_delete: boolean, user_haveProjectsAssigned: boolean, user_profile_read: boolean, user_profile_update: boolean, user_password_update: boolean, user_accessAccountingAttributes: boolean, user_scope_all: boolean, user_scope_own: boolean, brandCreditAccount_read_all: boolean, brandCreditAccount_read_team: boolean, brandCreditAccount_read_own: boolean, brandCreditAccount_create: boolean, brandCreditAccount_update_all: boolean, brandCreditAccount_update_team: boolean, brandCreditAccount_update_own: boolean, brandCreditAccount_delete_all: boolean, brandCreditAccount_delete_team: boolean, brandCreditAccount_delete_own: boolean, brandCreditAccount_setBudgetCategories: boolean, credit_transfer_fromBudgetItem: boolean, credit_transfer_fromBrandCreditAccount: boolean, credit_transfer_betweenTeams: boolean, credit_transfer_withDate: boolean, credit_prepayment: boolean, contract_read: boolean, contract_create: boolean, contract_update: boolean, contract_delete: boolean, order_read: boolean, order_create: boolean, order_update: boolean, order_delete: boolean, otherDocument_read: boolean, otherDocument_create: boolean, otherDocument_update: boolean, otherDocument_delete: boolean, expense_read_all: boolean, expense_read_own: boolean, expense_read_team: boolean, expense_read_excludeRestrictedTeams: boolean, expense_create: boolean, expense_update_all: boolean, expense_update_own: boolean, expense_update_team: boolean, expense_delete_all: boolean, expense_delete_own: boolean, expense_delete_team: boolean, expense_markAsPaid: boolean, expense_deleteFiles: boolean, expense_approve: boolean, expense_accessAccountingAttributes: boolean, expense_accessImported: boolean, expense_canApproveBudgetItem: boolean, expense_modelLock: boolean, requestForInvoicing_read_all: boolean, requestForInvoicing_read_own: boolean, requestForInvoicing_read_team: boolean, requestForInvoicing_create_all: boolean, requestForInvoicing_create_own: boolean, requestForInvoicing_create_team: boolean, requestForInvoicing_update_all: boolean, requestForInvoicing_update_own: boolean, requestForInvoicing_update_team: boolean, requestForInvoicing_delete_all: boolean, requestForInvoicing_delete_own: boolean, requestForInvoicing_delete_team: boolean, requestForInvoicing_accessAccountingAttributes: boolean, requestForInvoicing_querySubmittedCount_all: boolean, requestForInvoicing_querySubmittedCount_own: boolean, outgoingInvoice_read_all: boolean, outgoingInvoice_read_own: boolean, outgoingInvoice_read_team: boolean, outgoingInvoice_create: boolean, outgoingInvoice_update_all: boolean, outgoingInvoice_update_own: boolean, outgoingInvoice_update_team: boolean, outgoingInvoice_delete_all: boolean, outgoingInvoice_delete_own: boolean, outgoingInvoice_delete_team: boolean, outgoingInvoice_accessAccountingAttributes: boolean, outgoingInvoice_markAsPaid: boolean, outgoingInvoice_sendToClient: boolean, outgoingInvoice_updateInvoiceNumber: boolean, outgoingInvoice_modelLock: boolean, project_accessAccountingAttributes: boolean, project_viewAllFields: boolean, project_read_all: boolean, project_read_own: boolean, project_read_team: boolean, project_read_excludeRestrictedTeams: boolean, project_create_all: boolean, project_create_own: boolean, project_create_team: boolean, project_update_all: boolean, project_update_own: boolean, project_update_team: boolean, project_delete_all: boolean, project_delete_own: boolean, project_delete_team: boolean, project_pin_all: boolean, project_pin_own: boolean, project_pin_team: boolean, project_finish_all: boolean, project_finish_own: boolean, project_finish_team: boolean, project_reopen_all: boolean, project_reopen_own: boolean, project_reopen_team: boolean, project_archive_all: boolean, project_archive_own: boolean, project_archive_team: boolean, project_duplicate_all: boolean, project_duplicate_own: boolean, project_duplicate_team: boolean, project_timeTrackingReport_read_all: boolean, project_timeTrackingReport_read_own: boolean, project_timeTrackingReport_read_team: boolean, project_budget_update_all: boolean, project_budget_update_own: boolean, project_budget_update_team: boolean, project_budget_completeExpenseBudgetItem_all: boolean, project_budget_completeExpenseBudgetItem_own: boolean, project_budget_completeExpenseBudgetItem_team: boolean, project_budget_reopenExpenseBudgetItem_all: boolean, project_budget_reopenExpenseBudgetItem_own: boolean, project_budget_reopenExpenseBudgetItem_team: boolean, project_lockBillingPlan: boolean, project_billingTime_lock: boolean, projectCategory_query: boolean, projectCategory_create: boolean, projectCategory_update: boolean, projectCategory_delete: boolean, wip_submit_all: boolean, wip_submit_own: boolean, wip_submit_team: boolean, wip_lock_all: boolean, wip_lock_own: boolean, wip_lock_team: boolean, wip_read_all: boolean, wip_read_own: boolean, wip_read_team: boolean, wip_unlock_all: boolean, wip_unlock_own: boolean, wip_unlock_team: boolean, wip_close_all: boolean, wip_close_own: boolean, wip_close_team: boolean, wip_open_all: boolean, wip_open_own: boolean, wip_open_team: boolean, timeTracking_read_all: boolean, timeTracking_read_own: boolean, timeTracking_read_team: boolean, timeTracking_create_all: boolean, timeTracking_create_own: boolean, timeTracking_create_team: boolean, timeTracking_update_all: boolean, timeTracking_update_own: boolean, timeTracking_update_team: boolean, timeTracking_delete_all: boolean, timeTracking_delete_own: boolean, timeTracking_delete_team: boolean, timeTracking_timer_use_all: boolean, timeTracking_timer_use_own: boolean, timeTracking_timer_use_team: boolean, timeTracking_timer_use_manual: boolean, timeTracking_report_read_all: boolean, timeTracking_report_read_team: boolean, timeTracking_report_read_own: boolean, timeTracking_userMonthlyReport_read: boolean, billingPlan_create: boolean, billingPlan_update: boolean, billingPlan_listing: boolean, integration_budgetovac: boolean, integration_forecasting: boolean, task_viewAllFields: boolean, task_read_all: boolean, task_read_own: boolean, task_create_all: boolean, task_create_scoped: boolean, task_update_all: boolean, task_update_own: boolean, task_update_scoped: boolean, task_delete_all: boolean, task_delete_own: boolean, task_update_status_own: boolean, task_update_status_all: boolean, task_update_current_assignee_own: boolean, task_update_current_assignee_all: boolean, taskComment_create: boolean, taskComment_update_own: boolean, taskComment_update_all: boolean, taskComment_delete_own: boolean, taskComment_delete_all?: boolean | null, assignableFile_create: boolean, assignableFile_delete_all: boolean, assignableFile_delete_own: boolean, planning_create_all: boolean, planning_create_own: boolean, planning_update_all: boolean, planning_update_own: boolean, planning_delete_all: boolean, planning_delete_own: boolean, planning_complete_all: boolean, planning_complete_own: boolean, planning_play_own: boolean, planning_read_all: boolean, planning_read_own: boolean, planning_show_daily_capacity: boolean, profitLossReport_query_all: boolean, workspaceSetting_edit: boolean, notificationSetting_query: boolean, notificationSetting_update: boolean, utilizationReport_query_all: boolean, utilizationReport_query_own: boolean, utilizationReport_query_team: boolean, utilizationReportProfit_query_all: boolean, budget_read_all: boolean, budget_read_own: boolean, budget_read_team: boolean, quote_create_withoutInternalApproved: boolean, quote_manualApprove: boolean } } | null, teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string, is_default: boolean, user_count: number }>, taskPriorities: Array<{ __typename?: 'TaskPriority', id: string, name: string, system_priority?: TaskSystemPriorityEnum | null, emoji?: string | null }>, workspaceAccountingAccountSetting: { __typename?: 'WorkspaceAccountingAccountSettings', accounting_accounts: Array<{ __typename?: 'WorkspaceAccountingAccount', id: string, account_number: string, title: string, accounting_type: Accounting_Account_Type, budget_categories?: Array<{ __typename?: 'AccountingAccountBudgetCategory', accounting_account_id: string, budget_category_id: string, budget_category_type: string }> | null }> }, workspaceSettings?: { __typename?: 'WorkspaceSettings', title?: string | null, setup_completed?: boolean | null, default_payment_due: number, exchange_rate_denomination: number, generate_numerical_brand_codes: boolean, time_tracking_rate_type: string, time_tracking_rate_length: number, transfer_credit_directly_from_invoice: boolean, require_two_factor_authentication: boolean, invoicing_more_teams: boolean, can_transfer_credit_with_date_without_constraints: boolean, default_task_priority_id: number, default_task_status_id: number, automatically_approved_expense_items: boolean, can_close_expense_budget_item_with_unapproved_expenses: boolean, show_expense_item_vat_rate: boolean, show_accounting_vat_classification: boolean, trial_from?: Date | null, unpaid_banner_message?: string | null, default_user_plannable_capacity: number, specific_time_in_planning_enabled: boolean, timetastic_integration: boolean, working_from: Time, working_to: Time, can_skip_invoice_date_validations: boolean, show_done_tasks: boolean, use_current_assignee: boolean, planning_alphabet_user_order: boolean, hide_expense_summary: boolean, disable_home_office_in_planning: boolean, hide_planning_total_daily_capacity: boolean, start_day_of_week: StartDayOfWeekEnum, xero_enabled: boolean, default_utilization_range_from: number, default_utilization_range_to: number, auto_deadline_in_tasks: boolean, budget_xlsx_languages?: Array<string> | null, locale: string, vapid_public_key: string, default_show_unit_price_on_invoices: boolean, default_show_billing_accounting_on_invoices: boolean, automate_invoicing_plan_approval: boolean, enable_bank: boolean, bank_api_active: boolean, enable_contractor_full_bank_account_data: boolean, pipedrive_enabled: boolean, expense_effectix_custom_cost_ratio: boolean, partner_access_enabled: boolean, enable_expense_email_import: boolean, google_email_integration_enabled: boolean, create_quote_only_after_approved_budgets: boolean, show_smtp_settings: boolean, show_mcp_settings: boolean, brand_template_id?: string | null, enable_additional_brand_numeric_code: boolean, show_amounts_in_time_tracking_report: boolean, highlight_overtime_in_tasks: boolean, enable_allocation_meeting_play: boolean, auto_complete_allocation_types?: Array<CapacityAllocationTypeEnum | null> | null, expense_identification_fields_required: boolean, contractor_fields_extra_validation: boolean, planned_expenses_show_client_price: boolean, prevent_saving_duplicated_expenses: boolean, financial_amount_by_percent: boolean, enable_calendar_integration: boolean, only_from_calendar_integration: boolean, require_already_paid_subfields_for_drafts: boolean, require_project_category: boolean, planning_view_settings?: Array<{ __typename?: 'PlanningViewSetting', name: string, value: string }> | null, country: { __typename?: 'Country', id: string, name: string, code: string }, currency: { __typename?: 'Currency', id: string, denomination: number, code: string }, defaultVatRate: { __typename?: 'VatRate', deleted: boolean, type?: VatRateTypeEnum | null, id: string, amount: number }, moduleSettings: { __typename?: 'ModuleSettings', billing_plan: boolean, budgetovac: boolean, clients: boolean, contractors: boolean, documents: boolean, expenses: boolean, invoices: boolean, planovac: boolean, projects: boolean, reports: boolean, time_tracking: boolean, time_billing: boolean }, exportSettings: { __typename?: 'ExportSettings', expenses: boolean, mrp: boolean, pohoda: boolean, premier: boolean, proluc: boolean, triad_project_effectiveness: boolean, project_effectiveness: boolean, project_progress_statistics: boolean, project_status: boolean, unpaid_outgoing_invoices: boolean, mlggk_project_effectiveness: boolean, xero: boolean, vario: boolean, transakcio: boolean, omega: boolean }, currencyExchangeRatesStructured: Array<{ __typename?: 'CurrencyExchangeRateStructured', exchangeRates: Array<{ __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: Date | null, valid_to?: Date | null }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }>, budget_pdf_export_settings?: { __typename?: 'BudgetPdfSettings', show_hours?: boolean | null, show_disclaimer?: boolean | null, signature?: boolean | null, show_summary?: boolean | null, show_client_name?: boolean | null, show_client_details?: boolean | null, language?: string | null, our_work_show_commission?: boolean | null, title_page_with_vat?: boolean | null, workspace_company_id: string, workspace_bank_account_id?: string | null, billing_entity_id?: string | null, hide_title_page?: boolean | null, add_billing_plan?: boolean | null, billing_plan_exchange_rate?: number | null, our_work_positions?: BudgetPdfExportOurWorkPositionsEnum | null, our_work_view?: BudgetPdfExportOurWorkViewEnum | null, our_work_description?: boolean | null, our_work_vat_in_items?: boolean | null, our_work_show_discount?: boolean | null, expense_show_commission?: boolean | null, expense_show_quantity?: boolean | null, expense_show_unit?: boolean | null, expense_show_discount?: boolean | null, expense_show_description?: boolean | null, expense_show_vat_in_items?: boolean | null, show_client_and_brand?: boolean | null, show_project_name_full?: boolean | null, use_client_name_from_billing_entity?: boolean | null, disclaimer?: Array<{ __typename?: 'BudgetPdfDisclaimer', language?: string | null, disclaimer?: string | null } | null> | null } | null, companies: Array<{ __typename?: 'WorkspaceCompany', id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | null, bankAccounts: Array<{ __typename?: 'WorkspaceBankAccount', id: string, iban: string, account_holder_name?: string | null, deleted: boolean }>, country?: { __typename?: 'Country', id: string } | null }> } | null, workspaceAccountingVatClassificationSetting: { __typename?: 'WorkspaceAccountingVatClassificationSettings', accounting_vat_classifications: Array<{ __typename?: 'AccountingVatClassification', id: string, centre: string, title: string, type: Accounting_Centre_Type, vat_rate_id?: string | null, deleted_at?: Date | null, vatRate?: { __typename?: 'VatRate', id: string, amount: number } | null }> } };

export type ModelLockFragment = { __typename?: 'ModelLock', id: string, locked_at: Date, deleted_at?: Date | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | null };

export type LockModelMutationVariables = Exact<{
  lockable_id: Scalars['ID']['input'];
  lockable_type: ModelLockLockableTypeEnum;
}>;


export type LockModelMutation = { __typename?: 'Mutation', lockModel: { __typename?: 'ModelLock', id: string, locked_at: Date, deleted_at?: Date | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | null } };

export type UnlockModelMutationVariables = Exact<{
  lockable_id: Scalars['ID']['input'];
  lockable_type: ModelLockLockableTypeEnum;
}>;


export type UnlockModelMutation = { __typename?: 'Mutation', unlockModel: boolean };

export type BulkLockModelMutationVariables = Exact<{
  lockable_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  lockable_type: ModelLockLockableTypeEnum;
}>;


export type BulkLockModelMutation = { __typename?: 'Mutation', bulkLockModel: { __typename?: 'BulkActionResponse', total: number, failed: number } };

export type BulkUnlockModelMutationVariables = Exact<{
  lockable_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  lockable_type: ModelLockLockableTypeEnum;
}>;


export type BulkUnlockModelMutation = { __typename?: 'Mutation', bulkUnlockModel: { __typename?: 'BulkActionResponse', total: number, failed: number } };

export type GetModelLockQueryVariables = Exact<{
  lockable_id: Scalars['ID']['input'];
  lockable_type: ModelLockLockableTypeEnum;
}>;


export type GetModelLockQuery = { __typename?: 'Query', getModelLock?: { __typename?: 'ModelLock', id: string, locked_at: Date, deleted_at?: Date | null, is_locked: boolean, lockedByUser: { __typename?: 'User', id: string, full_name: string }, deletedByUser?: { __typename?: 'User', id: string, full_name: string } | null } | null };

export type ProjectStageFragment = { __typename?: 'ProjectStage', id: string, name: string, system_name?: string | null };

export type UpdateProjectStageMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  projectStageId: Scalars['ID']['input'];
}>;


export type UpdateProjectStageMutation = { __typename?: 'Mutation', updateProjectStage?: { __typename?: 'Project', id: string, project_stage?: { __typename?: 'ProjectStage', id: string, name: string, system_name?: string | null } | null } | null };

export type PipedriveDataQueryVariables = Exact<{ [key: string]: never; }>;


export type PipedriveDataQuery = { __typename?: 'Query', getPipedriveStages?: Array<{ __typename?: 'PipedriveStage', pipedrive_stage_id: string, name: string }> | null, projectStages: Array<{ __typename?: 'ProjectStage', id: string, name: string, system_name?: string | null }> };

export type QuoteEmailDataQueryVariables = Exact<{
  quoteId: Scalars['ID']['input'];
}>;


export type QuoteEmailDataQuery = { __typename?: 'Query', GetQuoteEmailData: { __typename?: 'QuoteEmailData', primary_recipient?: string | null, recipients?: Array<string | null> | null, subject: string, content: string, attachments?: Array<{ __typename?: 'QuoteAttachment', name: string, link: string }> | null } };

export type StarFragment = { __typename?: 'Star', id: string, starable_id: string, starable_type: StarsStarableTypeEnum, created_at: Date, updated_at?: Date | null };

export type StarMutationVariables = Exact<{
  starable_id: Scalars['ID']['input'];
  starable_type: StarsStarableTypeEnum;
}>;


export type StarMutation = { __typename?: 'Mutation', star: { __typename?: 'Star', id: string, starable_id: string, starable_type: StarsStarableTypeEnum, created_at: Date, updated_at?: Date | null } };

export type UnstarMutationVariables = Exact<{
  starable_id: Scalars['ID']['input'];
  starable_type: StarsStarableTypeEnum;
}>;


export type UnstarMutation = { __typename?: 'Mutation', unstar: boolean };

export type BulkStarMutationVariables = Exact<{
  starable_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  starable_type: StarsStarableTypeEnum;
}>;


export type BulkStarMutation = { __typename?: 'Mutation', bulkStar: { __typename?: 'BulkActionResponse', total: number, failed: number } };

export type BulkUnstarMutationVariables = Exact<{
  starable_ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  starable_type: StarsStarableTypeEnum;
}>;


export type BulkUnstarMutation = { __typename?: 'Mutation', bulkUnstar: { __typename?: 'BulkActionResponse', total: number, failed: number } };

export type TagFragment = { __typename?: 'Tag', id: string, title: string };

export type CreateTagMutationVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag?: { __typename?: 'Tag', id: string, title: string } | null };

export type UpdateTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag?: { __typename?: 'Tag', id: string, title: string } | null };

export type DeleteTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag?: boolean | null };

export type GetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsQuery = { __typename?: 'Query', getTags?: Array<{ __typename?: 'Tag', id: string, title: string }> | null };

export type AllocationItemsSelectOptionsQueryVariables = Exact<{
  user_id: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  task_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllocationItemsSelectOptionsQuery = { __typename?: 'Query', capacityAllocationItemList: Array<{ __typename?: 'CapacityAllocationItem', id: string, from_time?: Time | null, to_time?: Time | null, total_time: number, note?: string | null, capacityAllocation: { __typename?: 'CapacityAllocation', task?: { __typename?: 'Task', name: string } | null } }> };

export type CapacityAllocationUserItemDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  today: Scalars['Date']['input'];
}>;


export type CapacityAllocationUserItemDetailQuery = { __typename?: 'Query', capacityAllocationItemDetailQuery?: { __typename?: 'CapacityAllocationItem', id: string, completed: boolean, time_tracking_work_type_id?: string | null, duration_changed: boolean, date: Date, from_time?: Time | null, to_time?: Time | null, note?: string | null, total_time: number, type: CapacityAllocationTypeEnum, location?: string | null, global?: boolean | null, time_off_duration_type?: TimeOffDurationTypeEnum | null, meetLink?: string | null, eventLink?: string | null, seriesSummary: { __typename?: 'CapacityAllocationSeriesSummary', any_duration_changed: boolean, future_open_total_time: number, same_day_open_count: number, same_day_open_total_time: number, futureCompletedPerUser: Array<{ __typename?: 'CapacityAllocationUserCompletedCount', user_id: string, count: number }> }, user: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | null }, userStats?: { __typename?: 'CapacityAllocationUserItemStats', capacity_allocation_item_id: string, tracked_time_for_item?: number | null, has_running_timer: boolean } | null, teams?: Array<{ __typename?: 'TeamAttendee', team: { __typename?: 'Team', id: string, name: string } }> | null, userItems: Array<{ __typename?: 'CapacityAllocationItem', id: string, time_tracking_work_type_id?: string | null, user: { __typename?: 'User', id: string, full_name: string } }>, capacityAllocation: { __typename?: 'CapacityAllocation', id: string, deadline?: Date | null, deadline_time?: Time | null, location?: string | null, created_at: Date, create_task_positions: boolean, from_time?: Time | null, to_time?: Time | null, total_time: number, from_date: Date, to_date: Date, total_time_per_day?: number | null, note?: string | null, title?: string | null, repetition: CapacityAllocationRepetitionTypeEnum, deleted_items: boolean, repetition_settings?: { __typename?: 'RepetitionSettings', include_holidays?: boolean | null, days?: Array<RepetitionSettingsDaysEnum | null> | null, every: number, startType?: TimeOffDurationTypeEnum | null, toType?: TimeOffDurationTypeEnum | null, end: string } | null, task?: { __typename?: 'Task', id: string, name: string, billable: boolean, status: { __typename?: 'TaskStatus', id: string, name: string, background_color: string, foreground_color: string }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string }, project: { __typename?: 'Project', id: string, title: string, code: string } } | null } | null, createdBy: { __typename?: 'User', id: string }, calendarParticipants: Array<{ __typename?: 'CalendarEventParticipant', id: string, email: string, display_name?: string | null }> }, stats?: { __typename?: 'CapacityAllocationItemStats', tracking_enabled?: boolean | null, tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null } | null, timeOffType?: { __typename?: 'TimeOffType', id: string, name: string, affects_planning_capacity: boolean } | null, createdBy: { __typename?: 'User', id: string, full_name: string, profile?: { __typename?: 'UserProfile', hex_color: string } | null } } | null };

export type BrandSelectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandSelectOptionsQuery = { __typename?: 'Query', brandsSimpleMap: Array<{ __typename?: 'BrandSimple', name: string, id: string }> };

export type CompleteCapacityAllocationItemMutationVariables = Exact<{
  input: CompleteCapacityAllocationUserInput;
}>;


export type CompleteCapacityAllocationItemMutation = { __typename?: 'Mutation', completeCapacityAllocationItem: { __typename?: 'CapacityAllocationItem', id: string, completed: boolean, user: { __typename?: 'User', id: string } } };

export type ReopenCapacityAllocationItemMutationVariables = Exact<{
  input: ReopenCapacityAllocationItemInput;
}>;


export type ReopenCapacityAllocationItemMutation = { __typename?: 'Mutation', reopenCapacityAllocationItem: { __typename?: 'CapacityAllocationItem', id: string, completed: boolean, user: { __typename?: 'User', id: string } } };

export type DeleteCapacityAllocationMutationVariables = Exact<{
  input: DeleteCapacityAllocationInput;
}>;


export type DeleteCapacityAllocationMutation = { __typename?: 'Mutation', deleteCapacityAllocation: { __typename?: 'CapacityAllocation', id: string } };

export type DeleteCapacityAllocationItemMutationVariables = Exact<{
  input: DeleteCapacityAllocationItemInput;
}>;


export type DeleteCapacityAllocationItemMutation = { __typename?: 'Mutation', deleteCapacityAllocationItem: { __typename?: 'CapacityAllocationItem', id: string } };

export type DeleteCapacityAllocationForDayMutationVariables = Exact<{
  input: DeleteCapacityAllocationForDayInput;
}>;


export type DeleteCapacityAllocationForDayMutation = { __typename?: 'Mutation', deleteCapacityAllocationForDay: { __typename?: 'CapacityAllocation', id: string } };

export type DuplicateProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  with_tasks: Scalars['Boolean']['input'];
  with_task_attachments: Scalars['Boolean']['input'];
}>;


export type DuplicateProjectMutation = { __typename?: 'Mutation', duplicateProject: { __typename?: 'Project', id: string } };

export type GetWorkTypeOptionsQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;


export type GetWorkTypeOptionsQuery = { __typename?: 'Query', task: { __typename?: 'Task', ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', project: { __typename?: 'Project', availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> } } | null } };

export type UpdatePlanningSettingsMutationVariables = Exact<{
  input: UpdatePlanningSettings;
}>;


export type UpdatePlanningSettingsMutation = { __typename?: 'Mutation', updatePlanningSettings: { __typename?: 'WorkspaceSettings', title?: string | null, setup_completed?: boolean | null, default_payment_due: number, exchange_rate_denomination: number, generate_numerical_brand_codes: boolean, time_tracking_rate_type: string, time_tracking_rate_length: number, transfer_credit_directly_from_invoice: boolean, require_two_factor_authentication: boolean, invoicing_more_teams: boolean, can_transfer_credit_with_date_without_constraints: boolean, default_task_priority_id: number, default_task_status_id: number, automatically_approved_expense_items: boolean, can_close_expense_budget_item_with_unapproved_expenses: boolean, show_expense_item_vat_rate: boolean, show_accounting_vat_classification: boolean, trial_from?: Date | null, unpaid_banner_message?: string | null, default_user_plannable_capacity: number, specific_time_in_planning_enabled: boolean, timetastic_integration: boolean, working_from: Time, working_to: Time, can_skip_invoice_date_validations: boolean, show_done_tasks: boolean, use_current_assignee: boolean, planning_alphabet_user_order: boolean, hide_expense_summary: boolean, disable_home_office_in_planning: boolean, hide_planning_total_daily_capacity: boolean, start_day_of_week: StartDayOfWeekEnum, xero_enabled: boolean, default_utilization_range_from: number, default_utilization_range_to: number, auto_deadline_in_tasks: boolean, budget_xlsx_languages?: Array<string> | null, locale: string, vapid_public_key: string, default_show_unit_price_on_invoices: boolean, default_show_billing_accounting_on_invoices: boolean, automate_invoicing_plan_approval: boolean, enable_bank: boolean, bank_api_active: boolean, enable_contractor_full_bank_account_data: boolean, pipedrive_enabled: boolean, expense_effectix_custom_cost_ratio: boolean, partner_access_enabled: boolean, enable_expense_email_import: boolean, google_email_integration_enabled: boolean, create_quote_only_after_approved_budgets: boolean, show_smtp_settings: boolean, show_mcp_settings: boolean, brand_template_id?: string | null, enable_additional_brand_numeric_code: boolean, show_amounts_in_time_tracking_report: boolean, highlight_overtime_in_tasks: boolean, enable_allocation_meeting_play: boolean, auto_complete_allocation_types?: Array<CapacityAllocationTypeEnum | null> | null, expense_identification_fields_required: boolean, contractor_fields_extra_validation: boolean, planned_expenses_show_client_price: boolean, prevent_saving_duplicated_expenses: boolean, financial_amount_by_percent: boolean, enable_calendar_integration: boolean, only_from_calendar_integration: boolean, require_already_paid_subfields_for_drafts: boolean, require_project_category: boolean, planning_view_settings?: Array<{ __typename?: 'PlanningViewSetting', name: string, value: string }> | null, country: { __typename?: 'Country', id: string, name: string, code: string }, currency: { __typename?: 'Currency', id: string, denomination: number, code: string }, defaultVatRate: { __typename?: 'VatRate', deleted: boolean, type?: VatRateTypeEnum | null, id: string, amount: number }, moduleSettings: { __typename?: 'ModuleSettings', billing_plan: boolean, budgetovac: boolean, clients: boolean, contractors: boolean, documents: boolean, expenses: boolean, invoices: boolean, planovac: boolean, projects: boolean, reports: boolean, time_tracking: boolean, time_billing: boolean }, exportSettings: { __typename?: 'ExportSettings', expenses: boolean, mrp: boolean, pohoda: boolean, premier: boolean, proluc: boolean, triad_project_effectiveness: boolean, project_effectiveness: boolean, project_progress_statistics: boolean, project_status: boolean, unpaid_outgoing_invoices: boolean, mlggk_project_effectiveness: boolean, xero: boolean, vario: boolean, transakcio: boolean, omega: boolean }, currencyExchangeRatesStructured: Array<{ __typename?: 'CurrencyExchangeRateStructured', exchangeRates: Array<{ __typename?: 'CurrencyExchangeRate', id: string, exchange_rate: number, valid_from?: Date | null, valid_to?: Date | null }>, currency: { __typename?: 'Currency', id: string, code: string, denomination: number } }>, budget_pdf_export_settings?: { __typename?: 'BudgetPdfSettings', show_hours?: boolean | null, show_disclaimer?: boolean | null, signature?: boolean | null, show_summary?: boolean | null, show_client_name?: boolean | null, show_client_details?: boolean | null, language?: string | null, our_work_show_commission?: boolean | null, title_page_with_vat?: boolean | null, workspace_company_id: string, workspace_bank_account_id?: string | null, billing_entity_id?: string | null, hide_title_page?: boolean | null, add_billing_plan?: boolean | null, billing_plan_exchange_rate?: number | null, our_work_positions?: BudgetPdfExportOurWorkPositionsEnum | null, our_work_view?: BudgetPdfExportOurWorkViewEnum | null, our_work_description?: boolean | null, our_work_vat_in_items?: boolean | null, our_work_show_discount?: boolean | null, expense_show_commission?: boolean | null, expense_show_quantity?: boolean | null, expense_show_unit?: boolean | null, expense_show_discount?: boolean | null, expense_show_description?: boolean | null, expense_show_vat_in_items?: boolean | null, show_client_and_brand?: boolean | null, show_project_name_full?: boolean | null, use_client_name_from_billing_entity?: boolean | null, disclaimer?: Array<{ __typename?: 'BudgetPdfDisclaimer', language?: string | null, disclaimer?: string | null } | null> | null } | null, companies: Array<{ __typename?: 'WorkspaceCompany', id: string, name: string, internal_name: string, deleted: boolean, currency_id?: string | null, bankAccounts: Array<{ __typename?: 'WorkspaceBankAccount', id: string, iban: string, account_holder_name?: string | null, deleted: boolean }>, country?: { __typename?: 'Country', id: string } | null }> } };

export type PositionSelectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PositionSelectOptionsQuery = { __typename?: 'Query', timeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, default_rate: number, title: string }> };

export type PositionsForProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type PositionsForProjectQuery = { __typename?: 'Query', projectForTask: { __typename?: 'ProjectForTask', id: string, availableTimeTrackingWorkTypes: Array<{ __typename?: 'TimeTrackingWorkType', id: string, title: string }> } };

export type ProjectManagersSelectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectManagersSelectOptionsQuery = { __typename?: 'Query', projectManagerSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string } | null }> };

export type ProjectSelectOptionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ProjectQueryArgs>;
}>;


export type ProjectSelectOptionsQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectPaginator', data: Array<{ __typename?: 'Project', id: string, title: string, code: string, archived_at?: Date | null, finished_at?: Date | null, brand: { __typename?: 'Brand', id: string, name: string } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type RoleSelectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type RoleSelectOptionsQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string, name: string }> };

export type TaskSelectOptionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<TaskQueryArgs>;
}>;


export type TaskSelectOptionsQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskPaginator', data: Array<{ __typename?: 'Task', id: string, name: string, billable: boolean, status: { __typename?: 'TaskStatus', name: string, system_status?: TaskSystemStatusEnum | null }, ourWorkBudgetItem?: { __typename?: 'OurWorkBudgetItem', id: string, title: string, project: { __typename?: 'Project', id: string, code: string, title: string }, category: { __typename?: 'OurWorkBudgetCategory', name: string }, timeTrackingSettings: { __typename?: 'TimeTrackingBudgetItem', tracking_enabled_from?: Date | null, tracking_enabled_to?: Date | null, tracking_enabled: boolean } } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type TeamSelectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamSelectOptionsQuery = { __typename?: 'Query', teamSimpleMap: Array<{ __typename?: 'Team', id: string, name: string }> };

export type TimeOffTypeOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TimeOffTypeOptionsQuery = { __typename?: 'Query', timeOffTypesQuery?: Array<{ __typename?: 'TimeOffType', id: string, name: string }> | null };

export type UsersSelectOptionsQueryVariables = Exact<{
  onlyPlannable?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UsersWhereConditions>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UsersSelectOptionsQuery = { __typename?: 'Query', userSimpleMap: Array<{ __typename?: 'UserSimple', id: string, full_name: string, codename?: string | null, image?: { __typename?: 'AssignableFile', urls: { __typename?: 'AssignableFileUrlPair', thumbnail?: string | null } } | null, profile?: { __typename?: 'UserProfile', hex_color: string } | null }> };

export type BudgetItemsForProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type BudgetItemsForProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, ourWorkStructured: Array<{ __typename?: 'OurWorkStructuredBudgetItem', budgetItems: Array<{ __typename?: 'OurWorkBudgetItem', id: string, title: string, category: { __typename?: 'OurWorkBudgetCategory', name: string } }> }> } | null };

export const AccountMoveFragmentDoc = gql`
    fragment AccountMove on BankAccountMove {
  id
  bank_account_id
  amount
  currency {
    id
    code
    denomination
    exchange_rate
  }
  note
  reference
  vs
  ss
  ks
  status
  type
  date
  balance
  iban
  documents {
    id
    bank_account_move_id
    document_id
    document_type
    document_no
    amount
    date
    document_currency {
      id
      code
      denomination
    }
    exchange_rate
  }
}
    `;
export const BillingEntityModalFragmentDoc = gql`
    fragment BillingEntityModal on BillingEntity {
  id
  internal_name
  legal_name
  street
  city
  zip
  registration_no
  tax_no
  vat_no
  applies_vat
  payment_due
  invoice_email
  note
  language
  disable_email_notification
  country {
    id
    name
  }
  defaultCurrency {
    id
    code
  }
  workspaceCompany {
    id
    name
  }
  workspaceBankAccount {
    id
    iban
  }
}
    `;
export const BrandModalFragmentDoc = gql`
    fragment BrandModal on Brand {
  id
  name
  code
  numeric_code
  image {
    urls {
      thumbnail
    }
  }
  defaultBillingEntity {
    id
  }
}
    `;
export const BudgetGroupFragmentDoc = gql`
    fragment BudgetGroup on BudgetGroup {
  budget_name
  budget_number
  budgets {
    id
    project_id
    project {
      id
      title
    }
    brand {
      id
      name
    }
    description
    account_manager
    assignment_date
    status
    internally_approved
    client_approved
    is_active
    version
    price
    temporaryBrand {
      name
    }
    temporary_project_id
    temporaryProject {
      name
      is_archived
    }
    currency {
      id
      code
      denomination
    }
    created_at
    updated_at
    quotes {
      id
      url
      number
    }
  }
}
    `;
export const BudgetovacPositionPriceFragmentDoc = gql`
    fragment BudgetovacPositionPrice on BudgetovacPositionPrice {
  alias
  department_id
  department_name
  name
  position_id
  price
}
    `;
export const BudgetovacPositionsSetFragmentDoc = gql`
    fragment BudgetovacPositionsSet on BudgetovacPositionsSet {
  id
  name
  active
  client_id
  currency_code
  internal_production_commission
  external_production_commission
  media_budget_commission
  extras_commission
  positions_prices {
    ...BudgetovacPositionPrice
  }
}
    ${BudgetovacPositionPriceFragmentDoc}`;
export const BudgetovacPositionFragmentDoc = gql`
    fragment BudgetovacPosition on BudgetovacPosition {
  id
  name
  department_id
}
    `;
export const ContractorModelFragmentDoc = gql`
    fragment ContractorModel on Contractor {
  id
  legal_name
  street
  city
  zip
  registration_no
  tax_no
  vat_no
  national_id
  iban
  swift
  is_vat_payer
  business_form
  bank_account
  bank_account_code
  country {
    id
    name
    code
  }
  defaultAccountingAccount {
    id
  }
}
    `;
export const GlobalCreditAccountFragmentDoc = gql`
    fragment GlobalCreditAccount on GlobalCreditAccount {
  id
  title
  note
  creditAccount {
    id
    team {
      id
      name
    }
    created_at
    updated_at
  }
  stats {
    id
    remaining_credit
    total_credit
    total_debit
  }
  credits {
    id
    credit
    date
  }
  debits {
    id
    credit
    performed_at
    credit_account_operation_id
    expenseBudgetItem {
      id
      title
    }
  }
  created_at
  updated_at
}
    `;
export const ExternalLinkFragmentFragmentDoc = gql`
    fragment ExternalLinkFragment on ExternalLink {
  id
  title
  link
  model_id
  model_type
}
    `;
export const ExpenseItemDescriptionFragmentDoc = gql`
    fragment ExpenseItemDescription on ExpenseItemDesciption {
  id
  title
  deleted_at
}
    `;
export const OurWorkBudgetItemByCodeFragmentDoc = gql`
    fragment OurWorkBudgetItemByCode on OurWorkBudgetItemSimple {
  id
  title
  project {
    id
    project_manager_id
    archived_at
    finished_at
    brand {
      id
      name
    }
  }
}
    `;
export const ExpenseBudgetItemByCodeFragmentDoc = gql`
    fragment ExpenseBudgetItemByCode on ExpenseBudgetItemSimple {
  id
  title
  project {
    id
    project_manager_id
    archived_at
    finished_at
    brand {
      id
      name
    }
  }
}
    `;
export const ExpenseBudgetItemPlannedExpenseFieldsFragmentDoc = gql`
    fragment ExpenseBudgetItemPlannedExpenseFields on BudgetItemPlannedExpense {
  id
  description
  date
  budgeted_amount
  client_amount
  contractor {
    id
    legal_name
  }
  usedExpenses {
    id
    used_amount
    expenseItem {
      id
    }
  }
}
    `;
export const ModelLockFragmentDoc = gql`
    fragment ModelLock on ModelLock {
  id
  locked_at
  lockedByUser {
    id
    full_name
  }
  deleted_at
  deletedByUser {
    id
    full_name
  }
  is_locked
}
    `;
export const ExpenseFragmentDoc = gql`
    fragment Expense on Expense {
  id
  expense_no
  is_draft
  for_approval
  status
  type
  variable_symbol
  constant_symbol
  specific_symbol
  internal_number
  document_number
  note
  internal_note
  total_amount_includes_vat
  user_created_date
  issue_date
  date_of_supply
  due_date
  paid_at
  payment_type {
    id
    name
    system_name
  }
  has_master_agreement
  fond_contractor_id
  invoice_order_sequence_id
  legal_name
  street
  city
  zip
  registration_no
  tax_no
  vat_no
  business_form
  national_id
  iban
  swift
  exchange_rate
  workspace_company_id
  workspace_bank_account_id
  bank_account
  bank_account_code
  country {
    id
    name
    code
  }
  defaultAccountingAccount {
    id
  }
  contractor {
    id
  }
  contract {
    id
  }
  expenseVatItems {
    amount_in_currency
    vat_in_currency
    vat_percent_informative
  }
  currency {
    id
    denomination
  }
  expenseItemsStructured {
    brand {
      id
      name
    }
    total_amount
    expense_items {
      id
      brand_id
      project_id
      amount_in_currency
      amount_in_percent
      mandatory_id
      approved
      budget_item_type
      accounting_centre_id
      accounting_vat_classification_id
      expense_item_description_id
      tag_ids
      custom_cost_ratio
      globalCreditAccount {
        id
        title
        stats {
          remaining_credit
        }
      }
      vat_amount_in_currency
      vatRate {
        id
        amount
        type
        deleted
      }
      approvals {
        id
        user {
          id
          full_name
        }
        approved
        created_at
      }
      budgetItem {
        id
        title
        payment_status
        project {
          id
          brand {
            id
          }
        }
        ... on ExpenseBudgetItem {
          plannedExpenses {
            ...ExpenseBudgetItemPlannedExpenseFields
          }
        }
        ... on OurWorkBudgetItem {
          plannedExpenses {
            ...ExpenseBudgetItemPlannedExpenseFields
          }
        }
      }
      accountingAccount {
        id
        title
      }
      positions {
        time_tracking_work_type_id
        tracked_time
        report_date
        task {
          id
          name
        }
      }
      timeBillings {
        id
        is_locked
      }
    }
  }
  stats {
    total_vat_in_currency
    total_amount_with_vat_in_currency
    total_amount
    total_vat
    total_amount_with_vat
    total_amount_without_vat
  }
  expense_documents {
    public_id
    mime_type
    size
    name
    filename
    urls {
      viewable
      original
    }
  }
  lockedDocument {
    locked_to
    user {
      id
      full_name
    }
  }
  updated_at
  emailData {
    message_id
    subject
    from
    text
    received_at
  }
  relatedExpenses {
    id
    expense_no
    contractor {
      id
      legal_name
    }
    stats {
      total_amount_with_vat_in_currency
    }
    type
  }
  projectTimeBilling {
    id
    is_locked
    project {
      id
    }
  }
  modelLock {
    ...ModelLock
  }
}
    ${ExpenseBudgetItemPlannedExpenseFieldsFragmentDoc}
${ModelLockFragmentDoc}`;
export const ExpenseItemsListItemFragmentDoc = gql`
    fragment ExpenseItemsListItem on ExpenseItem {
  id
  amount
  amount_in_currency
  mandatory_id
  brand_id
  project_id
  tag_ids
  accounting_centre_id
  accounting_vat_classification_id
  accountingAccount {
    id
    title
    account_number
  }
  vatRate {
    id
    amount
  }
  description {
    title
  }
  budgetItem {
    id
    title
  }
  budget_item_type
  timeBillings {
    id
    is_locked
    title
    project {
      id
    }
  }
  expense {
    id
    expense_no
    document_number
    invoice_status
    status
    type
    date_of_supply
    due_date
    paid_at
    payment_status
    payment_type {
      name
    }
    note
    internal_note
    workspace_company_id
    currency {
      code
      denomination
    }
    accountMoves {
      amount_in_move_currency
    }
    contractor {
      id
      legal_name
    }
    projects {
      id
      title
      code
    }
  }
}
    `;
export const AccountingAccountOptionPartsFragmentDoc = gql`
    fragment AccountingAccountOptionParts on AccountingAccount {
  id
  title
  account_number
}
    `;
export const AllocationsColumnHeader_UserFragmentDoc = gql`
    fragment AllocationsColumnHeader_User on User {
  id
  image {
    urls {
      thumbnail
    }
  }
  full_name
  profile {
    hex_color
    planningRanges {
      type {
        value
      }
      valid_from
      valid_to
      daily_capacity
      weekly_capacities {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
      }
    }
    defaultWorktype {
      id
      title
    }
  }
  team {
    id
    name
  }
}
    `;
export const BrandCreditAccountOptionPartsFragmentDoc = gql`
    fragment BrandCreditAccountOptionParts on BrandCreditAccount {
  id
  title
}
    `;
export const BrandSimpleOptionPartsFragmentDoc = gql`
    fragment BrandSimpleOptionParts on BrandSimple {
  id
  name
  code
}
    `;
export const CapacityAllocationItemFragmentDoc = gql`
    fragment CapacityAllocationItem on CapacityAllocationItem {
  id
  date
  from_time
  to_time
  note
  total_time
  type
  location
  global
  teams {
    team {
      id
    }
  }
  time_off_duration_type
  time_tracking_work_type_id
  completed
  user {
    id
    full_name
    profile {
      hex_color
    }
  }
  timeOffType {
    id
    name
    affects_planning_capacity
  }
  createdBy {
    id
    full_name
    profile {
      hex_color
    }
  }
  meetLink
  eventLink
}
    `;
export const ClientSimpleOptionPartsFragmentDoc = gql`
    fragment ClientSimpleOptionParts on ClientSimple {
  id
  name
}
    `;
export const ContactOptionPartsFragmentDoc = gql`
    fragment ContactOptionParts on Contact {
  id
  first_name
  last_name
}
    `;
export const CountrySimpleOptionPartsFragmentDoc = gql`
    fragment CountrySimpleOptionParts on CountrySimple {
  id
  name
  code
}
    `;
export const CurrencyOptionPartsFragmentDoc = gql`
    fragment CurrencyOptionParts on Currency {
  id
  code
  denomination
}
    `;
export const PaginatorInfoFragmentDoc = gql`
    fragment PaginatorInfo on PaginatorInfo {
  count
  currentPage
  firstItem
  hasMorePages
  lastItem
  lastPage
  perPage
  total
}
    `;
export const PipedriveCustomFieldFragmentDoc = gql`
    fragment PipedriveCustomField on PipedriveCustomFieldValue {
  value
  customField {
    label
  }
}
    `;
export const ProjectSimpleOptionPartsFragmentDoc = gql`
    fragment ProjectSimpleOptionParts on ProjectSimple {
  id
  title
  code
  brand_id
}
    `;
export const UserSimpleOptionPartsFragmentDoc = gql`
    fragment UserSimpleOptionParts on UserSimple {
  id
  full_name
  name
  image {
    urls {
      thumbnail
    }
  }
}
    `;
export const CapacityAllocationItemStatsFragmentDoc = gql`
    fragment CapacityAllocationItemStats on CapacityAllocationItemStats {
  capacity_allocation_id
  capacity_allocation_item_id
  capacity_allocation_created_by_id
  task_id
  task_name
  task_status_id
  task_status_name
  task_status_system_status
  task_status_background_color
  task_status_foreground_color
  our_work_budget_item_id
  our_work_budget_item_title
  project_id
  project_code
  project_title
  tracking_enabled
  tracking_enabled_from
  tracking_enabled_to
  time_off_type_id
  time_off_type_name
  time_off_type_affects_planning_capacity
  deadline
  deadline_time
  repetition
  create_task_positions
  items_count
  title
}
    `;
export const TimeMaterialsBudgetItemFragmentFragmentDoc = gql`
    fragment TimeMaterialsBudgetItemFragment on TimeMaterialsBudgetItems {
  id
  amount
  invoiced
  title
  default_commission
  budget_category_id
  data {
    id
    name
    tracked_time
    amount
  }
}
    `;
export const OutgoingInvoiceCorePartsFragmentDoc = gql`
    fragment OutgoingInvoiceCoreParts on OutgoingInvoice {
  type
  invoice_no
  issue_date
  currency {
    id
    code
    denomination
  }
  due_date
  date_of_supply
  request_for_invoicing_created_date
  request_for_invoicing_submit_date
}
    `;
export const OutgoingInvoiceNotePartsFragmentDoc = gql`
    fragment OutgoingInvoiceNoteParts on OutgoingInvoice {
  note
  internal_note
  text_on_invoice
}
    `;
export const BillingEntityOptionPartsFragmentDoc = gql`
    fragment BillingEntityOptionParts on BillingEntity {
  id
  internal_name
  street
  city
}
    `;
export const ProofOfPaymentFragmentDoc = gql`
    fragment ProofOfPayment on OutgoingInvoice {
  id
  invoice_no
  stats {
    total_amount_in_currency
    total_amount_with_vat_in_currency
  }
}
    `;
export const ProformaInvoiceOptionsFragmentDoc = gql`
    fragment ProformaInvoiceOptions on OutgoingProformaInvoice {
  id
  invoice_no
  projects {
    id
  }
  vat_percent_informative
  currency {
    id
    code
    denomination
  }
  stats {
    id
    total_amount_with_vat_in_currency
    unused_amount_in_currency
  }
  proofOfPayments {
    ...ProofOfPayment
    summaryInvoicesForProofOfPayment {
      id
    }
  }
}
    ${ProofOfPaymentFragmentDoc}`;
export const BudgetPositionFragmentDoc = gql`
    fragment BudgetPosition on BudgetPosition {
  uninvoiced_amount
  uninvoiced_time
  invoiced_amount
  total_invoiced_amount
  total_invoiced_time
  budgeted_amount
  budgeted_time
  title
  time_tracking_work_type_id
  our_work_budget_item_id
  tracked_amount
  tracked_time
  unit_amount
  quantity
}
    `;
export const TimeMaterialsInvoiceDataFragmentFragmentDoc = gql`
    fragment TimeMaterialsInvoiceDataFragment on TimeMaterialsInvoiceData {
  project_id
  ids
  expense_ids
  groupBy
  from
  to
  commission_data {
    expense_budget_item_id
    commission
  }
}
    `;
export const OutgoingInvoiceFormPartsFragmentDoc = gql`
    fragment OutgoingInvoiceFormParts on OutgoingInvoice {
  id
  ...OutgoingInvoiceCoreParts
  ...OutgoingInvoiceNoteParts
  vat_percent_informative
  vat_reverse_charge
  old_invoice_alert_while_editing
  exchange_rate
  exchange_rate_source
  workspace_exchange_rate
  workspace_exchange_rate_source
  workspace_company_id
  workspace_bank_account_id
  show_unit_price
  show_billing_accounting
  type
  invoice_order_sequence_id
  credit_note_outgoing_invoice_id
  client {
    id
    billingEntities {
      ...BillingEntityOptionParts
      payment_due
      applies_vat
      country {
        id
        code
      }
      defaultCurrency {
        id
        code
      }
      workspaceCompany {
        id
      }
      workspaceBankAccount {
        id
      }
    }
  }
  owner {
    id
    full_name
    codename
  }
  teams {
    id
  }
  billingEntity {
    id
  }
  contact {
    id
  }
  projects {
    id
    type
    ourWorkStructured {
      id
      budgetItems {
        id
        category {
          id
        }
      }
    }
    expensesWithoutOtherStructured {
      id
      budgetItems {
        id
        category {
          id
        }
      }
    }
  }
  currency {
    id
    denomination
  }
  invoicePaymentMethod {
    id
  }
  orders {
    id
    purchase_order_no
  }
  proformaInvoicesPivot {
    invoice {
      ...ProformaInvoiceOptions
    }
    amount_in_currency
  }
  invoiceItems {
    description
    amount_in_currency
    unit_price
    quantity
    accounting_account_id
    accounting_centre_id
    tag_ids
    vat_percent_informative
  }
  ourWorkBudgetSplits {
    our_work_budget_item_id
    amount
    amount_in_percent
  }
  expenseBudgetSplits {
    expense_budget_item_id
    amount
  }
  prepaymentSplits {
    brand_credit_account_id
    amount
    amount_left
  }
  budget_positions {
    ...BudgetPosition
  }
  brands {
    id
  }
  filesToAttach {
    public_id
  }
  timeMaterialsInvoiceData {
    ...TimeMaterialsInvoiceDataFragment
  }
  invoiceProofOfPayments {
    amount_in_currency
    invoice {
      id
    }
  }
  projectTimeBilling {
    id
    is_locked
  }
  modelLock {
    ...ModelLock
  }
}
    ${OutgoingInvoiceCorePartsFragmentDoc}
${OutgoingInvoiceNotePartsFragmentDoc}
${BillingEntityOptionPartsFragmentDoc}
${ProformaInvoiceOptionsFragmentDoc}
${BudgetPositionFragmentDoc}
${TimeMaterialsInvoiceDataFragmentFragmentDoc}
${ModelLockFragmentDoc}`;
export const ProformaInvoiceCorePartsFragmentDoc = gql`
    fragment ProformaInvoiceCoreParts on OutgoingProformaInvoice {
  invoice_no
  issue_date
  due_date
  request_for_invoicing_created_date
  request_for_invoicing_submit_date
}
    `;
export const ProformaInvoiceNotePartsFragmentDoc = gql`
    fragment ProformaInvoiceNoteParts on OutgoingProformaInvoice {
  note
  internal_note
  text_on_invoice
}
    `;
export const ProformaInvoiceFormPartsFragmentDoc = gql`
    fragment ProformaInvoiceFormParts on OutgoingProformaInvoice {
  id
  ...ProformaInvoiceCoreParts
  ...ProformaInvoiceNoteParts
  vat_percent_informative
  vat_reverse_charge
  exchange_rate
  exchange_rate_source
  workspace_exchange_rate
  workspace_exchange_rate_source
  workspace_company_id
  workspace_bank_account_id
  show_unit_price
  show_billing_accounting
  invoice_order_sequence_id
  client {
    id
    billingEntities {
      ...BillingEntityOptionParts
      payment_due
      applies_vat
      country {
        id
        code
      }
      defaultCurrency {
        id
        code
      }
      workspaceCompany {
        id
      }
      workspaceBankAccount {
        id
      }
    }
  }
  owner {
    id
    full_name
    codename
  }
  teams {
    id
  }
  billingEntity {
    id
  }
  contact {
    id
  }
  projects {
    id
    ourWorkStructured {
      id
      budgetItems {
        id
        category {
          id
        }
      }
    }
    expensesWithoutOtherStructured {
      id
      budgetItems {
        id
        category {
          id
        }
      }
    }
  }
  currency {
    id
    denomination
  }
  invoicePaymentMethod {
    id
  }
  invoiceItems {
    description
    amount_in_currency
    unit_price
    quantity
    accounting_account_id
    accounting_centre_id
    tag_ids
    vat_percent_informative
  }
  ourWorkBudgetSplits {
    our_work_budget_item_id
    amount
    amount_in_percent
  }
  prepaymentSplits {
    brand_credit_account_id
    amount
  }
  expenseBudgetSplits {
    expense_budget_item_id
    amount
  }
  budget_positions {
    ...BudgetPosition
  }
  brands {
    id
  }
  filesToAttach {
    public_id
  }
  modelLock {
    ...ModelLock
  }
}
    ${ProformaInvoiceCorePartsFragmentDoc}
${ProformaInvoiceNotePartsFragmentDoc}
${BillingEntityOptionPartsFragmentDoc}
${BudgetPositionFragmentDoc}
${ModelLockFragmentDoc}`;
export const RequestForInvoicingCorePartsFragmentDoc = gql`
    fragment RequestForInvoicingCoreParts on RequestForInvoicing {
  type
  status
  issue_date
  due_date
  date_of_supply
}
    `;
export const RequestForInvoicingNotePartsFragmentDoc = gql`
    fragment RequestForInvoicingNoteParts on RequestForInvoicing {
  note
  internal_note
  text_on_invoice
}
    `;
export const RfiFormPartsFragmentDoc = gql`
    fragment RFIFormParts on RequestForInvoicing {
  id
  ...RequestForInvoicingCoreParts
  ...RequestForInvoicingNoteParts
  vat_percent_informative
  vat_reverse_charge
  exchange_rate
  exchange_rate_source
  workspace_exchange_rate
  workspace_exchange_rate_source
  workspace_company_id
  workspace_bank_account_id
  show_unit_price
  show_billing_accounting
  credit_note_outgoing_invoice_id
  client {
    id
    billingEntities {
      ...BillingEntityOptionParts
      payment_due
      applies_vat
      country {
        id
        code
      }
      defaultCurrency {
        id
        code
      }
      workspaceCompany {
        id
      }
      workspaceBankAccount {
        id
      }
    }
  }
  brands {
    id
  }
  owner {
    id
    full_name
    codename
  }
  teams {
    id
  }
  billingEntity {
    id
  }
  contact {
    id
  }
  projects {
    id
    type
    ourWorkStructured {
      id
      budgetItems {
        id
        category {
          id
        }
      }
    }
    expensesWithoutOtherStructured {
      id
      budgetItems {
        id
        category {
          id
        }
      }
    }
  }
  currency {
    id
    denomination
  }
  invoicePaymentMethod {
    id
  }
  orders {
    id
    purchase_order_no
  }
  proformaInvoices {
    ...ProformaInvoiceOptions
  }
  invoiceItems {
    description
    amount_in_currency
    unit_price
    quantity
    accounting_account_id
    accounting_centre_id
    tag_ids
    vat_percent_informative
  }
  ourWorkBudgetSplits {
    our_work_budget_item_id
    amount
    amount_in_percent
  }
  prepaymentSplits {
    brand_credit_account_id
    amount
  }
  expenseBudgetSplits {
    expense_budget_item_id
    amount
  }
  budget_positions {
    ...BudgetPosition
  }
  filesToAttach {
    public_id
  }
  timeMaterialsInvoiceData {
    ...TimeMaterialsInvoiceDataFragment
  }
  proofOfPayments {
    id
  }
}
    ${RequestForInvoicingCorePartsFragmentDoc}
${RequestForInvoicingNotePartsFragmentDoc}
${BillingEntityOptionPartsFragmentDoc}
${ProformaInvoiceOptionsFragmentDoc}
${BudgetPositionFragmentDoc}
${TimeMaterialsInvoiceDataFragmentFragmentDoc}`;
export const PdfFileFragmentDoc = gql`
    fragment PdfFile on AssignableFile {
  public_id
  mime_type
  size
  name
  filename
  urls {
    viewable
    original
  }
}
    `;
export const EmailDataFragmentDoc = gql`
    fragment EmailData on InvoiceEmailData {
  id
  recipients
  subject
  content
  attachments {
    id
    link
    name
    required
  }
}
    `;
export const EmailLogFragmentDoc = gql`
    fragment EmailLog on OutgoingInvoiceEmailLog {
  id
  type
  accepted_delivery
  recipients {
    email
  }
  recipientLog {
    recipient
    status
  }
  sent_at
}
    `;
export const InvoiceBudgetItemListItemFragmentDoc = gql`
    fragment InvoiceBudgetItemListItem on OIBudgetItemForTimeBilling {
  outgoing_invoice_id
  budget_item_id
  budget_item_type
  amount
  budgetItem {
    id
    title
  }
  outgoingInvoice {
    id
    invoice_no
    issue_date
    date_of_supply
    due_date
    paid_at
    payment_status
    type
    note
    internal_note
    text_on_invoice
    abraflexi_exported
    xero_exported
    has_proforma_payments
    proformaInvoicesPivot {
      invoice {
        id
        invoice_no
      }
    }
    currency {
      code
      denomination
    }
    accountMoves {
      amount_in_move_currency
    }
    billingEntity {
      internal_name
      street
      city
    }
    workspace_company_id
    brands {
      id
      name
    }
    projects {
      id
      title
      code
    }
    invoicePaymentMethod {
      id
      name
    }
    projectTimeBilling {
      id
      is_locked
      title
      project {
        id
      }
    }
    documentExports {
      id
      type
      exported_at
    }
    emailLogs {
      ...EmailLog
    }
    ourWorkBudgetSplits {
      id
      amount
    }
    expenseBudgetSplits {
      id
      amount
    }
  }
}
    ${EmailLogFragmentDoc}`;
export const InvoicePaymentMethodFragmentDoc = gql`
    fragment InvoicePaymentMethod on InvoicePaymentMethod {
  id
  name
}
    `;
export const UserToolTip_UserFragmentFragmentDoc = gql`
    fragment UserToolTip_UserFragment on User {
  id
  codename
  full_name
  image {
    urls {
      thumbnail
    }
  }
  profile {
    hex_color
    defaultWorktype {
      id
      title
    }
  }
  team {
    id
    name
  }
}
    `;
export const ProjectBillingSubRowFragmentDoc = gql`
    fragment ProjectBillingSubRow on ProjectBillingItem {
  id
  planned_amount
  planned_our_work
  planned_expense_categories {
    amount
    category_id
    category_name
  }
  planned_prepayments
  invoiced_amount
  invoiced_our_work
  invoiced_expense_categories {
    amount
    category_id
    category_name
  }
  invoiced_prepayments
  automatically_invoiced
  manually_invoiced
  balance
  issue_date
  date_of_supply
  due_date
  type
  invoice_no
  paid_at
  paid_amount
  status
  delivered
  note
  item_type
  invoice_type
  billing_item_type
  payment_status
  brandCreditAccount {
    id
    title
  }
  outgoingInvoice {
    id
  }
  outgoingProformaInvoice {
    id
  }
  requestForInvoicing {
    id
  }
}
    `;
export const ProjectBillingRowFragmentDoc = gql`
    fragment ProjectBillingRow on ProjectBilling {
  planned_amount
  planned_our_work
  planned_expense_categories {
    amount
    category_id
    category_name
  }
  planned_prepayments
  invoiced_amount
  invoiced_our_work
  invoiced_expense_categories {
    amount
    category_id
    category_name
  }
  invoiced_prepayments
  automatically_invoiced
  manually_invoiced
  balance
  billing_type
  has_billing_plan
  project {
    id
    code
    title
    projectManager {
      ...UserToolTip_UserFragment
    }
    brand {
      id
      name
      image {
        urls {
          thumbnail
        }
      }
    }
  }
  items {
    ...ProjectBillingSubRow
  }
}
    ${UserToolTip_UserFragmentFragmentDoc}
${ProjectBillingSubRowFragmentDoc}`;
export const ProjectBillingsSummaryFragmentFragmentDoc = gql`
    fragment ProjectBillingsSummaryFragment on ProjectBillingsSummary {
  total_paid_amount
  total_unpaid_amount
  total_planned_amount
  total_planned_our_work
  total_planned_expense_categories {
    amount
    category_id
    category_name
  }
  total_planned_prepayments
  total_invoiced_amount
  total_invoiced_our_work
  total_invoiced_expense_categories {
    amount
    category_id
    category_name
  }
  total_invoiced_prepayments
}
    `;
export const UserTooltipFragmentDoc = gql`
    fragment UserTooltip on User {
  id
  codename
  image {
    urls {
      thumbnail
    }
  }
  full_name
  profile {
    hex_color
    defaultWorktype {
      id
      title
    }
  }
  team {
    id
    name
  }
}
    `;
export const InvoicingPlanAdvancedListFragmentDoc = gql`
    fragment InvoicingPlanAdvancedList on BillingPlanBudgetCache {
  id
  type
  project {
    id
    title
    code
    billable
    projectManager {
      ...UserTooltip
    }
  }
  brand {
    id
    name
    image {
      urls {
        thumbnail
      }
    }
  }
  planned_amount
  issue_date
  date_of_supply
  due_date
  invoiced_amount
  billing_plan_invoice_id
  invoice_no
  request_for_invoicing_id
  paid_amount
  paid_at
  email_sent
  created_at
  updated_at
  message
  status
}
    ${UserTooltipFragmentDoc}`;
export const NotificationFragmentDoc = gql`
    fragment Notification on Notification {
  id
  type
  message
  object_id
  created_at
  read_at
  url
}
    `;
export const TaskNotificationsNotificationFragmentDoc = gql`
    fragment TaskNotificationsNotification on Notification {
  id
  message
  type
  read_at
  created_at
}
    `;
export const BillingPlanFragmentDoc = gql`
    fragment BillingPlan on BillingPlanBudget {
  id
  budget_item_id
  budget_item_type
  total_budget
  category {
    id
    name
  }
  title
  total_budget
  billing_item_type
  billingPlanBudgetItem {
    invoice_type
    day
    accounting_centre_id
    accounting_account_id
    months {
      value
      date
      billingPlanInvoice {
        amount
        invoice_type
        invoice_id
        date
      }
    }
  }
}
    `;
export const BillingPlanSettingsProjectFragmentDoc = gql`
    fragment BillingPlanSettingsProject on Project {
  title
  code
  start_date
  expected_end_date
  brand {
    image {
      urls {
        thumbnail
      }
    }
  }
  contact {
    email
  }
  brand {
    defaultBillingEntity {
      invoice_email
    }
  }
  projectManager {
    email
  }
  billingPlanSetting {
    to
    from
    auto_send_invoice
    auto_send_thank_you
    auto_create_invoice
    generate_invoice_items
    billing_item_type
    vat_rate_id
    date_of_supply_from_issue_date
    email_template {
      subject
      content
      recipients
    }
    auto_send_thank_you_template {
      subject
      content
      recipients
    }
    workspace_company_id
    workspace_bank_account_id
    billing_entity_id
    contact_id
    text_on_invoice
    internal_note
    note
    create_draft_invoice
    order_id
    create_summary_invoice_after_payment
    locked_at
    lockedByUser {
      id
      full_name
    }
  }
}
    `;
export const SimpleTaskForClientFragmentDoc = gql`
    fragment SimpleTaskForClient on Task {
  id
  name
  scopedCommentCount
  is_template
  is_starred
  task_template_group_id
  status {
    id
    name
    background_color
    foreground_color
    system_status
  }
  deadline
  days_to_deadline
  priority {
    id
    name
    system_priority
    emoji
  }
  positions {
    user {
      ...UserToolTip_UserFragment
      first_name
      last_name
    }
  }
  parent {
    id
    name
  }
  ourWorkBudgetItem {
    id
    project {
      id
      code
      title
      uses_budgetovac
      brand {
        name
        client {
          name
        }
      }
    }
  }
}
    ${UserToolTip_UserFragmentFragmentDoc}`;
export const SimpleTaskFragmentDoc = gql`
    fragment SimpleTask on Task {
  ...SimpleTaskForClient
  billable
  commentCount
  unreadCommentsCount
  stats {
    planned_time
    spent_time
  }
  scopes {
    value
  }
  ourWorkBudgetItem {
    title
    category {
      name
    }
    timeTrackingSettings {
      tracking_enabled_from
      tracking_enabled_to
      tracking_enabled
    }
  }
}
    ${SimpleTaskForClientFragmentDoc}`;
export const OurWorkBudgetItemOverviewTasksFragmentFragmentDoc = gql`
    fragment OurWorkBudgetItemOverviewTasksFragment on OurWorkBudgetItemOverview {
  tasks {
    ...SimpleTask
    subtasks {
      ...SimpleTask
    }
  }
}
    ${SimpleTaskFragmentDoc}`;
export const OurWorkBudgetItemOverviewFragmentFragmentDoc = gql`
    fragment OurWorkBudgetItemOverviewFragment on OurWorkBudgetItemOverview {
  id
  title
  item_code
  completed_at
  requested_for_deletion_at
  plannedExpenses {
    id
  }
  hidden
  order
  note
  deadline
  done_task_count
  task_count
  lastWorkInProgressItemStat {
    work_in_progress_id
    progress_percent
  }
  stats {
    total_budget
    total_time
    spent_budget
    spent_time
    remaining_time
    remaining_budget
    credit
    invoiced_percent
    spent_budget_percent
    credit_balance
    invoiceable
    uninvoiced
    net_profit
    net_margin_percent
    efficiency_percent
  }
  expenseStats {
    id
    task {
      id
      name
    }
    tracked_time
    report_date
    expense_item_amount
    expense {
      id
      expense_no
    }
    position {
      title
    }
  }
  ...OurWorkBudgetItemOverviewTasksFragment
}
    ${OurWorkBudgetItemOverviewTasksFragmentFragmentDoc}`;
export const OurWorkOverviewFragmentDoc = gql`
    fragment OurWorkOverview on OurWorkOverviewBudgetItem {
  id
  name
  total_budget
  credit
  budgetItems {
    ...OurWorkBudgetItemOverviewFragment
  }
}
    ${OurWorkBudgetItemOverviewFragmentFragmentDoc}`;
export const ExpenseStructuredBudgetItemFragmentFragmentDoc = gql`
    fragment ExpenseStructuredBudgetItemFragment on ExpenseBudgetItem {
  id
  item_code
  title
  type
  completed_at
  requested_for_deletion_at
  plannedExpenses {
    id
  }
  expenseStats {
    expense {
      status
    }
  }
  stats {
    total_budget
    client_price
    real_expenses
    real_commission
    planned_expenses
    planned_commission
    planned_profit
    real_expenses_percent
    real_commission_relative
    planned_commission_relative_computed
    credit
    credit_balance
    invoiced_percent
    invoiceable
    uninvoiced
    profit
    profit_percent
  }
}
    `;
export const ProjectDetailPlannedExpenseFieldsFragmentDoc = gql`
    fragment ProjectDetailPlannedExpenseFields on BudgetItemPlannedExpense {
  id
  budget_item_id
  budget_item_type
  description
  date
  client_amount
  budgeted_amount
  contractor {
    id
    legal_name
  }
}
    `;
export const WipItemStatAffectedValuesFragmentDoc = gql`
    fragment WipItemStatAffectedValues on WorkInProgressItemStat {
  progress
  progress_percent
  progress_change
  progress_change_percent
  spent_time_estimate
}
    `;
export const PlannedExpensesBudgetItemFragmentDoc = gql`
    fragment PlannedExpensesBudgetItem on PlannedExpensesBudgetItem {
  id
  title
  item_code
  category_name
  buy_price
  uninvoiced_amount
  planned_client_amount
  planned_budgeted_amount
  expenses_received
  expenses_received_percentage
  invoiced_amount
  invoiced_amount_percentage
  actual_profit_amount
  actual_profit_percentage
  total_budget
  total_budgeted_with_commission
  to_plan_buy_price
  to_plan_buy_price_percentage
  to_plan_client_price
  to_plan_client_price_percentage
  profit_estimate
  profit_estimate_percentage
}
    `;
export const PlannedExpensesProjectFragmentDoc = gql`
    fragment PlannedExpensesProject on PlannedExpensesProject {
  id
  project {
    id
    code
    title
    brand {
      id
      name
    }
    projectManager {
      ...UserToolTip_UserFragment
    }
  }
  uninvoiced_amount
  actual_profit_amount
  actual_profit_percentage
  total_planned_client_amount
  total_planned_budgeted_amount
  total_budget
  total_budgeted_with_commission
  total_buy_price
  total_expenses_received
  expenses_received_percentage
  total_invoiced_amount
  invoiced_amount_percentage
  to_plan_buy_price
  to_plan_buy_price_percentage
  to_plan_client_price
  to_plan_client_price_percentage
  profit_estimate
  profit_estimate_percentage
  budget_items {
    ...PlannedExpensesBudgetItem
  }
}
    ${UserToolTip_UserFragmentFragmentDoc}
${PlannedExpensesBudgetItemFragmentDoc}`;
export const PlannedExpensesSummaryFragmentDoc = gql`
    fragment PlannedExpensesSummary on PlannedExpensesSummary {
  uninvoiced_amount
  uninvoiced_amount_percentage
  actual_profit_amount
  actual_profit_percentage
  total_planned_client_amount
  planned_client_amount_percentage
  total_planned_budgeted_amount
  planned_budgeted_amount_percentage
  total_budget
  total_budgeted_with_commission
  total_buy_price
  total_expenses_received
  expenses_received_percentage
  total_invoiced_amount
  invoiced_amount_percentage
  to_plan_buy_price
  to_plan_buy_price_percentage
  to_plan_client_price
  to_plan_client_price_percentage
  profit_estimate
  profit_estimate_percentage
}
    `;
export const DistributionModalTableItemFragmentDoc = gql`
    fragment DistributionModalTableItem on TimeTrackingReport {
  id
  tracked_for_date
  user_full_name
  user_id
  task_name
  task_id
  our_work_budget_item_title
  note
  tracked_time
  billable
  hourly_rate
  amount
}
    `;
export const ProjectTimeBillingSourcePreviewFragmentDoc = gql`
    fragment ProjectTimeBillingSourcePreview on ProjectTimeBillingSourcePreview {
  source_type
  source_id
  outgoing_invoice_id
  budget_item_id
  budget_item_type
  amount
  expenseItem {
    id
    amount
    description {
      title
    }
    budgetItem {
      ... on OurWorkBudgetItem {
        id
        title
      }
      ... on ExpenseBudgetItem {
        id
        title
      }
    }
  }
  expense {
    id
    expense_no
    document_number
    date_of_supply
    contractor {
      legal_name
    }
    note
    emailData {
      text
    }
  }
  outgoingInvoice {
    id
    invoice_no
    issue_date
    billingEntity {
      internal_name
      street
      city
    }
  }
  budgetItem {
    ... on OurWorkBudgetItem {
      id
      title
    }
    ... on ExpenseBudgetItem {
      id
      title
    }
  }
}
    `;
export const ProjectTimeBillingComponentPreviewFragmentDoc = gql`
    fragment ProjectTimeBillingComponentPreview on ProjectTimeBillingComponentPreview {
  key
  amount
  use_in_total
  source_id
  source_type
}
    `;
export const ProjectTimeBillingUserRowPreviewFragmentDoc = gql`
    fragment ProjectTimeBillingUserRowPreview on ProjectTimeBillingUserRowPreview {
  user_id
  user {
    id
    full_name
    image {
      urls {
        thumbnail
      }
    }
  }
  time_tracking_work_type_id
  position {
    id
    title
  }
  team_id
  team {
    id
    name
  }
  tracked_time
  tracked_hours
  client_rate
  spent
  effective_hourly_rate
  amount
  invoiced_time
  overserviced_time
  effective_hourly_rate_invoiced
}
    `;
export const ProjectTimeBillingComputedFragmentDoc = gql`
    fragment ProjectTimeBillingComputed on ProjectTimeBillingComputed {
  date_from
  date_to
  computed_total_amount
  sources {
    ...ProjectTimeBillingSourcePreview
  }
  components {
    ...ProjectTimeBillingComponentPreview
  }
  userRows {
    ...ProjectTimeBillingUserRowPreview
  }
  distributions {
    time_tracking_item_id
  }
}
    ${ProjectTimeBillingSourcePreviewFragmentDoc}
${ProjectTimeBillingComponentPreviewFragmentDoc}
${ProjectTimeBillingUserRowPreviewFragmentDoc}`;
export const ProjectTimeBillingDistributionPreviewFragmentDoc = gql`
    fragment ProjectTimeBillingDistributionPreview on ProjectTimeBillingDistributionPreview {
  time_tracking_item_id
  invoiced_seconds
  overserviced_seconds
  uninvoiced_seconds
  timeTrackingItem {
    tracked_for_date
    tracked_time
    note
    billable
    user {
      id
      full_name
      image {
        urls {
          thumbnail
        }
      }
    }
    timeTrackingWorkType {
      id
      title
    }
    task {
      id
      name
    }
  }
}
    `;
export const ProjectTimeBillingListItemFragmentDoc = gql`
    fragment ProjectTimeBillingListItem on ProjectTimeBilling {
  id
  title
  date_from
  date_to
  type
  final_total_amount
  final_total_note
  is_locked
  lockedByUser {
    id
    full_name
    image {
      urls {
        thumbnail
      }
    }
  }
  locked_at
  createdByUser {
    id
    full_name
  }
  created_at
}
    `;
export const ProjectTimeBillingSourceFragmentDoc = gql`
    fragment ProjectTimeBillingSource on ProjectTimeBillingSource {
  source_type
  source_id
  outgoing_invoice_id
  budget_item_id
  budget_item_type
  amount
  expenseItem {
    id
    amount
    description {
      title
    }
    budgetItem {
      ... on OurWorkBudgetItem {
        id
        title
      }
      ... on ExpenseBudgetItem {
        id
        title
      }
    }
  }
  expense {
    id
    expense_no
    document_number
    date_of_supply
    contractor {
      legal_name
    }
    note
    emailData {
      text
    }
  }
  outgoingInvoice {
    id
    invoice_no
    issue_date
    billingEntity {
      internal_name
      street
      city
    }
  }
  budgetItem {
    ... on OurWorkBudgetItem {
      id
      title
    }
    ... on ExpenseBudgetItem {
      id
      title
    }
  }
}
    `;
export const ProjectTimeBillingComponentFragmentDoc = gql`
    fragment ProjectTimeBillingComponent on ProjectTimeBillingComponent {
  key
  amount
  use_in_total
}
    `;
export const ProjectTimeBillingUserRowFragmentDoc = gql`
    fragment ProjectTimeBillingUserRow on ProjectTimeBillingUserRow {
  id
  user {
    id
    full_name
    image {
      urls {
        thumbnail
      }
    }
  }
  position {
    id
    title
  }
  team {
    id
    name
  }
  tracked_time
  tracked_hours
  client_rate
  spent
  effective_hourly_rate
  amount
  invoiced_time
  overserviced_time
  effective_hourly_rate_invoiced
}
    `;
export const ProjectTimeBillingDetailFragmentDoc = gql`
    fragment ProjectTimeBillingDetail on ProjectTimeBilling {
  ...ProjectTimeBillingListItem
  sources {
    ...ProjectTimeBillingSource
  }
  components {
    ...ProjectTimeBillingComponent
  }
  userRows {
    ...ProjectTimeBillingUserRow
  }
  distributions {
    time_tracking_item_id
  }
}
    ${ProjectTimeBillingListItemFragmentDoc}
${ProjectTimeBillingSourceFragmentDoc}
${ProjectTimeBillingComponentFragmentDoc}
${ProjectTimeBillingUserRowFragmentDoc}`;
export const BrandTableDataFragmentDoc = gql`
    fragment BrandTableData on BrandWithRevenueResult {
  id
  name
  image {
    urls {
      thumbnail
    }
  }
  gross_income_for_date_range
}
    `;
export const ProfitAndLossReportColumnFragmentDoc = gql`
    fragment ProfitAndLossReportColumn on ProfitLossReportColumn {
  title
  expenses_amount
  invoiced_amount
  balance_amount
}
    `;
export const ProjectTableDataFragmentDoc = gql`
    fragment ProjectTableData on ProjectWithRevenueItem {
  id
  title
  code
  note
  finished_at
  archived_at
  status
  brand {
    id
    name
    image {
      urls {
        thumbnail
      }
    }
  }
  projectManager {
    ...UserToolTip_UserFragment
  }
  gross_income_for_date_range
}
    ${UserToolTip_UserFragmentFragmentDoc}`;
export const UserProfitReportFragmentDoc = gql`
    fragment UserProfitReport on UtilizationReport {
  total_time
  available_time
  remaining_time
  time_off
  overtime
  combined_time
  combined_time_billable
  budgeted_time
  budgeted_time_billable
  allocated_time
  allocated_time_billable
  tracked_time
  tracked_time_billable
  utilization_percentage
  utilization_percentage_billable
  internal_cost
  combined_amount_billable
  budgeted_amount_billable
  combined_profit_amount
  budgeted_profit_amount
  tracked_time_billable
}
    `;
export const UserProfitUserFragmentDoc = gql`
    fragment UserProfitUser on User {
  id
  full_name
  profile {
    hex_color
    utilization_range_from
    utilization_range_to
    defaultWorktype {
      title
    }
  }
  team {
    name
  }
  image {
    urls {
      thumbnail
    }
  }
}
    `;
export const TaskUserFragmentDoc = gql`
    fragment TaskUser on User {
  id
  codename
  first_name
  last_name
  full_name
  image {
    urls {
      thumbnail
    }
  }
  profile {
    hex_color
    defaultWorktype {
      id
      title
    }
  }
  team {
    id
    name
  }
}
    `;
export const TaskPositionUserFragmentDoc = gql`
    fragment TaskPositionUser on TaskPosition {
  id
  planned_time
  spent_time
  user {
    ...TaskUser
  }
  timeTrackingWorkType {
    id
    title
  }
}
    ${TaskUserFragmentDoc}`;
export const TaskBaseFragmentDoc = gql`
    fragment TaskBase on Task {
  id
  name
  deadline
  from
  to
  is_starred
  billable
  is_template
  task_template_group_id
  status {
    id
    name
    background_color
    foreground_color
    system_status
  }
  priority {
    id
    name
    system_priority
    emoji
  }
  stats {
    planned_time
    spent_time
  }
  currentAssignee {
    ...TaskUser
  }
  users {
    ...TaskUser
  }
  positions {
    ...TaskPositionUser
  }
  parent {
    id
    name
  }
  ourWorkBudgetItem {
    id
    title
    project {
      id
      code
      title
      uses_budgetovac
      brand {
        name
        client {
          name
        }
      }
    }
    timeTrackingSettings {
      tracking_enabled
      tracking_enabled_from
      tracking_enabled_to
    }
  }
}
    ${TaskUserFragmentDoc}
${TaskPositionUserFragmentDoc}`;
export const TaskScheduleFragmentDoc = gql`
    fragment TaskSchedule on Task {
  id
  from
  to
  deadline
}
    `;
export const BoardTaskUserFragmentDoc = gql`
    fragment BoardTaskUser on User {
  id
  first_name
  last_name
  full_name
  image {
    urls {
      thumbnail
    }
  }
  profile {
    hex_color
    defaultWorktype {
      id
      title
    }
  }
}
    `;
export const BoardTaskFragmentDoc = gql`
    fragment BoardTask on Task {
  id
  name
  deadline
  is_starred
  is_template
  billable
  status {
    id
    name
    background_color
    foreground_color
    system_status
  }
  priority {
    id
    name
    system_priority
    emoji
  }
  stats {
    planned_time
    spent_time
  }
  currentAssignee {
    ...BoardTaskUser
  }
  users {
    ...BoardTaskUser
  }
  positions {
    id
    spent_time
    user {
      ...BoardTaskUser
    }
    timeTrackingWorkType {
      id
      title
    }
  }
  parent {
    id
    name
  }
  ourWorkBudgetItem {
    id
    title
    project {
      id
      code
      title
    }
    timeTrackingSettings {
      tracking_enabled
      tracking_enabled_from
      tracking_enabled_to
    }
  }
}
    ${BoardTaskUserFragmentDoc}`;
export const BoardSettingsFragmentDoc = gql`
    fragment BoardSettings on TaskBoardSettings {
  board_key
  hidden_columns
  collapsed_columns
  column_order
  sort {
    column
    direction
  }
}
    `;
export const ListingClientTaskBaseFragmentDoc = gql`
    fragment ListingClientTaskBase on Task {
  id
  name
  is_template
  is_starred
  task_template_group_id
  from
  to
  created_at
  status {
    id
    name
    background_color
    foreground_color
    system_status
  }
  deadline
  priority {
    id
    name
    system_priority
    emoji
  }
  positions {
    user {
      ...UserToolTip_UserFragment
      first_name
      last_name
    }
  }
  parent {
    id
    name
  }
  ourWorkBudgetItem {
    id
    project {
      id
      code
      title
      uses_budgetovac
      brand {
        name
        client {
          name
        }
      }
    }
  }
}
    ${UserToolTip_UserFragmentFragmentDoc}`;
export const ListingClientTaskFragmentDoc = gql`
    fragment ListingClientTask on Task {
  ...ListingClientTaskBase
  subtasks {
    ...ListingClientTaskBase
  }
}
    ${ListingClientTaskBaseFragmentDoc}`;
export const ListingInternalTaskBaseFragmentDoc = gql`
    fragment ListingInternalTaskBase on Task {
  ...ListingClientTaskBase
  positions {
    spent_time
  }
  stats {
    planned_time
    spent_time
  }
  scopes {
    value
  }
  billable
  ourWorkBudgetItem {
    id
    title
    project {
      id
      title
      uses_budgetovac
      code
      brand {
        name
        client {
          name
        }
      }
    }
  }
  is_starred
}
    ${ListingClientTaskBaseFragmentDoc}`;
export const ListingInternalTaskFragmentDoc = gql`
    fragment ListingInternalTask on Task {
  ...ListingInternalTaskBase
  subtasks {
    ...ListingInternalTaskBase
  }
}
    ${ListingInternalTaskBaseFragmentDoc}`;
export const ProjectTemplateFragmentDoc = gql`
    fragment ProjectTemplate on Project {
  id
  title
  code
  billable
  note
  brand {
    id
    name
    image {
      urls {
        thumbnail
      }
    }
  }
  categories {
    id
    name
  }
  statsCached {
    id
    total_budget
    ourWork {
      id
      total_budget
    }
    expenses {
      id
      planned_expenses
    }
  }
}
    `;
export const TaskBasicInfoFragmentDoc = gql`
    fragment TaskBasicInfo on Task {
  id
  name
  status {
    id
    name
    background_color
    foreground_color
    system_status
  }
  priority {
    id
    name
    system_priority
    emoji
  }
  deadline
  scopedCommentCount
  positions {
    user {
      ...UserToolTip_UserFragment
      scope {
        value
      }
    }
  }
  ourWorkBudgetItem {
    project {
      id
      title
      code
      brand {
        name
        client {
          name
        }
      }
    }
  }
  subtasks {
    ...SimpleTaskForClient
  }
  parent {
    id
  }
  is_template
  task_template_group_id
}
    ${UserToolTip_UserFragmentFragmentDoc}
${SimpleTaskForClientFragmentDoc}`;
export const TaskExtendedInfoFragmentDoc = gql`
    fragment TaskExtendedInfo on Task {
  stats {
    planned_time
    spent_time
  }
  scopes {
    value
  }
  billable
  commentCount
  unreadCommentsCount
  ourWorkBudgetItem {
    id
    title
    project {
      id
      title
      uses_budgetovac
      code
      brand {
        name
        client {
          name
        }
      }
    }
  }
  subtasks {
    ...SimpleTask
  }
}
    ${SimpleTaskFragmentDoc}`;
export const TaskGroupTemplateFragmentDoc = gql`
    fragment TaskGroupTemplate on TaskTemplateGroup {
  id
  name
  tasks {
    ...TaskBasicInfo
    ...TaskExtendedInfo
  }
}
    ${TaskBasicInfoFragmentDoc}
${TaskExtendedInfoFragmentDoc}`;
export const TimeTrackingReportItemFragmentDoc = gql`
    fragment TimeTrackingReportItem on TimeTrackingReport {
  id
  tracked_time
  tracked_for_date
  brand_id
  brand_name
  client_name
  project_id
  project_title
  project_code
  project_time_billing_id
  project_time_billing_project_id
  project_time_billing_name
  project_time_billing_project_name
  project_time_billing_is_locked
  our_work_budget_item_title
  time_tracking_work_type_title
  time_tracking_work_type_id
  team_name
  task_id
  task_name
  user_full_name
  note
  invoiced_seconds
  overserviced_seconds
  uninvoiced_seconds
  amount
  hourly_rate
  locked_at
  locked_by_user_first_name
  locked_by_user_last_name
}
    `;
export const TimeTrackingEntryFragmentDoc = gql`
    fragment TimeTrackingEntry on TimeTrackingItem {
  id
  tracked_for_date
  tracked_time
  tracked_time_with_running_timer
  specific_time_from
  specific_time_to
  note
  auto_stopped
  billable
  is_locked
  timeBilling {
    id
    name
    is_locked
    project {
      id
    }
  }
  has_running_timer
  user {
    id
  }
  capacityAllocationItem {
    id
  }
  task {
    id
    name
    ourWorkBudgetItem {
      id
      title
      project {
        id
        code
        title
        brand {
          id
          name
        }
      }
    }
  }
  timeTrackingBudgetItem {
    id
    tracking_enabled
  }
  timeTrackingWorkType {
    id
    title
  }
  project {
    id
    title
    code
    brand {
      id
      name
    }
  }
}
    `;
export const UserForEditBasicFragmentDoc = gql`
    fragment UserForEditBasic on User {
  id
  scope {
    value
  }
  first_name
  last_name
  full_name
  codename
  created_at
  image {
    urls {
      thumbnail
    }
  }
  statusRanges {
    id
    valid_from
    valid_to
    active
    projectManager {
      id
    }
  }
  email
  phone
  note
  archived_at
  PMActiveProjectsCount
  permissions {
    user_haveProjectsAssigned
  }
  enabled_two_factor_authentication
  mcp_connected
  mcpTokens {
    id
    mcp_name
    created_at
  }
  muted_mail_notifications
  calendar_integrations
  calendar_sync_direction
  calendar_sync_allocation_types
  team {
    id
    name
  }
  roles {
    id
    name
  }
  brands {
    id
    name
  }
  tasks {
    id
  }
}
    `;
export const AttachmentFragmentDoc = gql`
    fragment Attachment on AssignableFile {
  public_id
  filename
  mime_type
  urls {
    thumbnail
    viewable
    original
  }
}
    `;
export const CommentFragmentDoc = gql`
    fragment Comment on TaskComment {
  id
  user {
    id
    codename
    full_name
    image {
      urls {
        thumbnail
      }
    }
    profile {
      hex_color
      defaultWorktype {
        id
        title
      }
    }
    team {
      id
      name
    }
  }
  reactions {
    id
    user {
      id
      full_name
    }
    emoji_id
  }
  body
  timestamp
  has_edits
  files {
    ...Attachment
  }
}
    ${AttachmentFragmentDoc}`;
export const TaskFragmentForScopedUserFragmentDoc = gql`
    fragment TaskFragmentForScopedUser on Task {
  ...SimpleTaskForClient
  created_at
  from
  days_to_from
  to
  days_to_to
  attachments_download_url
  clientCommentCount
  partnerCommentCount
  users {
    id
    first_name
    last_name
    scope {
      value
    }
  }
  currentAssignee {
    id
  }
  createdBy {
    id
    full_name
    codename
    image {
      urls {
        thumbnail
      }
    }
    profile {
      hex_color
      defaultWorktype {
        id
        title
      }
    }
    team {
      id
      name
    }
  }
  description {
    body
    mentioned_user_ids
    mentioned_team_ids
    mentioned_assignees
  }
  positions {
    id
    user {
      first_name
      last_name
      scope {
        value
      }
    }
  }
  ourWorkBudgetItem {
    project {
      availableTimeTrackingWorkTypes {
        id
        title
      }
      projectManager {
        id
      }
      otherProjectManagers {
        id
      }
      brand {
        id
        client {
          id
        }
      }
    }
  }
  files {
    ...Attachment
    created_at
  }
  parent {
    id
    name
    status {
      name
      system_status
    }
    ourWorkBudgetItem {
      project {
        id
        code
        title
      }
    }
  }
}
    ${SimpleTaskForClientFragmentDoc}
${AttachmentFragmentDoc}`;
export const TaskFragmentFragmentDoc = gql`
    fragment TaskFragment on Task {
  ...TaskFragmentForScopedUser
  revision
  cloudUrl
  driveCloudUrl
  billable
  scopes {
    value
  }
  commentCount
  scopedCommentCount
  otherPeopleTracked {
    user {
      full_name
    }
    time_tracking_work_type_id
    tracked_time
  }
  otherPeopleTrackedTotal
  users {
    id
    first_name
    last_name
    scope {
      value
    }
  }
  createdBy {
    id
    full_name
    codename
    image {
      urls {
        thumbnail
      }
    }
    profile {
      hex_color
      defaultWorktype {
        id
        title
      }
    }
    team {
      id
      name
    }
  }
  linkedTasks {
    id
    link_type {
      name
    }
    linked_task {
      id
      name
      commentCount
      status {
        id
        name
        background_color
        foreground_color
        system_status
      }
      priority {
        id
        name
        system_priority
        emoji
      }
      ourWorkBudgetItem {
        id
        title
        item_code
      }
    }
  }
  stats {
    planned_time
    spent_time
  }
  positions {
    timeTrackingWorkType {
      id
      title
    }
    planned_time
  }
  ourWorkBudgetItem {
    id
    title
    project {
      uses_budgetovac
    }
    timeTrackingSettings {
      tracking_enabled
      tracking_enabled_to
      tracking_enabled_from
    }
  }
  parent {
    ourWorkBudgetItem {
      title
    }
  }
  task_template_group_id
  taskWatchers {
    user_id
  }
}
    ${TaskFragmentForScopedUserFragmentDoc}`;
export const EbiCompleteDataFragmentDoc = gql`
    fragment EbiCompleteData on ExpenseBudgetItem {
  id
  completed_at
  stats {
    planned_commission
    planned_commission_relative_computed
    real_commission
    real_commission_relative
  }
}
    `;
export const ContactFragmentDoc = gql`
    fragment Contact on Contact {
  id
  first_name
  last_name
  email
  phone
}
    `;
export const ExchangeRateFragmentDoc = gql`
    fragment ExchangeRate on CurrencyExchangeRate {
  id
  exchange_rate
  valid_from
  valid_to
  currency {
    id
    code
    denomination
  }
}
    `;
export const CompleteExpenseBulkDataFragmentDoc = gql`
    fragment CompleteExpenseBulkData on ExpenseBudgetItem {
  id
  completed_at
}
    `;
export const FinishedProjectDataFragmentDoc = gql`
    fragment FinishedProjectData on Project {
  id
  status
  finished_at
  finishedBy {
    id
    full_name
  }
}
    `;
export const DocumentExportFragmentDoc = gql`
    fragment DocumentExport on DocumentExport {
  type
  exported_at
}
    `;
export const OutgoingInvoiceOfInvoiceStatsFragmentDoc = gql`
    fragment OutgoingInvoiceOfInvoiceStats on OutgoingInvoice {
  id
  invoice_no
  date_of_supply
  type
  has_proforma_payments
  proformaInvoicesPivot {
    invoice {
      id
      invoice_no
    }
  }
  abraflexi_exported
  xero_exported
  stats {
    billing_amount
  }
  documentExports {
    ...DocumentExport
  }
  emailLogs {
    ...EmailLog
  }
}
    ${DocumentExportFragmentDoc}
${EmailLogFragmentDoc}`;
export const MediaModelPartsFragmentDoc = gql`
    fragment MediaModelParts on AssignableFile {
  public_id
  mime_type
  size
  name
  filename
  urls {
    viewable
    original
  }
}
    `;
export const ModalOrderDataFragmentDoc = gql`
    fragment ModalOrderData on Order {
  id
  purchase_order_no
  date_of_order
  projects {
    id
  }
  brand {
    id
  }
  files {
    ...MediaModelParts
  }
  pdfFiles {
    ...MediaModelParts
  }
}
    ${MediaModelPartsFragmentDoc}`;
export const ProjectTitleFragmentDoc = gql`
    fragment ProjectTitle on Project {
  code
  numeric_code
  title
  billable
  brand {
    id
    name
    image {
      urls {
        thumbnail
      }
    }
  }
}
    `;
export const ArchivedProjectDataFragmentDoc = gql`
    fragment ArchivedProjectData on Project {
  id
  status
  archived_at
  archivedBy {
    id
    full_name
  }
}
    `;
export const FilterTemplateFragmentFragmentDoc = gql`
    fragment FilterTemplateFragment on FilterTemplate {
  id
  model_id
  model_type
  type
  name
  params
  user_id
}
    `;
export const WorkspaceAccountingAccountSettingsFragmentDoc = gql`
    fragment WorkspaceAccountingAccountSettings on WorkspaceAccountingAccountSettings {
  accounting_accounts {
    id
    account_number
    title
    accounting_type
    budget_categories {
      accounting_account_id
      budget_category_id
      budget_category_type
    }
  }
}
    `;
export const CostCenterFragmentDoc = gql`
    fragment CostCenter on AccountingCentre {
  id
  centre
  title
  type
  deleted_at
}
    `;
export const WorkspaceAccountingVatClassificationSettingFragmentDoc = gql`
    fragment WorkspaceAccountingVatClassificationSetting on WorkspaceAccountingVatClassificationSettings {
  accounting_vat_classifications {
    id
    centre
    title
    type
    vat_rate_id
    vatRate {
      id
      amount
    }
    deleted_at
  }
}
    `;
export const MeFragmentDoc = gql`
    fragment Me on User {
  id
  first_name
  last_name
  full_name
  email
  codename
  scope {
    value
  }
  enabled_two_factor_authentication
  image {
    urls {
      thumbnail
    }
  }
  profile {
    hex_color
    defaultWorktype {
      id
      title
      default_rate
    }
  }
  team {
    id
    name
  }
  roles {
    id
    name
    documentLimits {
      document_type
      limit
    }
  }
  permissions {
    bank_read_all
    brand_read
    brand_create
    brand_update
    brand_delete
    brand_archive
    brand_updateManagers
    client_read
    client_create
    client_update
    client_delete
    client_updateManagers
    contractor_read
    contractor_create
    contractor_update
    contractor_delete
    user_read_all
    user_read_own
    user_create
    user_scopeCreate
    user_update_all
    user_update_own
    user_updatePersonalData
    user_updateWorkData
    user_updateScopeUser
    user_updatePlanningData
    user_updateAllfredData
    user_delete
    user_haveProjectsAssigned
    user_profile_read
    user_profile_update
    user_password_update
    user_accessAccountingAttributes
    user_scope_all
    user_scope_own
    brandCreditAccount_read_all
    brandCreditAccount_read_team
    brandCreditAccount_read_own
    brandCreditAccount_create
    brandCreditAccount_update_all
    brandCreditAccount_update_team
    brandCreditAccount_update_own
    brandCreditAccount_delete_all
    brandCreditAccount_delete_team
    brandCreditAccount_delete_own
    brandCreditAccount_setBudgetCategories
    credit_transfer_fromBudgetItem
    credit_transfer_fromBrandCreditAccount
    credit_transfer_betweenTeams
    credit_transfer_withDate
    credit_prepayment
    contract_read
    contract_create
    contract_update
    contract_delete
    order_read
    order_create
    order_update
    order_delete
    otherDocument_read
    otherDocument_create
    otherDocument_update
    otherDocument_delete
    expense_read_all
    expense_read_own
    expense_read_team
    expense_read_excludeRestrictedTeams
    expense_create
    expense_update_all
    expense_update_own
    expense_update_team
    expense_delete_all
    expense_delete_own
    expense_delete_team
    expense_markAsPaid
    expense_deleteFiles
    expense_approve
    expense_accessAccountingAttributes
    expense_accessImported
    expense_canApproveBudgetItem
    expense_modelLock
    requestForInvoicing_read_all
    requestForInvoicing_read_own
    requestForInvoicing_read_team
    requestForInvoicing_create_all
    requestForInvoicing_create_own
    requestForInvoicing_create_team
    requestForInvoicing_update_all
    requestForInvoicing_update_own
    requestForInvoicing_update_team
    requestForInvoicing_delete_all
    requestForInvoicing_delete_own
    requestForInvoicing_delete_team
    requestForInvoicing_accessAccountingAttributes
    requestForInvoicing_querySubmittedCount_all
    requestForInvoicing_querySubmittedCount_own
    outgoingInvoice_read_all
    outgoingInvoice_read_own
    outgoingInvoice_read_team
    outgoingInvoice_create
    outgoingInvoice_update_all
    outgoingInvoice_update_own
    outgoingInvoice_update_team
    outgoingInvoice_delete_all
    outgoingInvoice_delete_own
    outgoingInvoice_delete_team
    outgoingInvoice_accessAccountingAttributes
    outgoingInvoice_markAsPaid
    outgoingInvoice_sendToClient
    outgoingInvoice_updateInvoiceNumber
    outgoingInvoice_modelLock
    project_accessAccountingAttributes
    project_viewAllFields
    project_read_all
    project_read_own
    project_read_team
    project_read_excludeRestrictedTeams
    project_create_all
    project_create_own
    project_create_team
    project_update_all
    project_update_own
    project_update_team
    project_delete_all
    project_delete_own
    project_delete_team
    project_pin_all
    project_pin_own
    project_pin_team
    project_finish_all
    project_finish_own
    project_finish_team
    project_reopen_all
    project_reopen_own
    project_reopen_team
    project_archive_all
    project_archive_own
    project_archive_team
    project_duplicate_all
    project_duplicate_own
    project_duplicate_team
    project_timeTrackingReport_read_all
    project_timeTrackingReport_read_own
    project_timeTrackingReport_read_team
    project_budget_update_all
    project_budget_update_own
    project_budget_update_team
    project_budget_completeExpenseBudgetItem_all
    project_budget_completeExpenseBudgetItem_own
    project_budget_completeExpenseBudgetItem_team
    project_budget_reopenExpenseBudgetItem_all
    project_budget_reopenExpenseBudgetItem_own
    project_budget_reopenExpenseBudgetItem_team
    project_lockBillingPlan
    project_billingTime_lock
    projectCategory_query
    projectCategory_create
    projectCategory_update
    projectCategory_delete
    wip_submit_all
    wip_submit_own
    wip_submit_team
    wip_lock_all
    wip_lock_own
    wip_lock_team
    wip_read_all
    wip_read_own
    wip_read_team
    wip_unlock_all
    wip_unlock_own
    wip_unlock_team
    wip_close_all
    wip_close_own
    wip_close_team
    wip_open_all
    wip_open_own
    wip_open_team
    timeTracking_read_all
    timeTracking_read_own
    timeTracking_read_team
    timeTracking_create_all
    timeTracking_create_own
    timeTracking_create_team
    timeTracking_update_all
    timeTracking_update_own
    timeTracking_update_team
    timeTracking_delete_all
    timeTracking_delete_own
    timeTracking_delete_team
    timeTracking_timer_use_all
    timeTracking_timer_use_own
    timeTracking_timer_use_team
    timeTracking_timer_use_manual
    timeTracking_report_read_all
    timeTracking_report_read_team
    timeTracking_report_read_own
    timeTracking_userMonthlyReport_read
    billingPlan_create
    billingPlan_update
    billingPlan_listing
    integration_budgetovac
    integration_forecasting
    task_viewAllFields
    task_read_all
    task_read_own
    task_create_all
    task_create_scoped
    task_update_all
    task_update_own
    task_update_scoped
    task_delete_all
    task_delete_own
    task_update_status_own
    task_update_status_all
    task_update_current_assignee_own
    task_update_current_assignee_all
    taskComment_create
    taskComment_update_own
    taskComment_update_all
    taskComment_delete_own
    taskComment_delete_all
    assignableFile_create
    assignableFile_delete_all
    assignableFile_delete_own
    planning_create_all
    planning_create_own
    planning_update_all
    planning_update_own
    planning_delete_all
    planning_delete_own
    planning_complete_all
    planning_complete_own
    planning_play_own
    planning_read_all
    planning_read_own
    planning_show_daily_capacity
    profitLossReport_query_all
    workspaceSetting_edit
    notificationSetting_query
    notificationSetting_update
    utilizationReport_query_all
    utilizationReport_query_own
    utilizationReport_query_team
    utilizationReportProfit_query_all
    budget_read_all
    budget_read_own
    budget_read_team
    quote_create_withoutInternalApproved
    quote_manualApprove
  }
}
    `;
export const VatRateOptionPartsFragmentDoc = gql`
    fragment VatRateOptionParts on VatRate {
  id
  amount
}
    `;
export const BudgetPdfSettingsFragmentDoc = gql`
    fragment BudgetPdfSettings on BudgetPdfSettings {
  show_hours
  show_disclaimer
  signature
  show_summary
  show_client_name
  show_client_details
  language
  our_work_show_commission
  title_page_with_vat
  workspace_company_id
  workspace_bank_account_id
  billing_entity_id
  hide_title_page
  add_billing_plan
  billing_plan_exchange_rate
  disclaimer {
    language
    disclaimer
  }
  our_work_positions
  our_work_view
  our_work_description
  our_work_vat_in_items
  our_work_show_discount
  expense_show_commission
  expense_show_quantity
  expense_show_unit
  expense_show_discount
  expense_show_description
  expense_show_vat_in_items
  show_client_and_brand
  show_project_name_full
  use_client_name_from_billing_entity
}
    `;
export const WorkspaceCompanyFragmentDoc = gql`
    fragment WorkspaceCompany on WorkspaceCompany {
  id
  name
  internal_name
  deleted
  currency_id
  country {
    id
  }
}
    `;
export const WorkspaceSettingsFragmentDoc = gql`
    fragment WorkspaceSettings on WorkspaceSettings {
  title
  setup_completed
  default_payment_due
  exchange_rate_denomination
  generate_numerical_brand_codes
  time_tracking_rate_type
  time_tracking_rate_length
  transfer_credit_directly_from_invoice
  require_two_factor_authentication
  invoicing_more_teams
  can_transfer_credit_with_date_without_constraints
  default_task_priority_id
  default_task_status_id
  automatically_approved_expense_items
  can_close_expense_budget_item_with_unapproved_expenses
  show_expense_item_vat_rate
  show_accounting_vat_classification
  trial_from
  unpaid_banner_message
  default_user_plannable_capacity
  specific_time_in_planning_enabled
  timetastic_integration
  working_from
  working_to
  planning_view_settings {
    name
    value
  }
  can_skip_invoice_date_validations
  show_done_tasks
  use_current_assignee
  planning_alphabet_user_order
  hide_expense_summary
  disable_home_office_in_planning
  hide_planning_total_daily_capacity
  start_day_of_week
  xero_enabled
  default_utilization_range_from
  default_utilization_range_to
  auto_deadline_in_tasks
  budget_xlsx_languages
  locale
  vapid_public_key
  default_show_unit_price_on_invoices
  default_show_billing_accounting_on_invoices
  automate_invoicing_plan_approval
  enable_bank
  bank_api_active
  enable_contractor_full_bank_account_data
  pipedrive_enabled
  expense_effectix_custom_cost_ratio
  partner_access_enabled
  enable_expense_email_import
  google_email_integration_enabled
  create_quote_only_after_approved_budgets
  show_smtp_settings
  show_mcp_settings
  brand_template_id
  enable_additional_brand_numeric_code
  show_amounts_in_time_tracking_report
  highlight_overtime_in_tasks
  enable_allocation_meeting_play
  auto_complete_allocation_types
  expense_identification_fields_required
  contractor_fields_extra_validation
  planned_expenses_show_client_price
  prevent_saving_duplicated_expenses
  financial_amount_by_percent
  enable_calendar_integration
  only_from_calendar_integration
  require_already_paid_subfields_for_drafts
  require_project_category
  country {
    id
    name
    code
  }
  currency {
    id
    denomination
    code
  }
  defaultVatRate {
    ...VatRateOptionParts
    deleted
    type
  }
  moduleSettings {
    billing_plan
    budgetovac
    clients
    contractors
    documents
    expenses
    invoices
    planovac
    projects
    reports
    time_tracking
    time_billing
  }
  exportSettings {
    expenses
    mrp
    pohoda
    premier
    proluc
    triad_project_effectiveness
    project_effectiveness
    project_progress_statistics
    project_status
    unpaid_outgoing_invoices
    mlggk_project_effectiveness
    xero
    vario
    transakcio
    omega
  }
  currencyExchangeRatesStructured {
    exchangeRates {
      id
      exchange_rate
      valid_from
      valid_to
    }
    currency {
      id
      code
      denomination
    }
  }
  budget_pdf_export_settings {
    ...BudgetPdfSettings
  }
  companies {
    ...WorkspaceCompany
    bankAccounts {
      id
      iban
      account_holder_name
      deleted
    }
  }
}
    ${VatRateOptionPartsFragmentDoc}
${BudgetPdfSettingsFragmentDoc}
${WorkspaceCompanyFragmentDoc}`;
export const ProjectStageFragmentDoc = gql`
    fragment ProjectStage on ProjectStage {
  id
  name
  system_name
}
    `;
export const StarFragmentDoc = gql`
    fragment Star on Star {
  id
  starable_id
  starable_type
  created_at
  updated_at
}
    `;
export const TagFragmentDoc = gql`
    fragment Tag on Tag {
  id
  title
}
    `;
export const SubscribeToPushNotificationsDocument = gql`
    mutation SubscribeToPushNotifications($endpoint: String!, $keys: PushNotificationSubscriptionKeys!) {
  subscribeToPushNotifications(endpoint: $endpoint, keys: $keys)
}
    `;

export function useSubscribeToPushNotificationsMutation() {
  return Urql.useMutation<SubscribeToPushNotificationsMutation, SubscribeToPushNotificationsMutationVariables>(SubscribeToPushNotificationsDocument);
};
export const UnsubscribeToPushNotificationsDocument = gql`
    mutation UnsubscribeToPushNotifications($endpoint: String!) {
  unsubscribeFromPushNotifications(endpoint: $endpoint)
}
    `;

export function useUnsubscribeToPushNotificationsMutation() {
  return Urql.useMutation<UnsubscribeToPushNotificationsMutation, UnsubscribeToPushNotificationsMutationVariables>(UnsubscribeToPushNotificationsDocument);
};
export const AddManualAccountMoveDocument = gql`
    mutation AddManualAccountMove($amount: BigInt!, $currencyId: ID!, $note: String!, $date: Date!) {
  addManualAccountMove(
    amount: $amount
    currency_id: $currencyId
    note: $note
    date: $date
  ) {
    ...AccountMove
  }
}
    ${AccountMoveFragmentDoc}`;

export function useAddManualAccountMoveMutation() {
  return Urql.useMutation<AddManualAccountMoveMutation, AddManualAccountMoveMutationVariables>(AddManualAccountMoveDocument);
};
export const BankAccountsForPaymentsDocument = gql`
    query BankAccountsForPayments {
  bankAccounts {
    id
    workspace_bank_account_id
    iban
    name
  }
}
    `;

export function useBankAccountsForPaymentsQuery(options?: Omit<Urql.UseQueryArgs<BankAccountsForPaymentsQueryVariables>, 'query'>) {
  return Urql.useQuery<BankAccountsForPaymentsQuery, BankAccountsForPaymentsQueryVariables>({ query: BankAccountsForPaymentsDocument, ...options });
};
export const AddDocumentsToAccountMoveDocument = gql`
    mutation AddDocumentsToAccountMove($bankAccountMoveId: ID!, $documents: [BankAccountMoveDocumentInput!]!) {
  addDocumentsToAccountMove(
    bank_account_move_id: $bankAccountMoveId
    documents: $documents
  ) {
    ...AccountMove
  }
}
    ${AccountMoveFragmentDoc}`;

export function useAddDocumentsToAccountMoveMutation() {
  return Urql.useMutation<AddDocumentsToAccountMoveMutation, AddDocumentsToAccountMoveMutationVariables>(AddDocumentsToAccountMoveDocument);
};
export const ExpensesForPaymentMatchDocument = gql`
    query ExpensesForPaymentMatch($page: Int, $first: Int, $filters: ExpenseQueryArgs) {
  expenses(page: $page, first: $first, filters: $filters) {
    data {
      id
      expense_no
      type
      invoice_status
      paid_at
      date_of_supply
      due_date
      has_master_agreement
      contractor {
        id
        legal_name
      }
      projects {
        id
        code
        title
      }
      workspace_company_id
      variable_symbol
      iban
      exchange_rate
      stats {
        total_amount
        total_amount_without_vat_in_currency
        total_amount_with_vat_in_currency
      }
      accountMoves {
        amount
      }
      currency {
        id
        code
        denomination
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

export function useExpensesForPaymentMatchQuery(options?: Omit<Urql.UseQueryArgs<ExpensesForPaymentMatchQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpensesForPaymentMatchQuery, ExpensesForPaymentMatchQueryVariables>({ query: ExpensesForPaymentMatchDocument, ...options });
};
export const InvoicesForPaymentMatchDocument = gql`
    query InvoicesForPaymentMatch($page: Int, $first: Int, $filters: OIQueryArgs) {
  outgoingInvoices(page: $page, first: $first, filters: $filters) {
    data {
      id
      invoice_no
      abraflexi_exported
      xero_exported
      type
      paid_at
      emailLogs {
        ...EmailLog
      }
      brands {
        id
        name
      }
      billingEntity {
        legal_name
        street
        city
      }
      projects {
        id
        title
        code
      }
      currency {
        id
        code
        denomination
      }
      exchange_rate
      stats {
        total_amount_with_vat_in_currency
        billing_amount_in_currency
        billing_amount_with_vat_in_currency
      }
      accountMoves {
        amount
      }
      issue_date
      relatesToOutgoingProformaInvoice {
        invoicePdf {
          preview
        }
      }
      invoicePdf {
        preview
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${EmailLogFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useInvoicesForPaymentMatchQuery(options?: Omit<Urql.UseQueryArgs<InvoicesForPaymentMatchQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoicesForPaymentMatchQuery, InvoicesForPaymentMatchQueryVariables>({ query: InvoicesForPaymentMatchDocument, ...options });
};
export const ProformasForPaymentMatchDocument = gql`
    query ProformasForPaymentMatch($page: Int, $first: Int, $filters: OIProformaQueryArgs) {
  outgoingProformaInvoices(page: $page, first: $first, filters: $filters) {
    data {
      id
      invoice_no
      abraflexi_exported
      paid_at
      emailLogs {
        ...EmailLog
      }
      brands {
        id
        name
      }
      billingEntity {
        legal_name
        street
        city
      }
      projects {
        id
        title
        code
      }
      currency {
        id
        code
        denomination
      }
      exchange_rate
      stats {
        total_amount_with_vat_in_currency
      }
      accountMoves {
        amount
      }
      issue_date
      proofOfPayments {
        id
        invoice_no
        invoicePdf {
          preview
        }
      }
      invoicePdf {
        preview
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${EmailLogFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useProformasForPaymentMatchQuery(options?: Omit<Urql.UseQueryArgs<ProformasForPaymentMatchQueryVariables>, 'query'>) {
  return Urql.useQuery<ProformasForPaymentMatchQuery, ProformasForPaymentMatchQueryVariables>({ query: ProformasForPaymentMatchDocument, ...options });
};
export const MatchPaymentModalFilterOptionsDocument = gql`
    query MatchPaymentModalFilterOptions {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projectManagerSimpleMap {
    id
    full_name
    codename
  }
}
    `;

export function useMatchPaymentModalFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<MatchPaymentModalFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<MatchPaymentModalFilterOptionsQuery, MatchPaymentModalFilterOptionsQueryVariables>({ query: MatchPaymentModalFilterOptionsDocument, ...options });
};
export const ExcludeAccountMoveDocument = gql`
    mutation ExcludeAccountMove($accountMoveId: ID!) {
  excludeBankAccountMove(bank_account_move_id: $accountMoveId) {
    ...AccountMove
  }
}
    ${AccountMoveFragmentDoc}`;

export function useExcludeAccountMoveMutation() {
  return Urql.useMutation<ExcludeAccountMoveMutation, ExcludeAccountMoveMutationVariables>(ExcludeAccountMoveDocument);
};
export const BankAccountMovesDocument = gql`
    query BankAccountMoves($filters: BankAccountMoveQueryArgs, $first: Int, $page: Int) {
  bankAccountMoves(filters: $filters, first: $first, page: $page) {
    data {
      ...AccountMove
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${AccountMoveFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useBankAccountMovesQuery(options?: Omit<Urql.UseQueryArgs<BankAccountMovesQueryVariables>, 'query'>) {
  return Urql.useQuery<BankAccountMovesQuery, BankAccountMovesQueryVariables>({ query: BankAccountMovesDocument, ...options });
};
export const CreateBillingEntityDocument = gql`
    mutation CreateBillingEntity($input: CreateBillingEntityInput!) {
  createBillingEntity(input: $input) {
    ...BillingEntityModal
  }
}
    ${BillingEntityModalFragmentDoc}`;

export function useCreateBillingEntityMutation() {
  return Urql.useMutation<CreateBillingEntityMutation, CreateBillingEntityMutationVariables>(CreateBillingEntityDocument);
};
export const UpdateBillingEntityDocument = gql`
    mutation UpdateBillingEntity($input: UpdateBillingEntityInput!) {
  updateBillingEntity(input: $input) {
    ...BillingEntityModal
  }
}
    ${BillingEntityModalFragmentDoc}`;

export function useUpdateBillingEntityMutation() {
  return Urql.useMutation<UpdateBillingEntityMutation, UpdateBillingEntityMutationVariables>(UpdateBillingEntityDocument);
};
export const OptionsForBillingEntityDocument = gql`
    query OptionsForBillingEntity {
  countrySimpleMap {
    id
    name
  }
  languagesForInvoicePdf
}
    `;

export function useOptionsForBillingEntityQuery(options?: Omit<Urql.UseQueryArgs<OptionsForBillingEntityQueryVariables>, 'query'>) {
  return Urql.useQuery<OptionsForBillingEntityQuery, OptionsForBillingEntityQueryVariables>({ query: OptionsForBillingEntityDocument, ...options });
};
export const CreateBrandDocument = gql`
    mutation CreateBrand($input: CreateBrandInput!) {
  createBrand(input: $input) {
    ...BrandModal
  }
}
    ${BrandModalFragmentDoc}`;

export function useCreateBrandMutation() {
  return Urql.useMutation<CreateBrandMutation, CreateBrandMutationVariables>(CreateBrandDocument);
};
export const UpdateBrandDocument = gql`
    mutation UpdateBrand($input: UpdateBrandInput!) {
  updateBrand(input: $input) {
    ...BrandModal
  }
}
    ${BrandModalFragmentDoc}`;

export function useUpdateBrandMutation() {
  return Urql.useMutation<UpdateBrandMutation, UpdateBrandMutationVariables>(UpdateBrandDocument);
};
export const GetNextNumericalBrandCodeDocument = gql`
    query GetNextNumericalBrandCode {
  getNextNumericalBrandCode
}
    `;

export function useGetNextNumericalBrandCodeQuery(options?: Omit<Urql.UseQueryArgs<GetNextNumericalBrandCodeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNextNumericalBrandCodeQuery, GetNextNumericalBrandCodeQueryVariables>({ query: GetNextNumericalBrandCodeDocument, ...options });
};
export const ClientOptionsForModalBrandDocument = gql`
    query ClientOptionsForModalBrand {
  clientsSimpleMap {
    id
    name
  }
}
    `;

export function useClientOptionsForModalBrandQuery(options?: Omit<Urql.UseQueryArgs<ClientOptionsForModalBrandQueryVariables>, 'query'>) {
  return Urql.useQuery<ClientOptionsForModalBrandQuery, ClientOptionsForModalBrandQueryVariables>({ query: ClientOptionsForModalBrandDocument, ...options });
};
export const BillingEntityOptionsForModalBrandDocument = gql`
    query BillingEntityOptionsForModalBrand($client_id: ID!) {
  client(id: $client_id) {
    id
    name
    billingEntities {
      id
      internal_name
    }
    workspaceCompany {
      id
    }
  }
}
    `;

export function useBillingEntityOptionsForModalBrandQuery(options: Omit<Urql.UseQueryArgs<BillingEntityOptionsForModalBrandQueryVariables>, 'query'>) {
  return Urql.useQuery<BillingEntityOptionsForModalBrandQuery, BillingEntityOptionsForModalBrandQueryVariables>({ query: BillingEntityOptionsForModalBrandDocument, ...options });
};
export const GetBrandForCreditAccountsDocument = gql`
    query GetBrandForCreditAccounts($id: ID!) {
  brand(id: $id) {
    id
    name
    code
    image {
      urls {
        thumbnail
      }
    }
    client {
      id
      name
    }
  }
}
    `;

export function useGetBrandForCreditAccountsQuery(options: Omit<Urql.UseQueryArgs<GetBrandForCreditAccountsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBrandForCreditAccountsQuery, GetBrandForCreditAccountsQueryVariables>({ query: GetBrandForCreditAccountsDocument, ...options });
};
export const UpdateTimeTrackingRatesForBrandDocument = gql`
    mutation UpdateTimeTrackingRatesForBrand($input: UpdateTimeTrackingRatesForBrandInput!) {
  updateTimeTrackingRatesForBrand(input: $input) {
    id
    average_time_tracking_rate
    timeTrackingRates {
      rate
      timeTrackingWorkType {
        id
        default_rate
        title
      }
    }
  }
}
    `;

export function useUpdateTimeTrackingRatesForBrandMutation() {
  return Urql.useMutation<UpdateTimeTrackingRatesForBrandMutation, UpdateTimeTrackingRatesForBrandMutationVariables>(UpdateTimeTrackingRatesForBrandDocument);
};
export const BrandDetailDocument = gql`
    query BrandDetail($id: ID!) {
  clientsSimpleMap {
    id
    name
  }
  brand(id: $id) {
    id
    name
    code
    numeric_code
    cloudUrl
    driveCloudUrl
    image {
      urls {
        thumbnail
      }
    }
    archived_at
    responsiblePerson {
      id
    }
    otherResponsiblePersons {
      id
    }
    defaultBillingEntity {
      id
    }
    pipedriveCustomFieldValues {
      ...PipedriveCustomField
    }
    client {
      id
      name
      billingEntities {
        id
        internal_name
      }
      responsiblePerson {
        id
      }
      otherResponsiblePersons {
        id
      }
    }
    users {
      id
      codename
      first_name
      last_name
      full_name
      email
      scope {
        value
      }
      scope_access
    }
    contacts {
      id
      first_name
      last_name
      phone
      email
      pipedriveCustomFieldValues {
        ...PipedriveCustomField
      }
    }
    timeTrackingRates {
      rate
      timeTrackingWorkType {
        id
        default_rate
        title
      }
    }
    average_time_tracking_rate
    calculated_average_time_tracking_rate
  }
  timeTrackingWorkTypes {
    id
    default_rate
    title
  }
}
    ${PipedriveCustomFieldFragmentDoc}`;

export function useBrandDetailQuery(options: Omit<Urql.UseQueryArgs<BrandDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<BrandDetailQuery, BrandDetailQueryVariables>({ query: BrandDetailDocument, ...options });
};
export const GetBrandForDocumentsDocument = gql`
    query GetBrandForDocuments($id: ID!) {
  brand(id: $id) {
    id
    name
    image {
      urls {
        thumbnail
      }
    }
    code
    client {
      id
      name
    }
  }
}
    `;

export function useGetBrandForDocumentsQuery(options: Omit<Urql.UseQueryArgs<GetBrandForDocumentsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBrandForDocumentsQuery, GetBrandForDocumentsQueryVariables>({ query: GetBrandForDocumentsDocument, ...options });
};
export const GetBrandsDocument = gql`
    query GetBrands($page: Int, $first: Int, $filters: BrandQueryArgs) {
  clientsSimpleMap {
    id
    name
  }
  contacts {
    id
    first_name
    last_name
  }
  brandsSummary(filters: $filters) {
    brandIds
  }
  brands(page: $page, first: $first, filters: $filters) {
    data {
      id
      name
      code
      archived_at
      image {
        urls {
          thumbnail
        }
      }
      client {
        id
        name
      }
      contacts {
        id
        first_name
        last_name
      }
      creditAccounts {
        id
      }
      defaultBillingEntity {
        id
      }
      pipedriveCustomFieldValues {
        ...PipedriveCustomField
      }
      stats {
        active_projects
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PipedriveCustomFieldFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useGetBrandsQuery(options?: Omit<Urql.UseQueryArgs<GetBrandsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBrandsQuery, GetBrandsQueryVariables>({ query: GetBrandsDocument, ...options });
};
export const DeleteBrandDocument = gql`
    mutation DeleteBrand($id: ID!) {
  deleteBrand(id: $id) {
    id
  }
}
    `;

export function useDeleteBrandMutation() {
  return Urql.useMutation<DeleteBrandMutation, DeleteBrandMutationVariables>(DeleteBrandDocument);
};
export const ArchiveBrandDocument = gql`
    mutation ArchiveBrand($id: ID!) {
  archiveBrand(id: $id) {
    id
  }
}
    `;

export function useArchiveBrandMutation() {
  return Urql.useMutation<ArchiveBrandMutation, ArchiveBrandMutationVariables>(ArchiveBrandDocument);
};
export const UnarchiveBrandDocument = gql`
    mutation UnarchiveBrand($id: ID!) {
  unarchiveBrand(id: $id) {
    id
  }
}
    `;

export function useUnarchiveBrandMutation() {
  return Urql.useMutation<UnarchiveBrandMutation, UnarchiveBrandMutationVariables>(UnarchiveBrandDocument);
};
export const PreviewQuoteDocument = gql`
    mutation PreviewQuote($input: quoteInput!) {
  previewQuote(input: $input) {
    url
  }
}
    `;

export function usePreviewQuoteMutation() {
  return Urql.useMutation<PreviewQuoteMutation, PreviewQuoteMutationVariables>(PreviewQuoteDocument);
};
export const SaveQuoteDocument = gql`
    mutation SaveQuote($input: quoteInput!) {
  saveQuote(input: $input) {
    id
    url
  }
}
    `;

export function useSaveQuoteMutation() {
  return Urql.useMutation<SaveQuoteMutation, SaveQuoteMutationVariables>(SaveQuoteDocument);
};
export const GetQuoteDocument = gql`
    query GetQuote($id: ID!) {
  GetQuote(id: $id) {
    id
    settings {
      ...BudgetPdfSettings
      date
      valid_until
    }
    url
    number
    status
    total_amount
    currency {
      id
      code
      denomination
      exchange_rate
    }
    budgets {
      id
      project {
        id
        title
      }
      brand {
        id
        name
      }
      account_manager
      assignment_date
      status
      client_approved
      price
      currency {
        id
        code
        denomination
        exchange_rate
      }
    }
    sent_to_client_date
    client_approval_date
    Client {
      billingEntities {
        id
        internal_name
        street
        city
        workspaceCompany {
          id
          deleted
        }
      }
    }
  }
}
    ${BudgetPdfSettingsFragmentDoc}`;

export function useGetQuoteQuery(options: Omit<Urql.UseQueryArgs<GetQuoteQueryVariables>, 'query'>) {
  return Urql.useQuery<GetQuoteQuery, GetQuoteQueryVariables>({ query: GetQuoteDocument, ...options });
};
export const CreateQuoteDocument = gql`
    mutation CreateQuote($budget_ids: [ID]!) {
  createQuote(budget_ids: $budget_ids) {
    id
    url
  }
}
    `;

export function useCreateQuoteMutation() {
  return Urql.useMutation<CreateQuoteMutation, CreateQuoteMutationVariables>(CreateQuoteDocument);
};
export const BudgetsExportDocument = gql`
    query BudgetsExport($ids: [ID], $options: BudgetExportOptionsInput) {
  budgetsExport(ids: $ids, options: $options)
}
    `;

export function useBudgetsExportQuery(options?: Omit<Urql.UseQueryArgs<BudgetsExportQueryVariables>, 'query'>) {
  return Urql.useQuery<BudgetsExportQuery, BudgetsExportQueryVariables>({ query: BudgetsExportDocument, ...options });
};
export const BudgetsFilterOptionsDocument = gql`
    query BudgetsFilterOptions {
  brandsSimpleMap {
    id
    name
  }
  projectsSimpleMap {
    id
    title
    code
  }
}
    `;

export function useBudgetsFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<BudgetsFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<BudgetsFilterOptionsQuery, BudgetsFilterOptionsQueryVariables>({ query: BudgetsFilterOptionsDocument, ...options });
};
export const GetBudgetsDocument = gql`
    query GetBudgets($filters: BudgetArgs) {
  budgets(filters: $filters) {
    data {
      ...BudgetGroup
    }
    allIds
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${BudgetGroupFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useGetBudgetsQuery(options?: Omit<Urql.UseQueryArgs<GetBudgetsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBudgetsQuery, GetBudgetsQueryVariables>({ query: GetBudgetsDocument, ...options });
};
export const CreateBudgetovacPositionsSetDocument = gql`
    mutation CreateBudgetovacPositionsSet($input: CreateBudgetovacPositionsSetInput!) {
  createBudgetovacPositionsSet(input: $input) {
    id
  }
}
    `;

export function useCreateBudgetovacPositionsSetMutation() {
  return Urql.useMutation<CreateBudgetovacPositionsSetMutation, CreateBudgetovacPositionsSetMutationVariables>(CreateBudgetovacPositionsSetDocument);
};
export const UpdateBudgetovacPositionsSetDocument = gql`
    mutation UpdateBudgetovacPositionsSet($input: UpdateBudgetovacPositionsSetInput!) {
  updateBudgetovacPositionsSet(input: $input) {
    id
  }
}
    `;

export function useUpdateBudgetovacPositionsSetMutation() {
  return Urql.useMutation<UpdateBudgetovacPositionsSetMutation, UpdateBudgetovacPositionsSetMutationVariables>(UpdateBudgetovacPositionsSetDocument);
};
export const DeleteBudgetovacPositionsSetDocument = gql`
    mutation DeleteBudgetovacPositionsSet($id: ID!) {
  deleteBudgetovacPositionsSet(id: $id) {
    id
  }
}
    `;

export function useDeleteBudgetovacPositionsSetMutation() {
  return Urql.useMutation<DeleteBudgetovacPositionsSetMutation, DeleteBudgetovacPositionsSetMutationVariables>(DeleteBudgetovacPositionsSetDocument);
};
export const SetActiveBudgetovacPositionsSetDocument = gql`
    mutation SetActiveBudgetovacPositionsSet($id: ID!, $active: Boolean!) {
  setActiveBudgetovacPositionsSet(id: $id, active: $active) {
    id
  }
}
    `;

export function useSetActiveBudgetovacPositionsSetMutation() {
  return Urql.useMutation<SetActiveBudgetovacPositionsSetMutation, SetActiveBudgetovacPositionsSetMutationVariables>(SetActiveBudgetovacPositionsSetDocument);
};
export const BudgetovacPositionsSetsDocument = gql`
    query BudgetovacPositionsSets($client_id: ID, $search: String) {
  budgetovacPositionsSets(client_id: $client_id, search: $search) {
    client_id
    brand {
      code
      name
    }
    budgetovacPositionSets {
      ...BudgetovacPositionsSet
    }
  }
}
    ${BudgetovacPositionsSetFragmentDoc}`;

export function useBudgetovacPositionsSetsQuery(options?: Omit<Urql.UseQueryArgs<BudgetovacPositionsSetsQueryVariables>, 'query'>) {
  return Urql.useQuery<BudgetovacPositionsSetsQuery, BudgetovacPositionsSetsQueryVariables>({ query: BudgetovacPositionsSetsDocument, ...options });
};
export const BudgetovacPositionsSetDocument = gql`
    query BudgetovacPositionsSet($id: ID!) {
  budgetovacPositionsSet(id: $id) {
    ...BudgetovacPositionsSet
  }
}
    ${BudgetovacPositionsSetFragmentDoc}`;

export function useBudgetovacPositionsSetQuery(options: Omit<Urql.UseQueryArgs<BudgetovacPositionsSetQueryVariables>, 'query'>) {
  return Urql.useQuery<BudgetovacPositionsSetQuery, BudgetovacPositionsSetQueryVariables>({ query: BudgetovacPositionsSetDocument, ...options });
};
export const BudgetovacPositionsSetModalDependenciesDocument = gql`
    query BudgetovacPositionsSetModalDependencies {
  budgetovacPositions {
    ...BudgetovacPosition
    alias
    price
    is_default
  }
  ourWorkBudgetCategories {
    id
    name
  }
  brandsSimpleMap {
    id
    name
  }
}
    ${BudgetovacPositionFragmentDoc}`;

export function useBudgetovacPositionsSetModalDependenciesQuery(options?: Omit<Urql.UseQueryArgs<BudgetovacPositionsSetModalDependenciesQueryVariables>, 'query'>) {
  return Urql.useQuery<BudgetovacPositionsSetModalDependenciesQuery, BudgetovacPositionsSetModalDependenciesQueryVariables>({ query: BudgetovacPositionsSetModalDependenciesDocument, ...options });
};
export const CreateBudgetovacPositionDocument = gql`
    mutation CreateBudgetovacPosition($input: CreateBudgetovacPositionInput!) {
  createBudgetovacPosition(input: $input) {
    ...BudgetovacPosition
    alias
    price
    is_default
  }
}
    ${BudgetovacPositionFragmentDoc}`;

export function useCreateBudgetovacPositionMutation() {
  return Urql.useMutation<CreateBudgetovacPositionMutation, CreateBudgetovacPositionMutationVariables>(CreateBudgetovacPositionDocument);
};
export const UpdateBudgetovacPositionDocument = gql`
    mutation UpdateBudgetovacPosition($input: UpdateBudgetovacPositionInput!) {
  updateBudgetovacPosition(input: $input) {
    id
  }
}
    `;

export function useUpdateBudgetovacPositionMutation() {
  return Urql.useMutation<UpdateBudgetovacPositionMutation, UpdateBudgetovacPositionMutationVariables>(UpdateBudgetovacPositionDocument);
};
export const DeleteBudgetovacPositionDocument = gql`
    mutation DeleteBudgetovacPosition($id: ID!) {
  deleteBudgetovacPosition(id: $id) {
    id
  }
}
    `;

export function useDeleteBudgetovacPositionMutation() {
  return Urql.useMutation<DeleteBudgetovacPositionMutation, DeleteBudgetovacPositionMutationVariables>(DeleteBudgetovacPositionDocument);
};
export const BudgetovacPositionsDocument = gql`
    query BudgetovacPositions {
  budgetovacPositions {
    ...BudgetovacPosition
  }
}
    ${BudgetovacPositionFragmentDoc}`;

export function useBudgetovacPositionsQuery(options?: Omit<Urql.UseQueryArgs<BudgetovacPositionsQueryVariables>, 'query'>) {
  return Urql.useQuery<BudgetovacPositionsQuery, BudgetovacPositionsQueryVariables>({ query: BudgetovacPositionsDocument, ...options });
};
export const BudgetovacDepartmentsDocument = gql`
    query BudgetovacDepartments {
  ourWorkBudgetCategories {
    id
    name
  }
}
    `;

export function useBudgetovacDepartmentsQuery(options?: Omit<Urql.UseQueryArgs<BudgetovacDepartmentsQueryVariables>, 'query'>) {
  return Urql.useQuery<BudgetovacDepartmentsQuery, BudgetovacDepartmentsQueryVariables>({ query: BudgetovacDepartmentsDocument, ...options });
};
export const DeleteQuoteDocument = gql`
    mutation DeleteQuote($id: ID!) {
  deleteQuote(id: $id)
}
    `;

export function useDeleteQuoteMutation() {
  return Urql.useMutation<DeleteQuoteMutation, DeleteQuoteMutationVariables>(DeleteQuoteDocument);
};
export const ManualApproveQuoteDocument = gql`
    mutation ManualApproveQuote($id: ID!) {
  manualApproveQuote(id: $id) {
    id
    status
    client_approval_date
  }
}
    `;

export function useManualApproveQuoteMutation() {
  return Urql.useMutation<ManualApproveQuoteMutation, ManualApproveQuoteMutationVariables>(ManualApproveQuoteDocument);
};
export const GetBudgetQuotesDocument = gql`
    query GetBudgetQuotes($filters: QuotesArgs) {
  getBudgetQuotes(filters: $filters) {
    data {
      id
      settings {
        date
      }
      budgets {
        id
        project_id
        project {
          id
          title
        }
        brand {
          id
          name
        }
        description
        account_manager
        assignment_date
        status
        internally_approved
        client_approved
        is_active
        version
        price
        temporaryBrand {
          name
        }
        temporary_project_id
        temporaryProject {
          name
          is_archived
        }
        currency {
          id
          code
          denomination
        }
        created_at
        updated_at
      }
      url
      number
      status
      client_approval_date
      sent_to_client_date
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

export function useGetBudgetQuotesQuery(options?: Omit<Urql.UseQueryArgs<GetBudgetQuotesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBudgetQuotesQuery, GetBudgetQuotesQueryVariables>({ query: GetBudgetQuotesDocument, ...options });
};
export const GetClientDocument = gql`
    query GetClient($id: ID!) {
  client(id: $id) {
    name
    image {
      urls {
        thumbnail
      }
    }
    brands {
      id
    }
  }
}
    `;

export function useGetClientQuery(options: Omit<Urql.UseQueryArgs<GetClientQueryVariables>, 'query'>) {
  return Urql.useQuery<GetClientQuery, GetClientQueryVariables>({ query: GetClientDocument, ...options });
};
export const DeleteBillingEntityDocument = gql`
    mutation DeleteBillingEntity($id: ID!) {
  deleteBillingEntity(id: $id) {
    id
  }
}
    `;

export function useDeleteBillingEntityMutation() {
  return Urql.useMutation<DeleteBillingEntityMutation, DeleteBillingEntityMutationVariables>(DeleteBillingEntityDocument);
};
export const DeleteContactDocument = gql`
    mutation DeleteContact($id: ID!) {
  deleteContact(id: $id) {
    id
  }
}
    `;

export function useDeleteContactMutation() {
  return Urql.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument);
};
export const UpdateClientDocument = gql`
    mutation UpdateClient($input: UpdateClientInput!) {
  updateClient(input: $input) {
    id
    name
    image {
      urls {
        thumbnail
      }
    }
    workspaceCompany {
      ...WorkspaceCompany
    }
  }
}
    ${WorkspaceCompanyFragmentDoc}`;

export function useUpdateClientMutation() {
  return Urql.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument);
};
export const DeleteClientDocument = gql`
    mutation DeleteClient($id: ID!) {
  deleteClient(id: $id) {
    id
  }
}
    `;

export function useDeleteClientMutation() {
  return Urql.useMutation<DeleteClientMutation, DeleteClientMutationVariables>(DeleteClientDocument);
};
export const CreateClientDocument = gql`
    mutation CreateClient($input: CreateClientInput!) {
  createClient(input: $input) {
    id
    name
    image {
      urls {
        thumbnail
      }
    }
    workspaceCompany {
      ...WorkspaceCompany
    }
  }
}
    ${WorkspaceCompanyFragmentDoc}`;

export function useCreateClientMutation() {
  return Urql.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument);
};
export const ClientDetailDocument = gql`
    query ClientDetail($id: ID!) {
  client(id: $id) {
    id
    name
    cloudUrl
    driveCloudUrl
    image {
      urls {
        thumbnail
      }
    }
    workspaceCompany {
      ...WorkspaceCompany
    }
    responsiblePerson {
      id
    }
    otherResponsiblePersons {
      id
    }
    brands {
      id
      name
      archived_at
      image {
        urls {
          thumbnail
        }
      }
      code
      defaultBillingEntity {
        id
      }
      pipedriveCustomFieldValues {
        ...PipedriveCustomField
      }
    }
    billingEntities {
      ...BillingEntityModal
    }
    contacts {
      id
      first_name
      last_name
      email
      phone
    }
    currencyExchangeRates(onlyActive: true) {
      id
      exchange_rate
      currency {
        id
        code
        denomination
      }
    }
    currencyExchangeRatesStructured {
      exchangeRates {
        id
        exchange_rate
        valid_from
        valid_to
      }
      currency {
        id
        code
        denomination
      }
    }
  }
  currencies {
    id
    code
  }
  countrySimpleMap {
    id
    name
  }
}
    ${WorkspaceCompanyFragmentDoc}
${PipedriveCustomFieldFragmentDoc}
${BillingEntityModalFragmentDoc}`;

export function useClientDetailQuery(options: Omit<Urql.UseQueryArgs<ClientDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<ClientDetailQuery, ClientDetailQueryVariables>({ query: ClientDetailDocument, ...options });
};
export const ClientFilterOptionsDocument = gql`
    query ClientFilterOptions($orderBy: [QueryContactsOrderByOrderByClause!]) {
  contacts(orderBy: $orderBy) {
    id
    first_name
    last_name
  }
  responsiblePersonsSimpleMap {
    id
    full_name
  }
  brandsSimpleMap {
    id
    name
  }
}
    `;

export function useClientFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<ClientFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ClientFilterOptionsQuery, ClientFilterOptionsQueryVariables>({ query: ClientFilterOptionsDocument, ...options });
};
export const GetClientsDocument = gql`
    query GetClients($page: Int, $first: Int, $onlyActive: Boolean, $filters: ClientQueryArgs) {
  clients(first: $first, page: $page, filters: $filters) {
    data {
      id
      name
      image {
        urls {
          thumbnail
        }
      }
      workspaceCompany {
        ...WorkspaceCompany
      }
      brands {
        id
        name
        projects(onlyActive: $onlyActive) {
          id
        }
      }
      responsiblePerson {
        id
        full_name
        image {
          urls {
            thumbnail
          }
        }
      }
      contacts {
        first_name
        last_name
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${WorkspaceCompanyFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useGetClientsQuery(options?: Omit<Urql.UseQueryArgs<GetClientsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetClientsQuery, GetClientsQueryVariables>({ query: GetClientsDocument, ...options });
};
export const AbraFlexiOiExportDocument = gql`
    query AbraFlexiOIExport($from: Date, $to: Date) {
  abraFlexiOIExport(from: $from, to: $to)
}
    `;

export function useAbraFlexiOiExportQuery(options?: Omit<Urql.UseQueryArgs<AbraFlexiOiExportQueryVariables>, 'query'>) {
  return Urql.useQuery<AbraFlexiOiExportQuery, AbraFlexiOiExportQueryVariables>({ query: AbraFlexiOiExportDocument, ...options });
};
export const AbraFlexiOutgoingProformaInvoicesExportDocument = gql`
    query AbraFlexiOutgoingProformaInvoicesExport($from: Date, $to: Date) {
  abraFlexiOutgoingProformaInvoicesExport(from: $from, to: $to)
}
    `;

export function useAbraFlexiOutgoingProformaInvoicesExportQuery(options?: Omit<Urql.UseQueryArgs<AbraFlexiOutgoingProformaInvoicesExportQueryVariables>, 'query'>) {
  return Urql.useQuery<AbraFlexiOutgoingProformaInvoicesExportQuery, AbraFlexiOutgoingProformaInvoicesExportQueryVariables>({ query: AbraFlexiOutgoingProformaInvoicesExportDocument, ...options });
};
export const ExpenseAbraFlexiExportDocument = gql`
    query ExpenseAbraFlexiExport($from: Date, $to: Date) {
  expenseAbraFlexiExport(from: $from, to: $to)
}
    `;

export function useExpenseAbraFlexiExportQuery(options?: Omit<Urql.UseQueryArgs<ExpenseAbraFlexiExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseAbraFlexiExportQuery, ExpenseAbraFlexiExportQueryVariables>({ query: ExpenseAbraFlexiExportDocument, ...options });
};
export const FinancialOiExportDocument = gql`
    query financialOIExport($from: Date, $to: Date) {
  financialOIExport(from: $from, to: $to)
}
    `;

export function useFinancialOiExportQuery(options?: Omit<Urql.UseQueryArgs<FinancialOiExportQueryVariables>, 'query'>) {
  return Urql.useQuery<FinancialOiExportQuery, FinancialOiExportQueryVariables>({ query: FinancialOiExportDocument, ...options });
};
export const ExpenseXeroExportDocument = gql`
    query ExpenseXeroExport($from: Date, $to: Date) {
  expenseXeroExport(from: $from, to: $to)
}
    `;

export function useExpenseXeroExportQuery(options?: Omit<Urql.UseQueryArgs<ExpenseXeroExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseXeroExportQuery, ExpenseXeroExportQueryVariables>({ query: ExpenseXeroExportDocument, ...options });
};
export const OutgoingInvoiceXeroExportDocument = gql`
    query OutgoingInvoiceXeroExport($from: Date, $to: Date) {
  xeroOIExport(from: $from, to: $to)
}
    `;

export function useOutgoingInvoiceXeroExportQuery(options?: Omit<Urql.UseQueryArgs<OutgoingInvoiceXeroExportQueryVariables>, 'query'>) {
  return Urql.useQuery<OutgoingInvoiceXeroExportQuery, OutgoingInvoiceXeroExportQueryVariables>({ query: OutgoingInvoiceXeroExportDocument, ...options });
};
export const ContractorDetailDocument = gql`
    query ContractorDetail($id: ID!) {
  contractor(id: $id) {
    ...ContractorModel
  }
}
    ${ContractorModelFragmentDoc}`;

export function useContractorDetailQuery(options: Omit<Urql.UseQueryArgs<ContractorDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<ContractorDetailQuery, ContractorDetailQueryVariables>({ query: ContractorDetailDocument, ...options });
};
export const CreateContractorDocument = gql`
    mutation CreateContractor($input: CreateContractorInput!) {
  createContractor(input: $input) {
    ...ContractorModel
  }
}
    ${ContractorModelFragmentDoc}`;

export function useCreateContractorMutation() {
  return Urql.useMutation<CreateContractorMutation, CreateContractorMutationVariables>(CreateContractorDocument);
};
export const UpdateContractorDocument = gql`
    mutation UpdateContractor($input: UpdateContractorInput!) {
  updateContractor(input: $input) {
    ...ContractorModel
  }
}
    ${ContractorModelFragmentDoc}`;

export function useUpdateContractorMutation() {
  return Urql.useMutation<UpdateContractorMutation, UpdateContractorMutationVariables>(UpdateContractorDocument);
};
export const ModalContractorDependenciesDocument = gql`
    query ModalContractorDependencies {
  countrySimpleMap {
    ...CountrySimpleOptionParts
  }
  accountingAccountsSimpleMap {
    ...AccountingAccountOptionParts
  }
}
    ${CountrySimpleOptionPartsFragmentDoc}
${AccountingAccountOptionPartsFragmentDoc}`;

export function useModalContractorDependenciesQuery(options?: Omit<Urql.UseQueryArgs<ModalContractorDependenciesQueryVariables>, 'query'>) {
  return Urql.useQuery<ModalContractorDependenciesQuery, ModalContractorDependenciesQueryVariables>({ query: ModalContractorDependenciesDocument, ...options });
};
export const CompanyDataAutocompleteDocument = gql`
    query CompanyDataAutocomplete($input: String!, $country_id: ID!) {
  getAutocompleteForCompanyData(input: $input, country_id: $country_id) {
    results {
      legal_name
      city
      national_id
      cancelled
    }
    suggestions
  }
}
    `;

export function useCompanyDataAutocompleteQuery(options: Omit<Urql.UseQueryArgs<CompanyDataAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<CompanyDataAutocompleteQuery, CompanyDataAutocompleteQueryVariables>({ query: CompanyDataAutocompleteDocument, ...options });
};
export const CompanyDataByRegistrationNoDocument = gql`
    query CompanyDataByRegistrationNo($registration_no: String!, $country_id: ID!) {
  getCompanyDataByRegistrationNo(
    registration_no: $registration_no
    country_id: $country_id
  ) {
    legal_name
    street
    city
    zip
    registration_no
    tax_no
    vat_no
    applies_vat
    bankAccounts {
      iban
      swift
    }
    country {
      id
      name
      code
      created_at
      updated_at
    }
    cancelled
  }
}
    `;

export function useCompanyDataByRegistrationNoQuery(options: Omit<Urql.UseQueryArgs<CompanyDataByRegistrationNoQueryVariables>, 'query'>) {
  return Urql.useQuery<CompanyDataByRegistrationNoQuery, CompanyDataByRegistrationNoQueryVariables>({ query: CompanyDataByRegistrationNoDocument, ...options });
};
export const BankAccountConverterDocument = gql`
    query BankAccountConverter($country_id: ID!, $account_number: String!, $account_code: String) {
  bankAccountConverter(
    country_id: $country_id
    account_number: $account_number
    account_code: $account_code
  ) {
    iban
  }
}
    `;

export function useBankAccountConverterQuery(options: Omit<Urql.UseQueryArgs<BankAccountConverterQueryVariables>, 'query'>) {
  return Urql.useQuery<BankAccountConverterQuery, BankAccountConverterQueryVariables>({ query: BankAccountConverterDocument, ...options });
};
export const GetContractorsDocument = gql`
    query GetContractors($page: Int, $first: Int, $filters: ContractorQueryArgs) {
  contractorsSummary(filters: $filters) {
    contractorIds
  }
  contractors(page: $page, first: $first, filters: $filters) {
    data {
      id
      iban
      registration_no
      legal_name
      is_vat_payer
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

export function useGetContractorsQuery(options?: Omit<Urql.UseQueryArgs<GetContractorsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetContractorsQuery, GetContractorsQueryVariables>({ query: GetContractorsDocument, ...options });
};
export const DeleteContractorDocument = gql`
    mutation DeleteContractor($id: ID!) {
  deleteContractor(id: $id) {
    id
  }
}
    `;

export function useDeleteContractorMutation() {
  return Urql.useMutation<DeleteContractorMutation, DeleteContractorMutationVariables>(DeleteContractorDocument);
};
export const DeleteContractorsBulkDocument = gql`
    mutation DeleteContractorsBulk($id: [ID!]!) {
  deleteContractorsBulk(id: $id) {
    total
    successful
    failed
  }
}
    `;

export function useDeleteContractorsBulkMutation() {
  return Urql.useMutation<DeleteContractorsBulkMutation, DeleteContractorsBulkMutationVariables>(DeleteContractorsBulkDocument);
};
export const GetCreditAccountDocument = gql`
    query GetCreditAccount($id: ID!) {
  brandCreditAccount(id: $id) {
    id
    title
    creditAccount {
      id
    }
    brand {
      id
      name
      image {
        urls {
          thumbnail
        }
      }
    }
    team {
      id
      name
    }
    ourWorkBudgetCategories {
      id
      name
    }
    expenseBudgetCategories {
      id
      name
    }
    credits {
      id
      credit
      date
      outgoingInvoice {
        id
        invoice_no
      }
      originatesBrandCreditAccount {
        id
        title
      }
    }
    debits {
      id
      credit
      performed_at
      expenseBudgetItem {
        id
        title
        project {
          id
          title
          code
        }
      }
      ourWorkBudgetItem {
        id
        title
        project {
          id
          title
          code
        }
      }
      brandCreditAccount {
        id
        title
      }
    }
    stats {
      id
      remaining_credit
      total_credit
      total_debit
    }
  }
}
    `;

export function useGetCreditAccountQuery(options: Omit<Urql.UseQueryArgs<GetCreditAccountQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCreditAccountQuery, GetCreditAccountQueryVariables>({ query: GetCreditAccountDocument, ...options });
};
export const GetCreditAccountOptionsDocument = gql`
    query GetCreditAccountOptions {
  clientsSimpleMap {
    id
    brands {
      id
      name
    }
  }
  ourWorkBudgetCategories {
    id
    name
  }
  expenseBudgetCategories {
    id
    name
  }
  teamSimpleMap {
    id
    name
  }
}
    `;

export function useGetCreditAccountOptionsQuery(options?: Omit<Urql.UseQueryArgs<GetCreditAccountOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCreditAccountOptionsQuery, GetCreditAccountOptionsQueryVariables>({ query: GetCreditAccountOptionsDocument, ...options });
};
export const UpdateCreditAccountDocument = gql`
    mutation UpdateCreditAccount($input: UpdateBrandCreditAccountInput!) {
  updateBrandCreditAccount(input: $input) {
    id
  }
}
    `;

export function useUpdateCreditAccountMutation() {
  return Urql.useMutation<UpdateCreditAccountMutation, UpdateCreditAccountMutationVariables>(UpdateCreditAccountDocument);
};
export const CreateCreditAccountDocument = gql`
    mutation CreateCreditAccount($input: CreateBrandCreditAccountInput!) {
  createBrandCreditAccount(input: $input) {
    id
  }
}
    `;

export function useCreateCreditAccountMutation() {
  return Urql.useMutation<CreateCreditAccountMutation, CreateCreditAccountMutationVariables>(CreateCreditAccountDocument);
};
export const GlobalCreditAccountDetailDocument = gql`
    query GlobalCreditAccountDetail($id: ID!) {
  globalCreditAccount(id: $id) {
    ...GlobalCreditAccount
    credits {
      expense {
        id
        expense_no
      }
      originatesGlobalCreditAccount {
        id
        title
      }
    }
    debits {
      expenseBudgetItem {
        id
        project {
          id
          code
          title
        }
      }
    }
  }
}
    ${GlobalCreditAccountFragmentDoc}`;

export function useGlobalCreditAccountDetailQuery(options: Omit<Urql.UseQueryArgs<GlobalCreditAccountDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<GlobalCreditAccountDetailQuery, GlobalCreditAccountDetailQueryVariables>({ query: GlobalCreditAccountDetailDocument, ...options });
};
export const CreateGlobalCreditAccountDocument = gql`
    mutation CreateGlobalCreditAccount($input: CreateGlobalCreditAccountInput!) {
  createGlobalCreditAccount(input: $input) {
    id
  }
}
    `;

export function useCreateGlobalCreditAccountMutation() {
  return Urql.useMutation<CreateGlobalCreditAccountMutation, CreateGlobalCreditAccountMutationVariables>(CreateGlobalCreditAccountDocument);
};
export const UpdateGlobalCreditAccountDocument = gql`
    mutation UpdateGlobalCreditAccount($input: UpdateGlobalCreditAccountInput!) {
  updateGlobalCreditAccount(input: $input) {
    id
  }
}
    `;

export function useUpdateGlobalCreditAccountMutation() {
  return Urql.useMutation<UpdateGlobalCreditAccountMutation, UpdateGlobalCreditAccountMutationVariables>(UpdateGlobalCreditAccountDocument);
};
export const DeleteGlobalCreditAccountDocument = gql`
    mutation DeleteGlobalCreditAccount($id: ID!) {
  deleteGlobalCreditAccount(id: $id)
}
    `;

export function useDeleteGlobalCreditAccountMutation() {
  return Urql.useMutation<DeleteGlobalCreditAccountMutation, DeleteGlobalCreditAccountMutationVariables>(DeleteGlobalCreditAccountDocument);
};
export const GlobalCreditAccountsDocument = gql`
    query GlobalCreditAccounts($filters: GlobalCreditAccountQueryArgs, $first: Int, $page: Int) {
  globalCreditAccounts(filters: $filters, first: $first, page: $page) {
    data {
      ...GlobalCreditAccount
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${GlobalCreditAccountFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useGlobalCreditAccountsQuery(options?: Omit<Urql.UseQueryArgs<GlobalCreditAccountsQueryVariables>, 'query'>) {
  return Urql.useQuery<GlobalCreditAccountsQuery, GlobalCreditAccountsQueryVariables>({ query: GlobalCreditAccountsDocument, ...options });
};
export const CreditAccountsTableSummaryDocument = gql`
    query CreditAccountsTableSummary($filters: CreditAccountQueryArgs) {
  brandCreditAccountsSummary(filters: $filters) {
    brand_credit_accounts
    total_credit
    total_debit
    remaining_credit
  }
}
    `;

export function useCreditAccountsTableSummaryQuery(options?: Omit<Urql.UseQueryArgs<CreditAccountsTableSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<CreditAccountsTableSummaryQuery, CreditAccountsTableSummaryQueryVariables>({ query: CreditAccountsTableSummaryDocument, ...options });
};
export const GetCreditAccountsDocument = gql`
    query GetCreditAccounts($page: Int, $first: Int, $filters: CreditAccountQueryArgs) {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  teamSimpleMap {
    id
    name
  }
  ourWorkBudgetCategories {
    id
    name
  }
  expenseBudgetCategories {
    id
    name
  }
  brandCreditAccounts(page: $page, first: $first, filters: $filters) {
    data {
      id
      title
      brand {
        name
        id
      }
      team {
        id
        name
      }
      ourWorkBudgetCategories {
        id
        name
      }
      expenseBudgetCategories {
        id
        name
      }
      stats {
        id
        total_credit
        remaining_credit
        total_debit
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

export function useGetCreditAccountsQuery(options?: Omit<Urql.UseQueryArgs<GetCreditAccountsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCreditAccountsQuery, GetCreditAccountsQueryVariables>({ query: GetCreditAccountsDocument, ...options });
};
export const GetContractsDocument = gql`
    query GetContracts($page: Int, $first: Int, $filters: ContractQueryArgs) {
  contractsSummary(filters: $filters) {
    contractIds
  }
  contracts(page: $page, first: $first, filters: $filters) {
    data {
      id
      title
      valid_from
      valid_to
      type
      cloudUrl
      driveCloudUrl
      projects {
        id
        title
        code
      }
      brands {
        id
        name
      }
      contractors {
        id
        legal_name
      }
      clients {
        id
        name
      }
      urls {
        preview
        download
      }
      files {
        public_id
        mime_type
        size
        name
        filename
        urls {
          viewable
          original
        }
      }
    }
    paginatorInfo {
      hasMorePages
      currentPage
      perPage
      total
      count
      firstItem
      lastItem
      lastPage
    }
  }
}
    `;

export function useGetContractsQuery(options?: Omit<Urql.UseQueryArgs<GetContractsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetContractsQuery, GetContractsQueryVariables>({ query: GetContractsDocument, ...options });
};
export const ContractsExportDocument = gql`
    query contractsExport($filters: ContractQueryArgs) {
  contractsExport(filters: $filters)
}
    `;

export function useContractsExportQuery(options?: Omit<Urql.UseQueryArgs<ContractsExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ContractsExportQuery, ContractsExportQueryVariables>({ query: ContractsExportDocument, ...options });
};
export const GetDocumentDependenciesDocument = gql`
    query GetDocumentDependencies($brandId: ID, $orIdIn: [ID!]) {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projectsSimpleMap(brand_id: $brandId, orIdIn: $orIdIn) {
    id
    title
    code
    brand {
      id
    }
  }
}
    `;

export function useGetDocumentDependenciesQuery(options?: Omit<Urql.UseQueryArgs<GetDocumentDependenciesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDocumentDependenciesQuery, GetDocumentDependenciesQueryVariables>({ query: GetDocumentDependenciesDocument, ...options });
};
export const GetDocumentDependenciesForClientDocument = gql`
    query GetDocumentDependenciesForClient($clientId: ID!) {
  client(id: $clientId) {
    id
    name
    brands {
      id
      name
    }
  }
  projectsSimpleMap(client_id: $clientId) {
    id
    title
    code
    brand {
      id
    }
  }
  contractorsSimpleMap {
    id
    legal_name
  }
}
    `;

export function useGetDocumentDependenciesForClientQuery(options: Omit<Urql.UseQueryArgs<GetDocumentDependenciesForClientQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDocumentDependenciesForClientQuery, GetDocumentDependenciesForClientQueryVariables>({ query: GetDocumentDependenciesForClientDocument, ...options });
};
export const GetOrdersDocument = gql`
    query GetOrders($page: Int, $first: Int, $filters: OrderQueryArgs) {
  ordersSummary(filters: $filters) {
    orderIds
  }
  orders(page: $page, first: $first, filters: $filters) {
    data {
      id
      purchase_order_no
      date_of_order
      cloudUrl
      driveCloudUrl
      outgoingInvoices {
        id
        invoice_no
      }
      projects {
        id
        title
        code
      }
      brand {
        id
        name
      }
      urls {
        preview
        download
      }
      files {
        public_id
        mime_type
        size
        name
        filename
        urls {
          viewable
          original
        }
      }
    }
    paginatorInfo {
      hasMorePages
      currentPage
      perPage
      total
      count
      firstItem
      lastItem
      lastPage
    }
  }
}
    `;

export function useGetOrdersQuery(options?: Omit<Urql.UseQueryArgs<GetOrdersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrdersQuery, GetOrdersQueryVariables>({ query: GetOrdersDocument, ...options });
};
export const GetOtherDocumentsDocument = gql`
    query GetOtherDocuments($page: Int, $first: Int, $filters: OtherDocumentQueryArgs) {
  otherDocumentsSummary(filters: $filters) {
    otherDocumentIds
  }
  otherDocuments(page: $page, first: $first, filters: $filters) {
    data {
      id
      title
      cloudUrl
      driveCloudUrl
      projects {
        id
        title
        code
      }
      brands {
        id
        name
      }
      contractors {
        id
        legal_name
      }
      clients {
        id
        name
      }
      urls {
        preview
        download
      }
      files {
        public_id
        mime_type
        size
        name
        filename
        urls {
          viewable
          original
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

export function useGetOtherDocumentsQuery(options?: Omit<Urql.UseQueryArgs<GetOtherDocumentsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOtherDocumentsQuery, GetOtherDocumentsQueryVariables>({ query: GetOtherDocumentsDocument, ...options });
};
export const UpdateOtherDocumentDocument = gql`
    mutation UpdateOtherDocument($input: UpdateOtherDocumentInput!) {
  updateOtherDocument(input: $input) {
    id
  }
}
    `;

export function useUpdateOtherDocumentMutation() {
  return Urql.useMutation<UpdateOtherDocumentMutation, UpdateOtherDocumentMutationVariables>(UpdateOtherDocumentDocument);
};
export const CreateOtherDocumentDocument = gql`
    mutation CreateOtherDocument($input: CreateOtherDocumentInput!) {
  createOtherDocument(input: $input) {
    id
  }
}
    `;

export function useCreateOtherDocumentMutation() {
  return Urql.useMutation<CreateOtherDocumentMutation, CreateOtherDocumentMutationVariables>(CreateOtherDocumentDocument);
};
export const DeleteOtherDocumentDocument = gql`
    mutation DeleteOtherDocument($id: ID!) {
  deleteOtherDocument(id: $id) {
    id
  }
}
    `;

export function useDeleteOtherDocumentMutation() {
  return Urql.useMutation<DeleteOtherDocumentMutation, DeleteOtherDocumentMutationVariables>(DeleteOtherDocumentDocument);
};
export const DeleteOrderDocument = gql`
    mutation DeleteOrder($id: ID!) {
  deleteOrder(id: $id) {
    id
  }
}
    `;

export function useDeleteOrderMutation() {
  return Urql.useMutation<DeleteOrderMutation, DeleteOrderMutationVariables>(DeleteOrderDocument);
};
export const CreateContractDocument = gql`
    mutation CreateContract($input: CreateContractInput!) {
  createContract(input: $input) {
    id
    title
    type
  }
}
    `;

export function useCreateContractMutation() {
  return Urql.useMutation<CreateContractMutation, CreateContractMutationVariables>(CreateContractDocument);
};
export const UpdateContractDocument = gql`
    mutation UpdateContract($input: UpdateContractInput!) {
  updateContract(input: $input) {
    id
  }
}
    `;

export function useUpdateContractMutation() {
  return Urql.useMutation<UpdateContractMutation, UpdateContractMutationVariables>(UpdateContractDocument);
};
export const DeleteContractDocument = gql`
    mutation DeleteContract($id: ID!) {
  deleteContract(id: $id) {
    id
  }
}
    `;

export function useDeleteContractMutation() {
  return Urql.useMutation<DeleteContractMutation, DeleteContractMutationVariables>(DeleteContractDocument);
};
export const DeleteUploadedFileDocument = gql`
    mutation DeleteUploadedFile($id: String!) {
  deleteUploadedFile(assignable_file_id: $id)
}
    `;

export function useDeleteUploadedFileMutation() {
  return Urql.useMutation<DeleteUploadedFileMutation, DeleteUploadedFileMutationVariables>(DeleteUploadedFileDocument);
};
export const CreateExternalLinkDocument = gql`
    mutation CreateExternalLink($input: CreateExternalLinkInput!) {
  createExternalLink(input: $input) {
    ...ExternalLinkFragment
  }
}
    ${ExternalLinkFragmentFragmentDoc}`;

export function useCreateExternalLinkMutation() {
  return Urql.useMutation<CreateExternalLinkMutation, CreateExternalLinkMutationVariables>(CreateExternalLinkDocument);
};
export const UpdateExternalLinkDocument = gql`
    mutation UpdateExternalLink($input: UpdateExternalLinkInput!) {
  updateExternalLink(input: $input) {
    ...ExternalLinkFragment
  }
}
    ${ExternalLinkFragmentFragmentDoc}`;

export function useUpdateExternalLinkMutation() {
  return Urql.useMutation<UpdateExternalLinkMutation, UpdateExternalLinkMutationVariables>(UpdateExternalLinkDocument);
};
export const DeleteExternalLinkDocument = gql`
    mutation DeleteExternalLink($id: ID!) {
  deleteExternalLink(id: $id)
}
    `;

export function useDeleteExternalLinkMutation() {
  return Urql.useMutation<DeleteExternalLinkMutation, DeleteExternalLinkMutationVariables>(DeleteExternalLinkDocument);
};
export const AllExternalLinksDocument = gql`
    query AllExternalLinks($model_type: ExternalLinkType) {
  externalLinks(model_type: $model_type) {
    ...ExternalLinkFragment
  }
}
    ${ExternalLinkFragmentFragmentDoc}`;

export function useAllExternalLinksQuery(options?: Omit<Urql.UseQueryArgs<AllExternalLinksQueryVariables>, 'query'>) {
  return Urql.useQuery<AllExternalLinksQuery, AllExternalLinksQueryVariables>({ query: AllExternalLinksDocument, ...options });
};
export const ProjectExternalLinksDocument = gql`
    query ProjectExternalLinks($id: ID!) {
  project(id: $id) {
    externalLinks {
      ...ExternalLinkFragment
    }
  }
}
    ${ExternalLinkFragmentFragmentDoc}`;

export function useProjectExternalLinksQuery(options: Omit<Urql.UseQueryArgs<ProjectExternalLinksQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectExternalLinksQuery, ProjectExternalLinksQueryVariables>({ query: ProjectExternalLinksDocument, ...options });
};
export const BrandExternalLinksDocument = gql`
    query BrandExternalLinks($id: ID!) {
  brand(id: $id) {
    externalLinks {
      ...ExternalLinkFragment
    }
  }
}
    ${ExternalLinkFragmentFragmentDoc}`;

export function useBrandExternalLinksQuery(options: Omit<Urql.UseQueryArgs<BrandExternalLinksQueryVariables>, 'query'>) {
  return Urql.useQuery<BrandExternalLinksQuery, BrandExternalLinksQueryVariables>({ query: BrandExternalLinksDocument, ...options });
};
export const ExternalLinksFilterOptionsDocument = gql`
    query ExternalLinksFilterOptions {
  projectsSimpleMap {
    id
    title
  }
  brandsSimpleMap {
    id
    name
  }
}
    `;

export function useExternalLinksFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<ExternalLinksFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ExternalLinksFilterOptionsQuery, ExternalLinksFilterOptionsQueryVariables>({ query: ExternalLinksFilterOptionsDocument, ...options });
};
export const BudgetItemPlannedExpensesForCreateExpenseDocument = gql`
    query BudgetItemPlannedExpensesForCreateExpense($budgetItemId: ID!, $budgetItemType: ExpenseBudgetItemTypeEnum!) {
  budgetItemPlannedExpenses(
    budget_item_id: $budgetItemId
    budget_item_type: $budgetItemType
  ) {
    id
    description
    date
    budgeted_amount
    client_amount
    contractor {
      id
      legal_name
    }
    usedExpenses {
      id
      used_amount
      expenseItem {
        id
      }
    }
  }
}
    `;

export function useBudgetItemPlannedExpensesForCreateExpenseQuery(options: Omit<Urql.UseQueryArgs<BudgetItemPlannedExpensesForCreateExpenseQueryVariables>, 'query'>) {
  return Urql.useQuery<BudgetItemPlannedExpensesForCreateExpenseQuery, BudgetItemPlannedExpensesForCreateExpenseQueryVariables>({ query: BudgetItemPlannedExpensesForCreateExpenseDocument, ...options });
};
export const CreateExpenseDocument = gql`
    mutation CreateExpense($input: CreateExpenseInput!) {
  createExpense(input: $input) {
    ...Expense
  }
}
    ${ExpenseFragmentDoc}`;

export function useCreateExpenseMutation() {
  return Urql.useMutation<CreateExpenseMutation, CreateExpenseMutationVariables>(CreateExpenseDocument);
};
export const FindAddressForExpenseDocument = gql`
    mutation FindAddressForExpense($search: String) {
  findAddressForExpense(search: $search) {
    street
    city
    zip
    country {
      id
      name
      code
    }
  }
}
    `;

export function useFindAddressForExpenseMutation() {
  return Urql.useMutation<FindAddressForExpenseMutation, FindAddressForExpenseMutationVariables>(FindAddressForExpenseDocument);
};
export const UpdateExpenseDocument = gql`
    mutation UpdateExpense($input: UpdateExpenseInput!) {
  updateExpense(input: $input) {
    ...Expense
  }
}
    ${ExpenseFragmentDoc}`;

export function useUpdateExpenseMutation() {
  return Urql.useMutation<UpdateExpenseMutation, UpdateExpenseMutationVariables>(UpdateExpenseDocument);
};
export const LockDocumentDocument = gql`
    mutation LockDocument($document_id: ID!, $document_type: LockDocumentTypeEnum!) {
  lockDocument(document_id: $document_id, document_type: $document_type) {
    document_id
  }
}
    `;

export function useLockDocumentMutation() {
  return Urql.useMutation<LockDocumentMutation, LockDocumentMutationVariables>(LockDocumentDocument);
};
export const UnlockDocumentDocument = gql`
    mutation UnlockDocument($document_id: ID!, $document_type: LockDocumentTypeEnum!) {
  unlockDocument(document_id: $document_id, document_type: $document_type) {
    document_id
  }
}
    `;

export function useUnlockDocumentMutation() {
  return Urql.useMutation<UnlockDocumentMutation, UnlockDocumentMutationVariables>(UnlockDocumentDocument);
};
export const CreateExpenseItemDescriptionDocument = gql`
    mutation CreateExpenseItemDescription($title: String!) {
  createExpenseItemDescription(title: $title) {
    ...ExpenseItemDescription
  }
}
    ${ExpenseItemDescriptionFragmentDoc}`;

export function useCreateExpenseItemDescriptionMutation() {
  return Urql.useMutation<CreateExpenseItemDescriptionMutation, CreateExpenseItemDescriptionMutationVariables>(CreateExpenseItemDescriptionDocument);
};
export const UpdateExpenseItemDescriptionDocument = gql`
    mutation UpdateExpenseItemDescription($id: ID!, $title: String!) {
  updateExpenseItemDescription(id: $id, title: $title) {
    ...ExpenseItemDescription
  }
}
    ${ExpenseItemDescriptionFragmentDoc}`;

export function useUpdateExpenseItemDescriptionMutation() {
  return Urql.useMutation<UpdateExpenseItemDescriptionMutation, UpdateExpenseItemDescriptionMutationVariables>(UpdateExpenseItemDescriptionDocument);
};
export const DeleteExpenseItemDescriptionDocument = gql`
    mutation DeleteExpenseItemDescription($id: ID!) {
  deleteExpenseItemDescription(id: $id)
}
    `;

export function useDeleteExpenseItemDescriptionMutation() {
  return Urql.useMutation<DeleteExpenseItemDescriptionMutation, DeleteExpenseItemDescriptionMutationVariables>(DeleteExpenseItemDescriptionDocument);
};
export const ContractForCreateExpenseDocument = gql`
    query ContractForCreateExpense($id: ID!) {
  contract(id: $id) {
    id
    type
    files {
      ...MediaModelParts
    }
  }
}
    ${MediaModelPartsFragmentDoc}`;

export function useContractForCreateExpenseQuery(options: Omit<Urql.UseQueryArgs<ContractForCreateExpenseQueryVariables>, 'query'>) {
  return Urql.useQuery<ContractForCreateExpenseQuery, ContractForCreateExpenseQueryVariables>({ query: ContractForCreateExpenseDocument, ...options });
};
export const ContractorForCreateExpenseDocument = gql`
    query ContractorForCreateExpense($id: ID!) {
  contractor(id: $id) {
    ...ContractorModel
  }
}
    ${ContractorModelFragmentDoc}`;

export function useContractorForCreateExpenseQuery(options: Omit<Urql.UseQueryArgs<ContractorForCreateExpenseQueryVariables>, 'query'>) {
  return Urql.useQuery<ContractorForCreateExpenseQuery, ContractorForCreateExpenseQueryVariables>({ query: ContractorForCreateExpenseDocument, ...options });
};
export const DependenciesForCreateExpenseDocument = gql`
    query DependenciesForCreateExpense {
  currencies {
    ...CurrencyOptionParts
  }
  vatRates {
    ...VatRateOptionParts
    deleted
    type
  }
  fondContractorsSimpleMap {
    id
    legal_name
  }
  accountingAccountsSimpleMap {
    ...AccountingAccountOptionParts
  }
  paymentTypes {
    id
    name
    system_name
  }
  clientsSimpleMap {
    id
    brands {
      ...BrandSimpleOptionParts
    }
  }
  accountingCentres {
    ...CostCenter
  }
  expenseItemDescriptions {
    ...ExpenseItemDescription
  }
}
    ${CurrencyOptionPartsFragmentDoc}
${VatRateOptionPartsFragmentDoc}
${AccountingAccountOptionPartsFragmentDoc}
${BrandSimpleOptionPartsFragmentDoc}
${CostCenterFragmentDoc}
${ExpenseItemDescriptionFragmentDoc}`;

export function useDependenciesForCreateExpenseQuery(options?: Omit<Urql.UseQueryArgs<DependenciesForCreateExpenseQueryVariables>, 'query'>) {
  return Urql.useQuery<DependenciesForCreateExpenseQuery, DependenciesForCreateExpenseQueryVariables>({ query: DependenciesForCreateExpenseDocument, ...options });
};
export const ExpenseForCreateExpenseDocument = gql`
    query ExpenseForCreateExpense($id: ID!) {
  expense(id: $id) {
    ...Expense
  }
}
    ${ExpenseFragmentDoc}`;

export function useExpenseForCreateExpenseQuery(options: Omit<Urql.UseQueryArgs<ExpenseForCreateExpenseQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseForCreateExpenseQuery, ExpenseForCreateExpenseQueryVariables>({ query: ExpenseForCreateExpenseDocument, ...options });
};
export const IsExpenseLockedDocument = gql`
    query IsExpenseLocked($id: ID!) {
  expense(id: $id) {
    lockedDocument {
      locked_to
      user {
        id
        full_name
      }
    }
  }
}
    `;

export function useIsExpenseLockedQuery(options: Omit<Urql.UseQueryArgs<IsExpenseLockedQueryVariables>, 'query'>) {
  return Urql.useQuery<IsExpenseLockedQuery, IsExpenseLockedQueryVariables>({ query: IsExpenseLockedDocument, ...options });
};
export const GetExpenseUpdatedAtDocument = gql`
    query GetExpenseUpdatedAt($id: ID!) {
  expense(id: $id) {
    updated_at
  }
}
    `;

export function useGetExpenseUpdatedAtQuery(options: Omit<Urql.UseQueryArgs<GetExpenseUpdatedAtQueryVariables>, 'query'>) {
  return Urql.useQuery<GetExpenseUpdatedAtQuery, GetExpenseUpdatedAtQueryVariables>({ query: GetExpenseUpdatedAtDocument, ...options });
};
export const GetExpenseBudgetItemsByItemCodeDocument = gql`
    query GetExpenseBudgetItemsByItemCode($item_code: String!) {
  expenseBudgetItemsByItemCode(item_code: $item_code) {
    ...ExpenseBudgetItemByCode
  }
}
    ${ExpenseBudgetItemByCodeFragmentDoc}`;

export function useGetExpenseBudgetItemsByItemCodeQuery(options: Omit<Urql.UseQueryArgs<GetExpenseBudgetItemsByItemCodeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetExpenseBudgetItemsByItemCodeQuery, GetExpenseBudgetItemsByItemCodeQueryVariables>({ query: GetExpenseBudgetItemsByItemCodeDocument, ...options });
};
export const GetOurWorkBudgetItemsByItemCodeDocument = gql`
    query GetOurWorkBudgetItemsByItemCode($item_code: String!) {
  ourWorkBudgetItemsByItemCode(item_code: $item_code) {
    ...OurWorkBudgetItemByCode
  }
}
    ${OurWorkBudgetItemByCodeFragmentDoc}`;

export function useGetOurWorkBudgetItemsByItemCodeQuery(options: Omit<Urql.UseQueryArgs<GetOurWorkBudgetItemsByItemCodeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOurWorkBudgetItemsByItemCodeQuery, GetOurWorkBudgetItemsByItemCodeQueryVariables>({ query: GetOurWorkBudgetItemsByItemCodeDocument, ...options });
};
export const ProjectForCreateExpenseDocument = gql`
    query ProjectForCreateExpense($id: ID!) {
  projectForExpense(id: $id) {
    id
    title
    code
    finished_at
    brand {
      id
    }
    team {
      id
      expense_cost_centre_id
    }
    expenses {
      id
      title
      item_code
      payment_status
      type
      completed_at
      category {
        id
        name
      }
      stats {
        total_budget
        planned_expenses
        real_expenses
      }
    }
    ourWorkBudgetItems {
      id
      title
      item_code
      timeTrackingSettings {
        id
        tracking_enabled
        tracking_enabled_from
        tracking_enabled_to
      }
      stats {
        remaining_budget
      }
    }
  }
}
    `;

export function useProjectForCreateExpenseQuery(options: Omit<Urql.UseQueryArgs<ProjectForCreateExpenseQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectForCreateExpenseQuery, ProjectForCreateExpenseQueryVariables>({ query: ProjectForCreateExpenseDocument, ...options });
};
export const ContractorSelectOptionsDocument = gql`
    query ContractorSelectOptions($page: Int, $first: Int, $filters: ContractorQueryArgs) {
  contractors(page: $page, first: $first, filters: $filters) {
    data {
      id
      legal_name
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

export function useContractorSelectOptionsQuery(options?: Omit<Urql.UseQueryArgs<ContractorSelectOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ContractorSelectOptionsQuery, ContractorSelectOptionsQueryVariables>({ query: ContractorSelectOptionsDocument, ...options });
};
export const BillingEntitySelectOptionsDocument = gql`
    query BillingEntitySelectOptions($page: Int, $first: Int, $filters: BillingEntityQueryArgs) {
  billingEntities(page: $page, first: $first, filters: $filters) {
    data {
      id
      internal_name
      street
      city
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

export function useBillingEntitySelectOptionsQuery(options?: Omit<Urql.UseQueryArgs<BillingEntitySelectOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<BillingEntitySelectOptionsQuery, BillingEntitySelectOptionsQueryVariables>({ query: BillingEntitySelectOptionsDocument, ...options });
};
export const GetExpensePredictionDocument = gql`
    query GetExpensePrediction($file: Upload!) {
  fetchOCRExpenseData(file: $file) {
    document_number
    for_approval
    type
    variable_symbol
    constant_symbol
    specific_symbol
    document_number
    total_amount_includes_vat
    total_amount_with_vat_in_currency
    issue_date
    date_of_supply
    due_date
    currency_id
    contractor_id
    legal_name
    street
    city
    zip
    country_id
    registration_no
    tax_no
    vat_no
    business_form
    iban
    swift
    bank_account
    bank_account_code
    expense_items {
      amount
      approved
      description
      vat_rate
    }
  }
}
    `;

export function useGetExpensePredictionQuery(options: Omit<Urql.UseQueryArgs<GetExpensePredictionQueryVariables>, 'query'>) {
  return Urql.useQuery<GetExpensePredictionQuery, GetExpensePredictionQueryVariables>({ query: GetExpensePredictionDocument, ...options });
};
export const TaskPositionsForExpenseDocument = gql`
    query TaskPositionsForExpense($id: ID!) {
  task(id: $id) {
    id
    positions {
      id
      timeTrackingWorkType {
        id
        title
      }
    }
  }
}
    `;

export function useTaskPositionsForExpenseQuery(options: Omit<Urql.UseQueryArgs<TaskPositionsForExpenseQueryVariables>, 'query'>) {
  return Urql.useQuery<TaskPositionsForExpenseQuery, TaskPositionsForExpenseQueryVariables>({ query: TaskPositionsForExpenseDocument, ...options });
};
export const ExpenseItemsListingDocument = gql`
    query ExpenseItemsListing($filters: ExpenseItemsTimeBillingQueryArgs, $first: Int, $page: Int) {
  expenseItemsForTimeBilling(filters: $filters, first: $first, page: $page) {
    data {
      ...ExpenseItemsListItem
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ExpenseItemsListItemFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useExpenseItemsListingQuery(options?: Omit<Urql.UseQueryArgs<ExpenseItemsListingQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseItemsListingQuery, ExpenseItemsListingQueryVariables>({ query: ExpenseItemsListingDocument, ...options });
};
export const ExpenseItemsListingSummaryDocument = gql`
    query ExpenseItemsListingSummary($filters: ExpenseItemsTimeBillingQueryArgs) {
  expenseItemsForTimeBillingSummary(filters: $filters) {
    allIds
    count
    amount
  }
}
    `;

export function useExpenseItemsListingSummaryQuery(options?: Omit<Urql.UseQueryArgs<ExpenseItemsListingSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseItemsListingSummaryQuery, ExpenseItemsListingSummaryQueryVariables>({ query: ExpenseItemsListingSummaryDocument, ...options });
};
export const ExpenseItemsListingFilterOptionsDocument = gql`
    query ExpenseItemsListingFilterOptions {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projectsSimpleMap {
    id
    title
    code
  }
  userSimpleMap {
    id
    full_name
  }
  accountingCentres {
    id
    title
  }
}
    `;

export function useExpenseItemsListingFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<ExpenseItemsListingFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseItemsListingFilterOptionsQuery, ExpenseItemsListingFilterOptionsQueryVariables>({ query: ExpenseItemsListingFilterOptionsDocument, ...options });
};
export const DeleteExpenseDocument = gql`
    mutation DeleteExpense($id: ID!) {
  deleteExpense(id: $id) {
    id
  }
}
    `;

export function useDeleteExpenseMutation() {
  return Urql.useMutation<DeleteExpenseMutation, DeleteExpenseMutationVariables>(DeleteExpenseDocument);
};
export const MarkExpenseAsPaidDocument = gql`
    mutation MarkExpenseAsPaid($id: ID!, $date: Date) {
  markExpenseAsPaid(id: $id, date: $date) {
    id
    paid_at
  }
}
    `;

export function useMarkExpenseAsPaidMutation() {
  return Urql.useMutation<MarkExpenseAsPaidMutation, MarkExpenseAsPaidMutationVariables>(MarkExpenseAsPaidDocument);
};
export const MarkExpenseAsUnpaidDocument = gql`
    mutation MarkExpenseAsUnpaid($id: ID!, $remove_matched_payments: Boolean! = false) {
  markExpenseAsUnpaid(id: $id, remove_matched_payments: $remove_matched_payments) {
    id
    paid_at
  }
}
    `;

export function useMarkExpenseAsUnpaidMutation() {
  return Urql.useMutation<MarkExpenseAsUnpaidMutation, MarkExpenseAsUnpaidMutationVariables>(MarkExpenseAsUnpaidDocument);
};
export const MarkExpenseAsPaidBulkDocument = gql`
    mutation MarkExpenseAsPaidBulk($id: [ID!]!, $date: Date) {
  markExpenseAsPaidBulk(id: $id, date: $date) {
    total
    successful
    failed
  }
}
    `;

export function useMarkExpenseAsPaidBulkMutation() {
  return Urql.useMutation<MarkExpenseAsPaidBulkMutation, MarkExpenseAsPaidBulkMutationVariables>(MarkExpenseAsPaidBulkDocument);
};
export const CloneExpenseDocument = gql`
    mutation CloneExpense($id: ID!) {
  cloneExpense(id: $id) {
    ...Expense
  }
}
    ${ExpenseFragmentDoc}`;

export function useCloneExpenseMutation() {
  return Urql.useMutation<CloneExpenseMutation, CloneExpenseMutationVariables>(CloneExpenseDocument);
};
export const BulkDeleteExpensesDocument = gql`
    mutation BulkDeleteExpenses($ids: [ID!]!) {
  bulkDeleteExpenses(ids: $ids) {
    total
    successful
    failed
  }
}
    `;

export function useBulkDeleteExpensesMutation() {
  return Urql.useMutation<BulkDeleteExpensesMutation, BulkDeleteExpensesMutationVariables>(BulkDeleteExpensesDocument);
};
export const GetExpensesDocument = gql`
    query GetExpenses($page: Int, $first: Int, $filters: ExpenseQueryArgs) {
  expenses(page: $page, first: $first, filters: $filters) {
    data {
      id
      invoice_status
      status
      type
      abraflexi_exported
      xero_exported
      documentExports {
        ...DocumentExport
      }
      contractor {
        id
        legal_name
      }
      projects {
        id
        code
        title
      }
      variable_symbol
      has_master_agreement
      workspace_company_id
      iban
      stats {
        total_amount
        total_amount_without_vat_in_currency
        total_amount_with_vat_in_currency
      }
      currency {
        id
        code
        denomination
      }
      date_of_supply
      due_date
      paid_at
      user_created_date
      is_draft
      expense_no
      exchange_rate
      expenseItems {
        mandatory_id
        approved
      }
      expense_documents {
        public_id
        mime_type
        size
        name
        filename
        urls {
          viewable
          original
        }
      }
      note
      internal_note
      emailData {
        text
      }
      workspace_bank_account_id
      accountMoves {
        id
        amount
        amount_in_move_currency
        exchange_rate
        bank_account_move_id
        bankAccountMove {
          ...AccountMove
        }
      }
      projectTimeBilling {
        id
        is_locked
      }
      modelLock {
        ...ModelLock
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${DocumentExportFragmentDoc}
${AccountMoveFragmentDoc}
${ModelLockFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useGetExpensesQuery(options?: Omit<Urql.UseQueryArgs<GetExpensesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetExpensesQuery, GetExpensesQueryVariables>({ query: GetExpensesDocument, ...options });
};
export const ExpensesTableSummaryDocument = gql`
    query ExpensesTableSummary($filters: ExpenseQueryArgs) {
  expensesSummary(filters: $filters) {
    expenseIds
    expenses
    total_amount
    total_vat
    total_amount_with_vat
    payments_due
    payments_due_vat
    payments_due_without_vat
    overdue_by_less_than_30_days
    overdue_by_less_than_30_days_vat
    overdue_by_less_than_30_days_without_vat
    overdue_by_31_to_90_days
    overdue_by_31_to_90_days_vat
    overdue_by_31_to_90_days_without_vat
    overdue_by_91_to_365_days
    overdue_by_91_to_365_days_vat
    overdue_by_91_to_365_days_without_vat
    overdue_by_more_than_365_days
    overdue_by_more_than_365_days_vat
    overdue_by_more_than_365_days_without_vat
  }
}
    `;

export function useExpensesTableSummaryQuery(options?: Omit<Urql.UseQueryArgs<ExpensesTableSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpensesTableSummaryQuery, ExpensesTableSummaryQueryVariables>({ query: ExpensesTableSummaryDocument, ...options });
};
export const ExpensesTableSelectedSummaryDocument = gql`
    query ExpensesTableSelectedSummary($filters: ExpenseQueryArgs) {
  expensesSummary(filters: $filters) {
    total_amount
    total_amount_with_vat
  }
}
    `;

export function useExpensesTableSelectedSummaryQuery(options?: Omit<Urql.UseQueryArgs<ExpensesTableSelectedSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpensesTableSelectedSummaryQuery, ExpensesTableSelectedSummaryQueryVariables>({ query: ExpensesTableSelectedSummaryDocument, ...options });
};
export const GetExpenseTimeBillingsDocument = gql`
    query GetExpenseTimeBillings($id: ID!) {
  expense(id: $id) {
    id
    expenseItems {
      id
      timeBillings {
        id
        is_locked
      }
    }
  }
}
    `;

export function useGetExpenseTimeBillingsQuery(options: Omit<Urql.UseQueryArgs<GetExpenseTimeBillingsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetExpenseTimeBillingsQuery, GetExpenseTimeBillingsQueryVariables>({ query: GetExpenseTimeBillingsDocument, ...options });
};
export const ExportExpensesSummaryDocument = gql`
    query ExportExpensesSummary($ids: [ID!]!) {
  expenseSummaryExportBulk(id: $ids)
}
    `;

export function useExportExpensesSummaryQuery(options: Omit<Urql.UseQueryArgs<ExportExpensesSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<ExportExpensesSummaryQuery, ExportExpensesSummaryQueryVariables>({ query: ExportExpensesSummaryDocument, ...options });
};
export const GenerateExpensePaymentOrderDocument = gql`
    query GenerateExpensePaymentOrder($ids: [ID!]!, $date: Date!, $type: ExpensePaymentOrderExportType!, $payment_type_id: ID!) {
  generateExpensePaymentOrder(
    expense_ids: $ids
    date: $date
    type: $type
    payment_type_id: $payment_type_id
  ) {
    url
    unprocessable_expense_ids
  }
}
    `;

export function useGenerateExpensePaymentOrderQuery(options: Omit<Urql.UseQueryArgs<GenerateExpensePaymentOrderQueryVariables>, 'query'>) {
  return Urql.useQuery<GenerateExpensePaymentOrderQuery, GenerateExpensePaymentOrderQueryVariables>({ query: GenerateExpensePaymentOrderDocument, ...options });
};
export const ExpenseExportDocument = gql`
    query ExpenseExport($filters: ExpenseQueryArgs, $from: Date, $to: Date) {
  expenseExport(filters: $filters, from: $from, to: $to)
}
    `;

export function useExpenseExportQuery(options?: Omit<Urql.UseQueryArgs<ExpenseExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseExportQuery, ExpenseExportQueryVariables>({ query: ExpenseExportDocument, ...options });
};
export const ExpenseXmlExportDocument = gql`
    query ExpenseXMLExport($filters: ExpenseQueryArgs, $from: Date, $to: Date) {
  expenseXMLExport(filters: $filters, from: $from, to: $to)
}
    `;

export function useExpenseXmlExportQuery(options?: Omit<Urql.UseQueryArgs<ExpenseXmlExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseXmlExportQuery, ExpenseXmlExportQueryVariables>({ query: ExpenseXmlExportDocument, ...options });
};
export const ExpenseOmegaExportDocument = gql`
    query ExpenseOmegaExport($ids: [ID!]!) {
  omegaExpenseExport(expense_ids: $ids)
}
    `;

export function useExpenseOmegaExportQuery(options: Omit<Urql.UseQueryArgs<ExpenseOmegaExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseOmegaExportQuery, ExpenseOmegaExportQueryVariables>({ query: ExpenseOmegaExportDocument, ...options });
};
export const ExpenseAbraFlexiSelectedExportDocument = gql`
    query ExpenseAbraFlexiSelectedExport($expense_ids: [ID!]!) {
  expenseAbraFlexiExport(expense_ids: $expense_ids)
}
    `;

export function useExpenseAbraFlexiSelectedExportQuery(options: Omit<Urql.UseQueryArgs<ExpenseAbraFlexiSelectedExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseAbraFlexiSelectedExportQuery, ExpenseAbraFlexiSelectedExportQueryVariables>({ query: ExpenseAbraFlexiSelectedExportDocument, ...options });
};
export const ExpensePremierExportDocument = gql`
    query ExpensePremierExport($expense_ids: [ID!]!) {
  expensePremierExport(expense_ids: $expense_ids)
}
    `;

export function useExpensePremierExportQuery(options: Omit<Urql.UseQueryArgs<ExpensePremierExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpensePremierExportQuery, ExpensePremierExportQueryVariables>({ query: ExpensePremierExportDocument, ...options });
};
export const ExpenseFilterOptionsDocument = gql`
    query ExpenseFilterOptions {
  projectsSimpleMap {
    id
    code
    title
  }
  userSimpleMap {
    id
    full_name
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  paymentTypes {
    id
    name
    system_name
  }
}
    `;

export function useExpenseFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<ExpenseFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseFilterOptionsQuery, ExpenseFilterOptionsQueryVariables>({ query: ExpenseFilterOptionsDocument, ...options });
};
export const PohodaExpenseExportDocument = gql`
    query PohodaExpenseExport($expense_ids: [ID!]!) {
  pohodaExpenseExport(expense_ids: $expense_ids)
}
    `;

export function usePohodaExpenseExportQuery(options: Omit<Urql.UseQueryArgs<PohodaExpenseExportQueryVariables>, 'query'>) {
  return Urql.useQuery<PohodaExpenseExportQuery, PohodaExpenseExportQueryVariables>({ query: PohodaExpenseExportDocument, ...options });
};
export const ExpenseAttachmentsExportBulkDocument = gql`
    query ExpenseAttachmentsExportBulk($selectedIds: [ID!]!) {
  ExpenseAttachmentsExport(expense_ids: $selectedIds)
}
    `;

export function useExpenseAttachmentsExportBulkQuery(options: Omit<Urql.UseQueryArgs<ExpenseAttachmentsExportBulkQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseAttachmentsExportBulkQuery, ExpenseAttachmentsExportBulkQueryVariables>({ query: ExpenseAttachmentsExportBulkDocument, ...options });
};
export const VarioExpenseExportDocument = gql`
    query VarioExpenseExport($expense_ids: [ID!]!) {
  varioExpenseExport(expense_ids: $expense_ids)
}
    `;

export function useVarioExpenseExportQuery(options: Omit<Urql.UseQueryArgs<VarioExpenseExportQueryVariables>, 'query'>) {
  return Urql.useQuery<VarioExpenseExportQuery, VarioExpenseExportQueryVariables>({ query: VarioExpenseExportDocument, ...options });
};
export const TransakcioExpenseExportDocument = gql`
    query TransakcioExpenseExport($expense_ids: [ID!]!) {
  transakcioExpenseExport(expense_ids: $expense_ids)
}
    `;

export function useTransakcioExpenseExportQuery(options: Omit<Urql.UseQueryArgs<TransakcioExpenseExportQueryVariables>, 'query'>) {
  return Urql.useQuery<TransakcioExpenseExportQuery, TransakcioExpenseExportQueryVariables>({ query: TransakcioExpenseExportDocument, ...options });
};
export const IsDateBeforeLastPlanningUpdateDocument = gql`
    mutation IsDateBeforeLastPlanningUpdate($date: DateTime) {
  isDateBeforeLastPlanningUpdate(date: $date)
}
    `;

export function useIsDateBeforeLastPlanningUpdateMutation() {
  return Urql.useMutation<IsDateBeforeLastPlanningUpdateMutation, IsDateBeforeLastPlanningUpdateMutationVariables>(IsDateBeforeLastPlanningUpdateDocument);
};
export const StopTimerForCapacityAllocationItemDocument = gql`
    mutation StopTimerForCapacityAllocationItem($input: stopTimerForCapacityAllocationItemInput!) {
  stopTimerForCapacityAllocationItem(input: $input) {
    id
  }
}
    `;

export function useStopTimerForCapacityAllocationItemMutation() {
  return Urql.useMutation<StopTimerForCapacityAllocationItemMutation, StopTimerForCapacityAllocationItemMutationVariables>(StopTimerForCapacityAllocationItemDocument);
};
export const UpdateAllocationItemDurationDocument = gql`
    mutation UpdateAllocationItemDuration($id: ID!, $total_time: BigInt!, $to_time: Time, $user_id: ID!) {
  updateCapacityAllocationItem(
    input: {id: $id, total_time: $total_time, to_time: $to_time, user_id: $user_id}
  ) {
    id
    total_time
    to_time
  }
}
    `;

export function useUpdateAllocationItemDurationMutation() {
  return Urql.useMutation<UpdateAllocationItemDurationMutation, UpdateAllocationItemDurationMutationVariables>(UpdateAllocationItemDurationDocument);
};
export const UpdateAllocationDurationDocument = gql`
    mutation UpdateAllocationDuration($id: ID!, $total_time: BigInt!, $to_time: Time, $create_task_positions: Boolean!) {
  updateCapacityAllocation(
    input: {id: $id, total_time: $total_time, total_time_per_day: $total_time, to_time: $to_time, create_task_positions: $create_task_positions}
  ) {
    id
    total_time
    to_time
  }
}
    `;

export function useUpdateAllocationDurationMutation() {
  return Urql.useMutation<UpdateAllocationDurationMutation, UpdateAllocationDurationMutationVariables>(UpdateAllocationDurationDocument);
};
export const CapacityAllocationItemTimeTrackingItemsDocument = gql`
    query CapacityAllocationItemTimeTrackingItems($id: ID!, $user_id: ID!, $task_id: ID!) {
  capacityAllocationItemTimeTrackingItems(id: $id, user_id: $user_id) {
    id
    tracked_time
    note
    is_locked
    billable
    timeTrackingWorkType {
      id
      title
    }
  }
  task(id: $task_id) {
    billable
    ourWorkBudgetItem {
      project {
        availableTimeTrackingWorkTypes {
          id
          title
        }
      }
    }
  }
}
    `;

export function useCapacityAllocationItemTimeTrackingItemsQuery(options: Omit<Urql.UseQueryArgs<CapacityAllocationItemTimeTrackingItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<CapacityAllocationItemTimeTrackingItemsQuery, CapacityAllocationItemTimeTrackingItemsQueryVariables>({ query: CapacityAllocationItemTimeTrackingItemsDocument, ...options });
};
export const ContractsSimpleDocument = gql`
    query ContractsSimple($contractorId: ID) {
  contractsSimpleMap(contractor_id: $contractorId) {
    id
    title
  }
}
    `;

export function useContractsSimpleQuery(options?: Omit<Urql.UseQueryArgs<ContractsSimpleQueryVariables>, 'query'>) {
  return Urql.useQuery<ContractsSimpleQuery, ContractsSimpleQueryVariables>({ query: ContractsSimpleDocument, ...options });
};
export const ConvertAmountDocument = gql`
    query ConvertAmount($clientId: ID, $projectId: ID, $workspaceCompanyId: ID, $amount: BigInt!, $currencyId: ID!, $exchangeRate: BigInt, $date: Date!, $type: ExchangeRateSource!) {
  convertAmountToWorkspaceCurrencyUsingExchangeRate(
    client_id: $clientId
    project_id: $projectId
    workspace_company_id: $workspaceCompanyId
    amount_in_currency: $amount
    currency_id: $currencyId
    exchange_rate: $exchangeRate
    date: $date
    type: $type
  ) {
    amount
  }
}
    `;

export function useConvertAmountQuery(options: Omit<Urql.UseQueryArgs<ConvertAmountQueryVariables>, 'query'>) {
  return Urql.useQuery<ConvertAmountQuery, ConvertAmountQueryVariables>({ query: ConvertAmountDocument, ...options });
};
export const GetExchangeRateDocument = gql`
    query GetExchangeRate($clientId: ID, $projectId: ID, $workspaceCompanyId: ID, $currencyId: ID!, $exchangeRate: BigInt, $date: Date!, $type: ExchangeRateSource!) {
  convertAmountToWorkspaceCurrencyUsingExchangeRate(
    client_id: $clientId
    project_id: $projectId
    workspace_company_id: $workspaceCompanyId
    amount_in_currency: 1000
    currency_id: $currencyId
    exchange_rate: $exchangeRate
    date: $date
    type: $type
  ) {
    exchange_rate
  }
}
    `;

export function useGetExchangeRateQuery(options: Omit<Urql.UseQueryArgs<GetExchangeRateQueryVariables>, 'query'>) {
  return Urql.useQuery<GetExchangeRateQuery, GetExchangeRateQueryVariables>({ query: GetExchangeRateDocument, ...options });
};
export const GetDuplicateExpensesIDsDocument = gql`
    query GetDuplicateExpensesIDs($contractorId: ID!, $variableSymbol: String!, $excludeExpenseId: ID, $documentNumber: String!) {
  getDuplicateExpensesIDs(
    contractor_id: $contractorId
    variable_symbol: $variableSymbol
    exclude_expense_id: $excludeExpenseId
    document_number: $documentNumber
  )
}
    `;

export function useGetDuplicateExpensesIDsQuery(options: Omit<Urql.UseQueryArgs<GetDuplicateExpensesIDsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDuplicateExpensesIDsQuery, GetDuplicateExpensesIDsQueryVariables>({ query: GetDuplicateExpensesIDsDocument, ...options });
};
export const LatestExpenseInternalNumberDocument = gql`
    query LatestExpenseInternalNumber {
  getLatestExpenseInternalNumberPerType {
    type
    internal_number
  }
}
    `;

export function useLatestExpenseInternalNumberQuery(options?: Omit<Urql.UseQueryArgs<LatestExpenseInternalNumberQueryVariables>, 'query'>) {
  return Urql.useQuery<LatestExpenseInternalNumberQuery, LatestExpenseInternalNumberQueryVariables>({ query: LatestExpenseInternalNumberDocument, ...options });
};
export const PlanningDailyViewPeopleDocument = gql`
    query PlanningDailyViewPeople($dailyViewFilters: PlanningDailyViewFilters!) {
  planningDailyViewPeople(filters: $dailyViewFilters) {
    last_updated_at
    data {
      user {
        ...AllocationsColumnHeader_User
      }
      items {
        capacity
        workStatus
        date
        holiday
        total_tracked_for_date
        items {
          id
          completed
          type
          total_time
          from_time
          to_time
          date
          note
          global
          teams {
            team {
              id
            }
          }
          createdBy {
            id
            full_name
            profile {
              hex_color
            }
          }
          time_tracking_work_type_id
          userStats {
            tracked_time_for_item
            has_running_timer
          }
          stats {
            ...CapacityAllocationItemStats
          }
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${AllocationsColumnHeader_UserFragmentDoc}
${CapacityAllocationItemStatsFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function usePlanningDailyViewPeopleQuery(options: Omit<Urql.UseQueryArgs<PlanningDailyViewPeopleQueryVariables>, 'query'>) {
  return Urql.useQuery<PlanningDailyViewPeopleQuery, PlanningDailyViewPeopleQueryVariables>({ query: PlanningDailyViewPeopleDocument, ...options });
};
export const ProjectsSimpleDocument = gql`
    query ProjectsSimple($clientId: ID, $brandId: ID, $orIdIn: [ID!], $withProBono: Boolean, $withArchived: Boolean, $my_projects: Boolean) {
  projectsSimpleMap(
    client_id: $clientId
    brand_id: $brandId
    orIdIn: $orIdIn
    withProBono: $withProBono
    withArchived: $withArchived
    my_projects: $my_projects
  ) {
    id
    code
    team_id
    title
    brand_id
    billable
    type
    project_manager_id
  }
}
    `;

export function useProjectsSimpleQuery(options?: Omit<Urql.UseQueryArgs<ProjectsSimpleQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectsSimpleQuery, ProjectsSimpleQueryVariables>({ query: ProjectsSimpleDocument, ...options });
};
export const TrackedForDayDocument = gql`
    query TrackedForDay($user_id: ID!, $date: Date!) {
  timeTrackingItems(user_id: $user_id, from: $date, to: $date) {
    ...TimeTrackingEntry
  }
}
    ${TimeTrackingEntryFragmentDoc}`;

export function useTrackedForDayQuery(options: Omit<Urql.UseQueryArgs<TrackedForDayQueryVariables>, 'query'>) {
  return Urql.useQuery<TrackedForDayQuery, TrackedForDayQueryVariables>({ query: TrackedForDayDocument, ...options });
};
export const UtilizationReportExportDocument = gql`
    query UtilizationReportExport($dataSource: UtilizationReportDataSource!, $where: UtilizationReportWhereConditions, $from: Date!, $to: Date!) {
  utilizationReportExport(
    dataSource: $dataSource
    where: $where
    from: $from
    to: $to
  )
}
    `;

export function useUtilizationReportExportQuery(options: Omit<Urql.UseQueryArgs<UtilizationReportExportQueryVariables>, 'query'>) {
  return Urql.useQuery<UtilizationReportExportQuery, UtilizationReportExportQueryVariables>({ query: UtilizationReportExportDocument, ...options });
};
export const UtilizationReportDocument = gql`
    query UtilizationReport($dataSource: UtilizationReportDataSource!, $where: UtilizationReportWhereConditions, $page: BigInt!, $first: BigInt!, $from: Date!, $to: Date!, $orderBy: [UtilizationReportOrderByClause!]) {
  utilizationReport(
    dataSource: $dataSource
    where: $where
    page: $page
    first: $first
    from: $from
    to: $to
    orderBy: $orderBy
  ) {
    data {
      user {
        id
        full_name
        profile {
          hex_color
          utilization_range_from
          utilization_range_to
          defaultWorktype {
            title
          }
        }
        team {
          name
        }
        image {
          urls {
            thumbnail
          }
        }
      }
      report {
        total_time
        available_time
        remaining_time
        time_off
        overtime
        combined_time
        combined_time_billable
        budgeted_time
        budgeted_time_billable
        allocated_time
        allocated_time_billable
        tracked_time
        tracked_time_billable
        utilization_percentage
        utilization_percentage_billable
        combined_amount_billable
        budgeted_amount_billable
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

export function useUtilizationReportQuery(options: Omit<Urql.UseQueryArgs<UtilizationReportQueryVariables>, 'query'>) {
  return Urql.useQuery<UtilizationReportQuery, UtilizationReportQueryVariables>({ query: UtilizationReportDocument, ...options });
};
export const UtilizationReportFilterOptionsDocument = gql`
    query UtilizationReportFilterOptions {
  teamSimpleMap {
    id
    name
  }
  userSimpleMap {
    id
    full_name
    codename
  }
  timeTrackingWorkTypes {
    id
    title
  }
}
    `;

export function useUtilizationReportFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<UtilizationReportFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<UtilizationReportFilterOptionsQuery, UtilizationReportFilterOptionsQueryVariables>({ query: UtilizationReportFilterOptionsDocument, ...options });
};
export const UtilizationReportGroupedByDocument = gql`
    query UtilizationReportGroupedBy($groupBy: UtilizationReportGroupBy!, $dataSource: UtilizationReportDataSource!, $where: UtilizationReportWhereConditions, $page: BigInt!, $first: BigInt!, $from: Date!, $to: Date!, $orderBy: [UtilizationReportOrderByClause!], $groupOrderBy: [UtilizationReportGroupOrderByClause!]) {
  utilizationReportGroups(
    groupBy: $groupBy
    dataSource: $dataSource
    where: $where
    page: $page
    first: $first
    from: $from
    to: $to
    orderBy: $orderBy
    groupOrderBy: $groupOrderBy
  ) {
    data {
      group_title
      report {
        total_time
        available_time
        remaining_time
        time_off
        overtime
        combined_time
        combined_time_billable
        budgeted_time
        budgeted_time_billable
        allocated_time
        allocated_time_billable
        tracked_time
        tracked_time_billable
        utilization_percentage
        utilization_percentage_billable
        combined_amount_billable
        budgeted_amount_billable
      }
      items {
        user {
          id
          full_name
          profile {
            hex_color
            utilization_range_from
            utilization_range_to
            defaultWorktype {
              title
            }
          }
          team {
            name
          }
          image {
            urls {
              thumbnail
            }
          }
        }
        report {
          total_time
          available_time
          remaining_time
          time_off
          overtime
          combined_time
          combined_time_billable
          budgeted_time
          budgeted_time_billable
          allocated_time
          allocated_time_billable
          tracked_time
          tracked_time_billable
          utilization_percentage
          utilization_percentage_billable
          combined_amount_billable
          budgeted_amount_billable
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

export function useUtilizationReportGroupedByQuery(options: Omit<Urql.UseQueryArgs<UtilizationReportGroupedByQueryVariables>, 'query'>) {
  return Urql.useQuery<UtilizationReportGroupedByQuery, UtilizationReportGroupedByQueryVariables>({ query: UtilizationReportGroupedByDocument, ...options });
};
export const UtilizationReportStatsDocument = gql`
    query UtilizationReportStats($dataSource: UtilizationReportDataSource!, $where: UtilizationReportWhereConditions, $from: Date!, $to: Date!) {
  utilizationReportSummary(
    dataSource: $dataSource
    where: $where
    from: $from
    to: $to
  ) {
    total_time
    available_time
    remaining_time
    time_off
    overtime
    combined_time
    combined_time_billable
    budgeted_time
    budgeted_time_billable
    allocated_time
    allocated_time_billable
    tracked_time
    tracked_time_billable
    utilization_percentage
    utilization_percentage_billable
  }
}
    `;

export function useUtilizationReportStatsQuery(options: Omit<Urql.UseQueryArgs<UtilizationReportStatsQueryVariables>, 'query'>) {
  return Urql.useQuery<UtilizationReportStatsQuery, UtilizationReportStatsQueryVariables>({ query: UtilizationReportStatsDocument, ...options });
};
export const UtilizationUserReportDataDocument = gql`
    query UtilizationUserReportData($dataSource: UtilizationReportDataSource!, $userId: ID!, $from: Date!, $to: Date!) {
  utilizationUserReport(
    dataSource: $dataSource
    userId: $userId
    from: $from
    to: $to
  ) {
    user {
      id
      full_name
      profile {
        hex_color
        utilization_range_from
        utilization_range_to
        defaultWorktype {
          title
        }
      }
      team {
        name
      }
      image {
        urls {
          thumbnail
        }
      }
    }
    report {
      total_time
      available_time
      remaining_time
      time_off
      overtime
      combined_time
      combined_time_billable
      budgeted_time
      budgeted_time_billable
      allocated_time
      allocated_time_billable
      tracked_time
      tracked_time_billable
      utilization_percentage
      utilization_percentage_billable
    }
  }
  utilizationTaskReport(
    dataSource: $dataSource
    userId: $userId
    from: $from
    to: $to
  ) {
    task {
      id
      name
      status {
        name
        foreground_color
        background_color
      }
      ourWorkBudgetItem {
        title
        project {
          title
          id
          code
        }
      }
    }
    budgeted_time
    budgeted_time_in_range
    remaining_amount
    remaining_time
    remaining_time_in_range
    remaining_time_in_percent
    tracked_amount
    tracked_in_range_amount
    tracked_time
    tracked_time_percent
    tracked_time_in_range
    tracked_time_in_range_percent
    allocated_amount
    allocated_in_range_amount
    allocated_time
    allocated_time_percent
    allocated_time_in_range
    allocated_time_in_range_percent
    over_budget_amount
    over_budget_time
    over_budget_time_in_percent
    total_task_budget_amount
    total_task_budget_in_range
  }
}
    `;

export function useUtilizationUserReportDataQuery(options: Omit<Urql.UseQueryArgs<UtilizationUserReportDataQueryVariables>, 'query'>) {
  return Urql.useQuery<UtilizationUserReportDataQuery, UtilizationUserReportDataQueryVariables>({ query: UtilizationUserReportDataDocument, ...options });
};
export const TimeAndMaterialsInvoiceDataDocument = gql`
    query TimeAndMaterialsInvoiceData($project_id: ID!, $groupBy: TimeMaterialsInvoiceDataGroupByEnum!, $from: Date!, $to: Date!, $filters: timeMaterialsQueryArgs, $outgoing_invoice_id: ID) {
  timeMaterialsInvoiceData(
    project_id: $project_id
    groupBy: $groupBy
    from: $from
    to: $to
    filters: $filters
    outgoing_invoice_id: $outgoing_invoice_id
  ) {
    project {
      id
      title
    }
    ourWorkBudgetItems {
      ...TimeMaterialsBudgetItemFragment
    }
    expenseBudgetItems {
      ...TimeMaterialsBudgetItemFragment
    }
  }
}
    ${TimeMaterialsBudgetItemFragmentFragmentDoc}`;

export function useTimeAndMaterialsInvoiceDataQuery(options: Omit<Urql.UseQueryArgs<TimeAndMaterialsInvoiceDataQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeAndMaterialsInvoiceDataQuery, TimeAndMaterialsInvoiceDataQueryVariables>({ query: TimeAndMaterialsInvoiceDataDocument, ...options });
};
export const TimeAndMaterialsFilterOptionsDocument = gql`
    query TimeAndMaterialsFilterOptions($projectId: [ID!]) {
  userSimpleMap {
    id
    full_name
  }
  ourWorkBudgetItemsSimpleMap(project_id: $projectId) {
    id
    title
    category {
      name
    }
  }
  timeTrackingWorkTypes {
    id
    title
  }
}
    `;

export function useTimeAndMaterialsFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<TimeAndMaterialsFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeAndMaterialsFilterOptionsQuery, TimeAndMaterialsFilterOptionsQueryVariables>({ query: TimeAndMaterialsFilterOptionsDocument, ...options });
};
export const CreateOutgoingInvoiceDocument = gql`
    mutation CreateOutgoingInvoice($request_for_invoicing_id: ID!, $invoice_no: String, $invoice_order_sequence_id: ID!, $skip_date_validations: Boolean!) {
  createOutgoingInvoice(
    request_for_invoicing_id: $request_for_invoicing_id
    invoice_no: $invoice_no
    invoice_order_sequence_id: $invoice_order_sequence_id
    skip_date_validations: $skip_date_validations
  ) {
    id
  }
}
    `;

export function useCreateOutgoingInvoiceMutation() {
  return Urql.useMutation<CreateOutgoingInvoiceMutation, CreateOutgoingInvoiceMutationVariables>(CreateOutgoingInvoiceDocument);
};
export const UpdateOutgoingInvoiceDocument = gql`
    mutation UpdateOutgoingInvoice($input: UpdateOutgoingInvoiceInput!, $skip_date_validations: Boolean!) {
  updateOutgoingInvoice(
    input: $input
    skip_date_validations: $skip_date_validations
  ) {
    id
  }
}
    `;

export function useUpdateOutgoingInvoiceMutation() {
  return Urql.useMutation<UpdateOutgoingInvoiceMutation, UpdateOutgoingInvoiceMutationVariables>(UpdateOutgoingInvoiceDocument);
};
export const CreateProformaInvoiceDocument = gql`
    mutation CreateProformaInvoice($request_for_invoicing_id: ID!, $invoice_no: ID!, $invoice_order_sequence_id: ID!, $skip_date_validations: Boolean!) {
  createOutgoingProformaInvoice(
    request_for_invoicing_id: $request_for_invoicing_id
    invoice_no: $invoice_no
    invoice_order_sequence_id: $invoice_order_sequence_id
    skip_date_validations: $skip_date_validations
  ) {
    id
  }
}
    `;

export function useCreateProformaInvoiceMutation() {
  return Urql.useMutation<CreateProformaInvoiceMutation, CreateProformaInvoiceMutationVariables>(CreateProformaInvoiceDocument);
};
export const UpdateProformaInvoiceDocument = gql`
    mutation UpdateProformaInvoice($input: UpdateOutgoingProformaInvoiceInput!, $skip_date_validations: Boolean!) {
  updateOutgoingProformaInvoice(
    input: $input
    skip_date_validations: $skip_date_validations
  ) {
    id
  }
}
    `;

export function useUpdateProformaInvoiceMutation() {
  return Urql.useMutation<UpdateProformaInvoiceMutation, UpdateProformaInvoiceMutationVariables>(UpdateProformaInvoiceDocument);
};
export const CreateRequestForInvoicingDocument = gql`
    mutation CreateRequestForInvoicing($input: CreateRequestForInvoicingInput!, $skip_date_validations: Boolean!) {
  createRequestForInvoicing(
    input: $input
    skip_date_validations: $skip_date_validations
  ) {
    id
    workspace_bank_account_id
  }
}
    `;

export function useCreateRequestForInvoicingMutation() {
  return Urql.useMutation<CreateRequestForInvoicingMutation, CreateRequestForInvoicingMutationVariables>(CreateRequestForInvoicingDocument);
};
export const UpdateRequestForInvoicingDocument = gql`
    mutation UpdateRequestForInvoicing($input: UpdateRequestForInvoicingInput!, $skip_date_validations: Boolean!) {
  updateRequestForInvoicing(
    input: $input
    skip_date_validations: $skip_date_validations
  ) {
    id
    workspace_bank_account_id
  }
}
    `;

export function useUpdateRequestForInvoicingMutation() {
  return Urql.useMutation<UpdateRequestForInvoicingMutation, UpdateRequestForInvoicingMutationVariables>(UpdateRequestForInvoicingDocument);
};
export const BasicDataDocument = gql`
    query BasicData($type: ACCOUNTING_ACCOUNT_TYPE) {
  clientsSimpleMap {
    ...ClientSimpleOptionParts
    brands {
      ...BrandSimpleOptionParts
    }
  }
  userSimpleMap {
    ...UserSimpleOptionParts
  }
  vatRates {
    ...VatRateOptionParts
    deleted
  }
  teamSimpleMap {
    id
    name
  }
  accountingAccountsSimpleMap(type: $type) {
    id
    title
    account_number
  }
  accountingCentres(type: INVOICE) {
    ...CostCenter
  }
  invoicePaymentMethods {
    ...InvoicePaymentMethod
  }
}
    ${ClientSimpleOptionPartsFragmentDoc}
${BrandSimpleOptionPartsFragmentDoc}
${UserSimpleOptionPartsFragmentDoc}
${VatRateOptionPartsFragmentDoc}
${CostCenterFragmentDoc}
${InvoicePaymentMethodFragmentDoc}`;

export function useBasicDataQuery(options?: Omit<Urql.UseQueryArgs<BasicDataQueryVariables>, 'query'>) {
  return Urql.useQuery<BasicDataQuery, BasicDataQueryVariables>({ query: BasicDataDocument, ...options });
};
export const GetTotalInWordsDocument = gql`
    query GetTotalInWords($amount: BigInt!, $language: String!) {
  getTotalInWords(amount: $amount, language: $language)
}
    `;

export function useGetTotalInWordsQuery(options: Omit<Urql.UseQueryArgs<GetTotalInWordsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTotalInWordsQuery, GetTotalInWordsQueryVariables>({ query: GetTotalInWordsDocument, ...options });
};
export const BillingEntitiesDataDocument = gql`
    query BillingEntitiesData($client_id: ID!) {
  client(id: $client_id) {
    id
    billingEntities {
      ...BillingEntityOptionParts
      payment_due
      applies_vat
      country {
        id
        code
      }
      defaultCurrency {
        id
        code
      }
      workspaceCompany {
        id
      }
      workspaceBankAccount {
        id
      }
    }
  }
}
    ${BillingEntityOptionPartsFragmentDoc}`;

export function useBillingEntitiesDataQuery(options: Omit<Urql.UseQueryArgs<BillingEntitiesDataQueryVariables>, 'query'>) {
  return Urql.useQuery<BillingEntitiesDataQuery, BillingEntitiesDataQueryVariables>({ query: BillingEntitiesDataDocument, ...options });
};
export const BrandsDataDocument = gql`
    query BrandsData($brand_ids: Mixed!, $brandCount: Int!) {
  brands(
    filters: {where: {column: ID, operator: IN, value: $brand_ids}}
    first: $brandCount
  ) {
    data {
      id
      name
      defaultBillingEntity {
        id
      }
      client {
        id
        name
        workspaceCompany {
          ...WorkspaceCompany
          vat_no
          invoicePdfSettings {
            text_on_invoice
          }
        }
      }
      contacts {
        ...ContactOptionParts
      }
      creditAccounts {
        ...BrandCreditAccountOptionParts
        stats {
          id
          total_debit
          remaining_credit
        }
      }
    }
  }
}
    ${WorkspaceCompanyFragmentDoc}
${ContactOptionPartsFragmentDoc}
${BrandCreditAccountOptionPartsFragmentDoc}`;

export function useBrandsDataQuery(options: Omit<Urql.UseQueryArgs<BrandsDataQueryVariables>, 'query'>) {
  return Urql.useQuery<BrandsDataQuery, BrandsDataQueryVariables>({ query: BrandsDataDocument, ...options });
};
export const BulkConvertAmountDocument = gql`
    query BulkConvertAmount($items: [AmountToConvert!]!, $currency_id: ID!, $exchange_rate: BigInt!, $workspace_company_id: ID) {
  bulkConvertAmountFromWorkspaceCurrencyUsingUserExchangeRates(
    items: $items
    currency_id: $currency_id
    exchange_rate: $exchange_rate
    workspace_company_id: $workspace_company_id
  ) {
    amount
    unit_price
    identifier
  }
}
    `;

export function useBulkConvertAmountQuery(options: Omit<Urql.UseQueryArgs<BulkConvertAmountQueryVariables>, 'query'>) {
  return Urql.useQuery<BulkConvertAmountQuery, BulkConvertAmountQueryVariables>({ query: BulkConvertAmountDocument, ...options });
};
export const DocumentsDataDocument = gql`
    query DocumentsData($project_ids: [ID!], $brand_ids: [ID!]!) {
  otherDocumentsWithPdf(brand_ids: $brand_ids, project_ids: $project_ids) {
    id
    brands {
      id
    }
    projects {
      id
    }
    pdfFiles {
      ...PdfFile
    }
  }
  ordersWithPdf(brand_ids: $brand_ids, project_ids: $project_ids) {
    id
    brand {
      id
    }
    projects {
      id
    }
    pdfFiles {
      ...PdfFile
    }
  }
}
    ${PdfFileFragmentDoc}`;

export function useDocumentsDataQuery(options: Omit<Urql.UseQueryArgs<DocumentsDataQueryVariables>, 'query'>) {
  return Urql.useQuery<DocumentsDataQuery, DocumentsDataQueryVariables>({ query: DocumentsDataDocument, ...options });
};
export const OutgoingInvoiceDocument = gql`
    query OutgoingInvoice($id: ID!) {
  outgoingInvoice(id: $id) {
    ...OutgoingInvoiceFormParts
  }
}
    ${OutgoingInvoiceFormPartsFragmentDoc}`;

export function useOutgoingInvoiceQuery(options: Omit<Urql.UseQueryArgs<OutgoingInvoiceQueryVariables>, 'query'>) {
  return Urql.useQuery<OutgoingInvoiceQuery, OutgoingInvoiceQueryVariables>({ query: OutgoingInvoiceDocument, ...options });
};
export const ProformaInvoiceDocument = gql`
    query ProformaInvoice($id: ID!) {
  outgoingProformaInvoice(id: $id) {
    ...ProformaInvoiceFormParts
  }
}
    ${ProformaInvoiceFormPartsFragmentDoc}`;

export function useProformaInvoiceQuery(options: Omit<Urql.UseQueryArgs<ProformaInvoiceQueryVariables>, 'query'>) {
  return Urql.useQuery<ProformaInvoiceQuery, ProformaInvoiceQueryVariables>({ query: ProformaInvoiceDocument, ...options });
};
export const ProjectsDataDocument = gql`
    query ProjectsData($project_ids: Mixed!, $projectsCount: Int!) {
  projects(
    filters: {where: {column: ID, operator: IN, value: $project_ids}}
    first: $projectsCount
  ) {
    data {
      id
      title
      code
      start_date
      finished_at
      archived_at
      billable
      status
      type
      projectManager {
        id
      }
      contact {
        id
      }
      team {
        id
        name
      }
      brand {
        id
      }
      stats: statsCached {
        id
        credit
        uninvoiced
      }
      lastInvoice {
        outgoing_invoice_date
        outgoingInvoice {
          id
          invoice_no
          type
        }
      }
      ourWorkStructured {
        id
        name
        total_budget
        budget_category_id
        budgetItems {
          id
          title
          completed_at
          requested_for_deletion_at
          vat_percent_informative
          creditAccount {
            id
          }
          stats {
            total_budget
            credit
            uninvoiced
          }
          budget_positions {
            ...BudgetPosition
          }
          tasks {
            id
            name
            positionsSpent {
              spent
              timeTrackingWorkType {
                title
              }
            }
            ourWorkBudgetItem {
              stats {
                spent_budget
              }
            }
          }
        }
      }
      expensesWithoutOtherStructured {
        id
        name
        total_budget
        budget_category_id
        budgetItems {
          id
          title
          completed_at
          requested_for_deletion_at
          vat_percent_informative
          stats {
            total_budget
            credit
            uninvoiced
            real_expenses
            real_commission
            real_commission_relative
            planned_expenses
            planned_commission
            planned_commission_relative_computed
          }
        }
      }
      ordersSimpleMap {
        id
        purchase_order_no
      }
    }
  }
}
    ${BudgetPositionFragmentDoc}`;

export function useProjectsDataQuery(options: Omit<Urql.UseQueryArgs<ProjectsDataQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectsDataQuery, ProjectsDataQueryVariables>({ query: ProjectsDataDocument, ...options });
};
export const RequestForInvoicingDocument = gql`
    query RequestForInvoicing($id: ID!) {
  requestForInvoicing(id: $id) {
    ...RFIFormParts
  }
}
    ${RfiFormPartsFragmentDoc}`;

export function useRequestForInvoicingQuery(options: Omit<Urql.UseQueryArgs<RequestForInvoicingQueryVariables>, 'query'>) {
  return Urql.useQuery<RequestForInvoicingQuery, RequestForInvoicingQueryVariables>({ query: RequestForInvoicingDocument, ...options });
};
export const UnusedPaidProformaInvoicesDocument = gql`
    query UnusedPaidProformaInvoices($project_ids: [ID!]!) {
  unusedPaidOutgoingProformaInvoices(project_ids: $project_ids) {
    ...ProformaInvoiceOptions
  }
}
    ${ProformaInvoiceOptionsFragmentDoc}`;

export function useUnusedPaidProformaInvoicesQuery(options: Omit<Urql.UseQueryArgs<UnusedPaidProformaInvoicesQueryVariables>, 'query'>) {
  return Urql.useQuery<UnusedPaidProformaInvoicesQuery, UnusedPaidProformaInvoicesQueryVariables>({ query: UnusedPaidProformaInvoicesDocument, ...options });
};
export const OrdersDocument = gql`
    query Orders($filters: OrderQueryArgs, $first: Int, $page: Int) {
  orders(filters: $filters, first: $first, page: $page) {
    data {
      id
      purchase_order_no
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

export function useOrdersQuery(options?: Omit<Urql.UseQueryArgs<OrdersQueryVariables>, 'query'>) {
  return Urql.useQuery<OrdersQuery, OrdersQueryVariables>({ query: OrdersDocument, ...options });
};
export const OutgoingInvoiceDetailDocument = gql`
    query OutgoingInvoiceDetail($id: ID!) {
  outgoingInvoice(id: $id) {
    id
    ...OutgoingInvoiceCoreParts
    ...OutgoingInvoiceNoteParts
    paid_at
    exchange_rate
    accountMoves {
      id
      bank_account_move_id
      amount
      exchange_rate
      date
      document_currency {
        code
        denomination
      }
      bankAccountMove {
        ...AccountMove
      }
    }
    teams {
      name
    }
    brands {
      id
      name
      image {
        urls {
          thumbnail
        }
      }
      creditAccounts {
        ...BrandCreditAccountOptionParts
      }
    }
    billingEntity {
      city
      legal_name
      street
      zip
      invoice_email
      country {
        id
        name
      }
      registration_no
      tax_no
      vat_no
    }
    contact {
      first_name
      last_name
      image {
        urls {
          thumbnail
        }
      }
    }
    currency {
      id
      code
      denomination
    }
    invoiceItems {
      id
      description
      amount_in_currency
      vat_percent_informative
    }
    orders {
      id
      purchase_order_no
      urls {
        preview
      }
    }
    proformaInvoicesPivot {
      invoice {
        id
        invoice_no
      }
      amount_in_currency
    }
    relatesToOutgoingProformaInvoice {
      id
      invoice_no
    }
    stats {
      total_amount_in_currency
      total_amount_with_vat_in_currency
      total_vat_in_currency
      vat_percent_informative
      total_amount_with_vat_in_currency_to_pay
      total_amount_with_vat_in_currency_to_pay_from_proforma_payments
    }
    ourWorkBudgetSplits {
      our_work_budget_item_id
      amount
      amount_in_percent
    }
    expenseBudgetSplits {
      expense_budget_item_id
      amount
    }
    prepaymentSplits {
      brand_credit_account_id
      amount
    }
    projects {
      id
      code
      title
      team {
        id
        name
      }
      ourWorkStructured {
        id
        name
        budgetItems {
          id
          title
          stats {
            total_budget
            credit
            uninvoiced
          }
        }
      }
      expensesStructured {
        id
        name
        budgetItems {
          id
          title
          completed_at
          stats {
            total_budget
            real_expenses
            planned_expenses
            credit
            real_commission
            real_commission_relative
            planned_commission
            planned_commission_relative_computed
          }
        }
      }
    }
    filesToAttach {
      public_id
      filename
      urls {
        original
      }
    }
    invoicePdf {
      preview
      download
    }
    invoiceProofOfPayments {
      invoice {
        id
        invoice_no
      }
    }
    projectTimeBilling {
      id
      date_from
      date_to
      project {
        id
        title
        code
        numeric_code
      }
    }
    modelLock {
      ...ModelLock
    }
    invoicePaymentMethod {
      ...InvoicePaymentMethod
    }
  }
}
    ${OutgoingInvoiceCorePartsFragmentDoc}
${OutgoingInvoiceNotePartsFragmentDoc}
${AccountMoveFragmentDoc}
${BrandCreditAccountOptionPartsFragmentDoc}
${ModelLockFragmentDoc}
${InvoicePaymentMethodFragmentDoc}`;

export function useOutgoingInvoiceDetailQuery(options: Omit<Urql.UseQueryArgs<OutgoingInvoiceDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<OutgoingInvoiceDetailQuery, OutgoingInvoiceDetailQueryVariables>({ query: OutgoingInvoiceDetailDocument, ...options });
};
export const ProformaInvoiceDetailDocument = gql`
    query ProformaInvoiceDetail($id: ID!) {
  outgoingProformaInvoice(id: $id) {
    id
    ...ProformaInvoiceCoreParts
    ...ProformaInvoiceNoteParts
    paid_at
    exchange_rate
    accountMoves {
      id
      bank_account_move_id
      amount
      exchange_rate
      date
      document_currency {
        code
        denomination
      }
      bankAccountMove {
        ...AccountMove
      }
    }
    teams {
      name
    }
    brands {
      id
      name
      image {
        urls {
          thumbnail
        }
      }
      creditAccounts {
        id
        title
      }
    }
    billingEntity {
      city
      legal_name
      street
      zip
      invoice_email
      country {
        id
        name
      }
      registration_no
      tax_no
      vat_no
    }
    contact {
      first_name
      last_name
      image {
        urls {
          thumbnail
        }
      }
    }
    currency {
      id
      code
      denomination
    }
    invoiceItems {
      id
      description
      amount_in_currency
      vat_percent_informative
    }
    stats {
      total_amount_in_currency
      total_amount_with_vat_in_currency
      total_vat_in_currency
      vat_percent_informative
      unused_amount_in_currency
      unused_amount
    }
    projects {
      id
      code
      title
      team {
        id
        name
      }
      ourWorkStructured {
        id
        name
        budgetItems {
          id
          title
          stats {
            total_budget
            credit
            uninvoiced
          }
        }
      }
      expensesStructured {
        id
        name
        budgetItems {
          id
          title
          completed_at
          stats {
            total_budget
            real_expenses
            planned_expenses
            credit
            real_commission
            real_commission_relative
            planned_commission
            planned_commission_relative_computed
          }
        }
      }
    }
    filesToAttach {
      public_id
      filename
      urls {
        original
      }
    }
    invoicePdf {
      preview
      download
    }
    proofOfPayments {
      id
      invoice_no
    }
    modelLock {
      ...ModelLock
    }
    invoicePaymentMethod {
      ...InvoicePaymentMethod
    }
  }
}
    ${ProformaInvoiceCorePartsFragmentDoc}
${ProformaInvoiceNotePartsFragmentDoc}
${AccountMoveFragmentDoc}
${ModelLockFragmentDoc}
${InvoicePaymentMethodFragmentDoc}`;

export function useProformaInvoiceDetailQuery(options: Omit<Urql.UseQueryArgs<ProformaInvoiceDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<ProformaInvoiceDetailQuery, ProformaInvoiceDetailQueryVariables>({ query: ProformaInvoiceDetailDocument, ...options });
};
export const DeleteOutgoingProformaInvoiceDocument = gql`
    mutation DeleteOutgoingProformaInvoice($id: ID!) {
  deleteOutgoingProformaInvoice(id: $id)
}
    `;

export function useDeleteOutgoingProformaInvoiceMutation() {
  return Urql.useMutation<DeleteOutgoingProformaInvoiceMutation, DeleteOutgoingProformaInvoiceMutationVariables>(DeleteOutgoingProformaInvoiceDocument);
};
export const MarkProformaAsPaidDocument = gql`
    mutation MarkProformaAsPaid($id: ID!, $date: Date, $create_summary_invoice: Boolean) {
  markOutgoingProformaInvoiceAsPaid(
    id: $id
    date: $date
    create_summary_invoice: $create_summary_invoice
  ) {
    id
  }
}
    `;

export function useMarkProformaAsPaidMutation() {
  return Urql.useMutation<MarkProformaAsPaidMutation, MarkProformaAsPaidMutationVariables>(MarkProformaAsPaidDocument);
};
export const MarkProformaAsUnpaidDocument = gql`
    mutation MarkProformaAsUnpaid($id: ID!, $remove_matched_payments: Boolean! = false) {
  markOutgoingProformaInvoiceAsUnpaid(
    id: $id
    remove_matched_payments: $remove_matched_payments
  ) {
    id
    paid_at
  }
}
    `;

export function useMarkProformaAsUnpaidMutation() {
  return Urql.useMutation<MarkProformaAsUnpaidMutation, MarkProformaAsUnpaidMutationVariables>(MarkProformaAsUnpaidDocument);
};
export const SendProformaDocument = gql`
    mutation SendProforma($id: ID!) {
  sendOutgoingProformaInvoice(id: $id)
}
    `;

export function useSendProformaMutation() {
  return Urql.useMutation<SendProformaMutation, SendProformaMutationVariables>(SendProformaDocument);
};
export const SendProformaBulkDocument = gql`
    mutation SendProformaBulk($ids: [ID!]!) {
  sendOutgoingProformaInvoiceBulk(id: $ids)
}
    `;

export function useSendProformaBulkMutation() {
  return Urql.useMutation<SendProformaBulkMutation, SendProformaBulkMutationVariables>(SendProformaBulkDocument);
};
export const SendOutgoingProformaDocument = gql`
    mutation SendOutgoingProforma($id: ID!, $recipients: [String], $subject: String, $content: String, $attachments: [ID]) {
  sendOutgoingProformaInvoice(
    id: $id
    recipients: $recipients
    subject: $subject
    content: $content
    attachments: $attachments
  )
}
    `;

export function useSendOutgoingProformaMutation() {
  return Urql.useMutation<SendOutgoingProformaMutation, SendOutgoingProformaMutationVariables>(SendOutgoingProformaDocument);
};
export const BulkDownloadProformaInvoicesDocument = gql`
    query BulkDownloadProformaInvoices($ids: [ID!]!) {
  bulkDownloadOutgoingProformaInvoices(ids: $ids)
}
    `;

export function useBulkDownloadProformaInvoicesQuery(options: Omit<Urql.UseQueryArgs<BulkDownloadProformaInvoicesQueryVariables>, 'query'>) {
  return Urql.useQuery<BulkDownloadProformaInvoicesQuery, BulkDownloadProformaInvoicesQueryVariables>({ query: BulkDownloadProformaInvoicesDocument, ...options });
};
export const GetProformaEmailDataDocument = gql`
    query GetProformaEmailData($proforma_invoice_id: ID!) {
  getProformaInvoiceEmailData(outgoing_proforma_invoice_id: $proforma_invoice_id) {
    ...EmailData
  }
}
    ${EmailDataFragmentDoc}`;

export function useGetProformaEmailDataQuery(options: Omit<Urql.UseQueryArgs<GetProformaEmailDataQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProformaEmailDataQuery, GetProformaEmailDataQueryVariables>({ query: GetProformaEmailDataDocument, ...options });
};
export const ProformaInvoicesOptionsDocument = gql`
    query ProformaInvoicesOptions {
  clientsSimpleMap {
    ...ClientSimpleOptionParts
    brands {
      ...BrandSimpleOptionParts
    }
  }
  projectManagerSimpleMap {
    id
    full_name
    codename
  }
}
    ${ClientSimpleOptionPartsFragmentDoc}
${BrandSimpleOptionPartsFragmentDoc}`;

export function useProformaInvoicesOptionsQuery(options?: Omit<Urql.UseQueryArgs<ProformaInvoicesOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ProformaInvoicesOptionsQuery, ProformaInvoicesOptionsQueryVariables>({ query: ProformaInvoicesOptionsDocument, ...options });
};
export const ProformaInvoicesTableDataDocument = gql`
    query ProformaInvoicesTableData($filters: OIProformaQueryArgs, $first: Int, $page: Int) {
  outgoingProformaInvoices(filters: $filters, first: $first, page: $page) {
    data {
      id
      ...ProformaInvoiceCoreParts
      abraflexi_exported
      documentExports {
        ...DocumentExport
      }
      paid_at
      note
      internal_note
      workspace_company_id
      exchange_rate
      summaryInvoices {
        id
        invoice_no
      }
      invoicePdf {
        preview
        download
      }
      proofOfPayments {
        id
        invoice_no
        invoicePdf {
          preview
          download
        }
      }
      currency {
        id
        code
        denomination
      }
      owner {
        id
      }
      brands {
        id
        name
      }
      projects {
        id
        title
        code
      }
      emailLogs {
        ...EmailLog
      }
      stats {
        total_amount_in_currency
        total_amount_with_vat_in_currency
        unused_amount_in_currency
      }
      accountMoves {
        id
        amount
        amount_in_move_currency
        bank_account_move_id
        exchange_rate
        bankAccountMove {
          ...AccountMove
        }
      }
      modelLock {
        ...ModelLock
      }
      invoicePaymentMethod {
        ...InvoicePaymentMethod
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ProformaInvoiceCorePartsFragmentDoc}
${DocumentExportFragmentDoc}
${EmailLogFragmentDoc}
${AccountMoveFragmentDoc}
${ModelLockFragmentDoc}
${InvoicePaymentMethodFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useProformaInvoicesTableDataQuery(options?: Omit<Urql.UseQueryArgs<ProformaInvoicesTableDataQueryVariables>, 'query'>) {
  return Urql.useQuery<ProformaInvoicesTableDataQuery, ProformaInvoicesTableDataQueryVariables>({ query: ProformaInvoicesTableDataDocument, ...options });
};
export const ProformaInvoicesTableSummaryDocument = gql`
    query ProformaInvoicesTableSummary($filters: OIProformaQueryArgs) {
  outgoingProformaInvoicesSummary(filters: $filters) {
    outgoingInvoiceIds
    invoices
    total_amount
    total_amount_with_vat
    payments_due
    overdue_by_less_than_30_days
    overdue_by_31_to_90_days
    overdue_by_91_to_365_days
    overdue_by_more_than_365_days
  }
}
    `;

export function useProformaInvoicesTableSummaryQuery(options?: Omit<Urql.UseQueryArgs<ProformaInvoicesTableSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<ProformaInvoicesTableSummaryQuery, ProformaInvoicesTableSummaryQueryVariables>({ query: ProformaInvoicesTableSummaryDocument, ...options });
};
export const ProformaOmegaExportDocument = gql`
    query ProformaOmegaExport($ids: [ID!]!) {
  omegaProformaExport(outgoing_proforma_invoice_ids: $ids)
}
    `;

export function useProformaOmegaExportQuery(options: Omit<Urql.UseQueryArgs<ProformaOmegaExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ProformaOmegaExportQuery, ProformaOmegaExportQueryVariables>({ query: ProformaOmegaExportDocument, ...options });
};
export const ProformaPohodaExportDocument = gql`
    query ProformaPohodaExport($outgoingProformaInvoiceIds: [ID!]!) {
  pohodaOPIExport(outgoing_proforma_invoice_ids: $outgoingProformaInvoiceIds)
}
    `;

export function useProformaPohodaExportQuery(options: Omit<Urql.UseQueryArgs<ProformaPohodaExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ProformaPohodaExportQuery, ProformaPohodaExportQueryVariables>({ query: ProformaPohodaExportDocument, ...options });
};
export const ProformaPremierExportDocument = gql`
    query ProformaPremierExport($outgoing_proforma_invoice_ids: [ID!]!) {
  premierProformaOIExport(
    outgoing_proforma_invoice_ids: $outgoing_proforma_invoice_ids
  )
}
    `;

export function useProformaPremierExportQuery(options: Omit<Urql.UseQueryArgs<ProformaPremierExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ProformaPremierExportQuery, ProformaPremierExportQueryVariables>({ query: ProformaPremierExportDocument, ...options });
};
export const DeleteRequestForInvoicingDocument = gql`
    mutation DeleteRequestForInvoicing($id: ID!) {
  deleteRequestForInvoicing(id: $id) {
    id
  }
}
    `;

export function useDeleteRequestForInvoicingMutation() {
  return Urql.useMutation<DeleteRequestForInvoicingMutation, DeleteRequestForInvoicingMutationVariables>(DeleteRequestForInvoicingDocument);
};
export const SubmitRequestForInvoicingDocument = gql`
    mutation SubmitRequestForInvoicing($id: ID!) {
  submitRequestForInvoicing(id: $id) {
    id
  }
}
    `;

export function useSubmitRequestForInvoicingMutation() {
  return Urql.useMutation<SubmitRequestForInvoicingMutation, SubmitRequestForInvoicingMutationVariables>(SubmitRequestForInvoicingDocument);
};
export const DeleteRequestsForInvoicingBulkDocument = gql`
    mutation DeleteRequestsForInvoicingBulk($id: [ID!]!) {
  deleteRequestsForInvoicingBulk(id: $id) {
    total
    successful
    failed
  }
}
    `;

export function useDeleteRequestsForInvoicingBulkMutation() {
  return Urql.useMutation<DeleteRequestsForInvoicingBulkMutation, DeleteRequestsForInvoicingBulkMutationVariables>(DeleteRequestsForInvoicingBulkDocument);
};
export const SubmitRequestsForInvoicingBulkDocument = gql`
    mutation SubmitRequestsForInvoicingBulk($id: [ID!]!) {
  submitRequestsForInvoicingBulk(id: $id) {
    total
    successful
    failed
  }
}
    `;

export function useSubmitRequestsForInvoicingBulkMutation() {
  return Urql.useMutation<SubmitRequestsForInvoicingBulkMutation, SubmitRequestsForInvoicingBulkMutationVariables>(SubmitRequestsForInvoicingBulkDocument);
};
export const GetRequestsForInvoicingDocument = gql`
    query GetRequestsForInvoicing($page: Int, $first: Int, $filters: RequestForInvoicingQueryArgs) {
  requestsForInvoicingSummary(filters: $filters) {
    requestForInvoicingIds
  }
  requestsForInvoicing(page: $page, first: $first, filters: $filters) {
    data {
      id
      type
      status
      date_of_supply
      created_at
      submit_date
      note
      internal_note
      brands {
        id
        name
      }
      stats {
        total_amount
        total_amount_with_vat
      }
      projects {
        id
        title
        code
      }
      owner {
        id
      }
      invoicePaymentMethod {
        ...InvoicePaymentMethod
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${InvoicePaymentMethodFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useGetRequestsForInvoicingQuery(options?: Omit<Urql.UseQueryArgs<GetRequestsForInvoicingQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRequestsForInvoicingQuery, GetRequestsForInvoicingQueryVariables>({ query: GetRequestsForInvoicingDocument, ...options });
};
export const GetRequestsForInvoicingSummaryDocument = gql`
    query GetRequestsForInvoicingSummary($filters: RequestForInvoicingQueryArgs) {
  requestsForInvoicingSummary(filters: $filters) {
    requestForInvoicingIds
  }
}
    `;

export function useGetRequestsForInvoicingSummaryQuery(options?: Omit<Urql.UseQueryArgs<GetRequestsForInvoicingSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRequestsForInvoicingSummaryQuery, GetRequestsForInvoicingSummaryQueryVariables>({ query: GetRequestsForInvoicingSummaryDocument, ...options });
};
export const RequestsForInvoicingFiltersDocument = gql`
    query RequestsForInvoicingFilters {
  clientsSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    full_name
    codename
  }
  brandsSimpleMap: clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
}
    `;

export function useRequestsForInvoicingFiltersQuery(options?: Omit<Urql.UseQueryArgs<RequestsForInvoicingFiltersQueryVariables>, 'query'>) {
  return Urql.useQuery<RequestsForInvoicingFiltersQuery, RequestsForInvoicingFiltersQueryVariables>({ query: RequestsForInvoicingFiltersDocument, ...options });
};
export const OutgoingInvoiceItemsListingDocument = gql`
    query OutgoingInvoiceItemsListing($filters: OIBudgetItemsTimeBillingQueryArgs) {
  oiBudgetItemsForTimeBilling(filters: $filters) {
    data {
      ...InvoiceBudgetItemListItem
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${InvoiceBudgetItemListItemFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useOutgoingInvoiceItemsListingQuery(options?: Omit<Urql.UseQueryArgs<OutgoingInvoiceItemsListingQueryVariables>, 'query'>) {
  return Urql.useQuery<OutgoingInvoiceItemsListingQuery, OutgoingInvoiceItemsListingQueryVariables>({ query: OutgoingInvoiceItemsListingDocument, ...options });
};
export const OutgoingInvoiceItemsListingSummaryDocument = gql`
    query OutgoingInvoiceItemsListingSummary($filters: OIBudgetItemsTimeBillingQueryArgs) {
  oiBudgetItemsForTimeBillingSummary(filters: $filters) {
    count
    amount
  }
}
    `;

export function useOutgoingInvoiceItemsListingSummaryQuery(options?: Omit<Urql.UseQueryArgs<OutgoingInvoiceItemsListingSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<OutgoingInvoiceItemsListingSummaryQuery, OutgoingInvoiceItemsListingSummaryQueryVariables>({ query: OutgoingInvoiceItemsListingSummaryDocument, ...options });
};
export const OutgoingInvoiceItemsListingFilterOptionsDocument = gql`
    query OutgoingInvoiceItemsListingFilterOptions {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projectsSimpleMap {
    id
    title
    code
  }
  projectManagerSimpleMap {
    id
    full_name
  }
  projectCategories {
    id
    name
  }
}
    `;

export function useOutgoingInvoiceItemsListingFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<OutgoingInvoiceItemsListingFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<OutgoingInvoiceItemsListingFilterOptionsQuery, OutgoingInvoiceItemsListingFilterOptionsQueryVariables>({ query: OutgoingInvoiceItemsListingFilterOptionsDocument, ...options });
};
export const OutgoingInvoiceItemsListingBudgetItemFilterOptionsDocument = gql`
    query OutgoingInvoiceItemsListingBudgetItemFilterOptions($projectId: ID!) {
  ourWorkBudgetItemsSimpleMap(project_id: [$projectId]) {
    id
    title
    category {
      name
    }
  }
  expenseBudgetItemsSimpleMap(project_id: $projectId) {
    id
    title
    category {
      name
    }
  }
}
    `;

export function useOutgoingInvoiceItemsListingBudgetItemFilterOptionsQuery(options: Omit<Urql.UseQueryArgs<OutgoingInvoiceItemsListingBudgetItemFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<OutgoingInvoiceItemsListingBudgetItemFilterOptionsQuery, OutgoingInvoiceItemsListingBudgetItemFilterOptionsQueryVariables>({ query: OutgoingInvoiceItemsListingBudgetItemFilterOptionsDocument, ...options });
};
export const MarkOutgoingInvoiceAsPaidDocument = gql`
    mutation MarkOutgoingInvoiceAsPaid($id: ID!, $date: Date) {
  markOutgoingInvoiceAsPaid(id: $id, date: $date) {
    id
  }
}
    `;

export function useMarkOutgoingInvoiceAsPaidMutation() {
  return Urql.useMutation<MarkOutgoingInvoiceAsPaidMutation, MarkOutgoingInvoiceAsPaidMutationVariables>(MarkOutgoingInvoiceAsPaidDocument);
};
export const MarkOutgoingInvoiceAsUnpaidDocument = gql`
    mutation MarkOutgoingInvoiceAsUnpaid($id: ID!, $remove_matched_payments: Boolean! = false) {
  markOutgoingInvoiceAsUnpaid(
    id: $id
    remove_matched_payments: $remove_matched_payments
  ) {
    id
    paid_at
  }
}
    `;

export function useMarkOutgoingInvoiceAsUnpaidMutation() {
  return Urql.useMutation<MarkOutgoingInvoiceAsUnpaidMutation, MarkOutgoingInvoiceAsUnpaidMutationVariables>(MarkOutgoingInvoiceAsUnpaidDocument);
};
export const MarkOutgoingInvoiceAsPaidBulkDocument = gql`
    mutation MarkOutgoingInvoiceAsPaidBulk($id: [ID!]!, $date: Date) {
  markOutgoingInvoiceAsPaidBulk(id: $id, date: $date) {
    total
    successful
    failed
  }
}
    `;

export function useMarkOutgoingInvoiceAsPaidBulkMutation() {
  return Urql.useMutation<MarkOutgoingInvoiceAsPaidBulkMutation, MarkOutgoingInvoiceAsPaidBulkMutationVariables>(MarkOutgoingInvoiceAsPaidBulkDocument);
};
export const SendOutgoingInvoiceDocument = gql`
    mutation SendOutgoingInvoice($id: ID!, $recipients: [String], $subject: String, $content: String, $attachments: [ID]) {
  sendOutgoingInvoice(
    id: $id
    recipients: $recipients
    subject: $subject
    content: $content
    attachments: $attachments
  )
}
    `;

export function useSendOutgoingInvoiceMutation() {
  return Urql.useMutation<SendOutgoingInvoiceMutation, SendOutgoingInvoiceMutationVariables>(SendOutgoingInvoiceDocument);
};
export const SendOutgoingInvoiceBulkDocument = gql`
    mutation SendOutgoingInvoiceBulk($ids: [ID!]!) {
  sendOutgoingInvoiceBulk(id: $ids)
}
    `;

export function useSendOutgoingInvoiceBulkMutation() {
  return Urql.useMutation<SendOutgoingInvoiceBulkMutation, SendOutgoingInvoiceBulkMutationVariables>(SendOutgoingInvoiceBulkDocument);
};
export const UpdateOutgoingInvoiceNumberDocument = gql`
    mutation UpdateOutgoingInvoiceNumber($input: UpdateOutgoingInvoiceNumberInput) {
  updateOutgoingInvoiceNumber(input: $input, force: true) {
    id
  }
}
    `;

export function useUpdateOutgoingInvoiceNumberMutation() {
  return Urql.useMutation<UpdateOutgoingInvoiceNumberMutation, UpdateOutgoingInvoiceNumberMutationVariables>(UpdateOutgoingInvoiceNumberDocument);
};
export const DeleteOutgoingInvoiceDocument = gql`
    mutation DeleteOutgoingInvoice($id: ID!) {
  deleteOutgoingInvoice(id: $id)
}
    `;

export function useDeleteOutgoingInvoiceMutation() {
  return Urql.useMutation<DeleteOutgoingInvoiceMutation, DeleteOutgoingInvoiceMutationVariables>(DeleteOutgoingInvoiceDocument);
};
export const GetOutgoingInvoicesFilterOptionsDocument = gql`
    query GetOutgoingInvoicesFilterOptions {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projectManagerSimpleMap {
    id
    full_name
    codename
  }
  projectCategories {
    id
    name
  }
  projectsSimpleMap {
    id
    code
    title
  }
}
    `;

export function useGetOutgoingInvoicesFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<GetOutgoingInvoicesFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOutgoingInvoicesFilterOptionsQuery, GetOutgoingInvoicesFilterOptionsQueryVariables>({ query: GetOutgoingInvoicesFilterOptionsDocument, ...options });
};
export const GetInvoiceEmailDataDocument = gql`
    query GetInvoiceEmailData($outgoing_invoice_id: ID!) {
  getInvoiceEmailData(outgoing_invoice_id: $outgoing_invoice_id) {
    ...EmailData
  }
}
    ${EmailDataFragmentDoc}`;

export function useGetInvoiceEmailDataQuery(options: Omit<Urql.UseQueryArgs<GetInvoiceEmailDataQueryVariables>, 'query'>) {
  return Urql.useQuery<GetInvoiceEmailDataQuery, GetInvoiceEmailDataQueryVariables>({ query: GetInvoiceEmailDataDocument, ...options });
};
export const GetOutgoingInvoiceSuggestedNumberDocument = gql`
    query GetOutgoingInvoiceSuggestedNumber($id: ID) {
  outgoingInvoice(id: $id) {
    sequence {
      next_invoice_no
    }
  }
}
    `;

export function useGetOutgoingInvoiceSuggestedNumberQuery(options?: Omit<Urql.UseQueryArgs<GetOutgoingInvoiceSuggestedNumberQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOutgoingInvoiceSuggestedNumberQuery, GetOutgoingInvoiceSuggestedNumberQueryVariables>({ query: GetOutgoingInvoiceSuggestedNumberDocument, ...options });
};
export const GetOutgoingInvoicesDocument = gql`
    query GetOutgoingInvoices($page: Int, $first: Int, $filters: OIQueryArgs) {
  outgoingInvoices(page: $page, first: $first, filters: $filters) {
    data {
      id
      ...OutgoingInvoiceCoreParts
      paid_at
      note
      internal_note
      abraflexi_exported
      xero_exported
      documentExports {
        ...DocumentExport
      }
      workspace_company_id
      exchange_rate
      invoicePdf {
        preview
        download
      }
      has_proforma_payments
      proformaInvoicesPivot {
        invoice {
          id
          invoice_no
        }
      }
      relatesToOutgoingProformaInvoice {
        id
        invoicePdf {
          preview
          download
        }
      }
      owner {
        id
        email
      }
      contact {
        email
      }
      brands {
        id
        name
      }
      billingEntity {
        invoice_email
        internal_name
        street
        city
      }
      projects {
        id
        title
        code
      }
      emailLogs {
        ...EmailLog
      }
      stats {
        total_amount
        total_amount_with_vat
        total_amount_in_currency
        total_amount_with_vat_in_currency
        billing_amount
        billing_amount_with_vat
      }
      accountMoves {
        id
        bank_account_move_id
        amount
        amount_in_move_currency
        exchange_rate
        bankAccountMove {
          ...AccountMove
        }
      }
      projectTimeBilling {
        id
        is_locked
      }
      modelLock {
        ...ModelLock
      }
      invoicePaymentMethod {
        ...InvoicePaymentMethod
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${OutgoingInvoiceCorePartsFragmentDoc}
${DocumentExportFragmentDoc}
${EmailLogFragmentDoc}
${AccountMoveFragmentDoc}
${ModelLockFragmentDoc}
${InvoicePaymentMethodFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useGetOutgoingInvoicesQuery(options?: Omit<Urql.UseQueryArgs<GetOutgoingInvoicesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOutgoingInvoicesQuery, GetOutgoingInvoicesQueryVariables>({ query: GetOutgoingInvoicesDocument, ...options });
};
export const GetOutgoingInvoicePrepaymentSplitsDocument = gql`
    query GetOutgoingInvoicePrepaymentSplits($id: ID!) {
  outgoingInvoice(id: $id) {
    prepaymentSplits {
      id
      brandCreditAccount {
        id
        title
      }
    }
  }
}
    `;

export function useGetOutgoingInvoicePrepaymentSplitsQuery(options: Omit<Urql.UseQueryArgs<GetOutgoingInvoicePrepaymentSplitsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOutgoingInvoicePrepaymentSplitsQuery, GetOutgoingInvoicePrepaymentSplitsQueryVariables>({ query: GetOutgoingInvoicePrepaymentSplitsDocument, ...options });
};
export const CfExportDocument = gql`
    query cfExport($from: Date, $to: Date) {
  cfExport(from: $from, to: $to)
}
    `;

export function useCfExportQuery(options?: Omit<Urql.UseQueryArgs<CfExportQueryVariables>, 'query'>) {
  return Urql.useQuery<CfExportQuery, CfExportQueryVariables>({ query: CfExportDocument, ...options });
};
export const NotPaidOiExportDocument = gql`
    query notPaidOIExport($filters: OIQueryArgs, $date: Date) {
  notPaidOIExport(filters: $filters, date: $date)
}
    `;

export function useNotPaidOiExportQuery(options?: Omit<Urql.UseQueryArgs<NotPaidOiExportQueryVariables>, 'query'>) {
  return Urql.useQuery<NotPaidOiExportQuery, NotPaidOiExportQueryVariables>({ query: NotPaidOiExportDocument, ...options });
};
export const ClientOiExportDocument = gql`
    query clientOIExport($filters: OIQueryArgs, $from: Date, $to: Date) {
  clientOIExport(filters: $filters, from: $from, to: $to)
}
    `;

export function useClientOiExportQuery(options?: Omit<Urql.UseQueryArgs<ClientOiExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ClientOiExportQuery, ClientOiExportQueryVariables>({ query: ClientOiExportDocument, ...options });
};
export const MrpOiExportDocument = gql`
    query mrpOIExport($from: Date!, $to: Date!) {
  mrpOIExport(from: $from, to: $to)
}
    `;

export function useMrpOiExportQuery(options: Omit<Urql.UseQueryArgs<MrpOiExportQueryVariables>, 'query'>) {
  return Urql.useQuery<MrpOiExportQuery, MrpOiExportQueryVariables>({ query: MrpOiExportDocument, ...options });
};
export const PohodaOiExportDocument = gql`
    query pohodaOIExport($ids: [ID!]!) {
  pohodaOIExport(outgoing_invoice_ids: $ids)
}
    `;

export function usePohodaOiExportQuery(options: Omit<Urql.UseQueryArgs<PohodaOiExportQueryVariables>, 'query'>) {
  return Urql.useQuery<PohodaOiExportQuery, PohodaOiExportQueryVariables>({ query: PohodaOiExportDocument, ...options });
};
export const PremierOiExportDocument = gql`
    query PremierOIExport($outgoing_invoice_ids: [ID!]!) {
  premierOIExport(outgoing_invoice_ids: $outgoing_invoice_ids)
}
    `;

export function usePremierOiExportQuery(options: Omit<Urql.UseQueryArgs<PremierOiExportQueryVariables>, 'query'>) {
  return Urql.useQuery<PremierOiExportQuery, PremierOiExportQueryVariables>({ query: PremierOiExportDocument, ...options });
};
export const ProlucOiExportDocument = gql`
    query prolucOIExport($from: Date!, $to: Date!) {
  prolucOIExport(from: $from, to: $to)
}
    `;

export function useProlucOiExportQuery(options: Omit<Urql.UseQueryArgs<ProlucOiExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ProlucOiExportQuery, ProlucOiExportQueryVariables>({ query: ProlucOiExportDocument, ...options });
};
export const BulkDownloadOutgoingInvoicesDocument = gql`
    query bulkDownloadOutgoingInvoices($ids: [ID!]!) {
  bulkDownloadOutgoingInvoices(ids: $ids)
}
    `;

export function useBulkDownloadOutgoingInvoicesQuery(options: Omit<Urql.UseQueryArgs<BulkDownloadOutgoingInvoicesQueryVariables>, 'query'>) {
  return Urql.useQuery<BulkDownloadOutgoingInvoicesQuery, BulkDownloadOutgoingInvoicesQueryVariables>({ query: BulkDownloadOutgoingInvoicesDocument, ...options });
};
export const VarioOiExportDocument = gql`
    query varioOIExport($ids: [ID!]!) {
  varioOIExport(outgoing_invoice_ids: $ids)
}
    `;

export function useVarioOiExportQuery(options: Omit<Urql.UseQueryArgs<VarioOiExportQueryVariables>, 'query'>) {
  return Urql.useQuery<VarioOiExportQuery, VarioOiExportQueryVariables>({ query: VarioOiExportDocument, ...options });
};
export const OutgoingInvoiceOmegaExportDocument = gql`
    query OutgoingInvoiceOmegaExport($ids: [ID!]!) {
  omegaExport(outgoing_invoice_ids: $ids)
}
    `;

export function useOutgoingInvoiceOmegaExportQuery(options: Omit<Urql.UseQueryArgs<OutgoingInvoiceOmegaExportQueryVariables>, 'query'>) {
  return Urql.useQuery<OutgoingInvoiceOmegaExportQuery, OutgoingInvoiceOmegaExportQueryVariables>({ query: OutgoingInvoiceOmegaExportDocument, ...options });
};
export const OutgoingInvoiceAbraFlexiExportDocument = gql`
    query OutgoingInvoiceAbraFlexiExport($ids: [ID!]!) {
  abraFlexiOIExport(outgoing_invoice_ids: $ids)
}
    `;

export function useOutgoingInvoiceAbraFlexiExportQuery(options: Omit<Urql.UseQueryArgs<OutgoingInvoiceAbraFlexiExportQueryVariables>, 'query'>) {
  return Urql.useQuery<OutgoingInvoiceAbraFlexiExportQuery, OutgoingInvoiceAbraFlexiExportQueryVariables>({ query: OutgoingInvoiceAbraFlexiExportDocument, ...options });
};
export const OutgoingInvoicesTableSummaryDocument = gql`
    query OutgoingInvoicesTableSummary($filters: OIQueryArgs) {
  outgoingInvoicesSummary(filters: $filters) {
    outgoingInvoiceIds
    total_amount
    total_vat
    total_amount_with_vat
    billing_amount
    billing_amount_vat
    billing_amount_with_vat
    paid_amount
    unpaid_amount
    payments_due_without_vat
    payments_due_vat
    payments_due
    overdue
    overdue_vat
    overdue_without_vat
    overdue_by_less_than_30_days_without_vat
    overdue_by_less_than_30_days_vat
    overdue_by_less_than_30_days
    overdue_by_31_to_90_days_without_vat
    overdue_by_31_to_90_days_vat
    overdue_by_31_to_90_days
    overdue_by_91_to_365_days_without_vat
    overdue_by_91_to_365_days_vat
    overdue_by_91_to_365_days
    overdue_by_more_than_365_days_without_vat
    overdue_by_more_than_365_days_vat
    overdue_by_more_than_365_days
    invoices
  }
}
    `;

export function useOutgoingInvoicesTableSummaryQuery(options?: Omit<Urql.UseQueryArgs<OutgoingInvoicesTableSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<OutgoingInvoicesTableSummaryQuery, OutgoingInvoicesTableSummaryQueryVariables>({ query: OutgoingInvoicesTableSummaryDocument, ...options });
};
export const ChangeOutgoingInvoiceDatesDocument = gql`
    mutation ChangeOutgoingInvoiceDates($id: ID!, $issue_date: Date!, $date_of_supply: Date!, $due_date: Date!, $paid_at: Date) {
  changeOutgoingInvoiceDates(
    id: $id
    issue_date: $issue_date
    date_of_supply: $date_of_supply
    due_date: $due_date
    paid_at: $paid_at
  )
}
    `;

export function useChangeOutgoingInvoiceDatesMutation() {
  return Urql.useMutation<ChangeOutgoingInvoiceDatesMutation, ChangeOutgoingInvoiceDatesMutationVariables>(ChangeOutgoingInvoiceDatesDocument);
};
export const ChangeOutgoingProformaInvoiceDatesDocument = gql`
    mutation ChangeOutgoingProformaInvoiceDates($id: ID!, $issue_date: Date!, $due_date: Date!, $paid_at: Date) {
  changeOutgoingProformaInvoiceDates(
    id: $id
    issue_date: $issue_date
    due_date: $due_date
    paid_at: $paid_at
  )
}
    `;

export function useChangeOutgoingProformaInvoiceDatesMutation() {
  return Urql.useMutation<ChangeOutgoingProformaInvoiceDatesMutation, ChangeOutgoingProformaInvoiceDatesMutationVariables>(ChangeOutgoingProformaInvoiceDatesDocument);
};
export const ProjectBillingsListDocument = gql`
    query ProjectBillingsList($filters: ProjectBillingsQueryArgs, $first: Int, $page: Int) {
  projectBillings(filters: $filters, first: $first, page: $page) {
    data {
      ...ProjectBillingRow
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ProjectBillingRowFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useProjectBillingsListQuery(options?: Omit<Urql.UseQueryArgs<ProjectBillingsListQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectBillingsListQuery, ProjectBillingsListQueryVariables>({ query: ProjectBillingsListDocument, ...options });
};
export const ProjectBillingsSummaryDocument = gql`
    query ProjectBillingsSummary($filters: ProjectBillingsQueryArgs) {
  projectBillingsSummary(filters: $filters) {
    ...ProjectBillingsSummaryFragment
  }
}
    ${ProjectBillingsSummaryFragmentFragmentDoc}`;

export function useProjectBillingsSummaryQuery(options?: Omit<Urql.UseQueryArgs<ProjectBillingsSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectBillingsSummaryQuery, ProjectBillingsSummaryQueryVariables>({ query: ProjectBillingsSummaryDocument, ...options });
};
export const ProjectBillingsFilterOptionsDocument = gql`
    query ProjectBillingsFilterOptions {
  projectsSimpleMap {
    id
    code
    title
  }
  teamSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    full_name
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  expenseBudgetCategories {
    id
    name
  }
  projectCategories {
    id
    name
  }
}
    `;

export function useProjectBillingsFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<ProjectBillingsFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectBillingsFilterOptionsQuery, ProjectBillingsFilterOptionsQueryVariables>({ query: ProjectBillingsFilterOptionsDocument, ...options });
};
export const InvoicingPlanExportBasicDocument = gql`
    query InvoicingPlanExportBasic($month: BigInt!, $year: BigInt!) {
  exportBillingPlan(month: $month, year: $year)
}
    `;

export function useInvoicingPlanExportBasicQuery(options: Omit<Urql.UseQueryArgs<InvoicingPlanExportBasicQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoicingPlanExportBasicQuery, InvoicingPlanExportBasicQueryVariables>({ query: InvoicingPlanExportBasicDocument, ...options });
};
export const InvoicingPlanExportDetailedDocument = gql`
    query InvoicingPlanExportDetailed($filters: ProjectBillingsQueryArgs) {
  projectBillingsExport(filters: $filters)
}
    `;

export function useInvoicingPlanExportDetailedQuery(options?: Omit<Urql.UseQueryArgs<InvoicingPlanExportDetailedQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoicingPlanExportDetailedQuery, InvoicingPlanExportDetailedQueryVariables>({ query: InvoicingPlanExportDetailedDocument, ...options });
};
export const CreateBillingPlanDocument = gql`
    mutation CreateBillingPlan($projectId: ID!) {
  createBillingPlan(project_id: $projectId) {
    id
  }
}
    `;

export function useCreateBillingPlanMutation() {
  return Urql.useMutation<CreateBillingPlanMutation, CreateBillingPlanMutationVariables>(CreateBillingPlanDocument);
};
export const UpdateBillingPlanDocument = gql`
    mutation UpdateBillingPlan($input: UpdateBillingPlanInput!) {
  updateBillingPlan(input: $input) {
    id
  }
}
    `;

export function useUpdateBillingPlanMutation() {
  return Urql.useMutation<UpdateBillingPlanMutation, UpdateBillingPlanMutationVariables>(UpdateBillingPlanDocument);
};
export const ProjectBillingPlanDataDocument = gql`
    query ProjectBillingPlanData($projectId: ID!) {
  project(id: $projectId) {
    id
    start_date
    expected_end_date
    stats {
      id
      total_budget
    }
    billingPlanByMonths {
      id
      period
      invoiced_amount
      items {
        id
        amount
        date
      }
    }
  }
}
    `;

export function useProjectBillingPlanDataQuery(options: Omit<Urql.UseQueryArgs<ProjectBillingPlanDataQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectBillingPlanDataQuery, ProjectBillingPlanDataQueryVariables>({ query: ProjectBillingPlanDataDocument, ...options });
};
export const CreateInvoiceFromBillingPlanDocument = gql`
    mutation CreateInvoiceFromBillingPlan($input: CreateInvoiceFromBillingPlanInput) {
  createInvoiceFromBillingPlan(input: $input) {
    id
  }
}
    `;

export function useCreateInvoiceFromBillingPlanMutation() {
  return Urql.useMutation<CreateInvoiceFromBillingPlanMutation, CreateInvoiceFromBillingPlanMutationVariables>(CreateInvoiceFromBillingPlanDocument);
};
export const InvoicingPlanFutureListDocument = gql`
    query InvoicingPlanFutureList($filters: BillingPlanCacheOverviewQueryArgs!, $first: Int, $page: Int) {
  billingPlanCacheOverview(filters: $filters, first: $first, page: $page) {
    data {
      ...InvoicingPlanAdvancedList
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${InvoicingPlanAdvancedListFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useInvoicingPlanFutureListQuery(options: Omit<Urql.UseQueryArgs<InvoicingPlanFutureListQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoicingPlanFutureListQuery, InvoicingPlanFutureListQueryVariables>({ query: InvoicingPlanFutureListDocument, ...options });
};
export const InvoicingPlanFutureListSummaryDocument = gql`
    query InvoicingPlanFutureListSummary($filters: BillingPlanCacheOverviewQueryArgs!) {
  billingPlanCacheOverviewSummary(filters: $filters) {
    projects
    planned_amount
    invoiced_amount
    uninvoiced_amount
  }
}
    `;

export function useInvoicingPlanFutureListSummaryQuery(options: Omit<Urql.UseQueryArgs<InvoicingPlanFutureListSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoicingPlanFutureListSummaryQuery, InvoicingPlanFutureListSummaryQueryVariables>({ query: InvoicingPlanFutureListSummaryDocument, ...options });
};
export const InvoicingPlanFutureListFilterOptionsDocument = gql`
    query InvoicingPlanFutureListFilterOptions {
  projectsSimpleMap {
    id
    code
    title
  }
  teamSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    full_name
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
}
    `;

export function useInvoicingPlanFutureListFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<InvoicingPlanFutureListFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<InvoicingPlanFutureListFilterOptionsQuery, InvoicingPlanFutureListFilterOptionsQueryVariables>({ query: InvoicingPlanFutureListFilterOptionsDocument, ...options });
};
export const MarkNotificationAsReadDocument = gql`
    mutation MarkNotificationAsRead($id: ID!) {
  markNotificationAsRead(id: $id) {
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;

export function useMarkNotificationAsReadMutation() {
  return Urql.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument);
};
export const MarkNotificationAsUnreadDocument = gql`
    mutation MarkNotificationAsUnread($id: ID!) {
  markNotificationAsUnread(id: $id) {
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;

export function useMarkNotificationAsUnreadMutation() {
  return Urql.useMutation<MarkNotificationAsUnreadMutation, MarkNotificationAsUnreadMutationVariables>(MarkNotificationAsUnreadDocument);
};
export const MarkAllNotificationsAsReadDocument = gql`
    mutation MarkAllNotificationsAsRead($groups: [NotificationGroup]) {
  markAllNotificationsAsRead(groups: $groups)
}
    `;

export function useMarkAllNotificationsAsReadMutation() {
  return Urql.useMutation<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>(MarkAllNotificationsAsReadDocument);
};
export const NotificationsDocument = gql`
    query Notifications($page: Int, $first: Int, $groups: [NotificationGroup], $type: NotificationType, $read: Boolean) {
  notifications(
    page: $page
    first: $first
    groups: $groups
    type: $type
    read: $read
  ) {
    data {
      ...Notification
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${NotificationFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useNotificationsQuery(options?: Omit<Urql.UseQueryArgs<NotificationsQueryVariables>, 'query'>) {
  return Urql.useQuery<NotificationsQuery, NotificationsQueryVariables>({ query: NotificationsDocument, ...options });
};
export const UnreadNotificationsCountDocument = gql`
    query UnreadNotificationsCount($groups: [NotificationGroup]) {
  unreadNotificationsCount(groups: $groups)
}
    `;

export function useUnreadNotificationsCountQuery(options?: Omit<Urql.UseQueryArgs<UnreadNotificationsCountQueryVariables>, 'query'>) {
  return Urql.useQuery<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>({ query: UnreadNotificationsCountDocument, ...options });
};
export const TaskNotificationsDocument = gql`
    query TaskNotifications($page: Int, $first: Int, $read: Boolean) {
  taskAndCommunicationNotifications(page: $page, first: $first, read: $read) {
    data {
      task {
        ...SimpleTask
      }
      notifications {
        ...TaskNotificationsNotification
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${SimpleTaskFragmentDoc}
${TaskNotificationsNotificationFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useTaskNotificationsQuery(options?: Omit<Urql.UseQueryArgs<TaskNotificationsQueryVariables>, 'query'>) {
  return Urql.useQuery<TaskNotificationsQuery, TaskNotificationsQueryVariables>({ query: TaskNotificationsDocument, ...options });
};
export const TaskNotificationsForScopedUserDocument = gql`
    query TaskNotificationsForScopedUser($page: Int, $first: Int, $read: Boolean) {
  taskAndCommunicationNotifications(page: $page, first: $first, read: $read) {
    data {
      task {
        ...SimpleTaskForClient
      }
      notifications {
        ...TaskNotificationsNotification
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${SimpleTaskForClientFragmentDoc}
${TaskNotificationsNotificationFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useTaskNotificationsForScopedUserQuery(options?: Omit<Urql.UseQueryArgs<TaskNotificationsForScopedUserQueryVariables>, 'query'>) {
  return Urql.useQuery<TaskNotificationsForScopedUserQuery, TaskNotificationsForScopedUserQueryVariables>({ query: TaskNotificationsForScopedUserDocument, ...options });
};
export const UpdateProjectBillingPlanDocument = gql`
    mutation UpdateProjectBillingPlan($input: updateProjectBillingPlanBudgetInput) {
  updateProjectBillingPlanBudget(input: $input) {
    ...BillingPlan
  }
}
    ${BillingPlanFragmentDoc}`;

export function useUpdateProjectBillingPlanMutation() {
  return Urql.useMutation<UpdateProjectBillingPlanMutation, UpdateProjectBillingPlanMutationVariables>(UpdateProjectBillingPlanDocument);
};
export const UpdateProjectBillingPlanSettingsDocument = gql`
    mutation UpdateProjectBillingPlanSettings($input: updateProjectBillingPlanSettingsInput) {
  updateProjectBillingPlanSettings(input: $input) {
    ...BillingPlanSettingsProject
  }
}
    ${BillingPlanSettingsProjectFragmentDoc}`;

export function useUpdateProjectBillingPlanSettingsMutation() {
  return Urql.useMutation<UpdateProjectBillingPlanSettingsMutation, UpdateProjectBillingPlanSettingsMutationVariables>(UpdateProjectBillingPlanSettingsDocument);
};
export const LockProjectBillingPlanDocument = gql`
    mutation LockProjectBillingPlan($projectId: ID!) {
  lockBillingPlanForProject(project_id: $projectId) {
    billingPlanSetting {
      locked_at
      lockedByUser {
        id
        full_name
      }
    }
  }
}
    `;

export function useLockProjectBillingPlanMutation() {
  return Urql.useMutation<LockProjectBillingPlanMutation, LockProjectBillingPlanMutationVariables>(LockProjectBillingPlanDocument);
};
export const BillingPlanDocument = gql`
    query BillingPlan($projectId: ID!, $billingItemType: BillingItemTypEnum!) {
  billingPlanBudget(project_id: $projectId, billing_item_type: $billingItemType) {
    ...BillingPlan
  }
}
    ${BillingPlanFragmentDoc}`;

export function useBillingPlanQuery(options: Omit<Urql.UseQueryArgs<BillingPlanQueryVariables>, 'query'>) {
  return Urql.useQuery<BillingPlanQuery, BillingPlanQueryVariables>({ query: BillingPlanDocument, ...options });
};
export const BillingPlanOptionsDocument = gql`
    query BillingPlanOptions($accountingCentreType: ACCOUNTING_CENTRE_TYPE!) {
  accountingCentres(type: $accountingCentreType) {
    ...CostCenter
  }
}
    ${CostCenterFragmentDoc}`;

export function useBillingPlanOptionsQuery(options: Omit<Urql.UseQueryArgs<BillingPlanOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<BillingPlanOptionsQuery, BillingPlanOptionsQueryVariables>({ query: BillingPlanOptionsDocument, ...options });
};
export const BillingPlanSettingsDocument = gql`
    query BillingPlanSettings($projectId: ID!) {
  project(id: $projectId) {
    ...BillingPlanSettingsProject
  }
  EmailTemplates {
    id
    type
    subject
    content
  }
  vatRates {
    id
    amount
    deleted
    default
  }
}
    ${BillingPlanSettingsProjectFragmentDoc}`;

export function useBillingPlanSettingsQuery(options: Omit<Urql.UseQueryArgs<BillingPlanSettingsQueryVariables>, 'query'>) {
  return Urql.useQuery<BillingPlanSettingsQuery, BillingPlanSettingsQueryVariables>({ query: BillingPlanSettingsDocument, ...options });
};
export const BillingPlanIssueInvoicesOptionsDocument = gql`
    query BillingPlanIssueInvoicesOptions($projectId: ID!) {
  vatRates {
    id
    amount
    default
  }
  project(id: $projectId) {
    brand {
      contacts {
        id
        first_name
        last_name
        email
      }
      client {
        billingEntities {
          id
          street
          city
          internal_name
          applies_vat
          invoice_email
          defaultCurrency {
            id
            code
          }
        }
        currencyExchangeRates(onlyActive: true) {
          id
          exchange_rate
          currency {
            id
            code
          }
        }
      }
    }
    ordersSimpleMap {
      id
      purchase_order_no
    }
  }
}
    `;

export function useBillingPlanIssueInvoicesOptionsQuery(options: Omit<Urql.UseQueryArgs<BillingPlanIssueInvoicesOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<BillingPlanIssueInvoicesOptionsQuery, BillingPlanIssueInvoicesOptionsQueryVariables>({ query: BillingPlanIssueInvoicesOptionsDocument, ...options });
};
export const IsBillingPlanLockedDocument = gql`
    query IsBillingPlanLocked($projectId: ID!) {
  project(id: $projectId) {
    billingPlanSetting {
      locked_at
      lockedByUser {
        id
        full_name
      }
    }
  }
}
    `;

export function useIsBillingPlanLockedQuery(options: Omit<Urql.UseQueryArgs<IsBillingPlanLockedQueryVariables>, 'query'>) {
  return Urql.useQuery<IsBillingPlanLockedQuery, IsBillingPlanLockedQueryVariables>({ query: IsBillingPlanLockedDocument, ...options });
};
export const GetBudgetExceededDocument = gql`
    query GetBudgetExceeded($page: Int!, $first: Int, $filters: ProjectQueryArgs) {
  teamSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    full_name
    codename
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projects(page: $page, first: $first, filters: $filters) {
    paginatorInfo {
      hasMorePages
      currentPage
      perPage
      total
      count
      firstItem
      lastItem
      lastPage
    }
    data {
      id
      title
      code
      billable
      type
      brand {
        id
        name
        client {
          image {
            urls {
              thumbnail
            }
          }
        }
      }
      projectManager {
        codename
        full_name
        id
        image {
          urls {
            thumbnail
          }
        }
        profile {
          hex_color
          defaultWorktype {
            id
            title
          }
        }
        team {
          id
          name
        }
      }
      expenses(hasBudgetExceeded: true) {
        title
        id
        stats {
          planned_expenses
          real_expenses
          planned_commission
          credit
          total_budget
          budget_exceeded
          real_expenses_percent
          credit
          real_expenses_percent
          real_commission
          real_commission_relative
          planned_commission_relative_computed
          planned_profit
        }
      }
      ourWork(hasBudgetExceeded: true) {
        id
        title
        stats {
          credit
          total_budget
          spent_budget
          budget_exceeded
          spent_budget_percent
          spent_time
          invoiced_percent
          remaining_budget
          remaining_time
        }
      }
      stats {
        budget_exceeded
      }
    }
  }
}
    `;

export function useGetBudgetExceededQuery(options: Omit<Urql.UseQueryArgs<GetBudgetExceededQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBudgetExceededQuery, GetBudgetExceededQueryVariables>({ query: GetBudgetExceededDocument, ...options });
};
export const UpdateProjectBudgetDocument = gql`
    mutation UpdateProjectBudget($input: UpdateProjectBudgetInput!) {
  updateProjectBudget(input: $input) {
    id
    title
    code
    billable
    uses_budgetovac
    finished_at
    type
    brand {
      id
      name
      image {
        urls {
          thumbnail
        }
      }
    }
    budgetovacBudget {
      budget_id
      newer_final_version_available
    }
    ourWorkStructured {
      name
      budget_category_id
      budgetItems {
        id
        title
        stats {
          credit
          total_budget
        }
      }
      total_budget
      credit
    }
    expensesWithoutOtherStructured {
      name
      budget_category_id
      budgetItems {
        id
        title
        type
        completed_at
        stats {
          real_expenses
          credit
          total_budget
          planned_commission
          planned_expenses
        }
      }
      total_budget
      credit
      real_expenses
      real_expenses_without_other
    }
    stats {
      total_budget
      credit
      planned_commission
      ourWork {
        total_budget
      }
      expenses {
        planned_expenses
      }
    }
  }
}
    `;

export function useUpdateProjectBudgetMutation() {
  return Urql.useMutation<UpdateProjectBudgetMutation, UpdateProjectBudgetMutationVariables>(UpdateProjectBudgetDocument);
};
export const ProjectForBudgetDocument = gql`
    query ProjectForBudget($id: ID!) {
  expenseBudgetCategories {
    id
    name
  }
  ourWorkBudgetCategories {
    id
    name
  }
  project(id: $id) {
    id
    title
    code
    billable
    uses_budgetovac
    finished_at
    type
    brand {
      id
      name
      image {
        urls {
          thumbnail
        }
      }
    }
    budgetovacBudget {
      budget_id
      newer_final_version_available
    }
    ourWorkStructured {
      name
      budget_category_id
      budgetItems {
        id
        title
        stats {
          credit
          total_budget
        }
      }
      total_budget
      credit
    }
    expensesWithoutOtherStructured {
      name
      budget_category_id
      budgetItems {
        id
        title
        type
        completed_at
        stats {
          real_expenses
          credit
          total_budget
          planned_commission
          planned_expenses
        }
      }
      total_budget
      credit
      real_expenses
      real_expenses_without_other
    }
    stats {
      total_budget
      credit
      planned_commission
      ourWork {
        total_budget
      }
      expenses {
        planned_expenses
      }
    }
  }
  projectDatesForBudgetChange(project_id: $id) {
    lowestPossibleDateForBudgetChange
    defaultDateForBudgetChange
  }
}
    `;

export function useProjectForBudgetQuery(options: Omit<Urql.UseQueryArgs<ProjectForBudgetQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectForBudgetQuery, ProjectForBudgetQueryVariables>({ query: ProjectForBudgetDocument, ...options });
};
export const ProjectForBudgetsDocument = gql`
    query ProjectForBudgets($id: ID!) {
  project(id: $id) {
    id
    finished_at
    uses_budgetovac
    budgetovacBudget {
      budget_id
    }
    ...ProjectTitle
  }
}
    ${ProjectTitleFragmentDoc}`;

export function useProjectForBudgetsQuery(options: Omit<Urql.UseQueryArgs<ProjectForBudgetsQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectForBudgetsQuery, ProjectForBudgetsQueryVariables>({ query: ProjectForBudgetsDocument, ...options });
};
export const BudgetInternalApproveDocument = gql`
    mutation BudgetInternalApprove($id: ID!) {
  budgetInternalApprove(id: $id) {
    id
  }
}
    `;

export function useBudgetInternalApproveMutation() {
  return Urql.useMutation<BudgetInternalApproveMutation, BudgetInternalApproveMutationVariables>(BudgetInternalApproveDocument);
};
export const ChangeBudgetAssignedAtDocument = gql`
    mutation ChangeBudgetAssignedAt($id: ID!, $date: Date!) {
  changeBudgetAssignedAt(id: $id, date: $date) {
    id
    assignment_date
  }
}
    `;

export function useChangeBudgetAssignedAtMutation() {
  return Urql.useMutation<ChangeBudgetAssignedAtMutation, ChangeBudgetAssignedAtMutationVariables>(ChangeBudgetAssignedAtDocument);
};
export const BudgetGroupsForProjectsDocument = gql`
    query BudgetGroupsForProjects($projectId: ID!) {
  budgetsForProject(project_id: $projectId) {
    ...BudgetGroup
  }
}
    ${BudgetGroupFragmentDoc}`;

export function useBudgetGroupsForProjectsQuery(options: Omit<Urql.UseQueryArgs<BudgetGroupsForProjectsQueryVariables>, 'query'>) {
  return Urql.useQuery<BudgetGroupsForProjectsQuery, BudgetGroupsForProjectsQueryVariables>({ query: BudgetGroupsForProjectsDocument, ...options });
};
export const ProjectTitleDocument = gql`
    query ProjectTitle($projectId: ID!) {
  project(id: $projectId) {
    ...ProjectTitle
    lowestPossibleDateForStartDateChange
  }
}
    ${ProjectTitleFragmentDoc}`;

export function useProjectTitleQuery(options: Omit<Urql.UseQueryArgs<ProjectTitleQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectTitleQuery, ProjectTitleQueryVariables>({ query: ProjectTitleDocument, ...options });
};
export const GetProjectBudgetExceededCountDocument = gql`
    query GetProjectBudgetExceededCount {
  getActiveProjectBudgetExceededCount
}
    `;

export function useGetProjectBudgetExceededCountQuery(options?: Omit<Urql.UseQueryArgs<GetProjectBudgetExceededCountQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProjectBudgetExceededCountQuery, GetProjectBudgetExceededCountQueryVariables>({ query: GetProjectBudgetExceededCountDocument, ...options });
};
export const GetProjectUsesBudgetovacDocument = gql`
    query GetProjectUsesBudgetovac($id: ID!) {
  project(id: $id) {
    id
    uses_budgetovac
    finished_at
  }
}
    `;

export function useGetProjectUsesBudgetovacQuery(options: Omit<Urql.UseQueryArgs<GetProjectUsesBudgetovacQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProjectUsesBudgetovacQuery, GetProjectUsesBudgetovacQueryVariables>({ query: GetProjectUsesBudgetovacDocument, ...options });
};
export const CreateProjectFromTemplateDocument = gql`
    mutation CreateProjectFromTemplate($input: CreateProjectFromTemplateInput!) {
  createProjectFromTemplate(input: $input) {
    id
  }
}
    `;

export function useCreateProjectFromTemplateMutation() {
  return Urql.useMutation<CreateProjectFromTemplateMutation, CreateProjectFromTemplateMutationVariables>(CreateProjectFromTemplateDocument);
};
export const GetBrandContactsDocument = gql`
    query GetBrandContacts($id: ID!) {
  brand(id: $id) {
    id
    name
    code
    contacts {
      id
      first_name
      last_name
      image {
        urls {
          thumbnail
        }
      }
    }
  }
}
    `;

export function useGetBrandContactsQuery(options: Omit<Urql.UseQueryArgs<GetBrandContactsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBrandContactsQuery, GetBrandContactsQueryVariables>({ query: GetBrandContactsDocument, ...options });
};
export const GetPmDocument = gql`
    query GetPM($id: ID!) {
  user(id: $id) {
    team {
      id
    }
  }
}
    `;

export function useGetPmQuery(options: Omit<Urql.UseQueryArgs<GetPmQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPmQuery, GetPmQueryVariables>({ query: GetPmDocument, ...options });
};
export const RateCardsDocument = gql`
    query RateCards($brandId: ID) {
  projectRateCard(brand_id: $brandId) {
    id
    name
    currency_iso
  }
}
    `;

export function useRateCardsQuery(options?: Omit<Urql.UseQueryArgs<RateCardsQueryVariables>, 'query'>) {
  return Urql.useQuery<RateCardsQuery, RateCardsQueryVariables>({ query: RateCardsDocument, ...options });
};
export const GetProjectFromTemplateDocument = gql`
    query GetProjectFromTemplate($projectId: ID) {
  project(id: $projectId) {
    title
    type
    start_date
    billable
    note
    rate_card_id
    categories {
      id
    }
    brand {
      id
    }
    contact {
      id
    }
    team {
      id
    }
    projectManager {
      id
    }
    otherProjectManagers {
      id
    }
  }
}
    `;

export function useGetProjectFromTemplateQuery(options?: Omit<Urql.UseQueryArgs<GetProjectFromTemplateQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProjectFromTemplateQuery, GetProjectFromTemplateQueryVariables>({ query: GetProjectFromTemplateDocument, ...options });
};
export const CreateProjectDocument = gql`
    mutation CreateProject($input: CreateProjectInput!) {
  createProject(input: $input) {
    id
  }
}
    `;

export function useCreateProjectMutation() {
  return Urql.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument);
};
export const GetProjectCreateDataDocument = gql`
    query GetProjectCreateData {
  teamSimpleMap {
    id
    name
  }
  lowestDateWithOpenProgress
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projectManagerSimpleMap {
    id
    name
    image {
      urls {
        thumbnail
      }
    }
    codename
    full_name
  }
}
    `;

export function useGetProjectCreateDataQuery(options?: Omit<Urql.UseQueryArgs<GetProjectCreateDataQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProjectCreateDataQuery, GetProjectCreateDataQueryVariables>({ query: GetProjectCreateDataDocument, ...options });
};
export const ProjectDetailForClientDocument = gql`
    query ProjectDetailForClient($id: ID!) {
  project(id: $id) {
    id
    title
    code
    note
    status
    finished_at
    archived_at
    cloudUrl
    driveCloudUrl
    type
    start_date
    expected_end_date
    externalLinks {
      ...ExternalLinkFragment
    }
    finishedBy {
      id
      full_name
    }
    archivedBy {
      id
      full_name
    }
    otherProjectManagers {
      id
      profile {
        hex_color
      }
      image {
        urls {
          thumbnail
        }
      }
      full_name
    }
    contact {
      id
      phone
      image {
        urls {
          thumbnail
        }
      }
      email
      first_name
      last_name
    }
    projectManager {
      id
      full_name
      profile {
        hex_color
      }
      team {
        name
      }
      image {
        urls {
          thumbnail
        }
      }
    }
    team {
      name
    }
    brand {
      id
      name
      image {
        urls {
          thumbnail
        }
      }
    }
  }
}
    ${ExternalLinkFragmentFragmentDoc}`;

export function useProjectDetailForClientQuery(options: Omit<Urql.UseQueryArgs<ProjectDetailForClientQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectDetailForClientQuery, ProjectDetailForClientQueryVariables>({ query: ProjectDetailForClientDocument, ...options });
};
export const TasksForClientDocument = gql`
    query TasksForClient($filters: TaskQueryArgs) {
  tasks(filters: $filters, first: 1000) {
    data {
      ...SimpleTaskForClient
      subtasks {
        ...SimpleTaskForClient
      }
    }
  }
}
    ${SimpleTaskForClientFragmentDoc}`;

export function useTasksForClientQuery(options?: Omit<Urql.UseQueryArgs<TasksForClientQueryVariables>, 'query'>) {
  return Urql.useQuery<TasksForClientQuery, TasksForClientQueryVariables>({ query: TasksForClientDocument, ...options });
};
export const ProjectDetailCreateBudgetItemPlannedExpensesDocument = gql`
    mutation ProjectDetailCreateBudgetItemPlannedExpenses($input: CreateBudgetItemPlannedExpensesInput!) {
  createBudgetItemPlannedExpenses(input: $input) {
    ...ProjectDetailPlannedExpenseFields
  }
}
    ${ProjectDetailPlannedExpenseFieldsFragmentDoc}`;

export function useProjectDetailCreateBudgetItemPlannedExpensesMutation() {
  return Urql.useMutation<ProjectDetailCreateBudgetItemPlannedExpensesMutation, ProjectDetailCreateBudgetItemPlannedExpensesMutationVariables>(ProjectDetailCreateBudgetItemPlannedExpensesDocument);
};
export const ProjectDetailCreateBudgetItemPlannedExpensesBulkDocument = gql`
    mutation ProjectDetailCreateBudgetItemPlannedExpensesBulk($items: [CreateBudgetItemPlannedExpensesInput!]!) {
  createBudgetItemPlannedExpensesBulk(items: $items) {
    ...ProjectDetailPlannedExpenseFields
  }
}
    ${ProjectDetailPlannedExpenseFieldsFragmentDoc}`;

export function useProjectDetailCreateBudgetItemPlannedExpensesBulkMutation() {
  return Urql.useMutation<ProjectDetailCreateBudgetItemPlannedExpensesBulkMutation, ProjectDetailCreateBudgetItemPlannedExpensesBulkMutationVariables>(ProjectDetailCreateBudgetItemPlannedExpensesBulkDocument);
};
export const InvoiceProjectByCurrentMonthBillingPlanDocument = gql`
    mutation InvoiceProjectByCurrentMonthBillingPlan($projectId: ID!, $type: RequestForInvoicingTypeEnum!) {
  invoiceProjectByCurrentMonthBillingPlan(id: $projectId, invoice_type: $type) {
    id
  }
}
    `;

export function useInvoiceProjectByCurrentMonthBillingPlanMutation() {
  return Urql.useMutation<InvoiceProjectByCurrentMonthBillingPlanMutation, InvoiceProjectByCurrentMonthBillingPlanMutationVariables>(InvoiceProjectByCurrentMonthBillingPlanDocument);
};
export const ResetBillingPlanNotificationsDocument = gql`
    mutation ResetBillingPlanNotifications($projectId: ID!, $type: BillingPlanNotificationTypeEnum!) {
  resetBillingPlanNotifications(project_id: $projectId, types: [$type]) {
    id
    billingPlanNotifications {
      project_budget_changed
      project_dates_changed
    }
  }
}
    `;

export function useResetBillingPlanNotificationsMutation() {
  return Urql.useMutation<ResetBillingPlanNotificationsMutation, ResetBillingPlanNotificationsMutationVariables>(ResetBillingPlanNotificationsDocument);
};
export const UpdateOurWorkBudgetItemsDocument = gql`
    mutation UpdateOurWorkBudgetItems($budgetItems: [UpdateBudgetItem!]!) {
  updateOurWorkBudgetItems(budget_items: $budgetItems) {
    id
  }
}
    `;

export function useUpdateOurWorkBudgetItemsMutation() {
  return Urql.useMutation<UpdateOurWorkBudgetItemsMutation, UpdateOurWorkBudgetItemsMutationVariables>(UpdateOurWorkBudgetItemsDocument);
};
export const CreateExpenseBudgetItemDocument = gql`
    mutation CreateExpenseBudgetItem($projectId: ID!, $title: String!, $expenseBudgetCategoryId: ID!) {
  createExpenseBudgetItem(
    project_id: $projectId
    title: $title
    expense_budget_category_id: $expenseBudgetCategoryId
  ) {
    ...ExpenseStructuredBudgetItemFragment
  }
}
    ${ExpenseStructuredBudgetItemFragmentFragmentDoc}`;

export function useCreateExpenseBudgetItemMutation() {
  return Urql.useMutation<CreateExpenseBudgetItemMutation, CreateExpenseBudgetItemMutationVariables>(CreateExpenseBudgetItemDocument);
};
export const CreateOurWorkBudgetItemDocument = gql`
    mutation CreateOurWorkBudgetItem($projectId: ID!, $title: String!) {
  createOurWorkBudgetItem(project_id: $projectId, title: $title) {
    ...OurWorkBudgetItemOverviewFragment
  }
}
    ${OurWorkBudgetItemOverviewFragmentFragmentDoc}`;

export function useCreateOurWorkBudgetItemMutation() {
  return Urql.useMutation<CreateOurWorkBudgetItemMutation, CreateOurWorkBudgetItemMutationVariables>(CreateOurWorkBudgetItemDocument);
};
export const CreateTasksFromTemplateGroupDocument = gql`
    mutation CreateTasksFromTemplateGroup($ourWorkBudgetItemIds: [ID!]!, $taskTemplateGroupId: ID!) {
  createTasksFromTaskTemplateGroup(
    our_work_budget_item_ids: $ourWorkBudgetItemIds
    task_template_group_id: $taskTemplateGroupId
  )
}
    `;

export function useCreateTasksFromTemplateGroupMutation() {
  return Urql.useMutation<CreateTasksFromTemplateGroupMutation, CreateTasksFromTemplateGroupMutationVariables>(CreateTasksFromTemplateGroupDocument);
};
export const OurWorkOverviewForProjectDocument = gql`
    query OurWorkOverviewForProject($projectId: ID!) {
  project(id: $projectId) {
    ourWorkOverview(withDoneTasks: false) {
      ...OurWorkOverview
    }
  }
}
    ${OurWorkOverviewFragmentDoc}`;

export function useOurWorkOverviewForProjectQuery(options: Omit<Urql.UseQueryArgs<OurWorkOverviewForProjectQueryVariables>, 'query'>) {
  return Urql.useQuery<OurWorkOverviewForProjectQuery, OurWorkOverviewForProjectQueryVariables>({ query: OurWorkOverviewForProjectDocument, ...options });
};
export const OurWorkOverviewDoneTasksForProjectDocument = gql`
    query OurWorkOverviewDoneTasksForProject($projectId: ID!, $budgetItemId: ID) {
  project(id: $projectId) {
    ourWorkOverview(withDoneTasks: true, budgetItemId: $budgetItemId) {
      budgetItems {
        id
        ...OurWorkBudgetItemOverviewTasksFragment
      }
    }
  }
}
    ${OurWorkBudgetItemOverviewTasksFragmentFragmentDoc}`;

export function useOurWorkOverviewDoneTasksForProjectQuery(options: Omit<Urql.UseQueryArgs<OurWorkOverviewDoneTasksForProjectQueryVariables>, 'query'>) {
  return Urql.useQuery<OurWorkOverviewDoneTasksForProjectQuery, OurWorkOverviewDoneTasksForProjectQueryVariables>({ query: OurWorkOverviewDoneTasksForProjectDocument, ...options });
};
export const ProjectDetailDocument = gql`
    query ProjectDetail($id: ID!) {
  project(id: $id) {
    id
    title
    code
    numeric_code
    note
    status
    billable
    is_pinned
    is_starred
    uses_budgetovac
    finished_at
    archived_at
    cloudUrl
    driveCloudUrl
    billingPlanIsMissing
    type
    start_date
    expected_end_date
    is_template
    externalLinks {
      ...ExternalLinkFragment
    }
    categories {
      id
      name
    }
    billingPlanNotifications {
      project_dates_changed
      project_budget_changed
    }
    finishedBy {
      id
      full_name
    }
    archivedBy {
      id
      full_name
    }
    budgetovacBudget {
      budget_id
      internally_approved
      newer_final_version_available
    }
    budgetovacBudgets {
      id
      internally_approved
      is_active
    }
    lastWorkInProgressProjectStat {
      progress_percent
    }
    orders {
      data {
        id
        purchase_order_no
      }
    }
    projectManager {
      ...UserToolTip_UserFragment
    }
    otherProjectManagers {
      ...UserToolTip_UserFragment
    }
    contact {
      id
      phone
      image {
        urls {
          thumbnail
        }
      }
      email
      first_name
      last_name
    }
    team {
      id
      name
    }
    brand {
      id
      name
      image {
        urls {
          thumbnail
        }
      }
    }
    currentMonthBillingPlanOutgoingInvoice
    currentMonthBillingPlanOutgoingProformaInvoice
    statsCached {
      total_budget
      invoiceable
      uninvoiced
      credit
      credit_balance
      credit_direct
      credit_from_prepayments
      unused_sum_from_proformas
      over_invoiced
      net_profit
      net_margin_percent
      gross_income
      outgoing_invoice_amount
      outgoing_invoice_paid
      outgoing_proforma_invoice_amount
      outgoing_proforma_invoice_paid
      outgoing_proforma_invoice_settled
      outgoing_proforma_invoice_unsettled
      credit_from_unused_prepayments
      ourWork {
        spent_time
        remaining_time
        total_time
        total_budget
        spent_budget
        spent_budget_percent
        remaining_budget
        credit
        invoiced_percent
        invoiceable
        uninvoiced
        all_items_completed
        net_profit
        net_margin_percent
        efficiency_percent
      }
      expenses {
        total_budget
        planned_expenses
        planned_commission
        planned_profit
        planned_commission_relative_computed
        real_expenses
        real_commission
        real_expenses_percent
        real_commission_relative
        credit
        credit_balance
        invoiced_percent
        invoiceable
        uninvoiced
        all_items_completed
      }
    }
    expensesStructured {
      id
      budget_category_id
      name
      total_budget
      credit
      budgetItems {
        ...ExpenseStructuredBudgetItemFragment
      }
    }
    invoiceStats {
      id
    }
    proformaInvoices {
      id
    }
    prepaymentStats {
      id
    }
    currentMonthBillingPlanStats {
      current_month_planned
      show_invoice_date_approaching_warning
    }
    billingPlanSetting {
      project_id
    }
    billingPlanByMonths {
      id
    }
    project_stage {
      ...ProjectStage
    }
    pipedriveCustomFieldValues {
      ...PipedriveCustomField
    }
  }
}
    ${ExternalLinkFragmentFragmentDoc}
${UserToolTip_UserFragmentFragmentDoc}
${ExpenseStructuredBudgetItemFragmentFragmentDoc}
${ProjectStageFragmentDoc}
${PipedriveCustomFieldFragmentDoc}`;

export function useProjectDetailQuery(options: Omit<Urql.UseQueryArgs<ProjectDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectDetailQuery, ProjectDetailQueryVariables>({ query: ProjectDetailDocument, ...options });
};
export const ProjectGraphDocument = gql`
    query ProjectGraph($projectId: ID!, $ourWorkBudgetItemIds: [ID!]) {
  projectGraph(
    project_id: $projectId
    our_work_budget_item_ids: $ourWorkBudgetItemIds
  ) {
    totalBudgetData {
      date
      amount
    }
    spentBudgetData {
      date
      amount
    }
  }
}
    `;

export function useProjectGraphQuery(options: Omit<Urql.UseQueryArgs<ProjectGraphQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectGraphQuery, ProjectGraphQueryVariables>({ query: ProjectGraphDocument, ...options });
};
export const ProjectDetailBudgetItemPlannedExpensesDocument = gql`
    query ProjectDetailBudgetItemPlannedExpenses($budgetItemId: ID!, $budgetItemType: ExpenseBudgetItemTypeEnum!) {
  budgetItemPlannedExpenses(
    budget_item_id: $budgetItemId
    budget_item_type: $budgetItemType
  ) {
    ...ProjectDetailPlannedExpenseFields
  }
}
    ${ProjectDetailPlannedExpenseFieldsFragmentDoc}`;

export function useProjectDetailBudgetItemPlannedExpensesQuery(options: Omit<Urql.UseQueryArgs<ProjectDetailBudgetItemPlannedExpensesQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectDetailBudgetItemPlannedExpensesQuery, ProjectDetailBudgetItemPlannedExpensesQueryVariables>({ query: ProjectDetailBudgetItemPlannedExpensesDocument, ...options });
};
export const ProjectDocumentsDocument = gql`
    query ProjectDocuments($id: ID!) {
  project(id: $id) {
    ...ProjectTitle
  }
}
    ${ProjectTitleFragmentDoc}`;

export function useProjectDocumentsQuery(options: Omit<Urql.UseQueryArgs<ProjectDocumentsQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectDocumentsQuery, ProjectDocumentsQueryVariables>({ query: ProjectDocumentsDocument, ...options });
};
export const UpdateProjectDocument = gql`
    mutation UpdateProject($input: UpdateProjectInput!, $propagate_billable: Boolean!) {
  updateProject(input: $input, propagate_billable: $propagate_billable) {
    id
  }
}
    `;

export function useUpdateProjectMutation() {
  return Urql.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument);
};
export const GetProjectEditDataDocument = gql`
    query GetProjectEditData($id: ID!) {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  lowestDateWithOpenProgress
  teamSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    full_name
    image {
      urls {
        thumbnail
      }
    }
    codename
    name
  }
  project(id: $id) {
    title
    code
    note
    start_date
    expected_end_date
    billable
    type
    finished_at
    uses_budgetovac
    lowestPossibleDateForStartDateChange
    rate_card_id
    is_template
    users {
      id
    }
    categories {
      id
      name
    }
    team {
      id
      name
    }
    brand {
      id
      name
    }
    contact {
      id
    }
    projectManager {
      id
    }
    otherProjectManagers {
      id
    }
    ourWorkStructured {
      budgetItems {
        id
        tasks {
          id
        }
      }
    }
  }
}
    `;

export function useGetProjectEditDataQuery(options: Omit<Urql.UseQueryArgs<GetProjectEditDataQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProjectEditDataQuery, GetProjectEditDataQueryVariables>({ query: GetProjectEditDataDocument, ...options });
};
export const ClientsProjectListTableDataDocument = gql`
    query ClientsProjectListTableData($page: Int!, $first: Int, $filters: ProjectQueryArgs) {
  projects(page: $page, first: $first, filters: $filters) {
    data {
      id
      title
      code
      brand {
        name
        image {
          urls {
            thumbnail
          }
        }
      }
      users {
        full_name
        scope {
          value
        }
      }
      projectManager {
        ...UserToolTip_UserFragment
      }
      stats {
        invoiced_percent
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${UserToolTip_UserFragmentFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useClientsProjectListTableDataQuery(options: Omit<Urql.UseQueryArgs<ClientsProjectListTableDataQueryVariables>, 'query'>) {
  return Urql.useQuery<ClientsProjectListTableDataQuery, ClientsProjectListTableDataQueryVariables>({ query: ClientsProjectListTableDataDocument, ...options });
};
export const ClientsProjectListFilterOptionsDocument = gql`
    query ClientsProjectListFilterOptions {
  teamSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    name
    codename
    full_name
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
}
    `;

export function useClientsProjectListFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<ClientsProjectListFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ClientsProjectListFilterOptionsQuery, ClientsProjectListFilterOptionsQueryVariables>({ query: ClientsProjectListFilterOptionsDocument, ...options });
};
export const CloseWipDocument = gql`
    mutation CloseWip($id: ID!) {
  closeWip(id: $id) {
    is_closed
  }
}
    `;

export function useCloseWipMutation() {
  return Urql.useMutation<CloseWipMutation, CloseWipMutationVariables>(CloseWipDocument);
};
export const CloseWipBulkDocument = gql`
    mutation CloseWipBulk($periodId: ID!, $projectId: ID, $where: WipsWhereConditions) {
  closeWipBulk(
    input: {period_id: $periodId, project_id: $projectId, where: $where}
  ) {
    total
    successful
    failed
  }
}
    `;

export function useCloseWipBulkMutation() {
  return Urql.useMutation<CloseWipBulkMutation, CloseWipBulkMutationVariables>(CloseWipBulkDocument);
};
export const LockWipDocument = gql`
    mutation LockWip($id: ID!) {
  lockWip(id: $id) {
    is_locked
  }
}
    `;

export function useLockWipMutation() {
  return Urql.useMutation<LockWipMutation, LockWipMutationVariables>(LockWipDocument);
};
export const LockWipBulkDocument = gql`
    mutation LockWipBulk($periodId: ID!, $projectId: ID, $where: WipsWhereConditions) {
  lockWipBulk(
    input: {period_id: $periodId, project_id: $projectId, where: $where}
  ) {
    total
    successful
    failed
  }
}
    `;

export function useLockWipBulkMutation() {
  return Urql.useMutation<LockWipBulkMutation, LockWipBulkMutationVariables>(LockWipBulkDocument);
};
export const OpenWipDocument = gql`
    mutation OpenWip($id: ID!) {
  openWip(id: $id) {
    is_closed
  }
}
    `;

export function useOpenWipMutation() {
  return Urql.useMutation<OpenWipMutation, OpenWipMutationVariables>(OpenWipDocument);
};
export const OpenWipBulkDocument = gql`
    mutation OpenWipBulk($periodId: ID!, $projectId: ID, $where: WipsWhereConditions) {
  openWipBulk(
    input: {period_id: $periodId, project_id: $projectId, where: $where}
  ) {
    total
    successful
    failed
  }
}
    `;

export function useOpenWipBulkMutation() {
  return Urql.useMutation<OpenWipBulkMutation, OpenWipBulkMutationVariables>(OpenWipBulkDocument);
};
export const SubmitProgressDocument = gql`
    mutation SubmitProgress($input: SubmitProgressInput!) {
  submitProgress(input: $input) {
    changedWorkInProgressItemStats {
      our_work_budget_item_id
      work_in_progress_id
      ...WipItemStatAffectedValues
    }
    lastWorkInProgressProjectStat {
      progress
      progress_percent
      progress_change
      progress_change_percent
      spent_time_estimate
    }
  }
}
    ${WipItemStatAffectedValuesFragmentDoc}`;

export function useSubmitProgressMutation() {
  return Urql.useMutation<SubmitProgressMutation, SubmitProgressMutationVariables>(SubmitProgressDocument);
};
export const SubmitProgressBulkDocument = gql`
    mutation SubmitProgressBulk($ids: [ID!]!, $progress: BigInt!) {
  submitProgressBulk(input: {ids: $ids, progress: $progress}) {
    id
    lastWorkInProgressItemStat {
      id
      work_in_progress_id
      ...WipItemStatAffectedValues
    }
  }
}
    ${WipItemStatAffectedValuesFragmentDoc}`;

export function useSubmitProgressBulkMutation() {
  return Urql.useMutation<SubmitProgressBulkMutation, SubmitProgressBulkMutationVariables>(SubmitProgressBulkDocument);
};
export const UnlockWipDocument = gql`
    mutation UnlockWip($id: ID!) {
  unlockWip(id: $id) {
    is_locked
  }
}
    `;

export function useUnlockWipMutation() {
  return Urql.useMutation<UnlockWipMutation, UnlockWipMutationVariables>(UnlockWipDocument);
};
export const UnlockWipBulkDocument = gql`
    mutation UnlockWipBulk($periodId: ID!, $projectId: ID, $where: WipsWhereConditions) {
  unlockWipBulk(
    input: {period_id: $periodId, project_id: $projectId, where: $where}
  ) {
    total
    successful
    failed
  }
}
    `;

export function useUnlockWipBulkMutation() {
  return Urql.useMutation<UnlockWipBulkMutation, UnlockWipBulkMutationVariables>(UnlockWipBulkDocument);
};
export const ProjectProgressStatisticsExportDocument = gql`
    query ProjectProgressStatisticsExport($from: Date, $to: Date, $wip_period_ids: [ID!]) {
  projectProgressStatisticsExport(
    from: $from
    to: $to
    wip_period_ids: $wip_period_ids
  )
}
    `;

export function useProjectProgressStatisticsExportQuery(options?: Omit<Urql.UseQueryArgs<ProjectProgressStatisticsExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectProgressStatisticsExportQuery, ProjectProgressStatisticsExportQueryVariables>({ query: ProjectProgressStatisticsExportDocument, ...options });
};
export const ProjectWipExportDocument = gql`
    query ProjectWipExport($period_id: ID!) {
  projectWipExport(period_id: $period_id)
}
    `;

export function useProjectWipExportQuery(options: Omit<Urql.UseQueryArgs<ProjectWipExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectWipExportQuery, ProjectWipExportQueryVariables>({ query: ProjectWipExportDocument, ...options });
};
export const ProjectsCommissionExportDocument = gql`
    query ProjectsCommissionExport($from: Date, $to: Date) {
  projectsCommissionExport(from: $from, to: $to)
}
    `;

export function useProjectsCommissionExportQuery(options?: Omit<Urql.UseQueryArgs<ProjectsCommissionExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectsCommissionExportQuery, ProjectsCommissionExportQueryVariables>({ query: ProjectsCommissionExportDocument, ...options });
};
export const ProjectsWipFilterOptionsDocument = gql`
    query ProjectsWIPFilterOptions {
  teamSimpleMap {
    id
    name
  }
  roles {
    id
    name
  }
  clientsSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    full_name
    codename
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  wipPeriodsMap {
    id
    title
    starts_at
    ends_at
    is_current
  }
}
    `;

export function useProjectsWipFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<ProjectsWipFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectsWipFilterOptionsQuery, ProjectsWipFilterOptionsQueryVariables>({ query: ProjectsWipFilterOptionsDocument, ...options });
};
export const ProjectsWipSummaryDocument = gql`
    query ProjectsWIPSummary($filters: WipQueryArgs) {
  wipProjectsPeriodSummary(filters: $filters) {
    progress_change
    progress_change_billable
    profit_estimate
    is_period_closed
    is_period_locked
    is_previous_period_closed
  }
}
    `;

export function useProjectsWipSummaryQuery(options?: Omit<Urql.UseQueryArgs<ProjectsWipSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectsWipSummaryQuery, ProjectsWipSummaryQueryVariables>({ query: ProjectsWipSummaryDocument, ...options });
};
export const ProjectsWipTableDataDocument = gql`
    query ProjectsWIPTableData($page: Int!, $first: Int, $filters: WipQueryArgs) {
  projectsWithPeriods(first: $first, page: $page, filters: $filters) {
    data {
      id
      total_budget
      total_budget_change
      spent_budget
      spent_budget_percent
      spent_time
      remaining_budget
      remaining_time
      progress_percent
      progress_change
      progress_change_percent
      profit_estimate
      profit_estimate_percent
      is_locked
      is_closed
      project {
        id
        title
        code
        billable
        projectManager {
          ...UserToolTip_UserFragment
        }
        otherProjectManagers {
          id
        }
        brand {
          id
          name
          image {
            urls {
              thumbnail
            }
          }
        }
        categories {
          name
        }
      }
      budgetItemsStats {
        our_work_budget_item_id
        work_in_progress_id
        title
        total_budget
        spent_budget
        spent_budget_percent
        spent_time
        remaining_budget
        remaining_time
        progress_percent
        progress_change
        progress_change_percent
        profit_estimate
        profit_estimate_percent
        total_budget_change
        is_locked
        is_closed
        deleted
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${UserToolTip_UserFragmentFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useProjectsWipTableDataQuery(options: Omit<Urql.UseQueryArgs<ProjectsWipTableDataQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectsWipTableDataQuery, ProjectsWipTableDataQueryVariables>({ query: ProjectsWipTableDataDocument, ...options });
};
export const ProjectsEffectivenessExportDocument = gql`
    query ProjectsEffectivenessExport($filters: ProjectQueryArgs, $startDate: DateRange, $finishedAt: DateRange, $dateOfSupply: DateRange) {
  projectsEffectivenessExport(
    filters: $filters
    startDate: $startDate
    finishedAt: $finishedAt
    dateOfSupply: $dateOfSupply
  )
}
    `;

export function useProjectsEffectivenessExportQuery(options?: Omit<Urql.UseQueryArgs<ProjectsEffectivenessExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectsEffectivenessExportQuery, ProjectsEffectivenessExportQueryVariables>({ query: ProjectsEffectivenessExportDocument, ...options });
};
export const MlggkProjectsEffectivenessExportDocument = gql`
    query MlggkProjectsEffectivenessExport($filters: ProjectQueryArgs, $startDate: DateRange, $finishedAt: DateRange, $dateOfSupply: DateRange) {
  mlggkProjectsEffectivenessExport(
    filters: $filters
    startDate: $startDate
    finishedAt: $finishedAt
    dateOfSupply: $dateOfSupply
  )
}
    `;

export function useMlggkProjectsEffectivenessExportQuery(options?: Omit<Urql.UseQueryArgs<MlggkProjectsEffectivenessExportQueryVariables>, 'query'>) {
  return Urql.useQuery<MlggkProjectsEffectivenessExportQuery, MlggkProjectsEffectivenessExportQueryVariables>({ query: MlggkProjectsEffectivenessExportDocument, ...options });
};
export const TriadProjectsEffectivenessExportDocument = gql`
    query TriadProjectsEffectivenessExport($filters: ProjectQueryArgs, $from: Date, $to: Date) {
  triadProjectsEffectivenessExport(filters: $filters, from: $from, to: $to)
}
    `;

export function useTriadProjectsEffectivenessExportQuery(options?: Omit<Urql.UseQueryArgs<TriadProjectsEffectivenessExportQueryVariables>, 'query'>) {
  return Urql.useQuery<TriadProjectsEffectivenessExportQuery, TriadProjectsEffectivenessExportQueryVariables>({ query: TriadProjectsEffectivenessExportDocument, ...options });
};
export const StarProjectDocument = gql`
    mutation StarProject($project_id: ID!, $options: ProjectStarOptions) {
  starProject(project_id: $project_id, options: $options) {
    ...Star
  }
}
    ${StarFragmentDoc}`;

export function useStarProjectMutation() {
  return Urql.useMutation<StarProjectMutation, StarProjectMutationVariables>(StarProjectDocument);
};
export const UnstarProjectDocument = gql`
    mutation UnstarProject($project_id: ID!, $options: ProjectStarOptions) {
  unstarProject(project_id: $project_id, options: $options)
}
    `;

export function useUnstarProjectMutation() {
  return Urql.useMutation<UnstarProjectMutation, UnstarProjectMutationVariables>(UnstarProjectDocument);
};
export const BulkStarProjectsDocument = gql`
    mutation BulkStarProjects($project_ids: [ID!]!, $options: ProjectStarOptions) {
  bulkStarProjects(project_ids: $project_ids, options: $options) {
    total
    successful
    failed
  }
}
    `;

export function useBulkStarProjectsMutation() {
  return Urql.useMutation<BulkStarProjectsMutation, BulkStarProjectsMutationVariables>(BulkStarProjectsDocument);
};
export const BulkUnstarProjectsDocument = gql`
    mutation BulkUnstarProjects($project_ids: [ID!]!, $options: ProjectStarOptions) {
  bulkUnstarProjects(project_ids: $project_ids, options: $options) {
    total
    successful
    failed
  }
}
    `;

export function useBulkUnstarProjectsMutation() {
  return Urql.useMutation<BulkUnstarProjectsMutation, BulkUnstarProjectsMutationVariables>(BulkUnstarProjectsDocument);
};
export const FinishedProjectListTableDataSimpleDocument = gql`
    query FinishedProjectListTableDataSimple($page: Int!, $first: Int, $filters: ProjectQueryArgs) {
  projects(page: $page, first: $first, filters: $filters) {
    data {
      id
      title
      code
      is_pinned
      is_starred
      billable
      is_template
      brand {
        id
        name
        image {
          urls {
            thumbnail
          }
        }
      }
      projectManager {
        ...UserToolTip_UserFragment
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${UserToolTip_UserFragmentFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useFinishedProjectListTableDataSimpleQuery(options: Omit<Urql.UseQueryArgs<FinishedProjectListTableDataSimpleQueryVariables>, 'query'>) {
  return Urql.useQuery<FinishedProjectListTableDataSimpleQuery, FinishedProjectListTableDataSimpleQueryVariables>({ query: FinishedProjectListTableDataSimpleDocument, ...options });
};
export const FinishedProjectListTableDataDocument = gql`
    query FinishedProjectListTableData($page: Int!, $first: Int, $filters: ProjectQueryArgs) {
  projects(page: $page, first: $first, filters: $filters) {
    data {
      id
      title
      code
      note
      billable
      is_pinned
      is_starred
      type
      finished_at
      archived_at
      cloudUrl
      driveCloudUrl
      is_template
      scopes {
        value
      }
      brand {
        id
        name
        image {
          urls {
            thumbnail
          }
        }
      }
      projectManager {
        ...UserToolTip_UserFragment
      }
      otherProjectManagers {
        id
      }
      categories {
        id
        name
      }
      ourWork {
        id
        title
        category {
          name
        }
        stats {
          invoiced_percent
          efficiency_percent
          remaining_budget
          net_margin_percent
          net_profit
        }
      }
      expenses {
        id
        title
        category {
          name
        }
        stats {
          profit
          profit_percent
          invoiced_percent
        }
      }
      statsCached {
        id
        profit
        credit
        unused_sum_from_proformas
        net_profit
        net_margin_percent
        invoiced_percent
        ourWork {
          id
          efficiency_percent
          remaining_budget
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${UserToolTip_UserFragmentFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useFinishedProjectListTableDataQuery(options: Omit<Urql.UseQueryArgs<FinishedProjectListTableDataQueryVariables>, 'query'>) {
  return Urql.useQuery<FinishedProjectListTableDataQuery, FinishedProjectListTableDataQueryVariables>({ query: FinishedProjectListTableDataDocument, ...options });
};
export const ProjectListFilterOptionsDocument = gql`
    query ProjectListFilterOptions {
  teamSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    name
    codename
    full_name
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
}
    `;

export function useProjectListFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<ProjectListFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectListFilterOptionsQuery, ProjectListFilterOptionsQueryVariables>({ query: ProjectListFilterOptionsDocument, ...options });
};
export const ProjectListTableDataSimpleDocument = gql`
    query ProjectListTableDataSimple($page: Int!, $first: Int, $filters: ProjectQueryArgs) {
  projects(page: $page, first: $first, filters: $filters) {
    data {
      id
      title
      code
      numeric_code
      is_pinned
      is_starred
      billable
      is_template
      project_stage {
        ...ProjectStage
      }
      projectManager {
        ...UserToolTip_UserFragment
      }
      ourWork {
        id
      }
      brand {
        id
        name
        image {
          urls {
            thumbnail
          }
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ProjectStageFragmentDoc}
${UserToolTip_UserFragmentFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useProjectListTableDataSimpleQuery(options: Omit<Urql.UseQueryArgs<ProjectListTableDataSimpleQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectListTableDataSimpleQuery, ProjectListTableDataSimpleQueryVariables>({ query: ProjectListTableDataSimpleDocument, ...options });
};
export const ProjectSubrowsDocument = gql`
    query ProjectSubrows($id: ID!) {
  project(id: $id) {
    id
    ourWork {
      id
      title
      category {
        name
      }
      lastWorkInProgressItemStat {
        work_in_progress_id
        progress_percent
        progress
        spent_time_estimate
      }
      stats {
        id
        total_budget
        spent_budget_percent
        spent_budget
        spent_time
        budget_exceeded
        credit_balance
        invoiced_percent
      }
    }
  }
}
    `;

export function useProjectSubrowsQuery(options: Omit<Urql.UseQueryArgs<ProjectSubrowsQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectSubrowsQuery, ProjectSubrowsQueryVariables>({ query: ProjectSubrowsDocument, ...options });
};
export const ProjectsSubrowsForPageDocument = gql`
    query ProjectsSubrowsForPage($page: Int!, $first: Int, $filters: ProjectQueryArgs) {
  projects(page: $page, first: $first, filters: $filters) {
    data {
      id
      ourWork {
        id
        title
        category {
          name
        }
        lastWorkInProgressItemStat {
          work_in_progress_id
          progress_percent
          progress
          spent_time_estimate
        }
        stats {
          id
          total_budget
          spent_budget_percent
          spent_budget
          spent_time
          budget_exceeded
          credit_balance
          invoiced_percent
        }
      }
    }
  }
}
    `;

export function useProjectsSubrowsForPageQuery(options: Omit<Urql.UseQueryArgs<ProjectsSubrowsForPageQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectsSubrowsForPageQuery, ProjectsSubrowsForPageQueryVariables>({ query: ProjectsSubrowsForPageDocument, ...options });
};
export const ProjectListTableDataDocument = gql`
    query ProjectListTableData($page: Int!, $first: Int, $filters: ProjectQueryArgs) {
  projects(page: $page, first: $first, filters: $filters) {
    data {
      id
      title
      code
      numeric_code
      note
      billable
      is_pinned
      is_starred
      type
      finished_at
      archived_at
      billingPlanIsMissing
      cloudUrl
      driveCloudUrl
      is_template
      scopes {
        value
      }
      project_stage {
        ...ProjectStage
      }
      lastWorkInProgressProjectStat {
        progress_percent
        progress
        spent_time_estimate
      }
      budgetovacBudget {
        budget_id
        internally_approved
        newer_final_version_available
      }
      budgetovacBudgets {
        id
        internally_approved
        is_active
      }
      brand {
        id
        name
        image {
          urls {
            thumbnail
          }
        }
      }
      projectManager {
        ...UserToolTip_UserFragment
      }
      otherProjectManagers {
        id
      }
      categories {
        id
        name
      }
      ourWork {
        id
      }
      ourWorkOverview {
        id
        name
        budget_exceeded
      }
      expensesStructured {
        id
        name
        budget_exceeded
      }
      statsCached {
        id
        budget_exceeded
        credit_balance
        invoiced_percent
        total_budget
        ourWork {
          id
          total_budget
          spent_budget
          spent_time
          spent_budget_percent
        }
        expenses {
          id
          all_items_completed
          planned_expenses
          planned_commission
          planned_commission_relative_computed
          real_expenses
          real_commission
          real_commission_relative
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ProjectStageFragmentDoc}
${UserToolTip_UserFragmentFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useProjectListTableDataQuery(options: Omit<Urql.UseQueryArgs<ProjectListTableDataQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectListTableDataQuery, ProjectListTableDataQueryVariables>({ query: ProjectListTableDataDocument, ...options });
};
export const ProjectListTableSummaryDocument = gql`
    query ProjectListTableSummary($filters: ProjectQueryArgs) {
  projectsSummary(filters: $filters) {
    total_budget
    our_work_total_budget
    our_work_spent_budget
    our_work_credit_balance
    our_work_credit_proforma_balance
    expenses_credit_balance
    expenses_credit_proforma_balance
    uninvoiced
    proforma_uninvoiced
    projectIds
    real_expenses
  }
}
    `;

export function useProjectListTableSummaryQuery(options?: Omit<Urql.UseQueryArgs<ProjectListTableSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectListTableSummaryQuery, ProjectListTableSummaryQueryVariables>({ query: ProjectListTableSummaryDocument, ...options });
};
export const FinishedProjectListTableSummaryDocument = gql`
    query FinishedProjectListTableSummary($filters: ProjectQueryArgs) {
  projectsSummary(filters: $filters) {
    projectIds
    profit
    net_profit
    gross_income
    net_margin_percent
    our_work_efficiency
    credit
  }
}
    `;

export function useFinishedProjectListTableSummaryQuery(options?: Omit<Urql.UseQueryArgs<FinishedProjectListTableSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<FinishedProjectListTableSummaryQuery, FinishedProjectListTableSummaryQueryVariables>({ query: FinishedProjectListTableSummaryDocument, ...options });
};
export const PlannedExpensesOverviewDocument = gql`
    query PlannedExpensesOverview($page: Int, $first: Int, $filters: PlannedExpensesQueryArgs) {
  plannedExpensesOverview(page: $page, first: $first, filters: $filters) {
    data {
      ...PlannedExpensesProject
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PlannedExpensesProjectFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function usePlannedExpensesOverviewQuery(options?: Omit<Urql.UseQueryArgs<PlannedExpensesOverviewQueryVariables>, 'query'>) {
  return Urql.useQuery<PlannedExpensesOverviewQuery, PlannedExpensesOverviewQueryVariables>({ query: PlannedExpensesOverviewDocument, ...options });
};
export const PlannedExpensesOverviewSummaryDocument = gql`
    query PlannedExpensesOverviewSummary($filters: PlannedExpensesQueryArgs) {
  plannedExpensesOverviewSummary(filters: $filters) {
    ...PlannedExpensesSummary
  }
}
    ${PlannedExpensesSummaryFragmentDoc}`;

export function usePlannedExpensesOverviewSummaryQuery(options?: Omit<Urql.UseQueryArgs<PlannedExpensesOverviewSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<PlannedExpensesOverviewSummaryQuery, PlannedExpensesOverviewSummaryQueryVariables>({ query: PlannedExpensesOverviewSummaryDocument, ...options });
};
export const PlannedExpensesFilterOptionsDocument = gql`
    query PlannedExpensesFilterOptions {
  teamSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    codename
    full_name
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projectCategories {
    id
    name
  }
  projectStages {
    id
    name
  }
  projectsSimpleMap {
    id
    code
    title
  }
}
    `;

export function usePlannedExpensesFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<PlannedExpensesFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<PlannedExpensesFilterOptionsQuery, PlannedExpensesFilterOptionsQueryVariables>({ query: PlannedExpensesFilterOptionsDocument, ...options });
};
export const GetProjectSettingsDocument = gql`
    query GetProjectSettings($id: ID!) {
  project(id: $id) {
    id
    uses_budgetovac
    finished_at
    average_time_tracking_rate
    calculated_average_time_tracking_rate
    rate_card_id
    rate_card_exchange_rate
    type
    timeTrackingRates {
      rate
      timeTrackingWorkType {
        id
        default_rate
        title
      }
    }
    ourWork {
      id
      title
      category {
        name
      }
      timeTrackingSettings {
        id
        tracking_enabled_from
        tracking_enabled_to
        tracking_enabled
      }
    }
    budgetovacBudget {
      budget_id
    }
    ...ProjectTitle
  }
}
    ${ProjectTitleFragmentDoc}`;

export function useGetProjectSettingsQuery(options: Omit<Urql.UseQueryArgs<GetProjectSettingsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>({ query: GetProjectSettingsDocument, ...options });
};
export const UpdateTimeTrackingSettingsForProjectDocument = gql`
    mutation UpdateTimeTrackingSettingsForProject($input: UpdateTimeTrackingSettingsInput!) {
  updateTimeTrackingSettingsForProject(input: $input) {
    ourWork {
      id
      title
      timeTrackingSettings {
        id
        tracking_enabled_from
        tracking_enabled_to
        tracking_enabled
      }
    }
  }
}
    `;

export function useUpdateTimeTrackingSettingsForProjectMutation() {
  return Urql.useMutation<UpdateTimeTrackingSettingsForProjectMutation, UpdateTimeTrackingSettingsForProjectMutationVariables>(UpdateTimeTrackingSettingsForProjectDocument);
};
export const UpdateTimeTrackingRatesForProjectDocument = gql`
    mutation UpdateTimeTrackingRatesForProject($input: UpdateTimeTrackingRatesForProjectInput!) {
  updateTimeTrackingRatesForProject(input: $input) {
    average_time_tracking_rate
    timeTrackingRates {
      rate
      timeTrackingWorkType {
        id
        default_rate
        title
      }
    }
  }
}
    `;

export function useUpdateTimeTrackingRatesForProjectMutation() {
  return Urql.useMutation<UpdateTimeTrackingRatesForProjectMutation, UpdateTimeTrackingRatesForProjectMutationVariables>(UpdateTimeTrackingRatesForProjectDocument);
};
export const ChangeRateCardOnProjectDocument = gql`
    mutation ChangeRateCardOnProject($projectId: ID!, $rateCardId: ID!, $exchangeRate: BigInt) {
  changeRateCardOnProject(
    project_id: $projectId
    rate_card_id: $rateCardId
    exchange_rate: $exchangeRate
  ) {
    rate_card_id
  }
}
    `;

export function useChangeRateCardOnProjectMutation() {
  return Urql.useMutation<ChangeRateCardOnProjectMutation, ChangeRateCardOnProjectMutationVariables>(ChangeRateCardOnProjectDocument);
};
export const DistributionModalTableDataDocument = gql`
    query DistributionModalTableData($first: BigInt!, $page: BigInt, $from: Date!, $to: Date!, $where: TimeTrackingReportsWhereConditions, $orderBy: [TimeTrackingItemOrderByClause!]) {
  getTimeTrackingItems(
    first: $first
    page: $page
    from: $from
    to: $to
    where: $where
    orderBy: $orderBy
  ) {
    data {
      ...DistributionModalTableItem
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${DistributionModalTableItemFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useDistributionModalTableDataQuery(options: Omit<Urql.UseQueryArgs<DistributionModalTableDataQueryVariables>, 'query'>) {
  return Urql.useQuery<DistributionModalTableDataQuery, DistributionModalTableDataQueryVariables>({ query: DistributionModalTableDataDocument, ...options });
};
export const DistributionModalFilterOptionsDocument = gql`
    query DistributionModalFilterOptions($projectId: ID!, $userSimpleWhere: UsersWhereConditions) {
  ourWorkBudgetItemsSimpleMap(project_id: [$projectId]) {
    id
    title
    timeTrackingSettings {
      tracking_enabled
      tracking_enabled_from
      tracking_enabled_to
    }
  }
  timeTrackingWorkTypes {
    id
    default_rate
    title
  }
  userSimpleMap(where: $userSimpleWhere) {
    id
    name
    full_name
    image {
      urls {
        thumbnail
      }
    }
    codename
  }
}
    `;

export function useDistributionModalFilterOptionsQuery(options: Omit<Urql.UseQueryArgs<DistributionModalFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<DistributionModalFilterOptionsQuery, DistributionModalFilterOptionsQueryVariables>({ query: DistributionModalFilterOptionsDocument, ...options });
};
export const TimeBillingExpenseItemsForModalDocument = gql`
    query TimeBillingExpenseItemsForModal($filters: ExpenseItemsTimeBillingQueryArgs, $first: Int, $page: Int) {
  expenseItemsForTimeBilling(filters: $filters, first: $first, page: $page) {
    data {
      id
      amount
      description {
        title
      }
      expense {
        id
        expense_no
        document_number
        date_of_supply
        contractor {
          legal_name
        }
      }
      budget_item_type
      budgetItem {
        id
        title
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

export function useTimeBillingExpenseItemsForModalQuery(options?: Omit<Urql.UseQueryArgs<TimeBillingExpenseItemsForModalQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeBillingExpenseItemsForModalQuery, TimeBillingExpenseItemsForModalQueryVariables>({ query: TimeBillingExpenseItemsForModalDocument, ...options });
};
export const TimeBillingOiBudgetItemsForModalDocument = gql`
    query TimeBillingOiBudgetItemsForModal($filters: OIBudgetItemsTimeBillingQueryArgs) {
  oiBudgetItemsForTimeBilling(filters: $filters) {
    data {
      outgoing_invoice_id
      budget_item_id
      budget_item_type
      amount
      outgoingInvoice {
        id
        invoice_no
        issue_date
        billingEntity {
          internal_name
          street
          city
        }
      }
      budgetItem {
        id
        title
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

export function useTimeBillingOiBudgetItemsForModalQuery(options?: Omit<Urql.UseQueryArgs<TimeBillingOiBudgetItemsForModalQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeBillingOiBudgetItemsForModalQuery, TimeBillingOiBudgetItemsForModalQueryVariables>({ query: TimeBillingOiBudgetItemsForModalDocument, ...options });
};
export const TimeBillingSourcesEditModalFilterOptionsDocument = gql`
    query TimeBillingSourcesEditModalFilterOptions($projectId: ID!) {
  ourWorkBudgetItemsSimpleMap(project_id: [$projectId]) {
    id
    title
    category {
      name
    }
  }
  expenseBudgetItemsSimpleMap(project_id: $projectId) {
    id
    title
    category {
      name
    }
  }
}
    `;

export function useTimeBillingSourcesEditModalFilterOptionsQuery(options: Omit<Urql.UseQueryArgs<TimeBillingSourcesEditModalFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeBillingSourcesEditModalFilterOptionsQuery, TimeBillingSourcesEditModalFilterOptionsQueryVariables>({ query: TimeBillingSourcesEditModalFilterOptionsDocument, ...options });
};
export const CreateProjectTimeBillingDocument = gql`
    mutation CreateProjectTimeBilling($input: CreateProjectTimeBillingInput!) {
  createProjectTimeBilling(input: $input) {
    ...ProjectTimeBillingDetail
  }
}
    ${ProjectTimeBillingDetailFragmentDoc}`;

export function useCreateProjectTimeBillingMutation() {
  return Urql.useMutation<CreateProjectTimeBillingMutation, CreateProjectTimeBillingMutationVariables>(CreateProjectTimeBillingDocument);
};
export const UpdateProjectTimeBillingDocument = gql`
    mutation UpdateProjectTimeBilling($input: UpdateProjectTimeBillingInput!) {
  updateProjectTimeBilling(input: $input) {
    ...ProjectTimeBillingDetail
  }
}
    ${ProjectTimeBillingDetailFragmentDoc}`;

export function useUpdateProjectTimeBillingMutation() {
  return Urql.useMutation<UpdateProjectTimeBillingMutation, UpdateProjectTimeBillingMutationVariables>(UpdateProjectTimeBillingDocument);
};
export const LockProjectTimeBillingDocument = gql`
    mutation LockProjectTimeBilling($id: ID!) {
  lockProjectTimeBilling(id: $id) {
    ...ProjectTimeBillingDetail
  }
}
    ${ProjectTimeBillingDetailFragmentDoc}`;

export function useLockProjectTimeBillingMutation() {
  return Urql.useMutation<LockProjectTimeBillingMutation, LockProjectTimeBillingMutationVariables>(LockProjectTimeBillingDocument);
};
export const UnlockProjectTimeBillingDocument = gql`
    mutation UnlockProjectTimeBilling($id: ID!) {
  unlockProjectTimeBilling(id: $id) {
    ...ProjectTimeBillingDetail
  }
}
    ${ProjectTimeBillingDetailFragmentDoc}`;

export function useUnlockProjectTimeBillingMutation() {
  return Urql.useMutation<UnlockProjectTimeBillingMutation, UnlockProjectTimeBillingMutationVariables>(UnlockProjectTimeBillingDocument);
};
export const DeleteProjectTimeBillingDocument = gql`
    mutation DeleteProjectTimeBilling($id: ID!) {
  deleteProjectTimeBilling(id: $id)
}
    `;

export function useDeleteProjectTimeBillingMutation() {
  return Urql.useMutation<DeleteProjectTimeBillingMutation, DeleteProjectTimeBillingMutationVariables>(DeleteProjectTimeBillingDocument);
};
export const CreateDataForProjectTimeBillingDocument = gql`
    query CreateDataForProjectTimeBilling($projectId: ID!, $dateFrom: Date!, $dateTo: Date!) {
  createDataForProjectTimeBilling(
    project_id: $projectId
    date_from: $dateFrom
    date_to: $dateTo
  ) {
    ...ProjectTimeBillingComputed
  }
}
    ${ProjectTimeBillingComputedFragmentDoc}`;

export function useCreateDataForProjectTimeBillingQuery(options: Omit<Urql.UseQueryArgs<CreateDataForProjectTimeBillingQueryVariables>, 'query'>) {
  return Urql.useQuery<CreateDataForProjectTimeBillingQuery, CreateDataForProjectTimeBillingQueryVariables>({ query: CreateDataForProjectTimeBillingDocument, ...options });
};
export const ProjectTimeBillingsDocument = gql`
    query ProjectTimeBillings($projectId: ID!, $first: Int!, $page: Int, $orderBy: [QueryProjectTimeBillingsOrderByOrderByClause!]) {
  projectTimeBillings(
    project_id: $projectId
    first: $first
    page: $page
    orderBy: $orderBy
  ) {
    data {
      ...ProjectTimeBillingListItem
    }
    paginatorInfo {
      currentPage
      lastPage
      total
      hasMorePages
    }
  }
}
    ${ProjectTimeBillingListItemFragmentDoc}`;

export function useProjectTimeBillingsQuery(options: Omit<Urql.UseQueryArgs<ProjectTimeBillingsQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectTimeBillingsQuery, ProjectTimeBillingsQueryVariables>({ query: ProjectTimeBillingsDocument, ...options });
};
export const ProjectTimeBillingDetailDocument = gql`
    query ProjectTimeBillingDetail($id: ID!) {
  projectTimeBilling(id: $id) {
    ...ProjectTimeBillingDetail
  }
}
    ${ProjectTimeBillingDetailFragmentDoc}`;

export function useProjectTimeBillingDetailQuery(options: Omit<Urql.UseQueryArgs<ProjectTimeBillingDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectTimeBillingDetailQuery, ProjectTimeBillingDetailQueryVariables>({ query: ProjectTimeBillingDetailDocument, ...options });
};
export const PreviewProjectTimeBillingDocument = gql`
    query PreviewProjectTimeBilling($input: PreviewProjectTimeBillingInput!) {
  previewProjectTimeBilling(input: $input) {
    ...ProjectTimeBillingComputed
  }
}
    ${ProjectTimeBillingComputedFragmentDoc}`;

export function usePreviewProjectTimeBillingQuery(options: Omit<Urql.UseQueryArgs<PreviewProjectTimeBillingQueryVariables>, 'query'>) {
  return Urql.useQuery<PreviewProjectTimeBillingQuery, PreviewProjectTimeBillingQueryVariables>({ query: PreviewProjectTimeBillingDocument, ...options });
};
export const UpdateProjectTimeBreakdownItemDocument = gql`
    mutation UpdateProjectTimeBreakdownItem($id: ID!, $budgeted: Int!, $dateFrom: Date, $dateTo: Date) {
  updateProjectTimeBreakdown(
    id: $id
    budgeted: $budgeted
    date_from: $dateFrom
    date_to: $dateTo
  ) {
    id
  }
}
    `;

export function useUpdateProjectTimeBreakdownItemMutation() {
  return Urql.useMutation<UpdateProjectTimeBreakdownItemMutation, UpdateProjectTimeBreakdownItemMutationVariables>(UpdateProjectTimeBreakdownItemDocument);
};
export const TimeTrackingProjectReportDocument = gql`
    query TimeTrackingProjectReport($filters: TimeTrackingProjectReportQueryArgs) {
  timeTrackingProjectReport(filters: $filters) {
    user_id
    team_id
    user_full_name
    tracked_time
    amount
    invoiced_amount
    time_tracking_work_type_title
    group_tracked_time
    group_amount
    our_work_budget_item_title
    hourly_rate
    internal_hourly_rate
    image
    time_tracking_work_type_id
    our_work_budget_item_id
    personal_expense
    personal_profitability
    invoiced_personal_profitability
    billable_all
    invoiced_seconds
    overserviced_seconds
    uninvoiced_seconds
  }
}
    `;

export function useTimeTrackingProjectReportQuery(options?: Omit<Urql.UseQueryArgs<TimeTrackingProjectReportQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingProjectReportQuery, TimeTrackingProjectReportQueryVariables>({ query: TimeTrackingProjectReportDocument, ...options });
};
export const ProjectOurWorkItemsDocument = gql`
    query ProjectOurWorkItems($id: ID!) {
  project(id: $id) {
    uses_budgetovac
    start_date
    finished_at
    expected_end_date
    brand {
      id
    }
    ourWork {
      id
      title
    }
    ...ProjectTitle
  }
}
    ${ProjectTitleFragmentDoc}`;

export function useProjectOurWorkItemsQuery(options: Omit<Urql.UseQueryArgs<ProjectOurWorkItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectOurWorkItemsQuery, ProjectOurWorkItemsQueryVariables>({ query: ProjectOurWorkItemsDocument, ...options });
};
export const ProjectTimeBreakdownDocument = gql`
    query ProjectTimeBreakdown($projectId: ID!) {
  projectTimeBreakdowns(project_id: $projectId) {
    id
    title
    tracked_time
    tracked_amount
    budgeted
    budgeted_time
    personal_expenses
    profit
    time_breakdown {
      id
      date_from
      date_to
      tracked_time
      tracked_amount
      budgeted
      budgeted_time
      personal_expenses
      profit
    }
  }
}
    `;

export function useProjectTimeBreakdownQuery(options: Omit<Urql.UseQueryArgs<ProjectTimeBreakdownQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectTimeBreakdownQuery, ProjectTimeBreakdownQueryVariables>({ query: ProjectTimeBreakdownDocument, ...options });
};
export const BrandReportOptionsDocument = gql`
    query BrandReportOptions {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projectsSimpleMap {
    id
    title
    code
  }
}
    `;

export function useBrandReportOptionsQuery(options?: Omit<Urql.UseQueryArgs<BrandReportOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<BrandReportOptionsQuery, BrandReportOptionsQueryVariables>({ query: BrandReportOptionsDocument, ...options });
};
export const BrandProfitAndRevenueSummaryDocument = gql`
    query BrandProfitAndRevenueSummary($filters: BrandRevenueQueryArgs) {
  brandRevenueSummary(filters: $filters) {
    our_work_revenue_for_date_range
    our_work_billings_for_date_range
    our_work_revenue_for_date_range_percentage
    gross_profit_for_date_range
    gross_income_for_date_range
    total_invoiced
    expense_revenue_for_date_range {
      category {
        id
        name
      }
      profit
      profit_percentage
      billings
    }
    brand_profit_share {
      name
      value
    }
    brand_revenue_share {
      name
      value
    }
    client_revenue_share {
      name
      value
    }
  }
}
    `;

export function useBrandProfitAndRevenueSummaryQuery(options?: Omit<Urql.UseQueryArgs<BrandProfitAndRevenueSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<BrandProfitAndRevenueSummaryQuery, BrandProfitAndRevenueSummaryQueryVariables>({ query: BrandProfitAndRevenueSummaryDocument, ...options });
};
export const BrandProfitAndRevenueTableDataDocument = gql`
    query BrandProfitAndRevenueTableData($filters: BrandRevenueQueryArgs) {
  expenseBudgetCategories {
    id
    name
  }
  brandRevenue(filters: $filters) {
    result {
      ...BrandTableData
      gross_profit_for_date_range
      our_work_revenue_for_date_range
      filtered_profit_share
      total_profit_share
      expenses_profit_for_date_range {
        expense_budget_category_id
        profit
      }
      total_invoiced
      our_work_billings_for_date_range
      filtered_revenue_share
      total_revenue_share
      expenses_billings_for_date_range {
        expense_budget_category_id
        billings
      }
      brands {
        id
        name
        image {
          urls {
            thumbnail
          }
        }
        gross_income_for_date_range
        gross_profit_for_date_range
        our_work_revenue_for_date_range
        filtered_profit_share
        total_profit_share
        expenses_profit_for_date_range {
          expense_budget_category_id
          profit
        }
        total_invoiced
        our_work_billings_for_date_range
        filtered_revenue_share
        total_revenue_share
        expenses_billings_for_date_range {
          expense_budget_category_id
          billings
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${BrandTableDataFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useBrandProfitAndRevenueTableDataQuery(options?: Omit<Urql.UseQueryArgs<BrandProfitAndRevenueTableDataQueryVariables>, 'query'>) {
  return Urql.useQuery<BrandProfitAndRevenueTableDataQuery, BrandProfitAndRevenueTableDataQueryVariables>({ query: BrandProfitAndRevenueTableDataDocument, ...options });
};
export const BrandProfitSummaryDocument = gql`
    query BrandProfitSummary($filters: BrandRevenueQueryArgs) {
  brandRevenueSummary(filters: $filters) {
    our_work_revenue_for_date_range
    our_work_revenue_for_date_range_percentage
    gross_profit_for_date_range
    expense_revenue_for_date_range {
      category {
        id
        name
      }
      profit
      profit_percentage
      billings
    }
    brand_profit_share {
      name
      value
    }
    profit_top_clients {
      name
      total_value
      brands {
        name
        value
      }
    }
  }
}
    `;

export function useBrandProfitSummaryQuery(options?: Omit<Urql.UseQueryArgs<BrandProfitSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<BrandProfitSummaryQuery, BrandProfitSummaryQueryVariables>({ query: BrandProfitSummaryDocument, ...options });
};
export const BrandProfitTableDataDocument = gql`
    query BrandProfitTableData($filters: BrandRevenueQueryArgs) {
  expenseBudgetCategories {
    id
    name
  }
  brandRevenue(filters: $filters) {
    result {
      ...BrandTableData
      gross_profit_for_date_range
      our_work_revenue_for_date_range
      filtered_profit_share
      total_profit_share
      expenses_profit_for_date_range {
        expense_budget_category_id
        profit
      }
      brands {
        id
        name
        image {
          urls {
            thumbnail
          }
        }
        gross_income_for_date_range
        gross_profit_for_date_range
        our_work_revenue_for_date_range
        filtered_profit_share
        total_profit_share
        expenses_profit_for_date_range {
          expense_budget_category_id
          profit
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${BrandTableDataFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useBrandProfitTableDataQuery(options?: Omit<Urql.UseQueryArgs<BrandProfitTableDataQueryVariables>, 'query'>) {
  return Urql.useQuery<BrandProfitTableDataQuery, BrandProfitTableDataQueryVariables>({ query: BrandProfitTableDataDocument, ...options });
};
export const BrandRevenueSummaryDocument = gql`
    query BrandRevenueSummary($filters: BrandRevenueQueryArgs) {
  brandRevenueSummary(filters: $filters) {
    our_work_billings_for_date_range
    gross_income_for_date_range
    total_invoiced
    expense_revenue_for_date_range {
      category {
        id
        name
      }
      profit
      billings
    }
    brand_revenue_share {
      name
      value
    }
    client_revenue_share {
      name
      value
    }
    revenue_top_clients {
      name
      total_value
      brands {
        name
        value
      }
    }
  }
}
    `;

export function useBrandRevenueSummaryQuery(options?: Omit<Urql.UseQueryArgs<BrandRevenueSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<BrandRevenueSummaryQuery, BrandRevenueSummaryQueryVariables>({ query: BrandRevenueSummaryDocument, ...options });
};
export const BrandRevenueTableDataDocument = gql`
    query BrandRevenueTableData($filters: BrandRevenueQueryArgs) {
  expenseBudgetCategories {
    id
    name
  }
  brandRevenue(filters: $filters) {
    result {
      ...BrandTableData
      total_invoiced
      our_work_billings_for_date_range
      filtered_revenue_share
      total_revenue_share
      expenses_billings_for_date_range {
        expense_budget_category_id
        billings
      }
      brands {
        id
        name
        image {
          urls {
            thumbnail
          }
        }
        gross_income_for_date_range
        total_invoiced
        our_work_billings_for_date_range
        filtered_revenue_share
        total_revenue_share
        expenses_billings_for_date_range {
          expense_budget_category_id
          billings
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${BrandTableDataFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useBrandRevenueTableDataQuery(options?: Omit<Urql.UseQueryArgs<BrandRevenueTableDataQueryVariables>, 'query'>) {
  return Urql.useQuery<BrandRevenueTableDataQuery, BrandRevenueTableDataQueryVariables>({ query: BrandRevenueTableDataDocument, ...options });
};
export const ProfitAndLossReportDocument = gql`
    query ProfitAndLossReport($where: ProfitLossReportWhereConditions, $from: Date!, $to: Date!, $rows: ProfitLossReportRows!, $columns: ProfitLossReportColumns, $page: BigInt!, $first: BigInt!, $includeDraftExpenses: Boolean) {
  profitLossReport(
    where: $where
    from: $from
    to: $to
    rows: $rows
    columns: $columns
    page: $page
    first: $first
    include_draft_expenses: $includeDraftExpenses
  ) {
    data {
      id
      title
      columns {
        ...ProfitAndLossReportColumn
      }
      items {
        id
        title
        columns {
          ...ProfitAndLossReportColumn
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ProfitAndLossReportColumnFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useProfitAndLossReportQuery(options: Omit<Urql.UseQueryArgs<ProfitAndLossReportQueryVariables>, 'query'>) {
  return Urql.useQuery<ProfitAndLossReportQuery, ProfitAndLossReportQueryVariables>({ query: ProfitAndLossReportDocument, ...options });
};
export const ProfitAndLossReportSummaryDocument = gql`
    query ProfitAndLossReportSummary($where: ProfitLossReportWhereConditions, $from: Date!, $to: Date!, $columns: ProfitLossReportColumns, $includeDraftExpenses: Boolean) {
  profitLossReportSummary(
    where: $where
    from: $from
    to: $to
    columns: $columns
    include_draft_expenses: $includeDraftExpenses
  ) {
    data {
      ...ProfitAndLossReportColumn
    }
  }
}
    ${ProfitAndLossReportColumnFragmentDoc}`;

export function useProfitAndLossReportSummaryQuery(options: Omit<Urql.UseQueryArgs<ProfitAndLossReportSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<ProfitAndLossReportSummaryQuery, ProfitAndLossReportSummaryQueryVariables>({ query: ProfitAndLossReportSummaryDocument, ...options });
};
export const ProfitAndLossFilterOptionsDocument = gql`
    query ProfitAndLossFilterOptions {
  clientsSimpleMap {
    ...ClientSimpleOptionParts
    brands {
      ...BrandSimpleOptionParts
    }
  }
  projectManagerSimpleMap {
    ...UserSimpleOptionParts
  }
  projectCategories {
    id
    name
  }
  teamSimpleMap {
    id
    name
  }
  projectsSimpleMap {
    id
    title
    code
  }
}
    ${ClientSimpleOptionPartsFragmentDoc}
${BrandSimpleOptionPartsFragmentDoc}
${UserSimpleOptionPartsFragmentDoc}`;

export function useProfitAndLossFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<ProfitAndLossFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ProfitAndLossFilterOptionsQuery, ProfitAndLossFilterOptionsQueryVariables>({ query: ProfitAndLossFilterOptionsDocument, ...options });
};
export const UpdateProjectNoteDocument = gql`
    mutation UpdateProjectNote($id: ID!, $note: String, $isTemplate: Boolean!) {
  updateProject(input: {id: $id, note: $note, is_template: $isTemplate}) {
    id
    note
  }
}
    `;

export function useUpdateProjectNoteMutation() {
  return Urql.useMutation<UpdateProjectNoteMutation, UpdateProjectNoteMutationVariables>(UpdateProjectNoteDocument);
};
export const UpdateOwbiNoteDocument = gql`
    mutation UpdateOWBINote($id: ID!, $note: String) {
  updateOurWorkBudgetItemNote(our_work_budget_item_id: $id, note: $note) {
    id
    note
  }
}
    `;

export function useUpdateOwbiNoteMutation() {
  return Urql.useMutation<UpdateOwbiNoteMutation, UpdateOwbiNoteMutationVariables>(UpdateOwbiNoteDocument);
};
export const UpdateExbiNoteDocument = gql`
    mutation UpdateEXBINote($id: ID!, $note: String) {
  updateExpenseBudgetItemNote(expense_budget_item_id: $id, note: $note) {
    id
    note
  }
}
    `;

export function useUpdateExbiNoteMutation() {
  return Urql.useMutation<UpdateExbiNoteMutation, UpdateExbiNoteMutationVariables>(UpdateExbiNoteDocument);
};
export const ProjectReportOptionsDocument = gql`
    query ProjectReportOptions {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  teamSimpleMap {
    id
    name
  }
}
    `;

export function useProjectReportOptionsQuery(options?: Omit<Urql.UseQueryArgs<ProjectReportOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectReportOptionsQuery, ProjectReportOptionsQueryVariables>({ query: ProjectReportOptionsDocument, ...options });
};
export const ProjectRevenueDetailDocument = gql`
    query ProjectRevenueDetail($projectId: ID!, $from: Date!, $to: Date!) {
  projectRevenueDetail(project_id: $projectId, from: $from, to: $to) {
    ourWork {
      billings_for_date_range
      revenue_for_date_range
      ourWorkBudgetItem {
        id
        title
        note
        stats {
          net_profit
          net_margin_percent
        }
      }
    }
    expensesStructured {
      expenseBudgetCategory {
        id
        name
      }
      budgetItems {
        billings_for_date_range
        profit_for_date_range
        expenseBudgetItem {
          completed_at
          category {
            name
          }
          id
          type
          title
          note
          stats {
            credit
            profit
            profit_percent
            real_expenses
          }
        }
      }
    }
  }
}
    `;

export function useProjectRevenueDetailQuery(options: Omit<Urql.UseQueryArgs<ProjectRevenueDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectRevenueDetailQuery, ProjectRevenueDetailQueryVariables>({ query: ProjectRevenueDetailDocument, ...options });
};
export const ProjectsReportExportDocument = gql`
    query ProjectsReportExport($from: Date!, $to: Date!) {
  projectsProfitExport(from: $from, to: $to)
}
    `;

export function useProjectsReportExportQuery(options: Omit<Urql.UseQueryArgs<ProjectsReportExportQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectsReportExportQuery, ProjectsReportExportQueryVariables>({ query: ProjectsReportExportDocument, ...options });
};
export const ProjectProfitAndRevenueSummaryDocument = gql`
    query ProjectProfitAndRevenueSummary($filters: ProjectRevenueQueryArgs) {
  projectRevenueSummary(filters: $filters) {
    our_work_revenue_for_date_range
    our_work_billings_for_date_range
    our_work_revenue_for_date_range_percentage
    gross_profit_for_date_range
    gross_income_for_date_range
    total_invoiced
    expense_revenue_for_date_range {
      category {
        id
        name
      }
      profit
      profit_percentage
      billings
    }
    brand_profit_share {
      name
      value
    }
    brand_revenue_share {
      name
      value
    }
    client_revenue_share {
      name
      value
    }
  }
}
    `;

export function useProjectProfitAndRevenueSummaryQuery(options?: Omit<Urql.UseQueryArgs<ProjectProfitAndRevenueSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectProfitAndRevenueSummaryQuery, ProjectProfitAndRevenueSummaryQueryVariables>({ query: ProjectProfitAndRevenueSummaryDocument, ...options });
};
export const ProjectProfitAndRevenueTableDataDocument = gql`
    query ProjectProfitAndRevenueTableData($filters: ProjectRevenueQueryArgs) {
  expenseBudgetCategories {
    id
    name
  }
  projectRevenue(filters: $filters) {
    projects {
      ...ProjectTableData
      gross_profit_for_date_range
      filtered_profit_share
      total_profit_share
      our_work_revenue_for_date_range
      expenses_profit_for_date_range {
        expense_budget_category_id
        profit
      }
      total_invoiced
      our_work_billings_for_date_range
      total_revenue_share
      filtered_revenue_share
      expenses_billings_for_date_range {
        expense_budget_category_id
        billings
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ProjectTableDataFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useProjectProfitAndRevenueTableDataQuery(options?: Omit<Urql.UseQueryArgs<ProjectProfitAndRevenueTableDataQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectProfitAndRevenueTableDataQuery, ProjectProfitAndRevenueTableDataQueryVariables>({ query: ProjectProfitAndRevenueTableDataDocument, ...options });
};
export const ProjectProfitSummaryDocument = gql`
    query ProjectProfitSummary($filters: ProjectRevenueQueryArgs) {
  projectRevenueSummary(filters: $filters) {
    our_work_revenue_for_date_range
    our_work_revenue_for_date_range_percentage
    gross_profit_for_date_range
    expense_revenue_for_date_range {
      category {
        id
        name
      }
      profit
      profit_percentage
      billings
    }
    brand_profit_share {
      name
      value
    }
    profit_top_projects {
      title
      total_value
      our_work {
        value
      }
      expense_budget_categories {
        value
        expense_budget_item_id
      }
    }
  }
}
    `;

export function useProjectProfitSummaryQuery(options?: Omit<Urql.UseQueryArgs<ProjectProfitSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectProfitSummaryQuery, ProjectProfitSummaryQueryVariables>({ query: ProjectProfitSummaryDocument, ...options });
};
export const ProjectProfitTableDataDocument = gql`
    query ProjectProfitTableData($filters: ProjectRevenueQueryArgs) {
  expenseBudgetCategories {
    id
    name
  }
  projectRevenue(filters: $filters) {
    projects {
      ...ProjectTableData
      gross_profit_for_date_range
      filtered_profit_share
      total_profit_share
      our_work_revenue_for_date_range
      expenses_profit_for_date_range {
        expense_budget_category_id
        profit
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ProjectTableDataFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useProjectProfitTableDataQuery(options?: Omit<Urql.UseQueryArgs<ProjectProfitTableDataQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectProfitTableDataQuery, ProjectProfitTableDataQueryVariables>({ query: ProjectProfitTableDataDocument, ...options });
};
export const ProjectRevenueSummaryDocument = gql`
    query ProjectRevenueSummary($filters: ProjectRevenueQueryArgs) {
  projectRevenueSummary(filters: $filters) {
    our_work_billings_for_date_range
    gross_income_for_date_range
    total_invoiced
    expense_revenue_for_date_range {
      category {
        id
        name
      }
      profit
      billings
    }
    brand_revenue_share {
      name
      value
    }
    client_revenue_share {
      name
      value
    }
    revenue_top_projects {
      title
      total_value
      our_work {
        value
      }
      expense_budget_categories {
        value
        expense_budget_item_id
      }
    }
  }
}
    `;

export function useProjectRevenueSummaryQuery(options?: Omit<Urql.UseQueryArgs<ProjectRevenueSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectRevenueSummaryQuery, ProjectRevenueSummaryQueryVariables>({ query: ProjectRevenueSummaryDocument, ...options });
};
export const ProjectRevenueTableDataDocument = gql`
    query ProjectRevenueTableData($filters: ProjectRevenueQueryArgs) {
  expenseBudgetCategories {
    id
    name
  }
  projectRevenue(filters: $filters) {
    projects {
      ...ProjectTableData
      total_invoiced
      total_revenue_share
      filtered_revenue_share
      our_work_billings_for_date_range
      expenses_billings_for_date_range {
        expense_budget_category_id
        billings
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ProjectTableDataFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useProjectRevenueTableDataQuery(options?: Omit<Urql.UseQueryArgs<ProjectRevenueTableDataQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectRevenueTableDataQuery, ProjectRevenueTableDataQueryVariables>({ query: ProjectRevenueTableDataDocument, ...options });
};
export const ProjectsAllDocument = gql`
    query ProjectsAll($filters: ProjectAllQueryArgs, $first: Int, $page: Int) {
  projectsAll(filters: $filters, first: $first, page: $page) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      id
      code
      title
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

export function useProjectsAllQuery(options?: Omit<Urql.UseQueryArgs<ProjectsAllQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectsAllQuery, ProjectsAllQueryVariables>({ query: ProjectsAllDocument, ...options });
};
export const UserMonthlyReportDataDocument = gql`
    query UserMonthlyReportData($month: BigInt!, $year: BigInt!, $first: BigInt, $page: BigInt, $orderBy: UserMonthlyReportOrderByClause) {
  userMonthlyReport(
    month: $month
    year: $year
    first: $first
    page: $page
    orderBy: $orderBy
  ) {
    teams {
      id
      name
      is_default
      user_count
    }
    paginatorInfo {
      count
      currentPage
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
    data {
      id
      user_full_name
      user_image
      total_tracked_time
      tracked_time_per_team {
        team_id
        tracked_time
        tracked_time_percentage
      }
    }
  }
}
    `;

export function useUserMonthlyReportDataQuery(options: Omit<Urql.UseQueryArgs<UserMonthlyReportDataQueryVariables>, 'query'>) {
  return Urql.useQuery<UserMonthlyReportDataQuery, UserMonthlyReportDataQueryVariables>({ query: UserMonthlyReportDataDocument, ...options });
};
export const UserMonthlyReportExportDocument = gql`
    query userMonthlyReportExport($month: BigInt!, $year: BigInt!) {
  userMonthlyReportExport(month: $month, year: $year)
}
    `;

export function useUserMonthlyReportExportQuery(options: Omit<Urql.UseQueryArgs<UserMonthlyReportExportQueryVariables>, 'query'>) {
  return Urql.useQuery<UserMonthlyReportExportQuery, UserMonthlyReportExportQueryVariables>({ query: UserMonthlyReportExportDocument, ...options });
};
export const UserProfitReportDocument = gql`
    query UserProfitReport($dataSource: UtilizationReportDataSource!, $where: UtilizationReportWhereConditions, $page: BigInt!, $first: BigInt!, $from: Date!, $to: Date!, $orderBy: [UtilizationReportOrderByClause!]) {
  utilizationReport(
    dataSource: $dataSource
    where: $where
    page: $page
    first: $first
    from: $from
    to: $to
    orderBy: $orderBy
  ) {
    data {
      user {
        ...UserProfitUser
      }
      report {
        ...UserProfitReport
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${UserProfitUserFragmentDoc}
${UserProfitReportFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useUserProfitReportQuery(options: Omit<Urql.UseQueryArgs<UserProfitReportQueryVariables>, 'query'>) {
  return Urql.useQuery<UserProfitReportQuery, UserProfitReportQueryVariables>({ query: UserProfitReportDocument, ...options });
};
export const UserProfitReportGroupedByDocument = gql`
    query UserProfitReportGroupedBy($groupBy: UtilizationReportGroupBy!, $dataSource: UtilizationReportDataSource!, $where: UtilizationReportWhereConditions, $page: BigInt!, $first: BigInt!, $from: Date!, $to: Date!, $orderBy: [UtilizationReportOrderByClause!], $groupOrderBy: [UtilizationReportGroupOrderByClause!]) {
  utilizationReportGroups(
    groupBy: $groupBy
    dataSource: $dataSource
    where: $where
    page: $page
    first: $first
    from: $from
    to: $to
    orderBy: $orderBy
    groupOrderBy: $groupOrderBy
  ) {
    data {
      group_title
      report {
        ...UserProfitReport
      }
      items {
        user {
          ...UserProfitUser
        }
        report {
          ...UserProfitReport
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${UserProfitReportFragmentDoc}
${UserProfitUserFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useUserProfitReportGroupedByQuery(options: Omit<Urql.UseQueryArgs<UserProfitReportGroupedByQueryVariables>, 'query'>) {
  return Urql.useQuery<UserProfitReportGroupedByQuery, UserProfitReportGroupedByQueryVariables>({ query: UserProfitReportGroupedByDocument, ...options });
};
export const UserProfitReportStatsDocument = gql`
    query UserProfitReportStats($dataSource: UtilizationReportDataSource!, $where: UtilizationReportWhereConditions, $from: Date!, $to: Date!) {
  utilizationReportSummary(
    dataSource: $dataSource
    where: $where
    from: $from
    to: $to
  ) {
    ...UserProfitReport
  }
}
    ${UserProfitReportFragmentDoc}`;

export function useUserProfitReportStatsQuery(options: Omit<Urql.UseQueryArgs<UserProfitReportStatsQueryVariables>, 'query'>) {
  return Urql.useQuery<UserProfitReportStatsQuery, UserProfitReportStatsQueryVariables>({ query: UserProfitReportStatsDocument, ...options });
};
export const UserProfitReportExportDocument = gql`
    query UserProfitReportExport($dataSource: UtilizationReportDataSource!, $where: UtilizationReportWhereConditions, $from: Date!, $to: Date!) {
  utilizationReportExport(
    dataSource: $dataSource
    where: $where
    from: $from
    to: $to
  )
}
    `;

export function useUserProfitReportExportQuery(options: Omit<Urql.UseQueryArgs<UserProfitReportExportQueryVariables>, 'query'>) {
  return Urql.useQuery<UserProfitReportExportQuery, UserProfitReportExportQueryVariables>({ query: UserProfitReportExportDocument, ...options });
};
export const UpdateTaskCurrentAssigneeDocument = gql`
    mutation UpdateTaskCurrentAssignee($taskId: ID!, $userId: ID) {
  updateTaskCurrentAssignee(task_id: $taskId, current_assignee_user_id: $userId) {
    id
    currentAssignee {
      ...TaskUser
    }
    positions {
      ...TaskPositionUser
    }
    users {
      ...TaskUser
    }
  }
}
    ${TaskUserFragmentDoc}
${TaskPositionUserFragmentDoc}`;

export function useUpdateTaskCurrentAssigneeMutation() {
  return Urql.useMutation<UpdateTaskCurrentAssigneeMutation, UpdateTaskCurrentAssigneeMutationVariables>(UpdateTaskCurrentAssigneeDocument);
};
export const UpdateTaskAssigneesDocument = gql`
    mutation UpdateTaskAssignees($taskId: ID!, $positions: [TaskPositionInput!]!) {
  updateTaskAssignees(task_id: $taskId, positions: $positions) {
    id
    currentAssignee {
      ...TaskUser
    }
    positions {
      ...TaskPositionUser
    }
    users {
      ...TaskUser
    }
    stats {
      planned_time
      spent_time
    }
  }
}
    ${TaskUserFragmentDoc}
${TaskPositionUserFragmentDoc}`;

export function useUpdateTaskAssigneesMutation() {
  return Urql.useMutation<UpdateTaskAssigneesMutation, UpdateTaskAssigneesMutationVariables>(UpdateTaskAssigneesDocument);
};
export const UpdateTaskDeadlineDocument = gql`
    mutation UpdateTaskDeadline($taskId: ID!, $deadline: DateTime) {
  updateTaskDeadline(task_id: $taskId, deadline: $deadline) {
    ...TaskSchedule
  }
}
    ${TaskScheduleFragmentDoc}`;

export function useUpdateTaskDeadlineMutation() {
  return Urql.useMutation<UpdateTaskDeadlineMutation, UpdateTaskDeadlineMutationVariables>(UpdateTaskDeadlineDocument);
};
export const UpdateTaskDurationDocument = gql`
    mutation UpdateTaskDuration($taskId: ID!, $from: Date, $to: Date) {
  updateTaskDuration(task_id: $taskId, from: $from, to: $to) {
    ...TaskSchedule
  }
}
    ${TaskScheduleFragmentDoc}`;

export function useUpdateTaskDurationMutation() {
  return Urql.useMutation<UpdateTaskDurationMutation, UpdateTaskDurationMutationVariables>(UpdateTaskDurationDocument);
};
export const UpdateTaskBillableDocument = gql`
    mutation UpdateTaskBillable($taskId: ID!, $billable: Boolean!, $propagateBillable: Boolean!) {
  updateTaskBillable(
    task_id: $taskId
    billable: $billable
    propagate_billable: $propagateBillable
  ) {
    id
    billable
  }
}
    `;

export function useUpdateTaskBillableMutation() {
  return Urql.useMutation<UpdateTaskBillableMutation, UpdateTaskBillableMutationVariables>(UpdateTaskBillableDocument);
};
export const AddTaskAssigneeDocument = gql`
    mutation AddTaskAssignee($taskId: ID!, $position: TaskPositionInput!) {
  addTaskAssignee(task_id: $taskId, position: $position) {
    id
    currentAssignee {
      ...TaskUser
    }
    positions {
      ...TaskPositionUser
    }
    users {
      ...TaskUser
    }
    stats {
      planned_time
      spent_time
    }
  }
}
    ${TaskUserFragmentDoc}
${TaskPositionUserFragmentDoc}`;

export function useAddTaskAssigneeMutation() {
  return Urql.useMutation<AddTaskAssigneeMutation, AddTaskAssigneeMutationVariables>(AddTaskAssigneeDocument);
};
export const UpdateTaskBoardSettingsDocument = gql`
    mutation UpdateTaskBoardSettings($input: UpdateTaskBoardSettingsInput!) {
  updateTaskBoardSettings(input: $input) {
    ...BoardSettings
  }
}
    ${BoardSettingsFragmentDoc}`;

export function useUpdateTaskBoardSettingsMutation() {
  return Urql.useMutation<UpdateTaskBoardSettingsMutation, UpdateTaskBoardSettingsMutationVariables>(UpdateTaskBoardSettingsDocument);
};
export const MoveTaskOnBoardDocument = gql`
    mutation MoveTaskOnBoard($input: MoveTaskOnBoardInput!) {
  moveTaskOnBoard(input: $input) {
    ...TaskBase
  }
}
    ${TaskBaseFragmentDoc}`;

export function useMoveTaskOnBoardMutation() {
  return Urql.useMutation<MoveTaskOnBoardMutation, MoveTaskOnBoardMutationVariables>(MoveTaskOnBoardDocument);
};
export const TaskBoardColumnCountsDocument = gql`
    query TaskBoardColumnCounts($filters: TaskQueryArgs!, $groupBy: TaskBoardGroupByEnum!, $groupValues: [ID!], $includeComplete: Boolean, $first: Int, $page: Int) {
  taskBoardColumnCounts(
    filters: $filters
    group_by: $groupBy
    group_values: $groupValues
    include_complete: $includeComplete
    first: $first
    page: $page
  ) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      group_value
      group_label
      total
      spent_time
      planned_time
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

export function useTaskBoardColumnCountsQuery(options: Omit<Urql.UseQueryArgs<TaskBoardColumnCountsQueryVariables>, 'query'>) {
  return Urql.useQuery<TaskBoardColumnCountsQuery, TaskBoardColumnCountsQueryVariables>({ query: TaskBoardColumnCountsDocument, ...options });
};
export const TaskBoardColumnTasksDocument = gql`
    query TaskBoardColumnTasks($filters: TaskQueryArgs!, $first: Int, $page: Int) {
  tasks(filters: $filters, first: $first, page: $page) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      ...TaskBase
    }
  }
}
    ${PaginatorInfoFragmentDoc}
${TaskBaseFragmentDoc}`;

export function useTaskBoardColumnTasksQuery(options: Omit<Urql.UseQueryArgs<TaskBoardColumnTasksQueryVariables>, 'query'>) {
  return Urql.useQuery<TaskBoardColumnTasksQuery, TaskBoardColumnTasksQueryVariables>({ query: TaskBoardColumnTasksDocument, ...options });
};
export const TaskBoardSettingsDocument = gql`
    query TaskBoardSettings($boardKey: String!) {
  taskBoardSettings(board_key: $boardKey) {
    ...BoardSettings
  }
}
    ${BoardSettingsFragmentDoc}`;

export function useTaskBoardSettingsQuery(options: Omit<Urql.UseQueryArgs<TaskBoardSettingsQueryVariables>, 'query'>) {
  return Urql.useQuery<TaskBoardSettingsQuery, TaskBoardSettingsQueryVariables>({ query: TaskBoardSettingsDocument, ...options });
};
export const BulkTasksDeleteDocument = gql`
    mutation BulkTasksDelete($taskIds: [ID!]!) {
  bulkDeleteTasks(task_ids: $taskIds)
}
    `;

export function useBulkTasksDeleteMutation() {
  return Urql.useMutation<BulkTasksDeleteMutation, BulkTasksDeleteMutationVariables>(BulkTasksDeleteDocument);
};
export const BulkTasksEditDocument = gql`
    mutation BulkTasksEdit($taskIds: [ID!]!, $duplicateTasks: Boolean!, $data: BulkEditTaskInput!) {
  bulkEditTasks(task_ids: $taskIds, duplicate_task: $duplicateTasks, data: $data)
}
    `;

export function useBulkTasksEditMutation() {
  return Urql.useMutation<BulkTasksEditMutation, BulkTasksEditMutationVariables>(BulkTasksEditDocument);
};
export const ListingClientTasksDocument = gql`
    query ListingClientTasks($filters: TaskQueryArgs!, $first: Int, $page: Int) {
  tasks(filters: $filters, first: $first, page: $page) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      ...ListingClientTask
    }
  }
}
    ${PaginatorInfoFragmentDoc}
${ListingClientTaskFragmentDoc}`;

export function useListingClientTasksQuery(options: Omit<Urql.UseQueryArgs<ListingClientTasksQueryVariables>, 'query'>) {
  return Urql.useQuery<ListingClientTasksQuery, ListingClientTasksQueryVariables>({ query: ListingClientTasksDocument, ...options });
};
export const ListingInternalTasksDocument = gql`
    query ListingInternalTasks($filters: TaskQueryArgs!, $first: Int, $page: Int) {
  tasks(filters: $filters, first: $first, page: $page) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      ...ListingInternalTask
    }
  }
}
    ${PaginatorInfoFragmentDoc}
${ListingInternalTaskFragmentDoc}`;

export function useListingInternalTasksQuery(options: Omit<Urql.UseQueryArgs<ListingInternalTasksQueryVariables>, 'query'>) {
  return Urql.useQuery<ListingInternalTasksQuery, ListingInternalTasksQueryVariables>({ query: ListingInternalTasksDocument, ...options });
};
export const AllTaskIdsDocument = gql`
    query AllTaskIds($filters: TaskQueryArgs!) {
  taskIds(filters: $filters)
}
    `;

export function useAllTaskIdsQuery(options: Omit<Urql.UseQueryArgs<AllTaskIdsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllTaskIdsQuery, AllTaskIdsQueryVariables>({ query: AllTaskIdsDocument, ...options });
};
export const PrepareTaskDataForBulkActionsDocument = gql`
    query PrepareTaskDataForBulkActions($taskIds: [ID!]!, $destinationBudgetItemId: ID!) {
  prepareTaskDataForBulkActions(
    task_ids: $taskIds
    destination_budget_item_id: $destinationBudgetItemId
  ) {
    has_subtasks
    available_positions {
      id
      title
    }
    unavailable_positions {
      id
      title
    }
  }
}
    `;

export function usePrepareTaskDataForBulkActionsQuery(options: Omit<Urql.UseQueryArgs<PrepareTaskDataForBulkActionsQueryVariables>, 'query'>) {
  return Urql.useQuery<PrepareTaskDataForBulkActionsQuery, PrepareTaskDataForBulkActionsQueryVariables>({ query: PrepareTaskDataForBulkActionsDocument, ...options });
};
export const BulkTasksOptionsDocument = gql`
    query BulkTasksOptions {
  taskStatuses {
    name
    id
  }
}
    `;

export function useBulkTasksOptionsQuery(options?: Omit<Urql.UseQueryArgs<BulkTasksOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<BulkTasksOptionsQuery, BulkTasksOptionsQueryVariables>({ query: BulkTasksOptionsDocument, ...options });
};
export const TasksDocument = gql`
    query Tasks($filters: TaskQueryArgs!, $first: Int, $page: Int) {
  tasks(filters: $filters, first: $first, page: $page) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      ...TaskBasicInfo
      ...TaskExtendedInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}
${TaskBasicInfoFragmentDoc}
${TaskExtendedInfoFragmentDoc}`;

export function useTasksQuery(options: Omit<Urql.UseQueryArgs<TasksQueryVariables>, 'query'>) {
  return Urql.useQuery<TasksQuery, TasksQueryVariables>({ query: TasksDocument, ...options });
};
export const TasksForScopedUsersDocument = gql`
    query TasksForScopedUsers($filters: TaskQueryArgs!, $first: Int, $page: Int) {
  tasks(filters: $filters, first: $first, page: $page) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      ...TaskBasicInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}
${TaskBasicInfoFragmentDoc}`;

export function useTasksForScopedUsersQuery(options: Omit<Urql.UseQueryArgs<TasksForScopedUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<TasksForScopedUsersQuery, TasksForScopedUsersQueryVariables>({ query: TasksForScopedUsersDocument, ...options });
};
export const TasksFilterOptionsDocument = gql`
    query TasksFilterOptions {
  teamSimpleMap {
    id
    name
  }
  userSimpleMap {
    id
    full_name
    codename
  }
  taskStatuses {
    id
    name
    background_color
    foreground_color
    system_status
  }
  taskPriorities {
    name
    id
  }
  timeTrackingWorkTypes {
    id
    title
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  projectsSimpleMap {
    id
    code
    title
  }
  projectManagerSimpleMap {
    id
    full_name
    codename
  }
  userSimpleMap {
    id
    full_name
  }
}
    `;

export function useTasksFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<TasksFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<TasksFilterOptionsQuery, TasksFilterOptionsQueryVariables>({ query: TasksFilterOptionsDocument, ...options });
};
export const BudgetItemsFilterOptionsDocument = gql`
    query BudgetItemsFilterOptions($project_id: [ID!]) {
  ourWorkBudgetItemsSimpleMap(project_id: $project_id) {
    id
    title
    item_code
  }
}
    `;

export function useBudgetItemsFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<BudgetItemsFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<BudgetItemsFilterOptionsQuery, BudgetItemsFilterOptionsQueryVariables>({ query: BudgetItemsFilterOptionsDocument, ...options });
};
export const CreateCapacityAllocationDocument = gql`
    mutation CreateCapacityAllocation($input: CreateCapacityAllocationInput!) {
  createCapacityAllocation(input: $input) {
    id
  }
}
    `;

export function useCreateCapacityAllocationMutation() {
  return Urql.useMutation<CreateCapacityAllocationMutation, CreateCapacityAllocationMutationVariables>(CreateCapacityAllocationDocument);
};
export const UpdateCapacityAllocationDocument = gql`
    mutation UpdateCapacityAllocation($input: UpdateCapacityAllocationInput!) {
  updateCapacityAllocation(input: $input) {
    id
  }
}
    `;

export function useUpdateCapacityAllocationMutation() {
  return Urql.useMutation<UpdateCapacityAllocationMutation, UpdateCapacityAllocationMutationVariables>(UpdateCapacityAllocationDocument);
};
export const UpdateCapacityAllocationForDayDocument = gql`
    mutation UpdateCapacityAllocationForDay($input: UpdateCapacityAllocationForDayInput!) {
  UpdateCapacityAllocationForDay(input: $input) {
    id
  }
}
    `;

export function useUpdateCapacityAllocationForDayMutation() {
  return Urql.useMutation<UpdateCapacityAllocationForDayMutation, UpdateCapacityAllocationForDayMutationVariables>(UpdateCapacityAllocationForDayDocument);
};
export const UpdateCapacityAllocationItemDocument = gql`
    mutation UpdateCapacityAllocationItem($input: UpdateCapacityAllocationItemInput!) {
  updateCapacityAllocationItem(input: $input) {
    id
  }
}
    `;

export function useUpdateCapacityAllocationItemMutation() {
  return Urql.useMutation<UpdateCapacityAllocationItemMutation, UpdateCapacityAllocationItemMutationVariables>(UpdateCapacityAllocationItemDocument);
};
export const CopyCapacityAllocationItemDocument = gql`
    mutation CopyCapacityAllocationItem($input: MoveCapacityAllocationItemInput!) {
  copyCapacityAllocationItem(input: $input) {
    ...CapacityAllocationItem
    stats {
      ...CapacityAllocationItemStats
    }
    userItems {
      capacityAllocation {
        id
      }
      ...CapacityAllocationItem
      stats {
        ...CapacityAllocationItemStats
      }
    }
  }
}
    ${CapacityAllocationItemFragmentDoc}
${CapacityAllocationItemStatsFragmentDoc}`;

export function useCopyCapacityAllocationItemMutation() {
  return Urql.useMutation<CopyCapacityAllocationItemMutation, CopyCapacityAllocationItemMutationVariables>(CopyCapacityAllocationItemDocument);
};
export const MoveCapacityAllocationItemDocument = gql`
    mutation MoveCapacityAllocationItem($input: MoveCapacityAllocationItemInput!) {
  moveCapacityAllocationItem(input: $input) {
    id
    userItems {
      capacityAllocation {
        id
      }
      ...CapacityAllocationItem
      stats {
        ...CapacityAllocationItemStats
      }
    }
    id
    timeTrackingWorkType {
      id
      title
    }
    completed
    user {
      id
      full_name
      profile {
        hex_color
      }
      image {
        urls {
          thumbnail
        }
      }
    }
  }
}
    ${CapacityAllocationItemFragmentDoc}
${CapacityAllocationItemStatsFragmentDoc}`;

export function useMoveCapacityAllocationItemMutation() {
  return Urql.useMutation<MoveCapacityAllocationItemMutation, MoveCapacityAllocationItemMutationVariables>(MoveCapacityAllocationItemDocument);
};
export const ReorderCapacityAllocationUserItemsDocument = gql`
    mutation ReorderCapacityAllocationUserItems($ids: [ID!]!) {
  reorderCapacityAllocationItems(ids: $ids) {
    id
  }
}
    `;

export function useReorderCapacityAllocationUserItemsMutation() {
  return Urql.useMutation<ReorderCapacityAllocationUserItemsMutation, ReorderCapacityAllocationUserItemsMutationVariables>(ReorderCapacityAllocationUserItemsDocument);
};
export const ValidateCreateTimeTrackingItemDocument = gql`
    mutation ValidateCreateTimeTrackingItem($user_id: ID, $task_id: ID!, $time_tracking_work_type_id: ID!, $capacity_allocation_item_id: ID) {
  validateCreateTimeTrackingItem(
    user_id: $user_id
    task_id: $task_id
    time_tracking_work_type_id: $time_tracking_work_type_id
    capacity_allocation_item_id: $capacity_allocation_item_id
  )
}
    `;

export function useValidateCreateTimeTrackingItemMutation() {
  return Urql.useMutation<ValidateCreateTimeTrackingItemMutation, ValidateCreateTimeTrackingItemMutationVariables>(ValidateCreateTimeTrackingItemDocument);
};
export const UpdateTimeTrackingWorkTypeInTrackingDocument = gql`
    mutation UpdateTimeTrackingWorkTypeInTracking($user_id: ID, $task_id: ID!, $old_time_tracking_work_type_id: ID!, $new_time_tracking_work_type_id: ID!, $capacity_allocation_item_id: ID) {
  updateTimeTrackingWorkTypeInTracking(
    user_id: $user_id
    task_id: $task_id
    old_time_tracking_work_type_id: $old_time_tracking_work_type_id
    new_time_tracking_work_type_id: $new_time_tracking_work_type_id
    capacity_allocation_item_id: $capacity_allocation_item_id
  )
}
    `;

export function useUpdateTimeTrackingWorkTypeInTrackingMutation() {
  return Urql.useMutation<UpdateTimeTrackingWorkTypeInTrackingMutation, UpdateTimeTrackingWorkTypeInTrackingMutationVariables>(UpdateTimeTrackingWorkTypeInTrackingDocument);
};
export const UpdatePlanningUsersOrderDocument = gql`
    mutation UpdatePlanningUsersOrder($user_ids: [ID!]!, $type: PlanningOrderTypeEnum!, $model_id: ID) {
  updatePlanningUsersOrder(user_ids: $user_ids, type: $type, model_id: $model_id)
}
    `;

export function useUpdatePlanningUsersOrderMutation() {
  return Urql.useMutation<UpdatePlanningUsersOrderMutation, UpdatePlanningUsersOrderMutationVariables>(UpdatePlanningUsersOrderDocument);
};
export const GetAllocationModalOptionsDocument = gql`
    query GetAllocationModalOptions($where: UsersWhereConditions) {
  userSimpleMap(where: $where) {
    id
    full_name
    codename
    team_id
    profile {
      plannable
    }
  }
}
    `;

export function useGetAllocationModalOptionsQuery(options?: Omit<Urql.UseQueryArgs<GetAllocationModalOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAllocationModalOptionsQuery, GetAllocationModalOptionsQueryVariables>({ query: GetAllocationModalOptionsDocument, ...options });
};
export const GetTaskPositionsDocument = gql`
    query GetTaskPositions($task_id: ID!) {
  task(id: $task_id) {
    ourWorkBudgetItem {
      project {
        availableTimeTrackingWorkTypes {
          id
          title
        }
      }
    }
  }
}
    `;

export function useGetTaskPositionsQuery(options: Omit<Urql.UseQueryArgs<GetTaskPositionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTaskPositionsQuery, GetTaskPositionsQueryVariables>({ query: GetTaskPositionsDocument, ...options });
};
export const IsUserInTaskDocument = gql`
    query IsUserInTask($taskId: ID!, $userId: ID!) {
  isUserInTask(task_id: $taskId, user_id: $userId)
}
    `;

export function useIsUserInTaskQuery(options: Omit<Urql.UseQueryArgs<IsUserInTaskQueryVariables>, 'query'>) {
  return Urql.useQuery<IsUserInTaskQuery, IsUserInTaskQueryVariables>({ query: IsUserInTaskDocument, ...options });
};
export const ModalCapacityAllocationTaskOptionsDocument = gql`
    query ModalCapacityAllocationTaskOptions($taskId: ID!) {
  task(id: $taskId) {
    from
    to
    planned_time
    deadline
    stats {
      planned_time
      history_spent_time
      allocated_time
      left_to_allocate
    }
    positions {
      timeTrackingWorkType {
        id
        title
      }
      user {
        id
      }
    }
  }
}
    `;

export function useModalCapacityAllocationTaskOptionsQuery(options: Omit<Urql.UseQueryArgs<ModalCapacityAllocationTaskOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ModalCapacityAllocationTaskOptionsQuery, ModalCapacityAllocationTaskOptionsQueryVariables>({ query: ModalCapacityAllocationTaskOptionsDocument, ...options });
};
export const ModalCapacityAllocationProjectOptionsDocument = gql`
    query ModalCapacityAllocationProjectOptions($projectId: ID!) {
  projectForTask(id: $projectId) {
    id
    availableTimeTrackingWorkTypes {
      id
      title
    }
  }
}
    `;

export function useModalCapacityAllocationProjectOptionsQuery(options: Omit<Urql.UseQueryArgs<ModalCapacityAllocationProjectOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ModalCapacityAllocationProjectOptionsQuery, ModalCapacityAllocationProjectOptionsQueryVariables>({ query: ModalCapacityAllocationProjectOptionsDocument, ...options });
};
export const PlanningFilterOptionsDocument = gql`
    query PlanningFilterOptions {
  taskStatuses {
    id
    name
  }
  taskPriorities {
    id
    name
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  userSimpleMap {
    id
    full_name
    codename
  }
  timeTrackingWorkTypes {
    id
    title
  }
  teamSimpleMap {
    id
    name
  }
}
    `;

export function usePlanningFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<PlanningFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<PlanningFilterOptionsQuery, PlanningFilterOptionsQueryVariables>({ query: PlanningFilterOptionsDocument, ...options });
};
export const ProjectTemplatesDocument = gql`
    query ProjectTemplates($filters: ProjectQueryArgs, $first: Int, $page: Int) {
  projects(filters: $filters, first: $first, page: $page) {
    data {
      ...ProjectTemplate
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${ProjectTemplateFragmentDoc}
${PaginatorInfoFragmentDoc}`;

export function useProjectTemplatesQuery(options?: Omit<Urql.UseQueryArgs<ProjectTemplatesQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectTemplatesQuery, ProjectTemplatesQueryVariables>({ query: ProjectTemplatesDocument, ...options });
};
export const ProjectTemplatesFilterOptionsDocument = gql`
    query ProjectTemplatesFilterOptions {
  teamSimpleMap {
    id
    name
  }
  projectManagerSimpleMap {
    id
    name
    codename
    full_name
  }
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
}
    `;

export function useProjectTemplatesFilterOptionsQuery(options?: Omit<Urql.UseQueryArgs<ProjectTemplatesFilterOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectTemplatesFilterOptionsQuery, ProjectTemplatesFilterOptionsQueryVariables>({ query: ProjectTemplatesFilterOptionsDocument, ...options });
};
export const CreateTaskGroupTemplateDocument = gql`
    mutation CreateTaskGroupTemplate($name: String!) {
  createTaskTemplateGroup(name: $name) {
    ...TaskGroupTemplate
  }
}
    ${TaskGroupTemplateFragmentDoc}`;

export function useCreateTaskGroupTemplateMutation() {
  return Urql.useMutation<CreateTaskGroupTemplateMutation, CreateTaskGroupTemplateMutationVariables>(CreateTaskGroupTemplateDocument);
};
export const UpdateTaskGroupTemplateDocument = gql`
    mutation UpdateTaskGroupTemplate($id: ID!, $name: String!) {
  updateTaskTemplateGroup(id: $id, name: $name) {
    ...TaskGroupTemplate
  }
}
    ${TaskGroupTemplateFragmentDoc}`;

export function useUpdateTaskGroupTemplateMutation() {
  return Urql.useMutation<UpdateTaskGroupTemplateMutation, UpdateTaskGroupTemplateMutationVariables>(UpdateTaskGroupTemplateDocument);
};
export const DeleteTaskGroupTemplateDocument = gql`
    mutation DeleteTaskGroupTemplate($id: ID!) {
  deleteTaskTemplateGroup(id: $id)
}
    `;

export function useDeleteTaskGroupTemplateMutation() {
  return Urql.useMutation<DeleteTaskGroupTemplateMutation, DeleteTaskGroupTemplateMutationVariables>(DeleteTaskGroupTemplateDocument);
};
export const TaskGroupTemplatesDocument = gql`
    query TaskGroupTemplates {
  taskTemplateGroups {
    ...TaskGroupTemplate
  }
}
    ${TaskGroupTemplateFragmentDoc}`;

export function useTaskGroupTemplatesQuery(options?: Omit<Urql.UseQueryArgs<TaskGroupTemplatesQueryVariables>, 'query'>) {
  return Urql.useQuery<TaskGroupTemplatesQuery, TaskGroupTemplatesQueryVariables>({ query: TaskGroupTemplatesDocument, ...options });
};
export const TaskGroupTemplatesSimpleDocument = gql`
    query TaskGroupTemplatesSimple {
  taskTemplateGroups {
    id
    name
  }
}
    `;

export function useTaskGroupTemplatesSimpleQuery(options?: Omit<Urql.UseQueryArgs<TaskGroupTemplatesSimpleQueryVariables>, 'query'>) {
  return Urql.useQuery<TaskGroupTemplatesSimpleQuery, TaskGroupTemplatesSimpleQueryVariables>({ query: TaskGroupTemplatesSimpleDocument, ...options });
};
export const TaskGroupTemplateDocument = gql`
    query TaskGroupTemplate($id: ID!) {
  taskTemplateGroup(id: $id) {
    ...TaskGroupTemplate
  }
}
    ${TaskGroupTemplateFragmentDoc}`;

export function useTaskGroupTemplateQuery(options: Omit<Urql.UseQueryArgs<TaskGroupTemplateQueryVariables>, 'query'>) {
  return Urql.useQuery<TaskGroupTemplateQuery, TaskGroupTemplateQueryVariables>({ query: TaskGroupTemplateDocument, ...options });
};
export const MoveTimeTrackingItemsToWorkTypeDocument = gql`
    mutation MoveTimeTrackingItemsToWorkType($item_ids: [ID!]!, $work_type_id: ID!) {
  moveTimeTrackingItemsToWorkType(
    time_tracking_item_ids: $item_ids
    time_tracking_work_type_id: $work_type_id
  ) {
    total
    successful
    failed
  }
}
    `;

export function useMoveTimeTrackingItemsToWorkTypeMutation() {
  return Urql.useMutation<MoveTimeTrackingItemsToWorkTypeMutation, MoveTimeTrackingItemsToWorkTypeMutationVariables>(MoveTimeTrackingItemsToWorkTypeDocument);
};
export const MoveTimeTrackingItemsToTaskDocument = gql`
    mutation MoveTimeTrackingItemsToTask($item_ids: [ID!]!, $task_id: ID!, $time_tracking_work_type_mapping: [TimeTrackingWorkTypeMapping!]!) {
  moveTimeTrackingItemsToTask(
    task_id: $task_id
    time_tracking_item_ids: $item_ids
    time_tracking_work_type_mapping: $time_tracking_work_type_mapping
  ) {
    total
    successful
    failed
  }
}
    `;

export function useMoveTimeTrackingItemsToTaskMutation() {
  return Urql.useMutation<MoveTimeTrackingItemsToTaskMutation, MoveTimeTrackingItemsToTaskMutationVariables>(MoveTimeTrackingItemsToTaskDocument);
};
export const UnlockTimeTrackingItemsDocument = gql`
    mutation UnlockTimeTrackingItems($ids: [ID!]!) {
  unlockTimeTrackingItems(ids: $ids) {
    total
    failed
    successful
  }
}
    `;

export function useUnlockTimeTrackingItemsMutation() {
  return Urql.useMutation<UnlockTimeTrackingItemsMutation, UnlockTimeTrackingItemsMutationVariables>(UnlockTimeTrackingItemsDocument);
};
export const BulkDeleteTimeTrackingItemsDocument = gql`
    mutation BulkDeleteTimeTrackingItems($ids: [ID!]!) {
  bulkDeleteTimeTrackingItems(ids: $ids) {
    total
    successful
    failed
  }
}
    `;

export function useBulkDeleteTimeTrackingItemsMutation() {
  return Urql.useMutation<BulkDeleteTimeTrackingItemsMutation, BulkDeleteTimeTrackingItemsMutationVariables>(BulkDeleteTimeTrackingItemsDocument);
};
export const UpdateTimeTrackingItemsBillableDocument = gql`
    mutation UpdateTimeTrackingItemsBillable($timeTrackingItemIds: [ID!]!, $billable: Boolean!) {
  updateTimeTrackingItemsBillable(
    time_tracking_item_ids: $timeTrackingItemIds
    billable: $billable
  ) {
    total
    successful
    failed
  }
}
    `;

export function useUpdateTimeTrackingItemsBillableMutation() {
  return Urql.useMutation<UpdateTimeTrackingItemsBillableMutation, UpdateTimeTrackingItemsBillableMutationVariables>(UpdateTimeTrackingItemsBillableDocument);
};
export const TimeTrackingReportSummaryDocument = gql`
    query TimeTrackingReportSummary($where: TimeTrackingReportsWhereConditions, $from: Date!, $to: Date!) {
  getTimeTrackingItemsSummary(from: $from, to: $to, where: $where) {
    ids
    tracked_time
  }
}
    `;

export function useTimeTrackingReportSummaryQuery(options: Omit<Urql.UseQueryArgs<TimeTrackingReportSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingReportSummaryQuery, TimeTrackingReportSummaryQueryVariables>({ query: TimeTrackingReportSummaryDocument, ...options });
};
export const TimeTrackingReportSelectedSummaryDocument = gql`
    query TimeTrackingReportSelectedSummary($where: TimeTrackingReportsWhereConditions, $from: Date!, $to: Date!) {
  getTimeTrackingItemsSummary(from: $from, to: $to, where: $where) {
    tracked_time
    invoiced_seconds
    overserviced_seconds
    uninvoiced_seconds
    amount
    invoiced_amount
    overserviced_amount
    uninvoiced_amount
  }
}
    `;

export function useTimeTrackingReportSelectedSummaryQuery(options: Omit<Urql.UseQueryArgs<TimeTrackingReportSelectedSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingReportSelectedSummaryQuery, TimeTrackingReportSelectedSummaryQueryVariables>({ query: TimeTrackingReportSelectedSummaryDocument, ...options });
};
export const TimeTrackingReportGroupedByDocument = gql`
    query TimeTrackingReportGroupedBy($groupBy: TimeTrackingReportGroupBy, $where: TimeTrackingReportsWhereConditions, $first: BigInt, $page: BigInt, $orderBy: [TimeTrackingItemOrderByClause!]) {
  timeTrackingReport(
    groupBy: $groupBy
    where: $where
    first: $first
    page: $page
    orderBy: $orderBy
  ) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      groupBy
      trackedTime
      items {
        ...TimeTrackingReportItem
      }
    }
  }
}
    ${PaginatorInfoFragmentDoc}
${TimeTrackingReportItemFragmentDoc}`;

export function useTimeTrackingReportGroupedByQuery(options?: Omit<Urql.UseQueryArgs<TimeTrackingReportGroupedByQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingReportGroupedByQuery, TimeTrackingReportGroupedByQueryVariables>({ query: TimeTrackingReportGroupedByDocument, ...options });
};
export const TimeTrackingUngroupedItemsDocument = gql`
    query TimeTrackingUngroupedItems($where: TimeTrackingReportsWhereConditions, $first: BigInt, $page: BigInt, $from: Date!, $to: Date!, $orderBy: [TimeTrackingItemOrderByClause!]) {
  getTimeTrackingItems(
    where: $where
    first: $first
    page: $page
    from: $from
    to: $to
    orderBy: $orderBy
  ) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      ...TimeTrackingReportItem
    }
  }
}
    ${PaginatorInfoFragmentDoc}
${TimeTrackingReportItemFragmentDoc}`;

export function useTimeTrackingUngroupedItemsQuery(options: Omit<Urql.UseQueryArgs<TimeTrackingUngroupedItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingUngroupedItemsQuery, TimeTrackingUngroupedItemsQueryVariables>({ query: TimeTrackingUngroupedItemsDocument, ...options });
};
export const TimeTrackingReportExportDocument = gql`
    query TimeTrackingReportExport($where: TimeTrackingReportsWhereConditions) {
  timeTrackingReportExport(where: $where)
}
    `;

export function useTimeTrackingReportExportQuery(options?: Omit<Urql.UseQueryArgs<TimeTrackingReportExportQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingReportExportQuery, TimeTrackingReportExportQueryVariables>({ query: TimeTrackingReportExportDocument, ...options });
};
export const TimeTrackingEffectivenessReportExportDocument = gql`
    query TimeTrackingEffectivenessReportExport($where: TimeTrackingReportsWhereConditions) {
  userEffectivenessReportExport(where: $where)
}
    `;

export function useTimeTrackingEffectivenessReportExportQuery(options?: Omit<Urql.UseQueryArgs<TimeTrackingEffectivenessReportExportQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingEffectivenessReportExportQuery, TimeTrackingEffectivenessReportExportQueryVariables>({ query: TimeTrackingEffectivenessReportExportDocument, ...options });
};
export const TimeTrackingTimeOffsExportDocument = gql`
    query TimeTrackingTimeOffsExport($from: Date!, $to: Date!) {
  timeOffsExport(from: $from, to: $to)
}
    `;

export function useTimeTrackingTimeOffsExportQuery(options: Omit<Urql.UseQueryArgs<TimeTrackingTimeOffsExportQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingTimeOffsExportQuery, TimeTrackingTimeOffsExportQueryVariables>({ query: TimeTrackingTimeOffsExportDocument, ...options });
};
export const TimeTrackingReportExportPdfDocument = gql`
    query TimeTrackingReportExportPdf($where: TimeTrackingReportsWhereConditions, $from: Date!, $to: Date!, $type: TimeTrackingReportExportType!) {
  timeTrackingReportExportPdf(
    where: $where
    date_from: $from
    date_to: $to
    report_type: $type
  )
}
    `;

export function useTimeTrackingReportExportPdfQuery(options: Omit<Urql.UseQueryArgs<TimeTrackingReportExportPdfQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingReportExportPdfQuery, TimeTrackingReportExportPdfQueryVariables>({ query: TimeTrackingReportExportPdfDocument, ...options });
};
export const GetTasksSimpleMapOptionsDocument = gql`
    query GetTasksSimpleMapOptions($our_work_budget_item_id: [ID!], $parent_ids: [ID!]) {
  tasksSimpleMap(
    our_work_budget_item_id: $our_work_budget_item_id
    parent_ids: $parent_ids
  ) {
    id
    name
    parent {
      id
    }
  }
}
    `;

export function useGetTasksSimpleMapOptionsQuery(options?: Omit<Urql.UseQueryArgs<GetTasksSimpleMapOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTasksSimpleMapOptionsQuery, GetTasksSimpleMapOptionsQueryVariables>({ query: GetTasksSimpleMapOptionsDocument, ...options });
};
export const GetOurWorkBudgetItemsSimpleMapOptionsDocument = gql`
    query GetOurWorkBudgetItemsSimpleMapOptions($project_id: [ID!]!) {
  ourWorkBudgetItemsSimpleMap(project_id: $project_id) {
    id
    title
    project {
      id
    }
    timeTrackingSettings {
      tracking_enabled
      tracking_enabled_from
      tracking_enabled_to
    }
  }
}
    `;

export function useGetOurWorkBudgetItemsSimpleMapOptionsQuery(options: Omit<Urql.UseQueryArgs<GetOurWorkBudgetItemsSimpleMapOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOurWorkBudgetItemsSimpleMapOptionsQuery, GetOurWorkBudgetItemsSimpleMapOptionsQueryVariables>({ query: GetOurWorkBudgetItemsSimpleMapOptionsDocument, ...options });
};
export const TimeTrackingReportOptionsDocument = gql`
    query TimeTrackingReportOptions($userSimpleWhere: UsersWhereConditions) {
  clientsSimpleMap {
    id
    name
    brands {
      id
      name
    }
  }
  timeTrackingWorkTypes {
    id
    default_rate
    title
  }
  teamSimpleMap {
    id
    name
  }
  projectsSimpleMap(withArchived: true, withFinished: true) {
    id
    title
    code
    brand_id
    archived_at
    finished_at
  }
  userSimpleMap(withArchived: true, where: $userSimpleWhere) {
    id
    name
    full_name
    image {
      urls {
        thumbnail
      }
    }
    team_id
    codename
    archived_at
  }
  projectCategories {
    id
    name
  }
}
    `;

export function useTimeTrackingReportOptionsQuery(options?: Omit<Urql.UseQueryArgs<TimeTrackingReportOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingReportOptionsQuery, TimeTrackingReportOptionsQueryVariables>({ query: TimeTrackingReportOptionsDocument, ...options });
};
export const GetProjectsWithPositionsDocument = gql`
    query GetProjectsWithPositions($brandId: ID) {
  brand(id: $brandId) {
    projects {
      id
      code
      title
      availableTimeTrackingWorkTypes {
        id
        title
      }
    }
  }
}
    `;

export function useGetProjectsWithPositionsQuery(options?: Omit<Urql.UseQueryArgs<GetProjectsWithPositionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProjectsWithPositionsQuery, GetProjectsWithPositionsQueryVariables>({ query: GetProjectsWithPositionsDocument, ...options });
};
export const AvailableWorkTypesForBulkMovingTimeTrackingItemsDocument = gql`
    query AvailableWorkTypesForBulkMovingTimeTrackingItems($itemIds: [ID!]!) {
  getAvailableWorkTypesForBulkMovingTimeTrackingItems(
    time_tracking_item_ids: $itemIds
  ) {
    id
    title
  }
}
    `;

export function useAvailableWorkTypesForBulkMovingTimeTrackingItemsQuery(options: Omit<Urql.UseQueryArgs<AvailableWorkTypesForBulkMovingTimeTrackingItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<AvailableWorkTypesForBulkMovingTimeTrackingItemsQuery, AvailableWorkTypesForBulkMovingTimeTrackingItemsQueryVariables>({ query: AvailableWorkTypesForBulkMovingTimeTrackingItemsDocument, ...options });
};
export const TimeTrackingItemsWorkTypesDocument = gql`
    query TimeTrackingItemsWorkTypes($itemIds: [ID!]!) {
  timeTrackingItemsWorkTypes(time_tracking_item_ids: $itemIds) {
    id
    title
  }
}
    `;

export function useTimeTrackingItemsWorkTypesQuery(options: Omit<Urql.UseQueryArgs<TimeTrackingItemsWorkTypesQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingItemsWorkTypesQuery, TimeTrackingItemsWorkTypesQueryVariables>({ query: TimeTrackingItemsWorkTypesDocument, ...options });
};
export const CheckTimeTrackingItemsLockedDocument = gql`
    query CheckTimeTrackingItemsLocked($itemIds: [ID!]!) {
  checkTimeTrackingItemsLocked(ids: $itemIds)
}
    `;

export function useCheckTimeTrackingItemsLockedQuery(options: Omit<Urql.UseQueryArgs<CheckTimeTrackingItemsLockedQueryVariables>, 'query'>) {
  return Urql.useQuery<CheckTimeTrackingItemsLockedQuery, CheckTimeTrackingItemsLockedQueryVariables>({ query: CheckTimeTrackingItemsLockedDocument, ...options });
};
export const AddRowToWeekTimeReportDocument = gql`
    mutation AddRowToWeekTimeReport($task_id: ID!, $time_tracking_work_type_id: ID!, $user_id: ID) {
  addRowToWeekTimeReport(
    task_id: $task_id
    time_tracking_work_type_id: $time_tracking_work_type_id
    user_id: $user_id
  ) {
    task {
      id
    }
  }
}
    `;

export function useAddRowToWeekTimeReportMutation() {
  return Urql.useMutation<AddRowToWeekTimeReportMutation, AddRowToWeekTimeReportMutationVariables>(AddRowToWeekTimeReportDocument);
};
export const CreateOrUpdateTrackedTimeForDayDocument = gql`
    mutation CreateOrUpdateTrackedTimeForDay($task_id: ID!, $time_tracking_work_type_id: ID!, $user_id: ID, $tracked_for_date: Date!, $tracked_time: BigInt!) {
  createOrUpdateTrackedTimeForDay(
    task_id: $task_id
    time_tracking_work_type_id: $time_tracking_work_type_id
    user_id: $user_id
    tracked_for_date: $tracked_for_date
    tracked_time: $tracked_time
  )
}
    `;

export function useCreateOrUpdateTrackedTimeForDayMutation() {
  return Urql.useMutation<CreateOrUpdateTrackedTimeForDayMutation, CreateOrUpdateTrackedTimeForDayMutationVariables>(CreateOrUpdateTrackedTimeForDayDocument);
};
export const CreateTimeTrackingItemDocument = gql`
    mutation CreateTimeTrackingItem($user_id: ID, $task_id: ID!, $tracked_for_date: Date!, $time_tracking_work_type_id: ID!, $tracked_time: BigInt, $capacity_allocation_item_id: ID, $note: String, $billable: Boolean, $specificTimeFrom: Time, $specificTimeTo: Time) {
  createTimeTrackingItem(
    user_id: $user_id
    task_id: $task_id
    tracked_for_date: $tracked_for_date
    time_tracking_work_type_id: $time_tracking_work_type_id
    tracked_time: $tracked_time
    capacity_allocation_item_id: $capacity_allocation_item_id
    note: $note
    billable: $billable
    specific_time_from: $specificTimeFrom
    specific_time_to: $specificTimeTo
  ) {
    id
  }
}
    `;

export function useCreateTimeTrackingItemMutation() {
  return Urql.useMutation<CreateTimeTrackingItemMutation, CreateTimeTrackingItemMutationVariables>(CreateTimeTrackingItemDocument);
};
export const DeleteTimeTrackingItemDocument = gql`
    mutation DeleteTimeTrackingItem($id: ID!) {
  deleteTimeTrackingItem(id: $id) {
    id
  }
}
    `;

export function useDeleteTimeTrackingItemMutation() {
  return Urql.useMutation<DeleteTimeTrackingItemMutation, DeleteTimeTrackingItemMutationVariables>(DeleteTimeTrackingItemDocument);
};
export const RemoveRowFromWeekTimeReportDocument = gql`
    mutation RemoveRowFromWeekTimeReport($task_id: ID!, $time_tracking_work_type_id: ID!, $user_id: ID, $first_date_of_week: Date!) {
  removeRowFromWeekTimeReport(
    task_id: $task_id
    time_tracking_work_type_id: $time_tracking_work_type_id
    user_id: $user_id
    first_date_of_week: $first_date_of_week
  ) {
    task {
      id
    }
  }
}
    `;

export function useRemoveRowFromWeekTimeReportMutation() {
  return Urql.useMutation<RemoveRowFromWeekTimeReportMutation, RemoveRowFromWeekTimeReportMutationVariables>(RemoveRowFromWeekTimeReportDocument);
};
export const StartTimerDocument = gql`
    mutation StartTimer($time_tracking_item_id: ID!) {
  startTimer(time_tracking_item_id: $time_tracking_item_id)
}
    `;

export function useStartTimerMutation() {
  return Urql.useMutation<StartTimerMutation, StartTimerMutationVariables>(StartTimerDocument);
};
export const StopTimerDocument = gql`
    mutation StopTimer($time_tracking_item_id: ID!) {
  stopTimer(time_tracking_item_id: $time_tracking_item_id)
}
    `;

export function useStopTimerMutation() {
  return Urql.useMutation<StopTimerMutation, StopTimerMutationVariables>(StopTimerDocument);
};
export const UpdateTimeTrackingItemDocument = gql`
    mutation UpdateTimeTrackingItem($id: ID!, $task_id: ID!, $tracked_for_date: Date!, $time_tracking_work_type_id: ID!, $tracked_time: BigInt, $specificTimeFrom: Time, $specificTimeTo: Time, $note: String, $capacity_allocation_item_id: ID, $billable: Boolean) {
  updateTimeTrackingItem(
    id: $id
    task_id: $task_id
    tracked_for_date: $tracked_for_date
    time_tracking_work_type_id: $time_tracking_work_type_id
    tracked_time: $tracked_time
    specific_time_from: $specificTimeFrom
    specific_time_to: $specificTimeTo
    note: $note
    capacity_allocation_item_id: $capacity_allocation_item_id
    billable: $billable
  ) {
    id
  }
}
    `;

export function useUpdateTimeTrackingItemMutation() {
  return Urql.useMutation<UpdateTimeTrackingItemMutation, UpdateTimeTrackingItemMutationVariables>(UpdateTimeTrackingItemDocument);
};
export const TimeTrackingBrandsDocument = gql`
    query TimeTrackingBrands {
  clientsSimpleMap {
    brands {
      ...BrandSimpleOptionParts
    }
  }
}
    ${BrandSimpleOptionPartsFragmentDoc}`;

export function useTimeTrackingBrandsQuery(options?: Omit<Urql.UseQueryArgs<TimeTrackingBrandsQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingBrandsQuery, TimeTrackingBrandsQueryVariables>({ query: TimeTrackingBrandsDocument, ...options });
};
export const TimeTrackingItemDocument = gql`
    query TimeTrackingItem($id: ID!) {
  timeTrackingItem(id: $id) {
    ...TimeTrackingEntry
  }
}
    ${TimeTrackingEntryFragmentDoc}`;

export function useTimeTrackingItemQuery(options: Omit<Urql.UseQueryArgs<TimeTrackingItemQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingItemQuery, TimeTrackingItemQueryVariables>({ query: TimeTrackingItemDocument, ...options });
};
export const TimeTrackingItemsDocument = gql`
    query TimeTrackingItems($user_id: ID!, $from: Date!, $to: Date!) {
  timeTrackingSummaryPerDay(user_id: $user_id, from: $from, to: $to) {
    date
    tracked_time
    auto_stopped
  }
  timeTrackingItems(user_id: $user_id, from: $from, to: $to) {
    ...TimeTrackingEntry
  }
  runningTimer(user_id: $user_id) {
    id
    timeTrackingItem {
      id
      tracked_for_date
    }
  }
}
    ${TimeTrackingEntryFragmentDoc}`;

export function useTimeTrackingItemsQuery(options: Omit<Urql.UseQueryArgs<TimeTrackingItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingItemsQuery, TimeTrackingItemsQueryVariables>({ query: TimeTrackingItemsDocument, ...options });
};
export const TimeTrackingOptionsForProjectDocument = gql`
    query TimeTrackingOptionsForProject($id: ID!, $date: Date!) {
  timeTrackingOptionsForProject(project_id: $id, date: $date) {
    ourWork {
      id
      title
      timeTrackingSettings {
        id
        tracking_enabled
        tracking_enabled_from
        tracking_enabled_to
      }
      category {
        name
      }
      tasks {
        id
        name
        positions {
          timeTrackingWorkType {
            id
          }
          user {
            id
          }
        }
      }
    }
    availableTimeTrackingWorkTypes {
      id
      title
    }
  }
}
    `;

export function useTimeTrackingOptionsForProjectQuery(options: Omit<Urql.UseQueryArgs<TimeTrackingOptionsForProjectQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingOptionsForProjectQuery, TimeTrackingOptionsForProjectQueryVariables>({ query: TimeTrackingOptionsForProjectDocument, ...options });
};
export const TimeTrackingProjectsDocument = gql`
    query TimeTrackingProjects($brandId: ID) {
  projectsSimpleMap(brand_id: $brandId) {
    ...ProjectSimpleOptionParts
    billable
  }
}
    ${ProjectSimpleOptionPartsFragmentDoc}`;

export function useTimeTrackingProjectsQuery(options?: Omit<Urql.UseQueryArgs<TimeTrackingProjectsQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingProjectsQuery, TimeTrackingProjectsQueryVariables>({ query: TimeTrackingProjectsDocument, ...options });
};
export const TimeTrackingUsersDocument = gql`
    query TimeTrackingUsers {
  userSimpleMap {
    id
    codename
    image {
      urls {
        thumbnail
      }
    }
    full_name
    team_id
  }
}
    `;

export function useTimeTrackingUsersQuery(options?: Omit<Urql.UseQueryArgs<TimeTrackingUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingUsersQuery, TimeTrackingUsersQueryVariables>({ query: TimeTrackingUsersDocument, ...options });
};
export const WeekTimeReportDocument = gql`
    query WeekTimeReport($user_id: ID!, $from: Date!) {
  weekTimeReport(user_id: $user_id, from: $from) {
    rows {
      task {
        id
        name
        billable
        ourWorkBudgetItem {
          id
          title
          project {
            id
            title
            code
            brand {
              id
              name
            }
          }
        }
      }
      timeTrackingWorkType {
        id
        title
      }
      trackedTime {
        date
        tracked_time
      }
    }
    dailyTotals {
      date
      total_tracked_time
    }
  }
}
    `;

export function useWeekTimeReportQuery(options: Omit<Urql.UseQueryArgs<WeekTimeReportQueryVariables>, 'query'>) {
  return Urql.useQuery<WeekTimeReportQuery, WeekTimeReportQueryVariables>({ query: WeekTimeReportDocument, ...options });
};
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($input: UpdatePasswordInput!) {
  updatePassword(input: $input) {
    id
  }
}
    `;

export function useUpdatePasswordMutation() {
  return Urql.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument);
};
export const GetUsersDocument = gql`
    query GetUsers($page: Int, $first: Int, $filters: UserQueryArgs) {
  roles {
    id
    name
  }
  teamSimpleMap {
    id
    name
  }
  brandsSimpleMap {
    id
    name
  }
  usersSummary(filters: $filters) {
    userIds
  }
  users(page: $page, first: $first, filters: $filters) {
    data {
      id
      scope {
        value
      }
      first_name
      last_name
      full_name
      codename
      image {
        urls {
          thumbnail
        }
      }
      brands {
        id
        name
      }
      email
      phone
      note
      archived_at
      PMActiveProjectsCount
      enabled_two_factor_authentication
      team {
        id
        name
      }
      roles {
        id
        name
      }
      profile {
        hex_color
        plannable
        defaultWorktype {
          id
          default_rate
          title
        }
      }
      permissions {
        user_haveProjectsAssigned
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

export function useGetUsersQuery(options?: Omit<Urql.UseQueryArgs<GetUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUsersQuery, GetUsersQueryVariables>({ query: GetUsersDocument, ...options });
};
export const ProjectManagerOptionsForUsersDocument = gql`
    query ProjectManagerOptionsForUsers {
  projectManagerSimpleMap {
    id
    full_name
    codename
  }
}
    `;

export function useProjectManagerOptionsForUsersQuery(options?: Omit<Urql.UseQueryArgs<ProjectManagerOptionsForUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectManagerOptionsForUsersQuery, ProjectManagerOptionsForUsersQueryVariables>({ query: ProjectManagerOptionsForUsersDocument, ...options });
};
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: ID!) {
  deleteUser(id: $id) {
    id
  }
}
    `;

export function useDeleteUserMutation() {
  return Urql.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument);
};
export const ScheduleUserArchivalDocument = gql`
    mutation ScheduleUserArchival($id: ID!, $date: Date, $project_manager_id: ID) {
  scheduleUserArchival(
    id: $id
    date: $date
    project_manager_id: $project_manager_id
  ) {
    id
  }
}
    `;

export function useScheduleUserArchivalMutation() {
  return Urql.useMutation<ScheduleUserArchivalMutation, ScheduleUserArchivalMutationVariables>(ScheduleUserArchivalDocument);
};
export const ScheduleUserActivationDocument = gql`
    mutation ScheduleUserActivation($id: ID!, $date: Date) {
  scheduleUserActivation(id: $id, date: $date) {
    id
  }
}
    `;

export function useScheduleUserActivationMutation() {
  return Urql.useMutation<ScheduleUserActivationMutation, ScheduleUserActivationMutationVariables>(ScheduleUserActivationDocument);
};
export const ReassignActiveProjectsAndOwnedInvoicesDocument = gql`
    mutation ReassignActiveProjectsAndOwnedInvoices($fromUser: ID!, $toUser: ID!) {
  reassignActiveProjectsAndOwnedInvoices(
    from_user_id: $fromUser
    to_user_id: $toUser
  )
}
    `;

export function useReassignActiveProjectsAndOwnedInvoicesMutation() {
  return Urql.useMutation<ReassignActiveProjectsAndOwnedInvoicesMutation, ReassignActiveProjectsAndOwnedInvoicesMutationVariables>(ReassignActiveProjectsAndOwnedInvoicesDocument);
};
export const UpdateUserPasswordDocument = gql`
    mutation UpdateUserPassword($input: UpdateUserPasswordInput!) {
  updateUserPassword(input: $input) {
    id
  }
}
    `;

export function useUpdateUserPasswordMutation() {
  return Urql.useMutation<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>(UpdateUserPasswordDocument);
};
export const GetScopedUserForEditDocument = gql`
    query GetScopedUserForEdit($id: ID!) {
  user(id: $id) {
    ...UserForEditBasic
    scope_access
    projects {
      id
      title
      code
    }
    tasks {
      id
      name
      status {
        name
        system_status
      }
    }
  }
}
    ${UserForEditBasicFragmentDoc}`;

export function useGetScopedUserForEditQuery(options: Omit<Urql.UseQueryArgs<GetScopedUserForEditQueryVariables>, 'query'>) {
  return Urql.useQuery<GetScopedUserForEditQuery, GetScopedUserForEditQueryVariables>({ query: GetScopedUserForEditDocument, ...options });
};
export const GetUserForEditDocument = gql`
    query GetUserForEdit($id: ID!) {
  user(id: $id) {
    ...UserForEditBasic
    profile {
      hex_color
      plannable
      rates {
        id
        valid_from
        valid_to
        rate
      }
      planningRanges {
        id
        type {
          value
        }
        valid_from
        valid_to
        utilising
        weekly_capacities {
          monday
          tuesday
          wednesday
          thursday
          friday
          saturday
          sunday
        }
        daily_capacity
      }
      defaultWorktype {
        id
        default_rate
        title
      }
    }
  }
}
    ${UserForEditBasicFragmentDoc}`;

export function useGetUserForEditQuery(options: Omit<Urql.UseQueryArgs<GetUserForEditQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserForEditQuery, GetUserForEditQueryVariables>({ query: GetUserForEditDocument, ...options });
};
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    id
  }
}
    `;

export function useCreateUserMutation() {
  return Urql.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument);
};
export const CreateScopedUserDocument = gql`
    mutation CreateScopedUser($input: CreateScopedUserInput!) {
  createScopedUser(input: $input) {
    id
  }
}
    `;

export function useCreateScopedUserMutation() {
  return Urql.useMutation<CreateScopedUserMutation, CreateScopedUserMutationVariables>(CreateScopedUserDocument);
};
export const DisableTwoFactorAuthenticationDocument = gql`
    mutation DisableTwoFactorAuthentication($id: ID!) {
  disableTwoFactorAuthentication(id: $id) {
    id
    enabled_two_factor_authentication
  }
}
    `;

export function useDisableTwoFactorAuthenticationMutation() {
  return Urql.useMutation<DisableTwoFactorAuthenticationMutation, DisableTwoFactorAuthenticationMutationVariables>(DisableTwoFactorAuthenticationDocument);
};
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
  }
}
    `;

export function useUpdateUserMutation() {
  return Urql.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument);
};
export const SetUserProfileRatesDocument = gql`
    mutation SetUserProfileRates($user_id: ID!, $rates: [UserProfileRateInput!]!) {
  setUserProfileRates(user_id: $user_id, rates: $rates) {
    rates {
      id
    }
  }
}
    `;

export function useSetUserProfileRatesMutation() {
  return Urql.useMutation<SetUserProfileRatesMutation, SetUserProfileRatesMutationVariables>(SetUserProfileRatesDocument);
};
export const ConnectToMcpDocument = gql`
    mutation ConnectToMcp($input: ConnectToMcpInput!) {
  connectToMcp(input: $input) {
    status
    message
  }
}
    `;

export function useConnectToMcpMutation() {
  return Urql.useMutation<ConnectToMcpMutation, ConnectToMcpMutationVariables>(ConnectToMcpDocument);
};
export const DisconnectFromMcpDocument = gql`
    mutation DisconnectFromMcp($input: DisconnectFromMcpInput!) {
  disconnectFromMcp(input: $input) {
    status
    message
  }
}
    `;

export function useDisconnectFromMcpMutation() {
  return Urql.useMutation<DisconnectFromMcpMutation, DisconnectFromMcpMutationVariables>(DisconnectFromMcpDocument);
};
export const SetUserProfilePlanningRangesDocument = gql`
    mutation SetUserProfilePlanningRanges($user_id: ID!, $planningRanges: [PlanningRangeInput!]!) {
  setUserProfilePlanningRanges(user_id: $user_id, planningRanges: $planningRanges) {
    planningRanges {
      id
    }
  }
}
    `;

export function useSetUserProfilePlanningRangesMutation() {
  return Urql.useMutation<SetUserProfilePlanningRangesMutation, SetUserProfilePlanningRangesMutationVariables>(SetUserProfilePlanningRangesDocument);
};
export const GetNewSequenceNumberDocument = gql`
    query GetNewSequenceNumber($invoice_type: SequenceTypesEnum, $date: Date!, $workspace_company_id: ID!, $documentId: ID) {
  getNewInvoiceNumber(
    invoice_type: $invoice_type
    date: $date
    workspace_company_id: $workspace_company_id
    document_id: $documentId
  ) {
    id
    document_no
  }
}
    `;

export function useGetNewSequenceNumberQuery(options: Omit<Urql.UseQueryArgs<GetNewSequenceNumberQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNewSequenceNumberQuery, GetNewSequenceNumberQueryVariables>({ query: GetNewSequenceNumberDocument, ...options });
};
export const CheckSequenceNumberExistDocument = gql`
    query CheckSequenceNumberExist($document_no: String, $invoice_type: SequenceTypesEnum, $date: Date!, $document_id: ID, $invoice_order_sequence_id: ID!, $workspace_company_id: ID!) {
  checkInvoiceNumberExist(
    document_no: $document_no
    invoice_type: $invoice_type
    date: $date
    document_id: $document_id
    invoice_order_sequence_id: $invoice_order_sequence_id
    workspace_company_id: $workspace_company_id
  )
}
    `;

export function useCheckSequenceNumberExistQuery(options: Omit<Urql.UseQueryArgs<CheckSequenceNumberExistQueryVariables>, 'query'>) {
  return Urql.useQuery<CheckSequenceNumberExistQuery, CheckSequenceNumberExistQueryVariables>({ query: CheckSequenceNumberExistDocument, ...options });
};
export const UpdateProjectCategoryDocument = gql`
    mutation UpdateProjectCategory($id: ID!, $name: String) {
  updateProjectCategory(id: $id, name: $name) {
    id
    name
  }
}
    `;

export function useUpdateProjectCategoryMutation() {
  return Urql.useMutation<UpdateProjectCategoryMutation, UpdateProjectCategoryMutationVariables>(UpdateProjectCategoryDocument);
};
export const DeleteProjectCategoryDocument = gql`
    mutation DeleteProjectCategory($id: ID!) {
  deleteProjectCategory(id: $id) {
    id
  }
}
    `;

export function useDeleteProjectCategoryMutation() {
  return Urql.useMutation<DeleteProjectCategoryMutation, DeleteProjectCategoryMutationVariables>(DeleteProjectCategoryDocument);
};
export const CreateProjectCategoryDocument = gql`
    mutation CreateProjectCategory($name: String!) {
  createProjectCategory(name: $name) {
    id
    name
  }
}
    `;

export function useCreateProjectCategoryMutation() {
  return Urql.useMutation<CreateProjectCategoryMutation, CreateProjectCategoryMutationVariables>(CreateProjectCategoryDocument);
};
export const GetProjectCategoriesDocument = gql`
    query GetProjectCategories {
  projectCategories {
    id
    name
  }
}
    `;

export function useGetProjectCategoriesQuery(options?: Omit<Urql.UseQueryArgs<GetProjectCategoriesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProjectCategoriesQuery, GetProjectCategoriesQueryVariables>({ query: GetProjectCategoriesDocument, ...options });
};
export const MarkTaskNotificationsAsUnreadDocument = gql`
    mutation MarkTaskNotificationsAsUnread($task_id: ID!) {
  markTaskAndCommunicationNotificationAsUnread(task_id: $task_id)
}
    `;

export function useMarkTaskNotificationsAsUnreadMutation() {
  return Urql.useMutation<MarkTaskNotificationsAsUnreadMutation, MarkTaskNotificationsAsUnreadMutationVariables>(MarkTaskNotificationsAsUnreadDocument);
};
export const UpdateTaskScopesDocument = gql`
    mutation UpdateTaskScopes($input: UpdateTaskInput!) {
  updateTask(input: $input, propagate_billable: false) {
    id
  }
}
    `;

export function useUpdateTaskScopesMutation() {
  return Urql.useMutation<UpdateTaskScopesMutation, UpdateTaskScopesMutationVariables>(UpdateTaskScopesDocument);
};
export const UpdateProjectScopesDocument = gql`
    mutation UpdateProjectScopes($input: UpdateProjectInput!) {
  updateProject(input: $input, propagate_billable: false) {
    id
  }
}
    `;

export function useUpdateProjectScopesMutation() {
  return Urql.useMutation<UpdateProjectScopesMutation, UpdateProjectScopesMutationVariables>(UpdateProjectScopesDocument);
};
export const CreateAssignableFileDocument = gql`
    mutation CreateAssignableFile($file: Upload!) {
  createAssignableFile(file: $file) {
    ...Attachment
  }
}
    ${AttachmentFragmentDoc}`;

export function useCreateAssignableFileMutation() {
  return Urql.useMutation<CreateAssignableFileMutation, CreateAssignableFileMutationVariables>(CreateAssignableFileDocument);
};
export const UsersSimpleMapDocument = gql`
    query UsersSimpleMap($search: String, $allowedScopes: Mixed, $taskId: ID, $mentions: Boolean) {
  userSimpleMap(
    search: $search
    where: {column: SCOPE, value: $allowedScopes, operator: IN}
    task_id: $taskId
    mentions: $mentions
  ) {
    id
    full_name
    image {
      urls {
        thumbnail
      }
    }
  }
}
    `;

export function useUsersSimpleMapQuery(options?: Omit<Urql.UseQueryArgs<UsersSimpleMapQueryVariables>, 'query'>) {
  return Urql.useQuery<UsersSimpleMapQuery, UsersSimpleMapQueryVariables>({ query: UsersSimpleMapDocument, ...options });
};
export const GetDefaultUserMentionsDocument = gql`
    query GetDefaultUserMentions($where: UsersWhereConditions, $taskId: ID) {
  userSimpleMap(where: $where, task_id: $taskId, mentions: true) {
    id
    full_name
    image {
      urls {
        thumbnail
      }
    }
  }
}
    `;

export function useGetDefaultUserMentionsQuery(options?: Omit<Urql.UseQueryArgs<GetDefaultUserMentionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDefaultUserMentionsQuery, GetDefaultUserMentionsQueryVariables>({ query: GetDefaultUserMentionsDocument, ...options });
};
export const UsersAllocatedTimeDocument = gql`
    query UsersAllocatedTime($from: Date!, $to: Date!, $types: [CapacityAllocationTypeEnum!]!, $user_ids: [ID!]!) {
  GetUsersAllocatedTime(from: $from, to: $to, types: $types, user_ids: $user_ids) {
    user_id
    dates {
      date
      planned_capacity
      data {
        from_time
        to_time
        type
        value
      }
    }
  }
}
    `;

export function useUsersAllocatedTimeQuery(options: Omit<Urql.UseQueryArgs<UsersAllocatedTimeQueryVariables>, 'query'>) {
  return Urql.useQuery<UsersAllocatedTimeQuery, UsersAllocatedTimeQueryVariables>({ query: UsersAllocatedTimeDocument, ...options });
};
export const CheckForAllocationConflictsDocument = gql`
    query CheckForAllocationConflicts($from: Date!, $to: Date!, $user_ids: [ID!]!, $from_time: Time, $to_time: Time, $types: [CapacityAllocationTypeEnum!]!, $repetition_settings: [RepetitionSettingsDaysEnum]) {
  GetUsersAllocationConflicts(
    from: $from
    to: $to
    user_ids: $user_ids
    from_time: $from_time
    to_time: $to_time
    types: $types
    repetition_settings: $repetition_settings
  ) {
    user_id
    conflict
  }
}
    `;

export function useCheckForAllocationConflictsQuery(options: Omit<Urql.UseQueryArgs<CheckForAllocationConflictsQueryVariables>, 'query'>) {
  return Urql.useQuery<CheckForAllocationConflictsQuery, CheckForAllocationConflictsQueryVariables>({ query: CheckForAllocationConflictsDocument, ...options });
};
export const BrandForNavigationDocument = gql`
    query BrandForNavigation($id: ID!) {
  brand(id: $id) {
    id
    name
    code
  }
}
    `;

export function useBrandForNavigationQuery(options: Omit<Urql.UseQueryArgs<BrandForNavigationQueryVariables>, 'query'>) {
  return Urql.useQuery<BrandForNavigationQuery, BrandForNavigationQueryVariables>({ query: BrandForNavigationDocument, ...options });
};
export const GetSubmittedRfiCountDocument = gql`
    query GetSubmittedRfiCount {
  getSubmittedRfiCount
}
    `;

export function useGetSubmittedRfiCountQuery(options?: Omit<Urql.UseQueryArgs<GetSubmittedRfiCountQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSubmittedRfiCountQuery, GetSubmittedRfiCountQueryVariables>({ query: GetSubmittedRfiCountDocument, ...options });
};
export const ProjectForNavigationDocument = gql`
    query ProjectForNavigation($id: ID!) {
  project(id: $id) {
    id
    title
    code
    finished_at
    uses_budgetovac
    type
    is_template
  }
}
    `;

export function useProjectForNavigationQuery(options: Omit<Urql.UseQueryArgs<ProjectForNavigationQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectForNavigationQuery, ProjectForNavigationQueryVariables>({ query: ProjectForNavigationDocument, ...options });
};
export const ContractorForNavigationDocument = gql`
    query ContractorForNavigation($id: ID!) {
  contractor(id: $id) {
    id
    legal_name
  }
}
    `;

export function useContractorForNavigationQuery(options: Omit<Urql.UseQueryArgs<ContractorForNavigationQueryVariables>, 'query'>) {
  return Urql.useQuery<ContractorForNavigationQuery, ContractorForNavigationQueryVariables>({ query: ContractorForNavigationDocument, ...options });
};
export const CreditAccountForNavigationDocument = gql`
    query CreditAccountForNavigation($id: ID!) {
  brandCreditAccount(id: $id) {
    id
    title
  }
}
    `;

export function useCreditAccountForNavigationQuery(options: Omit<Urql.UseQueryArgs<CreditAccountForNavigationQueryVariables>, 'query'>) {
  return Urql.useQuery<CreditAccountForNavigationQuery, CreditAccountForNavigationQueryVariables>({ query: CreditAccountForNavigationDocument, ...options });
};
export const ExpenseForNavigationDocument = gql`
    query ExpenseForNavigation($id: ID!) {
  expense(id: $id) {
    id
    expense_no
    is_draft
  }
}
    `;

export function useExpenseForNavigationQuery(options: Omit<Urql.UseQueryArgs<ExpenseForNavigationQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseForNavigationQuery, ExpenseForNavigationQueryVariables>({ query: ExpenseForNavigationDocument, ...options });
};
export const OutgoingInvoiceForNavigationDocument = gql`
    query OutgoingInvoiceForNavigation($id: ID!) {
  outgoingInvoice(id: $id) {
    id
    invoice_no
    type
  }
}
    `;

export function useOutgoingInvoiceForNavigationQuery(options: Omit<Urql.UseQueryArgs<OutgoingInvoiceForNavigationQueryVariables>, 'query'>) {
  return Urql.useQuery<OutgoingInvoiceForNavigationQuery, OutgoingInvoiceForNavigationQueryVariables>({ query: OutgoingInvoiceForNavigationDocument, ...options });
};
export const ProformaInvoiceForNavigationDocument = gql`
    query ProformaInvoiceForNavigation($id: ID!) {
  outgoingProformaInvoice(id: $id) {
    id
    invoice_no
  }
}
    `;

export function useProformaInvoiceForNavigationQuery(options: Omit<Urql.UseQueryArgs<ProformaInvoiceForNavigationQueryVariables>, 'query'>) {
  return Urql.useQuery<ProformaInvoiceForNavigationQuery, ProformaInvoiceForNavigationQueryVariables>({ query: ProformaInvoiceForNavigationDocument, ...options });
};
export const GetRequestForInvoicingTypeDocument = gql`
    query GetRequestForInvoicingType($id: ID!) {
  requestForInvoicing(id: $id) {
    id
    type
  }
}
    `;

export function useGetRequestForInvoicingTypeQuery(options: Omit<Urql.UseQueryArgs<GetRequestForInvoicingTypeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRequestForInvoicingTypeQuery, GetRequestForInvoicingTypeQueryVariables>({ query: GetRequestForInvoicingTypeDocument, ...options });
};
export const QuoteForNavigationDocument = gql`
    query QuoteForNavigation($id: ID!) {
  GetQuote(id: $id) {
    id
    number
  }
}
    `;

export function useQuoteForNavigationQuery(options: Omit<Urql.UseQueryArgs<QuoteForNavigationQueryVariables>, 'query'>) {
  return Urql.useQuery<QuoteForNavigationQuery, QuoteForNavigationQueryVariables>({ query: QuoteForNavigationDocument, ...options });
};
export const AccessTokenForBudgetovacDocument = gql`
    query AccessTokenForBudgetovac($appName: ThirdPartyEnum = BUDGETOVAC) {
  getAccessTokenForThirdParty(appName: $appName)
}
    `;

export function useAccessTokenForBudgetovacQuery(options?: Omit<Urql.UseQueryArgs<AccessTokenForBudgetovacQueryVariables>, 'query'>) {
  return Urql.useQuery<AccessTokenForBudgetovacQuery, AccessTokenForBudgetovacQueryVariables>({ query: AccessTokenForBudgetovacDocument, ...options });
};
export const RunningTimerDocument = gql`
    query RunningTimer($user_id: ID!) {
  runningTimer(user_id: $user_id) {
    id
    timeTrackingItem {
      ...TimeTrackingEntry
    }
  }
}
    ${TimeTrackingEntryFragmentDoc}`;

export function useRunningTimerQuery(options: Omit<Urql.UseQueryArgs<RunningTimerQueryVariables>, 'query'>) {
  return Urql.useQuery<RunningTimerQuery, RunningTimerQueryVariables>({ query: RunningTimerDocument, ...options });
};
export const AddScopedUsersToTaskDocument = gql`
    mutation AddScopedUsersToTask($id: ID!, $user_ids: [ID!], $isTemplate: Boolean!) {
  updateTask(input: {id: $id, user_ids: $user_ids, is_template: $isTemplate}) {
    id
    users {
      id
      first_name
      last_name
      scope {
        value
      }
    }
  }
}
    `;

export function useAddScopedUsersToTaskMutation() {
  return Urql.useMutation<AddScopedUsersToTaskMutation, AddScopedUsersToTaskMutationVariables>(AddScopedUsersToTaskDocument);
};
export const CreateLinkTaskDocument = gql`
    mutation createLinkTask($task_id: ID!, $link_type_id: ID!, $linked_task_id: ID!) {
  addTaskLink(
    task_id: $task_id
    link_type_id: $link_type_id
    linked_task_id: $linked_task_id
  ) {
    id
    linked_task {
      id
      status {
        id
        name
        background_color
        foreground_color
        system_status
      }
      name
      commentCount
      priority {
        id
        name
        system_priority
        emoji
      }
      ourWorkBudgetItem {
        id
        title
        item_code
      }
    }
    link_type {
      id
      name
    }
  }
}
    `;

export function useCreateLinkTaskMutation() {
  return Urql.useMutation<CreateLinkTaskMutation, CreateLinkTaskMutationVariables>(CreateLinkTaskDocument);
};
export const CreateTaskCommentDocument = gql`
    mutation createTaskComment($input: CreateTaskCommentInput!) {
  createTaskComment(input: $input) {
    ...Comment
  }
}
    ${CommentFragmentDoc}`;

export function useCreateTaskCommentMutation() {
  return Urql.useMutation<CreateTaskCommentMutation, CreateTaskCommentMutationVariables>(CreateTaskCommentDocument);
};
export const DeleteAssignableFileDocument = gql`
    mutation deleteAssignableFile($publicId: String!) {
  deleteAssignableFile(public_id: $publicId) {
    result
  }
}
    `;

export function useDeleteAssignableFileMutation() {
  return Urql.useMutation<DeleteAssignableFileMutation, DeleteAssignableFileMutationVariables>(DeleteAssignableFileDocument);
};
export const DeleteLinkTaskDocument = gql`
    mutation deleteLinkTask($task_link_id: ID!) {
  deleteTaskLink(task_link_id: $task_link_id) {
    id
  }
}
    `;

export function useDeleteLinkTaskMutation() {
  return Urql.useMutation<DeleteLinkTaskMutation, DeleteLinkTaskMutationVariables>(DeleteLinkTaskDocument);
};
export const DeleteTaskCommentDocument = gql`
    mutation deleteTaskComment($id: ID!) {
  deleteTaskComment(id: $id) {
    id
  }
}
    `;

export function useDeleteTaskCommentMutation() {
  return Urql.useMutation<DeleteTaskCommentMutation, DeleteTaskCommentMutationVariables>(DeleteTaskCommentDocument);
};
export const DuplicateTaskDocument = gql`
    mutation duplicateTask($task_id: ID!, $task_input: CreateTaskInput, $with_attachments: Boolean, $with_links: Boolean, $with_comments: Boolean, $performed_by_user_id: ID) {
  duplicateTask(
    task_id: $task_id
    task_input: $task_input
    with_attachments: $with_attachments
    with_comments: $with_comments
    with_links: $with_links
    performed_by_user_id: $performed_by_user_id
  ) {
    ...TaskFragment
    ...SimpleTask
  }
}
    ${TaskFragmentFragmentDoc}
${SimpleTaskFragmentDoc}`;

export function useDuplicateTaskMutation() {
  return Urql.useMutation<DuplicateTaskMutation, DuplicateTaskMutationVariables>(DuplicateTaskDocument);
};
export const EditTaskWatchersDocument = gql`
    mutation EditTaskWatchers($taskId: ID!, $userIds: [ID!]!) {
  editTaskWatchers(task_id: $taskId, user_ids: $userIds) {
    taskWatchers {
      user_id
    }
  }
}
    `;

export function useEditTaskWatchersMutation() {
  return Urql.useMutation<EditTaskWatchersMutation, EditTaskWatchersMutationVariables>(EditTaskWatchersDocument);
};
export const LastSeenCommentDocument = gql`
    mutation LastSeenComment($comment_id: ID!) {
  lastSeen(task_comment_id: $comment_id) {
    id
  }
}
    `;

export function useLastSeenCommentMutation() {
  return Urql.useMutation<LastSeenCommentMutation, LastSeenCommentMutationVariables>(LastSeenCommentDocument);
};
export const MarkTaskNotificationsAsReadDocument = gql`
    mutation MarkTaskNotificationsAsRead($task_id: ID!) {
  markTaskAndCommunicationNotificationAsRead(task_id: $task_id)
}
    `;

export function useMarkTaskNotificationsAsReadMutation() {
  return Urql.useMutation<MarkTaskNotificationsAsReadMutation, MarkTaskNotificationsAsReadMutationVariables>(MarkTaskNotificationsAsReadDocument);
};
export const ToggleTaskCommentReactionDocument = gql`
    mutation ToggleTaskCommentReaction($input: ToggleTaskCommentReactionInput!) {
  toggleTaskCommentReaction(input: $input) {
    id
    user {
      id
      full_name
    }
    emoji_id
  }
}
    `;

export function useToggleTaskCommentReactionMutation() {
  return Urql.useMutation<ToggleTaskCommentReactionMutation, ToggleTaskCommentReactionMutationVariables>(ToggleTaskCommentReactionDocument);
};
export const UpdateTaskCommentDocument = gql`
    mutation updateTaskComment($input: UpdateTaskCommentInput!) {
  updateTaskComment(input: $input) {
    ...Comment
  }
}
    ${CommentFragmentDoc}`;

export function useUpdateTaskCommentMutation() {
  return Urql.useMutation<UpdateTaskCommentMutation, UpdateTaskCommentMutationVariables>(UpdateTaskCommentDocument);
};
export const UpdateTaskDescriptionDocument = gql`
    mutation updateTaskDescription($input: UpdateTaskDescriptionInput!) {
  updateTaskDescription(input: $input) {
    id
    description {
      body
      mentioned_user_ids
      mentioned_team_ids
      mentioned_assignees
    }
    revision
  }
}
    `;

export function useUpdateTaskDescriptionMutation() {
  return Urql.useMutation<UpdateTaskDescriptionMutation, UpdateTaskDescriptionMutationVariables>(UpdateTaskDescriptionDocument);
};
export const UpdateTaskFilesDocument = gql`
    mutation updateTaskFiles($task_id: ID!, $files: [String!]!) {
  addTaskFiles(task_id: $task_id, files: $files) {
    id
    files {
      ...Attachment
      created_at
    }
  }
}
    ${AttachmentFragmentDoc}`;

export function useUpdateTaskFilesMutation() {
  return Urql.useMutation<UpdateTaskFilesMutation, UpdateTaskFilesMutationVariables>(UpdateTaskFilesDocument);
};
export const UpdateTaskPriorityDocument = gql`
    mutation updateTaskPriority($task_id: ID!, $priority_id: ID!) {
  updateTaskPriority(task_id: $task_id, priority_id: $priority_id) {
    id
    priority {
      id
      name
      system_priority
      emoji
    }
  }
}
    `;

export function useUpdateTaskPriorityMutation() {
  return Urql.useMutation<UpdateTaskPriorityMutation, UpdateTaskPriorityMutationVariables>(UpdateTaskPriorityDocument);
};
export const UpdateTaskStatusDocument = gql`
    mutation updateTaskStatus($task_id: ID!, $status_id: ID!) {
  updateTaskStatus(task_id: $task_id, status_id: $status_id) {
    id
    status {
      id
      name
      background_color
      foreground_color
      system_status
    }
  }
}
    `;

export function useUpdateTaskStatusMutation() {
  return Urql.useMutation<UpdateTaskStatusMutation, UpdateTaskStatusMutationVariables>(UpdateTaskStatusDocument);
};
export const CheckTaskRevisionDocument = gql`
    query CheckTaskRevision($id: ID!) {
  task(id: $id) {
    id
    revision
  }
}
    `;

export function useCheckTaskRevisionQuery(options: Omit<Urql.UseQueryArgs<CheckTaskRevisionQueryVariables>, 'query'>) {
  return Urql.useQuery<CheckTaskRevisionQuery, CheckTaskRevisionQueryVariables>({ query: CheckTaskRevisionDocument, ...options });
};
export const GetTaskCommunicationFilesDocument = gql`
    query GetTaskCommunicationFiles($task_id: ID!, $scope: UserScopeEnum) {
  taskCommentFiles(task_id: $task_id, scope: $scope) {
    ...Attachment
  }
}
    ${AttachmentFragmentDoc}`;

export function useGetTaskCommunicationFilesQuery(options: Omit<Urql.UseQueryArgs<GetTaskCommunicationFilesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTaskCommunicationFilesQuery, GetTaskCommunicationFilesQueryVariables>({ query: GetTaskCommunicationFilesDocument, ...options });
};
export const GetTaskLinkTypesDocument = gql`
    query GetTaskLinkTypes {
  taskLinkTypes {
    id
    name
  }
}
    `;

export function useGetTaskLinkTypesQuery(options?: Omit<Urql.UseQueryArgs<GetTaskLinkTypesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTaskLinkTypesQuery, GetTaskLinkTypesQueryVariables>({ query: GetTaskLinkTypesDocument, ...options });
};
export const GetTaskLinksDocument = gql`
    query GetTaskLinks($id: ID!) {
  task(id: $id) {
    linkedTasks {
      link_type {
        name
      }
      linked_task {
        status {
          id
          name
          background_color
          foreground_color
          system_status
        }
        name
        priority {
          id
          name
          system_priority
          emoji
        }
      }
    }
  }
}
    `;

export function useGetTaskLinksQuery(options: Omit<Urql.UseQueryArgs<GetTaskLinksQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTaskLinksQuery, GetTaskLinksQueryVariables>({ query: GetTaskLinksDocument, ...options });
};
export const TaskDocument = gql`
    query Task($id: ID!) {
  taskPositionStat(task_id: $id) {
    timeTrackingWorkType {
      id
      title
    }
    user {
      ...UserToolTip_UserFragment
      first_name
      last_name
      scope {
        value
      }
    }
    planned_time
    spent_time
  }
  task(id: $id) {
    ...TaskFragment
    subtasks {
      ...TaskFragment
    }
  }
  taskStatuses {
    id
    name
    background_color
    foreground_color
    system_status
  }
  taskPriorities {
    id
    name
    system_priority
    emoji
  }
}
    ${UserToolTip_UserFragmentFragmentDoc}
${TaskFragmentFragmentDoc}`;

export function useTaskQuery(options: Omit<Urql.UseQueryArgs<TaskQueryVariables>, 'query'>) {
  return Urql.useQuery<TaskQuery, TaskQueryVariables>({ query: TaskDocument, ...options });
};
export const TaskForScopedUsersDocument = gql`
    query TaskForScopedUsers($id: ID!) {
  task(id: $id) {
    ...TaskFragmentForScopedUser
  }
  taskStatuses {
    id
    name
    background_color
    foreground_color
  }
  taskPriorities {
    id
    name
    system_priority
    emoji
  }
}
    ${TaskFragmentForScopedUserFragmentDoc}`;

export function useTaskForScopedUsersQuery(options: Omit<Urql.UseQueryArgs<TaskForScopedUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<TaskForScopedUsersQuery, TaskForScopedUsersQueryVariables>({ query: TaskForScopedUsersDocument, ...options });
};
export const TaskCommentsDocument = gql`
    query TaskComments($id: ID!, $page: Int = 1, $first: Int = 10, $scope: UserScopeEnum, $lastCommentId: ID) {
  taskComments(
    task_id: $id
    page: $page
    first: $first
    scope: $scope
    last_comment_ID: $lastCommentId
  ) {
    paginatorInfo {
      ...PaginatorInfo
    }
    data {
      ...Comment
    }
  }
}
    ${PaginatorInfoFragmentDoc}
${CommentFragmentDoc}`;

export function useTaskCommentsQuery(options: Omit<Urql.UseQueryArgs<TaskCommentsQueryVariables>, 'query'>) {
  return Urql.useQuery<TaskCommentsQuery, TaskCommentsQueryVariables>({ query: TaskCommentsDocument, ...options });
};
export const TaskStatusesDocument = gql`
    query TaskStatuses {
  taskStatuses {
    id
    name
    background_color
    foreground_color
    system_status
  }
}
    `;

export function useTaskStatusesQuery(options?: Omit<Urql.UseQueryArgs<TaskStatusesQueryVariables>, 'query'>) {
  return Urql.useQuery<TaskStatusesQuery, TaskStatusesQueryVariables>({ query: TaskStatusesDocument, ...options });
};
export const HasTaskPermissionDocument = gql`
    query HasTaskPermission($task_id: ID!, $type: TaskPermissionTypeEnum!) {
  hasTaskPermission(task_id: $task_id, type: $type)
}
    `;

export function useHasTaskPermissionQuery(options: Omit<Urql.UseQueryArgs<HasTaskPermissionQueryVariables>, 'query'>) {
  return Urql.useQuery<HasTaskPermissionQuery, HasTaskPermissionQueryVariables>({ query: HasTaskPermissionDocument, ...options });
};
export const CompleteExpenseBudgetItemDocument = gql`
    mutation CompleteExpenseBudgetItem($id: ID!, $completed_at: Date) {
  completeExpenseBudgetItem(id: $id, completed_at: $completed_at) {
    ...EbiCompleteData
  }
}
    ${EbiCompleteDataFragmentDoc}`;

export function useCompleteExpenseBudgetItemMutation() {
  return Urql.useMutation<CompleteExpenseBudgetItemMutation, CompleteExpenseBudgetItemMutationVariables>(CompleteExpenseBudgetItemDocument);
};
export const ReopenExpenseBudgetItemDocument = gql`
    mutation ReopenExpenseBudgetItem($id: ID!) {
  reopenExpenseBudgetItem(id: $id) {
    ...EbiCompleteData
  }
}
    ${EbiCompleteDataFragmentDoc}`;

export function useReopenExpenseBudgetItemMutation() {
  return Urql.useMutation<ReopenExpenseBudgetItemMutation, ReopenExpenseBudgetItemMutationVariables>(ReopenExpenseBudgetItemDocument);
};
export const ReturnGlobalCreditDocument = gql`
    mutation ReturnGlobalCredit($amount: BigInt!, $expense_budget_item_id: ID!, $global_credit_account_id: ID!, $credit_account_operation_id: ID!) {
  returnGlobalCreditFromExpenseItem(
    amount: $amount
    expense_budget_item_id: $expense_budget_item_id
    global_credit_account_id: $global_credit_account_id
    credit_account_operation_id: $credit_account_operation_id
  )
}
    `;

export function useReturnGlobalCreditMutation() {
  return Urql.useMutation<ReturnGlobalCreditMutation, ReturnGlobalCreditMutationVariables>(ReturnGlobalCreditDocument);
};
export const TransferGlobalCreditDocument = gql`
    mutation TransferGlobalCredit($amount: BigInt!, $fromCreditAccountId: ID!, $toCreditAccountId: ID!, $performedAt: DateTime) {
  transferGlobalCredit(
    amount: $amount
    from_credit_account_id: $fromCreditAccountId
    to_credit_account_id: $toCreditAccountId
    performed_at: $performedAt
  )
}
    `;

export function useTransferGlobalCreditMutation() {
  return Urql.useMutation<TransferGlobalCreditMutation, TransferGlobalCreditMutationVariables>(TransferGlobalCreditDocument);
};
export const ExpenseBudgetItemDocument = gql`
    query ExpenseBudgetItem($id: ID!) {
  expenseBudgetItem(id: $id) {
    id
    type
    title
    completed_at
    project {
      id
      billable
      brand {
        id
      }
    }
    expenseStats {
      id
      amount
      date
      expense {
        id
        status
      }
      contractor {
        id
        legal_name
      }
    }
    creditAccount {
      id
    }
    stats {
      real_expenses
      planned_commission
      planned_commission_relative_computed
      real_commission
      real_commission_relative
    }
    globalPrepaymentStats {
      id
      credit
      date
      credit_account_operation_id
      expenseBudgetItem {
        id
        title
      }
      globalCreditAccount {
        id
        title
      }
    }
  }
}
    `;

export function useExpenseBudgetItemQuery(options: Omit<Urql.UseQueryArgs<ExpenseBudgetItemQueryVariables>, 'query'>) {
  return Urql.useQuery<ExpenseBudgetItemQuery, ExpenseBudgetItemQueryVariables>({ query: ExpenseBudgetItemDocument, ...options });
};
export const CreateContactDocument = gql`
    mutation CreateContact($input: CreateContactInput!) {
  createContact(input: $input) {
    ...Contact
  }
}
    ${ContactFragmentDoc}`;

export function useCreateContactMutation() {
  return Urql.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument);
};
export const UpdateContactDocument = gql`
    mutation UpdateContact($input: UpdateContactInput!) {
  updateContact(input: $input) {
    ...Contact
  }
}
    ${ContactFragmentDoc}`;

export function useUpdateContactMutation() {
  return Urql.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument);
};
export const CreateCurrencyExchangeRateForClientDocument = gql`
    mutation CreateCurrencyExchangeRateForClient($input: CreateCurrencyExchangeRateInput!) {
  createCurrencyExchangeRate(input: $input) {
    ...ExchangeRate
  }
}
    ${ExchangeRateFragmentDoc}`;

export function useCreateCurrencyExchangeRateForClientMutation() {
  return Urql.useMutation<CreateCurrencyExchangeRateForClientMutation, CreateCurrencyExchangeRateForClientMutationVariables>(CreateCurrencyExchangeRateForClientDocument);
};
export const UpdateCurrencyExchangeRateForClientDocument = gql`
    mutation UpdateCurrencyExchangeRateForClient($input: UpdateCurrencyExchangeRateInput!) {
  updateCurrencyExchangeRate(input: $input) {
    ...ExchangeRate
  }
}
    ${ExchangeRateFragmentDoc}`;

export function useUpdateCurrencyExchangeRateForClientMutation() {
  return Urql.useMutation<UpdateCurrencyExchangeRateForClientMutation, UpdateCurrencyExchangeRateForClientMutationVariables>(UpdateCurrencyExchangeRateForClientDocument);
};
export const CreateCurrencyExchangeRateForWorkspaceDocument = gql`
    mutation CreateCurrencyExchangeRateForWorkspace($input: CreateExchangeRateSettingsInput!) {
  createExchangeRateForWorkspace(input: $input) {
    ...ExchangeRate
  }
}
    ${ExchangeRateFragmentDoc}`;

export function useCreateCurrencyExchangeRateForWorkspaceMutation() {
  return Urql.useMutation<CreateCurrencyExchangeRateForWorkspaceMutation, CreateCurrencyExchangeRateForWorkspaceMutationVariables>(CreateCurrencyExchangeRateForWorkspaceDocument);
};
export const UpdateCurrencyExchangeRateForWorkspaceDocument = gql`
    mutation UpdateCurrencyExchangeRateForWorkspace($input: UpdateExchangeRateSettingsInput!) {
  updateExchangeRateForWorkspace(input: $input) {
    ...ExchangeRate
  }
}
    ${ExchangeRateFragmentDoc}`;

export function useUpdateCurrencyExchangeRateForWorkspaceMutation() {
  return Urql.useMutation<UpdateCurrencyExchangeRateForWorkspaceMutation, UpdateCurrencyExchangeRateForWorkspaceMutationVariables>(UpdateCurrencyExchangeRateForWorkspaceDocument);
};
export const CompleteExpenseBulkDocument = gql`
    mutation CompleteExpenseBulk($ids: [ID!]!, $completed_at: Date) {
  completeExpenseBudgetItemBulk(ids: $ids, completed_at: $completed_at) {
    ...CompleteExpenseBulkData
  }
}
    ${CompleteExpenseBulkDataFragmentDoc}`;

export function useCompleteExpenseBulkMutation() {
  return Urql.useMutation<CompleteExpenseBulkMutation, CompleteExpenseBulkMutationVariables>(CompleteExpenseBulkDocument);
};
export const FinishProjectDocument = gql`
    mutation FinishProject($id: ID!) {
  finishProject(id: $id) {
    ...FinishedProjectData
  }
}
    ${FinishedProjectDataFragmentDoc}`;

export function useFinishProjectMutation() {
  return Urql.useMutation<FinishProjectMutation, FinishProjectMutationVariables>(FinishProjectDocument);
};
export const RedistributeProjectCreditDocument = gql`
    mutation RedistributeProjectCredit($id: ID!) {
  redistributeProjectCredit(project_id: $id) {
    id
  }
}
    `;

export function useRedistributeProjectCreditMutation() {
  return Urql.useMutation<RedistributeProjectCreditMutation, RedistributeProjectCreditMutationVariables>(RedistributeProjectCreditDocument);
};
export const ModalFinishProjectDocument = gql`
    query ModalFinishProject($id: ID!) {
  project(id: $id) {
    id
    billable
  }
  getProjectCanBeFinishedSummary(id: $id) {
    id
    project_already_finished
    can_be_finished_without_further_changes
    can_redistribute_credit_automatically
    overinvoiced_for_project
    underinvoiced_for_project
    incomplete_expense_budget_items {
      id
      title
      stats {
        id
        real_expenses_percent
        real_expenses
        real_commission
        real_commission_relative
      }
    }
    incomplete_our_work_budget_items {
      id
      title
      stats {
        id
        spent_time
        spent_budget
      }
      lastWorkInProgressItemStat {
        work_in_progress_id
        progress_percent
      }
    }
    underinvoiced_our_work_budget_items {
      id
      title
      stats {
        id
        uninvoiced
        credit
        total_budget
      }
    }
    underinvoiced_expense_budget_items {
      id
      title
      stats {
        id
        uninvoiced
        credit
        total_budget
      }
    }
    overinvoiced_our_work_budget_items {
      id
      title
      stats {
        id
        credit
        total_budget
        over_invoiced
      }
    }
    overinvoiced_expense_budget_items {
      id
      title
      stats {
        id
        credit
        total_budget
        over_invoiced
      }
    }
  }
}
    `;

export function useModalFinishProjectQuery(options: Omit<Urql.UseQueryArgs<ModalFinishProjectQueryVariables>, 'query'>) {
  return Urql.useQuery<ModalFinishProjectQuery, ModalFinishProjectQueryVariables>({ query: ModalFinishProjectDocument, ...options });
};
export const ModalGetCreditDependenciesDocument = gql`
    query ModalGetCreditDependencies($id: ID!) {
  brand(id: $id) {
    id
    creditAccounts {
      id
      title
      creditAccount {
        id
      }
      stats {
        id
        remaining_credit
      }
    }
  }
}
    `;

export function useModalGetCreditDependenciesQuery(options: Omit<Urql.UseQueryArgs<ModalGetCreditDependenciesQueryVariables>, 'query'>) {
  return Urql.useQuery<ModalGetCreditDependenciesQuery, ModalGetCreditDependenciesQueryVariables>({ query: ModalGetCreditDependenciesDocument, ...options });
};
export const InvoiceProjectDocument = gql`
    mutation InvoiceProject($id: ID!, $amount: BigInt, $expense_budget_item_id: ID, $our_work_budget_item_id: ID) {
  invoiceProject(
    id: $id
    amount: $amount
    expense_budget_item_id: $expense_budget_item_id
    our_work_budget_item_id: $our_work_budget_item_id
  ) {
    id
  }
}
    `;

export function useInvoiceProjectMutation() {
  return Urql.useMutation<InvoiceProjectMutation, InvoiceProjectMutationVariables>(InvoiceProjectDocument);
};
export const ModalInvoicesOurWorkBiDocument = gql`
    query ModalInvoicesOurWorkBI($id: ID!) {
  ourWorkBudgetItem(id: $id) {
    id
    title
    project {
      id
      billable
      brand {
        id
      }
    }
    creditAccount {
      id
    }
    invoiceStats {
      id
      credit
      outgoingInvoice {
        ...OutgoingInvoiceOfInvoiceStats
      }
    }
    outgoingProformaInvoiceStats {
      id
      amount
      invoice_no
      date
    }
    prepaymentStats {
      id
      date
      credit
      brandCreditAccount {
        id
        title
      }
      ourWorkBudgetItem {
        id
        title
      }
      credit_account_operation_id
    }
    stats {
      id
      credit
      credit_direct
      credit_from_prepayments
      uninvoiced
    }
  }
}
    ${OutgoingInvoiceOfInvoiceStatsFragmentDoc}`;

export function useModalInvoicesOurWorkBiQuery(options: Omit<Urql.UseQueryArgs<ModalInvoicesOurWorkBiQueryVariables>, 'query'>) {
  return Urql.useQuery<ModalInvoicesOurWorkBiQuery, ModalInvoicesOurWorkBiQueryVariables>({ query: ModalInvoicesOurWorkBiDocument, ...options });
};
export const ModalInvoicesExpenseBiDocument = gql`
    query ModalInvoicesExpenseBI($id: ID!) {
  expenseBudgetItem(id: $id) {
    id
    title
    project {
      id
      billable
      brand {
        id
      }
    }
    creditAccount {
      id
    }
    invoiceStats {
      id
      credit
      outgoingInvoice {
        ...OutgoingInvoiceOfInvoiceStats
      }
    }
    outgoingProformaInvoiceStats {
      id
      amount
      invoice_no
      date
    }
    prepaymentStats {
      id
      date
      credit
      brandCreditAccount {
        id
        title
      }
      expenseBudgetItem {
        id
        title
      }
      credit_account_operation_id
    }
    stats {
      id
      credit
      credit_direct
      credit_from_prepayments
      uninvoiced
    }
  }
}
    ${OutgoingInvoiceOfInvoiceStatsFragmentDoc}`;

export function useModalInvoicesExpenseBiQuery(options: Omit<Urql.UseQueryArgs<ModalInvoicesExpenseBiQueryVariables>, 'query'>) {
  return Urql.useQuery<ModalInvoicesExpenseBiQuery, ModalInvoicesExpenseBiQueryVariables>({ query: ModalInvoicesExpenseBiDocument, ...options });
};
export const ModalInvoicesProjectDocument = gql`
    query ModalInvoicesProject($id: ID!) {
  project(id: $id) {
    id
    billable
    proformaInvoices {
      id
      invoice_no
      issue_date
      abraflexi_exported
      documentExports {
        ...DocumentExport
      }
      emailLogs {
        ...EmailLog
      }
      stats {
        total_amount
      }
    }
    invoiceStats {
      id
      credit
      outgoingInvoice {
        ...OutgoingInvoiceOfInvoiceStats
      }
    }
    prepaymentStats {
      id
      date
      credit
      brandCreditAccount {
        id
        title
      }
      ourWorkBudgetItem {
        id
        title
      }
      expenseBudgetItem {
        id
        title
      }
    }
    statsCached {
      id
      credit_direct
      credit_from_prepayments
      unused_sum_from_proformas
    }
  }
}
    ${DocumentExportFragmentDoc}
${EmailLogFragmentDoc}
${OutgoingInvoiceOfInvoiceStatsFragmentDoc}`;

export function useModalInvoicesProjectQuery(options: Omit<Urql.UseQueryArgs<ModalInvoicesProjectQueryVariables>, 'query'>) {
  return Urql.useQuery<ModalInvoicesProjectQuery, ModalInvoicesProjectQueryVariables>({ query: ModalInvoicesProjectDocument, ...options });
};
export const CreateOrderDocument = gql`
    mutation CreateOrder($input: CreateOrderInput!) {
  createOrder(input: $input) {
    ...ModalOrderData
  }
}
    ${ModalOrderDataFragmentDoc}`;

export function useCreateOrderMutation() {
  return Urql.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument);
};
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($input: UpdateOrderInput!) {
  updateOrder(input: $input) {
    ...ModalOrderData
  }
}
    ${ModalOrderDataFragmentDoc}`;

export function useUpdateOrderMutation() {
  return Urql.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument);
};
export const ModalCreateOrderBrandOptionsDocument = gql`
    query ModalCreateOrderBrandOptions {
  clientsSimpleMap {
    brands {
      ...BrandSimpleOptionParts
    }
  }
}
    ${BrandSimpleOptionPartsFragmentDoc}`;

export function useModalCreateOrderBrandOptionsQuery(options?: Omit<Urql.UseQueryArgs<ModalCreateOrderBrandOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ModalCreateOrderBrandOptionsQuery, ModalCreateOrderBrandOptionsQueryVariables>({ query: ModalCreateOrderBrandOptionsDocument, ...options });
};
export const ModalCreateOrderProjectOptionsDocument = gql`
    query ModalCreateOrderProjectOptions($brandId: ID!) {
  projectsSimpleMap(brand_id: $brandId) {
    ...ProjectSimpleOptionParts
  }
}
    ${ProjectSimpleOptionPartsFragmentDoc}`;

export function useModalCreateOrderProjectOptionsQuery(options: Omit<Urql.UseQueryArgs<ModalCreateOrderProjectOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ModalCreateOrderProjectOptionsQuery, ModalCreateOrderProjectOptionsQueryVariables>({ query: ModalCreateOrderProjectOptionsDocument, ...options });
};
export const ReturnCreditFromOurWorkDocument = gql`
    mutation returnCreditFromOurWork($amount: BigInt!, $our_work_budget_item_id: ID!, $brand_credit_account_id: ID!, $credit_account_operation_id: ID!) {
  returnCreditFromOurWorkBudgetItem(
    amount: $amount
    our_work_budget_item_id: $our_work_budget_item_id
    brand_credit_account_id: $brand_credit_account_id
    credit_account_operation_id: $credit_account_operation_id
  )
}
    `;

export function useReturnCreditFromOurWorkMutation() {
  return Urql.useMutation<ReturnCreditFromOurWorkMutation, ReturnCreditFromOurWorkMutationVariables>(ReturnCreditFromOurWorkDocument);
};
export const ReturnCreditFromExpenseDocument = gql`
    mutation returnCreditFromExpense($amount: BigInt!, $expense_budget_item_id: ID!, $brand_credit_account_id: ID!, $credit_account_operation_id: ID!) {
  returnCreditFromExpenseBudgetItem(
    amount: $amount
    expense_budget_item_id: $expense_budget_item_id
    brand_credit_account_id: $brand_credit_account_id
    credit_account_operation_id: $credit_account_operation_id
  )
}
    `;

export function useReturnCreditFromExpenseMutation() {
  return Urql.useMutation<ReturnCreditFromExpenseMutation, ReturnCreditFromExpenseMutationVariables>(ReturnCreditFromExpenseDocument);
};
export const SendQuoteDocument = gql`
    mutation SendQuote($input: quoteSendInput!) {
  sendQuote(input: $input) {
    id
  }
}
    `;

export function useSendQuoteMutation() {
  return Urql.useMutation<SendQuoteMutation, SendQuoteMutationVariables>(SendQuoteDocument);
};
export const CreateTaskDocument = gql`
    mutation CreateTask($input: CreateTaskInput!) {
  createTask(input: $input) {
    ...SimpleTask
  }
}
    ${SimpleTaskFragmentDoc}`;

export function useCreateTaskMutation() {
  return Urql.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument);
};
export const CreateScopedTaskDocument = gql`
    mutation CreateScopedTask($input: CreateScopedTaskInput!) {
  createScopedTask(input: $input) {
    ...TaskFragmentForScopedUser
  }
}
    ${TaskFragmentForScopedUserFragmentDoc}`;

export function useCreateScopedTaskMutation() {
  return Urql.useMutation<CreateScopedTaskMutation, CreateScopedTaskMutationVariables>(CreateScopedTaskDocument);
};
export const DeleteTaskDocument = gql`
    mutation DeleteTask($id: ID!) {
  deleteTask(id: $id) {
    id
  }
}
    `;

export function useDeleteTaskMutation() {
  return Urql.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument);
};
export const UpdateTaskDocument = gql`
    mutation UpdateTask($input: UpdateTaskInput!, $propagate_billable: Boolean!) {
  updateTask(input: $input, propagate_billable: $propagate_billable) {
    ...SimpleTask
  }
}
    ${SimpleTaskFragmentDoc}`;

export function useUpdateTaskMutation() {
  return Urql.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument);
};
export const UpdateScopedTaskDocument = gql`
    mutation UpdateScopedTask($input: UpdateScopedTaskInput!) {
  updateScopedTask(input: $input) {
    ...TaskFragmentForScopedUser
  }
}
    ${TaskFragmentForScopedUserFragmentDoc}`;

export function useUpdateScopedTaskMutation() {
  return Urql.useMutation<UpdateScopedTaskMutation, UpdateScopedTaskMutationVariables>(UpdateScopedTaskDocument);
};
export const AvailableTaskPositionsHoursByOurWorkBudgetDocument = gql`
    query AvailableTaskPositionsHoursByOurWorkBudget($our_work_budget_item_id: ID!) {
  availableTaskPositionsHoursByOurWorkBudget(
    our_work_budget_item_id: $our_work_budget_item_id
  ) {
    time_tracking_work_type_id
    planned_time
  }
}
    `;

export function useAvailableTaskPositionsHoursByOurWorkBudgetQuery(options: Omit<Urql.UseQueryArgs<AvailableTaskPositionsHoursByOurWorkBudgetQueryVariables>, 'query'>) {
  return Urql.useQuery<AvailableTaskPositionsHoursByOurWorkBudgetQuery, AvailableTaskPositionsHoursByOurWorkBudgetQueryVariables>({ query: AvailableTaskPositionsHoursByOurWorkBudgetDocument, ...options });
};
export const GetPrioritiesOptionsDocument = gql`
    query GetPrioritiesOptions {
  taskPriorities {
    name
    id
  }
}
    `;

export function useGetPrioritiesOptionsQuery(options?: Omit<Urql.UseQueryArgs<GetPrioritiesOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPrioritiesOptionsQuery, GetPrioritiesOptionsQueryVariables>({ query: GetPrioritiesOptionsDocument, ...options });
};
export const GetProjectBillableDocument = gql`
    query GetProjectBillable($projectId: ID) {
  projectsSimpleMap(project_ids: [$projectId]) {
    id
    billable
  }
}
    `;

export function useGetProjectBillableQuery(options?: Omit<Urql.UseQueryArgs<GetProjectBillableQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProjectBillableQuery, GetProjectBillableQueryVariables>({ query: GetProjectBillableDocument, ...options });
};
export const GetProjectOptionsDocument = gql`
    query GetProjectOptions($withTemplates: Boolean) {
  projectsSimpleMap(with_templates: $withTemplates) {
    id
    title
    code
  }
}
    `;

export function useGetProjectOptionsQuery(options?: Omit<Urql.UseQueryArgs<GetProjectOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProjectOptionsQuery, GetProjectOptionsQueryVariables>({ query: GetProjectOptionsDocument, ...options });
};
export const GetStatusOptionsDocument = gql`
    query GetStatusOptions {
  taskStatuses {
    name
    id
  }
}
    `;

export function useGetStatusOptionsQuery(options?: Omit<Urql.UseQueryArgs<GetStatusOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetStatusOptionsQuery, GetStatusOptionsQueryVariables>({ query: GetStatusOptionsDocument, ...options });
};
export const TimeTrackingWorkTypesDocument = gql`
    query TimeTrackingWorkTypes {
  timeTrackingWorkTypes {
    id
    title
  }
}
    `;

export function useTimeTrackingWorkTypesQuery(options?: Omit<Urql.UseQueryArgs<TimeTrackingWorkTypesQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingWorkTypesQuery, TimeTrackingWorkTypesQueryVariables>({ query: TimeTrackingWorkTypesDocument, ...options });
};
export const GetUnmatchedWorkTypesForTaskMoveDocument = gql`
    query GetUnmatchedWorkTypesForTaskMove($taskIds: [ID!]!, $newProjectId: ID!) {
  getUnmatchedWorkTypesForTaskMove(
    task_ids: $taskIds
    new_project_id: $newProjectId
  ) {
    unmatched_work_types {
      id
      title
    }
    target_available_work_types {
      id
      title
    }
    has_time_tracking_entries
  }
}
    `;

export function useGetUnmatchedWorkTypesForTaskMoveQuery(options: Omit<Urql.UseQueryArgs<GetUnmatchedWorkTypesForTaskMoveQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUnmatchedWorkTypesForTaskMoveQuery, GetUnmatchedWorkTypesForTaskMoveQueryVariables>({ query: GetUnmatchedWorkTypesForTaskMoveDocument, ...options });
};
export const ModalTaskDependenciesDocument = gql`
    query ModalTaskDependencies($projectId: ID!) {
  projectForTask(id: $projectId) {
    id
    code
    availableTimeTrackingWorkTypes {
      id
      title
    }
    ourWork {
      id
      title
      category {
        name
      }
      timeTrackingSettings {
        tracking_enabled
        tracking_enabled_from
        tracking_enabled_to
      }
    }
  }
}
    `;

export function useModalTaskDependenciesQuery(options: Omit<Urql.UseQueryArgs<ModalTaskDependenciesQueryVariables>, 'query'>) {
  return Urql.useQuery<ModalTaskDependenciesQuery, ModalTaskDependenciesQueryVariables>({ query: ModalTaskDependenciesDocument, ...options });
};
export const TransferCreditDocument = gql`
    mutation transferCredit($amount: BigInt!, $from_credit_account_id: ID!, $to_credit_account_id: ID!, $outgoing_invoice_id: ID, $performed_at: DateTime) {
  transferCredit(
    amount: $amount
    from_credit_account_id: $from_credit_account_id
    to_credit_account_id: $to_credit_account_id
    outgoing_invoice_id: $outgoing_invoice_id
    performed_at: $performed_at
  )
}
    `;

export function useTransferCreditMutation() {
  return Urql.useMutation<TransferCreditMutation, TransferCreditMutationVariables>(TransferCreditDocument);
};
export const GetModalTransferCreditDependenciesDocument = gql`
    query GetModalTransferCreditDependencies($id: ID!) {
  brandCreditAccount(id: $id) {
    id
    creditAccount {
      id
    }
    stats {
      remaining_credit
    }
    ourWorkBudgetCategories {
      id
    }
    expenseBudgetCategories {
      id
    }
    brand {
      client {
        id
        brands {
          id
          name
          projects {
            id
            title
            code
            billable
            finished_at
          }
          creditAccounts {
            id
            title
            creditAccount {
              id
            }
            ourWorkBudgetCategories {
              id
            }
            expenseBudgetCategories {
              id
            }
          }
        }
      }
    }
  }
}
    `;

export function useGetModalTransferCreditDependenciesQuery(options: Omit<Urql.UseQueryArgs<GetModalTransferCreditDependenciesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetModalTransferCreditDependenciesQuery, GetModalTransferCreditDependenciesQueryVariables>({ query: GetModalTransferCreditDependenciesDocument, ...options });
};
export const GetProjectBudgetItemsDocument = gql`
    query GetProjectBudgetItems($id: ID!) {
  project(id: $id) {
    ourWork {
      id
      title
      creditAccount {
        id
      }
      stats {
        uninvoiced
        credit
      }
      category {
        id
        name
      }
    }
    expenses {
      id
      title
      creditAccount {
        id
      }
      type
      stats {
        uninvoiced
        credit
      }
      category {
        id
        name
      }
    }
  }
}
    `;

export function useGetProjectBudgetItemsQuery(options: Omit<Urql.UseQueryArgs<GetProjectBudgetItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProjectBudgetItemsQuery, GetProjectBudgetItemsQueryVariables>({ query: GetProjectBudgetItemsDocument, ...options });
};
export const CheckIfCreditAccountsBelongToTheSameTeamDocument = gql`
    query checkIfCreditAccountsBelongToTheSameTeam($credit_account_ids: [ID!]!) {
  checkIfCreditAccountsBelongToTheSameTeam(
    credit_account_ids: $credit_account_ids
  )
}
    `;

export function useCheckIfCreditAccountsBelongToTheSameTeamQuery(options: Omit<Urql.UseQueryArgs<CheckIfCreditAccountsBelongToTheSameTeamQueryVariables>, 'query'>) {
  return Urql.useQuery<CheckIfCreditAccountsBelongToTheSameTeamQuery, CheckIfCreditAccountsBelongToTheSameTeamQueryVariables>({ query: CheckIfCreditAccountsBelongToTheSameTeamDocument, ...options });
};
export const WipForBudgetAndPeriodDocument = gql`
    query WipForBudgetAndPeriod($our_work_budget_item_id: ID!, $period_id: ID!) {
  wipForBudgetAndPeriod(
    our_work_budget_item_id: $our_work_budget_item_id
    period_id: $period_id
  ) {
    id
    progress_percent
    work_in_progress_id
    is_closed
    is_locked
  }
}
    `;

export function useWipForBudgetAndPeriodQuery(options: Omit<Urql.UseQueryArgs<WipForBudgetAndPeriodQueryVariables>, 'query'>) {
  return Urql.useQuery<WipForBudgetAndPeriodQuery, WipForBudgetAndPeriodQueryVariables>({ query: WipForBudgetAndPeriodDocument, ...options });
};
export const WipPeriodsDocument = gql`
    query WipPeriods($budgetItemId: ID) {
  wipPeriodsMap(budgetItemId: $budgetItemId) {
    id
    title
    starts_at
    ends_at
    is_current
  }
}
    `;

export function useWipPeriodsQuery(options?: Omit<Urql.UseQueryArgs<WipPeriodsQueryVariables>, 'query'>) {
  return Urql.useQuery<WipPeriodsQuery, WipPeriodsQueryVariables>({ query: WipPeriodsDocument, ...options });
};
export const AccessTokenForPlanovacDocument = gql`
    query AccessTokenForPlanovac($appName: ThirdPartyEnum = PLANOVAC) {
  getAccessTokenForThirdParty(appName: $appName)
}
    `;

export function useAccessTokenForPlanovacQuery(options?: Omit<Urql.UseQueryArgs<AccessTokenForPlanovacQueryVariables>, 'query'>) {
  return Urql.useQuery<AccessTokenForPlanovacQuery, AccessTokenForPlanovacQueryVariables>({ query: AccessTokenForPlanovacDocument, ...options });
};
export const ArchiveProjectDocument = gql`
    mutation ArchiveProject($id: ID!) {
  archiveProject(id: $id) {
    ...ArchivedProjectData
  }
}
    ${ArchivedProjectDataFragmentDoc}`;

export function useArchiveProjectMutation() {
  return Urql.useMutation<ArchiveProjectMutation, ArchiveProjectMutationVariables>(ArchiveProjectDocument);
};
export const ArchiveProjectsBulkDocument = gql`
    mutation ArchiveProjectsBulk($id: [ID!]!) {
  archiveProjectsBulk(id: $id) {
    total
    successful
    failed
  }
}
    `;

export function useArchiveProjectsBulkMutation() {
  return Urql.useMutation<ArchiveProjectsBulkMutation, ArchiveProjectsBulkMutationVariables>(ArchiveProjectsBulkDocument);
};
export const UnarchiveProjectDocument = gql`
    mutation UnarchiveProject($id: ID!) {
  unarchiveProject(id: $id) {
    ...ArchivedProjectData
  }
}
    ${ArchivedProjectDataFragmentDoc}`;

export function useUnarchiveProjectMutation() {
  return Urql.useMutation<UnarchiveProjectMutation, UnarchiveProjectMutationVariables>(UnarchiveProjectDocument);
};
export const UnarchiveProjectsBulkDocument = gql`
    mutation UnarchiveProjectsBulk($id: [ID!]!) {
  unarchiveProjectsBulk(id: $id) {
    total
    successful
    failed
  }
}
    `;

export function useUnarchiveProjectsBulkMutation() {
  return Urql.useMutation<UnarchiveProjectsBulkMutation, UnarchiveProjectsBulkMutationVariables>(UnarchiveProjectsBulkDocument);
};
export const BulkProjectUpdateDocument = gql`
    mutation BulkProjectUpdate($ids: [ID!]!, $input: BulkUpdateProjectsInput!) {
  bulkUpdateProjects(ids: $ids, input: $input) {
    total
    successful
    failed
  }
}
    `;

export function useBulkProjectUpdateMutation() {
  return Urql.useMutation<BulkProjectUpdateMutation, BulkProjectUpdateMutationVariables>(BulkProjectUpdateDocument);
};
export const DeleteProjectDocument = gql`
    mutation DeleteProject($id: ID!) {
  deleteProject(id: $id) {
    id
  }
}
    `;

export function useDeleteProjectMutation() {
  return Urql.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument);
};
export const DeleteProjectsBulkDocument = gql`
    mutation DeleteProjectsBulk($id: [ID!]!) {
  deleteProjectsBulk(id: $id) {
    total
    successful
    failed
  }
}
    `;

export function useDeleteProjectsBulkMutation() {
  return Urql.useMutation<DeleteProjectsBulkMutation, DeleteProjectsBulkMutationVariables>(DeleteProjectsBulkDocument);
};
export const InvoiceProjectByTypeDocument = gql`
    mutation InvoiceProjectByType($id: ID!, $invoice_type: RequestForInvoicingTypeEnum!) {
  invoiceProject(id: $id, invoice_type: $invoice_type) {
    id
  }
}
    `;

export function useInvoiceProjectByTypeMutation() {
  return Urql.useMutation<InvoiceProjectByTypeMutation, InvoiceProjectByTypeMutationVariables>(InvoiceProjectByTypeDocument);
};
export const InvoiceProjectsByTypeBulkDocument = gql`
    mutation InvoiceProjectsByTypeBulk($id: [ID!]!, $invoice_type: RequestForInvoicingTypeEnum!) {
  invoiceProjectsBulk(id: $id, invoice_type: $invoice_type) {
    id
  }
}
    `;

export function useInvoiceProjectsByTypeBulkMutation() {
  return Urql.useMutation<InvoiceProjectsByTypeBulkMutation, InvoiceProjectsByTypeBulkMutationVariables>(InvoiceProjectsByTypeBulkDocument);
};
export const PinProjectDocument = gql`
    mutation PinProject($id: ID!) {
  pinProject(id: $id) {
    id
    is_pinned
  }
}
    `;

export function usePinProjectMutation() {
  return Urql.useMutation<PinProjectMutation, PinProjectMutationVariables>(PinProjectDocument);
};
export const PinProjectsBulkDocument = gql`
    mutation PinProjectsBulk($id: [ID!]!) {
  pinProjectsBulk(id: $id) {
    total
    successful
    failed
  }
}
    `;

export function usePinProjectsBulkMutation() {
  return Urql.useMutation<PinProjectsBulkMutation, PinProjectsBulkMutationVariables>(PinProjectsBulkDocument);
};
export const UnpinProjectDocument = gql`
    mutation UnpinProject($id: ID!) {
  unpinProject(id: $id) {
    id
    is_pinned
  }
}
    `;

export function useUnpinProjectMutation() {
  return Urql.useMutation<UnpinProjectMutation, UnpinProjectMutationVariables>(UnpinProjectDocument);
};
export const UnpinProjectsBulkDocument = gql`
    mutation UnpinProjectsBulk($id: [ID!]!) {
  unpinProjectsBulk(id: $id) {
    total
    successful
    failed
  }
}
    `;

export function useUnpinProjectsBulkMutation() {
  return Urql.useMutation<UnpinProjectsBulkMutation, UnpinProjectsBulkMutationVariables>(UnpinProjectsBulkDocument);
};
export const ProformaInvoiceProjectDocument = gql`
    mutation ProformaInvoiceProject($projectId: ID!) {
  proformaInvoiceProject(id: $projectId) {
    id
  }
}
    `;

export function useProformaInvoiceProjectMutation() {
  return Urql.useMutation<ProformaInvoiceProjectMutation, ProformaInvoiceProjectMutationVariables>(ProformaInvoiceProjectDocument);
};
export const ReopenProjectDocument = gql`
    mutation ReopenProject($id: ID!) {
  reopenProject(id: $id) {
    ...FinishedProjectData
  }
}
    ${FinishedProjectDataFragmentDoc}`;

export function useReopenProjectMutation() {
  return Urql.useMutation<ReopenProjectMutation, ReopenProjectMutationVariables>(ReopenProjectDocument);
};
export const TimeTrackingPopoverItemsDocument = gql`
    query TimeTrackingPopoverItems($user_id: ID!, $from: Date!, $to: Date!) {
  timeTrackingItems(user_id: $user_id, from: $from, to: $to) {
    ...TimeTrackingEntry
  }
  runningTimer(user_id: $user_id) {
    id
    timeTrackingItem {
      ...TimeTrackingEntry
    }
  }
}
    ${TimeTrackingEntryFragmentDoc}`;

export function useTimeTrackingPopoverItemsQuery(options: Omit<Urql.UseQueryArgs<TimeTrackingPopoverItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeTrackingPopoverItemsQuery, TimeTrackingPopoverItemsQueryVariables>({ query: TimeTrackingPopoverItemsDocument, ...options });
};
export const AddAccountMovesToDocumentDocument = gql`
    mutation AddAccountMovesToDocument($documentId: ID!, $documentType: BankDocumentTypeEnum!, $date: Date!, $bankAccountMoves: [BankAccountMoveToDocumentInput!]!) {
  addBankAccountMovesToDocument(
    document_id: $documentId
    document_type: $documentType
    date: $date
    bank_account_moves: $bankAccountMoves
  )
}
    `;

export function useAddAccountMovesToDocumentMutation() {
  return Urql.useMutation<AddAccountMovesToDocumentMutation, AddAccountMovesToDocumentMutationVariables>(AddAccountMovesToDocumentDocument);
};
export const CreateFilterTemplateDocument = gql`
    mutation CreateFilterTemplate($input: FilterTemplateInput!) {
  createFilterTemplate(input: $input) {
    ...FilterTemplateFragment
  }
}
    ${FilterTemplateFragmentFragmentDoc}`;

export function useCreateFilterTemplateMutation() {
  return Urql.useMutation<CreateFilterTemplateMutation, CreateFilterTemplateMutationVariables>(CreateFilterTemplateDocument);
};
export const DeleteFilterTemplateDocument = gql`
    mutation DeleteFilterTemplate($id: ID!) {
  deleteFilterTemplate(id: $id)
}
    `;

export function useDeleteFilterTemplateMutation() {
  return Urql.useMutation<DeleteFilterTemplateMutation, DeleteFilterTemplateMutationVariables>(DeleteFilterTemplateDocument);
};
export const FilterTemplatesDocument = gql`
    query FilterTemplates($modelId: ID, $modelType: String!, $type: String) {
  filterTemplates(model_id: $modelId, model_type: $modelType, type: $type) {
    ...FilterTemplateFragment
  }
}
    ${FilterTemplateFragmentFragmentDoc}`;

export function useFilterTemplatesQuery(options: Omit<Urql.UseQueryArgs<FilterTemplatesQueryVariables>, 'query'>) {
  return Urql.useQuery<FilterTemplatesQuery, FilterTemplatesQueryVariables>({ query: FilterTemplatesDocument, ...options });
};
export const UpdateWorkspaceSettingsDocument = gql`
    mutation UpdateWorkspaceSettings($notifications: updateWorkspaceNotifications!, $tasks: InputWorkspaceTaskSettings!, $companies: InputWorkspaceCompanySetting!, $financial: InputWorkspaceFinancialSetting!, $accountingAccounts: InputUpdateWorkspaceAccountingAccountSettings!, $costCenters: InputUpdateWorkspaceAccountingCentreSettings!, $accountingVatClassifications: InputUpdateWorkspaceAccountingVatClassificationSettings!, $userManagement: InputWorkspaceUserManagementSetting!, $planningUtilization: InputWorkspacePlanningSetting!, $planningViewSettings: UpdatePlanningSettings!, $projects: InputUpdateWorkspaceProjectSettings!, $pipedrive: InputUpdateWorkspacePipedriveIntegration) {
  UpdateWorkspaceNotifications(input: $notifications) {
    id
  }
  updateWorkspaceTaskSettings(input: $tasks) {
    show_done_tasks
    use_current_assignee
  }
  updateWorkspaceCompanies(input: $companies) {
    id
  }
  updateWorkspaceFinancialSettings(input: $financial) {
    vat_rates {
      id
    }
  }
  updateWorkspaceAccountingAccountSettings(input: $accountingAccounts) {
    accounting_accounts {
      id
    }
  }
  updateWorkspaceAccountingCentreSettings(input: $costCenters) {
    accounting_centres {
      id
    }
  }
  updateWorkspaceAccountingVatClassificationSettings(
    input: $accountingVatClassifications
  ) {
    accounting_vat_classifications {
      id
    }
  }
  updateWorkspaceUserManagementSettings(input: $userManagement) {
    require_two_factor_authentication
  }
  updateWorkspacePlanningSettings(input: $planningUtilization) {
    specific_time_in_planning_enabled
  }
  updatePlanningSettings(input: $planningViewSettings) {
    title
  }
  updateWorkspaceProjectSettings(input: $projects) {
    project_code_with_year
  }
  updateWorkspacePipedriveIntegration(input: $pipedrive) {
    settings {
      pipedrive_stage_id
      project_stage_id
      project_billable
    }
  }
}
    `;

export function useUpdateWorkspaceSettingsMutation() {
  return Urql.useMutation<UpdateWorkspaceSettingsMutation, UpdateWorkspaceSettingsMutationVariables>(UpdateWorkspaceSettingsDocument);
};
export const TestImapConnectionDocument = gql`
    mutation TestImapConnection {
  testWorkspaceAutoExpenseEmail
}
    `;

export function useTestImapConnectionMutation() {
  return Urql.useMutation<TestImapConnectionMutation, TestImapConnectionMutationVariables>(TestImapConnectionDocument);
};
export const CreateWorkspaceSmtpSettingsDocument = gql`
    mutation CreateWorkspaceSmtpSettings($input: CreateWorkspaceSmtpSettingsInput!) {
  createWorkspaceSmtpSettings(input: $input) {
    id
    active
    smtp_host
    smtp_port
    smtp_username
    smtp_encryption
    smtp_from_address
    smtp_from_name
  }
}
    `;

export function useCreateWorkspaceSmtpSettingsMutation() {
  return Urql.useMutation<CreateWorkspaceSmtpSettingsMutation, CreateWorkspaceSmtpSettingsMutationVariables>(CreateWorkspaceSmtpSettingsDocument);
};
export const UpdateWorkspaceSmtpSettingsDocument = gql`
    mutation UpdateWorkspaceSmtpSettings($id: ID!, $input: UpdateWorkspaceSmtpSettingsInput!) {
  updateWorkspaceSmtpSettings(id: $id, input: $input) {
    id
    active
    smtp_host
    smtp_port
    smtp_username
    smtp_encryption
    smtp_from_address
    smtp_from_name
  }
}
    `;

export function useUpdateWorkspaceSmtpSettingsMutation() {
  return Urql.useMutation<UpdateWorkspaceSmtpSettingsMutation, UpdateWorkspaceSmtpSettingsMutationVariables>(UpdateWorkspaceSmtpSettingsDocument);
};
export const TestSmtpConnectionDocument = gql`
    mutation TestSmtpConnection($input: TestSmtpConnectionInput!) {
  testSmtpConnection(input: $input) {
    error
    message
    success
  }
}
    `;

export function useTestSmtpConnectionMutation() {
  return Urql.useMutation<TestSmtpConnectionMutation, TestSmtpConnectionMutationVariables>(TestSmtpConnectionDocument);
};
export const SendTestEmailDocument = gql`
    mutation SendTestEmail($input: CreateWorkspaceSmtpSettingsInput!) {
  sendTestEmail(input: $input) {
    error
    message
    success
  }
}
    `;

export function useSendTestEmailMutation() {
  return Urql.useMutation<SendTestEmailMutation, SendTestEmailMutationVariables>(SendTestEmailDocument);
};
export const GlobalWorkspaceSettingsDocument = gql`
    query GlobalWorkspaceSettings {
  currencies {
    id
    code
    denomination
  }
  teamSimpleMap {
    id
    name
    is_default
    user_count
  }
  taskPriorities {
    id
    name
    system_priority
    emoji
  }
  workspaceAccountingAccountSetting {
    ...WorkspaceAccountingAccountSettings
  }
  workspaceAccountingVatClassificationSetting {
    ...WorkspaceAccountingVatClassificationSetting
  }
  workspaceSettings {
    ...WorkspaceSettings
  }
}
    ${WorkspaceAccountingAccountSettingsFragmentDoc}
${WorkspaceAccountingVatClassificationSettingFragmentDoc}
${WorkspaceSettingsFragmentDoc}`;

export function useGlobalWorkspaceSettingsQuery(options?: Omit<Urql.UseQueryArgs<GlobalWorkspaceSettingsQueryVariables>, 'query'>) {
  return Urql.useQuery<GlobalWorkspaceSettingsQuery, GlobalWorkspaceSettingsQueryVariables>({ query: GlobalWorkspaceSettingsDocument, ...options });
};
export const TeamUsersDocument = gql`
    query TeamUsers($team_id: Mixed!) {
  userSimpleMap(where: {column: TEAM_ID, value: $team_id}) {
    id
    full_name
    profile {
      hex_color
    }
    image {
      urls {
        thumbnail
      }
    }
  }
}
    `;

export function useTeamUsersQuery(options: Omit<Urql.UseQueryArgs<TeamUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<TeamUsersQuery, TeamUsersQueryVariables>({ query: TeamUsersDocument, ...options });
};
export const WorkspaceSettingsDocument = gql`
    query WorkspaceSettings {
  roles {
    name
  }
  workspaceSettings {
    bmail_activated
  }
  countrySimpleMap {
    id
    name
  }
  WorkspaceNotifications {
    database_enabled
    description
    id
    mail_enabled
    name
    roles_to_notify
    threshold
    threshold_type
    to_roles
  }
  workspaceTaskSettings {
    task_statuses {
      background_color
      default
      done
      foreground_color
      id
      name
      order
    }
    task_priorities {
      default
      id
      name
      order
      system_priority
      emoji
    }
    show_done_tasks
    use_current_assignee
  }
  workspaceCompaniesSettings {
    city
    country_id
    currency_id
    deleted
    id
    internal_name
    is_default
    name
    registration_no
    street
    tax_no
    vat_no
    zip
    bank_accounts {
      account_holder_name
      bank_account
      bank_code
      bank_name
      bic
      deleted
      iban
      id
    }
    sequences {
      id
      format
      next_number
      types
    }
    pdfSettings {
      logo_assignable_file {
        public_id
        urls {
          original
        }
      }
      stamp_assignable_file {
        public_id
        urls {
          original
        }
      }
    }
  }
  workspaceFinancialSettings {
    default_show_unit_price_on_invoices
    default_show_billing_accounting_on_invoices
    invoice_attachment_name_templates {
      outgoing_invoice
      outgoing_proforma
      payment_receipt
    }
    vat_rates {
      id
      amount
      deleted
      default
    }
    currencies {
      id
      code
      exchange_rate
      denomination
    }
  }
  defaultCurrencies {
    code
    symbol
  }
  workspaceAccountingAccountSetting {
    ...WorkspaceAccountingAccountSettings
  }
  ourWorkBudgetCategories {
    id
    name
  }
  expenseBudgetCategories {
    id
    name
  }
  workspaceAccountingCentreSetting {
    accounting_centres {
      ...CostCenter
    }
  }
  workspaceAccountingVatClassificationSetting {
    accounting_vat_classifications {
      id
      type
      vat_rate_id
      centre
      title
      deleted_at
    }
  }
  workspaceUserManagementSetting {
    teams {
      id
      name
      deleted_at
      is_default
      user_count
    }
    require_two_factor_authentication
  }
  updateWorkspacePlanningSettings {
    working_from
    working_to
    default_user_plannable_capacity
    specific_time_in_planning_enabled
    hide_planning_total_daily_capacity
    planning_alphabet_user_order
    disable_home_office_in_planning
    start_day_of_week
    default_utilization_range_from
    default_utilization_range_to
    planning_sort_prioritize_time_specific_items
  }
  workspaceProjectSettings {
    project_code_generator
    project_code_length
    project_code_with_year
    can_close_expense_budget_item_with_unapproved_expenses
    create_default_task_enabled
    create_default_task_only_to_our_work_category
    our_work_budget_categories_count
    project_count
    automate_invoicing_plan_approval
    enable_additional_brand_numeric_code
  }
  banksQuery {
    api_id
    name
    logo
    url
  }
  workspacePipedriveIntegration {
    initialization_url
    settings {
      pipedrive_stage_id
      project_stage_id
      project_billable
    }
  }
  workspaceAutoExpenseEmailSettings {
    imap_host
    imap_port
    imap_username
    imap_encryption
    is_active
  }
  workspaceSmtpSettings {
    id
    active
    is_google_connected
    is_microsoft_connected
    smtp_host
    smtp_port
    smtp_username
    smtp_encryption
    smtp_from_address
    smtp_from_name
  }
}
    ${WorkspaceAccountingAccountSettingsFragmentDoc}
${CostCenterFragmentDoc}`;

export function useWorkspaceSettingsQuery(options?: Omit<Urql.UseQueryArgs<WorkspaceSettingsQueryVariables>, 'query'>) {
  return Urql.useQuery<WorkspaceSettingsQuery, WorkspaceSettingsQueryVariables>({ query: WorkspaceSettingsDocument, ...options });
};
export const TaskStatsDocument = gql`
    query TaskStats($id: ID!) {
  task(id: $id) {
    stats {
      spent_time
      planned_time
    }
  }
}
    `;

export function useTaskStatsQuery(options: Omit<Urql.UseQueryArgs<TaskStatsQueryVariables>, 'query'>) {
  return Urql.useQuery<TaskStatsQuery, TaskStatsQueryVariables>({ query: TaskStatsDocument, ...options });
};
export const LoginDocument = gql`
    query Login {
  currencies {
    id
    code
    denomination
    exchange_rate
  }
  me {
    ...Me
  }
  teamSimpleMap {
    id
    name
    is_default
    user_count
  }
  taskPriorities {
    id
    name
    system_priority
    emoji
  }
  workspaceAccountingAccountSetting {
    ...WorkspaceAccountingAccountSettings
  }
  workspaceSettings {
    ...WorkspaceSettings
  }
  workspaceAccountingVatClassificationSetting {
    ...WorkspaceAccountingVatClassificationSetting
  }
}
    ${MeFragmentDoc}
${WorkspaceAccountingAccountSettingsFragmentDoc}
${WorkspaceSettingsFragmentDoc}
${WorkspaceAccountingVatClassificationSettingFragmentDoc}`;

export function useLoginQuery(options?: Omit<Urql.UseQueryArgs<LoginQueryVariables>, 'query'>) {
  return Urql.useQuery<LoginQuery, LoginQueryVariables>({ query: LoginDocument, ...options });
};
export const LockModelDocument = gql`
    mutation LockModel($lockable_id: ID!, $lockable_type: ModelLockLockableTypeEnum!) {
  lockModel(lockable_id: $lockable_id, lockable_type: $lockable_type) {
    ...ModelLock
  }
}
    ${ModelLockFragmentDoc}`;

export function useLockModelMutation() {
  return Urql.useMutation<LockModelMutation, LockModelMutationVariables>(LockModelDocument);
};
export const UnlockModelDocument = gql`
    mutation UnlockModel($lockable_id: ID!, $lockable_type: ModelLockLockableTypeEnum!) {
  unlockModel(lockable_id: $lockable_id, lockable_type: $lockable_type)
}
    `;

export function useUnlockModelMutation() {
  return Urql.useMutation<UnlockModelMutation, UnlockModelMutationVariables>(UnlockModelDocument);
};
export const BulkLockModelDocument = gql`
    mutation BulkLockModel($lockable_ids: [ID!]!, $lockable_type: ModelLockLockableTypeEnum!) {
  bulkLockModel(lockable_ids: $lockable_ids, lockable_type: $lockable_type) {
    total
    failed
  }
}
    `;

export function useBulkLockModelMutation() {
  return Urql.useMutation<BulkLockModelMutation, BulkLockModelMutationVariables>(BulkLockModelDocument);
};
export const BulkUnlockModelDocument = gql`
    mutation BulkUnlockModel($lockable_ids: [ID!]!, $lockable_type: ModelLockLockableTypeEnum!) {
  bulkUnlockModel(lockable_ids: $lockable_ids, lockable_type: $lockable_type) {
    total
    failed
  }
}
    `;

export function useBulkUnlockModelMutation() {
  return Urql.useMutation<BulkUnlockModelMutation, BulkUnlockModelMutationVariables>(BulkUnlockModelDocument);
};
export const GetModelLockDocument = gql`
    query GetModelLock($lockable_id: ID!, $lockable_type: ModelLockLockableTypeEnum!) {
  getModelLock(lockable_id: $lockable_id, lockable_type: $lockable_type) {
    ...ModelLock
  }
}
    ${ModelLockFragmentDoc}`;

export function useGetModelLockQuery(options: Omit<Urql.UseQueryArgs<GetModelLockQueryVariables>, 'query'>) {
  return Urql.useQuery<GetModelLockQuery, GetModelLockQueryVariables>({ query: GetModelLockDocument, ...options });
};
export const UpdateProjectStageDocument = gql`
    mutation UpdateProjectStage($projectId: ID!, $projectStageId: ID!) {
  updateProjectStage(project_id: $projectId, project_stage_id: $projectStageId) {
    id
    project_stage {
      ...ProjectStage
    }
  }
}
    ${ProjectStageFragmentDoc}`;

export function useUpdateProjectStageMutation() {
  return Urql.useMutation<UpdateProjectStageMutation, UpdateProjectStageMutationVariables>(UpdateProjectStageDocument);
};
export const PipedriveDataDocument = gql`
    query PipedriveData {
  getPipedriveStages {
    pipedrive_stage_id
    name
  }
  projectStages {
    ...ProjectStage
  }
}
    ${ProjectStageFragmentDoc}`;

export function usePipedriveDataQuery(options?: Omit<Urql.UseQueryArgs<PipedriveDataQueryVariables>, 'query'>) {
  return Urql.useQuery<PipedriveDataQuery, PipedriveDataQueryVariables>({ query: PipedriveDataDocument, ...options });
};
export const QuoteEmailDataDocument = gql`
    query QuoteEmailData($quoteId: ID!) {
  GetQuoteEmailData(id: $quoteId) {
    primary_recipient
    recipients
    subject
    content
    attachments {
      name
      link
    }
  }
}
    `;

export function useQuoteEmailDataQuery(options: Omit<Urql.UseQueryArgs<QuoteEmailDataQueryVariables>, 'query'>) {
  return Urql.useQuery<QuoteEmailDataQuery, QuoteEmailDataQueryVariables>({ query: QuoteEmailDataDocument, ...options });
};
export const StarDocument = gql`
    mutation Star($starable_id: ID!, $starable_type: StarsStarableTypeEnum!) {
  star(starable_id: $starable_id, starable_type: $starable_type) {
    ...Star
  }
}
    ${StarFragmentDoc}`;

export function useStarMutation() {
  return Urql.useMutation<StarMutation, StarMutationVariables>(StarDocument);
};
export const UnstarDocument = gql`
    mutation Unstar($starable_id: ID!, $starable_type: StarsStarableTypeEnum!) {
  unstar(starable_id: $starable_id, starable_type: $starable_type)
}
    `;

export function useUnstarMutation() {
  return Urql.useMutation<UnstarMutation, UnstarMutationVariables>(UnstarDocument);
};
export const BulkStarDocument = gql`
    mutation BulkStar($starable_ids: [ID!]!, $starable_type: StarsStarableTypeEnum!) {
  bulkStar(starable_ids: $starable_ids, starable_type: $starable_type) {
    total
    failed
  }
}
    `;

export function useBulkStarMutation() {
  return Urql.useMutation<BulkStarMutation, BulkStarMutationVariables>(BulkStarDocument);
};
export const BulkUnstarDocument = gql`
    mutation BulkUnstar($starable_ids: [ID!]!, $starable_type: StarsStarableTypeEnum!) {
  bulkUnstar(starable_ids: $starable_ids, starable_type: $starable_type) {
    total
    failed
  }
}
    `;

export function useBulkUnstarMutation() {
  return Urql.useMutation<BulkUnstarMutation, BulkUnstarMutationVariables>(BulkUnstarDocument);
};
export const CreateTagDocument = gql`
    mutation CreateTag($title: String!) {
  createTag(title: $title) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;

export function useCreateTagMutation() {
  return Urql.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument);
};
export const UpdateTagDocument = gql`
    mutation UpdateTag($id: ID!, $title: String!) {
  updateTag(id: $id, title: $title) {
    ...Tag
  }
}
    ${TagFragmentDoc}`;

export function useUpdateTagMutation() {
  return Urql.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument);
};
export const DeleteTagDocument = gql`
    mutation DeleteTag($id: ID!) {
  deleteTag(id: $id)
}
    `;

export function useDeleteTagMutation() {
  return Urql.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument);
};
export const GetTagsDocument = gql`
    query GetTags {
  getTags {
    ...Tag
  }
}
    ${TagFragmentDoc}`;

export function useGetTagsQuery(options?: Omit<Urql.UseQueryArgs<GetTagsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTagsQuery, GetTagsQueryVariables>({ query: GetTagsDocument, ...options });
};
export const AllocationItemsSelectOptionsDocument = gql`
    query AllocationItemsSelectOptions($user_id: ID!, $date: Date!, $task_id: ID) {
  capacityAllocationItemList(user_id: $user_id, date: $date, task_id: $task_id) {
    id
    capacityAllocation {
      task {
        name
      }
    }
    from_time
    to_time
    total_time
    note
  }
}
    `;

export function useAllocationItemsSelectOptionsQuery(options: Omit<Urql.UseQueryArgs<AllocationItemsSelectOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllocationItemsSelectOptionsQuery, AllocationItemsSelectOptionsQueryVariables>({ query: AllocationItemsSelectOptionsDocument, ...options });
};
export const CapacityAllocationUserItemDetailDocument = gql`
    query CapacityAllocationUserItemDetail($id: ID!, $today: Date!) {
  capacityAllocationItemDetailQuery(id: $id) {
    id
    completed
    seriesSummary(today: $today) {
      any_duration_changed
      future_open_total_time
      same_day_open_count
      same_day_open_total_time
      futureCompletedPerUser {
        user_id
        count
      }
    }
    user {
      id
      full_name
      profile {
        hex_color
      }
    }
    time_tracking_work_type_id
    duration_changed
    userStats {
      capacity_allocation_item_id
      tracked_time_for_item
      has_running_timer
    }
    ...CapacityAllocationItem
    teams {
      team {
        id
        name
      }
    }
    userItems {
      id
      time_tracking_work_type_id
      user {
        id
        full_name
      }
    }
    capacityAllocation {
      id
      deadline
      deadline_time
      location
      created_at
      create_task_positions
      from_time
      to_time
      total_time
      from_date
      to_date
      total_time_per_day
      note
      title
      repetition
      deleted_items
      repetition_settings {
        include_holidays
        days
        every
        startType
        toType
        end
      }
      task {
        id
        name
        billable
        status {
          id
          name
          background_color
          foreground_color
        }
        ourWorkBudgetItem {
          id
          title
          category {
            name
          }
          project {
            id
            title
            code
          }
        }
      }
      createdBy {
        id
      }
      calendarParticipants {
        id
        email
        display_name
      }
    }
    stats {
      tracking_enabled
      tracking_enabled_from
      tracking_enabled_to
    }
  }
}
    ${CapacityAllocationItemFragmentDoc}`;

export function useCapacityAllocationUserItemDetailQuery(options: Omit<Urql.UseQueryArgs<CapacityAllocationUserItemDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<CapacityAllocationUserItemDetailQuery, CapacityAllocationUserItemDetailQueryVariables>({ query: CapacityAllocationUserItemDetailDocument, ...options });
};
export const BrandSelectOptionsDocument = gql`
    query BrandSelectOptions {
  brandsSimpleMap {
    name
    id
  }
}
    `;

export function useBrandSelectOptionsQuery(options?: Omit<Urql.UseQueryArgs<BrandSelectOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<BrandSelectOptionsQuery, BrandSelectOptionsQueryVariables>({ query: BrandSelectOptionsDocument, ...options });
};
export const CompleteCapacityAllocationItemDocument = gql`
    mutation CompleteCapacityAllocationItem($input: CompleteCapacityAllocationUserInput!) {
  completeCapacityAllocationItem(input: $input) {
    id
    user {
      id
    }
    completed
  }
}
    `;

export function useCompleteCapacityAllocationItemMutation() {
  return Urql.useMutation<CompleteCapacityAllocationItemMutation, CompleteCapacityAllocationItemMutationVariables>(CompleteCapacityAllocationItemDocument);
};
export const ReopenCapacityAllocationItemDocument = gql`
    mutation ReopenCapacityAllocationItem($input: ReopenCapacityAllocationItemInput!) {
  reopenCapacityAllocationItem(input: $input) {
    id
    user {
      id
    }
    completed
  }
}
    `;

export function useReopenCapacityAllocationItemMutation() {
  return Urql.useMutation<ReopenCapacityAllocationItemMutation, ReopenCapacityAllocationItemMutationVariables>(ReopenCapacityAllocationItemDocument);
};
export const DeleteCapacityAllocationDocument = gql`
    mutation DeleteCapacityAllocation($input: DeleteCapacityAllocationInput!) {
  deleteCapacityAllocation(input: $input) {
    id
  }
}
    `;

export function useDeleteCapacityAllocationMutation() {
  return Urql.useMutation<DeleteCapacityAllocationMutation, DeleteCapacityAllocationMutationVariables>(DeleteCapacityAllocationDocument);
};
export const DeleteCapacityAllocationItemDocument = gql`
    mutation DeleteCapacityAllocationItem($input: DeleteCapacityAllocationItemInput!) {
  deleteCapacityAllocationItem(input: $input) {
    id
  }
}
    `;

export function useDeleteCapacityAllocationItemMutation() {
  return Urql.useMutation<DeleteCapacityAllocationItemMutation, DeleteCapacityAllocationItemMutationVariables>(DeleteCapacityAllocationItemDocument);
};
export const DeleteCapacityAllocationForDayDocument = gql`
    mutation DeleteCapacityAllocationForDay($input: DeleteCapacityAllocationForDayInput!) {
  deleteCapacityAllocationForDay(input: $input) {
    id
  }
}
    `;

export function useDeleteCapacityAllocationForDayMutation() {
  return Urql.useMutation<DeleteCapacityAllocationForDayMutation, DeleteCapacityAllocationForDayMutationVariables>(DeleteCapacityAllocationForDayDocument);
};
export const DuplicateProjectDocument = gql`
    mutation DuplicateProject($id: ID!, $with_tasks: Boolean!, $with_task_attachments: Boolean!) {
  duplicateProject(
    id: $id
    with_tasks: $with_tasks
    with_task_attachments: $with_task_attachments
  ) {
    id
  }
}
    `;

export function useDuplicateProjectMutation() {
  return Urql.useMutation<DuplicateProjectMutation, DuplicateProjectMutationVariables>(DuplicateProjectDocument);
};
export const GetWorkTypeOptionsDocument = gql`
    query GetWorkTypeOptions($taskId: ID!) {
  task(id: $taskId) {
    ourWorkBudgetItem {
      project {
        availableTimeTrackingWorkTypes {
          id
          title
        }
      }
    }
  }
}
    `;

export function useGetWorkTypeOptionsQuery(options: Omit<Urql.UseQueryArgs<GetWorkTypeOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWorkTypeOptionsQuery, GetWorkTypeOptionsQueryVariables>({ query: GetWorkTypeOptionsDocument, ...options });
};
export const UpdatePlanningSettingsDocument = gql`
    mutation UpdatePlanningSettings($input: UpdatePlanningSettings!) {
  updatePlanningSettings(input: $input) {
    ...WorkspaceSettings
  }
}
    ${WorkspaceSettingsFragmentDoc}`;

export function useUpdatePlanningSettingsMutation() {
  return Urql.useMutation<UpdatePlanningSettingsMutation, UpdatePlanningSettingsMutationVariables>(UpdatePlanningSettingsDocument);
};
export const PositionSelectOptionsDocument = gql`
    query PositionSelectOptions {
  timeTrackingWorkTypes {
    id
    default_rate
    title
  }
}
    `;

export function usePositionSelectOptionsQuery(options?: Omit<Urql.UseQueryArgs<PositionSelectOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<PositionSelectOptionsQuery, PositionSelectOptionsQueryVariables>({ query: PositionSelectOptionsDocument, ...options });
};
export const PositionsForProjectDocument = gql`
    query PositionsForProject($projectId: ID!) {
  projectForTask(id: $projectId) {
    id
    availableTimeTrackingWorkTypes {
      id
      title
    }
  }
}
    `;

export function usePositionsForProjectQuery(options: Omit<Urql.UseQueryArgs<PositionsForProjectQueryVariables>, 'query'>) {
  return Urql.useQuery<PositionsForProjectQuery, PositionsForProjectQueryVariables>({ query: PositionsForProjectDocument, ...options });
};
export const ProjectManagersSelectOptionsDocument = gql`
    query ProjectManagersSelectOptions {
  projectManagerSimpleMap {
    id
    image {
      urls {
        thumbnail
      }
    }
    profile {
      hex_color
    }
    full_name
    codename
  }
}
    `;

export function useProjectManagersSelectOptionsQuery(options?: Omit<Urql.UseQueryArgs<ProjectManagersSelectOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectManagersSelectOptionsQuery, ProjectManagersSelectOptionsQueryVariables>({ query: ProjectManagersSelectOptionsDocument, ...options });
};
export const ProjectSelectOptionsDocument = gql`
    query projectSelectOptions($page: Int, $first: Int, $filters: ProjectQueryArgs) {
  projects(page: $page, first: $first, filters: $filters) {
    data {
      id
      title
      code
      brand {
        id
        name
      }
      archived_at
      finished_at
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

export function useProjectSelectOptionsQuery(options?: Omit<Urql.UseQueryArgs<ProjectSelectOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ProjectSelectOptionsQuery, ProjectSelectOptionsQueryVariables>({ query: ProjectSelectOptionsDocument, ...options });
};
export const RoleSelectOptionsDocument = gql`
    query RoleSelectOptions {
  roles {
    id
    name
  }
}
    `;

export function useRoleSelectOptionsQuery(options?: Omit<Urql.UseQueryArgs<RoleSelectOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<RoleSelectOptionsQuery, RoleSelectOptionsQueryVariables>({ query: RoleSelectOptionsDocument, ...options });
};
export const TaskSelectOptionsDocument = gql`
    query taskSelectOptions($page: Int, $first: Int, $filters: TaskQueryArgs) {
  tasks(page: $page, first: $first, filters: $filters) {
    data {
      id
      name
      billable
      status {
        name
        system_status
      }
      ourWorkBudgetItem {
        id
        title
        project {
          id
          code
          title
        }
        category {
          name
        }
        timeTrackingSettings {
          tracking_enabled_from
          tracking_enabled_to
          tracking_enabled
        }
      }
    }
    paginatorInfo {
      ...PaginatorInfo
    }
  }
}
    ${PaginatorInfoFragmentDoc}`;

export function useTaskSelectOptionsQuery(options?: Omit<Urql.UseQueryArgs<TaskSelectOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<TaskSelectOptionsQuery, TaskSelectOptionsQueryVariables>({ query: TaskSelectOptionsDocument, ...options });
};
export const TeamSelectOptionsDocument = gql`
    query TeamSelectOptions {
  teamSimpleMap {
    id
    name
  }
}
    `;

export function useTeamSelectOptionsQuery(options?: Omit<Urql.UseQueryArgs<TeamSelectOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<TeamSelectOptionsQuery, TeamSelectOptionsQueryVariables>({ query: TeamSelectOptionsDocument, ...options });
};
export const TimeOffTypeOptionsDocument = gql`
    query TimeOffTypeOptions {
  timeOffTypesQuery {
    id
    name
  }
}
    `;

export function useTimeOffTypeOptionsQuery(options?: Omit<Urql.UseQueryArgs<TimeOffTypeOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeOffTypeOptionsQuery, TimeOffTypeOptionsQueryVariables>({ query: TimeOffTypeOptionsDocument, ...options });
};
export const UsersSelectOptionsDocument = gql`
    query UsersSelectOptions($onlyPlannable: Boolean, $where: UsersWhereConditions, $taskId: ID, $projectId: ID) {
  userSimpleMap(
    onlyPlannable: $onlyPlannable
    where: $where
    task_id: $taskId
    project_id: $projectId
  ) {
    id
    image {
      urls {
        thumbnail
      }
    }
    profile {
      hex_color
    }
    full_name
    codename
  }
}
    `;

export function useUsersSelectOptionsQuery(options?: Omit<Urql.UseQueryArgs<UsersSelectOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<UsersSelectOptionsQuery, UsersSelectOptionsQueryVariables>({ query: UsersSelectOptionsDocument, ...options });
};
export const BudgetItemsForProjectDocument = gql`
    query BudgetItemsForProject($projectId: ID!) {
  project(id: $projectId) {
    id
    ourWorkStructured {
      budgetItems {
        id
        title
        category {
          name
        }
      }
    }
  }
}
    `;

export function useBudgetItemsForProjectQuery(options: Omit<Urql.UseQueryArgs<BudgetItemsForProjectQueryVariables>, 'query'>) {
  return Urql.useQuery<BudgetItemsForProjectQuery, BudgetItemsForProjectQueryVariables>({ query: BudgetItemsForProjectDocument, ...options });
};